"use client";
var tH = Object.defineProperty;
var hT = (e) => {
  throw TypeError(e);
};
var nH = (e, t, n) => t in e ? tH(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var da = (e, t, n) => nH(e, typeof t != "symbol" ? t + "" : t, n), pT = (e, t, n) => t.has(e) || hT("Cannot " + n);
var Dr = (e, t, n) => (pT(e, t, "read from private field"), n ? n.call(e) : t.get(e)), zv = (e, t, n) => t.has(e) ? hT("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), os = (e, t, n, r) => (pT(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import { jsxs as he, jsx as E, Fragment as Ut } from "react/jsx-runtime";
import * as te from "react";
import I, { forwardRef as Dt, Fragment as Ur, useMemo as Fe, useState as Me, useCallback as qe, isValidElement as rt, createElement as ql, useLayoutEffect as di, useEffect as Xe, useRef as ut, cloneElement as ht, createContext as dt, useContext as Ve, useId as Kw, Component as Gw, useInsertionEffect as z$, Children as Yt, memo as rH, Suspense as iH, startTransition as oH, PureComponent as pi, useImperativeHandle as aH } from "react";
import * as V$ from "react-dom";
import { flushSync as U$, createPortal as Yw } from "react-dom";
import { c as So, g as kt } from "./_commonjsHelpers-DaMA6jEr.js";
const qw = "-", sH = (e) => {
  const t = cH(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(qw);
      return s[0] === "" && s.length !== 1 && s.shift(), H$(s, t) || lH(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = n[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, H$ = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? H$(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(qw);
  return (a = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : a.classGroupId;
}, mT = /^\[(.+)\]$/, lH = (e) => {
  if (mT.test(e)) {
    const t = mT.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, cH = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return fH(Object.entries(e.classGroups), n).forEach(([o, a]) => {
    u0(a, r, o, t);
  }), r;
}, u0 = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : gT(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (uH(i)) {
        u0(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, a]) => {
      u0(a, gT(t, o), n, r);
    });
  });
}, gT = (e, t) => {
  let n = e;
  return t.split(qw).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, uH = (e) => e.isThemeGetter, fH = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, s]) => [t + a, s])) : o);
  return [n, i];
}) : e, dH = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, a) => {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let a = n.get(o);
      if (a !== void 0)
        return a;
      if ((a = r.get(o)) !== void 0)
        return i(o, a), a;
    },
    set(o, a) {
      n.has(o) ? n.set(o, a) : i(o, a);
    }
  };
}, K$ = "!", hH = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length, a = (s) => {
    const l = [];
    let c = 0, f = 0, d;
    for (let v = 0; v < s.length; v++) {
      let x = s[v];
      if (c === 0) {
        if (x === i && (r || s.slice(v, v + o) === t)) {
          l.push(s.slice(f, v)), f = v + o;
          continue;
        }
        if (x === "/") {
          d = v;
          continue;
        }
      }
      x === "[" ? c++ : x === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(f), m = p.startsWith(K$), y = m ? p.substring(1) : p, g = d && d > f ? d - f : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: y,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: a
  }) : a;
}, pH = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, mH = (e) => ({
  cache: dH(e.cacheSize),
  parseClassName: hH(e),
  ...sH(e)
}), gH = /\s+/, yH = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = [], a = e.trim().split(gH);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: f,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: m
    } = n(c);
    let y = !!m, g = r(y ? p.substring(0, m) : p);
    if (!g) {
      if (!y) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (g = r(p), !g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      y = !1;
    }
    const v = pH(f).join(":"), x = d ? v + K$ : v, w = x + g;
    if (o.includes(w))
      continue;
    o.push(w);
    const S = i(g, y);
    for (let A = 0; A < S.length; ++A) {
      const _ = S[A];
      o.push(x + _);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function vH() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = G$(t)) && (r && (r += " "), r += n);
  return r;
}
const G$ = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = G$(e[r])) && (n && (n += " "), n += t);
  return n;
};
function bH(e, ...t) {
  let n, r, i, o = a;
  function a(l) {
    const c = t.reduce((f, d) => d(f), e());
    return n = mH(c), r = n.cache.get, i = n.cache.set, o = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const f = yH(l, n);
    return i(l, f), f;
  }
  return function() {
    return o(vH.apply(null, arguments));
  };
}
const Wt = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Y$ = /^\[(?:([a-z-]+):)?(.+)\]$/i, xH = /^\d+\/\d+$/, wH = /* @__PURE__ */ new Set(["px", "full", "screen"]), _H = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, SH = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, OH = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, AH = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, TH = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, vo = (e) => Wl(e) || wH.has(e) || xH.test(e), ha = (e) => Mc(e, "length", DH), Wl = (e) => !!e && !Number.isNaN(Number(e)), Vv = (e) => Mc(e, "number", Wl), vu = (e) => !!e && Number.isInteger(Number(e)), PH = (e) => e.endsWith("%") && Wl(e.slice(0, -1)), Je = (e) => Y$.test(e), pa = (e) => _H.test(e), CH = /* @__PURE__ */ new Set(["length", "size", "percentage"]), EH = (e) => Mc(e, CH, q$), kH = (e) => Mc(e, "position", q$), MH = /* @__PURE__ */ new Set(["image", "url"]), NH = (e) => Mc(e, MH, RH), $H = (e) => Mc(e, "", IH), bu = () => !0, Mc = (e, t, n) => {
  const r = Y$.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, DH = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  SH.test(e) && !OH.test(e)
), q$ = () => !1, IH = (e) => AH.test(e), RH = (e) => TH.test(e), jH = () => {
  const e = Wt("colors"), t = Wt("spacing"), n = Wt("blur"), r = Wt("brightness"), i = Wt("borderColor"), o = Wt("borderRadius"), a = Wt("borderSpacing"), s = Wt("borderWidth"), l = Wt("contrast"), c = Wt("grayscale"), f = Wt("hueRotate"), d = Wt("invert"), p = Wt("gap"), m = Wt("gradientColorStops"), y = Wt("gradientColorStopPositions"), g = Wt("inset"), v = Wt("margin"), x = Wt("opacity"), w = Wt("padding"), S = Wt("saturate"), A = Wt("scale"), _ = Wt("sepia"), O = Wt("skew"), P = Wt("space"), C = Wt("translate"), k = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], $ = () => ["auto", Je, t], N = () => [Je, t], R = () => ["", vo, ha], L = () => ["auto", Wl, Je], F = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], W = () => ["solid", "dashed", "dotted", "double", "none"], z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], U = () => ["", "0", Je], V = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Y = () => [Wl, Je];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [bu],
      spacing: [vo, ha],
      blur: ["none", "", pa, Je],
      brightness: Y(),
      borderColor: [e],
      borderRadius: ["none", "", "full", pa, Je],
      borderSpacing: N(),
      borderWidth: R(),
      contrast: Y(),
      grayscale: U(),
      hueRotate: Y(),
      invert: U(),
      gap: N(),
      gradientColorStops: [e],
      gradientColorStopPositions: [PH, ha],
      inset: $(),
      margin: $(),
      opacity: Y(),
      padding: N(),
      saturate: Y(),
      scale: Y(),
      sepia: U(),
      skew: Y(),
      space: N(),
      translate: N()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Je]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [pa]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": V()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": V()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...F(), Je]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: k()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": k()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": k()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", vu, Je]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: $()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Je]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: U()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: U()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", vu, Je]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [bu]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", vu, Je]
        }, Je]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": L()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": L()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [bu]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [vu, Je]
        }, Je]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": L()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": L()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Je]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Je]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...G()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...G(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Je, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Je, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Je, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [pa]
        }, pa]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Je, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Je, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Je, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Je, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", pa, ha]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Vv]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [bu]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Je]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Wl, Vv]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", vo, Je]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Je]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Je]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [x]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [x]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...W(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", vo, ha]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", vo, Je]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: N()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Je]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Je]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [x]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...F(), kH]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", EH]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, NH]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [y]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [x]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...W(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [x]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: W()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...W()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [vo, Je]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [vo, ha]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: R()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [x]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [vo, ha]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", pa, $H]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [bu]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [x]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", pa, Je]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [x]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Je]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Y()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Je]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Y()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Je]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [A]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [A]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [A]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [vu, Je]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [C]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [C]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Je]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Je]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": N()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": N()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": N()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": N()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": N()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": N()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": N()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": N()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": N()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": N()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": N()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": N()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": N()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": N()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": N()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": N()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": N()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": N()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Je]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [vo, ha, Vv]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, LH = /* @__PURE__ */ bH(jH);
function X$(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = X$(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Ye() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = X$(e)) && (r && (r += " "), r += t);
  return r;
}
const K = (...e) => LH(Ye(...e)), lf = (...e) => (...t) => e.forEach((n) => n == null ? void 0 : n(...t)), Jm = (e) => {
  const t = {
    0: "gap-0",
    xxs: "gap-1",
    xs: "gap-2",
    sm: "gap-3",
    md: "gap-4",
    lg: "gap-5",
    xl: "gap-6",
    "2xl": "gap-8"
  };
  return t[e] || t.md;
}, BH = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  7: "grid-cols-7",
  8: "grid-cols-8",
  9: "grid-cols-9",
  10: "grid-cols-10",
  11: "grid-cols-11",
  12: "grid-cols-12"
}, FH = () => {
  var i, o;
  const e = ((o = (i = window.navigator) == null ? void 0 : i.userAgentData) == null ? void 0 : o.platform) || window.navigator.platform, t = [
    "macOS",
    "Macintosh",
    "MacIntel",
    "MacPPC",
    "Mac68K"
  ], n = ["Win32", "Win64", "Windows", "WinCE"];
  let r = "null";
  return t.includes(e) ? r = "Mac OS" : n.includes(e) && (r = "Windows"), r;
}, WH = (e) => e < 1024 ? `${e} bytes` : e < 1024 * 1024 ? `${(e / 1024).toFixed(2)} KB` : e < 1024 * 1024 * 1024 ? `${(e / (1024 * 1024)).toFixed(2)} MB` : `${(e / (1024 * 1024 * 1024)).toFixed(2)} GB`, Ru = {
  set: (e, t) => {
    if (!(typeof window > "u"))
      try {
        localStorage.setItem(e, JSON.stringify(t));
      } catch (n) {
        console.error(n);
      }
  },
  get: (e) => {
    if (typeof window > "u")
      return null;
    try {
      const t = localStorage.getItem(e);
      return t ? JSON.parse(t) : null;
    } catch (t) {
      return console.error(t), null;
    }
  },
  remove: (e) => {
    if (!(typeof window > "u"))
      try {
        localStorage.removeItem(e);
      } catch (t) {
        console.error(t);
      }
  }
}, Hn = Dt(
  (e, t) => {
    const {
      variant: n = "primary",
      // primary, secondary, outline, ghost, link
      size: r = "md",
      // xs, sm, md, lg
      type: i = "button",
      tag: o = "button",
      className: a,
      children: s,
      disabled: l = !1,
      destructive: c = !1,
      // true, false
      icon: f = null,
      // icon component
      iconPosition: d = "left",
      // left, right,
      loading: p = !1,
      ...m
    } = e, y = "outline outline-1 border-none cursor-pointer transition-colors duration-300 ease-in-out text-xs font-semibold focus:ring-2 focus:ring-toggle-on focus:ring-offset-2 disabled:text-text-disabled", g = p ? "opacity-50 disabled:cursor-not-allowed" : "", v = {
      primary: "text-text-on-color bg-button-primary hover:bg-button-primary-hover outline-button-primary hover:outline-button-primary-hover disabled:bg-button-disabled disabled:outline-button-disabled",
      secondary: "text-text-on-color bg-button-secondary hover:bg-button-secondary-hover outline-button-secondary hover:outline-button-secondary-hover disabled:bg-button-disabled disabled:outline-button-disabled",
      outline: "text-button-tertiary-color outline-border-subtle bg-button-tertiary hover:bg-button-tertiary-hover hover:outline-border-subtle disabled:bg-button-tertiary disabled:outline-border-disabled",
      ghost: "text-text-primary bg-transparent outline-transparent hover:bg-button-tertiary-hover",
      link: "outline-none text-link-primary bg-transparent hover:text-link-primary-hover hover:underline p-0 border-0 leading-none"
    }[n], x = c && !l ? {
      primary: "bg-button-danger hover:bg-button-danger-hover outline-button-danger hover:outline-button-danger-hover",
      secondary: "bg-button-danger hover:bg-button-danger-hover outline-button-danger hover:outline-button-danger-hover",
      outline: "text-button-danger outline outline-1 outline-button-danger hover:outline-button-danger bg-button-tertiary hover:bg-field-background-error",
      ghost: "text-button-danger hover:bg-field-background-error",
      link: "text-button-danger hover:text-button-danger-secondary"
    }[n] : "", w = {
      xs: "p-1 rounded [&>svg]:size-4",
      sm: "p-2 rounded [&>svg]:size-4 gap-0.5",
      md: "p-2.5 rounded-md text-sm [&>svg]:size-5 gap-1",
      lg: "p-3 rounded-lg text-base [&>svg]:size-6 gap-1"
    }[r];
    let S, A = null, _ = "";
    return f && (_ = "flex items-center justify-center", d === "left" ? S = f : A = f), /* @__PURE__ */ he(
      o,
      {
        ref: t,
        type: i,
        className: K(
          _,
          y,
          w,
          v,
          x,
          g,
          {
            "cursor-default": l
          },
          a
        ),
        disabled: l,
        ...m,
        children: [
          /* @__PURE__ */ E(Ur, { children: S }, "left-icon"),
          s ? /* @__PURE__ */ E("span", { className: "px-1", children: s }) : null,
          /* @__PURE__ */ E(Ur, { children: A }, "right-icon")
        ]
      }
    );
  }
);
Hn.displayName = "Button";
const zH = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let ro = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e));
  for (; e--; )
    t += zH[n[e] & 63];
  return t;
};
const eo = Dt(
  ({
    children: e = null,
    tag: t = "label",
    size: n = "sm",
    // xs, sm, md
    className: r = "",
    variant: i = "neutral",
    // neutral, help, error, disabled
    required: o = !1,
    ...a
  }, s) => {
    const l = "font-medium text-field-label flex items-center gap-0.5", c = {
      xs: "text-xs [&>*]:text-xs [&>svg]:h-3 [&>svg]:w-3",
      sm: "text-sm [&>*]:text-sm [&>svg]:h-4 [&>svg]:w-4",
      md: "text-base [&>*]:text-base [&>svg]:h-5 [&>svg]:w-5"
    }, f = {
      neutral: "text-field-label [&>*]:text-field-label",
      help: "text-field-helper [&>*]:text-field-helper",
      error: "text-support-error [&>*]:text-support-error",
      disabled: "text-field-color-disabled disabled cursor-not-allowed [&>*]:text-field-color-disabled"
    }, d = {
      neutral: "",
      help: "font-normal",
      error: "font-normal",
      disabled: ""
    };
    if (!e)
      return null;
    let p = "";
    return o && (p = "after:content-['*'] after:text-field-required after:ml-0.5"), /* @__PURE__ */ E(
      t,
      {
        ref: s,
        className: K(
          l,
          c[n],
          f[i],
          p,
          d == null ? void 0 : d[i],
          r
        ),
        ...a,
        children: e
      }
    );
  }
);
eo.displayName = "Label";
const VH = ({
  label: e,
  switchId: t,
  disabled: n = !1,
  children: r,
  size: i
}) => {
  const o = {
    sm: "text-sm leading-5 font-medium",
    md: "text-base leading-6 font-medium"
  }, a = {
    sm: "text-sm leading-5 font-normal",
    md: "text-sm leading-5 font-normal"
  }, s = {
    sm: "space-y-0.5",
    md: "space-y-1"
  };
  if (rt(e))
    return /* @__PURE__ */ he(
      "div",
      {
        className: K("inline-flex items-center gap-3", "items-start"),
        children: [
          r,
          e
        ]
      }
    );
  const c = () => {
    const { heading: p = "", description: m = "" } = e || {};
    return /* @__PURE__ */ he("div", { className: K("space-y-0.5", s[i]), children: [
      p && /* @__PURE__ */ E(
        eo,
        {
          htmlFor: t,
          className: K("m-0", o[i]),
          ...n && { variant: "disabled" },
          children: p
        }
      ),
      m && /* @__PURE__ */ E(
        eo,
        {
          tag: "p",
          variant: "help",
          className: K(
            "text-sm font-normal leading-5 m-0",
            a[i]
          ),
          ...n && { variant: "disabled" },
          children: m
        }
      )
    ] });
  }, f = !(e != null && e.heading) && !(e != null && e.description), d = !(e != null && e.heading) || !(e != null && e.description) ? "items-center" : "items-start";
  return f ? r : /* @__PURE__ */ he("div", { className: K("inline-flex", d, "gap-3"), children: [
    r,
    c()
  ] });
}, UH = ({
  id: e,
  onChange: t,
  value: n,
  defaultValue: r = !1,
  size: i = "sm",
  disabled: o = !1,
  label: a = { heading: "", description: "" },
  name: s,
  className: l,
  ...c
}, f) => {
  const d = i === "lg" ? "md" : i, p = Fe(() => typeof n < "u", [n]), m = Fe(() => e || `switch-${ro()}`, []), [y, g] = Me(r), v = "primary", x = qe(
    () => p ? n : y,
    [p, n, y]
  ), w = (C) => {
    if (o)
      return;
    const k = C.target.checked;
    p || g(k), typeof t == "function" && t(k);
  }, S = {
    primary: {
      input: "bg-toggle-off checked:bg-toggle-on focus:ring focus:ring-toggle-on focus:ring-offset-2 border border-solid border-toggle-off-border checked:border-toggle-on-border shadow-toggleContainer focus:outline-none checked:focus:border-toggle-on-border focus:border-toggle-off-border",
      toggleDial: "bg-toggle-dial-background shadow-toggleDial"
    }
  }, A = {
    primary: {
      input: "group-hover/switch:bg-toggle-off-hover checked:group-hover/switch:bg-toggle-on-hover checked:group-hover/switch:border-toggle-on-border"
    }
  }, _ = {
    md: {
      container: "w-11 h-6",
      toggleDial: "size-4 peer-checked:translate-x-5"
    },
    sm: {
      container: "w-10 h-5",
      toggleDial: "size-3 peer-checked:translate-x-5"
    }
  }, O = {
    md: "group-hover/switch:size-5 group-focus-within/switch:size-5 group-focus-within/switch:left-0.5 group-hover/switch:left-0.5",
    sm: "group-hover/switch:size-4 group-focus-within/switch:size-4 group-focus-within/switch:left-0.5 group-hover/switch:left-0.5"
  }, P = {
    input: "bg-toggle-off-disabled disabled:border-transparent shadow-none disabled:cursor-not-allowed checked:disabled:bg-toggle-on-disabled",
    toggleDial: "peer-disabled:cursor-not-allowed"
  };
  return /* @__PURE__ */ E(
    VH,
    {
      label: a,
      switchId: m,
      disabled: o,
      size: d,
      children: /* @__PURE__ */ he(
        "div",
        {
          className: K(
            "relative group/switch inline-block cursor-pointer rounded-full shrink-0",
            _[d].container,
            l
          ),
          children: [
            /* @__PURE__ */ E(
              "input",
              {
                ref: f,
                id: m,
                type: "checkbox",
                className: K(
                  "peer appearance-none absolute rounded-full cursor-pointer transition-colors duration-300 h-full w-full  before:content-[''] checked:before:content-[''] m-0 checked:[background-image:none]",
                  S[v].input,
                  o && P.input,
                  !o && A[v].input
                ),
                checked: x(),
                onChange: w,
                disabled: o,
                name: s,
                ...c
              }
            ),
            /* @__PURE__ */ E(
              "label",
              {
                htmlFor: m,
                className: K(
                  "peer/toggle-dial bg-white border rounded-full absolute cursor-pointer shadow-md before:content[''] before:transition-opacity before:opacity-0 hover:before:opacity-10 before:hidden border-none transition-all duration-300 top-2/4 left-1 -translate-y-2/4 before:w-10 before:h-10 before:rounded-full before:absolute before:top-2/4 before:left-2/4 before:-translate-y-2/4 before:-translate-x-2/4",
                  _[d].toggleDial,
                  S[v].toggleDial,
                  o && P.toggleDial,
                  !o && O[d]
                )
              }
            )
          ]
        }
      )
    }
  );
}, Z$ = Dt(UH);
Z$.displayName = "Switch";
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HH = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), J$ = (...e) => e.filter((t, n, r) => !!t && r.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var KH = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GH = Dt(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: o,
    iconNode: a,
    ...s
  }, l) => ql(
    "svg",
    {
      ref: l,
      ...KH,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: J$("lucide", i),
      ...s
    },
    [
      ...a.map(([c, f]) => ql(c, f)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const on = (e, t) => {
  const n = Dt(
    ({ className: r, ...i }, o) => ql(GH, {
      ref: o,
      iconNode: t,
      className: J$(`lucide-${HH(e)}`, r),
      ...i
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ad = on("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xw = on("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q$ = on("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zw = on("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YH = on("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qH = on("CloudUpload", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M12 12v9", key: "192myk" }],
  ["path", { d: "m16 16-4-4-4 4", key: "119tzi" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XH = on("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZH = on("File", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JH = on("ImageOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f0 = on("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QH = on("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eD = on("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eK = on("PanelLeftClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tK = on("PanelLeftOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tD = on("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nD = on("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nK = on("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rK = on("Trash", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iK = on("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yT = on("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oK = on("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-react v0.417.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Na = on("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), aK = ({
  id: e,
  label: t,
  defaultChecked: n = !1,
  checked: r,
  onChange: i,
  indeterminate: o,
  disabled: a,
  size: s = "md",
  className: l,
  ...c
}, f) => {
  var O, P;
  const d = Fe(() => e || `checkbox-${ro()}`, [e]), p = Fe(
    () => typeof r < "u",
    [r]
  ), [m, y] = Me(n || !1), g = "primary", v = {
    sm: {
      checkbox: "size-4 rounded gap-1",
      icon: "size-3",
      text: "text-sm",
      // text class for sm
      description: "text-sm",
      gap: "gap-0.5"
    },
    md: {
      checkbox: "size-5 rounded gap-1",
      icon: "size-4",
      text: "text-base",
      // text class for md
      description: "text-sm",
      gap: "gap-1"
    }
  }, x = {
    primary: {
      checkbox: "border-border-strong hover:border-border-interactive checked:border-border-interactive bg-white checked:bg-toggle-on checked:hover:bg-toggle-on-hover checked:hover:border-toggle-on-hover focus:ring-2 focus:ring-offset-2 focus:ring-focus",
      icon: "text-white"
    }
  }, w = {
    checkbox: "cursor-not-allowed disabled:bg-white checked:disabled:bg-white disabled:border-border-disabled checked:disabled:border-border-disabled",
    icon: "cursor-not-allowed peer-disabled:text-border-disabled"
  }, S = qe(
    () => p ? r : m,
    [p, r, m]
  ), A = (C) => {
    if (a)
      return;
    const k = C.target.checked;
    p || y(k), typeof i == "function" && i(k);
  }, _ = qe(() => rt(t) ? t : !(t != null && t.heading) && !(t != null && t.description) ? null : /* @__PURE__ */ he("div", { className: v[s].gap, children: [
    (t == null ? void 0 : t.heading) && /* @__PURE__ */ E(
      eo,
      {
        className: K(
          "text-text-primary font-medium leading-4 m-0",
          v[s].text,
          v[s].gap,
          a && "text-text-disabled"
        ),
        htmlFor: d,
        children: t == null ? void 0 : t.heading
      }
    ),
    (t == null ? void 0 : t.description) && /* @__PURE__ */ E(
      eo,
      {
        tag: "p",
        className: K(
          "font-normal leading-5 m-0",
          v[s].description,
          a && "text-text-disabled"
        ),
        variant: "help",
        children: t == null ? void 0 : t.description
      }
    )
  ] }), [t, s, a]);
  return /* @__PURE__ */ he(
    "div",
    {
      className: K(
        "inline-flex items-center justify-center gap-2",
        !!t && "items-start",
        a && "cursor-not-allowed"
      ),
      children: [
        /* @__PURE__ */ he(
          "label",
          {
            className: K(
              "relative flex items-center justify-center rounded-full p-0.5",
              !a && "cursor-pointer"
            ),
            htmlFor: d,
            children: [
              /* @__PURE__ */ E(
                "input",
                {
                  ref: f,
                  id: d,
                  type: "checkbox",
                  className: K(
                    "peer relative cursor-pointer appearance-none transition-all m-0 before:content-[''] checked:before:content-[''] checked:before:hidden before:hidden !border-1.5 border-solid",
                    x[g].checkbox,
                    v[s].checkbox,
                    a && w.checkbox,
                    l
                  ),
                  checked: S(),
                  onChange: A,
                  disabled: a,
                  ...c
                }
              ),
              /* @__PURE__ */ E(
                "span",
                {
                  className: K(
                    "pointer-events-none inline-flex items-center absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100",
                    x[g].icon,
                    a && w.icon
                  ),
                  children: o ? /* @__PURE__ */ E(eD, { className: K((O = v[s]) == null ? void 0 : O.icon) }) : /* @__PURE__ */ E(ad, { className: K((P = v[s]) == null ? void 0 : P.icon) })
                }
              )
            ]
          }
        ),
        !!t && _()
      ]
    }
  );
}, Jw = Dt(aK);
Jw.displayName = "Checkbox";
const vT = {
  primary: {
    checkbox: "border-border-strong hover:border-border-interactive checked:border-border-interactive bg-white checked:bg-toggle-on checked:hover:bg-toggle-on-hover checked:hover:border-toggle-on-hover focus:ring-2 focus:ring-offset-2 focus:ring-focus",
    icon: "text-white"
  }
}, bT = {
  checkbox: "disabled:bg-white checked:disabled:bg-white disabled:border-border-disabled checked:disabled:border-border-disabled cursor-not-allowed",
  icon: "peer-disabled:text-border-disabled cursor-not-allowed"
}, sK = {
  sm: "text-sm leading-5",
  md: "text-base leading-6"
}, Uv = {
  sm: {
    checkbox: "size-4",
    icon: "size-1.5",
    info: "size-4"
  },
  md: {
    checkbox: "size-5",
    icon: "size-2",
    info: "size-5"
  }
}, xT = {
  sm: {
    switch: "mt-1",
    radio: "mt-0.5"
  },
  md: {
    switch: "mt-0.5",
    radio: "mt-px"
  }
}, lK = {
  xs: "py-1 px-1 text-sm gap-0.5 [&>svg]:size-4",
  sm: "py-1 px-1.5 text-base gap-1 [&>svg]:size-4",
  md: "py-2 px-2.5 text-base gap-1 [&>svg]:size-5",
  lg: "py-2.5 px-3 text-base gap-1 [&>svg]:size-6"
}, cK = "border-0 border-r border-border-subtle border-solid", uK = "bg-background-primary text-primary cursor-pointer flex items-center justify-center", fK = "hover:bg-button-tertiary-hover", dK = "focus:outline-none";
function Qm() {
  return typeof window < "u";
}
function Wa(e) {
  return rD(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Or(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function io(e) {
  var t;
  return (t = (rD(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function rD(e) {
  return Qm() ? e instanceof Node || e instanceof Or(e).Node : !1;
}
function Ct(e) {
  return Qm() ? e instanceof Element || e instanceof Or(e).Element : !1;
}
function pn(e) {
  return Qm() ? e instanceof HTMLElement || e instanceof Or(e).HTMLElement : !1;
}
function d0(e) {
  return !Qm() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Or(e).ShadowRoot;
}
function sd(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = Hr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function hK(e) {
  return ["table", "td", "th"].includes(Wa(e));
}
function eg(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Qw(e) {
  const t = tg(), n = Ct(e) ? Hr(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function pK(e) {
  let t = Bo(e);
  for (; pn(t) && !$a(t); ) {
    if (Qw(t))
      return t;
    if (eg(t))
      return null;
    t = Bo(t);
  }
  return null;
}
function tg() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function $a(e) {
  return ["html", "body", "#document"].includes(Wa(e));
}
function Hr(e) {
  return Or(e).getComputedStyle(e);
}
function ng(e) {
  return Ct(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Bo(e) {
  if (Wa(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    d0(e) && e.host || // Fallback.
    io(e)
  );
  return d0(t) ? t.host : t;
}
function iD(e) {
  const t = Bo(e);
  return $a(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : pn(t) && sd(t) ? t : iD(t);
}
function Pa(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = iD(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Or(i);
  if (o) {
    const s = h0(a);
    return t.concat(a, a.visualViewport || [], sd(i) ? i : [], s && n ? Pa(s) : []);
  }
  return t.concat(i, Pa(i, [], n));
}
function h0(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ti(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function hn(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && d0(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function oD() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function aD() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function sD(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : p0() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function e1(e) {
  return mK() ? !1 : !p0() && e.width === 0 && e.height === 0 || p0() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function t1() {
  return /apple/i.test(navigator.vendor);
}
function p0() {
  const e = /android/i;
  return e.test(oD()) || e.test(aD());
}
function lD() {
  return oD().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function mK() {
  return aD().includes("jsdom/");
}
function cf(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function gK(e) {
  return "nativeEvent" in e;
}
function yK(e) {
  return e.matches("html,body");
}
function Kn(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Hv(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Oo(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const vK = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function n1(e) {
  return pn(e) && e.matches(vK);
}
function Un(e) {
  e.preventDefault(), e.stopPropagation();
}
function m0(e) {
  return e ? e.getAttribute("role") === "combobox" && n1(e) : !1;
}
const Da = Math.min, Br = Math.max, hp = Math.round, Cl = Math.floor, Hi = (e) => ({
  x: e,
  y: e
}), bK = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, xK = {
  start: "end",
  end: "start"
};
function g0(e, t, n) {
  return Br(e, Da(t, n));
}
function Nc(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ia(e) {
  return e.split("-")[0];
}
function $c(e) {
  return e.split("-")[1];
}
function cD(e) {
  return e === "x" ? "y" : "x";
}
function r1(e) {
  return e === "y" ? "height" : "width";
}
function $s(e) {
  return ["top", "bottom"].includes(Ia(e)) ? "y" : "x";
}
function i1(e) {
  return cD($s(e));
}
function wK(e, t, n) {
  n === void 0 && (n = !1);
  const r = $c(e), i = i1(e), o = r1(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = pp(a)), [a, pp(a)];
}
function _K(e) {
  const t = pp(e);
  return [y0(e), t, y0(t)];
}
function y0(e) {
  return e.replace(/start|end/g, (t) => xK[t]);
}
function SK(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function OK(e, t, n, r) {
  const i = $c(e);
  let o = SK(Ia(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(y0)))), o;
}
function pp(e) {
  return e.replace(/left|right|bottom|top/g, (t) => bK[t]);
}
function AK(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function uD(e) {
  return typeof e != "number" ? AK(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function mp(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var TK = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], gp = /* @__PURE__ */ TK.join(","), fD = typeof Element > "u", Xl = fD ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, yp = !fD && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, vp = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), o = i === "" || i === "true", a = o || n && t && e(t.parentNode);
  return a;
}, PK = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, CK = function(t, n, r) {
  if (vp(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(gp));
  return n && Xl.call(t, gp) && i.unshift(t), i = i.filter(r), i;
}, EK = function e(t, n, r) {
  for (var i = [], o = Array.from(t); o.length; ) {
    var a = o.shift();
    if (!vp(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = e(l, !0, r);
        r.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var f = Xl.call(a, gp);
        f && r.filter(a) && (n || !t.includes(a)) && i.push(a);
        var d = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), p = !vp(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (d && p) {
          var m = e(d === !0 ? a.children : d.children, !0, r);
          r.flatten ? i.push.apply(i, m) : i.push({
            scopeParent: a,
            candidates: m
          });
        } else
          o.unshift.apply(o, a.children);
      }
  }
  return i;
}, dD = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, hD = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || PK(t)) && !dD(t) ? 0 : t.tabIndex;
}, kK = function(t, n) {
  var r = hD(t);
  return r < 0 && n && !dD(t) ? 0 : r;
}, MK = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, pD = function(t) {
  return t.tagName === "INPUT";
}, NK = function(t) {
  return pD(t) && t.type === "hidden";
}, $K = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, DK = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, IK = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || yp(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var o = DK(i, t.form);
  return !o || o === t;
}, RK = function(t) {
  return pD(t) && t.type === "radio";
}, jK = function(t) {
  return RK(t) && !IK(t);
}, LK = function(t) {
  var n, r = t && yp(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (r && r !== t) {
    var a, s, l;
    for (o = !!((a = i) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !o && i; ) {
      var c, f, d;
      r = yp(i), i = (c = r) === null || c === void 0 ? void 0 : c.host, o = !!((f = i) !== null && f !== void 0 && (d = f.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return o;
}, wT = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, BK = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var o = Xl.call(t, "details>summary:first-of-type"), a = o ? t.parentElement : t;
  if (Xl.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = yp(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return wT(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (LK(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return wT(t);
  return !1;
}, FK = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return Xl.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, WK = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  vp(n) || NK(n) || BK(n, t) || // For a details element with a summary, the summary element gets the focus
  $K(n) || FK(n));
}, v0 = function(t, n) {
  return !(jK(n) || hD(n) < 0 || !WK(t, n));
}, zK = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, VK = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, o) {
    var a = !!i.scopeParent, s = a ? i.scopeParent : i, l = kK(s, a), c = a ? e(i.candidates) : s;
    l === 0 ? a ? n.push.apply(n, c) : n.push(s) : r.push({
      documentOrder: o,
      tabIndex: l,
      item: i,
      isScope: a,
      content: c
    });
  }), r.sort(MK).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, rg = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = EK([t], n.includeContainer, {
    filter: v0.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: zK
  }) : r = CK(t, n.includeContainer, v0.bind(null, n)), VK(r);
}, UK = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Xl.call(t, gp) === !1 ? !1 : v0(n, t);
};
function _T(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = $s(t), a = i1(t), s = r1(a), l = Ia(t), c = o === "y", f = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, p = r[s] / 2 - i[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: f,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch ($c(t)) {
    case "start":
      m[a] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      m[a] += p * (n && c ? -1 : 1);
      break;
  }
  return m;
}
const HK = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: f,
    y: d
  } = _T(c, r, l), p = r, m = {}, y = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: v,
      fn: x
    } = s[g], {
      x: w,
      y: S,
      data: A,
      reset: _
    } = await x({
      x: f,
      y: d,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: m,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = w ?? f, d = S ?? d, m = {
      ...m,
      [v]: {
        ...m[v],
        ...A
      }
    }, _ && y <= 50 && (y++, typeof _ == "object" && (_.placement && (p = _.placement), _.rects && (c = _.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : _.rects), {
      x: f,
      y: d
    } = _T(c, p, l)), g = -1);
  }
  return {
    x: f,
    y: d,
    placement: p,
    strategy: i,
    middlewareData: m
  };
};
async function o1(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = Nc(t, e), y = uD(m), v = s[p ? d === "floating" ? "reference" : "floating" : d], x = mp(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(v))) == null || n ? v : v.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: l
  })), w = d === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), A = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = mp(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: S,
    strategy: l
  }) : w);
  return {
    top: (x.top - _.top + y.top) / A.y,
    bottom: (_.bottom - x.bottom + y.bottom) / A.y,
    left: (x.left - _.left + y.left) / A.x,
    right: (_.right - x.right + y.right) / A.x
  };
}
const KK = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: f = 0
    } = Nc(e, t) || {};
    if (c == null)
      return {};
    const d = uD(f), p = {
      x: n,
      y: r
    }, m = i1(i), y = r1(m), g = await a.getDimensions(c), v = m === "y", x = v ? "top" : "left", w = v ? "bottom" : "right", S = v ? "clientHeight" : "clientWidth", A = o.reference[y] + o.reference[m] - p[m] - o.floating[y], _ = p[m] - o.reference[m], O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let P = O ? O[S] : 0;
    (!P || !await (a.isElement == null ? void 0 : a.isElement(O))) && (P = s.floating[S] || o.floating[y]);
    const C = A / 2 - _ / 2, k = P / 2 - g[y] / 2 - 1, D = Da(d[x], k), $ = Da(d[w], k), N = D, R = P - g[y] - $, L = P / 2 - g[y] / 2 + C, F = g0(N, L, R), W = !l.arrow && $c(i) != null && L !== F && o.reference[y] / 2 - (L < N ? D : $) - g[y] / 2 < 0, z = W ? L < N ? L - N : L - R : 0;
    return {
      [m]: p[m] + z,
      data: {
        [m]: F,
        centerOffset: L - F - z,
        ...W && {
          alignmentOffset: z
        }
      },
      reset: W
    };
  }
}), GK = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: f = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: g = !0,
        ...v
      } = Nc(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const x = Ia(i), w = $s(s), S = Ia(s) === s, A = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), _ = p || (S || !g ? [pp(s)] : _K(s)), O = y !== "none";
      !p && O && _.push(...OK(s, g, y, A));
      const P = [s, ..._], C = await o1(t, v), k = [];
      let D = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (f && k.push(C[x]), d) {
        const L = wK(i, a, A);
        k.push(C[L[0]], C[L[1]]);
      }
      if (D = [...D, {
        placement: i,
        overflows: k
      }], !k.every((L) => L <= 0)) {
        var $, N;
        const L = ((($ = o.flip) == null ? void 0 : $.index) || 0) + 1, F = P[L];
        if (F)
          return {
            data: {
              index: L,
              overflows: D
            },
            reset: {
              placement: F
            }
          };
        let W = (N = D.filter((z) => z.overflows[0] <= 0).sort((z, G) => z.overflows[1] - G.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!W)
          switch (m) {
            case "bestFit": {
              var R;
              const z = (R = D.filter((G) => {
                if (O) {
                  const U = $s(G.placement);
                  return U === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((U) => U > 0).reduce((U, V) => U + V, 0)]).sort((G, U) => G[1] - U[1])[0]) == null ? void 0 : R[0];
              z && (W = z);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (i !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
async function YK(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Ia(n), s = $c(n), l = $s(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, f = o && l ? -1 : 1, d = Nc(t, e);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: y
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof y == "number" && (m = s === "end" ? y * -1 : y), l ? {
    x: m * f,
    y: p * c
  } : {
    x: p * c,
    y: m * f
  };
}
const qK = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, l = await YK(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, XK = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x,
              y: w
            } = v;
            return {
              x,
              y: w
            };
          }
        },
        ...l
      } = Nc(e, t), c = {
        x: n,
        y: r
      }, f = await o1(t, l), d = $s(Ia(i)), p = cD(d);
      let m = c[p], y = c[d];
      if (o) {
        const v = p === "y" ? "top" : "left", x = p === "y" ? "bottom" : "right", w = m + f[v], S = m - f[x];
        m = g0(w, m, S);
      }
      if (a) {
        const v = d === "y" ? "top" : "left", x = d === "y" ? "bottom" : "right", w = y + f[v], S = y - f[x];
        y = g0(w, y, S);
      }
      const g = s.fn({
        ...t,
        [p]: m,
        [d]: y
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [p]: o,
            [d]: a
          }
        }
      };
    }
  };
}, ZK = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = Nc(e, t), f = await o1(t, c), d = Ia(i), p = $c(i), m = $s(i) === "y", {
        width: y,
        height: g
      } = o.floating;
      let v, x;
      d === "top" || d === "bottom" ? (v = d, x = p === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (x = d, v = p === "end" ? "top" : "bottom");
      const w = g - f.top - f.bottom, S = y - f.left - f.right, A = Da(g - f[v], w), _ = Da(y - f[x], S), O = !t.middlewareData.shift;
      let P = A, C = _;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (C = S), (r = t.middlewareData.shift) != null && r.enabled.y && (P = w), O && !p) {
        const D = Br(f.left, 0), $ = Br(f.right, 0), N = Br(f.top, 0), R = Br(f.bottom, 0);
        m ? C = y - 2 * (D !== 0 || $ !== 0 ? D + $ : Br(f.left, f.right)) : P = g - 2 * (N !== 0 || R !== 0 ? N + R : Br(f.top, f.bottom));
      }
      await l({
        ...t,
        availableWidth: C,
        availableHeight: P
      });
      const k = await a.getDimensions(s.floating);
      return y !== k.width || g !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function mD(e) {
  const t = Hr(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = pn(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = hp(n) !== o || hp(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function a1(e) {
  return Ct(e) ? e : e.contextElement;
}
function zl(e) {
  const t = a1(e);
  if (!pn(t))
    return Hi(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = mD(t);
  let a = (o ? hp(n.width) : n.width) / r, s = (o ? hp(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const JK = /* @__PURE__ */ Hi(0);
function gD(e) {
  const t = Or(e);
  return !tg() || !t.visualViewport ? JK : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function QK(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Or(e) ? !1 : t;
}
function Ds(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = a1(e);
  let a = Hi(1);
  t && (r ? Ct(r) && (a = zl(r)) : a = zl(e));
  const s = QK(o, n, r) ? gD(o) : Hi(0);
  let l = (i.left + s.x) / a.x, c = (i.top + s.y) / a.y, f = i.width / a.x, d = i.height / a.y;
  if (o) {
    const p = Or(o), m = r && Ct(r) ? Or(r) : r;
    let y = p, g = h0(y);
    for (; g && r && m !== y; ) {
      const v = zl(g), x = g.getBoundingClientRect(), w = Hr(g), S = x.left + (g.clientLeft + parseFloat(w.paddingLeft)) * v.x, A = x.top + (g.clientTop + parseFloat(w.paddingTop)) * v.y;
      l *= v.x, c *= v.y, f *= v.x, d *= v.y, l += S, c += A, y = Or(g), g = h0(y);
    }
  }
  return mp({
    width: f,
    height: d,
    x: l,
    y: c
  });
}
function s1(e, t) {
  const n = ng(e).scrollLeft;
  return t ? t.left + n : Ds(io(e)).left + n;
}
function yD(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    s1(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function eG(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = io(r), s = t ? eg(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Hi(1);
  const f = Hi(0), d = pn(r);
  if ((d || !d && !o) && ((Wa(r) !== "body" || sd(a)) && (l = ng(r)), pn(r))) {
    const m = Ds(r);
    c = zl(r), f.x = m.x + r.clientLeft, f.y = m.y + r.clientTop;
  }
  const p = a && !d && !o ? yD(a, l, !0) : Hi(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + f.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + f.y + p.y
  };
}
function tG(e) {
  return Array.from(e.getClientRects());
}
function nG(e) {
  const t = io(e), n = ng(e), r = e.ownerDocument.body, i = Br(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = Br(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + s1(e);
  const s = -n.scrollTop;
  return Hr(r).direction === "rtl" && (a += Br(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function rG(e, t) {
  const n = Or(e), r = io(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const c = tg();
    (!c || c && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function iG(e, t) {
  const n = Ds(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = pn(e) ? zl(e) : Hi(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, l = i * o.x, c = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function ST(e, t, n) {
  let r;
  if (t === "viewport")
    r = rG(e, n);
  else if (t === "document")
    r = nG(io(e));
  else if (Ct(t))
    r = iG(t, n);
  else {
    const i = gD(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return mp(r);
}
function vD(e, t) {
  const n = Bo(e);
  return n === t || !Ct(n) || $a(n) ? !1 : Hr(n).position === "fixed" || vD(n, t);
}
function oG(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Pa(e, [], !1).filter((s) => Ct(s) && Wa(s) !== "body"), i = null;
  const o = Hr(e).position === "fixed";
  let a = o ? Bo(e) : e;
  for (; Ct(a) && !$a(a); ) {
    const s = Hr(a), l = Qw(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || sd(a) && !l && vD(e, a)) ? r = r.filter((f) => f !== a) : i = s, a = Bo(a);
  }
  return t.set(e, r), r;
}
function aG(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? eg(t) ? [] : oG(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((c, f) => {
    const d = ST(t, f, i);
    return c.top = Br(d.top, c.top), c.right = Da(d.right, c.right), c.bottom = Da(d.bottom, c.bottom), c.left = Br(d.left, c.left), c;
  }, ST(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function sG(e) {
  const {
    width: t,
    height: n
  } = mD(e);
  return {
    width: t,
    height: n
  };
}
function lG(e, t, n) {
  const r = pn(t), i = io(t), o = n === "fixed", a = Ds(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Hi(0);
  if (r || !r && !o)
    if ((Wa(t) !== "body" || sd(i)) && (s = ng(t)), r) {
      const p = Ds(t, !0, o, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else i && (l.x = s1(i));
  const c = i && !r && !o ? yD(i, s) : Hi(0), f = a.left + s.scrollLeft - l.x - c.x, d = a.top + s.scrollTop - l.y - c.y;
  return {
    x: f,
    y: d,
    width: a.width,
    height: a.height
  };
}
function Kv(e) {
  return Hr(e).position === "static";
}
function OT(e, t) {
  if (!pn(e) || Hr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return io(e) === n && (n = n.ownerDocument.body), n;
}
function bD(e, t) {
  const n = Or(e);
  if (eg(e))
    return n;
  if (!pn(e)) {
    let i = Bo(e);
    for (; i && !$a(i); ) {
      if (Ct(i) && !Kv(i))
        return i;
      i = Bo(i);
    }
    return n;
  }
  let r = OT(e, t);
  for (; r && hK(r) && Kv(r); )
    r = OT(r, t);
  return r && $a(r) && Kv(r) && !Qw(r) ? n : r || pK(e) || n;
}
const cG = async function(e) {
  const t = this.getOffsetParent || bD, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: lG(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function uG(e) {
  return Hr(e).direction === "rtl";
}
const fG = {
  convertOffsetParentRelativeRectToViewportRelativeRect: eG,
  getDocumentElement: io,
  getClippingRect: aG,
  getOffsetParent: bD,
  getElementRects: cG,
  getClientRects: tG,
  getDimensions: sG,
  getScale: zl,
  isElement: Ct,
  isRTL: uG
};
function dG(e, t) {
  let n = null, r;
  const i = io(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const {
      left: c,
      top: f,
      width: d,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !d || !p)
      return;
    const m = Cl(f), y = Cl(i.clientWidth - (c + d)), g = Cl(i.clientHeight - (f + p)), v = Cl(c), w = {
      rootMargin: -m + "px " + -y + "px " + -g + "px " + -v + "px",
      threshold: Br(0, Da(1, l)) || 1
    };
    let S = !0;
    function A(_) {
      const O = _[0].intersectionRatio;
      if (O !== l) {
        if (!S)
          return a();
        O ? a(!1, O) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(A, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(A, w);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function ig(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = a1(e), f = i || o ? [...c ? Pa(c) : [], ...Pa(t)] : [];
  f.forEach((x) => {
    i && x.addEventListener("scroll", n, {
      passive: !0
    }), o && x.addEventListener("resize", n);
  });
  const d = c && s ? dG(c, n) : null;
  let p = -1, m = null;
  a && (m = new ResizeObserver((x) => {
    let [w] = x;
    w && w.target === c && m && (m.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), c && !l && m.observe(c), m.observe(t));
  let y, g = l ? Ds(e) : null;
  l && v();
  function v() {
    const x = Ds(e);
    g && (x.x !== g.x || x.y !== g.y || x.width !== g.width || x.height !== g.height) && n(), g = x, y = requestAnimationFrame(v);
  }
  return n(), () => {
    var x;
    f.forEach((w) => {
      i && w.removeEventListener("scroll", n), o && w.removeEventListener("resize", n);
    }), d == null || d(), (x = m) == null || x.disconnect(), m = null, l && cancelAnimationFrame(y);
  };
}
const hG = qK, pG = XK, mG = GK, gG = ZK, AT = KK, yG = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: fG,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return HK(e, t, {
    ...i,
    platform: o
  });
};
var rp = typeof document < "u" ? di : Xe;
function bp(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!bp(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !bp(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function xD(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function TT(e, t) {
  const n = xD(e);
  return Math.round(t * n) / n;
}
function Gv(e) {
  const t = te.useRef(e);
  return rp(() => {
    t.current = e;
  }), t;
}
function vG(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [f, d] = te.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = te.useState(r);
  bp(p, r) || m(r);
  const [y, g] = te.useState(null), [v, x] = te.useState(null), w = te.useCallback((G) => {
    G !== O.current && (O.current = G, g(G));
  }, []), S = te.useCallback((G) => {
    G !== P.current && (P.current = G, x(G));
  }, []), A = o || y, _ = a || v, O = te.useRef(null), P = te.useRef(null), C = te.useRef(f), k = l != null, D = Gv(l), $ = Gv(i), N = Gv(c), R = te.useCallback(() => {
    if (!O.current || !P.current)
      return;
    const G = {
      placement: t,
      strategy: n,
      middleware: p
    };
    $.current && (G.platform = $.current), yG(O.current, P.current, G).then((U) => {
      const V = {
        ...U,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: N.current !== !1
      };
      L.current && !bp(C.current, V) && (C.current = V, V$.flushSync(() => {
        d(V);
      }));
    });
  }, [p, t, n, $, N]);
  rp(() => {
    c === !1 && C.current.isPositioned && (C.current.isPositioned = !1, d((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [c]);
  const L = te.useRef(!1);
  rp(() => (L.current = !0, () => {
    L.current = !1;
  }), []), rp(() => {
    if (A && (O.current = A), _ && (P.current = _), A && _) {
      if (D.current)
        return D.current(A, _, R);
      R();
    }
  }, [A, _, R, D, k]);
  const F = te.useMemo(() => ({
    reference: O,
    floating: P,
    setReference: w,
    setFloating: S
  }), [w, S]), W = te.useMemo(() => ({
    reference: A,
    floating: _
  }), [A, _]), z = te.useMemo(() => {
    const G = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return G;
    const U = TT(W.floating, f.x), V = TT(W.floating, f.y);
    return s ? {
      ...G,
      transform: "translate(" + U + "px, " + V + "px)",
      ...xD(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: U,
      top: V
    };
  }, [n, s, W.floating, f.x, f.y]);
  return te.useMemo(() => ({
    ...f,
    update: R,
    refs: F,
    elements: W,
    floatingStyles: z
  }), [f, R, F, W, z]);
}
const bG = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? AT({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? AT({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, og = (e, t) => ({
  ...hG(e),
  options: [e, t]
}), wD = (e, t) => ({
  ...pG(e),
  options: [e, t]
}), ag = (e, t) => ({
  ...mG(e),
  options: [e, t]
}), _D = (e, t) => ({
  ...gG(e),
  options: [e, t]
}), xG = (e, t) => ({
  ...bG(e),
  options: [e, t]
}), SD = {
  ...te
}, wG = SD.useInsertionEffect, _G = wG || ((e) => e());
function Nn(e) {
  const t = te.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return _G(() => {
    t.current = e;
  }), te.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const l1 = "ArrowUp", ld = "ArrowDown", Ca = "ArrowLeft", Ea = "ArrowRight";
function Th(e, t, n) {
  return Math.floor(e / t) !== n;
}
function Vu(e, t) {
  return t < 0 || t >= e.current.length;
}
function Yv(e, t) {
  return Qn(e, {
    disabledIndices: t
  });
}
function PT(e, t) {
  return Qn(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function Qn(e, t) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: i,
    amount: o = 1
  } = t === void 0 ? {} : t;
  const a = e.current;
  let s = n;
  do
    s += r ? -o : o;
  while (s >= 0 && s <= a.length - 1 && ip(a, s, i));
  return s;
}
function SG(e, t) {
  let {
    event: n,
    orientation: r,
    loop: i,
    rtl: o,
    cols: a,
    disabledIndices: s,
    minIndex: l,
    maxIndex: c,
    prevIndex: f,
    stopEvent: d = !1
  } = t, p = f;
  if (n.key === l1) {
    if (d && Un(n), f === -1)
      p = c;
    else if (p = Qn(e, {
      startingIndex: p,
      amount: a,
      decrement: !0,
      disabledIndices: s
    }), i && (f - a < l || p < 0)) {
      const m = f % a, y = c % a, g = c - (y - m);
      y === m ? p = c : p = y > m ? g : g - a;
    }
    Vu(e, p) && (p = f);
  }
  if (n.key === ld && (d && Un(n), f === -1 ? p = l : (p = Qn(e, {
    startingIndex: f,
    amount: a,
    disabledIndices: s
  }), i && f + a > c && (p = Qn(e, {
    startingIndex: f % a - a,
    amount: a,
    disabledIndices: s
  }))), Vu(e, p) && (p = f)), r === "both") {
    const m = Cl(f / a);
    n.key === (o ? Ca : Ea) && (d && Un(n), f % a !== a - 1 ? (p = Qn(e, {
      startingIndex: f,
      disabledIndices: s
    }), i && Th(p, a, m) && (p = Qn(e, {
      startingIndex: f - f % a - 1,
      disabledIndices: s
    }))) : i && (p = Qn(e, {
      startingIndex: f - f % a - 1,
      disabledIndices: s
    })), Th(p, a, m) && (p = f)), n.key === (o ? Ea : Ca) && (d && Un(n), f % a !== 0 ? (p = Qn(e, {
      startingIndex: f,
      decrement: !0,
      disabledIndices: s
    }), i && Th(p, a, m) && (p = Qn(e, {
      startingIndex: f + (a - f % a),
      decrement: !0,
      disabledIndices: s
    }))) : i && (p = Qn(e, {
      startingIndex: f + (a - f % a),
      decrement: !0,
      disabledIndices: s
    })), Th(p, a, m) && (p = f));
    const y = Cl(c / a) === m;
    Vu(e, p) && (i && y ? p = n.key === (o ? Ea : Ca) ? c : Qn(e, {
      startingIndex: f - f % a - 1,
      disabledIndices: s
    }) : p = f);
  }
  return p;
}
function OG(e, t, n) {
  const r = [];
  let i = 0;
  return e.forEach((o, a) => {
    let {
      width: s,
      height: l
    } = o;
    if (s > t && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + a + " is greater than grid columns");
    let c = !1;
    for (n && (i = 0); !c; ) {
      const f = [];
      for (let d = 0; d < s; d++)
        for (let p = 0; p < l; p++)
          f.push(i + d + p * t);
      i % t + s <= t && f.every((d) => r[d] == null) ? (f.forEach((d) => {
        r[d] = a;
      }), c = !0) : i++;
    }
  }), [...r];
}
function AG(e, t, n, r, i) {
  if (e === -1) return -1;
  const o = n.indexOf(e), a = t[e];
  switch (i) {
    case "tl":
      return o;
    case "tr":
      return a ? o + a.width - 1 : o;
    case "bl":
      return a ? o + (a.height - 1) * r : o;
    case "br":
      return n.lastIndexOf(e);
  }
}
function TG(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function ip(e, t, n) {
  if (n)
    return n.includes(t);
  const r = e[t];
  return r == null || r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true";
}
var Nt = typeof document < "u" ? di : Xe;
function uf() {
  return uf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uf.apply(this, arguments);
}
let CT = !1, PG = 0;
const ET = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + PG++
);
function CG() {
  const [e, t] = te.useState(() => CT ? ET() : void 0);
  return Nt(() => {
    e == null && t(ET());
  }, []), te.useEffect(() => {
    CT = !0;
  }, []), e;
}
const EG = SD.useId, sg = EG || CG;
let ff;
process.env.NODE_ENV !== "production" && (ff = /* @__PURE__ */ new Set());
function op() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((e = ff) != null && e.has(i))) {
    var o;
    (o = ff) == null || o.add(i), console.warn(i);
  }
}
function kG() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((e = ff) != null && e.has(i))) {
    var o;
    (o = ff) == null || o.add(i), console.error(i);
  }
}
const MG = /* @__PURE__ */ te.forwardRef(function(t, n) {
  const {
    context: {
      placement: r,
      elements: {
        floating: i
      },
      middlewareData: {
        arrow: o,
        shift: a
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: f = 0,
    staticOffset: d,
    stroke: p,
    d: m,
    style: {
      transform: y,
      ...g
    } = {},
    ...v
  } = t;
  process.env.NODE_ENV !== "production" && (n || op("The `ref` prop is required for `FloatingArrow`."));
  const x = sg(), [w, S] = te.useState(!1);
  if (Nt(() => {
    if (!i) return;
    Hr(i).direction === "rtl" && S(!0);
  }, [i]), !i)
    return null;
  const [A, _] = r.split("-"), O = A === "top" || A === "bottom";
  let P = d;
  (O && a != null && a.x || !O && a != null && a.y) && (P = null);
  const C = f * 2, k = C / 2, D = s / 2 * (c / -8 + 1), $ = l / 2 * c / 4, N = !!m, R = P && _ === "end" ? "bottom" : "top";
  let L = P && _ === "end" ? "right" : "left";
  P && w && (L = _ === "end" ? "left" : "right");
  const F = (o == null ? void 0 : o.x) != null ? P || o.x : "", W = (o == null ? void 0 : o.y) != null ? P || o.y : "", z = m || "M0,0" + (" H" + s) + (" L" + (s - D) + "," + (l - $)) + (" Q" + s / 2 + "," + l + " " + D + "," + (l - $)) + " Z", G = {
    top: N ? "rotate(180deg)" : "",
    left: N ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: N ? "" : "rotate(180deg)",
    right: N ? "rotate(-90deg)" : "rotate(90deg)"
  }[A];
  return /* @__PURE__ */ te.createElement("svg", uf({}, v, {
    "aria-hidden": !0,
    ref: n,
    width: N ? s : s + C,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [L]: F,
      [R]: W,
      [A]: O || N ? "100%" : "calc(100% - " + C / 2 + "px)",
      transform: [G, y].filter((U) => !!U).join(" "),
      ...g
    }
  }), C > 0 && /* @__PURE__ */ te.createElement("path", {
    clipPath: "url(#" + x + ")",
    fill: "none",
    stroke: p,
    strokeWidth: C + (m ? 0 : 1),
    d: z
  }), /* @__PURE__ */ te.createElement("path", {
    stroke: C && !m ? v.fill : "none",
    d: z
  }), /* @__PURE__ */ te.createElement("clipPath", {
    id: x
  }, /* @__PURE__ */ te.createElement("rect", {
    x: -k,
    y: k * (N ? -1 : 1),
    width: s + C,
    height: s
  })));
});
function NG() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((i) => i(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((i) => i !== n)) || []);
    }
  };
}
const $G = /* @__PURE__ */ te.createContext(null), DG = /* @__PURE__ */ te.createContext(null), lg = () => {
  var e;
  return ((e = te.useContext($G)) == null ? void 0 : e.id) || null;
}, cd = () => te.useContext(DG);
function Is(e) {
  return "data-floating-ui-" + e;
}
function Yn(e) {
  const t = ut(e);
  return Nt(() => {
    t.current = e;
  }), t;
}
const kT = /* @__PURE__ */ Is("safe-polygon");
function qv(e, t, n) {
  return n && !cf(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function IG(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    events: o,
    elements: a
  } = e, {
    enabled: s = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: f = !1,
    restMs: d = 0,
    move: p = !0
  } = t, m = cd(), y = lg(), g = Yn(c), v = Yn(l), x = Yn(n), w = te.useRef(), S = te.useRef(-1), A = te.useRef(), _ = te.useRef(-1), O = te.useRef(!0), P = te.useRef(!1), C = te.useRef(() => {
  }), k = te.useRef(!1), D = te.useCallback(() => {
    var z;
    const G = (z = i.current.openEvent) == null ? void 0 : z.type;
    return (G == null ? void 0 : G.includes("mouse")) && G !== "mousedown";
  }, [i]);
  te.useEffect(() => {
    if (!s) return;
    function z(G) {
      let {
        open: U
      } = G;
      U || (clearTimeout(S.current), clearTimeout(_.current), O.current = !0, k.current = !1);
    }
    return o.on("openchange", z), () => {
      o.off("openchange", z);
    };
  }, [s, o]), te.useEffect(() => {
    if (!s || !g.current || !n) return;
    function z(U) {
      D() && r(!1, U, "hover");
    }
    const G = Kn(a.floating).documentElement;
    return G.addEventListener("mouseleave", z), () => {
      G.removeEventListener("mouseleave", z);
    };
  }, [a.floating, n, r, s, g, D]);
  const $ = te.useCallback(function(z, G, U) {
    G === void 0 && (G = !0), U === void 0 && (U = "hover");
    const V = qv(v.current, "close", w.current);
    V && !A.current ? (clearTimeout(S.current), S.current = window.setTimeout(() => r(!1, z, U), V)) : G && (clearTimeout(S.current), r(!1, z, U));
  }, [v, r]), N = Nn(() => {
    C.current(), A.current = void 0;
  }), R = Nn(() => {
    if (P.current) {
      const z = Kn(a.floating).body;
      z.style.pointerEvents = "", z.removeAttribute(kT), P.current = !1;
    }
  }), L = Nn(() => i.current.openEvent ? ["click", "mousedown"].includes(i.current.openEvent.type) : !1);
  te.useEffect(() => {
    if (!s) return;
    function z(Y) {
      if (clearTimeout(S.current), O.current = !1, f && !cf(w.current) || d > 0 && !qv(v.current, "open"))
        return;
      const ee = qv(v.current, "open", w.current);
      ee ? S.current = window.setTimeout(() => {
        x.current || r(!0, Y, "hover");
      }, ee) : n || r(!0, Y, "hover");
    }
    function G(Y) {
      if (L()) return;
      C.current();
      const ee = Kn(a.floating);
      if (clearTimeout(_.current), k.current = !1, g.current && i.current.floatingContext) {
        n || clearTimeout(S.current), A.current = g.current({
          ...i.current.floatingContext,
          tree: m,
          x: Y.clientX,
          y: Y.clientY,
          onClose() {
            R(), N(), L() || $(Y, !0, "safe-polygon");
          }
        });
        const re = A.current;
        ee.addEventListener("mousemove", re), C.current = () => {
          ee.removeEventListener("mousemove", re);
        };
        return;
      }
      (w.current === "touch" ? !hn(a.floating, Y.relatedTarget) : !0) && $(Y);
    }
    function U(Y) {
      L() || i.current.floatingContext && (g.current == null || g.current({
        ...i.current.floatingContext,
        tree: m,
        x: Y.clientX,
        y: Y.clientY,
        onClose() {
          R(), N(), L() || $(Y);
        }
      })(Y));
    }
    if (Ct(a.domReference)) {
      var V;
      const Y = a.domReference;
      return n && Y.addEventListener("mouseleave", U), (V = a.floating) == null || V.addEventListener("mouseleave", U), p && Y.addEventListener("mousemove", z, {
        once: !0
      }), Y.addEventListener("mouseenter", z), Y.addEventListener("mouseleave", G), () => {
        var ee;
        n && Y.removeEventListener("mouseleave", U), (ee = a.floating) == null || ee.removeEventListener("mouseleave", U), p && Y.removeEventListener("mousemove", z), Y.removeEventListener("mouseenter", z), Y.removeEventListener("mouseleave", G);
      };
    }
  }, [a, s, e, f, d, p, $, N, R, r, n, x, m, v, g, i, L]), Nt(() => {
    var z;
    if (s && n && (z = g.current) != null && z.__options.blockPointerEvents && D()) {
      P.current = !0;
      const U = a.floating;
      if (Ct(a.domReference) && U) {
        var G;
        const V = Kn(a.floating).body;
        V.setAttribute(kT, "");
        const Y = a.domReference, ee = m == null || (G = m.nodesRef.current.find((ie) => ie.id === y)) == null || (G = G.context) == null ? void 0 : G.elements.floating;
        return ee && (ee.style.pointerEvents = ""), V.style.pointerEvents = "none", Y.style.pointerEvents = "auto", U.style.pointerEvents = "auto", () => {
          V.style.pointerEvents = "", Y.style.pointerEvents = "", U.style.pointerEvents = "";
        };
      }
    }
  }, [s, n, y, a, m, g, D]), Nt(() => {
    n || (w.current = void 0, k.current = !1, N(), R());
  }, [n, N, R]), te.useEffect(() => () => {
    N(), clearTimeout(S.current), clearTimeout(_.current), R();
  }, [s, a.domReference, N, R]);
  const F = te.useMemo(() => {
    function z(G) {
      w.current = G.pointerType;
    }
    return {
      onPointerDown: z,
      onPointerEnter: z,
      onMouseMove(G) {
        const {
          nativeEvent: U
        } = G;
        function V() {
          !O.current && !x.current && r(!0, U, "hover");
        }
        f && !cf(w.current) || n || d === 0 || k.current && G.movementX ** 2 + G.movementY ** 2 < 2 || (clearTimeout(_.current), w.current === "touch" ? V() : (k.current = !0, _.current = window.setTimeout(V, d)));
      }
    };
  }, [f, r, n, x, d]), W = te.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(S.current);
    },
    onMouseLeave(z) {
      L() || $(z.nativeEvent, !1);
    }
  }), [$, L]);
  return te.useMemo(() => s ? {
    reference: F,
    floating: W
  } : {}, [s, F, W]);
}
let MT = 0;
function ba(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: i = !1
  } = t;
  r && cancelAnimationFrame(MT);
  const o = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  i ? o() : MT = requestAnimationFrame(o);
}
function RG(e, t) {
  var n;
  let r = [], i = (n = e.find((o) => o.id === t)) == null ? void 0 : n.parentId;
  for (; i; ) {
    const o = e.find((a) => a.id === i);
    i = o == null ? void 0 : o.parentId, o && (r = r.concat(o));
  }
  return r;
}
function Ts(e, t) {
  let n = e.filter((i) => {
    var o;
    return i.parentId === t && ((o = i.context) == null ? void 0 : o.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((i) => {
      var o;
      return (o = r) == null ? void 0 : o.some((a) => {
        var s;
        return i.parentId === a.id && ((s = i.context) == null ? void 0 : s.open);
      });
    }), n = n.concat(r);
  return n;
}
function jG(e, t) {
  let n, r = -1;
  function i(o, a) {
    a > r && (n = o, r = a), Ts(e, o).forEach((l) => {
      i(l.id, a + 1);
    });
  }
  return i(t, 0), e.find((o) => o.id === n);
}
let vl = /* @__PURE__ */ new WeakMap(), Ph = /* @__PURE__ */ new WeakSet(), Ch = {}, Xv = 0;
const LG = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, OD = (e) => e && (e.host || OD(e.parentNode)), BG = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = OD(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function FG(e, t, n, r) {
  const i = "data-floating-ui-inert", o = r ? "inert" : n ? "aria-hidden" : null, a = BG(t, e), s = /* @__PURE__ */ new Set(), l = new Set(a), c = [];
  Ch[i] || (Ch[i] = /* @__PURE__ */ new WeakMap());
  const f = Ch[i];
  a.forEach(d), p(t), s.clear();
  function d(m) {
    !m || s.has(m) || (s.add(m), m.parentNode && d(m.parentNode));
  }
  function p(m) {
    !m || l.has(m) || [].forEach.call(m.children, (y) => {
      if (Wa(y) !== "script")
        if (s.has(y))
          p(y);
        else {
          const g = o ? y.getAttribute(o) : null, v = g !== null && g !== "false", x = (vl.get(y) || 0) + 1, w = (f.get(y) || 0) + 1;
          vl.set(y, x), f.set(y, w), c.push(y), x === 1 && v && Ph.add(y), w === 1 && y.setAttribute(i, ""), !v && o && y.setAttribute(o, "true");
        }
    });
  }
  return Xv++, () => {
    c.forEach((m) => {
      const y = (vl.get(m) || 0) - 1, g = (f.get(m) || 0) - 1;
      vl.set(m, y), f.set(m, g), y || (!Ph.has(m) && o && m.removeAttribute(o), Ph.delete(m)), g || m.removeAttribute(i);
    }), Xv--, Xv || (vl = /* @__PURE__ */ new WeakMap(), vl = /* @__PURE__ */ new WeakMap(), Ph = /* @__PURE__ */ new WeakSet(), Ch = {});
  };
}
function NT(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = Kn(e[0]).body;
  return FG(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const df = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function AD(e, t) {
  const n = rg(e, df());
  t === "prev" && n.reverse();
  const r = n.indexOf(Ti(Kn(e)));
  return n.slice(r + 1)[0];
}
function TD() {
  return AD(document.body, "next");
}
function PD() {
  return AD(document.body, "prev");
}
function Uu(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !hn(n, r);
}
function WG(e) {
  rg(e, df()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function $T(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const cg = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let zG;
function DT(e) {
  e.key === "Tab" && (e.target, clearTimeout(zG));
}
const xp = /* @__PURE__ */ te.forwardRef(function(t, n) {
  const [r, i] = te.useState();
  Nt(() => (t1() && i("button"), document.addEventListener("keydown", DT), () => {
    document.removeEventListener("keydown", DT);
  }), []);
  const o = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Is("focus-guard")]: "",
    style: cg
  };
  return /* @__PURE__ */ te.createElement("span", uf({}, t, o));
}), CD = /* @__PURE__ */ te.createContext(null), IT = /* @__PURE__ */ Is("portal");
function VG(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = sg(), i = ED(), [o, a] = te.useState(null), s = te.useRef(null);
  return Nt(() => () => {
    o == null || o.remove(), queueMicrotask(() => {
      s.current = null;
    });
  }, [o]), Nt(() => {
    if (!r || s.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = r, c.setAttribute(IT, ""), l.appendChild(c), s.current = c, a(c);
  }, [t, r]), Nt(() => {
    if (n === null || !r || s.current) return;
    let l = n || (i == null ? void 0 : i.portalNode);
    l && !Ct(l) && (l = l.current), l = l || document.body;
    let c = null;
    t && (c = document.createElement("div"), c.id = t, l.appendChild(c));
    const f = document.createElement("div");
    f.id = r, f.setAttribute(IT, ""), l = c || l, l.appendChild(f), s.current = f, a(f);
  }, [t, n, r, i]), o;
}
function ug(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: i = !0
  } = e, o = VG({
    id: n,
    root: r
  }), [a, s] = te.useState(null), l = te.useRef(null), c = te.useRef(null), f = te.useRef(null), d = te.useRef(null), p = a == null ? void 0 : a.modal, m = a == null ? void 0 : a.open, y = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && // Don't render if unmount is transitioning.
    a.open && i && !!(r || o)
  );
  return te.useEffect(() => {
    if (!o || !i || p)
      return;
    function g(v) {
      o && Uu(v) && (v.type === "focusin" ? $T : WG)(o);
    }
    return o.addEventListener("focusin", g, !0), o.addEventListener("focusout", g, !0), () => {
      o.removeEventListener("focusin", g, !0), o.removeEventListener("focusout", g, !0);
    };
  }, [o, i, p]), te.useEffect(() => {
    o && (m || $T(o));
  }, [m, o]), /* @__PURE__ */ te.createElement(CD.Provider, {
    value: te.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: f,
      afterInsideRef: d,
      portalNode: o,
      setFocusManagerState: s
    }), [i, o])
  }, y && o && /* @__PURE__ */ te.createElement(xp, {
    "data-type": "outside",
    ref: l,
    onFocus: (g) => {
      if (Uu(g, o)) {
        var v;
        (v = f.current) == null || v.focus();
      } else {
        const x = PD() || (a == null ? void 0 : a.refs.domReference.current);
        x == null || x.focus();
      }
    }
  }), y && o && /* @__PURE__ */ te.createElement("span", {
    "aria-owns": o.id,
    style: cg
  }), o && /* @__PURE__ */ V$.createPortal(t, o), y && o && /* @__PURE__ */ te.createElement(xp, {
    "data-type": "outside",
    ref: c,
    onFocus: (g) => {
      if (Uu(g, o)) {
        var v;
        (v = d.current) == null || v.focus();
      } else {
        const x = TD() || (a == null ? void 0 : a.refs.domReference.current);
        x == null || x.focus(), a != null && a.closeOnFocusOut && (a == null || a.onOpenChange(!1, g.nativeEvent, "focus-out"));
      }
    }
  }));
}
const ED = () => te.useContext(CD), b0 = "data-floating-ui-focusable";
function kD(e) {
  return e ? e.hasAttribute(b0) ? e : e.querySelector("[" + b0 + "]") || e : null;
}
const RT = 20;
let fs = [];
function Zv(e) {
  fs = fs.filter((n) => n.isConnected);
  let t = e;
  if (!(!t || Wa(t) === "body")) {
    if (!UK(t, df())) {
      const n = rg(t, df())[0];
      n && (t = n);
    }
    fs.push(t), fs.length > RT && (fs = fs.slice(-RT));
  }
}
function jT() {
  return fs.slice().reverse().find((e) => e.isConnected);
}
const UG = /* @__PURE__ */ te.forwardRef(function(t, n) {
  return /* @__PURE__ */ te.createElement("button", uf({}, t, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: cg
  }));
});
function HG(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: i = ["content"],
    guards: o = !0,
    initialFocus: a = 0,
    returnFocus: s = !0,
    restoreFocus: l = !1,
    modal: c = !0,
    visuallyHiddenDismiss: f = !1,
    closeOnFocusOut: d = !0
  } = e, {
    open: p,
    refs: m,
    nodeId: y,
    onOpenChange: g,
    events: v,
    dataRef: x,
    floatingId: w,
    elements: {
      domReference: S,
      floating: A
    }
  } = t, _ = typeof a == "number" && a < 0, O = m0(S) && _, P = LG() ? o : !0, C = Yn(i), k = Yn(a), D = Yn(s), $ = cd(), N = ED(), R = te.useRef(null), L = te.useRef(null), F = te.useRef(!1), W = te.useRef(!1), z = te.useRef(-1), G = N != null, U = kD(A), V = Nn(function(re) {
    return re === void 0 && (re = U), re ? rg(re, df()) : [];
  }), Y = Nn((re) => {
    const le = V(re);
    return C.current.map((ae) => S && ae === "reference" ? S : U && ae === "floating" ? U : le).filter(Boolean).flat();
  });
  te.useEffect(() => {
    if (r || !c) return;
    function re(ae) {
      if (ae.key === "Tab") {
        hn(U, Ti(Kn(U))) && V().length === 0 && !O && Un(ae);
        const ue = Y(), ne = Oo(ae);
        C.current[0] === "reference" && ne === S && (Un(ae), ae.shiftKey ? ba(ue[ue.length - 1]) : ba(ue[1])), C.current[1] === "floating" && ne === U && ae.shiftKey && (Un(ae), ba(ue[0]));
      }
    }
    const le = Kn(U);
    return le.addEventListener("keydown", re), () => {
      le.removeEventListener("keydown", re);
    };
  }, [r, S, U, c, C, O, V, Y]), te.useEffect(() => {
    if (r || !A) return;
    function re(le) {
      const ae = Oo(le), ne = V().indexOf(ae);
      ne !== -1 && (z.current = ne);
    }
    return A.addEventListener("focusin", re), () => {
      A.removeEventListener("focusin", re);
    };
  }, [r, A, V]), te.useEffect(() => {
    if (r || !d) return;
    function re() {
      W.current = !0, setTimeout(() => {
        W.current = !1;
      });
    }
    function le(ae) {
      const ue = ae.relatedTarget;
      queueMicrotask(() => {
        const ne = !(hn(S, ue) || hn(A, ue) || hn(ue, A) || hn(N == null ? void 0 : N.portalNode, ue) || ue != null && ue.hasAttribute(Is("focus-guard")) || $ && (Ts($.nodesRef.current, y).find((J) => {
          var fe, be;
          return hn((fe = J.context) == null ? void 0 : fe.elements.floating, ue) || hn((be = J.context) == null ? void 0 : be.elements.domReference, ue);
        }) || RG($.nodesRef.current, y).find((J) => {
          var fe, be;
          return ((fe = J.context) == null ? void 0 : fe.elements.floating) === ue || ((be = J.context) == null ? void 0 : be.elements.domReference) === ue;
        })));
        if (l && ne && Ti(Kn(U)) === Kn(U).body) {
          pn(U) && U.focus();
          const J = z.current, fe = V(), be = fe[J] || fe[fe.length - 1] || U;
          pn(be) && be.focus();
        }
        (O || !c) && ue && ne && !W.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        ue !== jT() && (F.current = !0, g(!1, ae, "focus-out"));
      });
    }
    if (A && pn(S))
      return S.addEventListener("focusout", le), S.addEventListener("pointerdown", re), A.addEventListener("focusout", le), () => {
        S.removeEventListener("focusout", le), S.removeEventListener("pointerdown", re), A.removeEventListener("focusout", le);
      };
  }, [r, S, A, U, c, y, $, N, g, d, l, V, O]), te.useEffect(() => {
    var re;
    if (r) return;
    const le = Array.from((N == null || (re = N.portalNode) == null ? void 0 : re.querySelectorAll("[" + Is("portal") + "]")) || []);
    if (A) {
      const ae = [A, ...le, R.current, L.current, C.current.includes("reference") || O ? S : null].filter((ne) => ne != null), ue = c || O ? NT(ae, P, !P) : NT(ae);
      return () => {
        ue();
      };
    }
  }, [r, S, A, c, C, N, O, P]), Nt(() => {
    if (r || !pn(U)) return;
    const re = Kn(U), le = Ti(re);
    queueMicrotask(() => {
      const ae = Y(U), ue = k.current, ne = (typeof ue == "number" ? ae[ue] : ue.current) || U, J = hn(U, le);
      !_ && !J && p && ba(ne, {
        preventScroll: ne === U
      });
    });
  }, [r, p, U, _, Y, k]), Nt(() => {
    if (r || !U) return;
    let re = !1;
    const le = Kn(U), ae = Ti(le);
    let ne = x.current.openEvent;
    Zv(ae);
    function J(X) {
      let {
        open: De,
        reason: pe,
        event: ke,
        nested: it
      } = X;
      De && (ne = ke), pe === "escape-key" && m.domReference.current && Zv(m.domReference.current), pe === "hover" && ke.type === "mouseleave" && (F.current = !0), pe === "outside-press" && (it ? (F.current = !1, re = !0) : F.current = !(sD(ke) || e1(ke)));
    }
    v.on("openchange", J);
    const fe = le.createElement("span");
    fe.setAttribute("tabindex", "-1"), fe.setAttribute("aria-hidden", "true"), Object.assign(fe.style, cg), G && S && S.insertAdjacentElement("afterend", fe);
    function be() {
      return typeof D.current == "boolean" ? jT() || fe : D.current.current || fe;
    }
    return () => {
      v.off("openchange", J);
      const X = Ti(le), De = hn(A, X) || $ && Ts($.nodesRef.current, y).some((it) => {
        var st;
        return hn((st = it.context) == null ? void 0 : st.elements.floating, X);
      });
      (De || ne && ["click", "mousedown"].includes(ne.type)) && m.domReference.current && Zv(m.domReference.current);
      const ke = be();
      queueMicrotask(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        D.current && !F.current && pn(ke) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(ke !== X && X !== le.body) || De) && ke.focus({
          preventScroll: re
        }), fe.remove();
      });
    };
  }, [r, A, U, D, x, m, v, $, y, G, S]), te.useEffect(() => {
    queueMicrotask(() => {
      F.current = !1;
    });
  }, [r]), Nt(() => {
    if (!r && N)
      return N.setFocusManagerState({
        modal: c,
        closeOnFocusOut: d,
        open: p,
        onOpenChange: g,
        refs: m
      }), () => {
        N.setFocusManagerState(null);
      };
  }, [r, N, c, p, g, m, d]), Nt(() => {
    if (r || !U || typeof MutationObserver != "function" || _) return;
    const re = () => {
      const ae = U.getAttribute("tabindex"), ue = V(), ne = Ti(Kn(A)), J = ue.indexOf(ne);
      J !== -1 && (z.current = J), C.current.includes("floating") || ne !== m.domReference.current && ue.length === 0 ? ae !== "0" && U.setAttribute("tabindex", "0") : ae !== "-1" && U.setAttribute("tabindex", "-1");
    };
    re();
    const le = new MutationObserver(re);
    return le.observe(U, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      le.disconnect();
    };
  }, [r, A, U, m, C, V, _]);
  function ee(re) {
    return r || !f || !c ? null : /* @__PURE__ */ te.createElement(UG, {
      ref: re === "start" ? R : L,
      onClick: (le) => g(!1, le.nativeEvent)
    }, typeof f == "string" ? f : "Dismiss");
  }
  const ie = !r && P && (c ? !O : !0) && (G || c);
  return /* @__PURE__ */ te.createElement(te.Fragment, null, ie && /* @__PURE__ */ te.createElement(xp, {
    "data-type": "inside",
    ref: N == null ? void 0 : N.beforeInsideRef,
    onFocus: (re) => {
      if (c) {
        const ae = Y();
        ba(i[0] === "reference" ? ae[0] : ae[ae.length - 1]);
      } else if (N != null && N.preserveTabOrder && N.portalNode)
        if (F.current = !1, Uu(re, N.portalNode)) {
          const ae = TD() || S;
          ae == null || ae.focus();
        } else {
          var le;
          (le = N.beforeOutsideRef.current) == null || le.focus();
        }
    }
  }), !O && ee("start"), n, ee("end"), ie && /* @__PURE__ */ te.createElement(xp, {
    "data-type": "inside",
    ref: N == null ? void 0 : N.afterInsideRef,
    onFocus: (re) => {
      if (c)
        ba(Y()[0]);
      else if (N != null && N.preserveTabOrder && N.portalNode)
        if (d && (F.current = !0), Uu(re, N.portalNode)) {
          const ae = PD() || S;
          ae == null || ae.focus();
        } else {
          var le;
          (le = N.afterOutsideRef.current) == null || le.focus();
        }
    }
  }));
}
function LT(e) {
  return pn(e.target) && e.target.tagName === "BUTTON";
}
function BT(e) {
  return n1(e);
}
function c1(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: o
    }
  } = e, {
    enabled: a = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: f = !0,
    stickIfOpen: d = !0
  } = t, p = te.useRef(), m = te.useRef(!1), y = te.useMemo(() => ({
    onPointerDown(g) {
      p.current = g.pointerType;
    },
    onMouseDown(g) {
      const v = p.current;
      g.button === 0 && s !== "click" && (cf(v, !0) && c || (n && l && (!(i.current.openEvent && d) || i.current.openEvent.type === "mousedown") ? r(!1, g.nativeEvent, "click") : (g.preventDefault(), r(!0, g.nativeEvent, "click"))));
    },
    onClick(g) {
      const v = p.current;
      if (s === "mousedown" && p.current) {
        p.current = void 0;
        return;
      }
      cf(v, !0) && c || (n && l && (!(i.current.openEvent && d) || i.current.openEvent.type === "click") ? r(!1, g.nativeEvent, "click") : r(!0, g.nativeEvent, "click"));
    },
    onKeyDown(g) {
      p.current = void 0, !(g.defaultPrevented || !f || LT(g)) && (g.key === " " && !BT(o) && (g.preventDefault(), m.current = !0), g.key === "Enter" && r(!(n && l), g.nativeEvent, "click"));
    },
    onKeyUp(g) {
      g.defaultPrevented || !f || LT(g) || BT(o) || g.key === " " && m.current && (m.current = !1, r(!(n && l), g.nativeEvent, "click"));
    }
  }), [i, o, s, c, f, r, n, d, l]);
  return te.useMemo(() => a ? {
    reference: y
  } : {}, [a, y]);
}
const KG = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, GG = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, FT = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function fg(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: i,
    dataRef: o
  } = e, {
    enabled: a = !0,
    escapeKey: s = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: f = !1,
    referencePressEvent: d = "pointerdown",
    ancestorScroll: p = !1,
    bubbles: m,
    capture: y
  } = t, g = cd(), v = Nn(typeof l == "function" ? l : () => !1), x = typeof l == "function" ? v : l, w = te.useRef(!1), S = te.useRef(!1), {
    escapeKey: A,
    outsidePress: _
  } = FT(m), {
    escapeKey: O,
    outsidePress: P
  } = FT(y), C = te.useRef(!1), k = Nn((F) => {
    var W;
    if (!n || !a || !s || F.key !== "Escape" || C.current)
      return;
    const z = (W = o.current.floatingContext) == null ? void 0 : W.nodeId, G = g ? Ts(g.nodesRef.current, z) : [];
    if (!A && (F.stopPropagation(), G.length > 0)) {
      let U = !0;
      if (G.forEach((V) => {
        var Y;
        if ((Y = V.context) != null && Y.open && !V.context.dataRef.current.__escapeKeyBubbles) {
          U = !1;
          return;
        }
      }), !U)
        return;
    }
    r(!1, gK(F) ? F.nativeEvent : F, "escape-key");
  }), D = Nn((F) => {
    var W;
    const z = () => {
      var G;
      k(F), (G = Oo(F)) == null || G.removeEventListener("keydown", z);
    };
    (W = Oo(F)) == null || W.addEventListener("keydown", z);
  }), $ = Nn((F) => {
    var W;
    const z = w.current;
    w.current = !1;
    const G = S.current;
    if (S.current = !1, c === "click" && G || z || typeof x == "function" && !x(F))
      return;
    const U = Oo(F), V = "[" + Is("inert") + "]", Y = Kn(i.floating).querySelectorAll(V);
    let ee = Ct(U) ? U : null;
    for (; ee && !$a(ee); ) {
      const ae = Bo(ee);
      if ($a(ae) || !Ct(ae))
        break;
      ee = ae;
    }
    if (Y.length && Ct(U) && !yK(U) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !hn(U, i.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(Y).every((ae) => !hn(ee, ae)))
      return;
    if (pn(U) && L) {
      const ae = U.clientWidth > 0 && U.scrollWidth > U.clientWidth, ue = U.clientHeight > 0 && U.scrollHeight > U.clientHeight;
      let ne = ue && F.offsetX > U.clientWidth;
      if (ue && Hr(U).direction === "rtl" && (ne = F.offsetX <= U.offsetWidth - U.clientWidth), ne || ae && F.offsetY > U.clientHeight)
        return;
    }
    const ie = (W = o.current.floatingContext) == null ? void 0 : W.nodeId, re = g && Ts(g.nodesRef.current, ie).some((ae) => {
      var ue;
      return Hv(F, (ue = ae.context) == null ? void 0 : ue.elements.floating);
    });
    if (Hv(F, i.floating) || Hv(F, i.domReference) || re)
      return;
    const le = g ? Ts(g.nodesRef.current, ie) : [];
    if (le.length > 0) {
      let ae = !0;
      if (le.forEach((ue) => {
        var ne;
        if ((ne = ue.context) != null && ne.open && !ue.context.dataRef.current.__outsidePressBubbles) {
          ae = !1;
          return;
        }
      }), !ae)
        return;
    }
    r(!1, F, "outside-press");
  }), N = Nn((F) => {
    var W;
    const z = () => {
      var G;
      $(F), (G = Oo(F)) == null || G.removeEventListener(c, z);
    };
    (W = Oo(F)) == null || W.addEventListener(c, z);
  });
  te.useEffect(() => {
    if (!n || !a)
      return;
    o.current.__escapeKeyBubbles = A, o.current.__outsidePressBubbles = _;
    let F = -1;
    function W(Y) {
      r(!1, Y, "ancestor-scroll");
    }
    function z() {
      window.clearTimeout(F), C.current = !0;
    }
    function G() {
      F = window.setTimeout(
        () => {
          C.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        tg() ? 5 : 0
      );
    }
    const U = Kn(i.floating);
    s && (U.addEventListener("keydown", O ? D : k, O), U.addEventListener("compositionstart", z), U.addEventListener("compositionend", G)), x && U.addEventListener(c, P ? N : $, P);
    let V = [];
    return p && (Ct(i.domReference) && (V = Pa(i.domReference)), Ct(i.floating) && (V = V.concat(Pa(i.floating))), !Ct(i.reference) && i.reference && i.reference.contextElement && (V = V.concat(Pa(i.reference.contextElement)))), V = V.filter((Y) => {
      var ee;
      return Y !== ((ee = U.defaultView) == null ? void 0 : ee.visualViewport);
    }), V.forEach((Y) => {
      Y.addEventListener("scroll", W, {
        passive: !0
      });
    }), () => {
      s && (U.removeEventListener("keydown", O ? D : k, O), U.removeEventListener("compositionstart", z), U.removeEventListener("compositionend", G)), x && U.removeEventListener(c, P ? N : $, P), V.forEach((Y) => {
        Y.removeEventListener("scroll", W);
      }), window.clearTimeout(F);
    };
  }, [o, i, s, x, c, n, r, p, a, A, _, k, O, D, $, P, N]), te.useEffect(() => {
    w.current = !1;
  }, [x, c]);
  const R = te.useMemo(() => ({
    onKeyDown: k,
    [KG[d]]: (F) => {
      f && r(!1, F.nativeEvent, "reference-press");
    }
  }), [k, r, f, d]), L = te.useMemo(() => ({
    onKeyDown: k,
    onMouseDown() {
      S.current = !0;
    },
    onMouseUp() {
      S.current = !0;
    },
    [GG[c]]: () => {
      w.current = !0;
    }
  }), [k, c]);
  return te.useMemo(() => a ? {
    reference: R,
    floating: L
  } : {}, [a, R, L]);
}
function YG(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, i = sg(), o = te.useRef({}), [a] = te.useState(() => NG()), s = lg() != null;
  if (process.env.NODE_ENV !== "production") {
    const m = r.reference;
    m && !Ct(m) && kG("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = te.useState(r.reference), f = Nn((m, y, g) => {
    o.current.openEvent = m ? y : void 0, a.emit("openchange", {
      open: m,
      event: y,
      reason: g,
      nested: s
    }), n == null || n(m, y, g);
  }), d = te.useMemo(() => ({
    setPositionReference: c
  }), []), p = te.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return te.useMemo(() => ({
    dataRef: o,
    open: t,
    onOpenChange: f,
    elements: p,
    events: a,
    floatingId: i,
    refs: d
  }), [t, f, p, a, i, d]);
}
function dg(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = YG({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, i = r.elements, [o, a] = te.useState(null), [s, l] = te.useState(null), f = (i == null ? void 0 : i.domReference) || o, d = te.useRef(null), p = cd();
  Nt(() => {
    f && (d.current = f);
  }, [f]);
  const m = vG({
    ...e,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), y = te.useCallback((S) => {
    const A = Ct(S) ? {
      getBoundingClientRect: () => S.getBoundingClientRect(),
      contextElement: S
    } : S;
    l(A), m.refs.setReference(A);
  }, [m.refs]), g = te.useCallback((S) => {
    (Ct(S) || S === null) && (d.current = S, a(S)), (Ct(m.refs.reference.current) || m.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    S !== null && !Ct(S)) && m.refs.setReference(S);
  }, [m.refs]), v = te.useMemo(() => ({
    ...m.refs,
    setReference: g,
    setPositionReference: y,
    domReference: d
  }), [m.refs, g, y]), x = te.useMemo(() => ({
    ...m.elements,
    domReference: f
  }), [m.elements, f]), w = te.useMemo(() => ({
    ...m,
    ...r,
    refs: v,
    elements: x,
    nodeId: t
  }), [m, v, x, t, r]);
  return Nt(() => {
    r.dataRef.current.floatingContext = w;
    const S = p == null ? void 0 : p.nodesRef.current.find((A) => A.id === t);
    S && (S.context = w);
  }), te.useMemo(() => ({
    ...m,
    context: w,
    refs: v,
    elements: x
  }), [m, v, x, w]);
}
function qG(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: i,
    dataRef: o,
    elements: a
  } = e, {
    enabled: s = !0,
    visibleOnly: l = !0
  } = t, c = te.useRef(!1), f = te.useRef(), d = te.useRef(!0);
  te.useEffect(() => {
    if (!s) return;
    const m = Or(a.domReference);
    function y() {
      !n && pn(a.domReference) && a.domReference === Ti(Kn(a.domReference)) && (c.current = !0);
    }
    function g() {
      d.current = !0;
    }
    return m.addEventListener("blur", y), m.addEventListener("keydown", g, !0), () => {
      m.removeEventListener("blur", y), m.removeEventListener("keydown", g, !0);
    };
  }, [a.domReference, n, s]), te.useEffect(() => {
    if (!s) return;
    function m(y) {
      let {
        reason: g
      } = y;
      (g === "reference-press" || g === "escape-key") && (c.current = !0);
    }
    return i.on("openchange", m), () => {
      i.off("openchange", m);
    };
  }, [i, s]), te.useEffect(() => () => {
    clearTimeout(f.current);
  }, []);
  const p = te.useMemo(() => ({
    onPointerDown(m) {
      e1(m.nativeEvent) || (d.current = !1);
    },
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(m) {
      if (c.current) return;
      const y = Oo(m.nativeEvent);
      if (l && Ct(y))
        try {
          if (t1() && lD()) throw Error();
          if (!y.matches(":focus-visible")) return;
        } catch {
          if (!d.current && !n1(y))
            return;
        }
      r(!0, m.nativeEvent, "focus");
    },
    onBlur(m) {
      c.current = !1;
      const y = m.relatedTarget, g = m.nativeEvent, v = Ct(y) && y.hasAttribute(Is("focus-guard")) && y.getAttribute("data-type") === "outside";
      f.current = window.setTimeout(() => {
        var x;
        const w = Ti(a.domReference ? a.domReference.ownerDocument : document);
        !y && w === a.domReference || hn((x = o.current.floatingContext) == null ? void 0 : x.refs.floating.current, w) || hn(a.domReference, w) || v || r(!1, g, "focus");
      });
    }
  }), [o, a.domReference, r, l]);
  return te.useMemo(() => s ? {
    reference: p
  } : {}, [s, p]);
}
const WT = "active", zT = "selected";
function Jv(e, t, n) {
  const r = /* @__PURE__ */ new Map(), i = n === "item";
  let o = e;
  if (i && e) {
    const {
      [WT]: a,
      [zT]: s,
      ...l
    } = e;
    o = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [b0]: ""
    },
    ...o,
    ...t.map((a) => {
      const s = a ? a[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((a, s) => (s && Object.entries(s).forEach((l) => {
      let [c, f] = l;
      if (!(i && [WT, zT].includes(c)))
        if (c.indexOf("on") === 0) {
          if (r.has(c) || r.set(c, []), typeof f == "function") {
            var d;
            (d = r.get(c)) == null || d.push(f), a[c] = function() {
              for (var p, m = arguments.length, y = new Array(m), g = 0; g < m; g++)
                y[g] = arguments[g];
              return (p = r.get(c)) == null ? void 0 : p.map((v) => v(...y)).find((v) => v !== void 0);
            };
          }
        } else
          a[c] = f;
    }), a), {})
  };
}
function hg(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), n = e.map((s) => s == null ? void 0 : s.floating), r = e.map((s) => s == null ? void 0 : s.item), i = te.useCallback(
    (s) => Jv(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), o = te.useCallback(
    (s) => Jv(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = te.useCallback(
    (s) => Jv(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return te.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: o,
    getItemProps: a
  }), [i, o, a]);
}
let VT = !1;
function pg(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function UT(e, t) {
  return pg(t, e === l1 || e === ld, e === Ca || e === Ea);
}
function Qv(e, t, n) {
  return pg(t, e === ld, n ? e === Ca : e === Ea) || e === "Enter" || e === " " || e === "";
}
function XG(e, t, n) {
  return pg(t, n ? e === Ca : e === Ea, e === ld);
}
function HT(e, t, n) {
  return pg(t, n ? e === Ea : e === Ca, e === l1);
}
function ZG(e, t) {
  const {
    open: n,
    onOpenChange: r,
    elements: i
  } = e, {
    listRef: o,
    activeIndex: a,
    onNavigate: s = () => {
    },
    enabled: l = !0,
    selectedIndex: c = null,
    allowEscape: f = !1,
    loop: d = !1,
    nested: p = !1,
    rtl: m = !1,
    virtual: y = !1,
    focusItemOnOpen: g = "auto",
    focusItemOnHover: v = !0,
    openOnArrowKeyDown: x = !0,
    disabledIndices: w = void 0,
    orientation: S = "vertical",
    cols: A = 1,
    scrollItemIntoView: _ = !0,
    virtualItemRef: O,
    itemSizes: P,
    dense: C = !1
  } = t;
  process.env.NODE_ENV !== "production" && (f && (d || op("`useListNavigation` looping must be enabled to allow escaping."), y || op("`useListNavigation` must be virtual to allow escaping.")), S === "vertical" && A > 1 && op("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const k = kD(i.floating), D = Yn(k), $ = lg(), N = cd(), R = Nn(s), L = m0(i.domReference), F = te.useRef(g), W = te.useRef(c ?? -1), z = te.useRef(null), G = te.useRef(!0), U = te.useRef(R), V = te.useRef(!!i.floating), Y = te.useRef(n), ee = te.useRef(!1), ie = te.useRef(!1), re = Yn(w), le = Yn(n), ae = Yn(_), ue = Yn(c), [ne, J] = te.useState(), [fe, be] = te.useState(), X = Nn(function(Ie, lt, Oe) {
    Oe === void 0 && (Oe = !1);
    function Ke(mt) {
      y ? (J(mt.id), N == null || N.events.emit("virtualfocus", mt), O && (O.current = mt)) : ba(mt, {
        preventScroll: !0,
        // Mac Safari does not move the virtual cursor unless the focus call
        // is sync. However, for the very first focus call, we need to wait
        // for the position to be ready in order to prevent unwanted
        // scrolling. This means the virtual cursor will not move to the first
        // item when first opening the floating element, but will on
        // subsequent calls. `preventScroll` is supported in modern Safari,
        // so we can use that instead.
        // iOS Safari must be async or the first item will not be focused.
        sync: lD() && t1() ? VT || ee.current : !1
      });
    }
    const Zt = Ie.current[lt.current];
    Zt && Ke(Zt), requestAnimationFrame(() => {
      const mt = Ie.current[lt.current] || Zt;
      if (!mt) return;
      Zt || Ke(mt);
      const en = ae.current;
      en && pe && (Oe || !G.current) && (mt.scrollIntoView == null || mt.scrollIntoView(typeof en == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : en));
    });
  });
  Nt(() => {
    document.createElement("div").focus({
      get preventScroll() {
        return VT = !0, !1;
      }
    });
  }, []), Nt(() => {
    l && (n && i.floating ? F.current && c != null && (ie.current = !0, W.current = c, R(c)) : V.current && (W.current = -1, U.current(null)));
  }, [l, n, i.floating, c, R]), Nt(() => {
    if (l && n && i.floating)
      if (a == null) {
        if (ee.current = !1, ue.current != null)
          return;
        if (V.current && (W.current = -1, X(o, W)), (!Y.current || !V.current) && F.current && (z.current != null || F.current === !0 && z.current == null)) {
          let Ie = 0;
          const lt = () => {
            o.current[0] == null ? (Ie < 2 && (Ie ? requestAnimationFrame : queueMicrotask)(lt), Ie++) : (W.current = z.current == null || Qv(z.current, S, m) || p ? Yv(o, re.current) : PT(o, re.current), z.current = null, R(W.current));
          };
          lt();
        }
      } else Vu(o, a) || (W.current = a, X(o, W, ie.current), ie.current = !1);
  }, [l, n, i.floating, a, ue, p, o, S, m, R, X, re]), Nt(() => {
    var Ie;
    if (!l || i.floating || !N || y || !V.current)
      return;
    const lt = N.nodesRef.current, Oe = (Ie = lt.find((mt) => mt.id === $)) == null || (Ie = Ie.context) == null ? void 0 : Ie.elements.floating, Ke = Ti(Kn(i.floating)), Zt = lt.some((mt) => mt.context && hn(mt.context.elements.floating, Ke));
    Oe && !Zt && G.current && Oe.focus({
      preventScroll: !0
    });
  }, [l, i.floating, N, $, y]), Nt(() => {
    if (!l || !N || !y || $) return;
    function Ie(lt) {
      be(lt.id), O && (O.current = lt);
    }
    return N.events.on("virtualfocus", Ie), () => {
      N.events.off("virtualfocus", Ie);
    };
  }, [l, N, y, $, O]), Nt(() => {
    U.current = R, V.current = !!i.floating;
  }), Nt(() => {
    n || (z.current = null);
  }, [n]), Nt(() => {
    Y.current = n;
  }, [n]);
  const De = a != null, pe = te.useMemo(() => {
    function Ie(Oe) {
      if (!n) return;
      const Ke = o.current.indexOf(Oe);
      Ke !== -1 && R(Ke);
    }
    return {
      onFocus(Oe) {
        let {
          currentTarget: Ke
        } = Oe;
        Ie(Ke);
      },
      onClick: (Oe) => {
        let {
          currentTarget: Ke
        } = Oe;
        return Ke.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...v && {
        onMouseMove(Oe) {
          let {
            currentTarget: Ke
          } = Oe;
          Ie(Ke);
        },
        onPointerLeave(Oe) {
          let {
            pointerType: Ke
          } = Oe;
          !G.current || Ke === "touch" || (W.current = -1, X(o, W), R(null), y || ba(D.current, {
            preventScroll: !0
          }));
        }
      }
    };
  }, [n, D, X, v, o, R, y]), ke = Nn((Ie) => {
    if (G.current = !1, ee.current = !0, Ie.which === 229 || !le.current && Ie.currentTarget === D.current)
      return;
    if (p && HT(Ie.key, S, m)) {
      Un(Ie), r(!1, Ie.nativeEvent, "list-navigation"), pn(i.domReference) && (y ? N == null || N.events.emit("virtualfocus", i.domReference) : i.domReference.focus());
      return;
    }
    const lt = W.current, Oe = Yv(o, w), Ke = PT(o, w);
    if (L || (Ie.key === "Home" && (Un(Ie), W.current = Oe, R(W.current)), Ie.key === "End" && (Un(Ie), W.current = Ke, R(W.current))), A > 1) {
      const Zt = P || Array.from({
        length: o.current.length
      }, () => ({
        width: 1,
        height: 1
      })), mt = OG(Zt, A, C), en = mt.findIndex((yn) => yn != null && !ip(o.current, yn, w)), Yr = mt.reduce((yn, mr, tt) => mr != null && !ip(o.current, mr, w) ? tt : yn, -1), Cn = mt[SG({
        current: mt.map((yn) => yn != null ? o.current[yn] : null)
      }, {
        event: Ie,
        orientation: S,
        loop: d,
        rtl: m,
        cols: A,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: TG([...w || o.current.map((yn, mr) => ip(o.current, mr) ? mr : void 0), void 0], mt),
        minIndex: en,
        maxIndex: Yr,
        prevIndex: AG(
          W.current > Ke ? Oe : W.current,
          Zt,
          mt,
          A,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          Ie.key === ld ? "bl" : Ie.key === (m ? Ca : Ea) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Cn != null && (W.current = Cn, R(W.current)), S === "both")
        return;
    }
    if (UT(Ie.key, S)) {
      if (Un(Ie), n && !y && Ti(Ie.currentTarget.ownerDocument) === Ie.currentTarget) {
        W.current = Qv(Ie.key, S, m) ? Oe : Ke, R(W.current);
        return;
      }
      Qv(Ie.key, S, m) ? d ? W.current = lt >= Ke ? f && lt !== o.current.length ? -1 : Oe : Qn(o, {
        startingIndex: lt,
        disabledIndices: w
      }) : W.current = Math.min(Ke, Qn(o, {
        startingIndex: lt,
        disabledIndices: w
      })) : d ? W.current = lt <= Oe ? f && lt !== -1 ? o.current.length : Ke : Qn(o, {
        startingIndex: lt,
        decrement: !0,
        disabledIndices: w
      }) : W.current = Math.max(Oe, Qn(o, {
        startingIndex: lt,
        decrement: !0,
        disabledIndices: w
      })), Vu(o, W.current) ? R(null) : R(W.current);
    }
  }), it = te.useMemo(() => y && n && De && {
    "aria-activedescendant": fe || ne
  }, [y, n, De, fe, ne]), st = te.useMemo(() => ({
    "aria-orientation": S === "both" ? void 0 : S,
    ...!m0(i.domReference) && it,
    onKeyDown: ke,
    onPointerMove() {
      G.current = !0;
    }
  }), [it, ke, i.domReference, S]), Xn = te.useMemo(() => {
    function Ie(Oe) {
      g === "auto" && sD(Oe.nativeEvent) && (F.current = !0);
    }
    function lt(Oe) {
      F.current = g, g === "auto" && e1(Oe.nativeEvent) && (F.current = !0);
    }
    return {
      ...it,
      onKeyDown(Oe) {
        G.current = !1;
        const Ke = Oe.key.startsWith("Arrow"), Zt = ["Home", "End"].includes(Oe.key), mt = Ke || Zt, en = XG(Oe.key, S, m), Yr = HT(Oe.key, S, m), Cn = UT(Oe.key, S), yn = (p ? en : Cn) || Oe.key === "Enter" || Oe.key.trim() === "";
        if (y && n) {
          const St = N == null ? void 0 : N.nodesRef.current.find((qr) => qr.parentId == null), jn = N && St ? jG(N.nodesRef.current, St.id) : null;
          if (mt && jn && O) {
            const qr = new KeyboardEvent("keydown", {
              key: Oe.key,
              bubbles: !0
            });
            if (en || Yr) {
              var mr, tt;
              const so = ((mr = jn.context) == null ? void 0 : mr.elements.domReference) === Oe.currentTarget, un = Yr && !so ? (tt = jn.context) == null ? void 0 : tt.elements.domReference : en ? o.current.find((Pr) => (Pr == null ? void 0 : Pr.id) === ne) : null;
              un && (Un(Oe), un.dispatchEvent(qr), be(void 0));
            }
            if ((Cn || Zt) && jn.context && jn.context.open && jn.parentId && Oe.currentTarget !== jn.context.elements.domReference) {
              var Kt;
              Un(Oe), (Kt = jn.context.elements.domReference) == null || Kt.dispatchEvent(qr);
              return;
            }
          }
          return ke(Oe);
        }
        if (!(!n && !x && Ke)) {
          if (yn && (z.current = p && Cn ? null : Oe.key), p) {
            en && (Un(Oe), n ? (W.current = Yv(o, re.current), R(W.current)) : r(!0, Oe.nativeEvent, "list-navigation"));
            return;
          }
          Cn && (c != null && (W.current = c), Un(Oe), !n && x ? r(!0, Oe.nativeEvent, "list-navigation") : ke(Oe), n && R(W.current));
        }
      },
      onFocus() {
        n && !y && R(null);
      },
      onPointerDown: lt,
      onMouseDown: Ie,
      onClick: Ie
    };
  }, [ne, it, ke, re, g, o, p, R, r, n, x, S, m, c, N, y, O]);
  return te.useMemo(() => l ? {
    reference: Xn,
    floating: st,
    item: pe
  } : {}, [l, Xn, st, pe]);
}
const JG = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function u1(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: r,
    floatingId: i
  } = e, {
    enabled: o = !0,
    role: a = "dialog"
  } = t, s = (n = JG.get(a)) != null ? n : a, l = sg(), f = lg() != null, d = te.useMemo(() => s === "tooltip" || a === "label" ? {
    ["aria-" + (a === "label" ? "labelledby" : "describedby")]: r ? i : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": s === "alertdialog" ? "dialog" : s,
    "aria-controls": r ? i : void 0,
    ...s === "listbox" && {
      role: "combobox"
    },
    ...s === "menu" && {
      id: l
    },
    ...s === "menu" && f && {
      role: "menuitem"
    },
    ...a === "select" && {
      "aria-autocomplete": "none"
    },
    ...a === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [s, i, f, r, l, a]), p = te.useMemo(() => {
    const y = {
      id: i,
      ...s && {
        role: s
      }
    };
    return s === "tooltip" || a === "label" ? y : {
      ...y,
      ...s === "menu" && {
        "aria-labelledby": l
      }
    };
  }, [s, i, l, a]), m = te.useCallback((y) => {
    let {
      active: g,
      selected: v
    } = y;
    const x = {
      role: "option",
      ...g && {
        id: i + "-option"
      }
    };
    switch (a) {
      case "select":
        return {
          ...x,
          "aria-selected": g && v
        };
      case "combobox":
        return {
          ...x,
          ...g && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [i, a]);
  return te.useMemo(() => o ? {
    reference: d,
    floating: p,
    item: m
  } : {}, [o, d, p, m]);
}
const KT = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase());
function bl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function QG(e, t) {
  const [n, r] = te.useState(e);
  return e && !n && r(!0), te.useEffect(() => {
    if (!e && n) {
      const i = setTimeout(() => r(!1), t);
      return () => clearTimeout(i);
    }
  }, [e, n, t]), n;
}
function eY(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    elements: {
      floating: r
    }
  } = e, {
    duration: i = 250
  } = t, a = (typeof i == "number" ? i : i.close) || 0, [s, l] = te.useState("unmounted"), c = QG(n, a);
  return !c && s === "close" && l("unmounted"), Nt(() => {
    if (r) {
      if (n) {
        l("initial");
        const f = requestAnimationFrame(() => {
          l("open");
        });
        return () => {
          cancelAnimationFrame(f);
        };
      }
      l("close");
    }
  }, [n, r]), {
    isMounted: c,
    status: s
  };
}
function MD(e, t) {
  t === void 0 && (t = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: r,
    close: i,
    common: o,
    duration: a = 250
  } = t, s = e.placement, l = s.split("-")[0], c = te.useMemo(() => ({
    side: l,
    placement: s
  }), [l, s]), f = typeof a == "number", d = (f ? a : a.open) || 0, p = (f ? a : a.close) || 0, [m, y] = te.useState(() => ({
    ...bl(o, c),
    ...bl(n, c)
  })), {
    isMounted: g,
    status: v
  } = eY(e, {
    duration: a
  }), x = Yn(n), w = Yn(r), S = Yn(i), A = Yn(o);
  return Nt(() => {
    const _ = bl(x.current, c), O = bl(S.current, c), P = bl(A.current, c), C = bl(w.current, c) || Object.keys(_).reduce((k, D) => (k[D] = "", k), {});
    if (v === "initial" && y((k) => ({
      transitionProperty: k.transitionProperty,
      ...P,
      ..._
    })), v === "open" && y({
      transitionProperty: Object.keys(C).map(KT).join(","),
      transitionDuration: d + "ms",
      ...P,
      ...C
    }), v === "close") {
      const k = O || _;
      y({
        transitionProperty: Object.keys(k).map(KT).join(","),
        transitionDuration: p + "ms",
        ...P,
        ...k
      });
    }
  }, [p, S, x, w, A, d, v, c]), {
    isMounted: g,
    styles: m
  };
}
function tY(e, t) {
  var n;
  const {
    open: r,
    dataRef: i
  } = e, {
    listRef: o,
    activeIndex: a,
    onMatch: s,
    onTypingChange: l,
    enabled: c = !0,
    findMatch: f = null,
    resetMs: d = 750,
    ignoreKeys: p = [],
    selectedIndex: m = null
  } = t, y = te.useRef(), g = te.useRef(""), v = te.useRef((n = m ?? a) != null ? n : -1), x = te.useRef(null), w = Nn(s), S = Nn(l), A = Yn(f), _ = Yn(p);
  Nt(() => {
    r && (clearTimeout(y.current), x.current = null, g.current = "");
  }, [r]), Nt(() => {
    if (r && g.current === "") {
      var D;
      v.current = (D = m ?? a) != null ? D : -1;
    }
  }, [r, m, a]);
  const O = Nn((D) => {
    D ? i.current.typing || (i.current.typing = D, S(D)) : i.current.typing && (i.current.typing = D, S(D));
  }), P = Nn((D) => {
    function $(W, z, G) {
      const U = A.current ? A.current(z, G) : z.find((V) => (V == null ? void 0 : V.toLocaleLowerCase().indexOf(G.toLocaleLowerCase())) === 0);
      return U ? W.indexOf(U) : -1;
    }
    const N = o.current;
    if (g.current.length > 0 && g.current[0] !== " " && ($(N, N, g.current) === -1 ? O(!1) : D.key === " " && Un(D)), N == null || _.current.includes(D.key) || // Character key.
    D.key.length !== 1 || // Modifier key.
    D.ctrlKey || D.metaKey || D.altKey)
      return;
    r && D.key !== " " && (Un(D), O(!0)), N.every((W) => {
      var z, G;
      return W ? ((z = W[0]) == null ? void 0 : z.toLocaleLowerCase()) !== ((G = W[1]) == null ? void 0 : G.toLocaleLowerCase()) : !0;
    }) && g.current === D.key && (g.current = "", v.current = x.current), g.current += D.key, clearTimeout(y.current), y.current = setTimeout(() => {
      g.current = "", v.current = x.current, O(!1);
    }, d);
    const L = v.current, F = $(N, [...N.slice((L || 0) + 1), ...N.slice(0, (L || 0) + 1)], g.current);
    F !== -1 ? (w(F), x.current = F) : D.key !== " " && (g.current = "", O(!1));
  }), C = te.useMemo(() => ({
    onKeyDown: P
  }), [P]), k = te.useMemo(() => ({
    onKeyDown: P,
    onKeyUp(D) {
      D.key === " " && O(!1);
    }
  }), [P, O]);
  return te.useMemo(() => c ? {
    reference: C,
    floating: k
  } : {}, [c, C, k]);
}
function GT(e, t) {
  const [n, r] = e;
  let i = !1;
  const o = t.length;
  for (let a = 0, s = o - 1; a < o; s = a++) {
    const [l, c] = t[a] || [0, 0], [f, d] = t[s] || [0, 0];
    c >= r != d >= r && n <= (f - l) * (r - c) / (d - c) + l && (i = !i);
  }
  return i;
}
function nY(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function rY(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: r = !0
  } = e;
  let i, o = !1, a = null, s = null, l = performance.now();
  function c(d, p) {
    const m = performance.now(), y = m - l;
    if (a === null || s === null || y === 0)
      return a = d, s = p, l = m, null;
    const g = d - a, v = p - s, w = Math.sqrt(g * g + v * v) / y;
    return a = d, s = p, l = m, w;
  }
  const f = (d) => {
    let {
      x: p,
      y: m,
      placement: y,
      elements: g,
      onClose: v,
      nodeId: x,
      tree: w
    } = d;
    return function(A) {
      function _() {
        clearTimeout(i), v();
      }
      if (clearTimeout(i), !g.domReference || !g.floating || y == null || p == null || m == null)
        return;
      const {
        clientX: O,
        clientY: P
      } = A, C = [O, P], k = Oo(A), D = A.type === "mouseleave", $ = hn(g.floating, k), N = hn(g.domReference, k), R = g.domReference.getBoundingClientRect(), L = g.floating.getBoundingClientRect(), F = y.split("-")[0], W = p > L.right - L.width / 2, z = m > L.bottom - L.height / 2, G = nY(C, R), U = L.width > R.width, V = L.height > R.height, Y = (U ? R : L).left, ee = (U ? R : L).right, ie = (V ? R : L).top, re = (V ? R : L).bottom;
      if ($ && (o = !0, !D))
        return;
      if (N && (o = !1), N && !D) {
        o = !0;
        return;
      }
      if (D && Ct(A.relatedTarget) && hn(g.floating, A.relatedTarget) || w && Ts(w.nodesRef.current, x).some((ue) => {
        let {
          context: ne
        } = ue;
        return ne == null ? void 0 : ne.open;
      }))
        return;
      if (F === "top" && m >= R.bottom - 1 || F === "bottom" && m <= R.top + 1 || F === "left" && p >= R.right - 1 || F === "right" && p <= R.left + 1)
        return _();
      let le = [];
      switch (F) {
        case "top":
          le = [[Y, R.top + 1], [Y, L.bottom - 1], [ee, L.bottom - 1], [ee, R.top + 1]];
          break;
        case "bottom":
          le = [[Y, L.top + 1], [Y, R.bottom - 1], [ee, R.bottom - 1], [ee, L.top + 1]];
          break;
        case "left":
          le = [[L.right - 1, re], [L.right - 1, ie], [R.left + 1, ie], [R.left + 1, re]];
          break;
        case "right":
          le = [[R.right - 1, re], [R.right - 1, ie], [L.left + 1, ie], [L.left + 1, re]];
          break;
      }
      function ae(ue) {
        let [ne, J] = ue;
        switch (F) {
          case "top": {
            const fe = [U ? ne + t / 2 : W ? ne + t * 4 : ne - t * 4, J + t + 1], be = [U ? ne - t / 2 : W ? ne + t * 4 : ne - t * 4, J + t + 1], X = [[L.left, W || U ? L.bottom - t : L.top], [L.right, W ? U ? L.bottom - t : L.top : L.bottom - t]];
            return [fe, be, ...X];
          }
          case "bottom": {
            const fe = [U ? ne + t / 2 : W ? ne + t * 4 : ne - t * 4, J - t], be = [U ? ne - t / 2 : W ? ne + t * 4 : ne - t * 4, J - t], X = [[L.left, W || U ? L.top + t : L.bottom], [L.right, W ? U ? L.top + t : L.bottom : L.top + t]];
            return [fe, be, ...X];
          }
          case "left": {
            const fe = [ne + t + 1, V ? J + t / 2 : z ? J + t * 4 : J - t * 4], be = [ne + t + 1, V ? J - t / 2 : z ? J + t * 4 : J - t * 4];
            return [...[[z || V ? L.right - t : L.left, L.top], [z ? V ? L.right - t : L.left : L.right - t, L.bottom]], fe, be];
          }
          case "right": {
            const fe = [ne - t, V ? J + t / 2 : z ? J + t * 4 : J - t * 4], be = [ne - t, V ? J - t / 2 : z ? J + t * 4 : J - t * 4], X = [[z || V ? L.left + t : L.right, L.top], [z ? V ? L.left + t : L.right : L.left + t, L.bottom]];
            return [fe, be, ...X];
          }
        }
      }
      if (!GT([O, P], le)) {
        if (o && !G)
          return _();
        if (!D && r) {
          const ue = c(A.clientX, A.clientY);
          if (ue !== null && ue < 0.1)
            return _();
        }
        GT([O, P], ae([p, m])) ? !o && r && (i = window.setTimeout(_, 40)) : _();
      }
    };
  };
  return f.__options = {
    blockPointerEvents: n
  }, f;
}
const ud = "light", ND = "neutral", iY = "button", oY = ({
  theme: e = ud,
  variant: t = ND
}) => {
  let n = e === "light" ? "text-icon-secondary" : "text-icon-inverse";
  return n = {
    info: e === "light" ? "text-support-info" : "text-support-info-inverse",
    success: e === "light" ? "text-support-success" : "text-support-success-inverse",
    warning: e === "light" ? "text-support-warning" : "text-support-warning-inverse",
    error: e === "light" ? "text-support-error" : "text-support-error-inverse"
  }[t] || n, n;
}, wp = ({
  icon: e,
  theme: t = ud,
  variant: n = ND
}) => {
  var a;
  const r = "[&>svg]:h-5 [&>svg]:w-5", i = oY({ theme: t, variant: n });
  if (e && rt(e))
    return ht(e, {
      className: K(
        r,
        i,
        ((a = e == null ? void 0 : e.props) == null ? void 0 : a.className) ?? ""
      )
    });
  const o = {
    neutral: /* @__PURE__ */ E(f0, { className: K(r, i) }),
    info: /* @__PURE__ */ E(f0, { className: K(r, i) }),
    success: /* @__PURE__ */ E(ad, { className: K(r, i) }),
    warning: /* @__PURE__ */ E(iK, { className: K(r, i) }),
    error: /* @__PURE__ */ E(nK, { className: K(r, i) })
  };
  return o[n] || o.neutral;
}, x0 = ({
  actionType: e = iY,
  onAction: t = () => {
  },
  actionLabel: n = "",
  theme: r = ud
}) => {
  const i = "focus:ring-0 focus:ring-offset-0 ring-offset-0 focus:outline-none";
  let o = "text-button-primary border-button-primary hover:border-button-primary hover:text-button-primary-hover";
  switch (r === "dark" && (o = "text-text-inverse border-text-inverse hover:border-text-inverse hover:text-text-inverse"), e) {
    case "button":
      return /* @__PURE__ */ E(
        Hn,
        {
          variant: "outline",
          size: "xs",
          onClick: t,
          className: K(
            "rounded",
            i,
            o,
            r === "dark" ? "bg-transparent hover:bg-transparent" : "bg-white hover:bg-white"
          ),
          children: n
        }
      );
    case "link":
      return /* @__PURE__ */ E(
        Hn,
        {
          variant: "link",
          size: "xs",
          onClick: t,
          className: K(i, o),
          children: n
        }
      );
    default:
      return null;
  }
}, _p = ({
  theme: e = ud,
  title: t = "",
  inline: n = !1
}) => t ? /* @__PURE__ */ E(
  "span",
  {
    className: K(
      "block",
      {
        light: "text-text-primary",
        dark: "text-text-inverse"
      }[e],
      "text-sm leading-5 font-semibold",
      n ? "inline" : "block"
    ),
    children: t
  }
) : null, Sp = ({
  theme: e = ud,
  content: t = "",
  inline: n = !1
}) => t ? /* @__PURE__ */ E(
  "span",
  {
    className: K(
      {
        light: "text-text-primary",
        dark: "text-text-inverse"
      }[e],
      "block text-sm [&_*]:text-sm leading-5 [&_*]:leading-5 font-normal",
      n ? "inline" : "block"
    ),
    children: t
  }
) : null, w0 = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, f1 = ({
  variant: e = "dark",
  // 'light' | 'dark';
  placement: t = "bottom",
  //  | 'top' | 'top-start' | 'top-end' | 'right' | 'right-start' | 'right-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end';
  title: n = "",
  content: r,
  arrow: i = !1,
  open: o,
  setOpen: a,
  children: s,
  className: l,
  tooltipPortalRoot: c,
  // Root element where the dropdown will be rendered.
  tooltipPortalId: f,
  // Id of the dropdown portal where the dropdown will be rendered.
  boundary: d = "clippingAncestors",
  strategy: p = "fixed",
  // 'fixed' | 'absolute';
  offset: m = 8,
  // Offset option or number value. Default is 8.
  triggers: y = ["hover", "focus"],
  // 'click' | 'hover' | 'focus';
  interactive: g = !1
}) => {
  const v = Fe(
    () => typeof o == "boolean" && typeof a == "function",
    [o, a]
  ), [x, w] = Me(!1), S = ut(null), { refs: A, floatingStyles: _, context: O } = dg({
    open: v ? o : x,
    onOpenChange: v ? a : w,
    placement: t,
    strategy: p,
    middleware: [
      og(m),
      ag({ boundary: d }),
      // Ensure this is correctly cast
      wD({ boundary: d }),
      // Ensure this is correctly cast
      xG({ element: S })
    ],
    whileElementsMounted: ig
  }), P = c1(O, {
    enabled: !v && y.includes("click")
  }), C = IG(O, {
    move: !1,
    enabled: !v && y.includes("hover"),
    ...g && { handleClose: rY() }
  }), k = qG(O, {
    enabled: !v && y.includes("focus")
  }), D = fg(O), $ = u1(O, { role: "tooltip" }), { getReferenceProps: N, getFloatingProps: R } = hg([
    P,
    C,
    k,
    D,
    $
  ]), { isMounted: L, styles: F } = MD(O, {
    duration: 150,
    initial: { opacity: 0 },
    open: { opacity: 1 },
    close: { opacity: 0 }
  }), W = "absolute z-20 py-2 px-3 rounded-md text-xs leading-4 shadow-soft-shadow-lg", z = {
    light: "bg-tooltip-background-light text-text-primary",
    dark: "bg-tooltip-background-dark text-text-on-color"
  }[e], G = e === "dark" ? "text-tooltip-background-dark" : "text-tooltip-background-light";
  return /* @__PURE__ */ he(Ur, { children: [
    rt(s) && /* @__PURE__ */ E(Ur, { children: ht(s, {
      ref: w0(
        s.ref,
        A.setReference
      ),
      className: K(s.props.className),
      ...N()
    }) }, "tooltip-reference"),
    /* @__PURE__ */ E(ug, { id: f, root: c, children: L && /* @__PURE__ */ he(
      "div",
      {
        className: K(
          W,
          z,
          "max-w-80 w-fit",
          l
        ),
        ref: A.setFloating,
        style: {
          ..._,
          ...F
        },
        ...R(),
        children: [
          /* @__PURE__ */ he("div", { children: [
            !!n && /* @__PURE__ */ E(
              "span",
              {
                className: "font-semibold",
                children: n
              },
              "tooltip-title"
            ),
            !!r && /* @__PURE__ */ E(
              "div",
              {
                className: "font-normal",
                children: r
              },
              "tooltip-content"
            )
          ] }),
          i && /* @__PURE__ */ E(
            MG,
            {
              ref: S,
              context: O,
              className: K("fill-current", G)
            }
          )
        ]
      }
    ) })
  ] });
};
f1.displayName = "Tooltip";
const $D = dt({}), DD = () => Ve($D), ID = ({
  children: e,
  name: t,
  style: n = "simple",
  size: r = "md",
  value: i,
  defaultValue: o,
  by: a = "id",
  as: s = "div",
  onChange: l,
  className: c,
  disableGroup: f = !1,
  vertical: d = !1,
  columns: p = 4,
  multiSelection: m = !1,
  gapClassName: y = "gap-2"
}) => {
  const g = Fe(() => typeof i < "u", [i]), v = Fe(
    () => t || `radio-button-group-${ro()}`,
    [t]
  );
  let x;
  g ? x = i : m ? x = o ?? [] : x = o;
  const [w, S] = Me(x), A = qe(
    (P) => {
      if (m)
        S((C) => {
          const k = Array.isArray(C) && typeof P == "string" && C.includes(P);
          let D;
          return k ? D = C.filter(
            ($) => $ !== P
          ) : D = [
            ...Array.isArray(C) ? C : [],
            ...typeof P == "string" ? [P] : []
          ], typeof l == "function" && l(D), D;
        });
      else {
        if (g || S(P), typeof l != "function")
          return;
        l(P);
      }
    },
    [l]
  );
  c = K(
    "grid grid-cols-4",
    BH[p],
    y,
    n === "tile" && "gap-0",
    d && "grid-cols-1",
    c
  );
  const _ = K(
    n === "tile" ? "border border-border-subtle border-solid rounded-md shadow-sm" : "gap-6",
    c
  ), O = () => /* @__PURE__ */ E(
    $D.Provider,
    {
      value: {
        name: v,
        value: g ? i : w,
        by: a,
        onChange: A,
        isControlled: g,
        disableAll: f,
        style: n,
        columns: p,
        multiSelection: m,
        size: r
      },
      children: I.Children.map(e, (P) => rt(P) ? P : null)
    }
  );
  return /* @__PURE__ */ E(Ut, { children: n === "tile" ? /* @__PURE__ */ E("div", { className: _, children: O() }) : /* @__PURE__ */ E(s, { ...s === Ur ? {} : { className: c }, children: O() }) });
};
ID.displayName = "RadioButton.Group";
const aY = ({
  id: e,
  label: t,
  value: n,
  children: r,
  disabled: i,
  icon: o = null,
  inlineIcon: a = !1,
  hideSelection: s = !1,
  reversePosition: l = !1,
  borderOn: c = !1,
  borderOnActive: f = !0,
  badgeItem: d = null,
  useSwitch: p = !1,
  info: m = void 0,
  minWidth: y = !0,
  ...g
}, v) => {
  var G, U;
  const { buttonWrapperClasses: x, ...w } = g, S = DD(), {
    name: A,
    value: _,
    by: O,
    onChange: P,
    disableAll: C,
    checked: k,
    multiSelection: D,
    size: $ = "md"
    // Default size to 'md' if not provided
  } = S, N = "primary", R = Fe(() => e || `radio-button-${ro()}`, [e]), L = Fe(
    () => C || i,
    [C, i]
  ), F = Fe(() => D ? Array.isArray(_) && _.includes(n) : typeof k < "u" ? k : typeof _ != typeof n ? !1 : typeof _ == "string" ? _ === n : Array.isArray(_) ? _.includes(n) : _[O] === n[O], [_, n, k]), W = qe(() => rt(t) ? t : t != null && t.heading ? /* @__PURE__ */ he(
    "div",
    {
      className: K(
        !a && "space-y-1.5 mt-[2px]",
        l && (p ? "ml-10" : "ml-4"),
        a && "flex gap-2",
        a && !t.description && "items-center"
      ),
      children: [
        o && /* @__PURE__ */ E(Ut, { children: o }),
        /* @__PURE__ */ he("div", { className: K("space-y-1.5"), children: [
          /* @__PURE__ */ E(
            "p",
            {
              className: K(
                "text-text-primary font-medium m-0",
                sK[$],
                i && "text-text-disabled cursor-not-allowed"
              ),
              children: t.heading
            }
          ),
          t.description && /* @__PURE__ */ E("p", { className: "text-text-tertiary text-sm font-normal leading-5 m-0", children: t.description })
        ] })
      ]
    }
  ) : null, [t]);
  if (S.style === "tile")
    return /* @__PURE__ */ E(
      sY,
      {
        id: e,
        label: t,
        value: n,
        disabled: i,
        size: $,
        children: r
      }
    );
  const z = () => {
    L || (D ? p && P(n, !F) : P(n));
  };
  return /* @__PURE__ */ he(
    "label",
    {
      className: K(
        "inline-flex items-center relative cursor-pointer transition-all duration-300",
        !!t && "items-start justify-between",
        y && "min-w-[180px]",
        c && "border border-border-subtle border-solid rounded-md shadow-sm hover:ring-2 hover:ring-border-interactive",
        f && c && F && "ring-2 ring-border-interactive",
        $ === "sm" ? "px-3 py-3" : "px-4 py-4",
        "pr-12",
        L && "cursor-not-allowed opacity-40",
        x
      ),
      htmlFor: R,
      onClick: z,
      children: [
        !!t && /* @__PURE__ */ E(
          "label",
          {
            className: K(
              "cursor-pointer",
              L && "cursor-not-allowed"
            ),
            htmlFor: R,
            children: W()
          }
        ),
        !!m && /* @__PURE__ */ E("div", { className: "absolute mr-0.5 bottom-1.5 right-3", children: /* @__PURE__ */ E(f1, { title: m == null ? void 0 : m.heading, content: m == null ? void 0 : m.description, children: /* @__PURE__ */ E(
          f0,
          {
            className: K(
              "text-text-primary",
              (G = Uv[$]) == null ? void 0 : G.info
            )
          }
        ) }) }),
        /* @__PURE__ */ he(
          "label",
          {
            className: K(
              "absolute mr-0.5 right-3 flex items-center cursor-pointer rounded-full gap-2",
              l && "left-0",
              L && "cursor-not-allowed",
              a && "mr-3",
              p ? xT[$].switch : xT[$].radio
            ),
            onClick: z,
            children: [
              !!d && d,
              !s && (p ? /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(
                Z$,
                {
                  defaultValue: !1,
                  size: $,
                  onChange: () => {
                    D ? P(n, !F) : P(n);
                  },
                  checked: F,
                  ...w,
                  "aria-label": (t == null ? void 0 : t.heading) ?? "Switch"
                }
              ) }) : /* @__PURE__ */ he("span", { className: "relative p-0.5", children: [
                /* @__PURE__ */ E(
                  "input",
                  {
                    ref: v,
                    id: R,
                    type: D ? "checkbox" : "radio",
                    className: K(
                      "peer flex relative cursor-pointer appearance-none transition-all m-0 before:content-[''] checked:before:content-[''] checked:before:hidden before:hidden !border-1.5 border-solid",
                      !D && "rounded-full",
                      vT[N].checkbox,
                      Uv[$].checkbox,
                      L && bT.checkbox
                    ),
                    name: A,
                    value: n,
                    onChange: (V) => P(V.target.value),
                    checked: F,
                    disabled: L,
                    ...w
                  }
                ),
                /* @__PURE__ */ E(
                  "span",
                  {
                    className: K(
                      "inline-flex items-center absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100",
                      vT[N].icon,
                      L && bT.icon
                    ),
                    children: D ? /* @__PURE__ */ E(
                      ad,
                      {
                        className: $ === "sm" ? "size-3" : "size-4"
                      }
                    ) : /* @__PURE__ */ E(
                      "div",
                      {
                        className: K(
                          "rounded-full bg-current",
                          $ === "sm" && "mt-[0.5px]",
                          (U = Uv[$]) == null ? void 0 : U.icon
                        )
                      }
                    )
                  }
                )
              ] }))
            ]
          }
        )
      ]
    }
  );
}, _0 = Dt(aY);
_0.displayName = "RadioButton.Button";
const sY = ({
  id: e,
  children: t,
  value: n,
  disabled: r,
  size: i = "md",
  ...o
}) => {
  const a = DD(), {
    name: s,
    value: l,
    by: c,
    onChange: f,
    disableAll: d,
    checked: p
  } = a || {}, m = Fe(() => e || `radio-button-${ro()}`, [e]), y = Fe(
    () => d || r,
    [d, r]
  ), g = Fe(() => typeof p < "u" ? p : typeof l != typeof n ? !1 : typeof l == "string" ? l === n : Array.isArray(l) ? l.includes(n) : l && c ? l[c] === n[c] : !1, [l, n, p, c]), v = () => {
    f && f(n);
  }, w = K(
    uK,
    fK,
    dK,
    y ? "text-text-disabled cursor-not-allowed" : "",
    lK[i],
    cK
  );
  return /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ he(
    "button",
    {
      type: "button",
      id: m,
      "aria-label": "Radio Button",
      className: K(
        w,
        "first:rounded-tl first:rounded-bl first:border-0 first:border-r first:border-border-subtle last:rounded-tr last:rounded-br last:border-0",
        g && "bg-button-disabled"
      ),
      onClick: v,
      disabled: y,
      ...o,
      children: [
        /* @__PURE__ */ E(
          "input",
          {
            type: "hidden",
            value: n,
            name: s,
            checked: g,
            onChange: (S) => f == null ? void 0 : f(S.target.value)
          }
        ),
        t
      ]
    }
  ) });
}, HEe = Object.assign(_0, {
  Group: ID,
  Button: _0
}), mg = Dt(
  ({
    label: e = "",
    size: t = "sm",
    // xxs, xs, sm, md, lg
    className: n = "",
    type: r = "pill",
    // pill, rounded
    variant: i = "neutral",
    // neutral, red, yellow, green, blue, inverse
    icon: o = null,
    disabled: a = !1,
    onClose: s = () => {
    },
    closable: l = !1,
    onMouseDown: c = () => {
    },
    disableHover: f = !1
  }, d) => {
    const p = "font-medium border-badge-border-gray flex items-center justify-center border border-solid box-border max-w-full transition-colors duration-150 ease-in-out", m = {
      xxs: "py-0.5 px-0.5 text-xs h-4",
      xs: "py-0.5 px-1 text-xs h-5",
      sm: "py-1 px-1.5 text-xs h-6",
      md: "py-1 px-1.5 text-sm h-7",
      lg: "py-1 px-1.5 text-base h-8"
    }, y = {
      pill: "rounded-full",
      rounded: "rounded"
    }, g = {
      neutral: "hover:bg-badge-hover-gray",
      red: "hover:bg-badge-hover-red",
      yellow: "hover:bg-badge-hover-yellow",
      green: "hover:bg-badge-hover-green",
      blue: "hover:bg-badge-hover-sky",
      inverse: "hover:bg-badge-hover-inverse",
      disabled: "hover:bg-badge-hover-disabled"
    }, v = {
      neutral: "bg-badge-background-gray text-badge-color-gray border-badge-border-gray",
      red: "bg-badge-background-red text-badge-color-red border-badge-border-red",
      yellow: "bg-badge-background-yellow text-badge-color-yellow border-badge-border-yellow",
      green: "bg-badge-background-green text-badge-color-green border-badge-border-green",
      blue: "bg-badge-background-sky text-badge-color-sky border-badge-border-sky",
      inverse: "bg-background-inverse text-text-inverse border-background-inverse",
      disabled: "bg-badge-background-disabled text-badge-color-disabled border-badge-border-disabled disabled cursor-not-allowed"
    };
    let x = "", w = "group relative justify-center flex items-center cursor-pointer";
    const S = {
      xxs: "[&>svg]:size-3",
      xs: "[&>svg]:size-3",
      sm: "[&>svg]:size-3",
      md: "[&>svg]:size-4",
      lg: "[&>svg]:size-5"
    };
    return a ? (x = v.disabled, w += " cursor-not-allowed disabled") : x = v[i], e ? /* @__PURE__ */ he(
      "span",
      {
        className: K(
          p,
          m[t],
          y[r],
          "gap-0.5",
          x,
          !f && g[i],
          n
        ),
        ref: d,
        children: [
          o ? /* @__PURE__ */ E(
            "span",
            {
              className: K(
                "justify-center flex items-center",
                S[t]
              ),
              children: o
            }
          ) : null,
          /* @__PURE__ */ E("span", { className: "px-1 truncate inline-block", children: e }),
          l && /* @__PURE__ */ he(
            "span",
            {
              className: K(w, S[t]),
              onMouseDown: c,
              role: "button",
              tabIndex: 0,
              ...!a && {
                onClick: s
              },
              children: [
                /* @__PURE__ */ E("span", { className: "sr-only", children: `Remove ${e}` }),
                /* @__PURE__ */ E(Na, {}),
                /* @__PURE__ */ E("span", { className: "absolute -inset-1" })
              ]
            }
          )
        ]
      }
    ) : null;
  }
);
mg.displayName = "Badge";
const lY = ({
  id: e,
  defaultValue: t = "",
  value: n,
  size: r = "sm",
  // sm, md, lg
  className: i = "",
  disabled: o = !1,
  onChange: a = () => {
  },
  error: s = !1,
  onError: l = () => {
  },
  ...c
}, f) => {
  const d = Fe(() => e || `input-textarea-${ro()}`, [e]), p = Fe(() => typeof n < "u", [n]), [m, y] = Me(t), g = qe(
    () => p ? n : m,
    [p, n, m]
  ), v = (P) => {
    if (o)
      return;
    const C = P.target.value;
    p || y(C), typeof a == "function" && a(C);
  }, x = "py-2 rounded border border-solid border-border-subtle bg-field-secondary-background font-normal placeholder-text-tertiary text-text-primary focus:outline-none", w = {
    sm: "px-3 rounded text-xs",
    md: "px-3 rounded-md text-sm",
    lg: "px-4 rounded-lg text-base"
  }, S = o ? "hover:border-border-disabled" : "hover:border-border-strong", A = "focus:border-focus-border focus:ring-2 focus:ring-toggle-on focus:ring-offset-2", _ = s ? "focus:border-focus-error-border focus:ring-field-color-error border-focus-error-border" : "";
  return /* @__PURE__ */ E(
    "textarea",
    {
      ref: f,
      id: d,
      className: K(
        x,
        o ? "border-border-disabled bg-field-background-disabled cursor-not-allowed text-text-disabled" : "",
        w[r],
        A,
        S,
        _,
        i
      ),
      disabled: o,
      onChange: v,
      onInvalid: l,
      value: g(),
      ...c
    }
  );
}, cY = Dt(lY);
cY.displayName = "TextArea";
const KEe = Dt(
  ({
    variant: e = "primary",
    size: t = "md",
    border: n = "subtle",
    src: r,
    alt: i,
    children: o,
    className: a,
    ...s
  }, l) => {
    const [c, f] = Me(!1), d = r && n === "none" ? "subtle" : n, p = "rounded-full overflow-hidden flex items-center justify-center", m = {
      white: "text-text-primary bg-background-primary",
      gray: "text-text-primary bg-background-secondary",
      primary: "text-text-on-color bg-background-brand",
      "primary-light": "text-text-primary bg-brand-background-50",
      dark: "text-text-on-color bg-button-secondary"
    }[e], y = {
      xxs: "size-5 [&>svg]:size-3 text-xs",
      xs: "size-6 [&>svg]:size-4 text-sm",
      sm: "size-8 [&>svg]:size-5 text-base",
      md: "size-10 [&>svg]:size-6 text-lg",
      lg: "size-12 [&>svg]:size-12 text-lg"
    }[t], g = {
      none: "",
      subtle: "ring-1 ring-border-transparent-subtle",
      ring: "ring ring-border-subtle"
    }[d], v = r ? "object-cover object-center" : "", x = () => {
      var _, O, P;
      if (r && c) {
        if (i && typeof i == "string")
          return (_ = i == null ? void 0 : i[0]) == null ? void 0 : _.toUpperCase();
        if (o && typeof o == "string")
          return (O = o == null ? void 0 : o[0]) == null ? void 0 : O.toUpperCase();
        if (!o && !i)
          return /* @__PURE__ */ E(oK, {});
      }
      return o ? typeof o == "string" ? (P = o == null ? void 0 : o[0]) == null ? void 0 : P.toUpperCase() : o : null;
    }, w = () => {
      f(!0);
    }, S = !r || c, A = S ? "div" : "img";
    return Xe(() => {
      f(!1);
    }, [r]), /* @__PURE__ */ E(
      A,
      {
        ref: l,
        className: K(
          p,
          S && m,
          y,
          g,
          v,
          a
        ),
        ...S ? { children: x() } : { src: r, alt: i, onError: w },
        ...s
      }
    );
  }
), uY = ({
  id: e,
  type: t = "text",
  defaultValue: n = "",
  value: r,
  size: i = "sm",
  // sm, md, lg
  className: o = "",
  disabled: a = !1,
  onChange: s = () => {
  },
  error: l = !1,
  onError: c = () => {
  },
  prefix: f = null,
  suffix: d = null,
  label: p = "",
  ...m
}, y) => {
  const g = ut(null), v = Fe(() => e || `input-${t}-${ro()}`, [e]), x = Fe(() => typeof r < "u", [r]), [w, S] = Me(n), [A, _] = Me(null), O = qe(
    () => x ? r : w,
    [x, r, w]
  ), P = (ne) => {
    if (a)
      return;
    let J;
    t === "file" ? (J = ne.target.files, J && J.length > 0 ? _(J[0].name) : _(null)) : J = ne.target.value, !x && t !== "file" && S(J), typeof s == "function" && s(J);
  }, C = () => {
    _(null), g.current && (g.current.value = ""), s(null);
  }, k = "bg-field-secondary-background font-normal placeholder-text-tertiary text-text-primary w-full outline outline-1 outline-border-subtle border-none transition-[color,box-shadow,outline] duration-200", D = {
    xs: "px-2 py-1 rounded",
    sm: "p-3 py-2 rounded",
    md: "p-3.5 py-2.5 rounded-md",
    lg: "p-4 py-3 rounded-lg"
  }, $ = {
    xs: "text-xs font-medium",
    sm: "text-sm font-medium",
    md: "text-sm font-medium",
    lg: "text-base font-medium"
  }, N = {
    xs: "text-xs",
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  }, R = {
    sm: f ? "pl-8" : "",
    md: f ? "pl-9" : "",
    lg: f ? "pl-10" : ""
  }, L = {
    sm: d ? "pr-8" : "",
    md: d ? "pr-9" : "",
    lg: d ? "pr-10" : ""
  }, F = a ? "hover:outline-border-disabled" : "hover:outline-border-strong", W = "focus:outline-focus-border focus:ring-2 focus:ring-toggle-on focus:ring-offset-2", z = l ? "focus:outline-focus-error-border focus:ring-field-color-error outline-focus-error-border" : "", G = l ? "focus:outline-focus-error-border focus:ring-field-color-error outline-focus-error-border" : "", U = a ? "outline-border-disabled bg-field-background-disabled cursor-not-allowed text-text-disabled" : "", V = a ? "outline-border-disabled cursor-not-allowed text-text-disabled file:text-text-tertiary" : "", Y = "font-normal placeholder-text-tertiary text-text-primary pointer-events-none absolute inset-y-0 flex flex-1 items-center [&>svg]:h-4 [&>svg]:w-4", ee = a ? "font-normal placeholder-text-tertiary text-icon-disabled pointer-events-none absolute inset-y-0 flex flex-1 items-center" : "font-normal placeholder-text-tertiary text-field-placeholder pointer-events-none absolute inset-y-0 flex flex-1 items-center", ie = {
    xs: "[&>svg]:size-4",
    sm: "[&>svg]:size-4",
    md: "[&>svg]:size-5",
    lg: "[&>svg]:size-6"
  }, re = () => f ? /* @__PURE__ */ E("div", { className: K(Y, "left-0 pl-3", N[i]), children: f }) : null, le = () => t === "file" ? A ? /* @__PURE__ */ E(
    "div",
    {
      className: K(
        ee,
        "right-0 pr-3 cursor-pointer z-20 pointer-events-auto",
        ie[i]
      ),
      onClick: C,
      role: "button",
      tabIndex: 0,
      onKeyDown: (ne) => {
        (ne.key === "Enter" || ne.key === " ") && C();
      },
      children: /* @__PURE__ */ E(Na, {})
    }
  ) : /* @__PURE__ */ E(
    "div",
    {
      className: K(
        ee,
        "right-0 pr-3",
        ie[i]
      ),
      children: /* @__PURE__ */ E(yT, {})
    }
  ) : d ? /* @__PURE__ */ E("div", { className: K(Y, "right-0 pr-3", N[i]), children: d }) : null, ae = Fe(() => p ? /* @__PURE__ */ E(
    eo,
    {
      className: K($[i]),
      htmlFor: v,
      ...(m == null ? void 0 : m.required) && { required: !0 },
      children: p
    }
  ) : null, [p, i, v]), ue = A ? "file:border-0 file:bg-transparent pr-10" : "text-text-tertiary file:border-0 file:bg-transparent pr-10";
  return t === "file" ? /* @__PURE__ */ he("div", { className: "flex flex-col items-start gap-1.5 [&_*]:box-border box-border", children: [
    ae,
    /* @__PURE__ */ he(
      "div",
      {
        className: K(
          "w-full relative flex focus-within:z-10",
          o
        ),
        children: [
          /* @__PURE__ */ E(
            "input",
            {
              ref: w0(g, y),
              id: v,
              type: "file",
              className: K(
                k,
                V,
                D[i],
                N[i],
                W,
                F,
                G,
                ue
              ),
              disabled: a,
              onChange: P,
              onInvalid: c,
              ...m
            }
          ),
          /* @__PURE__ */ E(
            "div",
            {
              className: K(
                ee,
                "right-0 pr-3",
                ie[i]
              ),
              children: /* @__PURE__ */ E(yT, {})
            }
          )
        ]
      }
    )
  ] }) : /* @__PURE__ */ he("div", { className: "flex flex-col items-start gap-1.5 [&_*]:box-border box-border", children: [
    ae,
    /* @__PURE__ */ he(
      "div",
      {
        className: K(
          "w-full relative flex focus-within:z-10",
          o
        ),
        children: [
          re(),
          /* @__PURE__ */ E(
            "input",
            {
              ref: w0(g, y),
              id: v,
              type: t,
              className: K(
                k,
                U,
                D[i],
                N[i],
                R[i],
                L[i],
                W,
                F,
                z
              ),
              disabled: a,
              onChange: P,
              onInvalid: c,
              value: O(),
              ...m
            }
          ),
          le()
        ]
      }
    )
  ] });
}, fY = Dt(uY);
fY.displayName = "Input";
const GEe = ({
  title: e = "",
  description: t = "",
  icon: n = null,
  iconPosition: r = "right",
  // left, right
  tag: i = "h2",
  // h1, h2, h3, h4, h5, h6
  size: o = "sm",
  // xs, sm, md, lg
  className: a = ""
}) => {
  const s = {
    xs: "gap-1 [&>svg]:size-3.5",
    sm: "gap-1 [&>svg]:size-4",
    md: "gap-1.5 [&>svg]:size-5",
    lg: "gap-1.5 [&>svg]:size-5"
  };
  if (!e)
    return null;
  const l = () => /* @__PURE__ */ E(i, { className: K("font-semibold p-0 m-0", {
    xs: "text-base [&>*]:text-base gap-1",
    sm: "text-lg [&>*]:text-lg gap-1",
    md: "text-xl [&>*]:text-xl gap-1.5",
    lg: "text-2xl [&>*]:text-2xl gap-1.5"
  }[o]), children: e }), c = () => /* @__PURE__ */ E(
    "p",
    {
      className: K(
        "text-text-secondary font-normal my-0",
        {
          xs: "text-sm",
          sm: "text-sm",
          md: "text-base",
          lg: "text-base"
        }[o]
      ),
      children: t
    }
  );
  return t ? /* @__PURE__ */ he("div", { className: a, children: [
    /* @__PURE__ */ he("div", { children: [
      n && r === "left" && /* @__PURE__ */ he("div", { className: K("flex items-center", s[o]), children: [
        n,
        l()
      ] }),
      n && r === "right" && /* @__PURE__ */ he("div", { className: K("flex items-center", s[o]), children: [
        l(),
        n
      ] }),
      !n && l()
    ] }),
    c()
  ] }) : /* @__PURE__ */ he("div", { className: a, children: [
    n && r === "left" && /* @__PURE__ */ he("div", { className: K("flex items-center", s[o]), children: [
      n,
      l()
    ] }),
    n && r === "right" && /* @__PURE__ */ he("div", { className: K("flex items-center", s[o]), children: [
      l(),
      n
    ] }),
    !n && l()
  ] });
}, RD = ({
  variant: e = "primary",
  // primary, secondary
  size: t = "md",
  // sm, md, lg, xl,
  icon: n = null,
  className: r = ""
}) => {
  const i = {
    primary: "text-brand-primary-600",
    secondary: "text-background-primary"
  }[e], o = {
    sm: "[&>svg]:size-4",
    md: "[&>svg]:size-5",
    lg: "[&>svg]:size-6",
    xl: "[&>svg]:size-8"
  }[t];
  return /* @__PURE__ */ E(
    "span",
    {
      className: K("flex", o, i, r),
      children: n || /* @__PURE__ */ E(QH, { className: "animate-spin shrink-0" })
    }
  );
}, YEe = ({
  progress: e = 0,
  // 0-100
  speed: t = 200,
  className: n = ""
}) => {
  let r = e;
  e < 0 && (r = 0), e > 100 && (r = 100);
  const i = `translateX(-${100 - r}%)`, o = `h-2 rounded-full bg-background-brand absolute left-0 top-0 w-full bottom-0 origin-left transition-transform duration-${t} ease-linear`;
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "h-2 rounded-full bg-misc-progress-background overflow-hidden relative",
        n
      ),
      role: "progressbar",
      "aria-valuenow": r,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-label": "Progress Bar",
      children: /* @__PURE__ */ E(
        "div",
        {
          className: o,
          style: {
            transform: i
          }
        }
      )
    }
  );
}, jD = dt({
  activeItem: null,
  onChange: () => {
  },
  size: "md",
  iconPosition: "left"
}), dY = ({
  children: e,
  activeItem: t = null,
  onChange: n,
  className: r,
  size: i = "md",
  iconPosition: o = "left"
}) => {
  const a = qe(
    (l) => {
      n && n(l);
    },
    [n]
  ), s = K(
    "box-border flex border border-border-subtle border-solid rounded",
    r
  );
  return /* @__PURE__ */ E("div", { className: s, children: /* @__PURE__ */ E(
    jD.Provider,
    {
      value: {
        activeItem: t,
        onChange: a,
        size: i,
        iconPosition: o
      },
      children: I.Children.map(e, (l, c) => {
        if (!rt(l))
          return null;
        const f = c === 0, d = c === I.Children.count(e) - 1;
        return I.cloneElement(l, {
          ...l.props,
          index: c,
          isFirstChild: f,
          isLastChild: d
        });
      })
    }
  ) });
}, hY = ({
  slug: e,
  text: t,
  icon: n,
  className: r,
  disabled: i = !1,
  isFirstChild: o,
  isLastChild: a,
  ...s
}, l) => {
  const c = I.useContext(jD);
  if (!c)
    throw new Error("Button should be used inside Button Group");
  const { activeItem: f, onChange: d, size: p, iconPosition: m } = c, y = {
    xs: "py-1 px-1 text-sm gap-0.5 [&>svg]:size-4",
    sm: "py-2 px-2 text-base gap-1 [&>svg]:size-4",
    md: "py-2.5 px-2.5 text-base gap-1 [&>svg]:size-5"
  }, g = "bg-background-primary text-primary cursor-pointer flex items-center justify-center", v = "hover:bg-button-tertiary-hover", x = "focus:outline-none", w = i ? "text-text-disabled cursor-not-allowed" : "", S = o ? "rounded-tl rounded-bl border-0 border-r border-border-subtle" : "", A = a ? "rounded-tr rounded-br border-0" : "", _ = "border-0 border-r border-border-subtle border-solid", O = f === e ? "bg-button-disabled" : "", P = K(
    g,
    v,
    x,
    w,
    y[p],
    _,
    O,
    S,
    A,
    r
  );
  return /* @__PURE__ */ he(
    "button",
    {
      ref: l,
      className: P,
      disabled: i,
      onClick: (k) => {
        d({ event: k, value: { slug: e, text: t } });
      },
      ...s,
      children: [
        m === "left" && n && /* @__PURE__ */ E("span", { className: "mr-1", children: n }),
        t,
        m === "right" && n && /* @__PURE__ */ E("span", { className: "ml-1", children: n })
      ]
    }
  );
}, LD = Dt(hY);
LD.displayName = "Button";
const qEe = {
  Group: dY,
  Button: LD
}, YT = /* @__PURE__ */ new Set();
function gg(e, t, n) {
  e || YT.has(t) || (console.warn(t), YT.add(t));
}
function pY(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && gg(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, i) => i === "create" ? e : (t.has(i) || t.set(i, e(i)), t.get(i))
  });
}
function yg(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const S0 = (e) => Array.isArray(e);
function BD(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function hf(e) {
  return typeof e == "string" || Array.isArray(e);
}
function qT(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function d1(e, t, n, r) {
  if (typeof t == "function") {
    const [i, o] = qT(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, o] = qT(r);
    t = t(n !== void 0 ? n : e.custom, i, o);
  }
  return t;
}
function vg(e, t, n) {
  const r = e.getProps();
  return d1(r, t, n !== void 0 ? n : r.custom, e);
}
const h1 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], p1 = ["initial", ...h1], fd = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Hs = new Set(fd), Ki = (e) => e * 1e3, Mo = (e) => e / 1e3, mY = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, gY = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), yY = {
  type: "keyframes",
  duration: 0.8
}, vY = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, bY = (e, { keyframes: t }) => t.length > 2 ? yY : Hs.has(e) ? e.startsWith("scale") ? gY(t[1]) : mY : vY;
function m1(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const xY = {
  skipAnimations: !1,
  useManualTiming: !1
}, wY = (e) => e !== null;
function bg(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(wY), o = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !o || r === void 0 ? i[o] : r;
}
const qn = (e) => e;
function _Y(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function s(c) {
    o.has(c) && (l.schedule(c), e()), c(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, f = !1, d = !1) => {
      const m = d && r ? t : n;
      return f && o.add(c), m.has(c) || m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, r) {
        i = !0;
        return;
      }
      r = !0, [t, n] = [n, t], n.clear(), t.forEach(s), r = !1, i && (i = !1, l.process(c));
    }
  };
  return l;
}
const Eh = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], SY = 40;
function FD(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, o = () => n = !0, a = Eh.reduce((x, w) => (x[w] = _Y(o), x), {}), { read: s, resolveKeyframes: l, update: c, preRender: f, render: d, postRender: p } = a, m = () => {
    const x = performance.now();
    n = !1, i.delta = r ? 1e3 / 60 : Math.max(Math.min(x - i.timestamp, SY), 1), i.timestamp = x, i.isProcessing = !0, s.process(i), l.process(i), c.process(i), f.process(i), d.process(i), p.process(i), i.isProcessing = !1, n && t && (r = !1, e(m));
  }, y = () => {
    n = !0, r = !0, i.isProcessing || e(m);
  };
  return { schedule: Eh.reduce((x, w) => {
    const S = a[w];
    return x[w] = (A, _ = !1, O = !1) => (n || y(), S.schedule(A, _, O)), x;
  }, {}), cancel: (x) => {
    for (let w = 0; w < Eh.length; w++)
      a[Eh[w]].cancel(x);
  }, state: i, steps: a };
}
const { schedule: Tt, cancel: Ra, state: zn, steps: eb } = FD(typeof requestAnimationFrame < "u" ? requestAnimationFrame : qn, !0), WD = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, OY = 1e-7, AY = 12;
function TY(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = WD(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > OY && ++s < AY);
  return a;
}
function dd(e, t, n, r) {
  if (e === t && n === r)
    return qn;
  const i = (o) => TY(o, 0, 1, e, n);
  return (o) => o === 0 || o === 1 ? o : WD(i(o), t, r);
}
const zD = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, VD = (e) => (t) => 1 - e(1 - t), UD = /* @__PURE__ */ dd(0.33, 1.53, 0.69, 0.99), g1 = /* @__PURE__ */ VD(UD), HD = /* @__PURE__ */ zD(g1), KD = (e) => (e *= 2) < 1 ? 0.5 * g1(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), y1 = (e) => 1 - Math.sin(Math.acos(e)), GD = VD(y1), YD = zD(y1), qD = (e) => /^0[^.\s]+$/u.test(e);
function PY(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || qD(e) : !0;
}
let Dc = qn, Fo = qn;
process.env.NODE_ENV !== "production" && (Dc = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Fo = (e, t) => {
  if (!e)
    throw new Error(t);
});
const XD = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), ZD = (e) => (t) => typeof t == "string" && t.startsWith(e), JD = /* @__PURE__ */ ZD("--"), CY = /* @__PURE__ */ ZD("var(--"), v1 = (e) => CY(e) ? EY.test(e.split("/*")[0].trim()) : !1, EY = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, kY = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function MY(e) {
  const t = kY.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const NY = 4;
function QD(e, t, n = 1) {
  Fo(n <= NY, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, i] = MY(e);
  if (!r)
    return;
  const o = window.getComputedStyle(t).getPropertyValue(r);
  if (o) {
    const a = o.trim();
    return XD(a) ? parseFloat(a) : a;
  }
  return v1(i) ? QD(i, t, n + 1) : i;
}
const ja = (e, t, n) => n > t ? t : n < e ? e : n, Ic = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, pf = {
  ...Ic,
  transform: (e) => ja(0, 1, e)
}, kh = {
  ...Ic,
  default: 1
}, hd = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ya = /* @__PURE__ */ hd("deg"), Gi = /* @__PURE__ */ hd("%"), Be = /* @__PURE__ */ hd("px"), $Y = /* @__PURE__ */ hd("vh"), DY = /* @__PURE__ */ hd("vw"), XT = {
  ...Gi,
  parse: (e) => Gi.parse(e) / 100,
  transform: (e) => Gi.transform(e * 100)
}, IY = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), ZT = (e) => e === Ic || e === Be, JT = (e, t) => parseFloat(e.split(", ")[t]), QT = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const i = r.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return JT(i[1], t);
  {
    const o = r.match(/^matrix\((.+)\)$/u);
    return o ? JT(o[1], e) : 0;
  }
}, RY = /* @__PURE__ */ new Set(["x", "y", "z"]), jY = fd.filter((e) => !RY.has(e));
function LY(e) {
  const t = [];
  return jY.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Zl = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: QT(4, 13),
  y: QT(5, 14)
};
Zl.translateX = Zl.x;
Zl.translateY = Zl.y;
const eI = (e) => (t) => t.test(e), BY = {
  test: (e) => e === "auto",
  parse: (e) => e
}, tI = [Ic, Be, Gi, ya, DY, $Y, BY], eP = (e) => tI.find(eI(e)), Ps = /* @__PURE__ */ new Set();
let O0 = !1, A0 = !1;
function nI() {
  if (A0) {
    const e = Array.from(Ps).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = LY(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([o, a]) => {
        var s;
        (s = r.getValue(o)) === null || s === void 0 || s.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  A0 = !1, O0 = !1, Ps.forEach((e) => e.complete()), Ps.clear();
}
function rI() {
  Ps.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (A0 = !0);
  });
}
function FY() {
  rI(), nI();
}
class b1 {
  constructor(t, n, r, i, o, a = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = o, this.isAsync = a;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Ps.add(this), O0 || (O0 = !0, Tt.read(rI), Tt.resolveKeyframes(nI))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    for (let o = 0; o < t.length; o++)
      if (t[o] === null)
        if (o === 0) {
          const a = i == null ? void 0 : i.get(), s = t[t.length - 1];
          if (a !== void 0)
            t[0] = a;
          else if (r && n) {
            const l = r.readValue(n, s);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = s), i && a === void 0 && i.set(t[0]);
        } else
          t[o] = t[o - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Ps.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Ps.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Hu = (e) => Math.round(e * 1e5) / 1e5, x1 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function WY(e) {
  return e == null;
}
const zY = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, w1 = (e, t) => (n) => !!(typeof n == "string" && zY.test(n) && n.startsWith(e) || t && !WY(n) && Object.prototype.hasOwnProperty.call(n, t)), iI = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, o, a, s] = r.match(x1);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, VY = (e) => ja(0, 255, e), tb = {
  ...Ic,
  transform: (e) => Math.round(VY(e))
}, bs = {
  test: /* @__PURE__ */ w1("rgb", "red"),
  parse: /* @__PURE__ */ iI("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + tb.transform(e) + ", " + tb.transform(t) + ", " + tb.transform(n) + ", " + Hu(pf.transform(r)) + ")"
};
function UY(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const T0 = {
  test: /* @__PURE__ */ w1("#"),
  parse: UY,
  transform: bs.transform
}, El = {
  test: /* @__PURE__ */ w1("hsl", "hue"),
  parse: /* @__PURE__ */ iI("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Gi.transform(Hu(t)) + ", " + Gi.transform(Hu(n)) + ", " + Hu(pf.transform(r)) + ")"
}, er = {
  test: (e) => bs.test(e) || T0.test(e) || El.test(e),
  parse: (e) => bs.test(e) ? bs.parse(e) : El.test(e) ? El.parse(e) : T0.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? bs.transform(e) : El.transform(e)
}, HY = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function KY(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(x1)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(HY)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const oI = "number", aI = "color", GY = "var", YY = "var(", tP = "${}", qY = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function mf(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let o = 0;
  const s = t.replace(qY, (l) => (er.test(l) ? (r.color.push(o), i.push(aI), n.push(er.parse(l))) : l.startsWith(YY) ? (r.var.push(o), i.push(GY), n.push(l)) : (r.number.push(o), i.push(oI), n.push(parseFloat(l))), ++o, tP)).split(tP);
  return { values: n, split: s, indexes: r, types: i };
}
function sI(e) {
  return mf(e).values;
}
function lI(e) {
  const { split: t, types: n } = mf(e), r = t.length;
  return (i) => {
    let o = "";
    for (let a = 0; a < r; a++)
      if (o += t[a], i[a] !== void 0) {
        const s = n[a];
        s === oI ? o += Hu(i[a]) : s === aI ? o += er.transform(i[a]) : o += i[a];
      }
    return o;
  };
}
const XY = (e) => typeof e == "number" ? 0 : e;
function ZY(e) {
  const t = sI(e);
  return lI(e)(t.map(XY));
}
const La = {
  test: KY,
  parse: sI,
  createTransformer: lI,
  getAnimatableNone: ZY
}, JY = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function QY(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(x1) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = JY.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const eq = /\b([a-z-]*)\(.*?\)/gu, P0 = {
  ...La,
  getAnimatableNone: (e) => {
    const t = e.match(eq);
    return t ? t.map(QY).join(" ") : e;
  }
}, tq = {
  // Border props
  borderWidth: Be,
  borderTopWidth: Be,
  borderRightWidth: Be,
  borderBottomWidth: Be,
  borderLeftWidth: Be,
  borderRadius: Be,
  radius: Be,
  borderTopLeftRadius: Be,
  borderTopRightRadius: Be,
  borderBottomRightRadius: Be,
  borderBottomLeftRadius: Be,
  // Positioning props
  width: Be,
  maxWidth: Be,
  height: Be,
  maxHeight: Be,
  top: Be,
  right: Be,
  bottom: Be,
  left: Be,
  // Spacing props
  padding: Be,
  paddingTop: Be,
  paddingRight: Be,
  paddingBottom: Be,
  paddingLeft: Be,
  margin: Be,
  marginTop: Be,
  marginRight: Be,
  marginBottom: Be,
  marginLeft: Be,
  // Misc
  backgroundPositionX: Be,
  backgroundPositionY: Be
}, nq = {
  rotate: ya,
  rotateX: ya,
  rotateY: ya,
  rotateZ: ya,
  scale: kh,
  scaleX: kh,
  scaleY: kh,
  scaleZ: kh,
  skew: ya,
  skewX: ya,
  skewY: ya,
  distance: Be,
  translateX: Be,
  translateY: Be,
  translateZ: Be,
  x: Be,
  y: Be,
  z: Be,
  perspective: Be,
  transformPerspective: Be,
  opacity: pf,
  originX: XT,
  originY: XT,
  originZ: Be
}, nP = {
  ...Ic,
  transform: Math.round
}, _1 = {
  ...tq,
  ...nq,
  zIndex: nP,
  size: Be,
  // SVG
  fillOpacity: pf,
  strokeOpacity: pf,
  numOctaves: nP
}, rq = {
  ..._1,
  // Color props
  color: er,
  backgroundColor: er,
  outlineColor: er,
  fill: er,
  stroke: er,
  // Border props
  borderColor: er,
  borderTopColor: er,
  borderRightColor: er,
  borderBottomColor: er,
  borderLeftColor: er,
  filter: P0,
  WebkitFilter: P0
}, S1 = (e) => rq[e];
function cI(e, t) {
  let n = S1(e);
  return n !== P0 && (n = La), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const iq = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function oq(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const o = e[r];
    typeof o == "string" && !iq.has(o) && mf(o).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const o of t)
      e[o] = cI(n, i);
}
class uI extends b1 {
  constructor(t, n, r, i, o) {
    super(t, n, r, i, o, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let c = t[l];
      if (typeof c == "string" && (c = c.trim(), v1(c))) {
        const f = QD(c, n.current);
        f !== void 0 && (t[l] = f), l === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !IY.has(r) || t.length !== 2)
      return;
    const [i, o] = t, a = eP(i), s = eP(o);
    if (a !== s)
      if (ZT(a) && ZT(s))
        for (let l = 0; l < t.length; l++) {
          const c = t[l];
          typeof c == "string" && (t[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      PY(t[i]) && r.push(i);
    r.length && oq(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Zl[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const o = n.getValue(r);
    o && o.jump(this.measuredOrigin, !1);
    const a = i.length - 1, s = i[a];
    i[a] = Zl[r](n.measureViewportBox(), window.getComputedStyle(n.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function O1(e) {
  return typeof e == "function";
}
let ap;
function aq() {
  ap = void 0;
}
const Yi = {
  now: () => (ap === void 0 && Yi.set(zn.isProcessing || xY.useManualTiming ? zn.timestamp : performance.now()), ap),
  set: (e) => {
    ap = e, queueMicrotask(aq);
  }
}, rP = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(La.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function sq(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function lq(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const o = e[e.length - 1], a = rP(i, t), s = rP(o, t);
  return Dc(a === s, `You are trying to animate ${t} from "${i}" to "${o}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${o} via the \`style\` property.`), !a || !s ? !1 : sq(e) || (n === "spring" || O1(n)) && r;
}
const cq = 40;
class fI {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: a = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = Yi.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: o,
      repeatType: a,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > cq ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && FY(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = Yi.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: i, velocity: o, delay: a, onComplete: s, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !lq(t, r, i, o))
      if (a)
        this.options.duration = 0;
      else {
        l == null || l(bg(t, this.options, n)), s == null || s(), this.resolveFinishedPromise();
        return;
      }
    const f = this.initPlayback(t, n);
    f !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...f
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function dI(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const uq = 5;
function hI(e, t, n) {
  const r = Math.max(t - uq, 0);
  return dI(n - e(r), t - r);
}
const nb = 1e-3, fq = 0.01, iP = 10, dq = 0.05, hq = 1;
function pq({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, o;
  Dc(e <= Ki(iP), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = ja(dq, hq, a), e = ja(fq, iP, Mo(e)), a < 1 ? (i = (c) => {
    const f = c * a, d = f * e, p = f - n, m = C0(c, a), y = Math.exp(-d);
    return nb - p / m * y;
  }, o = (c) => {
    const d = c * a * e, p = d * n + n, m = Math.pow(a, 2) * Math.pow(c, 2) * e, y = Math.exp(-d), g = C0(Math.pow(c, 2), a);
    return (-i(c) + nb > 0 ? -1 : 1) * ((p - m) * y) / g;
  }) : (i = (c) => {
    const f = Math.exp(-c * e), d = (c - n) * e + 1;
    return -nb + f * d;
  }, o = (c) => {
    const f = Math.exp(-c * e), d = (n - c) * (e * e);
    return f * d;
  });
  const s = 5 / e, l = gq(i, o, s);
  if (e = Ki(e), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: a * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const mq = 12;
function gq(e, t, n) {
  let r = n;
  for (let i = 1; i < mq; i++)
    r = r - e(r) / t(r);
  return r;
}
function C0(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const yq = ["duration", "bounce"], vq = ["stiffness", "damping", "mass"];
function oP(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function bq(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!oP(e, vq) && oP(e, yq)) {
    const n = pq(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function pI({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const i = e[0], o = e[e.length - 1], a = { done: !1, value: i }, { stiffness: s, damping: l, mass: c, duration: f, velocity: d, isResolvedFromDuration: p } = bq({
    ...r,
    velocity: -Mo(r.velocity || 0)
  }), m = d || 0, y = l / (2 * Math.sqrt(s * c)), g = o - i, v = Mo(Math.sqrt(s / c)), x = Math.abs(g) < 5;
  n || (n = x ? 0.01 : 2), t || (t = x ? 5e-3 : 0.5);
  let w;
  if (y < 1) {
    const S = C0(v, y);
    w = (A) => {
      const _ = Math.exp(-y * v * A);
      return o - _ * ((m + y * v * g) / S * Math.sin(S * A) + g * Math.cos(S * A));
    };
  } else if (y === 1)
    w = (S) => o - Math.exp(-v * S) * (g + (m + v * g) * S);
  else {
    const S = v * Math.sqrt(y * y - 1);
    w = (A) => {
      const _ = Math.exp(-y * v * A), O = Math.min(S * A, 300);
      return o - _ * ((m + y * v * g) * Math.sinh(O) + S * g * Math.cosh(O)) / S;
    };
  }
  return {
    calculatedDuration: p && f || null,
    next: (S) => {
      const A = w(S);
      if (p)
        a.done = S >= f;
      else {
        let _ = 0;
        y < 1 && (_ = S === 0 ? Ki(m) : hI(w, S, A));
        const O = Math.abs(_) <= n, P = Math.abs(o - A) <= t;
        a.done = O && P;
      }
      return a.value = a.done ? o : A, a;
    }
  };
}
function aP({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: o = 500, modifyTarget: a, min: s, max: l, restDelta: c = 0.5, restSpeed: f }) {
  const d = e[0], p = {
    done: !1,
    value: d
  }, m = (C) => s !== void 0 && C < s || l !== void 0 && C > l, y = (C) => s === void 0 ? l : l === void 0 || Math.abs(s - C) < Math.abs(l - C) ? s : l;
  let g = n * t;
  const v = d + g, x = a === void 0 ? v : a(v);
  x !== v && (g = x - d);
  const w = (C) => -g * Math.exp(-C / r), S = (C) => x + w(C), A = (C) => {
    const k = w(C), D = S(C);
    p.done = Math.abs(k) <= c, p.value = p.done ? x : D;
  };
  let _, O;
  const P = (C) => {
    m(p.value) && (_ = C, O = pI({
      keyframes: [p.value, y(p.value)],
      velocity: hI(S, C, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: o,
      restDelta: c,
      restSpeed: f
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (C) => {
      let k = !1;
      return !O && _ === void 0 && (k = !0, A(C), P(C)), _ !== void 0 && C >= _ ? O.next(C - _) : (!k && A(C), p);
    }
  };
}
const xq = /* @__PURE__ */ dd(0.42, 0, 1, 1), wq = /* @__PURE__ */ dd(0, 0, 0.58, 1), mI = /* @__PURE__ */ dd(0.42, 0, 0.58, 1), _q = (e) => Array.isArray(e) && typeof e[0] != "number", A1 = (e) => Array.isArray(e) && typeof e[0] == "number", sP = {
  linear: qn,
  easeIn: xq,
  easeInOut: mI,
  easeOut: wq,
  circIn: y1,
  circInOut: YD,
  circOut: GD,
  backIn: g1,
  backInOut: HD,
  backOut: UD,
  anticipate: KD
}, lP = (e) => {
  if (A1(e)) {
    Fo(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, i] = e;
    return dd(t, n, r, i);
  } else if (typeof e == "string")
    return Fo(sP[e] !== void 0, `Invalid easing type '${e}'`), sP[e];
  return e;
}, Sq = (e, t) => (n) => t(e(n)), No = (...e) => e.reduce(Sq), Jl = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Qt = (e, t, n) => e + (t - e) * n;
function rb(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Oq({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = rb(l, s, e + 1 / 3), o = rb(l, s, e), a = rb(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function Op(e, t) {
  return (n) => n > 0 ? t : e;
}
const ib = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, Aq = [T0, bs, El], Tq = (e) => Aq.find((t) => t.test(e));
function cP(e) {
  const t = Tq(e);
  if (Dc(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === El && (n = Oq(n)), n;
}
const uP = (e, t) => {
  const n = cP(e), r = cP(t);
  if (!n || !r)
    return Op(e, t);
  const i = { ...n };
  return (o) => (i.red = ib(n.red, r.red, o), i.green = ib(n.green, r.green, o), i.blue = ib(n.blue, r.blue, o), i.alpha = Qt(n.alpha, r.alpha, o), bs.transform(i));
}, E0 = /* @__PURE__ */ new Set(["none", "hidden"]);
function Pq(e, t) {
  return E0.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function Cq(e, t) {
  return (n) => Qt(e, t, n);
}
function T1(e) {
  return typeof e == "number" ? Cq : typeof e == "string" ? v1(e) ? Op : er.test(e) ? uP : Mq : Array.isArray(e) ? gI : typeof e == "object" ? er.test(e) ? uP : Eq : Op;
}
function gI(e, t) {
  const n = [...e], r = n.length, i = e.map((o, a) => T1(o)(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}
function Eq(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = T1(e[i])(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
}
function kq(e, t) {
  var n;
  const r = [], i = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < t.values.length; o++) {
    const a = t.types[o], s = e.indexes[a][i[a]], l = (n = e.values[s]) !== null && n !== void 0 ? n : 0;
    r[o] = l, i[a]++;
  }
  return r;
}
const Mq = (e, t) => {
  const n = La.createTransformer(t), r = mf(e), i = mf(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? E0.has(e) && !i.values.length || E0.has(t) && !r.values.length ? Pq(e, t) : No(gI(kq(r, i), i.values), n) : (Dc(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Op(e, t));
};
function yI(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Qt(e, t, n) : T1(e)(e, t);
}
function Nq(e, t, n) {
  const r = [], i = n || yI, o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] || qn : t;
      s = No(l, s);
    }
    r.push(s);
  }
  return r;
}
function $q(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  if (Fo(o === t.length, "Both input and output ranges must be the same length"), o === 1)
    return () => t[0];
  if (o === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[o - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = Nq(t, r, i), s = a.length, l = (c) => {
    let f = 0;
    if (s > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const d = Jl(e[f], e[f + 1], c);
    return a[f](d);
  };
  return n ? (c) => l(ja(e[0], e[o - 1], c)) : l;
}
function Dq(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = Jl(0, t, r);
    e.push(Qt(n, 1, i));
  }
}
function Iq(e) {
  const t = [0];
  return Dq(t, e.length - 1), t;
}
function Rq(e, t) {
  return e.map((n) => n * t);
}
function jq(e, t) {
  return e.map(() => t || mI).splice(0, e.length - 1);
}
function Ap({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = _q(r) ? r.map(lP) : lP(r), o = {
    done: !1,
    value: t[0]
  }, a = Rq(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Iq(t),
    e
  ), s = $q(a, t, {
    ease: Array.isArray(i) ? i : jq(t, i)
  });
  return {
    calculatedDuration: e,
    next: (l) => (o.value = s(l), o.done = l >= e, o)
  };
}
const fP = 2e4;
function Lq(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < fP; )
    t += n, r = e.next(t);
  return t >= fP ? 1 / 0 : t;
}
const Bq = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Tt.update(t, !0),
    stop: () => Ra(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => zn.isProcessing ? zn.timestamp : Yi.now()
  };
}, Fq = {
  decay: aP,
  inertia: aP,
  tween: Ap,
  keyframes: Ap,
  spring: pI
}, Wq = (e) => e / 100;
class P1 extends fI {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: i, keyframes: o } = this.options, a = (i == null ? void 0 : i.KeyframeResolver) || b1, s = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new a(o, s, n, r, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: o, velocity: a = 0 } = this.options, s = O1(n) ? n : Fq[n] || Ap;
    let l, c;
    s !== Ap && typeof t[0] != "number" && (process.env.NODE_ENV !== "production" && Fo(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = No(Wq, yI(t[0], t[1])), t = [0, 100]);
    const f = s({ ...this.options, keyframes: t });
    o === "mirror" && (c = s({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -a
    })), f.calculatedDuration === null && (f.calculatedDuration = Lq(f));
    const { calculatedDuration: d } = f, p = d + i, m = p * (r + 1) - i;
    return {
      generator: f,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: d,
      resolvedDuration: p,
      totalDuration: m
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: C } = this.options;
      return { done: !0, value: C[C.length - 1] };
    }
    const { finalKeyframe: i, generator: o, mirroredGenerator: a, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: c, totalDuration: f, resolvedDuration: d } = r;
    if (this.startTime === null)
      return o.next(0);
    const { delay: p, repeat: m, repeatType: y, repeatDelay: g, onUpdate: v } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - f / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const x = this.currentTime - p * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? x < 0 : x > f;
    this.currentTime = Math.max(x, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = f);
    let S = this.currentTime, A = o;
    if (m) {
      const C = Math.min(this.currentTime, f) / d;
      let k = Math.floor(C), D = C % 1;
      !D && C >= 1 && (D = 1), D === 1 && k--, k = Math.min(k, m + 1), !!(k % 2) && (y === "reverse" ? (D = 1 - D, g && (D -= g / d)) : y === "mirror" && (A = a)), S = ja(0, 1, D) * d;
    }
    const _ = w ? { done: !1, value: l[0] } : A.next(S);
    s && (_.value = s(_.value));
    let { done: O } = _;
    !w && c !== null && (O = this.speed >= 0 ? this.currentTime >= f : this.currentTime <= 0);
    const P = this.holdTime === null && (this.state === "finished" || this.state === "running" && O);
    return P && i !== void 0 && (_.value = bg(l, this.options, i)), v && v(_.value), P && this.finish(), _;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? Mo(t.calculatedDuration) : 0;
  }
  get time() {
    return Mo(this.currentTime);
  }
  set time(t) {
    t = Ki(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = Mo(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = Bq, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const zq = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), Vq = 10, Uq = (e, t) => {
  let n = "";
  const r = Math.max(Math.round(t / Vq), 2);
  for (let i = 0; i < r; i++)
    n += e(Jl(0, r - 1, i)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function C1(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Hq = {
  linearEasing: void 0
};
function Kq(e, t) {
  const n = C1(e);
  return () => {
    var r;
    return (r = Hq[t]) !== null && r !== void 0 ? r : n();
  };
}
const Tp = /* @__PURE__ */ Kq(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function vI(e) {
  return !!(typeof e == "function" && Tp() || !e || typeof e == "string" && (e in k0 || Tp()) || A1(e) || Array.isArray(e) && e.every(vI));
}
const ju = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, k0 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ ju([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ ju([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ ju([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ ju([0.33, 1.53, 0.69, 0.99])
};
function bI(e, t) {
  if (e)
    return typeof e == "function" && Tp() ? Uq(e, t) : A1(e) ? ju(e) : Array.isArray(e) ? e.map((n) => bI(n, t) || k0.easeOut) : k0[e];
}
function Gq(e, t, n, { delay: r = 0, duration: i = 300, repeat: o = 0, repeatType: a = "loop", ease: s = "easeInOut", times: l } = {}) {
  const c = { [t]: n };
  l && (c.offset = l);
  const f = bI(s, i);
  return Array.isArray(f) && (c.easing = f), e.animate(c, {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: o + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
function dP(e, t) {
  e.timeline = t, e.onfinish = null;
}
const Yq = /* @__PURE__ */ C1(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Pp = 10, qq = 2e4;
function Xq(e) {
  return O1(e.type) || e.type === "spring" || !vI(e.ease);
}
function Zq(e, t) {
  const n = new P1({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const i = [];
  let o = 0;
  for (; !r.done && o < qq; )
    r = n.sample(o), i.push(r.value), o += Pp;
  return {
    times: void 0,
    keyframes: i,
    duration: o - Pp,
    ease: "linear"
  };
}
const xI = {
  anticipate: KD,
  backInOut: HD,
  circInOut: YD
};
function Jq(e) {
  return e in xI;
}
class hP extends fI {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: i, keyframes: o } = this.options;
    this.resolver = new uI(o, (a, s) => this.onKeyframesResolved(a, s), n, r, i), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    var r;
    let { duration: i = 300, times: o, ease: a, type: s, motionValue: l, name: c, startTime: f } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (typeof a == "string" && Tp() && Jq(a) && (a = xI[a]), Xq(this.options)) {
      const { onComplete: p, onUpdate: m, motionValue: y, element: g, ...v } = this.options, x = Zq(t, v);
      t = x.keyframes, t.length === 1 && (t[1] = t[0]), i = x.duration, o = x.times, a = x.ease, s = "keyframes";
    }
    const d = Gq(l.owner.current, c, t, { ...this.options, duration: i, times: o, ease: a });
    return d.startTime = f ?? this.calcStartTime(), this.pendingTimeline ? (dP(d, this.pendingTimeline), this.pendingTimeline = void 0) : d.onfinish = () => {
      const { onComplete: p } = this.options;
      l.set(bg(t, this.options, n)), p && p(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: d,
      duration: i,
      times: o,
      type: s,
      ease: a,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return Mo(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return Mo(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = Ki(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return qn;
      const { animation: r } = n;
      dP(r, t);
    }
    return qn;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: i, type: o, ease: a, times: s } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: f, onComplete: d, element: p, ...m } = this.options, y = new P1({
        ...m,
        keyframes: r,
        duration: i,
        type: o,
        ease: a,
        times: s,
        isGenerator: !0
      }), g = Ki(this.time);
      c.setWithVelocity(y.sample(g - Pp).value, y.sample(g).value, Pp);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: i, repeatType: o, damping: a, type: s } = t;
    return Yq() && r && zq.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !i && o !== "mirror" && a !== 0 && s !== "inertia";
  }
}
const Qq = C1(() => window.ScrollTimeline !== void 0);
class e9 {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t, n) {
    const r = this.animations.map((i) => Qq() && i.attachTimeline ? i.attachTimeline(t) : n(i));
    return () => {
      r.forEach((i, o) => {
        i && i(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function t9({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: o, repeatType: a, repeatDelay: s, from: l, elapsed: c, ...f }) {
  return !!Object.keys(f).length;
}
const E1 = (e, t, n, r = {}, i, o) => (a) => {
  const s = m1(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - Ki(l);
  let f = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -c,
    onUpdate: (p) => {
      t.set(p), s.onUpdate && s.onUpdate(p);
    },
    onComplete: () => {
      a(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: o ? void 0 : i
  };
  t9(s) || (f = {
    ...f,
    ...bY(e, f)
  }), f.duration && (f.duration = Ki(f.duration)), f.repeatDelay && (f.repeatDelay = Ki(f.repeatDelay)), f.from !== void 0 && (f.keyframes[0] = f.from);
  let d = !1;
  if ((f.type === !1 || f.duration === 0 && !f.repeatDelay) && (f.duration = 0, f.delay === 0 && (d = !0)), d && !o && t.get() !== void 0) {
    const p = bg(f.keyframes, s);
    if (p !== void 0)
      return Tt.update(() => {
        f.onUpdate(p), f.onComplete();
      }), new e9([]);
  }
  return !o && hP.supports(f) ? new hP(f) : new P1(f);
}, n9 = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), r9 = (e) => S0(e) ? e[e.length - 1] || 0 : e;
function k1(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function M1(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class N1 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return k1(this.subscriptions, t), () => M1(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let o = 0; o < i; o++) {
          const a = this.subscriptions[o];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const pP = 30, i9 = (e) => !isNaN(parseFloat(e));
class o9 {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.11.17", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      const o = Yi.now();
      this.updatedAt !== o && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Yi.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = i9(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && gg(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new N1());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Tt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Yi.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > pP)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, pP);
    return dI(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function gf(e, t) {
  return new o9(e, t);
}
function a9(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, gf(n));
}
function s9(e, t) {
  const n = vg(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...o } = n || {};
  o = { ...o, ...r };
  for (const a in o) {
    const s = r9(o[a]);
    a9(e, a, s);
  }
}
const $1 = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), l9 = "framerAppearId", wI = "data-" + $1(l9);
function _I(e) {
  return e.props[wI];
}
const rr = (e) => !!(e && e.getVelocity);
function c9(e) {
  return !!(rr(e) && e.add);
}
function M0(e, t) {
  const n = e.getValue("willChange");
  if (c9(n))
    return n.add(t);
}
function u9({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function SI(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  var o;
  let { transition: a = e.getDefaultTransition(), transitionEnd: s, ...l } = t;
  r && (a = r);
  const c = [], f = i && e.animationState && e.animationState.getState()[i];
  for (const d in l) {
    const p = e.getValue(d, (o = e.latestValues[d]) !== null && o !== void 0 ? o : null), m = l[d];
    if (m === void 0 || f && u9(f, d))
      continue;
    const y = {
      delay: n,
      ...m1(a || {}, d)
    };
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const x = _I(e);
      if (x) {
        const w = window.MotionHandoffAnimation(x, d, Tt);
        w !== null && (y.startTime = w, g = !0);
      }
    }
    M0(e, d), p.start(E1(d, p, m, e.shouldReduceMotion && Hs.has(d) ? { type: !1 } : y, e, g));
    const v = p.animation;
    v && c.push(v);
  }
  return s && Promise.all(c).then(() => {
    Tt.update(() => {
      s && s9(e, s);
    });
  }), c;
}
function N0(e, t, n = {}) {
  var r;
  const i = vg(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: o = e.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (o = n.transitionOverride);
  const a = i ? () => Promise.all(SI(e, i, n)) : () => Promise.resolve(), s = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: f = 0, staggerChildren: d, staggerDirection: p } = o;
    return f9(e, t, f + c, d, p, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [c, f] = l === "beforeChildren" ? [a, s] : [s, a];
    return c().then(() => f());
  } else
    return Promise.all([a(), s(n.delay)]);
}
function f9(e, t, n = 0, r = 0, i = 1, o) {
  const a = [], s = (e.variantChildren.size - 1) * r, l = i === 1 ? (c = 0) => c * r : (c = 0) => s - c * r;
  return Array.from(e.variantChildren).sort(d9).forEach((c, f) => {
    c.notify("AnimationStart", t), a.push(N0(c, t, {
      ...o,
      delay: n + l(f)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function d9(e, t) {
  return e.sortNodePosition(t);
}
function h9(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((o) => N0(e, o, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = N0(e, t, n);
  else {
    const i = typeof t == "function" ? vg(e, t, n.custom) : t;
    r = Promise.all(SI(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const p9 = p1.length;
function OI(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? OI(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < p9; n++) {
    const r = p1[n], i = e.props[r];
    (hf(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const m9 = [...h1].reverse(), g9 = h1.length;
function y9(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => h9(e, n, r)));
}
function v9(e) {
  let t = y9(e), n = mP(), r = !0;
  const i = (l) => (c, f) => {
    var d;
    const p = vg(e, f, l === "exit" ? (d = e.presenceContext) === null || d === void 0 ? void 0 : d.custom : void 0);
    if (p) {
      const { transition: m, transitionEnd: y, ...g } = p;
      c = { ...c, ...g, ...y };
    }
    return c;
  };
  function o(l) {
    t = l(e);
  }
  function a(l) {
    const { props: c } = e, f = OI(e.parent) || {}, d = [], p = /* @__PURE__ */ new Set();
    let m = {}, y = 1 / 0;
    for (let v = 0; v < g9; v++) {
      const x = m9[v], w = n[x], S = c[x] !== void 0 ? c[x] : f[x], A = hf(S), _ = x === l ? w.isActive : null;
      _ === !1 && (y = v);
      let O = S === f[x] && S !== c[x] && A;
      if (O && r && e.manuallyAnimateOnMount && (O = !1), w.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && _ === null || // If we didn't and don't have any defined prop for this animation type
      !S && !w.prevProp || // Or if the prop doesn't define an animation
      yg(S) || typeof S == "boolean")
        continue;
      const P = b9(w.prevProp, S);
      let C = P || // If we're making this variant active, we want to always make it active
      x === l && w.isActive && !O && A || // If we removed a higher-priority variant (i is in reverse order)
      v > y && A, k = !1;
      const D = Array.isArray(S) ? S : [S];
      let $ = D.reduce(i(x), {});
      _ === !1 && ($ = {});
      const { prevResolvedValues: N = {} } = w, R = {
        ...N,
        ...$
      }, L = (z) => {
        C = !0, p.has(z) && (k = !0, p.delete(z)), w.needsAnimating[z] = !0;
        const G = e.getValue(z);
        G && (G.liveStyle = !1);
      };
      for (const z in R) {
        const G = $[z], U = N[z];
        if (m.hasOwnProperty(z))
          continue;
        let V = !1;
        S0(G) && S0(U) ? V = !BD(G, U) : V = G !== U, V ? G != null ? L(z) : p.add(z) : G !== void 0 && p.has(z) ? L(z) : w.protectedKeys[z] = !0;
      }
      w.prevProp = S, w.prevResolvedValues = $, w.isActive && (m = { ...m, ...$ }), r && e.blockInitialAnimation && (C = !1), C && (!(O && P) || k) && d.push(...D.map((z) => ({
        animation: z,
        options: { type: x }
      })));
    }
    if (p.size) {
      const v = {};
      p.forEach((x) => {
        const w = e.getBaseTarget(x), S = e.getValue(x);
        S && (S.liveStyle = !0), v[x] = w ?? null;
      }), d.push({ animation: v });
    }
    let g = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (g = !1), r = !1, g ? t(d) : Promise.resolve();
  }
  function s(l, c) {
    var f;
    if (n[l].isActive === c)
      return Promise.resolve();
    (f = e.variantChildren) === null || f === void 0 || f.forEach((p) => {
      var m;
      return (m = p.animationState) === null || m === void 0 ? void 0 : m.setActive(l, c);
    }), n[l].isActive = c;
    const d = a(l);
    for (const p in n)
      n[p].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: a,
    setActive: s,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = mP(), r = !0;
    }
  };
}
function b9(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !BD(t, e) : !1;
}
function as(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function mP() {
  return {
    animate: as(!0),
    whileInView: as(),
    whileHover: as(),
    whileTap: as(),
    whileDrag: as(),
    whileFocus: as(),
    exit: as()
  };
}
class za {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class x9 extends za {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = v9(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    yg(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let w9 = 0;
class _9 extends za {
  constructor() {
    super(...arguments), this.id = w9++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const S9 = {
  animation: {
    Feature: x9
  },
  exit: {
    Feature: _9
  }
}, AI = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function xg(e, t = "page") {
  return {
    point: {
      x: e[`${t}X`],
      y: e[`${t}Y`]
    }
  };
}
const O9 = (e) => (t) => AI(t) && e(t, xg(t));
function Ao(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function $o(e, t, n, r) {
  return Ao(e, t, O9(n), r);
}
const gP = (e, t) => Math.abs(e - t);
function A9(e, t) {
  const n = gP(e.x, t.x), r = gP(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class TI {
  constructor(t, n, { transformPagePoint: r, contextWindow: i, dragSnapToOrigin: o = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = ab(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, m = A9(d.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !m)
        return;
      const { point: y } = d, { timestamp: g } = zn;
      this.history.push({ ...y, timestamp: g });
      const { onStart: v, onMove: x } = this.handlers;
      p || (v && v(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, p) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = ob(p, this.transformPagePoint), Tt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, p) => {
      this.end();
      const { onEnd: m, onSessionEnd: y, resumeAnimation: g } = this.handlers;
      if (this.dragSnapToOrigin && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const v = ab(d.type === "pointercancel" ? this.lastMoveEventInfo : ob(p, this.transformPagePoint), this.history);
      this.startEvent && m && m(d, v), y && y(d, v);
    }, !AI(t))
      return;
    this.dragSnapToOrigin = o, this.handlers = n, this.transformPagePoint = r, this.contextWindow = i || window;
    const a = xg(t), s = ob(a, this.transformPagePoint), { point: l } = s, { timestamp: c } = zn;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: f } = n;
    f && f(t, ab(s, this.history)), this.removeListeners = No($o(this.contextWindow, "pointermove", this.handlePointerMove), $o(this.contextWindow, "pointerup", this.handlePointerUp), $o(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ra(this.updatePoint);
  }
}
function ob(e, t) {
  return t ? { point: t(e.point) } : e;
}
function yP(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function ab({ point: e }, t) {
  return {
    point: e,
    delta: yP(e, PI(t)),
    offset: yP(e, T9(t)),
    velocity: P9(t, 0.1)
  };
}
function T9(e) {
  return e[0];
}
function PI(e) {
  return e[e.length - 1];
}
function P9(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const i = PI(e);
  for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > Ki(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const o = Mo(i.timestamp - r.timestamp);
  if (o === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function CI(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const vP = CI("dragHorizontal"), bP = CI("dragVertical");
function EI(e) {
  let t = !1;
  if (e === "y")
    t = bP();
  else if (e === "x")
    t = vP();
  else {
    const n = vP(), r = bP();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function kI() {
  const e = EI(!0);
  return e ? (e(), !1) : !0;
}
function kl(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
const MI = 1e-4, C9 = 1 - MI, E9 = 1 + MI, NI = 0.01, k9 = 0 - NI, M9 = 0 + NI;
function Kr(e) {
  return e.max - e.min;
}
function N9(e, t, n) {
  return Math.abs(e - t) <= n;
}
function xP(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Qt(t.min, t.max, e.origin), e.scale = Kr(n) / Kr(t), e.translate = Qt(n.min, n.max, e.origin) - e.originPoint, (e.scale >= C9 && e.scale <= E9 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= k9 && e.translate <= M9 || isNaN(e.translate)) && (e.translate = 0);
}
function Ku(e, t, n, r) {
  xP(e.x, t.x, n.x, r ? r.originX : void 0), xP(e.y, t.y, n.y, r ? r.originY : void 0);
}
function wP(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Kr(t);
}
function $9(e, t, n) {
  wP(e.x, t.x, n.x), wP(e.y, t.y, n.y);
}
function _P(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Kr(t);
}
function Gu(e, t, n) {
  _P(e.x, t.x, n.x), _P(e.y, t.y, n.y);
}
function D9(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Qt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Qt(n, e, r.max) : Math.min(e, n)), e;
}
function SP(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function I9(e, { top: t, left: n, bottom: r, right: i }) {
  return {
    x: SP(e.x, n, i),
    y: SP(e.y, t, r)
  };
}
function OP(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function R9(e, t) {
  return {
    x: OP(e.x, t.x),
    y: OP(e.y, t.y)
  };
}
function j9(e, t) {
  let n = 0.5;
  const r = Kr(e), i = Kr(t);
  return i > r ? n = Jl(t.min, t.max - r, e.min) : r > i && (n = Jl(e.min, e.max - i, t.min)), ja(0, 1, n);
}
function L9(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const $0 = 0.35;
function B9(e = $0) {
  return e === !1 ? e = 0 : e === !0 && (e = $0), {
    x: AP(e, "left", "right"),
    y: AP(e, "top", "bottom")
  };
}
function AP(e, t, n) {
  return {
    min: TP(e, t),
    max: TP(e, n)
  };
}
function TP(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const PP = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Ml = () => ({
  x: PP(),
  y: PP()
}), CP = () => ({ min: 0, max: 0 }), ln = () => ({
  x: CP(),
  y: CP()
});
function ci(e) {
  return [e("x"), e("y")];
}
function $I({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function F9({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function W9(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function sb(e) {
  return e === void 0 || e === 1;
}
function D0({ scale: e, scaleX: t, scaleY: n }) {
  return !sb(e) || !sb(t) || !sb(n);
}
function ds(e) {
  return D0(e) || DI(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function DI(e) {
  return EP(e.x) || EP(e.y);
}
function EP(e) {
  return e && e !== "0%";
}
function Cp(e, t, n) {
  const r = e - n, i = t * r;
  return n + i;
}
function kP(e, t, n, r, i) {
  return i !== void 0 && (e = Cp(e, i, r)), Cp(e, n, r) + t;
}
function I0(e, t = 0, n = 1, r, i) {
  e.min = kP(e.min, t, n, r, i), e.max = kP(e.max, t, n, r, i);
}
function II(e, { x: t, y: n }) {
  I0(e.x, t.translate, t.scale, t.originPoint), I0(e.y, n.translate, n.scale, n.originPoint);
}
const MP = 0.999999999999, NP = 1.0000000000001;
function z9(e, t, n, r = !1) {
  const i = n.length;
  if (!i)
    return;
  t.x = t.y = 1;
  let o, a;
  for (let s = 0; s < i; s++) {
    o = n[s], a = o.projectionDelta;
    const { visualElement: l } = o.options;
    l && l.props.style && l.props.style.display === "contents" || (r && o.options.layoutScroll && o.scroll && o !== o.root && $l(e, {
      x: -o.scroll.offset.x,
      y: -o.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, II(e, a)), r && ds(o.latestValues) && $l(e, o.latestValues));
  }
  t.x < NP && t.x > MP && (t.x = 1), t.y < NP && t.y > MP && (t.y = 1);
}
function Nl(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function $P(e, t, n, r, i = 0.5) {
  const o = Qt(e.min, e.max, i);
  I0(e, t, n, o, r);
}
function $l(e, t) {
  $P(e.x, t.x, t.scaleX, t.scale, t.originX), $P(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function RI(e, t) {
  return $I(W9(e.getBoundingClientRect(), t));
}
function V9(e, t, n) {
  const r = RI(e, n), { scroll: i } = t;
  return i && (Nl(r.x, i.offset.x), Nl(r.y, i.offset.y)), r;
}
const jI = ({ current: e }) => e ? e.ownerDocument.defaultView : null, U9 = /* @__PURE__ */ new WeakMap();
class H9 {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ln(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (f) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(xg(f, "page").point);
    }, o = (f, d) => {
      const { drag: p, dragPropagation: m, onDragStart: y } = this.getProps();
      if (p && !m && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = EI(p), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ci((v) => {
        let x = this.getAxisMotionValue(v).get() || 0;
        if (Gi.test(x)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const S = w.layout.layoutBox[v];
            S && (x = Kr(S) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[v] = x;
      }), y && Tt.postRender(() => y(f, d)), M0(this.visualElement, "transform");
      const { animationState: g } = this.visualElement;
      g && g.setActive("whileDrag", !0);
    }, a = (f, d) => {
      const { dragPropagation: p, dragDirectionLock: m, onDirectionLock: y, onDrag: g } = this.getProps();
      if (!p && !this.openGlobalLock)
        return;
      const { offset: v } = d;
      if (m && this.currentDirection === null) {
        this.currentDirection = K9(v), this.currentDirection !== null && y && y(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, v), this.updateAxis("y", d.point, v), this.visualElement.render(), g && g(f, d);
    }, s = (f, d) => this.stop(f, d), l = () => ci((f) => {
      var d;
      return this.getAnimationState(f) === "paused" && ((d = this.getAxisMotionValue(f).animation) === null || d === void 0 ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new TI(t, {
      onSessionStart: i,
      onStart: o,
      onMove: a,
      onSessionEnd: s,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: jI(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: o } = this.getProps();
    o && Tt.postRender(() => o(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: i } = this.getProps();
    if (!r || !Mh(t, i, this.currentDirection))
      return;
    const o = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = D9(a, this.constraints[t], this.elastic[t])), o.set(a);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, o = this.constraints;
    n && kl(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = I9(i.layoutBox, n) : this.constraints = !1, this.elastic = B9(r), o !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && ci((a) => {
      this.constraints !== !1 && this.getAxisMotionValue(a) && (this.constraints[a] = L9(i.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !kl(t))
      return !1;
    const r = t.current;
    Fo(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const o = V9(r, i.root, this.visualElement.getTransformPagePoint());
    let a = R9(i.layout.layoutBox, o);
    if (n) {
      const s = n(F9(a));
      this.hasMutatedConstraints = !!s, s && (a = $I(s));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: i, dragTransition: o, dragSnapToOrigin: a, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = ci((f) => {
      if (!Mh(f, n, this.currentDirection))
        return;
      let d = l && l[f] || {};
      a && (d = { min: 0, max: 0 });
      const p = i ? 200 : 1e6, m = i ? 40 : 1e7, y = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: p,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...o,
        ...d
      };
      return this.startAxisValueAnimation(f, y);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return M0(this.visualElement, t), r.start(E1(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    ci((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    ci((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), i = r[n];
    return i || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ci((n) => {
      const { drag: r } = this.getProps();
      if (!Mh(n, r, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, o = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: a, max: s } = i.layout.layoutBox[n];
        o.set(t[n] - Qt(a, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!kl(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    ci((a) => {
      const s = this.getAxisMotionValue(a);
      if (s && this.constraints !== !1) {
        const l = s.get();
        i[a] = j9({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: o } = this.visualElement.getProps();
    this.visualElement.current.style.transform = o ? o({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ci((a) => {
      if (!Mh(a, t, null))
        return;
      const s = this.getAxisMotionValue(a), { min: l, max: c } = this.constraints[a];
      s.set(Qt(l, c, i[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    U9.set(this.visualElement, this);
    const t = this.visualElement.current, n = $o(t, "pointerdown", (l) => {
      const { drag: c, dragListener: f = !0 } = this.getProps();
      c && f && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      kl(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, o = i.addEventListener("measure", r);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), Tt.read(r);
    const a = Ao(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (ci((f) => {
        const d = this.getAxisMotionValue(f);
        d && (this.originPoint[f] += l[f].translate, d.set(d.get() + l[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), o(), s && s();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: i = !1, dragConstraints: o = !1, dragElastic: a = $0, dragMomentum: s = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: i,
      dragConstraints: o,
      dragElastic: a,
      dragMomentum: s
    };
  }
}
function Mh(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function K9(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class G9 extends za {
  constructor(t) {
    super(t), this.removeGroupControls = qn, this.removeListeners = qn, this.controls = new H9(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || qn;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const DP = (e) => (t, n) => {
  e && Tt.postRender(() => e(t, n));
};
class Y9 extends za {
  constructor() {
    super(...arguments), this.removePointerDownListener = qn;
  }
  onPointerDown(t) {
    this.session = new TI(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: jI(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: DP(t),
      onStart: DP(n),
      onMove: r,
      onEnd: (o, a) => {
        delete this.session, i && Tt.postRender(() => i(o, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = $o(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const wg = dt(null);
function q9() {
  const e = Ve(wg);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, i = Kw();
  Xe(() => r(i), []);
  const o = qe(() => n && n(i), [i, n]);
  return !t && n ? [!1, o] : [!0];
}
const yf = dt({}), LI = dt({}), sp = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function IP(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const xu = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Be.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = IP(e, t.target.x), r = IP(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, X9 = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, i = La.parse(e);
    if (i.length > 5)
      return r;
    const o = La.createTransformer(e), a = typeof i[0] != "number" ? 1 : 0, s = n.x.scale * t.x, l = n.y.scale * t.y;
    i[0 + a] /= s, i[1 + a] /= l;
    const c = Qt(s, l, 0.5);
    return typeof i[2 + a] == "number" && (i[2 + a] /= c), typeof i[3 + a] == "number" && (i[3 + a] /= c), o(i);
  }
}, Ep = {};
function Z9(e) {
  Object.assign(Ep, e);
}
const { schedule: D1, cancel: XEe } = FD(queueMicrotask, !1);
class J9 extends Gw {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: i } = this.props, { projection: o } = t;
    Z9(Q9), o && (n.group && n.group.add(o), r && r.register && i && r.register(o), o.root.didUpdate(), o.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), o.setOptions({
      ...o.options,
      onExitComplete: () => this.safeToRemove()
    })), sp.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: i, isPresent: o } = this.props, a = r.projection;
    return a && (a.isPresent = o, i || t.layoutDependency !== n || n === void 0 ? a.willUpdate() : this.safeToRemove(), t.isPresent !== o && (o ? a.promote() : a.relegate() || Tt.postRender(() => {
      const s = a.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), D1.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: i } = t;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), r && r.deregister && r.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function BI(e) {
  const [t, n] = q9(), r = Ve(yf);
  return E(J9, { ...e, layoutGroup: r, switchLayoutGroup: Ve(LI), isPresent: t, safeToRemove: n });
}
const Q9 = {
  borderRadius: {
    ...xu,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: xu,
  borderTopRightRadius: xu,
  borderBottomLeftRadius: xu,
  borderBottomRightRadius: xu,
  boxShadow: X9
}, FI = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], e7 = FI.length, RP = (e) => typeof e == "string" ? parseFloat(e) : e, jP = (e) => typeof e == "number" || Be.test(e);
function t7(e, t, n, r, i, o) {
  i ? (e.opacity = Qt(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    n7(r)
  ), e.opacityExit = Qt(t.opacity !== void 0 ? t.opacity : 1, 0, r7(r))) : o && (e.opacity = Qt(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let a = 0; a < e7; a++) {
    const s = `border${FI[a]}Radius`;
    let l = LP(t, s), c = LP(n, s);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || jP(l) === jP(c) ? (e[s] = Math.max(Qt(RP(l), RP(c), r), 0), (Gi.test(c) || Gi.test(l)) && (e[s] += "%")) : e[s] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = Qt(t.rotate || 0, n.rotate || 0, r));
}
function LP(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const n7 = /* @__PURE__ */ WI(0, 0.5, GD), r7 = /* @__PURE__ */ WI(0.5, 0.95, qn);
function WI(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(Jl(e, t, r));
}
function BP(e, t) {
  e.min = t.min, e.max = t.max;
}
function oi(e, t) {
  BP(e.x, t.x), BP(e.y, t.y);
}
function FP(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function WP(e, t, n, r, i) {
  return e -= t, e = Cp(e, 1 / n, r), i !== void 0 && (e = Cp(e, 1 / i, r)), e;
}
function i7(e, t = 0, n = 1, r = 0.5, i, o = e, a = e) {
  if (Gi.test(t) && (t = parseFloat(t), t = Qt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let s = Qt(o.min, o.max, r);
  e === o && (s -= t), e.min = WP(e.min, t, n, s, i), e.max = WP(e.max, t, n, s, i);
}
function zP(e, t, [n, r, i], o, a) {
  i7(e, t[n], t[r], t[i], t.scale, o, a);
}
const o7 = ["x", "scaleX", "originX"], a7 = ["y", "scaleY", "originY"];
function VP(e, t, n, r) {
  zP(e.x, t, o7, n ? n.x : void 0, r ? r.x : void 0), zP(e.y, t, a7, n ? n.y : void 0, r ? r.y : void 0);
}
function UP(e) {
  return e.translate === 0 && e.scale === 1;
}
function zI(e) {
  return UP(e.x) && UP(e.y);
}
function HP(e, t) {
  return e.min === t.min && e.max === t.max;
}
function s7(e, t) {
  return HP(e.x, t.x) && HP(e.y, t.y);
}
function KP(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function VI(e, t) {
  return KP(e.x, t.x) && KP(e.y, t.y);
}
function GP(e) {
  return Kr(e.x) / Kr(e.y);
}
function YP(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class l7 {
  constructor() {
    this.members = [];
  }
  add(t) {
    k1(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (M1(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((i) => t === i);
    if (n === 0)
      return !1;
    let r;
    for (let i = n; i >= 0; i--) {
      const o = this.members[i];
      if (o.isPresent !== !1) {
        r = o;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: i } = t.options;
      i === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function c7(e, t, n) {
  let r = "";
  const i = e.x.translate / t.x, o = e.y.translate / t.y, a = (n == null ? void 0 : n.z) || 0;
  if ((i || o || a) && (r = `translate3d(${i}px, ${o}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: f, rotateX: d, rotateY: p, skewX: m, skewY: y } = n;
    c && (r = `perspective(${c}px) ${r}`), f && (r += `rotate(${f}deg) `), d && (r += `rotateX(${d}deg) `), p && (r += `rotateY(${p}deg) `), m && (r += `skewX(${m}deg) `), y && (r += `skewY(${y}deg) `);
  }
  const s = e.x.scale * t.x, l = e.y.scale * t.y;
  return (s !== 1 || l !== 1) && (r += `scale(${s}, ${l})`), r || "none";
}
const u7 = (e, t) => e.depth - t.depth;
class f7 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    k1(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    M1(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(u7), this.isDirty = !1, this.children.forEach(t);
  }
}
function lp(e) {
  const t = rr(e) ? e.get() : e;
  return n9(t) ? t.toValue() : t;
}
function d7(e, t) {
  const n = Yi.now(), r = ({ timestamp: i }) => {
    const o = i - n;
    o >= t && (Ra(r), e(o - t));
  };
  return Tt.read(r, !0), () => Ra(r);
}
function h7(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function p7(e, t, n) {
  const r = rr(e) ? e : gf(e);
  return r.start(E1("", r, t, n)), r.animation;
}
const hs = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, Lu = typeof window < "u" && window.MotionDebug !== void 0, lb = ["", "X", "Y", "Z"], m7 = { visibility: "hidden" }, qP = 1e3;
let g7 = 0;
function cb(e, t, n, r) {
  const { latestValues: i } = t;
  i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function UI(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = _I(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: o } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", Tt, !(i || o));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && UI(r);
}
function HI({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
  return class {
    constructor(a = {}, s = t == null ? void 0 : t()) {
      this.id = g7++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Lu && (hs.totalNodes = hs.resolvedTargetDeltas = hs.recalculatedProjection = 0), this.nodes.forEach(b7), this.nodes.forEach(O7), this.nodes.forEach(A7), this.nodes.forEach(x7), Lu && window.MotionDebug.record(hs);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new f7());
    }
    addEventListener(a, s) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new N1()), this.eventHandlers.get(a).add(s);
    }
    notifyListeners(a, ...s) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...s);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, s = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = h7(a), this.instance = a;
      const { layoutId: l, layout: c, visualElement: f } = this.options;
      if (f && !f.current && f.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), s && (c || l) && (this.isLayoutDirty = !0), e) {
        let d;
        const p = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, d && d(), d = d7(p, 250), sp.hasAnimatedSinceResize && (sp.hasAnimatedSinceResize = !1, this.nodes.forEach(ZP));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && f && (l || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: p, hasRelativeTargetChanged: m, layout: y }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const g = this.options.transition || f.getDefaultTransition() || k7, { onLayoutAnimationStart: v, onLayoutAnimationComplete: x } = f.getProps(), w = !this.targetLayout || !VI(this.targetLayout, y) || m, S = !p && m;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || S || p && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(d, S);
          const A = {
            ...m1(g, "layout"),
            onPlay: v,
            onComplete: x
          };
          (f.shouldReduceMotion || this.options.layoutRoot) && (A.delay = 0, A.type = !1), this.startAnimation(A);
        } else
          p || ZP(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = y;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ra(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(T7), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && UI(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const d = this.path[f];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(XP);
        return;
      }
      this.isUpdating || this.nodes.forEach(_7), this.isUpdating = !1, this.nodes.forEach(S7), this.nodes.forEach(y7), this.nodes.forEach(v7), this.clearAllSnapshots();
      const s = Yi.now();
      zn.delta = ja(0, 1e3 / 60, s - zn.timestamp), zn.timestamp = s, zn.isProcessing = !0, eb.update.process(zn), eb.preRender.process(zn), eb.render.process(zn), zn.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, D1.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(w7), this.sharedNodes.forEach(P7);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Tt.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Tt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ln(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (s = !1), s) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !zI(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, f = c !== this.prevTransformTemplateValue;
      a && (s || ds(this.latestValues) || f) && (i(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return a && (l = this.removeTransform(l)), M7(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var a;
      const { visualElement: s } = this.options;
      if (!s)
        return ln();
      const l = s.measureViewportBox();
      if (!(((a = this.scroll) === null || a === void 0 ? void 0 : a.wasRoot) || this.path.some(N7))) {
        const { scroll: f } = this.root;
        f && (Nl(l.x, f.offset.x), Nl(l.y, f.offset.y));
      }
      return l;
    }
    removeElementScroll(a) {
      var s;
      const l = ln();
      if (oi(l, a), !((s = this.scroll) === null || s === void 0) && s.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c], { scroll: d, options: p } = f;
        f !== this.root && d && p.layoutScroll && (d.wasRoot && oi(l, a), Nl(l.x, d.offset.x), Nl(l.y, d.offset.y));
      }
      return l;
    }
    applyTransform(a, s = !1) {
      const l = ln();
      oi(l, a);
      for (let c = 0; c < this.path.length; c++) {
        const f = this.path[c];
        !s && f.options.layoutScroll && f.scroll && f !== f.root && $l(l, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), ds(f.latestValues) && $l(l, f.latestValues);
      }
      return ds(this.latestValues) && $l(l, this.latestValues), l;
    }
    removeTransform(a) {
      const s = ln();
      oi(s, a);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !ds(c.latestValues))
          continue;
        D0(c.latestValues) && c.updateSnapshot();
        const f = ln(), d = c.measurePageBox();
        oi(f, d), VP(s, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, f);
      }
      return ds(this.latestValues) && VP(s, this.latestValues), s;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== zn.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var s;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(a || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: p } = this.options;
      if (!(!this.layout || !(d || p))) {
        if (this.resolvedRelativeTargetAt = zn.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ln(), this.relativeTargetOrigin = ln(), Gu(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), oi(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = ln(), this.targetWithTransforms = ln()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), $9(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : oi(this.target, this.layout.layoutBox), II(this.target, this.targetDelta)) : oi(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const m = this.getClosestProjectingParent();
            m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ln(), this.relativeTargetOrigin = ln(), Gu(this.relativeTargetOrigin, this.target, m.target), oi(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Lu && hs.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || D0(this.parent.latestValues) || DI(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const s = this.getLead(), l = !!this.resumingFrom || this !== s;
      let c = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === zn.timestamp && (c = !1), c)
        return;
      const { layout: f, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(f || d))
        return;
      oi(this.layoutCorrected, this.layout.layoutBox);
      const p = this.treeScale.x, m = this.treeScale.y;
      z9(this.layoutCorrected, this.treeScale, this.path, l), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = ln());
      const { target: y } = s;
      if (!y) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (FP(this.prevProjectionDelta.x, this.projectionDelta.x), FP(this.prevProjectionDelta.y, this.projectionDelta.y)), Ku(this.projectionDelta, this.layoutCorrected, y, this.latestValues), (this.treeScale.x !== p || this.treeScale.y !== m || !YP(this.projectionDelta.x, this.prevProjectionDelta.x) || !YP(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", y)), Lu && hs.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      var s;
      if ((s = this.options.visualElement) === null || s === void 0 || s.scheduleRender(), a) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Ml(), this.projectionDelta = Ml(), this.projectionDeltaWithTransform = Ml();
    }
    setAnimationOrigin(a, s = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, f = { ...this.latestValues }, d = Ml();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const p = ln(), m = l ? l.source : void 0, y = this.layout ? this.layout.source : void 0, g = m !== y, v = this.getStack(), x = !v || v.members.length <= 1, w = !!(g && !x && this.options.crossfade === !0 && !this.path.some(E7));
      this.animationProgress = 0;
      let S;
      this.mixTargetDelta = (A) => {
        const _ = A / 1e3;
        JP(d.x, a.x, _), JP(d.y, a.y, _), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Gu(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), C7(this.relativeTarget, this.relativeTargetOrigin, p, _), S && s7(this.relativeTarget, S) && (this.isProjectionDirty = !1), S || (S = ln()), oi(S, this.relativeTarget)), g && (this.animationValues = f, t7(f, c, this.latestValues, _, w, x)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = _;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ra(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Tt.update(() => {
        sp.hasAnimatedSinceResize = !0, this.currentAnimation = p7(0, qP, {
          ...a,
          onUpdate: (s) => {
            this.mixTargetDelta(s), a.onUpdate && a.onUpdate(s);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(qP), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: s, target: l, layout: c, latestValues: f } = a;
      if (!(!s || !l || !c)) {
        if (this !== a && this.layout && c && KI(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || ln();
          const d = Kr(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + d;
          const p = Kr(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + p;
        }
        oi(s, l), $l(s, f), Ku(this.projectionDeltaWithTransform, this.layoutCorrected, s, f);
      }
    }
    registerSharedNode(a, s) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new l7()), this.sharedNodes.get(a).add(s);
      const c = s.options.initialPromotionConfig;
      s.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: s } = this.options;
      return s ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: s, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let s = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const c = {};
      l.z && cb("z", a, c, this.animationValues);
      for (let f = 0; f < lb.length; f++)
        cb(`rotate${lb[f]}`, a, c, this.animationValues), cb(`skew${lb[f]}`, a, c, this.animationValues);
      a.render();
      for (const f in c)
        a.setStaticValue(f, c[f]), this.animationValues && (this.animationValues[f] = c[f]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var s, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return m7;
      const c = {
        visibility: ""
      }, f = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = lp(a == null ? void 0 : a.pointerEvents) || "", c.transform = f ? f(this.latestValues, "") : "none", c;
      const d = this.getLead();
      if (!this.projectionDelta || !this.layout || !d.target) {
        const g = {};
        return this.options.layoutId && (g.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, g.pointerEvents = lp(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !ds(this.latestValues) && (g.transform = f ? f({}, "") : "none", this.hasProjected = !1), g;
      }
      const p = d.animationValues || d.latestValues;
      this.applyTransformsToTarget(), c.transform = c7(this.projectionDeltaWithTransform, this.treeScale, p), f && (c.transform = f(p, c.transform));
      const { x: m, y } = this.projectionDelta;
      c.transformOrigin = `${m.origin * 100}% ${y.origin * 100}% 0`, d.animationValues ? c.opacity = d === this ? (l = (s = p.opacity) !== null && s !== void 0 ? s : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : c.opacity = d === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const g in Ep) {
        if (p[g] === void 0)
          continue;
        const { correct: v, applyTo: x } = Ep[g], w = c.transform === "none" ? p[g] : v(p[g], d);
        if (x) {
          const S = x.length;
          for (let A = 0; A < S; A++)
            c[x[A]] = w;
        } else
          c[g] = w;
      }
      return this.options.layoutId && (c.pointerEvents = d === this ? lp(a == null ? void 0 : a.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var s;
        return (s = a.currentAnimation) === null || s === void 0 ? void 0 : s.stop();
      }), this.root.nodes.forEach(XP), this.root.sharedNodes.clear();
    }
  };
}
function y7(e) {
  e.updateLayout();
}
function v7(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: i } = e.layout, { animationType: o } = e.options, a = n.source !== e.layout.source;
    o === "size" ? ci((d) => {
      const p = a ? n.measuredBox[d] : n.layoutBox[d], m = Kr(p);
      p.min = r[d].min, p.max = p.min + m;
    }) : KI(o, n.layoutBox, r) && ci((d) => {
      const p = a ? n.measuredBox[d] : n.layoutBox[d], m = Kr(r[d]);
      p.max = p.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[d].max = e.relativeTarget[d].min + m);
    });
    const s = Ml();
    Ku(s, r, n.layoutBox);
    const l = Ml();
    a ? Ku(l, e.applyTransform(i, !0), n.measuredBox) : Ku(l, r, n.layoutBox);
    const c = !zI(s);
    let f = !1;
    if (!e.resumeFrom) {
      const d = e.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: p, layout: m } = d;
        if (p && m) {
          const y = ln();
          Gu(y, n.layoutBox, p.layoutBox);
          const g = ln();
          Gu(g, r, m.layoutBox), VI(y, g) || (f = !0), d.options.layoutRoot && (e.relativeTarget = g, e.relativeTargetOrigin = y, e.relativeParent = d);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function b7(e) {
  Lu && hs.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function x7(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function w7(e) {
  e.clearSnapshot();
}
function XP(e) {
  e.clearMeasurements();
}
function _7(e) {
  e.isLayoutDirty = !1;
}
function S7(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function ZP(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function O7(e) {
  e.resolveTargetDelta();
}
function A7(e) {
  e.calcProjection();
}
function T7(e) {
  e.resetSkewAndRotation();
}
function P7(e) {
  e.removeLeadSnapshot();
}
function JP(e, t, n) {
  e.translate = Qt(t.translate, 0, n), e.scale = Qt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function QP(e, t, n, r) {
  e.min = Qt(t.min, n.min, r), e.max = Qt(t.max, n.max, r);
}
function C7(e, t, n, r) {
  QP(e.x, t.x, n.x, r), QP(e.y, t.y, n.y, r);
}
function E7(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const k7 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, eC = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), tC = eC("applewebkit/") && !eC("chrome/") ? Math.round : qn;
function nC(e) {
  e.min = tC(e.min), e.max = tC(e.max);
}
function M7(e) {
  nC(e.x), nC(e.y);
}
function KI(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !N9(GP(t), GP(n), 0.2);
}
function N7(e) {
  var t;
  return e !== e.root && ((t = e.scroll) === null || t === void 0 ? void 0 : t.wasRoot);
}
const $7 = HI({
  attachResizeListener: (e, t) => Ao(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), ub = {
  current: void 0
}, GI = HI({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!ub.current) {
      const e = new $7({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), ub.current = e;
    }
    return ub.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), D7 = {
  pan: {
    Feature: Y9
  },
  drag: {
    Feature: G9,
    ProjectionNode: GI,
    MeasureLayout: BI
  }
};
function rC(e, t) {
  const n = t ? "pointerenter" : "pointerleave", r = t ? "onHoverStart" : "onHoverEnd", i = (o, a) => {
    if (o.pointerType === "touch" || kI())
      return;
    const s = e.getProps();
    e.animationState && s.whileHover && e.animationState.setActive("whileHover", t);
    const l = s[r];
    l && Tt.postRender(() => l(o, a));
  };
  return $o(e.current, n, i, {
    passive: !e.getProps()[r]
  });
}
class I7 extends za {
  mount() {
    this.unmount = No(rC(this.node, !0), rC(this.node, !1));
  }
  unmount() {
  }
}
class R7 extends za {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = No(Ao(this.node.current, "focus", () => this.onFocus()), Ao(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const YI = (e, t) => t ? e === t ? !0 : YI(e, t.parentElement) : !1;
function fb(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, xg(n));
}
class j7 extends za {
  constructor() {
    super(...arguments), this.removeStartListeners = qn, this.removeEndListeners = qn, this.removeAccessibleListeners = qn, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), o = $o(window, "pointerup", (s, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: f, globalTapTarget: d } = this.node.getProps(), p = !d && !YI(this.node.current, s.target) ? f : c;
        p && Tt.update(() => p(s, l));
      }, {
        passive: !(r.onTap || r.onPointerUp)
      }), a = $o(window, "pointercancel", (s, l) => this.cancelPress(s, l), {
        passive: !(r.onTapCancel || r.onPointerCancel)
      });
      this.removeEndListeners = No(o, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (o) => {
        if (o.key !== "Enter" || this.isPressing)
          return;
        const a = (s) => {
          s.key !== "Enter" || !this.checkPressEnd() || fb("up", (l, c) => {
            const { onTap: f } = this.node.getProps();
            f && Tt.postRender(() => f(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = Ao(this.node.current, "keyup", a), fb("down", (s, l) => {
          this.startPress(s, l);
        });
      }, n = Ao(this.node.current, "keydown", t), r = () => {
        this.isPressing && fb("cancel", (o, a) => this.cancelPress(o, a));
      }, i = Ao(this.node.current, "blur", r);
      this.removeAccessibleListeners = No(n, i);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && Tt.postRender(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !kI();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && Tt.postRender(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = $o(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(t.onTapStart || t.onPointerStart)
    }), r = Ao(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = No(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const R0 = /* @__PURE__ */ new WeakMap(), db = /* @__PURE__ */ new WeakMap(), L7 = (e) => {
  const t = R0.get(e.target);
  t && t(e);
}, B7 = (e) => {
  e.forEach(L7);
};
function F7({ root: e, ...t }) {
  const n = e || document;
  db.has(n) || db.set(n, {});
  const r = db.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(B7, { root: e, ...t })), r[i];
}
function W7(e, t, n) {
  const r = F7(t);
  return R0.set(e, n), r.observe(e), () => {
    R0.delete(e), r.unobserve(e);
  };
}
const z7 = {
  some: 0,
  all: 1
};
class V7 extends za {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: o } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : z7[i]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, o && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: f, onViewportLeave: d } = this.node.getProps(), p = c ? f : d;
      p && p(l);
    };
    return W7(this.node.current, a, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(U7(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function U7({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const H7 = {
  inView: {
    Feature: V7
  },
  tap: {
    Feature: j7
  },
  focus: {
    Feature: R7
  },
  hover: {
    Feature: I7
  }
}, K7 = {
  layout: {
    ProjectionNode: GI,
    MeasureLayout: BI
  }
}, I1 = dt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), _g = dt({}), R1 = typeof window < "u", j1 = R1 ? di : Xe, qI = dt({ strict: !1 });
function G7(e, t, n, r, i) {
  var o, a;
  const { visualElement: s } = Ve(_g), l = Ve(qI), c = Ve(wg), f = Ve(I1).reducedMotion, d = ut();
  r = r || l.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: f
  }));
  const p = d.current, m = Ve(LI);
  p && !p.projection && i && (p.type === "html" || p.type === "svg") && Y7(d.current, n, i, m);
  const y = ut(!1);
  z$(() => {
    p && y.current && p.update(n, c);
  });
  const g = n[wI], v = ut(!!g && !(!((o = window.MotionHandoffIsComplete) === null || o === void 0) && o.call(window, g)) && ((a = window.MotionHasOptimisedAnimation) === null || a === void 0 ? void 0 : a.call(window, g)));
  return j1(() => {
    p && (y.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), D1.render(p.render), v.current && p.animationState && p.animationState.animateChanges());
  }), Xe(() => {
    p && (!v.current && p.animationState && p.animationState.animateChanges(), v.current && (queueMicrotask(() => {
      var x;
      (x = window.MotionHandoffMarkAsComplete) === null || x === void 0 || x.call(window, g);
    }), v.current = !1));
  }), p;
}
function Y7(e, t, n, r) {
  const { layoutId: i, layout: o, drag: a, dragConstraints: s, layoutScroll: l, layoutRoot: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : XI(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: o,
    alwaysMeasureLayout: !!a || s && kl(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof o == "string" ? o : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function XI(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : XI(e.parent);
}
function q7(e, t, n) {
  return qe(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : kl(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function Sg(e) {
  return yg(e.animate) || p1.some((t) => hf(e[t]));
}
function ZI(e) {
  return !!(Sg(e) || e.variants);
}
function X7(e, t) {
  if (Sg(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || hf(n) ? n : void 0,
      animate: hf(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Z7(e) {
  const { initial: t, animate: n } = X7(e, Ve(_g));
  return Fe(() => ({ initial: t, animate: n }), [iC(t), iC(n)]);
}
function iC(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const oC = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Ql = {};
for (const e in oC)
  Ql[e] = {
    isEnabled: (t) => oC[e].some((n) => !!t[n])
  };
function J7(e) {
  for (const t in e)
    Ql[t] = {
      ...Ql[t],
      ...e[t]
    };
}
const Q7 = Symbol.for("motionComponentSymbol");
function eX({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  e && J7(e);
  function o(s, l) {
    let c;
    const f = {
      ...Ve(I1),
      ...s,
      layoutId: tX(s)
    }, { isStatic: d } = f, p = Z7(s), m = r(s, d);
    if (!d && R1) {
      nX(f, e);
      const y = rX(f);
      c = y.MeasureLayout, p.visualElement = G7(i, m, f, t, y.ProjectionNode);
    }
    return he(_g.Provider, { value: p, children: [c && p.visualElement ? E(c, { visualElement: p.visualElement, ...f }) : null, n(i, s, q7(m, p.visualElement, l), m, d, p.visualElement)] });
  }
  const a = Dt(o);
  return a[Q7] = i, a;
}
function tX({ layoutId: e }) {
  const t = Ve(yf).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function nX(e, t) {
  const n = Ve(qI).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Dc(!1, r) : Fo(!1, r);
  }
}
function rX(e) {
  const { drag: t, layout: n } = Ql;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const iX = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function L1(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(iX.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function JI(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const o in n)
    e.style.setProperty(o, n[o]);
}
const QI = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function eR(e, t, n, r) {
  JI(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(QI.has(i) ? i : $1(i), t.attrs[i]);
}
function tR(e, { layout: t, layoutId: n }) {
  return Hs.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Ep[e] || e === "opacity");
}
function B1(e, t, n) {
  var r;
  const { style: i } = e, o = {};
  for (const a in i)
    (rr(i[a]) || t.style && rr(t.style[a]) || tR(a, e) || ((r = n == null ? void 0 : n.getValue(a)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (o[a] = i[a]);
  return o;
}
function nR(e, t, n) {
  const r = B1(e, t, n);
  for (const i in e)
    if (rr(e[i]) || rr(t[i])) {
      const o = fd.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[o] = e[i];
    }
  return r;
}
function F1(e) {
  const t = ut(null);
  return t.current === null && (t.current = e()), t.current;
}
function oX({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, i, o) {
  const a = {
    latestValues: aX(r, i, o, e),
    renderState: t()
  };
  return n && (a.mount = (s) => n(r, s, a)), a;
}
const rR = (e) => (t, n) => {
  const r = Ve(_g), i = Ve(wg), o = () => oX(e, t, r, i);
  return n ? o() : F1(o);
};
function aX(e, t, n, r) {
  const i = {}, o = r(e, {});
  for (const p in o)
    i[p] = lp(o[p]);
  let { initial: a, animate: s } = e;
  const l = Sg(e), c = ZI(e);
  t && c && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), s === void 0 && (s = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || a === !1;
  const d = f ? s : a;
  if (d && typeof d != "boolean" && !yg(d)) {
    const p = Array.isArray(d) ? d : [d];
    for (let m = 0; m < p.length; m++) {
      const y = d1(e, p[m]);
      if (y) {
        const { transitionEnd: g, transition: v, ...x } = y;
        for (const w in x) {
          let S = x[w];
          if (Array.isArray(S)) {
            const A = f ? S.length - 1 : 0;
            S = S[A];
          }
          S !== null && (i[w] = S);
        }
        for (const w in g)
          i[w] = g[w];
      }
    }
  }
  return i;
}
const W1 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), iR = () => ({
  ...W1(),
  attrs: {}
}), oR = (e, t) => t && typeof e == "number" ? t.transform(e) : e, sX = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, lX = fd.length;
function cX(e, t, n) {
  let r = "", i = !0;
  for (let o = 0; o < lX; o++) {
    const a = fd[o], s = e[a];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (a.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const c = oR(s, _1[a]);
      if (!l) {
        i = !1;
        const f = sX[a] || a;
        r += `${f}(${c}) `;
      }
      n && (t[a] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function z1(e, t, n) {
  const { style: r, vars: i, transformOrigin: o } = e;
  let a = !1, s = !1;
  for (const l in t) {
    const c = t[l];
    if (Hs.has(l)) {
      a = !0;
      continue;
    } else if (JD(l)) {
      i[l] = c;
      continue;
    } else {
      const f = oR(c, _1[l]);
      l.startsWith("origin") ? (s = !0, o[l] = f) : r[l] = f;
    }
  }
  if (t.transform || (a || n ? r.transform = cX(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: c = "50%", originZ: f = 0 } = o;
    r.transformOrigin = `${l} ${c} ${f}`;
  }
}
function aC(e, t, n) {
  return typeof e == "string" ? e : Be.transform(t + n * e);
}
function uX(e, t, n) {
  const r = aC(t, e.x, e.width), i = aC(n, e.y, e.height);
  return `${r} ${i}`;
}
const fX = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, dX = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function hX(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const o = i ? fX : dX;
  e[o.offset] = Be.transform(-r);
  const a = Be.transform(t), s = Be.transform(n);
  e[o.array] = `${a} ${s}`;
}
function V1(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: i,
  originY: o,
  pathLength: a,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, f, d) {
  if (z1(e, c, d), f) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: m, dimensions: y } = e;
  p.transform && (y && (m.transform = p.transform), delete p.transform), y && (i !== void 0 || o !== void 0 || m.transform) && (m.transformOrigin = uX(y, i !== void 0 ? i : 0.5, o !== void 0 ? o : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), a !== void 0 && hX(p, a, s, l, !1);
}
const U1 = (e) => typeof e == "string" && e.toLowerCase() === "svg", pX = {
  useVisualState: rR({
    scrapeMotionValuesFromProps: nR,
    createRenderState: iR,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      Tt.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), Tt.render(() => {
        V1(n, r, U1(t.tagName), e.transformTemplate), eR(t, n);
      });
    }
  })
}, mX = {
  useVisualState: rR({
    scrapeMotionValuesFromProps: B1,
    createRenderState: W1
  })
};
function aR(e, t, n) {
  for (const r in t)
    !rr(t[r]) && !tR(r, n) && (e[r] = t[r]);
}
function gX({ transformTemplate: e }, t) {
  return Fe(() => {
    const n = W1();
    return z1(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function yX(e, t) {
  const n = e.style || {}, r = {};
  return aR(r, n, e), Object.assign(r, gX(e, t)), r;
}
function vX(e, t) {
  const n = {}, r = yX(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const bX = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function kp(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || bX.has(e);
}
let sR = (e) => !kp(e);
function xX(e) {
  e && (sR = (t) => t.startsWith("on") ? !kp(t) : e(t));
}
try {
  xX(require("@emotion/is-prop-valid").default);
} catch {
}
function wX(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (sR(i) || n === !0 && kp(i) || !t && !kp(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function _X(e, t, n, r) {
  const i = Fe(() => {
    const o = iR();
    return V1(o, t, U1(r), e.transformTemplate), {
      ...o.attrs,
      style: { ...o.style }
    };
  }, [t]);
  if (e.style) {
    const o = {};
    aR(o, e.style, e), i.style = { ...o, ...i.style };
  }
  return i;
}
function SX(e = !1) {
  return (n, r, i, { latestValues: o }, a) => {
    const l = (L1(n) ? _X : vX)(r, o, a, n), c = wX(r, typeof n == "string", e), f = n !== Ur ? { ...c, ...l, ref: i } : {}, { children: d } = r, p = Fe(() => rr(d) ? d.get() : d, [d]);
    return ql(n, {
      ...f,
      children: p
    });
  };
}
function OX(e, t) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const a = {
      ...L1(r) ? pX : mX,
      preloadedFeatures: e,
      useRender: SX(i),
      createVisualElement: t,
      Component: r
    };
    return eX(a);
  };
}
const j0 = { current: null }, lR = { current: !1 };
function AX() {
  if (lR.current = !0, !!R1)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => j0.current = e.matches;
      e.addListener(t), t();
    } else
      j0.current = !1;
}
function TX(e, t, n) {
  for (const r in t) {
    const i = t[r], o = n[r];
    if (rr(i))
      e.addValue(r, i), process.env.NODE_ENV === "development" && gg(i.version === "11.11.17", `Attempting to mix Motion versions ${i.version} with 11.11.17 may not work as expected.`);
    else if (rr(o))
      e.addValue(r, gf(i, { owner: e }));
    else if (o !== i)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(i) : a.hasAnimated || a.set(i);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, gf(a !== void 0 ? a : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const sC = /* @__PURE__ */ new WeakMap(), PX = [...tI, er, La], CX = (e) => PX.find(eI(e)), lC = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class EX {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: o, visualState: a }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = b1, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = Yi.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, Tt.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = a;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!o, this.isControllingVariants = Sg(n), this.isVariantNode = ZI(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in d) {
      const m = d[p];
      l[p] !== void 0 && rr(m) && m.set(l[p], !1);
    }
  }
  mount(t) {
    this.current = t, sC.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), lR.current || AX(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : j0.current, process.env.NODE_ENV !== "production" && gg(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    sC.delete(this.current), this.projection && this.projection.unmount(), Ra(this.notifyUpdate), Ra(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Hs.has(t), i = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && Tt.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), o = n.on("renderRequest", this.scheduleRender);
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), o(), a && a(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Ql) {
      const n = Ql[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const o = this.features[t];
        o.isMounted ? o.update() : (o.mount(), o.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ln();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < lC.length; r++) {
      const i = lC[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const o = "on" + i, a = t[o];
      a && (this.propEventSubscriptions[i] = this.on(i, a));
    }
    this.prevMotionValues = TX(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = gf(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let i = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return i != null && (typeof i == "string" && (XD(i) || qD(i)) ? i = parseFloat(i) : !CX(i) && La.test(n) && (i = cI(t, n)), this.setBaseTarget(t, rr(i) ? i.get() : i)), rr(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let i;
    if (typeof r == "string" || typeof r == "object") {
      const a = d1(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      a && (i = a[t]);
    }
    if (r && i !== void 0)
      return i;
    const o = this.getBaseTargetFromProps(this.props, t);
    return o !== void 0 && !rr(o) ? o : this.initialValues[t] !== void 0 && i === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new N1()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class cR extends EX {
  constructor() {
    super(...arguments), this.KeyframeResolver = uI;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
}
function kX(e) {
  return window.getComputedStyle(e);
}
class MX extends cR {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = JI;
  }
  readValueFromInstance(t, n) {
    if (Hs.has(n)) {
      const r = S1(n);
      return r && r.default || 0;
    } else {
      const r = kX(t), i = (JD(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return RI(t, n);
  }
  build(t, n, r) {
    z1(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return B1(t, n, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    rr(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class NX extends cR {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ln;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Hs.has(n)) {
      const r = S1(n);
      return r && r.default || 0;
    }
    return n = QI.has(n) ? n : $1(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return nR(t, n, r);
  }
  build(t, n, r) {
    V1(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, i) {
    eR(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = U1(t.tagName), super.mount(t);
  }
}
const $X = (e, t) => L1(e) ? new NX(t) : new MX(t, {
  allowProjection: e !== Ur
}), DX = /* @__PURE__ */ OX({
  ...S9,
  ...H7,
  ...D7,
  ...K7
}, $X), An = /* @__PURE__ */ pY(DX);
class IX extends te.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function RX({ children: e, isPresent: t }) {
  const n = Kw(), r = ut(null), i = ut({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: o } = Ve(I1);
  return z$(() => {
    const { width: a, height: s, top: l, left: c } = i.current;
    if (t || !r.current || !a || !s)
      return;
    r.current.dataset.motionPopId = n;
    const f = document.createElement("style");
    return o && (f.nonce = o), document.head.appendChild(f), f.sheet && f.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${s}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(f);
    };
  }, [t]), E(IX, { isPresent: t, childRef: r, sizeRef: i, children: te.cloneElement(e, { ref: r }) });
}
const jX = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: i, presenceAffectsLayout: o, mode: a }) => {
  const s = F1(LX), l = Kw(), c = qe((d) => {
    s.set(d, !0);
    for (const p of s.values())
      if (!p)
        return;
    r && r();
  }, [s, r]), f = Fe(
    () => ({
      id: l,
      initial: t,
      isPresent: n,
      custom: i,
      onExitComplete: c,
      register: (d) => (s.set(d, !1), () => s.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    o ? [Math.random(), c] : [n, c]
  );
  return Fe(() => {
    s.forEach((d, p) => s.set(p, !1));
  }, [n]), te.useEffect(() => {
    !n && !s.size && r && r();
  }, [n]), a === "popLayout" && (e = E(RX, { isPresent: n, children: e })), E(wg.Provider, { value: f, children: e });
};
function LX() {
  return /* @__PURE__ */ new Map();
}
const Nh = (e) => e.key || "";
function cC(e) {
  const t = [];
  return Yt.forEach(e, (n) => {
    rt(n) && t.push(n);
  }), t;
}
const Ks = ({ children: e, exitBeforeEnter: t, custom: n, initial: r = !0, onExitComplete: i, presenceAffectsLayout: o = !0, mode: a = "sync" }) => {
  Fo(!t, "Replace exitBeforeEnter with mode='wait'");
  const s = Fe(() => cC(e), [e]), l = s.map(Nh), c = ut(!0), f = ut(s), d = F1(() => /* @__PURE__ */ new Map()), [p, m] = Me(s), [y, g] = Me(s);
  j1(() => {
    c.current = !1, f.current = s;
    for (let w = 0; w < y.length; w++) {
      const S = Nh(y[w]);
      l.includes(S) ? d.delete(S) : d.get(S) !== !0 && d.set(S, !1);
    }
  }, [y, l.length, l.join("-")]);
  const v = [];
  if (s !== p) {
    let w = [...s];
    for (let S = 0; S < y.length; S++) {
      const A = y[S], _ = Nh(A);
      l.includes(_) || (w.splice(S, 0, A), v.push(A));
    }
    a === "wait" && v.length && (w = v), g(cC(w)), m(s);
    return;
  }
  process.env.NODE_ENV !== "production" && a === "wait" && y.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: x } = Ve(yf);
  return E(Ut, { children: y.map((w) => {
    const S = Nh(w), A = s === y || l.includes(S), _ = () => {
      if (d.has(S))
        d.set(S, !0);
      else
        return;
      let O = !0;
      d.forEach((P) => {
        P || (O = !1);
      }), O && (x == null || x(), g(f.current), i && i());
    };
    return E(jX, { isPresent: A, initial: !c.current || r ? void 0 : !1, custom: A ? void 0 : n, presenceAffectsLayout: o, mode: a, onExitComplete: A ? void 0 : _, children: w }, S);
  }) });
}, BX = dt(null);
function FX() {
  const e = ut(!1);
  return j1(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function WX() {
  const e = FX(), [t, n] = Me(0), r = qe(() => {
    e.current && n(t + 1);
  }, [t]);
  return [qe(() => Tt.postRender(r), [r]), t];
}
const zX = (e) => !e.isLayoutDirty && e.willUpdate(!1);
function uC() {
  const e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new WeakMap(), n = () => e.forEach(zX);
  return {
    add: (r) => {
      e.add(r), t.set(r, r.addEventListener("willUpdate", n));
    },
    remove: (r) => {
      e.delete(r);
      const i = t.get(r);
      i && (i(), t.delete(r)), n();
    },
    dirty: n
  };
}
const uR = (e) => e === !0, VX = (e) => uR(e === !0) || e === "id", UX = ({ children: e, id: t, inherit: n = !0 }) => {
  const r = Ve(yf), i = Ve(BX), [o, a] = WX(), s = ut(null), l = r.id || i;
  s.current === null && (VX(n) && l && (t = t ? l + "-" + t : l), s.current = {
    id: t,
    group: uR(n) && r.group || uC()
  });
  const c = Fe(() => ({ ...s.current, forceRender: o }), [a]);
  return E(yf.Provider, { value: c, children: e });
}, HX = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
};
function KX(...e) {
  const t = ut(0), [n, r] = Me(e[t.current]), i = qe(
    (o) => {
      t.current = typeof o != "number" ? HX(0, e.length, t.current + 1) : o, r(e[t.current]);
    },
    // The array will change on each call, but by putting items.length at
    // the front of this array, we guarantee the dependency comparison will match up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e.length, ...e]
  );
  return [n, i];
}
const fR = dt({}), dR = () => Ve(fR), hR = dt(null), GX = () => Ve(hR), pR = ({
  children: e,
  activeItem: t = null,
  // The currently active item in the group.
  onChange: n,
  // Callback when the active item changes.
  className: r,
  // Additional class names for styling.
  size: i = "sm",
  // Size of the tabs in the group ('xs', 'sm', 'md', 'lg').
  orientation: o = "horizontal",
  // Orientation of the tabs ('horizontal', 'vertical').
  variant: a = "pill",
  // Style variant of the tabs ('pill', 'rounded', 'underline').
  iconPosition: s = "left",
  // Position of the icon in the tab ('left' or 'right').
  width: l = "full"
  // Width of the tabs ('auto' or 'full').
}) => {
  const c = ro(), f = dR(), d = (f == null ? void 0 : f.activeItem) || t, p = qe(
    (O, P) => {
      n && n({ event: O, value: P });
    },
    [n]
  );
  let m = "rounded-full", y = "p-1", g, v = "ring-1 ring-tab-border";
  o === "vertical" ? g = "gap-0.5" : (a === "rounded" || a === "pill") && (i === "xs" || i === "sm" ? g = "gap-0.5" : (i === "md" || i === "lg") && (g = "gap-1")), a === "rounded" || o === "vertical" ? m = "rounded-md" : a === "underline" && (m = "rounded-none", y = "p-0", v = "border-t-0 border-r-0 border-l-0 border-b border-solid border-tab-border", i === "xs" ? g = "gap-0" : i === "sm" ? g = "gap-2.5" : (i === "md" || i === "lg") && (g = "gap-3"));
  const _ = K(
    `box-border [&>*]:box-border flex items-center ${l === "full" ? "w-full" : ""} ${o === "vertical" ? "flex-col" : ""}`,
    m,
    y,
    g,
    v,
    a !== "underline" ? "bg-tab-background" : "",
    r
  );
  return /* @__PURE__ */ E("div", { className: _, children: /* @__PURE__ */ E(
    hR.Provider,
    {
      value: {
        activeItem: d,
        onChange: p,
        size: i,
        variant: a,
        orientation: o,
        iconPosition: s,
        width: l
      },
      children: /* @__PURE__ */ E(UX, { id: c, children: I.Children.map(e, (O) => rt(O) ? I.cloneElement(O) : null) })
    }
  ) });
};
pR.displayName = "Tabs.Group";
const mR = Dt(
  ({
    slug: e,
    text: t,
    icon: n,
    className: r,
    disabled: i = !1,
    badge: o = null,
    ...a
  }, s) => {
    const l = GX();
    if (!l)
      throw new Error("Tab should be used inside Tabs Group");
    const {
      activeItem: c,
      onChange: f,
      size: d,
      variant: p,
      orientation: m,
      iconPosition: y,
      width: g
    } = l, v = {
      xs: "px-1.5 py-0.5 text-xs [&_svg]:size-3",
      sm: p === "underline" ? "py-1.5 text-sm [&_svg]:size-4" : "px-3 py-1.5 text-sm [&_svg]:size-4",
      md: p === "underline" ? "py-2 text-base [&_svg]:size-5" : "px-3.5 py-1.5 text-base [&_svg]:size-5",
      lg: p === "underline" ? "p-2.5 text-lg [&_svg]:size-6" : "px-3.5 py-1.5 text-lg [&_svg]:size-6"
    }[d], S = K(
      "relative border-none bg-transparent text-text-secondary cursor-pointer flex items-center justify-center transition-[box-shadow,color,background-color] duration-200",
      g === "full" ? "flex-1" : "",
      m === "vertical" ? "w-full justify-between" : ""
    ), A = "border-none";
    let _ = "rounded-full";
    p === "rounded" ? _ = "rounded-md" : p === "underline" && (_ = "rounded-none");
    const D = K(
      S,
      A,
      _,
      "hover:text-text-primary group",
      "focus:outline-none",
      v,
      c === e ? "bg-background-primary text-text-primary shadow-sm" : "",
      i ? "text-text-disabled cursor-not-allowed hover:text-text-disabled" : "",
      r
    ), $ = K(
      "flex items-center gap-1 group-hover:text-text-primary",
      i && "group-hover:text-text-disabled"
    ), N = (R) => {
      f(R, { slug: e, text: t });
    };
    return /* @__PURE__ */ he(
      An.button,
      {
        ref: s,
        className: D,
        disabled: i,
        onClick: N,
        ...a,
        layoutRoot: !0,
        children: [
          c === e && p === "underline" && /* @__PURE__ */ E(
            An.span,
            {
              layoutId: "underline",
              layoutDependency: c,
              className: "absolute right-0 left-0 -bottom-px h-px bg-border-interactive"
            }
          ),
          /* @__PURE__ */ he("span", { className: $, children: [
            y === "left" && n && /* @__PURE__ */ E("span", { className: "mr-1 contents center-center transition duration-150", children: n }),
            t,
            y === "right" && n && /* @__PURE__ */ E("span", { className: "ml-1 contents center-center transition duration-150", children: n })
          ] }),
          o && rt(o) && o
        ]
      }
    );
  }
);
mR.displayName = "Tabs.Tab";
const H1 = ({ activeItem: e, children: t }) => /* @__PURE__ */ E(fR.Provider, { value: { activeItem: e }, children: t }), gR = ({ slug: e, children: t }) => {
  const n = dR();
  if (!n)
    throw new Error("TabPanel should be used inside Tabs");
  return e === n.activeItem ? /* @__PURE__ */ E(Ut, { children: t }) : null;
};
gR.displayName = "Tabs.Panel";
H1.Group = pR;
H1.Tab = mR;
H1.Panel = gR;
const Pi = {
  sm: {
    icon: "[&>svg]:size-4",
    searchIcon: "[&>svg]:size-4",
    selectButton: "px-2.5 py-2 rounded text-sm font-medium leading-4 min-h-[2rem]",
    multiSelect: "pl-2 pr-2 py-1.5",
    displaySelected: "text-sm font-normal",
    dropdown: "rounded-md",
    dropdownItemsWrapper: "p-1.5",
    searchbarWrapper: "p-3 flex items-center gap-0.5",
    searchbar: "font-medium text-sm",
    searchbarIcon: "size-4",
    label: "text-sm font-medium"
  },
  md: {
    icon: "[&>svg]:size-5",
    searchIcon: "[&>svg]:size-5",
    selectButton: "px-3.5 py-2.5 rounded-md text-xs font-medium leading-4 min-h-[2.5rem]",
    multiSelect: "pl-2 pr-2.5 py-2",
    displaySelected: "text-sm font-normal",
    dropdown: "rounded-lg",
    dropdownItemsWrapper: "p-2",
    searchbarWrapper: "p-2.5 flex items-center gap-1",
    searchbar: "font-medium text-sm",
    searchbarIcon: "size-5",
    label: "text-sm font-medium"
  },
  lg: {
    icon: "[&>svg]:size-6",
    searchIcon: "[&>svg]:size-5",
    selectButton: "px-4 py-3 rounded-lg text-sm font-medium leading-5 min-h-[3rem]",
    multiSelect: "pl-2.5 pr-3 py-2.5",
    displaySelected: "text-base font-normal",
    dropdown: "rounded-lg",
    dropdownItemsWrapper: "p-2",
    searchbarWrapper: "p-2.5 flex items-center gap-1",
    searchbar: "font-medium text-sm",
    searchbarIcon: "size-5",
    label: "text-base font-medium"
  }
}, $h = {
  selectButton: "group disabled:outline-field-border-disabled [&:hover:has(:disabled)]:outline-field-border-disabled disabled:cursor-default",
  icon: "group-disabled:text-icon-disabled",
  text: "group-disabled:text-field-color-disabled"
}, YX = "h-px my-2 w-full border-border-subtle border-b border-t-0 border-solid", qX = {
  sm: "w-[calc(100%+0.75rem)] translate-x-[-0.375rem]",
  md: "w-[calc(100%+1rem)] translate-x-[-0.5rem]",
  lg: "w-[calc(100%+1rem)] translate-x-[-0.5rem]"
}, cp = (e) => {
  var t;
  return typeof e == "string" ? e : typeof e == "object" && "textContent" in e ? ((t = e.textContent) == null ? void 0 : t.toString().toLowerCase()) || "" : typeof e == "object" && "children" in e ? cp(e.children) : "";
}, yR = dt(
  {}
), Og = () => Ve(yR);
function vR({
  children: e,
  icon: t = null,
  // Icon to show in the select button.
  placeholder: n = "Select an option",
  // Placeholder text.
  optionIcon: r = null,
  // Icon to show in the selected option.
  render: i,
  label: o,
  // Label for the select component.
  className: a,
  ...s
}) {
  var k, D;
  const {
    sizeValue: l,
    getReferenceProps: c,
    getValues: f,
    selectId: d,
    refs: p,
    isOpen: m,
    multiple: y,
    combobox: g,
    setSelected: v,
    onChange: x,
    isControlled: w,
    disabled: S,
    by: A
  } = Og(), _ = {
    sm: "xs",
    md: "sm",
    lg: "md"
  }[l], O = qe(() => {
    if (t)
      return t;
    const $ = "text-field-placeholder " + $h.icon;
    return g ? /* @__PURE__ */ E(YH, { className: $ }) : /* @__PURE__ */ E(Xw, { className: $ });
  }, [t]), P = qe(() => {
    const $ = f();
    if (!$)
      return null;
    if (y)
      return $.map(
        (R, L) => /* @__PURE__ */ E(
          mg,
          {
            className: "cursor-default",
            icon: r,
            type: "rounded",
            size: _,
            onMouseDown: C(R),
            label: typeof i == "function" ? i(R) : R.toString(),
            closable: !0,
            disabled: S
          },
          L
        )
      );
    let N = typeof $ == "string" ? $ : "";
    if (typeof i == "function" && (N = i($)), typeof e == "function" && typeof i != "function") {
      const R = {
        value: $,
        ...y ? {
          onClose: C(
            $
          )
        } : {}
      };
      N = e(R);
    }
    return (rt(e) || typeof e == "string") && typeof i != "function" && (N = e), /* @__PURE__ */ E(
      "span",
      {
        className: K(
          "truncate",
          Pi[l].displaySelected,
          $h.text
        ),
        children: N
      }
    );
  }, [f, S]), C = ($) => (N) => {
    N == null || N.preventDefault(), N == null || N.stopPropagation();
    const R = [
      ...f() ?? []
    ], L = R.findIndex((F) => F !== null && $ !== null && typeof F == "object" ? F[A] === $[A] : F === $);
    L !== -1 && (R.splice(L, 1), w || v(R), typeof x == "function" && x(R));
  };
  return /* @__PURE__ */ he("div", { className: "w-full flex flex-col items-start gap-1.5 [&_*]:box-border box-border", children: [
    !!o && /* @__PURE__ */ E(
      "label",
      {
        className: K(
          (k = Pi[l]) == null ? void 0 : k.label,
          "text-field-label"
        ),
        htmlFor: d,
        children: o
      }
    ),
    /* @__PURE__ */ he(
      "button",
      {
        id: d,
        ref: p.setReference,
        className: K(
          "flex items-center justify-between w-full box-border transition-[outline,background-color,color,box-shadow] duration-200 bg-white",
          "outline outline-1 outline-field-border border-none cursor-pointer",
          !m && "focus:ring-2 focus:ring-offset-2 focus:outline-focus-border focus:ring-focus [&:hover:not(:focus):not(:disabled)]:outline-border-strong",
          Pi[l].selectButton,
          y && Pi[l].multiSelect,
          $h.selectButton,
          a
        ),
        tabIndex: 0,
        disabled: S,
        ...s,
        ...c(),
        children: [
          /* @__PURE__ */ he(
            "div",
            {
              className: K(
                "flex-1 grid items-center justify-start gap-1.5 overflow-hidden",
                f() && "flex flex-wrap"
              ),
              children: [
                P(),
                (y ? !((D = f()) != null && D.length) : !f()) && /* @__PURE__ */ E(
                  "div",
                  {
                    className: K(
                      "[grid-area:1/1/2/3] text-field-input px-1",
                      Pi[l].displaySelected,
                      $h.text
                    ),
                    children: n
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ E(
            "div",
            {
              className: K(
                "flex items-center [&>svg]:shrink-0",
                Pi[l].icon
              ),
              children: O()
            }
          )
        ]
      }
    )
  ] });
}
function Dl({
  label: e,
  children: t,
  className: n,
  ...r
}) {
  const { index: i, totalGroups: o } = r, { sizeValue: a } = Og();
  return /* @__PURE__ */ he(Ur, { children: [
    /* @__PURE__ */ he("div", { className: "flex flex-col", role: "group", "aria-label": e, children: [
      /* @__PURE__ */ E(
        "div",
        {
          className: K(
            "p-2 font-normal text-text-tertiary",
            {
              sm: "text-xs",
              md: "text-xs",
              lg: "text-sm"
            }[a],
            n
          ),
          id: `group-${e == null ? void 0 : e.toLowerCase().replace(/\s+/g, "-")}`,
          children: e
        }
      ),
      /* @__PURE__ */ E(
        "div",
        {
          className: "flex flex-col",
          role: "presentation",
          "aria-labelledby": `group-${e == null ? void 0 : e.toLowerCase().replace(/\s+/g, "-")}`,
          children: t
        }
      )
    ] }),
    i < o && !!(t && Yt.count(t) > 0) && /* @__PURE__ */ E(
      "hr",
      {
        className: K(
          YX,
          qX[a]
        )
      }
    )
  ] });
}
function bR({
  children: e,
  className: t
  // Additional class name for the dropdown.
}) {
  const {
    isOpen: n,
    context: r,
    refs: i,
    combobox: o,
    floatingStyles: a,
    getFloatingProps: s,
    sizeValue: l,
    setSearchKeyword: c,
    setActiveIndex: f,
    setSelectedIndex: d,
    value: p,
    selected: m,
    getValues: y,
    searchKeyword: g,
    listContentRef: v,
    by: x,
    searchPlaceholder: w,
    activeIndex: S
  } = Og(), A = Fe(() => {
    const P = y();
    let C = -1;
    if (P) {
      let k = Yt.toArray(e);
      k.length > 0 && rt(k[0]) && k[0].type === Dl && (k = Yt.toArray(e).map(
        (D) => rt(D) ? Yt.toArray(D.props.children) : []
      ).flat()), C = k.findIndex((D) => {
        if (!rt(D))
          return !1;
        const $ = D.props.value;
        return typeof $ == "object" && typeof P == "object" ? $[x] === P[x] : $ === P;
      });
    }
    return C;
  }, [p, m, e, x]);
  di(() => {
    n || (f(A), d(A));
  }, [A, n]), di(() => {
    n && (o && [-1, null].includes(S) || f(-1));
  }, [g, n]);
  const _ = Fe(() => {
    let P = 0, C = 0;
    Yt.forEach(e, (N) => {
      rt(N) && N.type === Dl && Yt.toArray(
        N.props.children
      ).some((L) => {
        var F;
        if (!rt(L))
          return !1;
        if (g) {
          const W = (F = cp(
            L.props.children
          )) == null ? void 0 : F.toLowerCase(), z = g.toLowerCase();
          return W.includes(z);
        }
        return !0;
      }) && P++;
    }), C = Math.max(0, P - 1);
    let k = 0, D = 0;
    const $ = (N) => {
      var R, L;
      if (!rt(N))
        return null;
      if (N.type === Dl) {
        const F = Yt.map(
          N.props.children,
          $
        );
        if (!(F == null ? void 0 : F.some((G) => G !== null)))
          return null;
        const z = {
          ...N.props,
          children: F,
          index: D,
          totalGroups: C
        };
        return D++, ht(N, z);
      }
      if (g) {
        const F = (L = cp(
          (R = N.props) == null ? void 0 : R.children
        )) == null ? void 0 : L.toLowerCase(), W = g.toLowerCase();
        if (!(F == null ? void 0 : F.includes(W)))
          return null;
      }
      return ht(N, {
        ...N.props,
        index: k++
      });
    };
    return Yt.map(e, $);
  }, [g, p, m, e]), O = Yt.count(_);
  return Xe(() => {
    v.current = [];
    let P = Yt.toArray(e);
    P && rt(P[0]) && P[0].type === Dl && (P = Yt.toArray(P).map(
      (C) => rt(C) ? C.props.children : null
    ).filter(Boolean)), Yt.forEach(P, (C) => {
      var D, $;
      if (!rt(C))
        return;
      const k = ($ = cp(
        (D = C.props) == null ? void 0 : D.children
      )) == null ? void 0 : $.toLowerCase();
      if (g) {
        const N = g.toLowerCase();
        if (!(k == null ? void 0 : k.includes(N)))
          return;
      }
      v.current.push(k);
    });
  }, [g]), /* @__PURE__ */ E(Ut, { children: n && /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(HG, { context: r, modal: !1, children: /* @__PURE__ */ he(
    "div",
    {
      ref: i.setFloating,
      className: K(
        "box-border [&_*]:box-border w-full bg-white outline-none shadow-lg outline outline-1 outline-border-subtle",
        o && "grid grid-cols-1 grid-rows-[auto_1fr] divide-y divide-x-0 divide-solid divide-border-subtle",
        Pi[l].dropdown,
        !o && "h-auto",
        o ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden",
        t
      ),
      style: {
        ...a
      },
      ...s(),
      children: [
        o && /* @__PURE__ */ he(
          "div",
          {
            className: K(
              Pi[l].searchbarWrapper
            ),
            children: [
              /* @__PURE__ */ E(
                nD,
                {
                  className: K(
                    "text-icon-secondary shrink-0",
                    Pi[l].searchbarIcon
                  )
                }
              ),
              /* @__PURE__ */ E(
                "input",
                {
                  className: K(
                    "px-1 w-full placeholder:text-field-placeholder border-0 focus:outline-none focus:shadow-none",
                    Pi[l].searchbar
                  ),
                  type: "search",
                  name: "keyword",
                  placeholder: w,
                  onChange: (P) => c(P.target.value),
                  value: g,
                  autoComplete: "off"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ he(
          "div",
          {
            className: K(
              "overflow-y-auto overflow-x-hidden",
              !o && "w-full h-full",
              Pi[l].dropdownItemsWrapper
            ),
            children: [
              !!O && _,
              !O && /* @__PURE__ */ E("div", { className: "p-2 text-center text-base font-medium text-field-placeholder", children: "No items found" })
            ]
          }
        )
      ]
    }
  ) }) }) });
}
function xR({ children: e, root: t, id: n }) {
  return /* @__PURE__ */ E(ug, { id: n, root: t, children: e });
}
function wR({
  value: e,
  selected: t,
  children: n,
  className: r,
  ...i
}) {
  const {
    sizeValue: o,
    getItemProps: a,
    onKeyDownItem: s,
    onClickItem: l,
    activeIndex: c,
    selectedIndex: f,
    updateListRef: d,
    getValues: p,
    by: m,
    multiple: y
  } = Og(), { index: g } = i, v = ut(g), x = {
    sm: "py-1.5 px-2 text-sm font-normal",
    md: "p-2 text-sm font-normal",
    lg: "p-2 text-base font-normal"
  }, w = {
    sm: "size-4",
    md: "size-4",
    lg: "size-5"
  }, S = Fe(() => {
    if (!y)
      return !1;
    const _ = p();
    return _ ? _.some((O) => O !== null && e !== null && typeof O == "object" ? O[m] === e[m] : O === e) : !1;
  }, [e, p]), A = Fe(() => typeof t == "boolean" ? t : y ? S : g === f, [S, f, t]);
  return /* @__PURE__ */ he(
    "div",
    {
      className: K(
        "w-full flex items-center justify-between text-text-primary hover:bg-button-tertiary-hover rounded-md transition-all duration-150 cursor-pointer focus:outline-none focus-within:outline-none outline-none",
        x[o],
        g === c && "bg-button-tertiary-hover",
        r
      ),
      ref: (_) => {
        d(g, _);
      },
      role: "option",
      tabIndex: g === c ? 0 : -1,
      "aria-selected": A && g === c,
      ...a({
        // Handle pointer select.
        onClick() {
          l(v.current, e);
        },
        // Handle keyboard select.
        onKeyDown(_) {
          s(
            _,
            v.current,
            e
          );
        }
      }),
      children: [
        /* @__PURE__ */ E("span", { className: "w-full truncate", children: n }),
        A && /* @__PURE__ */ E(
          ad,
          {
            className: K(
              "text-icon-on-color-disabled",
              w[o]
            )
          }
        )
      ]
    }
  );
}
const pd = ({
  id: e,
  size: t = "md",
  // sm, md, lg
  value: n,
  // Value of the select (for controlled component).
  defaultValue: r,
  // Default value of the select (for uncontrolled component).
  onChange: i,
  // Callback function to handle the change event.
  by: o = "id",
  // Used to identify the select component. Default is 'id'.
  children: a,
  multiple: s = !1,
  // If true, it will allow multiple selection.
  combobox: l = !1,
  // If true, it will show a search box.
  disabled: c = !1,
  // If true, it will disable the select component.
  searchPlaceholder: f = "Search..."
  // Placeholder text for search box.
}) => {
  const d = Fe(() => e || `select-${ro()}`, [e]), p = Fe(() => typeof n < "u", [n]), [m, y] = Me(r), [g, v] = Me(""), x = qe(() => p ? n : m, [p, n, m]), [w, S] = Me(!1), [A, _] = Me(null), [O, P] = Me(null), C = {
    sm: l ? 256 : 172,
    md: l ? 256 : 216,
    lg: l ? 256 : 216
  }, { refs: k, floatingStyles: D, context: $ } = dg({
    placement: "bottom-start",
    open: w,
    onOpenChange: S,
    whileElementsMounted: ig,
    middleware: [
      og(5),
      ag({ padding: 10 }),
      _D({
        apply({ rects: ne, elements: J, availableHeight: fe }) {
          Object.assign(J.floating.style, {
            maxHeight: `min(${fe}px, ${C[t]}px)`,
            maxWidth: `${ne.reference.width}px`
          });
        },
        padding: 10
      })
    ]
  }), N = ut([]), R = ut([]), L = ut(!1), F = c1($, { event: "mousedown" }), W = fg($), z = u1($, { role: "listbox" }), G = ZG($, {
    listRef: N,
    activeIndex: A,
    selectedIndex: O,
    onNavigate: _,
    // This is a large list, allow looping.
    loop: !0
  }), U = tY($, {
    listRef: R,
    activeIndex: A,
    selectedIndex: O,
    onMatch: w ? _ : P,
    onTypingChange(ne) {
      L.current = ne;
    }
  }), { getReferenceProps: V, getFloatingProps: Y, getItemProps: ee } = hg([
    W,
    z,
    G,
    F,
    ...l ? [] : [U]
  ]), ie = (ne, J) => {
    const fe = [
      ...x() ?? []
    ];
    fe.findIndex((X) => X !== null && J !== null && typeof X == "object" ? X[o] === J[o] : X === J) === -1 && (fe.push(J), p || y(fe), P(ne), k.reference.current.focus(), S(!1), v(""), typeof i == "function" && i(fe));
  }, re = (ne, J) => {
    if (s)
      return ie(ne, J);
    P(ne), p || y(J), k.reference.current.focus(), S(!1), v(""), typeof i == "function" && i(J);
  }, le = qe((ne, J) => {
    N.current[ne] = J;
  }, []), ae = (ne, J) => {
    re(ne, J);
  }, ue = (ne, J, fe) => {
    ne.key === "Enter" && (ne.preventDefault(), re(J, fe)), ne.key === " " && !L.current && (ne.preventDefault(), re(J, fe));
  };
  return /* @__PURE__ */ E(
    yR.Provider,
    {
      value: {
        selectedIndex: O,
        setSelectedIndex: P,
        activeIndex: A,
        setActiveIndex: _,
        selected: m,
        setSelected: y,
        handleSelect: re,
        combobox: l,
        sizeValue: t,
        multiple: s,
        onChange: i,
        isTypingRef: L,
        getItemProps: ee,
        onClickItem: ae,
        onKeyDownItem: ue,
        getValues: x,
        selectId: d,
        getReferenceProps: V,
        isOpen: w,
        value: n,
        updateListRef: le,
        refs: k,
        listContentRef: R,
        by: o,
        getFloatingProps: Y,
        floatingStyles: D,
        context: $,
        searchKeyword: g,
        setSearchKeyword: v,
        disabled: c,
        isControlled: p,
        searchPlaceholder: f
      },
      children: a
    }
  );
};
xR.displayName = "Select.Portal";
vR.displayName = "Select.Button";
bR.displayName = "Select.Options";
wR.displayName = "Select.Option";
Dl.displayName = "Select.OptionGroup";
pd.Portal = xR;
pd.Button = vR;
pd.Options = bR;
pd.Option = wR;
pd.OptionGroup = Dl;
let XX = 1;
var xr, Fi;
class ZX {
  constructor() {
    zv(this, xr);
    zv(this, Fi);
    os(this, xr, []), os(this, Fi, []);
  }
  // Subscriber pattern.
  subscribe(t) {
    return Dr(this, Fi).push(t), () => {
      os(this, Fi, Dr(this, Fi).filter(
        (n) => n !== t
      ));
    };
  }
  // Publish a new toast.
  publish(t) {
    Dr(this, Fi).forEach((n) => n(t));
  }
  // Add a new toast.
  add(t) {
    Dr(this, xr).push(t), this.publish(t);
  }
  // Remove a toast.
  remove(t) {
    return os(this, xr, Dr(this, xr).filter((n) => n.id !== t)), t;
  }
  // Create a new toast.
  create(t) {
    const {
      id: n = void 0,
      message: r = "",
      jsx: i = void 0,
      ...o
    } = t;
    if (!r && typeof i != "function")
      return;
    const a = typeof n == "number" ? n : XX++;
    return Dr(this, xr).find((l) => l.id === a) && os(this, xr, Dr(this, xr).map((l) => l.id === a ? (this.publish({
      ...l,
      title: r,
      jsx: i,
      ...o
    }), { ...l, title: r, jsx: i, ...o }) : l)), this.add({ id: a, title: r, jsx: i, ...o }), a;
  }
  // Update a toast.
  update(t, n) {
    const { render: r = void 0 } = n;
    let i = n;
    switch (typeof r) {
      case "function":
        i = {
          jsx: r,
          ...n
        };
        break;
      case "string":
        i = {
          title: r,
          ...n
        };
        break;
    }
    os(this, xr, Dr(this, xr).map((o) => o.id === t ? (this.publish({ ...o, ...i }), { ...o, ...i }) : o));
  }
  // Dismiss toast.
  dismiss(t) {
    return t || Dr(this, xr).forEach(
      (n) => Dr(this, Fi).forEach(
        (r) => r({ id: n.id, dismiss: !0 })
      )
    ), Dr(this, Fi).forEach(
      (n) => n({ id: t, dismiss: !0 })
    ), t;
  }
  // History of toasts.
  history() {
    return Dr(this, xr);
  }
  // Types of toasts.
  // Default toast.
  default(t = "", n = {}) {
    return this.create({ message: t, type: "neutral", ...n });
  }
  // Success toast.
  success(t = "", n = {}) {
    return this.create({ message: t, type: "success", ...n });
  }
  // Error toast.
  error(t = "", n = {}) {
    return this.create({ message: t, type: "error", ...n });
  }
  // Warning toast.
  warning(t = "", n = {}) {
    return this.create({ message: t, type: "warning", ...n });
  }
  // Info toast
  info(t = "", n = {}) {
    return this.create({ message: t, type: "info", ...n });
  }
  // Custom toast.
  custom(t, n = {}) {
    return this.create({
      jsx: t,
      type: "custom",
      ...n
    });
  }
}
xr = new WeakMap(), Fi = new WeakMap();
const kn = new ZX(), JX = (e, t) => kn.default(e, t), JEe = Object.seal(
  Object.assign(
    JX,
    {
      success: kn.success.bind(kn),
      error: kn.error.bind(kn),
      warning: kn.warning.bind(kn),
      info: kn.info.bind(kn),
      custom: kn.custom.bind(kn),
      dismiss: kn.dismiss.bind(kn),
      update: kn.update.bind(kn)
    },
    {
      getHistory: kn.history.bind(kn)
    }
  )
);
let fC = !1;
const QX = (e) => rH((n) => {
  const r = n.singleTon;
  return fC && r ? null : (fC = !0, /* @__PURE__ */ E(e, { ...n }));
}), dC = {
  "top-left": "top-0 bottom-0 left-0 justify-start items-start",
  "top-right": "top-0 bottom-0 right-0 justify-start items-end",
  "bottom-left": "top-0 bottom-0 left-0 justify-end items-start",
  "bottom-right": "top-0 bottom-0 right-0 justify-end items-end"
}, hC = {
  stack: "w-[22.5rem]",
  inline: "lg:w-[47.5rem] w-full"
}, Dh = {
  light: {
    neutral: "border-alert-border-neutral bg-alert-background-neutral",
    custom: "border-alert-border-neutral bg-alert-background-neutral",
    info: "border-alert-border-info bg-alert-background-info",
    success: "border-alert-border-green bg-alert-background-green",
    warning: "border-alert-border-warning bg-alert-background-warning",
    error: "border-alert-border-danger bg-alert-background-danger"
  },
  dark: "bg-background-inverse border-background-inverse"
}, Ih = {
  light: "text-icon-secondary",
  dark: "text-icon-inverse"
}, eZ = ({
  position: e = "top-right",
  // top-right/top-left/bottom-right/bottom-left
  design: t = "stack",
  // stack/inline
  theme: n = "light",
  // light/dark
  className: r = "",
  autoDismiss: i = !0,
  // Auto dismiss the toast after a certain time.
  dismissAfter: o = 5e3
  // Time in milliseconds after which the toast will be dismissed.
}) => {
  const [a, s] = Me([]);
  Xe(() => {
    kn.subscribe((c) => {
      if (c != null && c.dismiss) {
        s(
          (f) => f.map(
            (d) => d.id === c.id ? { ...d, dismiss: !0 } : d
          )
        );
        return;
      }
      setTimeout(() => {
        U$(
          () => s((f) => f.findIndex(
            (p) => p.id === c.id
          ) !== -1 ? f.map((p) => p.id === c.id ? { ...p, ...c } : p) : [...f, c])
        );
      });
    });
  }, []);
  const l = (c) => {
    s((f) => f.filter((d) => d.id !== c));
  };
  return /* @__PURE__ */ E(
    "ul",
    {
      className: K(
        "fixed flex flex-col list-none z-20 p-10 pointer-events-none [&>li]:pointer-events-auto gap-3",
        dC[e] ?? dC["top-right"],
        r
      ),
      children: /* @__PURE__ */ E(Ks, { initial: !1, children: a.map((c) => /* @__PURE__ */ E(
        An.li,
        {
          initial: { opacity: 0, y: 50, scale: 0.7 },
          animate: { opacity: 1, y: 0, scale: 1 },
          exit: {
            opacity: 0,
            scale: 0.6,
            transition: { duration: 0.15 }
          },
          layoutId: `toast-${c.id}`,
          children: /* @__PURE__ */ E(
            tZ,
            {
              toastItem: c,
              title: c.title,
              content: c == null ? void 0 : c.description,
              icon: (c == null ? void 0 : c.icon) ?? void 0,
              design: (c == null ? void 0 : c.design) ?? t,
              autoDismiss: (c == null ? void 0 : c.autoDismiss) ?? i,
              dismissAfter: (c == null ? void 0 : c.dismissAfter) ?? o,
              removeToast: l,
              variant: c.type,
              theme: (c == null ? void 0 : c.theme) ?? n
            }
          )
        },
        c.id
      )) })
    }
  );
}, tZ = ({
  toastItem: e,
  title: t = "",
  content: n = "",
  autoDismiss: r = !0,
  dismissAfter: i = 5e3,
  theme: o = "light",
  // light/dark
  design: a = "stack",
  // inline/stack
  icon: s,
  variant: l = "neutral",
  // neutral/info/success/warning/danger
  removeToast: c
  // Function to remove the toast.
}) => {
  var w, S, A, _, O, P, C;
  const f = ut(0), d = ut(0), p = ut(), m = (k, D = i) => {
    if (!(!r || i < 0))
      return f.current = (/* @__PURE__ */ new Date()).getTime(), setTimeout(() => {
        typeof c == "function" && c(k.id);
      }, D);
  }, y = () => {
    clearTimeout(p.current), d.current = (/* @__PURE__ */ new Date()).getTime();
  }, g = () => {
    p.current = m(
      e,
      i - (d.current - f.current)
    );
  };
  Xe(() => {
    const k = i;
    return p.current = m(e, k), () => {
      clearTimeout(p.current);
    };
  }, []), Xe(() => {
    !(e != null && e.dismiss) || typeof c != "function" || c(e.id);
  }, [e]);
  const v = () => {
    var k, D;
    typeof c == "function" && ((D = (k = e == null ? void 0 : e.action) == null ? void 0 : k.onClick) == null || D.call(k, () => c(e.id)));
  };
  let x = null;
  return a === "stack" && (x = /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex items-center justify-start p-4 gap-2 relative border border-solid rounded-md shadow-lg",
        o === "dark" ? Dh.dark : (w = Dh.light) == null ? void 0 : w[l],
        hC.stack
      ),
      onMouseEnter: y,
      onMouseLeave: g,
      children: e.type !== "custom" ? /* @__PURE__ */ he(Ut, { children: [
        /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: wp({ variant: l, icon: s, theme: o }) }),
        /* @__PURE__ */ he("div", { className: "flex flex-col items-start justify-start gap-0.5 mr-6", children: [
          _p({ title: t, theme: o }),
          Sp({ content: n, theme: o }),
          ((S = e == null ? void 0 : e.action) == null ? void 0 : S.label) && typeof ((A = e == null ? void 0 : e.action) == null ? void 0 : A.onClick) == "function" && /* eslint-disable */
          /* @__PURE__ */ E("div", { className: "mt-2.5", children: x0({
            actionLabel: (_ = e == null ? void 0 : e.action) == null ? void 0 : _.label,
            actionType: ((O = e == null ? void 0 : e.action) == null ? void 0 : O.type) ?? "button",
            onAction: v,
            theme: o
          }) })
        ] }),
        /* @__PURE__ */ E("div", { className: "absolute right-4 top-4 [&_svg]:size-5", children: /* @__PURE__ */ E(
          "button",
          {
            className: K(
              "bg-transparent m-0 p-0 border-none focus:outline-none active:outline-none cursor-pointer",
              Ih[o] ?? Ih.light
            ),
            onClick: () => {
              typeof c == "function" && c(e.id);
            },
            children: /* @__PURE__ */ E(Na, {})
          }
        ) })
      ] }) : (P = e == null ? void 0 : e.jsx) == null ? void 0 : P.call(e, {
        close: () => c(e.id),
        action: e != null && e.action ? { ...e == null ? void 0 : e.action, onClick: v } : null
      })
    }
  )), a === "inline" && (x = /* @__PURE__ */ he(
    "div",
    {
      className: K(
        "flex items-center justify-start p-3 gap-2 relative border border-solid rounded-md shadow-lg",
        o === "dark" ? Dh.dark : (C = Dh.light) == null ? void 0 : C[l],
        hC.inline
      ),
      children: [
        /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: wp({ variant: l, icon: s, theme: o }) }),
        /* @__PURE__ */ he("div", { className: "flex items-start justify-start gap-1 mr-10 [&>span:first-child]:shrink-0", children: [
          _p({ title: t, theme: o }),
          Sp({ content: n, theme: o })
        ] }),
        /* @__PURE__ */ E("div", { className: "absolute right-3 top-3 [&_svg]:size-5", children: /* @__PURE__ */ E(
          "button",
          {
            className: K(
              "bg-transparent m-0 p-0 border-none focus:outline-none active:outline-none cursor-pointer",
              Ih[o] ?? Ih.light
            ),
            onClick: () => c(e.id),
            children: /* @__PURE__ */ E(Na, {})
          }
        ) })
      ]
    }
  )), x;
}, QEe = QX(eZ), nZ = {
  sm: {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6",
    7: "grid-cols-7",
    8: "grid-cols-8",
    9: "grid-cols-9",
    10: "grid-cols-10",
    11: "grid-cols-11",
    12: "grid-cols-12"
  },
  md: {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
    5: "md:grid-cols-5",
    6: "md:grid-cols-6",
    7: "md:grid-cols-7",
    8: "md:grid-cols-8",
    9: "md:grid-cols-9",
    10: "md:grid-cols-10",
    11: "md:grid-cols-11",
    12: "md:grid-cols-12"
  },
  lg: {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
    5: "lg:grid-cols-5",
    6: "lg:grid-cols-6",
    7: "lg:grid-cols-7",
    8: "lg:grid-cols-8",
    9: "lg:grid-cols-9",
    10: "lg:grid-cols-10",
    11: "lg:grid-cols-11",
    12: "lg:grid-cols-12"
  }
}, _R = {
  sm: {
    xs: "gap-2",
    sm: "gap-4",
    md: "gap-5",
    lg: "gap-6",
    xl: "gap-6",
    "2xl": "gap-8"
  },
  md: {
    xs: "md:gap-2",
    sm: "md:gap-4",
    md: "md:gap-5",
    lg: "md:gap-6",
    xl: "md:gap-6",
    "2xl": "md:gap-8"
  },
  lg: {
    xs: "lg:gap-2",
    sm: "lg:gap-4",
    md: "lg:gap-5",
    lg: "lg:gap-6",
    xl: "lg:gap-6",
    "2xl": "lg:gap-8"
  }
}, SR = {
  sm: {
    xs: "gap-x-2",
    sm: "gap-x-4",
    md: "gap-x-5",
    lg: "gap-x-6",
    xl: "gap-x-6",
    "2xl": "gap-x-8"
  },
  md: {
    xs: "md:gap-x-2",
    sm: "md:gap-x-4",
    md: "md:gap-x-5",
    lg: "md:gap-x-6",
    xl: "md:gap-x-6",
    "2xl": "md:gap-x-8"
  },
  lg: {
    xs: "lg:gap-x-2",
    sm: "lg:gap-x-4",
    md: "lg:gap-x-5",
    lg: "lg:gap-x-6",
    xl: "lg:gap-x-6",
    "2xl": "lg:gap-x-8"
  }
}, OR = {
  sm: {
    xs: "gap-y-2",
    sm: "gap-y-4",
    md: "gap-y-5",
    lg: "gap-y-6",
    xl: "gap-y-6",
    "2xl": "gap-y-8"
  },
  md: {
    xs: "md:gap-y-2",
    sm: "md:gap-y-4",
    md: "md:gap-y-5",
    lg: "md:gap-y-6",
    xl: "md:gap-y-6",
    "2xl": "md:gap-y-8"
  },
  lg: {
    xs: "lg:gap-y-2",
    sm: "lg:gap-y-4",
    md: "lg:gap-y-5",
    lg: "lg:gap-y-6",
    xl: "lg:gap-y-6",
    "2xl": "lg:gap-y-8"
  }
}, rZ = {
  sm: {
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
    4: "col-span-4",
    5: "col-span-5",
    6: "col-span-6",
    7: "col-span-7",
    8: "col-span-8",
    9: "col-span-9",
    10: "col-span-10",
    11: "col-span-11",
    12: "col-span-12"
  },
  md: {
    1: "md:col-span-1",
    2: "md:col-span-2",
    3: "md:col-span-3",
    4: "md:col-span-4",
    5: "md:col-span-5",
    6: "md:col-span-6",
    7: "md:col-span-7",
    8: "md:col-span-8",
    9: "md:col-span-9",
    10: "md:col-span-10",
    11: "md:col-span-11",
    12: "md:col-span-12"
  },
  lg: {
    1: "lg:col-span-1",
    2: "lg:col-span-2",
    3: "lg:col-span-3",
    4: "lg:col-span-4",
    5: "lg:col-span-5",
    6: "lg:col-span-6",
    7: "lg:col-span-7",
    8: "lg:col-span-8",
    9: "lg:col-span-9",
    10: "lg:col-span-10",
    11: "lg:col-span-11",
    12: "lg:col-span-12"
  }
}, iZ = {
  sm: {
    1: "col-start-1",
    2: "col-start-2",
    3: "col-start-3",
    4: "col-start-4",
    5: "col-start-5",
    6: "col-start-6",
    7: "col-start-7",
    8: "col-start-8",
    9: "col-start-9",
    10: "col-start-10",
    11: "col-start-11",
    12: "col-start-12"
  },
  md: {
    1: "md:col-start-1",
    2: "md:col-start-2",
    3: "md:col-start-3",
    4: "md:col-start-4",
    5: "md:col-start-5",
    6: "md:col-start-6",
    7: "md:col-start-7",
    8: "md:col-start-8",
    9: "md:col-start-9",
    10: "md:col-start-10",
    11: "md:col-start-11",
    12: "md:col-start-12"
  },
  lg: {
    1: "lg:col-start-1",
    2: "lg:col-start-2",
    3: "lg:col-start-3",
    4: "lg:col-start-4",
    5: "lg:col-start-5",
    6: "lg:col-start-6",
    7: "lg:col-start-7",
    8: "lg:col-start-8",
    9: "lg:col-start-9",
    10: "lg:col-start-10",
    11: "lg:col-start-11",
    12: "lg:col-start-12"
  }
}, oZ = {
  sm: {
    row: "grid-flow-row",
    column: "grid-flow-col",
    "row-dense": "grid-flow-row-dense",
    "column-dense": "grid-flow-col-dense"
  },
  md: {
    row: "md:grid-flow-row",
    column: "md:grid-flow-col",
    "row-dense": "md:grid-flow-row-dense",
    "column-dense": "md:grid-flow-col-dense"
  },
  lg: {
    row: "lg:grid-flow-row",
    column: "lg:grid-flow-col",
    "row-dense": "lg:grid-flow-row-dense",
    "column-dense": "lg:grid-flow-col-dense"
  }
}, AR = {
  sm: {
    normal: "justify-normal",
    start: "justify-start",
    end: "justify-end",
    center: "justify-center",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly",
    stretch: "justify-stretch"
  },
  md: {
    normal: "md:justify-normal",
    start: "md:justify-start",
    end: "md:justify-end",
    center: "md:justify-center",
    between: "md:justify-between",
    around: "md:justify-around",
    evenly: "md:justify-evenly",
    stretch: "md:justify-stretch"
  },
  lg: {
    normal: "lg:justify-normal",
    start: "lg:justify-start",
    end: "lg:justify-end",
    center: "lg:justify-center",
    between: "lg:justify-between",
    around: "lg:justify-around",
    evenly: "lg:justify-evenly",
    stretch: "lg:justify-stretch"
  }
}, TR = {
  sm: {
    start: "items-start",
    end: "items-end",
    center: "items-center",
    baseline: "items-baseline",
    stretch: "items-stretch"
  },
  md: {
    start: "md:items-start",
    end: "md:items-end",
    center: "md:items-center",
    baseline: "md:items-baseline",
    stretch: "md:items-stretch"
  },
  lg: {
    start: "lg:items-start",
    end: "lg:items-end",
    center: "lg:items-center",
    baseline: "lg:items-baseline",
    stretch: "lg:items-stretch"
  }
}, PR = {
  sm: {
    start: "self-start",
    end: "self-end",
    center: "self-center",
    baseline: "self-baseline",
    stretch: "self-stretch"
  },
  md: {
    start: "md:self-start",
    end: "md:self-end",
    center: "md:self-center",
    baseline: "md:self-baseline",
    stretch: "md:self-stretch"
  },
  lg: {
    start: "lg:self-start",
    end: "lg:self-end",
    center: "lg:self-center",
    baseline: "lg:self-baseline",
    stretch: "lg:self-stretch"
  }
}, CR = {
  sm: {
    auto: "justify-self-auto",
    start: "justify-self-start",
    end: "justify-self-end",
    center: "justify-self-center",
    baseline: "justify-self-baseline",
    stretch: "justify-self-stretch"
  },
  md: {
    auto: "md:justify-self-auto",
    start: "md:justify-self-start",
    end: "md:justify-self-end",
    center: "md:justify-self-center",
    baseline: "md:justify-self-baseline",
    stretch: "md:justify-self-stretch"
  },
  lg: {
    auto: "lg:justify-self-auto",
    start: "lg:justify-self-start",
    end: "lg:justify-self-end",
    center: "lg:justify-self-center",
    baseline: "lg:justify-self-baseline",
    stretch: "lg:justify-self-stretch"
  }
}, aZ = {
  sm: {
    row: "flex-row",
    "row-reverse": "flex-row-reverse",
    column: "flex-col",
    "column-reverse": "flex-col-reverse"
  },
  md: {
    row: "md:flex-row",
    "row-reverse": "md:flex-row-reverse",
    column: "md:flex-col",
    "column-reverse": "md:flex-col-reverse"
  },
  lg: {
    row: "lg:flex-row",
    "row-reverse": "lg:flex-row-reverse",
    column: "lg:flex-col",
    "column-reverse": "lg:flex-col-reverse"
  }
}, sZ = {
  sm: {
    wrap: "flex-wrap",
    "wrap-reverse": "flex-wrap-reverse",
    nowrap: "flex-nowrap"
  },
  md: {
    wrap: "md:flex-wrap",
    "wrap-reverse": "md:flex-wrap-reverse",
    nowrap: "md:flex-nowrap"
  },
  lg: {
    wrap: "lg:flex-wrap",
    "wrap-reverse": "lg:flex-wrap-reverse",
    nowrap: "lg:flex-nowrap"
  }
}, lZ = {
  sm: {
    1: "w-full",
    2: "w-1/2",
    3: "w-1/3",
    4: "w-1/4",
    5: "w-1/5",
    6: "w-1/6",
    7: "w-1/7",
    8: "w-1/8",
    9: "w-1/9",
    10: "w-1/10",
    11: "w-1/11",
    12: "w-1/12"
  },
  md: {
    1: "md:w-full",
    2: "md:w-1/2",
    3: "md:w-1/3",
    4: "md:w-1/4",
    5: "md:w-1/5",
    6: "md:w-1/6",
    7: "md:w-1/7",
    8: "md:w-1/8",
    9: "md:w-1/9",
    10: "md:w-1/10",
    11: "md:w-1/11",
    12: "md:w-1/12"
  },
  lg: {
    1: "lg:w-full",
    2: "lg:w-1/2",
    3: "lg:w-1/3",
    4: "lg:w-1/4",
    5: "lg:w-1/5",
    6: "lg:w-1/6",
    7: "lg:w-1/7",
    8: "lg:w-1/8",
    9: "lg:w-1/9",
    10: "lg:w-1/10",
    11: "lg:w-1/11",
    12: "lg:w-1/12"
  }
}, cZ = {
  sm: {
    1: "order-1",
    2: "order-2",
    3: "order-3",
    4: "order-4",
    5: "order-5",
    6: "order-6",
    7: "order-7",
    8: "order-8",
    9: "order-9",
    10: "order-10",
    11: "order-11",
    12: "order-12",
    first: "order-first",
    last: "order-last",
    none: "order-none"
  },
  md: {
    1: "md:order-1",
    2: "md:order-2",
    3: "md:order-3",
    4: "md:order-4",
    5: "md:order-5",
    6: "md:order-6",
    7: "md:order-7",
    8: "md:order-8",
    9: "md:order-9",
    10: "md:order-10",
    11: "md:order-11",
    12: "md:order-12",
    first: "md:order-first",
    last: "md:order-last",
    none: "md:order-none"
  },
  lg: {
    1: "lg:order-1",
    2: "lg:order-2",
    3: "lg:order-3",
    4: "lg:order-4",
    5: "lg:order-5",
    6: "lg:order-6",
    7: "lg:order-7",
    8: "lg:order-8",
    9: "lg:order-9",
    10: "lg:order-10",
    11: "lg:order-11",
    12: "lg:order-12",
    first: "lg:order-first",
    last: "lg:order-last",
    none: "lg:order-none"
  }
}, uZ = {
  sm: {
    0: "grow-0",
    1: "grow"
  },
  md: {
    0: "md:grow-0",
    1: "md:grow"
  },
  lg: {
    0: "lg:grow-0",
    1: "lg:grow"
  }
}, fZ = {
  sm: {
    0: "shrink-0",
    1: "shrink"
  },
  md: {
    0: "md:shrink-0",
    1: "md:shrink"
  },
  lg: {
    0: "lg:shrink-0",
    1: "lg:shrink"
  }
}, qt = (e, t, n, r = "sm") => {
  var o, a, s, l, c;
  const i = [];
  switch (typeof e) {
    case "object":
      for (const [d, p] of Object.entries(e))
        t[d] && i.push(
          ((o = t == null ? void 0 : t[d]) == null ? void 0 : o[p]) ?? ((a = t == null ? void 0 : t[d]) == null ? void 0 : a[n == null ? void 0 : n[d]]) ?? ""
        );
      break;
    case "string":
    case "number":
      const f = r;
      i.push(
        ((s = t == null ? void 0 : t[f]) == null ? void 0 : s[e]) ?? ((l = t == null ? void 0 : t[f]) == null ? void 0 : l[n == null ? void 0 : n[f]]) ?? ""
      );
      break;
    default:
      if (e === void 0)
        break;
      i.push(
        ((c = t == null ? void 0 : t[r]) == null ? void 0 : c[n]) ?? ""
      );
      break;
  }
  return i.join(" ");
}, Mp = ({
  className: e,
  cols: t,
  gap: n,
  gapX: r,
  gapY: i,
  align: o,
  justify: a,
  gridFlow: s,
  colsSubGrid: l = !1,
  rowsSubGrid: c = !1,
  autoRows: f = !1,
  autoCols: d = !1,
  children: p,
  ...m
}) => {
  const y = qt(t, nZ, 1), g = qt(n, _R, "sm"), v = qt(r, SR, ""), x = qt(i, OR, ""), w = qt(o, TR, ""), S = qt(a, AR, ""), A = qt(s, oZ, "");
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "grid",
        {
          "grid-cols-subgrid": l,
          "grid-rows-subgrid": c,
          "auto-cols-auto": d,
          "auto-rows-auto": f
        },
        y,
        g,
        v,
        x,
        w,
        S,
        A,
        e
      ),
      ...m,
      children: p
    }
  );
}, dZ = ({
  className: e,
  children: t,
  colSpan: n,
  colStart: r,
  alignSelf: i,
  justifySelf: o,
  ...a
}) => {
  const s = qt(n, rZ, 0), l = qt(
    r,
    iZ,
    0
  ), c = qt(
    i,
    PR,
    ""
  ), f = qt(
    o,
    CR,
    ""
  );
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        s,
        l,
        c,
        f,
        e
      ),
      ...a,
      children: t
    }
  );
};
Mp.Item = dZ;
const L0 = dt({}), hZ = () => Ve(L0), ER = ({
  containerType: e = "flex",
  // flex, (grid - functionality not implemented)
  gap: t = "sm",
  // xs, sm, md, lg, xl, 2xl
  gapX: n,
  gapY: r,
  direction: i,
  // row, row-reverse, column, column reverse
  justify: o,
  // justify-content (normal, start, end, center, between, around, evenly, stretch)
  align: a,
  // align-items (start, end, center, baseline, stretch)
  wrap: s,
  // nowrap, wrap, wrap-reverse
  cols: l,
  className: c,
  children: f,
  ...d
}) => {
  if (e === "grid")
    return /* @__PURE__ */ E(
      L0.Provider,
      {
        value: {
          containerType: e
        },
        children: /* @__PURE__ */ E(
          Mp,
          {
            className: c,
            gap: t,
            gapX: n,
            gapY: r,
            cols: l,
            children: f,
            align: a,
            justify: o,
            ...d
          }
        )
      }
    );
  const p = qt(s, sZ, ""), m = qt(t, _R, "sm"), y = qt(n, SR, ""), g = qt(r, OR, ""), v = qt(
    i,
    aZ,
    ""
  ), x = qt(
    o,
    AR,
    ""
  ), w = qt(a, TR, ""), S = K(
    "flex",
    p,
    m,
    y,
    g,
    v,
    x,
    w,
    c
  ), A = () => e === "flex" ? /* @__PURE__ */ E("div", { className: S, children: f }) : /* @__PURE__ */ E(
    Mp,
    {
      className: c,
      gap: t,
      gapX: n,
      gapY: r,
      cols: l,
      children: f,
      align: a,
      justify: o,
      ...d
    }
  );
  return /* @__PURE__ */ E(
    L0.Provider,
    {
      value: {
        containerType: e,
        cols: l
      },
      children: A()
    }
  );
}, kR = ({
  grow: e,
  shrink: t,
  order: n,
  alignSelf: r,
  justifySelf: i,
  className: o,
  children: a,
  ...s
}) => {
  const { containerType: l, cols: c } = hZ();
  if (l === "grid")
    return /* @__PURE__ */ E(
      Mp.Item,
      {
        className: o,
        alignSelf: r,
        justifySelf: i,
        children: a,
        ...s
      }
    );
  const f = qt(
    r,
    PR,
    ""
  ), d = qt(
    i,
    CR,
    ""
  ), p = qt(e, uZ, 0), m = qt(t, fZ, 0), y = qt(n, cZ, 0), g = qt(c, lZ, 1);
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "box-border",
        p,
        m,
        y,
        f,
        d,
        g,
        o
      ),
      children: a
    }
  );
};
ER.Item = kR;
ER.displayName = "Container";
kR.displayName = "Container.Item";
const eke = ({
  design: e = "inline",
  // stack/inline
  theme: t = "light",
  // light/dark
  variant: n = "neutral",
  className: r = "",
  title: i = "",
  content: o = "",
  icon: a = null,
  onClose: s,
  action: l = {
    label: "",
    onClick: () => {
    },
    type: "link"
  }
}) => {
  var m, y;
  const c = () => {
    typeof s == "function" && s();
  }, f = {
    light: {
      neutral: "ring-alert-border-neutral bg-alert-background-neutral",
      custom: "ring-alert-border-neutral bg-alert-background-neutral",
      info: "ring-alert-border-info bg-alert-background-info",
      success: "ring-alert-border-green bg-alert-background-green",
      warning: "ring-alert-border-warning bg-alert-background-warning",
      error: "ring-alert-border-danger bg-alert-background-danger"
    },
    dark: "bg-background-inverse ring-background-inverse"
  }, d = {
    light: "text-icon-secondary",
    dark: "text-icon-inverse"
  }, p = () => {
    var g;
    (g = l == null ? void 0 : l.onClick) == null || g.call(l, c);
  };
  return e === "stack" ? /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex items-center justify-start p-4 gap-2 relative ring-1 rounded-md shadow-lg",
        t === "dark" ? f.dark : (m = f.light) == null ? void 0 : m[n],
        r
      ),
      children: /* @__PURE__ */ he(Ut, { children: [
        /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: wp({ variant: n, icon: a, theme: t }) }),
        /* @__PURE__ */ he("div", { className: "flex flex-col items-start justify-start gap-0.5 mr-7", children: [
          _p({ title: i, theme: t }),
          Sp({ content: o, theme: t }),
          (l == null ? void 0 : l.label) && typeof (l == null ? void 0 : l.onClick) == "function" && /* @__PURE__ */ E("div", { className: "mt-2.5", children: x0({
            actionLabel: l == null ? void 0 : l.label,
            actionType: (l == null ? void 0 : l.type) ?? "button",
            onAction: p,
            theme: t
          }) })
        ] }),
        /* @__PURE__ */ E("div", { className: "absolute right-4 top-4 [&_svg]:size-5", children: /* @__PURE__ */ E(
          "button",
          {
            className: K(
              "bg-transparent m-0 p-0 border-none focus:outline-none active:outline-none cursor-pointer",
              d[t] ?? d.light
            ),
            onClick: () => c(),
            "aria-label": "Close alert",
            children: /* @__PURE__ */ E(Na, {})
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ he(
    "div",
    {
      className: K(
        "flex items-center justify-between p-3 gap-2 relative ring-1 rounded-lg shadow-lg",
        t === "dark" ? f.dark : (y = f.light) == null ? void 0 : y[n],
        r
      ),
      children: [
        /* @__PURE__ */ he("div", { className: "flex items-center justify-start gap-2", children: [
          /* @__PURE__ */ E("div", { className: "self-start flex items-center justify-center [&_svg]:size-5 shrink-0", children: wp({ variant: n, icon: a, theme: t }) }),
          /* @__PURE__ */ he("p", { className: "content-start space-x-1 my-0 mr-10 px-1", children: [
            _p({ title: i, theme: t, inline: !0 }),
            Sp({ content: o, theme: t, inline: !0 })
          ] })
        ] }),
        /* @__PURE__ */ he("div", { className: "flex h-full justify-start gap-4 [&_svg]:size-4", children: [
          (l == null ? void 0 : l.label) && typeof (l == null ? void 0 : l.onClick) == "function" && /* @__PURE__ */ E("div", { className: "self-center flex h-5", children: x0({
            actionLabel: l == null ? void 0 : l.label,
            actionType: (l == null ? void 0 : l.type) ?? "button",
            onAction: p,
            theme: t
          }) }),
          typeof s == "function" && /* @__PURE__ */ E(
            "button",
            {
              className: K(
                "self-start bg-transparent m-0 border-none p-0.5 focus:outline-none active:outline-none cursor-pointer size-5",
                d[t] ?? d.light
              ),
              onClick: () => c(),
              "aria-label": "Close alert",
              children: /* @__PURE__ */ E(Na, {})
            }
          )
        ] })
      ]
    }
  );
};
function pZ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mZ = pZ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const MR = dt(null);
function gZ(e, t) {
  return { getTheme: function() {
    return t ?? null;
  } };
}
function Gr() {
  const e = Ve(MR);
  return e == null && mZ(8), e;
}
function yZ({ defaultSelection: e }) {
  const [t] = Gr();
  return Xe(() => {
    t.focus(() => {
      const n = document.activeElement, r = t.getRootElement();
      r === null || n !== null && r.contains(n) || r.focus({ preventScroll: !0 });
    }, { defaultSelection: e });
  }, [e, t]), null;
}
function vZ(e) {
  return {};
}
const K1 = {}, bZ = {}, Cs = {}, Vl = {}, B0 = {}, Ul = {}, G1 = {}, F0 = {}, vf = {}, bf = {}, xs = {}, Y1 = {}, q1 = {}, NR = {}, X1 = {}, xZ = {}, Z1 = {}, wZ = {}, $R = {}, DR = {}, xf = {}, _Z = {}, J1 = {}, IR = {}, RR = {}, jR = {}, LR = {}, BR = {}, SZ = {}, OZ = {}, Q1 = {}, e_ = {}, W0 = {}, AZ = {}, TZ = {}, Rh = {}, jh = {}, PZ = {}, CZ = {}, EZ = {}, Di = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, kZ = Di && "documentMode" in document ? document.documentMode : null, wi = Di && /Mac|iPod|iPhone|iPad/.test(navigator.platform), ka = Di && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Np = !(!Di || !("InputEvent" in window) || kZ) && "getTargetRanges" in new window.InputEvent("input"), t_ = Di && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), Ag = Di && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, MZ = Di && /Android/.test(navigator.userAgent), FR = Di && /^(?=.*Chrome).*/i.test(navigator.userAgent), NZ = Di && MZ && FR, n_ = Di && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !FR, md = 1, Va = 3, Rs = 0, WR = 1, ec = 2, $Z = 0, DZ = 1, IZ = 2, $p = 4, Dp = 8, r_ = 128, RZ = 112 | (3 | $p | Dp) | r_, i_ = 1, o_ = 2, a_ = 3, s_ = 4, l_ = 5, c_ = 6, Tg = t_ || Ag || n_ ? " " : "​", Wo = `

`, jZ = ka ? " " : Tg, zR = "֑-߿יִ-﷽ﹰ-ﻼ", VR = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", LZ = new RegExp("^[^" + VR + "]*[" + zR + "]"), BZ = new RegExp("^[^" + zR + "]*[" + VR + "]"), Do = { bold: 1, code: 16, highlight: r_, italic: 2, strikethrough: $p, subscript: 32, superscript: 64, underline: Dp }, FZ = { directionless: 1, unmergeable: 2 }, pC = { center: o_, end: c_, justify: s_, left: i_, right: a_, start: l_ }, WZ = { [o_]: "center", [c_]: "end", [s_]: "justify", [i_]: "left", [a_]: "right", [l_]: "start" }, zZ = { normal: 0, segmented: 2, token: 1 }, VZ = { [$Z]: "normal", [IZ]: "segmented", [DZ]: "token" };
function UZ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _e = UZ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function Ip(...e) {
  const t = [];
  for (const n of e) if (n && typeof n == "string") for (const [r] of n.matchAll(/\S+/g)) t.push(r);
  return t;
}
const HZ = 100;
let z0 = !1, u_ = 0;
function KZ(e) {
  u_ = e.timeStamp;
}
function hb(e, t, n) {
  return t.__lexicalLineBreak === e || e[`__lexicalKey_${n._key}`] !== void 0;
}
function GZ(e, t, n) {
  const r = to(n._window);
  let i = null, o = null;
  r !== null && r.anchorNode === e && (i = r.anchorOffset, o = r.focusOffset);
  const a = e.nodeValue;
  a !== null && p_(t, a, i, o, !1);
}
function YZ(e, t, n) {
  if (we(e)) {
    const r = e.anchor.getNode();
    if (r.is(n) && e.format !== r.getFormat()) return !1;
  }
  return t.nodeType === Va && n.isAttached();
}
function UR(e, t, n) {
  z0 = !0;
  const r = performance.now() - u_ > HZ;
  try {
    Fr(e, () => {
      const i = Ne() || function(p) {
        return p.getEditorState().read(() => {
          const m = Ne();
          return m !== null ? m.clone() : null;
        });
      }(e), o = /* @__PURE__ */ new Map(), a = e.getRootElement(), s = e._editorState, l = e._blockCursorElement;
      let c = !1, f = "";
      for (let p = 0; p < t.length; p++) {
        const m = t[p], y = m.type, g = m.target;
        let v = Eg(g, s);
        if (!(v === null && g !== a || Ht(v))) {
          if (y === "characterData") r && Se(v) && YZ(i, g, v) && GZ(g, v, e);
          else if (y === "childList") {
            c = !0;
            const x = m.addedNodes;
            for (let A = 0; A < x.length; A++) {
              const _ = x[A], O = qR(_), P = _.parentNode;
              if (P != null && _ !== l && O === null && (_.nodeName !== "BR" || !hb(_, P, e))) {
                if (ka) {
                  const C = _.innerText || _.nodeValue;
                  C && (f += C);
                }
                P.removeChild(_);
              }
            }
            const w = m.removedNodes, S = w.length;
            if (S > 0) {
              let A = 0;
              for (let _ = 0; _ < S; _++) {
                const O = w[_];
                (O.nodeName === "BR" && hb(O, g, e) || l === O) && (g.appendChild(O), A++);
              }
              S !== A && (g === a && (v = ZR(s)), o.set(g, v));
            }
          }
        }
      }
      if (o.size > 0) for (const [p, m] of o) if (ye(m)) {
        const y = m.getChildrenKeys();
        let g = p.firstChild;
        for (let v = 0; v < y.length; v++) {
          const x = y[v], w = e.getElementByKey(x);
          w !== null && (g == null ? (p.appendChild(w), g = w) : g !== w && p.replaceChild(w, g), g = g.nextSibling);
        }
      } else Se(m) && m.markDirty();
      const d = n.takeRecords();
      if (d.length > 0) {
        for (let p = 0; p < d.length; p++) {
          const m = d[p], y = m.addedNodes, g = m.target;
          for (let v = 0; v < y.length; v++) {
            const x = y[v], w = x.parentNode;
            w == null || x.nodeName !== "BR" || hb(x, g, e) || w.removeChild(x);
          }
        }
        n.takeRecords();
      }
      i !== null && (c && (i.dirty = !0, zo(i)), ka && t2(e) && i.insertRawText(f));
    });
  } finally {
    z0 = !1;
  }
}
function HR(e) {
  const t = e._observer;
  t !== null && UR(e, t.takeRecords(), t);
}
function KR(e) {
  (function(t) {
    u_ === 0 && Ng(t).addEventListener("textInput", KZ, !0);
  })(e), e._observer = new MutationObserver((t, n) => {
    UR(e, t, n);
  });
}
function mC(e, t) {
  const n = e.__mode, r = e.__format, i = e.__style, o = t.__mode, a = t.__format, s = t.__style;
  return !(n !== null && n !== o || r !== null && r !== a || i !== null && i !== s);
}
function gC(e, t) {
  const n = e.mergeWithSibling(t), r = mn()._normalizedNodes;
  return r.add(e.__key), r.add(t.__key), n;
}
function yC(e) {
  let t, n, r = e;
  if (r.__text !== "" || !r.isSimpleText() || r.isUnmergeable()) {
    for (; (t = r.getPreviousSibling()) !== null && Se(t) && t.isSimpleText() && !t.isUnmergeable(); ) {
      if (t.__text !== "") {
        if (mC(t, r)) {
          r = gC(t, r);
          break;
        }
        break;
      }
      t.remove();
    }
    for (; (n = r.getNextSibling()) !== null && Se(n) && n.isSimpleText() && !n.isUnmergeable(); ) {
      if (n.__text !== "") {
        if (mC(r, n)) {
          r = gC(r, n);
          break;
        }
        break;
      }
      n.remove();
    }
  } else r.remove();
}
function qZ(e) {
  return vC(e.anchor), vC(e.focus), e;
}
function vC(e) {
  for (; e.type === "element"; ) {
    const t = e.getNode(), n = e.offset;
    let r, i;
    if (n === t.getChildrenSize() ? (r = t.getChildAtIndex(n - 1), i = !0) : (r = t.getChildAtIndex(n), i = !1), Se(r)) {
      e.set(r.__key, i ? r.getTextContentSize() : 0, "text");
      break;
    }
    if (!ye(r)) break;
    e.set(r.__key, i ? r.getChildrenSize() : 0, "element");
  }
}
let XZ = 1;
const ZZ = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
};
function GR(e) {
  const t = document.activeElement;
  if (t === null) return !1;
  const n = t.nodeName;
  return Ht(Eg(e)) && (n === "INPUT" || n === "TEXTAREA" || t.contentEditable === "true" && Cg(t) == null);
}
function Pg(e, t, n) {
  const r = e.getRootElement();
  try {
    return r !== null && r.contains(t) && r.contains(n) && t !== null && !GR(t) && YR(t) === e;
  } catch {
    return !1;
  }
}
function f_(e) {
  return e instanceof Fg;
}
function YR(e) {
  let t = e;
  for (; t != null; ) {
    const n = Cg(t);
    if (f_(n)) return n;
    t = Mg(t);
  }
  return null;
}
function Cg(e) {
  return e ? e.__lexicalEditor : null;
}
function Al(e) {
  return e.isToken() || e.isSegmented();
}
function JZ(e) {
  return e.nodeType === Va;
}
function Rp(e) {
  let t = e;
  for (; t != null; ) {
    if (JZ(t)) return t;
    t = t.firstChild;
  }
  return null;
}
function V0(e, t, n) {
  const r = Do[t];
  if (n !== null && (e & r) == (n & r)) return e;
  let i = e ^ r;
  return t === "subscript" ? i &= ~Do.superscript : t === "superscript" && (i &= ~Do.subscript), i;
}
function QZ(e, t) {
  if (t != null) return void (e.__key = t);
  wr(), O2();
  const n = mn(), r = Yo(), i = "" + XZ++;
  r._nodeMap.set(i, e), ye(e) ? n._dirtyElements.set(i, !0) : n._dirtyLeaves.add(i), n._cloneNotNeeded.add(i), n._dirtyType = WR, e.__key = i;
}
function Es(e) {
  const t = e.getParent();
  if (t !== null) {
    const n = e.getWritable(), r = t.getWritable(), i = e.getPreviousSibling(), o = e.getNextSibling();
    if (i === null) if (o !== null) {
      const a = o.getWritable();
      r.__first = o.__key, a.__prev = null;
    } else r.__first = null;
    else {
      const a = i.getWritable();
      if (o !== null) {
        const s = o.getWritable();
        s.__prev = a.__key, a.__next = s.__key;
      } else a.__next = null;
      n.__prev = null;
    }
    if (o === null) if (i !== null) {
      const a = i.getWritable();
      r.__last = i.__key, a.__next = null;
    } else r.__last = null;
    else {
      const a = o.getWritable();
      if (i !== null) {
        const s = i.getWritable();
        s.__next = a.__key, a.__prev = s.__key;
      } else a.__prev = null;
      n.__next = null;
    }
    r.__size--, n.__parent = null;
  }
}
function jp(e) {
  O2();
  const t = e.getLatest(), n = t.__parent, r = Yo(), i = mn(), o = r._nodeMap, a = i._dirtyElements;
  n !== null && function(l, c, f) {
    let d = l;
    for (; d !== null; ) {
      if (f.has(d)) return;
      const p = c.get(d);
      if (p === void 0) break;
      f.set(d, !1), d = p.__parent;
    }
  }(n, o, a);
  const s = t.__key;
  i._dirtyType = WR, ye(e) ? a.set(s, !0) : i._dirtyLeaves.add(s);
}
function Gn(e) {
  wr();
  const t = mn(), n = t._compositionKey;
  if (e !== n) {
    if (t._compositionKey = e, n !== null) {
      const r = $n(n);
      r !== null && r.getWritable();
    }
    if (e !== null) {
      const r = $n(e);
      r !== null && r.getWritable();
    }
  }
}
function Sa() {
  return bd() ? null : mn()._compositionKey;
}
function $n(e, t) {
  const n = (t || Yo())._nodeMap.get(e);
  return n === void 0 ? null : n;
}
function qR(e, t) {
  const n = e[`__lexicalKey_${mn()._key}`];
  return n !== void 0 ? $n(n, t) : null;
}
function Eg(e, t) {
  let n = e;
  for (; n != null; ) {
    const r = qR(n, t);
    if (r !== null) return r;
    n = Mg(n);
  }
  return null;
}
function XR(e) {
  const t = e._decorators, n = Object.assign({}, t);
  return e._pendingDecorators = n, n;
}
function bC(e) {
  return e.read(() => ir().getTextContent());
}
function ir() {
  return ZR(Yo());
}
function ZR(e) {
  return e._nodeMap.get("root");
}
function zo(e) {
  wr();
  const t = Yo();
  e !== null && (e.dirty = !0, e.setCachedNodes(null)), t._selection = e;
}
function Il(e) {
  const t = mn(), n = function(r, i) {
    let o = r;
    for (; o != null; ) {
      const a = o[`__lexicalKey_${i._key}`];
      if (a !== void 0) return a;
      o = Mg(o);
    }
    return null;
  }(e, t);
  return n === null ? e === t.getRootElement() ? $n("root") : null : $n(n);
}
function xC(e, t) {
  return t ? e.getTextContentSize() : 0;
}
function JR(e) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(e);
}
function d_(e) {
  const t = [];
  let n = e;
  for (; n !== null; ) t.push(n), n = n._parentEditor;
  return t;
}
function QR() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function e2(e) {
  return e.nodeType === Va ? e.nodeValue : null;
}
function h_(e, t, n) {
  const r = to(t._window);
  if (r === null) return;
  const i = r.anchorNode;
  let { anchorOffset: o, focusOffset: a } = r;
  if (i !== null) {
    let s = e2(i);
    const l = Eg(i);
    if (s !== null && Se(l)) {
      if (s === Tg && n) {
        const c = n.length;
        s = n, o = c, a = c;
      }
      s !== null && p_(l, s, o, a, e);
    }
  }
}
function p_(e, t, n, r, i) {
  let o = e;
  if (o.isAttached() && (i || !o.isDirty())) {
    const a = o.isComposing();
    let s = t;
    (a || i) && t[t.length - 1] === Tg && (s = t.slice(0, -1));
    const l = o.getTextContent();
    if (i || s !== l) {
      if (s === "") {
        if (Gn(null), t_ || Ag || n_) o.remove();
        else {
          const g = mn();
          setTimeout(() => {
            g.update(() => {
              o.isAttached() && o.remove();
            });
          }, 20);
        }
        return;
      }
      const c = o.getParent(), f = jg(), d = o.getTextContentSize(), p = Sa(), m = o.getKey();
      if (o.isToken() || p !== null && m === p && !a || we(f) && (c !== null && !c.canInsertTextBefore() && f.anchor.offset === 0 || f.anchor.key === e.__key && f.anchor.offset === 0 && !o.canInsertTextBefore() && !a || f.focus.key === e.__key && f.focus.offset === d && !o.canInsertTextAfter() && !a)) return void o.markDirty();
      const y = Ne();
      if (!we(y) || n === null || r === null) return void o.setTextContent(s);
      if (y.setTextNodeRange(o, n, o, r), o.isSegmented()) {
        const g = Vn(o.getTextContent());
        o.replace(g), o = g;
      }
      o.setTextContent(s);
    }
  }
}
function eJ(e, t) {
  if (t.isSegmented()) return !0;
  if (!e.isCollapsed()) return !1;
  const n = e.anchor.offset, r = t.getParentOrThrow(), i = t.isToken();
  return n === 0 ? !t.canInsertTextBefore() || !r.canInsertTextBefore() && !t.isComposing() || i || function(o) {
    const a = o.getPreviousSibling();
    return (Se(a) || ye(a) && a.isInline()) && !a.canInsertTextAfter();
  }(t) : n === t.getTextContentSize() && (!t.canInsertTextAfter() || !r.canInsertTextAfter() && !t.isComposing() || i);
}
function wC(e) {
  return e === "ArrowLeft";
}
function _C(e) {
  return e === "ArrowRight";
}
function Bu(e, t) {
  return wi ? e : t;
}
function SC(e) {
  return e === "Enter";
}
function wu(e) {
  return e === "Backspace";
}
function _u(e) {
  return e === "Delete";
}
function OC(e, t, n) {
  return e.toLowerCase() === "a" && Bu(t, n);
}
function tJ() {
  const e = ir();
  zo(qZ(e.select(0, e.getChildrenSize())));
}
function Yu(e, t) {
  e.__lexicalClassNameCache === void 0 && (e.__lexicalClassNameCache = {});
  const n = e.__lexicalClassNameCache, r = n[t];
  if (r !== void 0) return r;
  const i = e[t];
  if (typeof i == "string") {
    const o = Ip(i);
    return n[t] = o, o;
  }
  return i;
}
function m_(e, t, n, r, i) {
  if (n.size === 0) return;
  const o = r.__type, a = r.__key, s = t.get(o);
  s === void 0 && _e(33, o);
  const l = s.klass;
  let c = e.get(l);
  c === void 0 && (c = /* @__PURE__ */ new Map(), e.set(l, c));
  const f = c.get(a), d = f === "destroyed" && i === "created";
  (f === void 0 || d) && c.set(a, d ? "updated" : i);
}
function AC(e, t, n) {
  const r = e.getParent();
  let i = n, o = e;
  return r !== null && (t && n === 0 ? (i = o.getIndexWithinParent(), o = r) : t || n !== o.getChildrenSize() || (i = o.getIndexWithinParent() + 1, o = r)), o.getChildAtIndex(t ? i - 1 : i);
}
function U0(e, t) {
  const n = e.offset;
  if (e.type === "element")
    return AC(e.getNode(), t, n);
  {
    const r = e.getNode();
    if (t && n === 0 || !t && n === r.getTextContentSize()) {
      const i = t ? r.getPreviousSibling() : r.getNextSibling();
      return i === null ? AC(r.getParentOrThrow(), t, r.getIndexWithinParent() + (t ? 0 : 1)) : i;
    }
  }
  return null;
}
function t2(e) {
  const t = Ng(e).event, n = t && t.inputType;
  return n === "insertFromPaste" || n === "insertFromPasteAsQuotation";
}
function Ae(e, t, n) {
  return P2(e, t, n);
}
function kg(e) {
  return !ur(e) && !e.isLastChild() && !e.isInline();
}
function Lp(e, t) {
  const n = e._keyToDOMMap.get(t);
  return n === void 0 && _e(75, t), n;
}
function Mg(e) {
  const t = e.assignedSlot || e.parentElement;
  return t !== null && t.nodeType === 11 ? t.host : t;
}
function H0(e, t) {
  let n = e.getParent();
  for (; n !== null; ) {
    if (n.is(t)) return !0;
    n = n.getParent();
  }
  return !1;
}
function Ng(e) {
  const t = e._window;
  return t === null && _e(78), t;
}
function nJ(e) {
  let t = e.getParentOrThrow();
  for (; t !== null; ) {
    if (gd(t)) return t;
    t = t.getParentOrThrow();
  }
  return t;
}
function gd(e) {
  return ur(e) || ye(e) && e.isShadowRoot();
}
function $g(e) {
  const t = mn(), n = e.constructor.getType(), r = t._nodes.get(n);
  r === void 0 && _e(97);
  const i = r.replace;
  if (i !== null) {
    const o = i(e);
    return o instanceof e.constructor || _e(98), o;
  }
  return e;
}
function pb(e, t) {
  !ur(e.getParent()) || ye(t) || Ht(t) || _e(99);
}
function mb(e) {
  return (Ht(e) || ye(e) && !e.canBeEmpty()) && !e.isInline();
}
function g_(e, t, n) {
  n.style.removeProperty("caret-color"), t._blockCursorElement = null;
  const r = e.parentElement;
  r !== null && r.removeChild(e);
}
function rJ(e, t, n) {
  let r = e._blockCursorElement;
  if (we(n) && n.isCollapsed() && n.anchor.type === "element" && t.contains(document.activeElement)) {
    const i = n.anchor, o = i.getNode(), a = i.offset;
    let s = !1, l = null;
    if (a === o.getChildrenSize())
      mb(o.getChildAtIndex(a - 1)) && (s = !0);
    else {
      const c = o.getChildAtIndex(a);
      if (mb(c)) {
        const f = c.getPreviousSibling();
        (f === null || mb(f)) && (s = !0, l = e.getElementByKey(c.__key));
      }
    }
    if (s) {
      const c = e.getElementByKey(o.__key);
      return r === null && (e._blockCursorElement = r = function(f) {
        const d = f.theme, p = document.createElement("div");
        p.contentEditable = "false", p.setAttribute("data-lexical-cursor", "true");
        let m = d.blockCursor;
        if (m !== void 0) {
          if (typeof m == "string") {
            const y = Ip(m);
            m = d.blockCursor = y;
          }
          m !== void 0 && p.classList.add(...m);
        }
        return p;
      }(e._config)), t.style.caretColor = "transparent", void (l === null ? c.appendChild(r) : c.insertBefore(r, l));
    }
  }
  r !== null && g_(r, e, t);
}
function to(e) {
  return Di ? (e || window).getSelection() : null;
}
function y_(e) {
  return e.nodeType === 1;
}
function iJ(e) {
  const t = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var|#text)$/, "i");
  return e.nodeName.match(t) !== null;
}
function TC(e) {
  const t = new RegExp(/^(address|article|aside|blockquote|canvas|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hr|li|main|nav|noscript|ol|p|pre|section|table|td|tfoot|ul|video)$/, "i");
  return e.nodeName.match(t) !== null;
}
function Tl(e) {
  if (ur(e) || Ht(e) && !e.isInline()) return !0;
  if (!ye(e) || gd(e)) return !1;
  const t = e.getFirstChild(), n = t === null || Zu(t) || Se(t) || t.isInline();
  return !e.isInline() && e.canBeEmpty() !== !1 && n;
}
function gb(e, t) {
  let n = e;
  for (; n !== null && n.getParent() !== null && !t(n); ) n = n.getParentOrThrow();
  return t(n) ? n : null;
}
const PC = /* @__PURE__ */ new WeakMap(), oJ = /* @__PURE__ */ new Map();
function aJ(e) {
  if (!e._readOnly && e.isEmpty()) return oJ;
  e._readOnly || _e(192);
  let t = PC.get(e);
  if (!t) {
    t = /* @__PURE__ */ new Map(), PC.set(e, t);
    for (const [n, r] of e._nodeMap) {
      const i = r.__type;
      let o = t.get(i);
      o || (o = /* @__PURE__ */ new Map(), t.set(i, o)), o.set(n, r);
    }
  }
  return t;
}
function n2(e) {
  const t = e.constructor.clone(e);
  return t.afterCloneFrom(e), t;
}
function r2(e, t, n, r, i, o) {
  let a = e.getFirstChild();
  for (; a !== null; ) {
    const s = a.__key;
    a.__parent === t && (ye(a) && r2(a, s, n, r, i, o), n.has(s) || o.delete(s), i.push(s)), a = a.getNextSibling();
  }
}
let Ba, pr, wf, Dg, K0, G0, js, ki, Y0, _f, wn = "", cr = "", Bi = null, _i = "", _o = "", i2 = !1, Sf = !1, up = null;
function Bp(e, t) {
  const n = js.get(e);
  if (t !== null) {
    const r = Z0(e);
    r.parentNode === t && t.removeChild(r);
  }
  if (ki.has(e) || pr._keyToDOMMap.delete(e), ye(n)) {
    const r = Wp(n, js);
    q0(r, 0, r.length - 1, null);
  }
  n !== void 0 && m_(_f, wf, Dg, n, "destroyed");
}
function q0(e, t, n, r) {
  let i = t;
  for (; i <= n; ++i) {
    const o = e[i];
    o !== void 0 && Bp(o, r);
  }
}
function ss(e, t) {
  e.setProperty("text-align", t);
}
const sJ = "40px";
function o2(e, t) {
  const n = Ba.theme.indent;
  if (typeof n == "string") {
    const i = e.classList.contains(n);
    t > 0 && !i ? e.classList.add(n) : t < 1 && i && e.classList.remove(n);
  }
  const r = getComputedStyle(e).getPropertyValue("--lexical-indent-base-value") || sJ;
  e.style.setProperty("padding-inline-start", t === 0 ? "" : `calc(${t} * ${r})`);
}
function a2(e, t) {
  const n = e.style;
  t === 0 ? ss(n, "") : t === i_ ? ss(n, "left") : t === o_ ? ss(n, "center") : t === a_ ? ss(n, "right") : t === s_ ? ss(n, "justify") : t === l_ ? ss(n, "start") : t === c_ && ss(n, "end");
}
function Fp(e, t, n) {
  const r = ki.get(e);
  r === void 0 && _e(60);
  const i = r.createDOM(Ba, pr);
  if (function(o, a, s) {
    const l = s._keyToDOMMap;
    a["__lexicalKey_" + s._key] = o, l.set(o, a);
  }(e, i, pr), Se(r) ? i.setAttribute("data-lexical-text", "true") : Ht(r) && i.setAttribute("data-lexical-decorator", "true"), ye(r)) {
    const o = r.__indent, a = r.__size;
    if (o !== 0 && o2(i, o), a !== 0) {
      const l = a - 1;
      (function(c, f, d, p) {
        const m = cr;
        cr = "", X0(c, d, 0, f, p, null), l2(d, p), cr = m;
      })(Wp(r, ki), l, r, i);
    }
    const s = r.__format;
    s !== 0 && a2(i, s), r.isInline() || s2(null, r, i), kg(r) && (wn += Wo, _o += Wo);
  } else {
    const o = r.getTextContent();
    if (Ht(r)) {
      const a = r.decorate(pr, Ba);
      a !== null && c2(e, a), i.contentEditable = "false";
    } else Se(r) && (r.isDirectionless() || (cr += o));
    wn += o, _o += o;
  }
  if (t !== null) if (n != null) t.insertBefore(i, n);
  else {
    const o = t.__lexicalLineBreak;
    o != null ? t.insertBefore(i, o) : t.appendChild(i);
  }
  return m_(_f, wf, Dg, r, "created"), i;
}
function X0(e, t, n, r, i, o) {
  const a = wn;
  wn = "";
  let s = n;
  for (; s <= r; ++s) {
    Fp(e[s], i, o);
    const l = ki.get(e[s]);
    l !== null && Se(l) && (Bi === null && (Bi = l.getFormat()), _i === "" && (_i = l.getStyle()));
  }
  kg(t) && (wn += Wo), i.__lexicalTextContent = wn, wn = a + wn;
}
function CC(e, t) {
  const n = t.get(e);
  return Zu(n) || Ht(n) && n.isInline();
}
function s2(e, t, n) {
  const r = e !== null && (e.__size === 0 || CC(e.__last, js)), i = t.__size === 0 || CC(t.__last, ki);
  if (r) {
    if (!i) {
      const o = n.__lexicalLineBreak;
      if (o != null) try {
        n.removeChild(o);
      } catch (a) {
        if (typeof a == "object" && a != null) {
          const s = `${a.toString()} Parent: ${n.tagName}, child: ${o.tagName}.`;
          throw new Error(s);
        }
        throw a;
      }
      n.__lexicalLineBreak = null;
    }
  } else if (i) {
    const o = document.createElement("br");
    n.__lexicalLineBreak = o, n.appendChild(o);
  }
}
function l2(e, t) {
  const n = t.__lexicalDirTextContent, r = t.__lexicalDir;
  if (n !== cr || r !== up) {
    const o = cr === "", a = o ? up : (i = cr, LZ.test(i) ? "rtl" : BZ.test(i) ? "ltr" : null);
    if (a !== r) {
      const s = t.classList, l = Ba.theme;
      let c = r !== null ? l[r] : void 0, f = a !== null ? l[a] : void 0;
      if (c !== void 0) {
        if (typeof c == "string") {
          const d = Ip(c);
          c = l[r] = d;
        }
        s.remove(...c);
      }
      if (a === null || o && a === "ltr") t.removeAttribute("dir");
      else {
        if (f !== void 0) {
          if (typeof f == "string") {
            const d = Ip(f);
            f = l[a] = d;
          }
          f !== void 0 && s.add(...f);
        }
        t.dir = a;
      }
      Sf || (e.getWritable().__dir = a);
    }
    up = a, t.__lexicalDirTextContent = cr, t.__lexicalDir = a;
  }
  var i;
}
function lJ(e, t, n) {
  const r = cr;
  var i;
  cr = "", Bi = null, _i = "", function(o, a, s) {
    const l = wn, c = o.__size, f = a.__size;
    if (wn = "", c === 1 && f === 1) {
      const d = o.__first, p = a.__first;
      if (d === p) Fu(d, s);
      else {
        const y = Z0(d), g = Fp(p, null, null);
        try {
          s.replaceChild(g, y);
        } catch (v) {
          if (typeof v == "object" && v != null) {
            const x = `${v.toString()} Parent: ${s.tagName}, new child: {tag: ${g.tagName} key: ${p}}, old child: {tag: ${y.tagName}, key: ${d}}.`;
            throw new Error(x);
          }
          throw v;
        }
        Bp(d, null);
      }
      const m = ki.get(p);
      Se(m) && (Bi === null && (Bi = m.getFormat()), _i === "" && (_i = m.getStyle()));
    } else {
      const d = Wp(o, js), p = Wp(a, ki);
      if (c === 0) f !== 0 && X0(p, a, 0, f - 1, s, null);
      else if (f === 0) {
        if (c !== 0) {
          const m = s.__lexicalLineBreak == null;
          q0(d, 0, c - 1, m ? null : s), m && (s.textContent = "");
        }
      } else (function(m, y, g, v, x, w) {
        const S = v - 1, A = x - 1;
        let _, O, P = (D = w, D.firstChild), C = 0, k = 0;
        for (var D; C <= S && k <= A; ) {
          const R = y[C], L = g[k];
          if (R === L) P = yb(Fu(L, w)), C++, k++;
          else {
            _ === void 0 && (_ = new Set(y)), O === void 0 && (O = new Set(g));
            const W = O.has(R), z = _.has(L);
            if (W) if (z) {
              const G = Lp(pr, L);
              G === P ? P = yb(Fu(L, w)) : (P != null ? w.insertBefore(G, P) : w.appendChild(G), Fu(L, w)), C++, k++;
            } else Fp(L, w, P), k++;
            else P = yb(Z0(R)), Bp(R, w), C++;
          }
          const F = ki.get(L);
          F !== null && Se(F) && (Bi === null && (Bi = F.getFormat()), _i === "" && (_i = F.getStyle()));
        }
        const $ = C > S, N = k > A;
        if ($ && !N) {
          const R = g[A + 1];
          X0(g, m, k, A, w, R === void 0 ? null : pr.getElementByKey(R));
        } else N && !$ && q0(y, C, S, w);
      })(a, d, p, c, f, s);
    }
    kg(a) && (wn += Wo), s.__lexicalTextContent = wn, wn = l + wn;
  }(e, t, n), l2(t, n), ix(i = t) && Bi != null && Bi !== i.__textFormat && !Sf && (i.setTextFormat(Bi), i.setTextStyle(_i)), function(o) {
    ix(o) && _i !== "" && _i !== o.__textStyle && !Sf && o.setTextStyle(_i);
  }(t), cr = r;
}
function Wp(e, t) {
  const n = [];
  let r = e.__first;
  for (; r !== null; ) {
    const i = t.get(r);
    i === void 0 && _e(101), n.push(r), r = i.__next;
  }
  return n;
}
function Fu(e, t) {
  const n = js.get(e);
  let r = ki.get(e);
  n !== void 0 && r !== void 0 || _e(61);
  const i = i2 || G0.has(e) || K0.has(e), o = Lp(pr, e);
  if (n === r && !i) {
    if (ye(n)) {
      const a = o.__lexicalTextContent;
      a !== void 0 && (wn += a, _o += a);
      const s = o.__lexicalDirTextContent;
      s !== void 0 && (cr += s);
    } else {
      const a = n.getTextContent();
      Se(n) && !n.isDirectionless() && (cr += a), _o += a, wn += a;
    }
    return o;
  }
  if (n !== r && i && m_(_f, wf, Dg, r, "updated"), r.updateDOM(n, o, Ba)) {
    const a = Fp(e, null, null);
    return t === null && _e(62), t.replaceChild(a, o), Bp(e, null), a;
  }
  if (ye(n) && ye(r)) {
    const a = r.__indent;
    a !== n.__indent && o2(o, a);
    const s = r.__format;
    s !== n.__format && a2(o, s), i && (lJ(n, r, o), ur(r) || r.isInline() || s2(n, r, o)), kg(r) && (wn += Wo, _o += Wo);
  } else {
    const a = r.getTextContent();
    if (Ht(r)) {
      const s = r.decorate(pr, Ba);
      s !== null && c2(e, s);
    } else Se(r) && !r.isDirectionless() && (cr += a);
    wn += a, _o += a;
  }
  if (!Sf && ur(r) && r.__cachedText !== _o) {
    const a = r.getWritable();
    a.__cachedText = _o, r = a;
  }
  return o;
}
function c2(e, t) {
  let n = pr._pendingDecorators;
  const r = pr._decorators;
  if (n === null) {
    if (r[e] === t) return;
    n = XR(pr);
  }
  n[e] = t;
}
function yb(e) {
  let t = e.nextSibling;
  return t !== null && t === pr._blockCursorElement && (t = t.nextSibling), t;
}
function cJ(e, t, n, r, i, o) {
  wn = "", _o = "", cr = "", i2 = r === ec, up = null, pr = n, Ba = n._config, wf = n._nodes, Dg = pr._listeners.mutation, K0 = i, G0 = o, js = e._nodeMap, ki = t._nodeMap, Sf = t._readOnly, Y0 = new Map(n._keyToDOMMap);
  const a = /* @__PURE__ */ new Map();
  return _f = a, Fu("root", null), pr = void 0, wf = void 0, K0 = void 0, G0 = void 0, js = void 0, ki = void 0, Ba = void 0, Y0 = void 0, _f = void 0, a;
}
function Z0(e) {
  const t = Y0.get(e);
  return t === void 0 && _e(75, e), t;
}
const bo = Object.freeze({}), J0 = 30, Q0 = [["keydown", function(e, t) {
  if (qu = e.timeStamp, u2 = e.key, t.isComposing()) return;
  const { key: n, shiftKey: r, ctrlKey: i, metaKey: o, altKey: a } = e;
  Ae(t, NR, e) || n != null && (function(s, l, c, f) {
    return _C(s) && !l && !f && !c;
  }(n, i, a, o) ? Ae(t, X1, e) : function(s, l, c, f, d) {
    return _C(s) && !f && !c && (l || d);
  }(n, i, r, a, o) ? Ae(t, xZ, e) : function(s, l, c, f) {
    return wC(s) && !l && !f && !c;
  }(n, i, a, o) ? Ae(t, Z1, e) : function(s, l, c, f, d) {
    return wC(s) && !f && !c && (l || d);
  }(n, i, r, a, o) ? Ae(t, wZ, e) : /* @__PURE__ */ function(s, l, c) {
    return /* @__PURE__ */ function(f) {
      return f === "ArrowUp";
    }(s) && !l && !c;
  }(n, i, o) ? Ae(t, $R, e) : /* @__PURE__ */ function(s, l, c) {
    return /* @__PURE__ */ function(f) {
      return f === "ArrowDown";
    }(s) && !l && !c;
  }(n, i, o) ? Ae(t, DR, e) : function(s, l) {
    return SC(s) && l;
  }(n, r) ? (Xu = !0, Ae(t, xf, e)) : /* @__PURE__ */ function(s) {
    return s === " ";
  }(n) ? Ae(t, _Z, e) : function(s, l) {
    return wi && l && s.toLowerCase() === "o";
  }(n, i) ? (e.preventDefault(), Xu = !0, Ae(t, Vl, !0)) : function(s, l) {
    return SC(s) && !l;
  }(n, r) ? (Xu = !1, Ae(t, xf, e)) : function(s, l, c, f) {
    return wi ? !l && !c && (wu(s) || s.toLowerCase() === "h" && f) : !(f || l || c) && wu(s);
  }(n, a, o, i) ? wu(n) ? Ae(t, J1, e) : (e.preventDefault(), Ae(t, Cs, !0)) : /* @__PURE__ */ function(s) {
    return s === "Escape";
  }(n) ? Ae(t, IR, e) : function(s, l, c, f, d) {
    return wi ? !(c || f || d) && (_u(s) || s.toLowerCase() === "d" && l) : !(l || f || d) && _u(s);
  }(n, i, r, a, o) ? _u(n) ? Ae(t, RR, e) : (e.preventDefault(), Ae(t, Cs, !1)) : function(s, l, c) {
    return wu(s) && (wi ? l : c);
  }(n, a, i) ? (e.preventDefault(), Ae(t, vf, !0)) : function(s, l, c) {
    return _u(s) && (wi ? l : c);
  }(n, a, i) ? (e.preventDefault(), Ae(t, vf, !1)) : function(s, l) {
    return wi && l && wu(s);
  }(n, o) ? (e.preventDefault(), Ae(t, bf, !0)) : function(s, l) {
    return wi && l && _u(s);
  }(n, o) ? (e.preventDefault(), Ae(t, bf, !1)) : function(s, l, c, f) {
    return s.toLowerCase() === "b" && !l && Bu(c, f);
  }(n, a, o, i) ? (e.preventDefault(), Ae(t, xs, "bold")) : function(s, l, c, f) {
    return s.toLowerCase() === "u" && !l && Bu(c, f);
  }(n, a, o, i) ? (e.preventDefault(), Ae(t, xs, "underline")) : function(s, l, c, f) {
    return s.toLowerCase() === "i" && !l && Bu(c, f);
  }(n, a, o, i) ? (e.preventDefault(), Ae(t, xs, "italic")) : /* @__PURE__ */ function(s, l, c, f) {
    return s === "Tab" && !l && !c && !f;
  }(n, a, i, o) ? Ae(t, jR, e) : function(s, l, c, f) {
    return s.toLowerCase() === "z" && !l && Bu(c, f);
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, Y1, void 0)) : function(s, l, c, f) {
    return wi ? s.toLowerCase() === "z" && c && l : s.toLowerCase() === "y" && f || s.toLowerCase() === "z" && f && l;
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, q1, void 0)) : Rg(t._editorState._selection) ? function(s, l, c, f) {
    return !l && s.toLowerCase() === "c" && (wi ? c : f);
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, Q1, e)) : function(s, l, c, f) {
    return !l && s.toLowerCase() === "x" && (wi ? c : f);
  }(n, r, o, i) ? (e.preventDefault(), Ae(t, e_, e)) : OC(n, o, i) && (e.preventDefault(), Ae(t, W0, e)) : !ka && OC(n, o, i) && (e.preventDefault(), Ae(t, W0, e)), /* @__PURE__ */ function(s, l, c, f) {
    return s || l || c || f;
  }(i, r, a, o) && Ae(t, EZ, e));
}], ["pointerdown", function(e, t) {
  const n = e.target, r = e.pointerType;
  n instanceof Node && r !== "touch" && Fr(t, () => {
    Ht(Eg(n)) || (tx = !0);
  });
}], ["compositionstart", function(e, t) {
  Fr(t, () => {
    const n = Ne();
    if (we(n) && !t.isComposing()) {
      const r = n.anchor, i = n.anchor.getNode();
      Gn(r.key), (e.timeStamp < qu + J0 || r.type === "element" || !n.isCollapsed() || i.getFormat() !== n.format || Se(i) && i.getStyle() !== n.style) && Ae(t, Ul, jZ);
    }
  });
}], ["compositionend", function(e, t) {
  ka ? Su = !0 : Fr(t, () => {
    vb(t, e.data);
  });
}], ["input", function(e, t) {
  e.stopPropagation(), Fr(t, () => {
    const n = Ne(), r = e.data, i = p2(e);
    if (r != null && we(n) && h2(n, i, r, e.timeStamp, !1)) {
      Su && (vb(t, r), Su = !1);
      const o = n.anchor.getNode(), a = to(t._window);
      if (a === null) return;
      const s = n.isBackward(), l = s ? n.anchor.offset : n.focus.offset, c = s ? n.focus.offset : n.anchor.offset;
      Np && !n.isCollapsed() && Se(o) && a.anchorNode !== null && o.getTextContent().slice(0, l) + r + o.getTextContent().slice(l + c) === e2(a.anchorNode) || Ae(t, Ul, r);
      const f = r.length;
      ka && f > 1 && e.inputType === "insertCompositionText" && !t.isComposing() && (n.anchor.offset -= f), t_ || Ag || n_ || !t.isComposing() || (qu = 0, Gn(null));
    } else
      h_(!1, t, r !== null ? r : void 0), Su && (vb(t, r || void 0), Su = !1);
    wr(), HR(mn());
  }), Pl = null;
}], ["click", function(e, t) {
  Fr(t, () => {
    const n = Ne(), r = to(t._window), i = jg();
    if (r) {
      if (we(n)) {
        const o = n.anchor, a = o.getNode();
        o.type === "element" && o.offset === 0 && n.isCollapsed() && !ur(a) && ir().getChildrenSize() === 1 && a.getTopLevelElementOrThrow().isEmpty() && i !== null && n.is(i) ? (r.removeAllRanges(), n.dirty = !0) : e.detail === 3 && !n.isCollapsed() && a !== n.focus.getNode() && (ye(a) ? a.select(0) : a.getParentOrThrow().select(0));
      } else if (e.pointerType === "touch") {
        const o = r.anchorNode;
        if (o !== null) {
          const a = o.nodeType;
          (a === md || a === Va) && zo(x_(i, r, t, e));
        }
      }
    }
    Ae(t, bZ, e);
  });
}], ["cut", bo], ["copy", bo], ["dragstart", bo], ["dragover", bo], ["dragend", bo], ["paste", bo], ["focus", bo], ["blur", bo], ["drop", bo]];
Np && Q0.push(["beforeinput", (e, t) => function(n, r) {
  const i = n.inputType, o = p2(n);
  i === "deleteCompositionText" || ka && t2(r) || i !== "insertCompositionText" && Fr(r, () => {
    const a = Ne();
    if (i === "deleteContentBackward") {
      if (a === null) {
        const m = jg();
        if (!we(m)) return;
        zo(m.clone());
      }
      if (we(a)) {
        const m = a.anchor.key === a.focus.key;
        if (s = n.timeStamp, u2 === "MediaLast" && s < qu + J0 && r.isComposing() && m) {
          if (Gn(null), qu = 0, setTimeout(() => {
            Fr(r, () => {
              Gn(null);
            });
          }, J0), we(a)) {
            const y = a.anchor.getNode();
            y.markDirty(), a.format = y.getFormat(), Se(y) || _e(142), a.style = y.getStyle();
          }
        } else {
          Gn(null), n.preventDefault();
          const y = a.anchor.getNode().getTextContent(), g = a.anchor.offset === 0 && a.focus.offset === y.length;
          NZ && m && !g || Ae(r, Cs, !0);
        }
        return;
      }
    }
    var s;
    if (!we(a)) return;
    const l = n.data;
    Pl !== null && h_(!1, r, Pl), a.dirty && Pl === null || !a.isCollapsed() || ur(a.anchor.getNode()) || o === null || a.applyDOMRange(o), Pl = null;
    const c = a.anchor, f = a.focus, d = c.getNode(), p = f.getNode();
    if (i !== "insertText" && i !== "insertTranspose") switch (n.preventDefault(), i) {
      case "insertFromYank":
      case "insertFromDrop":
      case "insertReplacementText":
        Ae(r, Ul, n);
        break;
      case "insertFromComposition":
        Gn(null), Ae(r, Ul, n);
        break;
      case "insertLineBreak":
        Gn(null), Ae(r, Vl, !1);
        break;
      case "insertParagraph":
        Gn(null), Xu && !Ag ? (Xu = !1, Ae(r, Vl, !1)) : Ae(r, B0, void 0);
        break;
      case "insertFromPaste":
      case "insertFromPasteAsQuotation":
        Ae(r, G1, n);
        break;
      case "deleteByComposition":
        (function(m, y) {
          return m !== y || ye(m) || ye(y) || !m.isToken() || !y.isToken();
        })(d, p) && Ae(r, F0, n);
        break;
      case "deleteByDrag":
      case "deleteByCut":
        Ae(r, F0, n);
        break;
      case "deleteContent":
        Ae(r, Cs, !1);
        break;
      case "deleteWordBackward":
        Ae(r, vf, !0);
        break;
      case "deleteWordForward":
        Ae(r, vf, !1);
        break;
      case "deleteHardLineBackward":
      case "deleteSoftLineBackward":
        Ae(r, bf, !0);
        break;
      case "deleteContentForward":
      case "deleteHardLineForward":
      case "deleteSoftLineForward":
        Ae(r, bf, !1);
        break;
      case "formatStrikeThrough":
        Ae(r, xs, "strikethrough");
        break;
      case "formatBold":
        Ae(r, xs, "bold");
        break;
      case "formatItalic":
        Ae(r, xs, "italic");
        break;
      case "formatUnderline":
        Ae(r, xs, "underline");
        break;
      case "historyUndo":
        Ae(r, Y1, void 0);
        break;
      case "historyRedo":
        Ae(r, q1, void 0);
    }
    else {
      if (l === `
`) n.preventDefault(), Ae(r, Vl, !1);
      else if (l === Wo) n.preventDefault(), Ae(r, B0, void 0);
      else if (l == null && n.dataTransfer) {
        const m = n.dataTransfer.getData("text/plain");
        n.preventDefault(), a.insertRawText(m);
      } else l != null && h2(a, o, l, n.timeStamp, !0) ? (n.preventDefault(), Ae(r, Ul, l)) : Pl = l;
      f2 = n.timeStamp;
    }
  });
}(e, t)]);
let qu = 0, u2 = null, f2 = 0, Pl = null;
const zp = /* @__PURE__ */ new WeakMap();
let ex = !1, tx = !1, Xu = !1, Su = !1, d2 = [0, "", 0, "root", 0];
function h2(e, t, n, r, i) {
  const o = e.anchor, a = e.focus, s = o.getNode(), l = mn(), c = to(l._window), f = c !== null ? c.anchorNode : null, d = o.key, p = l.getElementByKey(d), m = n.length;
  return d !== a.key || !Se(s) || (!i && (!Np || f2 < r + 50) || s.isDirty() && m < 2 || JR(n)) && o.offset !== a.offset && !s.isComposing() || Al(s) || s.isDirty() && m > 1 || (i || !Np) && p !== null && !s.isComposing() && f !== Rp(p) || c !== null && t !== null && (!t.collapsed || t.startContainer !== c.anchorNode || t.startOffset !== c.anchorOffset) || s.getFormat() !== e.format || s.getStyle() !== e.style || eJ(e, s);
}
function EC(e, t) {
  return e !== null && e.nodeValue !== null && e.nodeType === Va && t !== 0 && t !== e.nodeValue.length;
}
function kC(e, t, n) {
  const { anchorNode: r, anchorOffset: i, focusNode: o, focusOffset: a } = e;
  ex && (ex = !1, EC(r, i) && EC(o, a)) || Fr(t, () => {
    if (!n) return void zo(null);
    if (!Pg(t, r, o)) return;
    const s = Ne();
    if (we(s)) {
      const l = s.anchor, c = l.getNode();
      if (s.isCollapsed()) {
        e.type === "Range" && e.anchorNode === e.focusNode && (s.dirty = !0);
        const f = Ng(t).event, d = f ? f.timeStamp : performance.now(), [p, m, y, g, v] = d2, x = ir(), w = t.isComposing() === !1 && x.getTextContent() === "";
        if (d < v + 200 && l.offset === y && l.key === g) s.format = p, s.style = m;
        else if (l.type === "text") Se(c) || _e(141), s.format = c.getFormat(), s.style = c.getStyle();
        else if (l.type === "element" && !w) {
          const S = l.getNode();
          s.style = "", S instanceof jc && S.getChildrenSize() === 0 ? (s.format = S.getTextFormat(), s.style = S.getTextStyle()) : s.format = 0;
        }
      } else {
        const f = l.key, d = s.focus.key, p = s.getNodes(), m = p.length, y = s.isBackward(), g = y ? a : i, v = y ? i : a, x = y ? d : f, w = y ? f : d;
        let S = RZ, A = !1;
        for (let _ = 0; _ < m; _++) {
          const O = p[_], P = O.getTextContentSize();
          if (Se(O) && P !== 0 && !(_ === 0 && O.__key === x && g === P || _ === m - 1 && O.__key === w && v === 0) && (A = !0, S &= O.getFormat(), S === 0)) break;
        }
        s.format = A ? S : 0;
      }
    }
    Ae(t, K1, void 0);
  });
}
function p2(e) {
  if (!e.getTargetRanges) return null;
  const t = e.getTargetRanges();
  return t.length === 0 ? null : t[0];
}
function vb(e, t) {
  const n = e._compositionKey;
  if (Gn(null), n !== null && t != null) {
    if (t === "") {
      const r = $n(n), i = Rp(e.getElementByKey(n));
      return void (i !== null && i.nodeValue !== null && Se(r) && p_(r, i.nodeValue, null, null, !0));
    }
    if (t[t.length - 1] === `
`) {
      const r = Ne();
      if (we(r)) {
        const i = r.focus;
        return r.anchor.set(i.key, i.offset, i.type), void Ae(e, xf, null);
      }
    }
  }
  h_(!0, e, t);
}
function m2(e) {
  let t = e.__lexicalEventHandles;
  return t === void 0 && (t = [], e.__lexicalEventHandles = t), t;
}
const Hl = /* @__PURE__ */ new Map();
function g2(e) {
  const t = e.target, n = to(t == null ? null : t.nodeType === 9 ? t.defaultView : t.ownerDocument.defaultView);
  if (n === null) return;
  const r = YR(n.anchorNode);
  if (r === null) return;
  tx && (tx = !1, Fr(r, () => {
    const c = jg(), f = n.anchorNode;
    if (f === null) return;
    const d = f.nodeType;
    d !== md && d !== Va || zo(x_(c, n, r, e));
  }));
  const i = d_(r), o = i[i.length - 1], a = o._key, s = Hl.get(a), l = s || o;
  l !== r && kC(n, l, !1), kC(n, r, !0), r !== o ? Hl.set(a, r) : s && Hl.delete(a);
}
function MC(e) {
  e._lexicalHandled = !0;
}
function NC(e) {
  return e._lexicalHandled === !0;
}
function uJ(e) {
  const t = e.ownerDocument, n = zp.get(t);
  n === void 0 && _e(162);
  const r = n - 1;
  r >= 0 || _e(164), zp.set(t, r), r === 0 && t.removeEventListener("selectionchange", g2);
  const i = Cg(e);
  f_(i) ? (function(a) {
    if (a._parentEditor !== null) {
      const s = d_(a), l = s[s.length - 1]._key;
      Hl.get(l) === a && Hl.delete(l);
    } else Hl.delete(a._key);
  }(i), e.__lexicalEditor = null) : i && _e(198);
  const o = m2(e);
  for (let a = 0; a < o.length; a++) o[a]();
  e.__lexicalEventHandles = [];
}
function nx(e, t, n) {
  wr();
  const r = e.__key, i = e.getParent();
  if (i === null) return;
  const o = function(s) {
    const l = Ne();
    if (!we(l) || !ye(s)) return l;
    const { anchor: c, focus: f } = l, d = c.getNode(), p = f.getNode();
    return H0(d, s) && c.set(s.__key, 0, "element"), H0(p, s) && f.set(s.__key, 0, "element"), l;
  }(e);
  let a = !1;
  if (we(o) && t) {
    const s = o.anchor, l = o.focus;
    s.key === r && (Up(s, e, i, e.getPreviousSibling(), e.getNextSibling()), a = !0), l.key === r && (Up(l, e, i, e.getPreviousSibling(), e.getNextSibling()), a = !0);
  } else Rg(o) && t && e.isSelected() && e.selectPrevious();
  if (we(o) && t && !a) {
    const s = e.getIndexWithinParent();
    Es(e), Vp(o, i, s, -1);
  } else Es(e);
  n || gd(i) || i.canBeEmpty() || !i.isEmpty() || nx(i, t), t && ur(i) && i.isEmpty() && i.selectEnd();
}
class Ig {
  static getType() {
    _e(64, this.name);
  }
  static clone(t) {
    _e(65, this.name);
  }
  afterCloneFrom(t) {
    this.__parent = t.__parent, this.__next = t.__next, this.__prev = t.__prev;
  }
  constructor(t) {
    this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, QZ(this, t);
  }
  getType() {
    return this.__type;
  }
  isInline() {
    _e(137, this.constructor.name);
  }
  isAttached() {
    let t = this.__key;
    for (; t !== null; ) {
      if (t === "root") return !0;
      const n = $n(t);
      if (n === null) break;
      t = n.__parent;
    }
    return !1;
  }
  isSelected(t) {
    const n = t || Ne();
    if (n == null) return !1;
    const r = n.getNodes().some((i) => i.__key === this.__key);
    if (Se(this)) return r;
    if (we(n) && n.anchor.type === "element" && n.focus.type === "element") {
      if (n.isCollapsed()) return !1;
      const i = this.getParent();
      if (Ht(this) && this.isInline() && i) {
        const o = n.isBackward() ? n.focus : n.anchor, a = o.getNode();
        if (o.offset === a.getChildrenSize() && a.is(i) && a.getLastChildOrThrow().is(this)) return !1;
      }
    }
    return r;
  }
  getKey() {
    return this.__key;
  }
  getIndexWithinParent() {
    const t = this.getParent();
    if (t === null) return -1;
    let n = t.getFirstChild(), r = 0;
    for (; n !== null; ) {
      if (this.is(n)) return r;
      r++, n = n.getNextSibling();
    }
    return -1;
  }
  getParent() {
    const t = this.getLatest().__parent;
    return t === null ? null : $n(t);
  }
  getParentOrThrow() {
    const t = this.getParent();
    return t === null && _e(66, this.__key), t;
  }
  getTopLevelElement() {
    let t = this;
    for (; t !== null; ) {
      const n = t.getParent();
      if (gd(n)) return ye(t) || t === this && Ht(t) || _e(194), t;
      t = n;
    }
    return null;
  }
  getTopLevelElementOrThrow() {
    const t = this.getTopLevelElement();
    return t === null && _e(67, this.__key), t;
  }
  getParents() {
    const t = [];
    let n = this.getParent();
    for (; n !== null; ) t.push(n), n = n.getParent();
    return t;
  }
  getParentKeys() {
    const t = [];
    let n = this.getParent();
    for (; n !== null; ) t.push(n.__key), n = n.getParent();
    return t;
  }
  getPreviousSibling() {
    const t = this.getLatest().__prev;
    return t === null ? null : $n(t);
  }
  getPreviousSiblings() {
    const t = [], n = this.getParent();
    if (n === null) return t;
    let r = n.getFirstChild();
    for (; r !== null && !r.is(this); ) t.push(r), r = r.getNextSibling();
    return t;
  }
  getNextSibling() {
    const t = this.getLatest().__next;
    return t === null ? null : $n(t);
  }
  getNextSiblings() {
    const t = [];
    let n = this.getNextSibling();
    for (; n !== null; ) t.push(n), n = n.getNextSibling();
    return t;
  }
  getCommonAncestor(t) {
    const n = this.getParents(), r = t.getParents();
    ye(this) && n.unshift(this), ye(t) && r.unshift(t);
    const i = n.length, o = r.length;
    if (i === 0 || o === 0 || n[i - 1] !== r[o - 1]) return null;
    const a = new Set(r);
    for (let s = 0; s < i; s++) {
      const l = n[s];
      if (a.has(l)) return l;
    }
    return null;
  }
  is(t) {
    return t != null && this.__key === t.__key;
  }
  isBefore(t) {
    if (this === t) return !1;
    if (t.isParentOf(this)) return !0;
    if (this.isParentOf(t)) return !1;
    const n = this.getCommonAncestor(t);
    let r = 0, i = 0, o = this;
    for (; ; ) {
      const a = o.getParentOrThrow();
      if (a === n) {
        r = o.getIndexWithinParent();
        break;
      }
      o = a;
    }
    for (o = t; ; ) {
      const a = o.getParentOrThrow();
      if (a === n) {
        i = o.getIndexWithinParent();
        break;
      }
      o = a;
    }
    return r < i;
  }
  isParentOf(t) {
    const n = this.__key;
    if (n === t.__key) return !1;
    let r = t;
    for (; r !== null; ) {
      if (r.__key === n) return !0;
      r = r.getParent();
    }
    return !1;
  }
  getNodesBetween(t) {
    const n = this.isBefore(t), r = [], i = /* @__PURE__ */ new Set();
    let o = this;
    for (; o !== null; ) {
      const a = o.__key;
      if (i.has(a) || (i.add(a), r.push(o)), o === t) break;
      const s = ye(o) ? n ? o.getFirstChild() : o.getLastChild() : null;
      if (s !== null) {
        o = s;
        continue;
      }
      const l = n ? o.getNextSibling() : o.getPreviousSibling();
      if (l !== null) {
        o = l;
        continue;
      }
      const c = o.getParentOrThrow();
      if (i.has(c.__key) || r.push(c), c === t) break;
      let f = null, d = c;
      do {
        if (d === null && _e(68), f = n ? d.getNextSibling() : d.getPreviousSibling(), d = d.getParent(), d === null) break;
        f !== null || i.has(d.__key) || r.push(d);
      } while (f === null);
      o = f;
    }
    return n || r.reverse(), r;
  }
  isDirty() {
    const t = mn()._dirtyLeaves;
    return t !== null && t.has(this.__key);
  }
  getLatest() {
    const t = $n(this.__key);
    return t === null && _e(113), t;
  }
  getWritable() {
    wr();
    const t = Yo(), n = mn(), r = t._nodeMap, i = this.__key, o = this.getLatest(), a = n._cloneNotNeeded, s = Ne();
    if (s !== null && s.setCachedNodes(null), a.has(i)) return jp(o), o;
    const l = n2(o);
    return a.add(i), jp(l), r.set(i, l), l;
  }
  getTextContent() {
    return "";
  }
  getTextContentSize() {
    return this.getTextContent().length;
  }
  createDOM(t, n) {
    _e(70);
  }
  updateDOM(t, n, r) {
    _e(71);
  }
  exportDOM(t) {
    return { element: this.createDOM(t._config, t) };
  }
  exportJSON() {
    _e(72);
  }
  static importJSON(t) {
    _e(18, this.name);
  }
  static transform() {
    return null;
  }
  remove(t) {
    nx(this, !0, t);
  }
  replace(t, n) {
    wr();
    let r = Ne();
    r !== null && (r = r.clone()), pb(this, t);
    const i = this.getLatest(), o = this.__key, a = t.__key, s = t.getWritable(), l = this.getParentOrThrow().getWritable(), c = l.__size;
    Es(s);
    const f = i.getPreviousSibling(), d = i.getNextSibling(), p = i.__prev, m = i.__next, y = i.__parent;
    if (nx(i, !1, !0), f === null ? l.__first = a : f.getWritable().__next = a, s.__prev = p, d === null ? l.__last = a : d.getWritable().__prev = a, s.__next = m, s.__parent = y, l.__size = c, n && (ye(this) && ye(s) || _e(139), this.getChildren().forEach((g) => {
      s.append(g);
    })), we(r)) {
      zo(r);
      const g = r.anchor, v = r.focus;
      g.key === o && RC(g, s), v.key === o && RC(v, s);
    }
    return Sa() === o && Gn(a), s;
  }
  insertAfter(t, n = !0) {
    wr(), pb(this, t);
    const r = this.getWritable(), i = t.getWritable(), o = i.getParent(), a = Ne();
    let s = !1, l = !1;
    if (o !== null) {
      const m = t.getIndexWithinParent();
      if (Es(i), we(a)) {
        const y = o.__key, g = a.anchor, v = a.focus;
        s = g.type === "element" && g.key === y && g.offset === m + 1, l = v.type === "element" && v.key === y && v.offset === m + 1;
      }
    }
    const c = this.getNextSibling(), f = this.getParentOrThrow().getWritable(), d = i.__key, p = r.__next;
    if (c === null ? f.__last = d : c.getWritable().__prev = d, f.__size++, r.__next = d, i.__next = p, i.__prev = r.__key, i.__parent = r.__parent, n && we(a)) {
      const m = this.getIndexWithinParent();
      Vp(a, f, m + 1);
      const y = f.__key;
      s && a.anchor.set(y, m + 2, "element"), l && a.focus.set(y, m + 2, "element");
    }
    return t;
  }
  insertBefore(t, n = !0) {
    wr(), pb(this, t);
    const r = this.getWritable(), i = t.getWritable(), o = i.__key;
    Es(i);
    const a = this.getPreviousSibling(), s = this.getParentOrThrow().getWritable(), l = r.__prev, c = this.getIndexWithinParent();
    a === null ? s.__first = o : a.getWritable().__next = o, s.__size++, r.__prev = o, i.__prev = l, i.__next = r.__key, i.__parent = r.__parent;
    const f = Ne();
    return n && we(f) && Vp(f, this.getParentOrThrow(), c), t;
  }
  isParentRequired() {
    return !1;
  }
  createParentElementNode() {
    return Io();
  }
  selectStart() {
    return this.selectPrevious();
  }
  selectEnd() {
    return this.selectNext(0, 0);
  }
  selectPrevious(t, n) {
    wr();
    const r = this.getPreviousSibling(), i = this.getParentOrThrow();
    if (r === null) return i.select(0, 0);
    if (ye(r)) return r.select();
    if (!Se(r)) {
      const o = r.getIndexWithinParent() + 1;
      return i.select(o, o);
    }
    return r.select(t, n);
  }
  selectNext(t, n) {
    wr();
    const r = this.getNextSibling(), i = this.getParentOrThrow();
    if (r === null) return i.select();
    if (ye(r)) return r.select(0, 0);
    if (!Se(r)) {
      const o = r.getIndexWithinParent();
      return i.select(o, o);
    }
    return r.select(t, n);
  }
  markDirty() {
    this.getWritable();
  }
}
class yd extends Ig {
  static getType() {
    return "linebreak";
  }
  static clone(t) {
    return new yd(t.__key);
  }
  constructor(t) {
    super(t);
  }
  getTextContent() {
    return `
`;
  }
  createDOM() {
    return document.createElement("br");
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { br: (t) => function(n) {
      const r = n.parentElement;
      if (r !== null && TC(r)) {
        const i = r.firstChild;
        if (i === n || i.nextSibling === n && Lh(i)) {
          const o = r.lastChild;
          if (o === n || o.previousSibling === n && Lh(o)) return !0;
        }
      }
      return !1;
    }(t) || function(n) {
      const r = n.parentElement;
      if (r !== null && TC(r)) {
        const i = r.firstChild;
        if (i === n || i.nextSibling === n && Lh(i)) return !1;
        const o = r.lastChild;
        if (o === n || o.previousSibling === n && Lh(o)) return !0;
      }
      return !1;
    }(t) ? null : { conversion: fJ, priority: 0 } };
  }
  static importJSON(t) {
    return Of();
  }
  exportJSON() {
    return { type: "linebreak", version: 1 };
  }
}
function fJ(e) {
  return { node: Of() };
}
function Of() {
  return $g(new yd());
}
function Zu(e) {
  return e instanceof yd;
}
function Lh(e) {
  return e.nodeType === Va && /^( |\t|\r?\n)+$/.test(e.textContent || "");
}
function bb(e, t) {
  return 16 & t ? "code" : t & r_ ? "mark" : 32 & t ? "sub" : 64 & t ? "sup" : null;
}
function xb(e, t) {
  return 1 & t ? "strong" : 2 & t ? "em" : "span";
}
function y2(e, t, n, r, i) {
  const o = r.classList;
  let a = Yu(i, "base");
  a !== void 0 && o.add(...a), a = Yu(i, "underlineStrikethrough");
  let s = !1;
  const l = t & Dp && t & $p;
  a !== void 0 && (n & Dp && n & $p ? (s = !0, l || o.add(...a)) : l && o.remove(...a));
  for (const c in Do) {
    const f = Do[c];
    if (a = Yu(i, c), a !== void 0) if (n & f) {
      if (s && (c === "underline" || c === "strikethrough")) {
        t & f && o.remove(...a);
        continue;
      }
      t & f && (!l || c !== "underline") && c !== "strikethrough" || o.add(...a);
    } else t & f && o.remove(...a);
  }
}
function v2(e, t, n) {
  const r = t.firstChild, i = n.isComposing(), o = e + (i ? Tg : "");
  if (r == null) t.textContent = o;
  else {
    const a = r.nodeValue;
    if (a !== o) if (i || ka) {
      const [s, l, c] = function(f, d) {
        const p = f.length, m = d.length;
        let y = 0, g = 0;
        for (; y < p && y < m && f[y] === d[y]; ) y++;
        for (; g + y < p && g + y < m && f[p - g - 1] === d[m - g - 1]; ) g++;
        return [y, p - y - g, d.slice(y, m - g)];
      }(a, o);
      l !== 0 && r.deleteData(s, l), r.insertData(s, c);
    } else r.nodeValue = o;
  }
}
function $C(e, t, n, r, i, o) {
  v2(i, e, t);
  const a = o.theme.text;
  a !== void 0 && y2(0, 0, r, e, a);
}
function Bh(e, t) {
  const n = document.createElement(t);
  return n.appendChild(e), n;
}
class Rc extends Ig {
  static getType() {
    return "text";
  }
  static clone(t) {
    return new Rc(t.__text, t.__key);
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__format = t.__format, this.__style = t.__style, this.__mode = t.__mode, this.__detail = t.__detail;
  }
  constructor(t, n) {
    super(n), this.__text = t, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getDetail() {
    return this.getLatest().__detail;
  }
  getMode() {
    const t = this.getLatest();
    return VZ[t.__mode];
  }
  getStyle() {
    return this.getLatest().__style;
  }
  isToken() {
    return this.getLatest().__mode === 1;
  }
  isComposing() {
    return this.__key === Sa();
  }
  isSegmented() {
    return this.getLatest().__mode === 2;
  }
  isDirectionless() {
    return !!(1 & this.getLatest().__detail);
  }
  isUnmergeable() {
    return !!(2 & this.getLatest().__detail);
  }
  hasFormat(t) {
    const n = Do[t];
    return !!(this.getFormat() & n);
  }
  isSimpleText() {
    return this.__type === "text" && this.__mode === 0;
  }
  getTextContent() {
    return this.getLatest().__text;
  }
  getFormatFlags(t, n) {
    return V0(this.getLatest().__format, t, n);
  }
  canHaveFormat() {
    return !0;
  }
  createDOM(t, n) {
    const r = this.__format, i = bb(0, r), o = xb(0, r), a = i === null ? o : i, s = document.createElement(a);
    let l = s;
    this.hasFormat("code") && s.setAttribute("spellcheck", "false"), i !== null && (l = document.createElement(o), s.appendChild(l)), $C(l, this, 0, r, this.__text, t);
    const c = this.__style;
    return c !== "" && (s.style.cssText = c), s;
  }
  updateDOM(t, n, r) {
    const i = this.__text, o = t.__format, a = this.__format, s = bb(0, o), l = bb(0, a), c = xb(0, o), f = xb(0, a);
    if ((s === null ? c : s) !== (l === null ? f : l)) return !0;
    if (s === l && c !== f) {
      const g = n.firstChild;
      g == null && _e(48);
      const v = document.createElement(f);
      return $C(v, this, 0, a, i, r), n.replaceChild(v, g), !1;
    }
    let d = n;
    l !== null && s !== null && (d = n.firstChild, d == null && _e(49)), v2(i, d, this);
    const p = r.theme.text;
    p !== void 0 && o !== a && y2(0, o, a, d, p);
    const m = t.__style, y = this.__style;
    return m !== y && (n.style.cssText = y), !1;
  }
  static importDOM() {
    return { "#text": () => ({ conversion: mJ, priority: 0 }), b: () => ({ conversion: hJ, priority: 0 }), code: () => ({ conversion: ma, priority: 0 }), em: () => ({ conversion: ma, priority: 0 }), i: () => ({ conversion: ma, priority: 0 }), s: () => ({ conversion: ma, priority: 0 }), span: () => ({ conversion: dJ, priority: 0 }), strong: () => ({ conversion: ma, priority: 0 }), sub: () => ({ conversion: ma, priority: 0 }), sup: () => ({ conversion: ma, priority: 0 }), u: () => ({ conversion: ma, priority: 0 }) };
  }
  static importJSON(t) {
    const n = Vn(t.text);
    return n.setFormat(t.format), n.setDetail(t.detail), n.setMode(t.mode), n.setStyle(t.style), n;
  }
  exportDOM(t) {
    let { element: n } = super.exportDOM(t);
    return n !== null && y_(n) || _e(132), n.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (n = Bh(n, "b")), this.hasFormat("italic") && (n = Bh(n, "i")), this.hasFormat("strikethrough") && (n = Bh(n, "s")), this.hasFormat("underline") && (n = Bh(n, "u")), { element: n };
  }
  exportJSON() {
    return { detail: this.getDetail(), format: this.getFormat(), mode: this.getMode(), style: this.getStyle(), text: this.getTextContent(), type: "text", version: 1 };
  }
  selectionTransform(t, n) {
  }
  setFormat(t) {
    const n = this.getWritable();
    return n.__format = typeof t == "string" ? Do[t] : t, n;
  }
  setDetail(t) {
    const n = this.getWritable();
    return n.__detail = typeof t == "string" ? FZ[t] : t, n;
  }
  setStyle(t) {
    const n = this.getWritable();
    return n.__style = t, n;
  }
  toggleFormat(t) {
    const n = V0(this.getFormat(), t, null);
    return this.setFormat(n);
  }
  toggleDirectionless() {
    const t = this.getWritable();
    return t.__detail ^= 1, t;
  }
  toggleUnmergeable() {
    const t = this.getWritable();
    return t.__detail ^= 2, t;
  }
  setMode(t) {
    const n = zZ[t];
    if (this.__mode === n) return this;
    const r = this.getWritable();
    return r.__mode = n, r;
  }
  setTextContent(t) {
    if (this.__text === t) return this;
    const n = this.getWritable();
    return n.__text = t, n;
  }
  select(t, n) {
    wr();
    let r = t, i = n;
    const o = Ne(), a = this.getTextContent(), s = this.__key;
    if (typeof a == "string") {
      const l = a.length;
      r === void 0 && (r = l), i === void 0 && (i = l);
    } else r = 0, i = 0;
    if (!we(o)) return S2(s, r, s, i, "text", "text");
    {
      const l = Sa();
      l !== o.anchor.key && l !== o.focus.key || Gn(s), o.setTextNodeRange(this, r, this, i);
    }
    return o;
  }
  selectStart() {
    return this.select(0, 0);
  }
  selectEnd() {
    const t = this.getTextContentSize();
    return this.select(t, t);
  }
  spliceText(t, n, r, i) {
    const o = this.getWritable(), a = o.__text, s = r.length;
    let l = t;
    l < 0 && (l = s + l, l < 0 && (l = 0));
    const c = Ne();
    if (i && we(c)) {
      const d = t + s;
      c.setTextNodeRange(o, d, o, d);
    }
    const f = a.slice(0, l) + r + a.slice(l + n);
    return o.__text = f, o;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  splitText(...t) {
    wr();
    const n = this.getLatest(), r = n.getTextContent(), i = n.__key, o = Sa(), a = new Set(t), s = [], l = r.length;
    let c = "";
    for (let _ = 0; _ < l; _++) c !== "" && a.has(_) && (s.push(c), c = ""), c += r[_];
    c !== "" && s.push(c);
    const f = s.length;
    if (f === 0) return [];
    if (s[0] === r) return [n];
    const d = s[0], p = n.getParent();
    let m;
    const y = n.getFormat(), g = n.getStyle(), v = n.__detail;
    let x = !1;
    n.isSegmented() ? (m = Vn(d), m.__format = y, m.__style = g, m.__detail = v, x = !0) : (m = n.getWritable(), m.__text = d);
    const w = Ne(), S = [m];
    let A = d.length;
    for (let _ = 1; _ < f; _++) {
      const O = s[_], P = O.length, C = Vn(O).getWritable();
      C.__format = y, C.__style = g, C.__detail = v;
      const k = C.__key, D = A + P;
      if (we(w)) {
        const $ = w.anchor, N = w.focus;
        $.key === i && $.type === "text" && $.offset > A && $.offset <= D && ($.key = k, $.offset -= A, w.dirty = !0), N.key === i && N.type === "text" && N.offset > A && N.offset <= D && (N.key = k, N.offset -= A, w.dirty = !0);
      }
      o === i && Gn(k), A = D, S.push(C);
    }
    if (p !== null) {
      (function(P) {
        const C = P.getPreviousSibling(), k = P.getNextSibling();
        C !== null && jp(C), k !== null && jp(k);
      })(this);
      const _ = p.getWritable(), O = this.getIndexWithinParent();
      x ? (_.splice(O, 0, S), this.remove()) : _.splice(O, 1, S), we(w) && Vp(w, p, O, f - 1);
    }
    return S;
  }
  mergeWithSibling(t) {
    const n = t === this.getPreviousSibling();
    n || t === this.getNextSibling() || _e(50);
    const r = this.__key, i = t.__key, o = this.__text, a = o.length;
    Sa() === i && Gn(r);
    const s = Ne();
    if (we(s)) {
      const d = s.anchor, p = s.focus;
      d !== null && d.key === i && (VC(d, n, r, t, a), s.dirty = !0), p !== null && p.key === i && (VC(p, n, r, t, a), s.dirty = !0);
    }
    const l = t.__text, c = n ? l + o : o + l;
    this.setTextContent(c);
    const f = this.getWritable();
    return t.remove(), f;
  }
  isTextEntity() {
    return !1;
  }
}
function dJ(e) {
  return { forChild: v_(e.style), node: null };
}
function hJ(e) {
  const t = e, n = t.style.fontWeight === "normal";
  return { forChild: v_(t.style, n ? void 0 : "bold"), node: null };
}
const DC = /* @__PURE__ */ new WeakMap();
function pJ(e) {
  return e.nodeName === "PRE" || e.nodeType === md && e.style !== void 0 && e.style.whiteSpace !== void 0 && e.style.whiteSpace.startsWith("pre");
}
function mJ(e) {
  const t = e;
  e.parentElement === null && _e(129);
  let n = t.textContent || "";
  if (function(r) {
    let i, o = r.parentNode;
    const a = [r];
    for (; o !== null && (i = DC.get(o)) === void 0 && !pJ(o); ) a.push(o), o = o.parentNode;
    const s = i === void 0 ? o : i;
    for (let l = 0; l < a.length; l++) DC.set(a[l], s);
    return s;
  }(t) !== null) {
    const r = n.split(/(\r?\n|\t)/), i = [], o = r.length;
    for (let a = 0; a < o; a++) {
      const s = r[a];
      s === `
` || s === `\r
` ? i.push(Of()) : s === "	" ? i.push(b_()) : s !== "" && i.push(Vn(s));
    }
    return { node: i };
  }
  if (n = n.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), n === "") return { node: null };
  if (n[0] === " ") {
    let r = t, i = !0;
    for (; r !== null && (r = IC(r, !1)) !== null; ) {
      const o = r.textContent || "";
      if (o.length > 0) {
        /[ \t\n]$/.test(o) && (n = n.slice(1)), i = !1;
        break;
      }
    }
    i && (n = n.slice(1));
  }
  if (n[n.length - 1] === " ") {
    let r = t, i = !0;
    for (; r !== null && (r = IC(r, !0)) !== null; )
      if ((r.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
        i = !1;
        break;
      }
    i && (n = n.slice(0, n.length - 1));
  }
  return n === "" ? { node: null } : { node: Vn(n) };
}
function IC(e, t) {
  let n = e;
  for (; ; ) {
    let r;
    for (; (r = t ? n.nextSibling : n.previousSibling) === null; ) {
      const o = n.parentElement;
      if (o === null) return null;
      n = o;
    }
    if (n = r, n.nodeType === md) {
      const o = n.style.display;
      if (o === "" && !iJ(n) || o !== "" && !o.startsWith("inline")) return null;
    }
    let i = n;
    for (; (i = t ? n.firstChild : n.lastChild) !== null; ) n = i;
    if (n.nodeType === Va) return n;
    if (n.nodeName === "BR") return null;
  }
}
const gJ = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
function ma(e) {
  const t = gJ[e.nodeName.toLowerCase()];
  return t === void 0 ? { node: null } : { forChild: v_(e.style, t), node: null };
}
function Vn(e = "") {
  return $g(new Rc(e));
}
function Se(e) {
  return e instanceof Rc;
}
function v_(e, t) {
  const n = e.fontWeight, r = e.textDecoration.split(" "), i = n === "700" || n === "bold", o = r.includes("line-through"), a = e.fontStyle === "italic", s = r.includes("underline"), l = e.verticalAlign;
  return (c) => (Se(c) && (i && !c.hasFormat("bold") && c.toggleFormat("bold"), o && !c.hasFormat("strikethrough") && c.toggleFormat("strikethrough"), a && !c.hasFormat("italic") && c.toggleFormat("italic"), s && !c.hasFormat("underline") && c.toggleFormat("underline"), l !== "sub" || c.hasFormat("subscript") || c.toggleFormat("subscript"), l !== "super" || c.hasFormat("superscript") || c.toggleFormat("superscript"), t && !c.hasFormat(t) && c.toggleFormat(t)), c);
}
class vd extends Rc {
  static getType() {
    return "tab";
  }
  static clone(t) {
    return new vd(t.__key);
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__text = t.__text;
  }
  constructor(t) {
    super("	", t), this.__detail = 2;
  }
  static importDOM() {
    return null;
  }
  static importJSON(t) {
    const n = b_();
    return n.setFormat(t.format), n.setStyle(t.style), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), type: "tab", version: 1 };
  }
  setTextContent(t) {
    _e(126);
  }
  setDetail(t) {
    _e(127);
  }
  setMode(t) {
    _e(128);
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
}
function b_() {
  return $g(new vd());
}
function yJ(e) {
  return e instanceof vd;
}
class vJ {
  constructor(t, n, r) {
    this._selection = null, this.key = t, this.offset = n, this.type = r;
  }
  is(t) {
    return this.key === t.key && this.offset === t.offset && this.type === t.type;
  }
  isBefore(t) {
    let n = this.getNode(), r = t.getNode();
    const i = this.offset, o = t.offset;
    if (ye(n)) {
      const a = n.getDescendantByIndex(i);
      n = a ?? n;
    }
    if (ye(r)) {
      const a = r.getDescendantByIndex(o);
      r = a ?? r;
    }
    return n === r ? i < o : n.isBefore(r);
  }
  getNode() {
    const t = $n(this.key);
    return t === null && _e(20), t;
  }
  set(t, n, r) {
    const i = this._selection, o = this.key;
    this.key = t, this.offset = n, this.type = r, bd() || (Sa() === o && Gn(t), i !== null && (i.setCachedNodes(null), i.dirty = !0));
  }
}
function Fa(e, t, n) {
  return new vJ(e, t, n);
}
function wb(e, t) {
  let n = t.__key, r = e.offset, i = "element";
  if (Se(t)) {
    i = "text";
    const o = t.getTextContentSize();
    r > o && (r = o);
  } else if (!ye(t)) {
    const o = t.getNextSibling();
    if (Se(o)) n = o.__key, r = 0, i = "text";
    else {
      const a = t.getParent();
      a && (n = a.__key, r = t.getIndexWithinParent() + 1);
    }
  }
  e.set(n, r, i);
}
function RC(e, t) {
  if (ye(t)) {
    const n = t.getLastDescendant();
    ye(n) || Se(n) ? wb(e, n) : wb(e, t);
  } else wb(e, t);
}
function xa(e, t, n, r) {
  e.key = t, e.offset = n, e.type = r;
}
let b2 = class x2 {
  constructor(t) {
    this._cachedNodes = null, this._nodes = t, this.dirty = !1;
  }
  getCachedNodes() {
    return this._cachedNodes;
  }
  setCachedNodes(t) {
    this._cachedNodes = t;
  }
  is(t) {
    if (!Rg(t)) return !1;
    const n = this._nodes, r = t._nodes;
    return n.size === r.size && Array.from(n).every((i) => r.has(i));
  }
  isCollapsed() {
    return !1;
  }
  isBackward() {
    return !1;
  }
  getStartEndPoints() {
    return null;
  }
  add(t) {
    this.dirty = !0, this._nodes.add(t), this._cachedNodes = null;
  }
  delete(t) {
    this.dirty = !0, this._nodes.delete(t), this._cachedNodes = null;
  }
  clear() {
    this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
  }
  has(t) {
    return this._nodes.has(t);
  }
  clone() {
    return new x2(new Set(this._nodes));
  }
  extract() {
    return this.getNodes();
  }
  insertRawText(t) {
  }
  insertText() {
  }
  insertNodes(t) {
    const n = this.getNodes(), r = n.length, i = n[r - 1];
    let o;
    if (Se(i)) o = i.select();
    else {
      const a = i.getIndexWithinParent() + 1;
      o = i.getParentOrThrow().select(a, a);
    }
    o.insertNodes(t);
    for (let a = 0; a < r; a++) n[a].remove();
  }
  getNodes() {
    const t = this._cachedNodes;
    if (t !== null) return t;
    const n = this._nodes, r = [];
    for (const i of n) {
      const o = $n(i);
      o !== null && r.push(o);
    }
    return bd() || (this._cachedNodes = r), r;
  }
  getTextContent() {
    const t = this.getNodes();
    let n = "";
    for (let r = 0; r < t.length; r++) n += t[r].getTextContent();
    return n;
  }
};
function we(e) {
  return e instanceof Gs;
}
class Gs {
  constructor(t, n, r, i) {
    this.anchor = t, this.focus = n, t._selection = this, n._selection = this, this._cachedNodes = null, this.format = r, this.style = i, this.dirty = !1;
  }
  getCachedNodes() {
    return this._cachedNodes;
  }
  setCachedNodes(t) {
    this._cachedNodes = t;
  }
  is(t) {
    return !!we(t) && this.anchor.is(t.anchor) && this.focus.is(t.focus) && this.format === t.format && this.style === t.style;
  }
  isCollapsed() {
    return this.anchor.is(this.focus);
  }
  getNodes() {
    const t = this._cachedNodes;
    if (t !== null) return t;
    const n = this.anchor, r = this.focus, i = n.isBefore(r), o = i ? n : r, a = i ? r : n;
    let s = o.getNode(), l = a.getNode();
    const c = o.offset, f = a.offset;
    if (ye(s)) {
      const p = s.getDescendantByIndex(c);
      s = p ?? s;
    }
    if (ye(l)) {
      let p = l.getDescendantByIndex(f);
      p !== null && p !== s && l.getChildAtIndex(f) === p && (p = p.getPreviousSibling()), l = p ?? l;
    }
    let d;
    return d = s.is(l) ? ye(s) && s.getChildrenSize() > 0 ? [] : [s] : s.getNodesBetween(l), bd() || (this._cachedNodes = d), d;
  }
  setTextNodeRange(t, n, r, i) {
    xa(this.anchor, t.__key, n, "text"), xa(this.focus, r.__key, i, "text"), this._cachedNodes = null, this.dirty = !0;
  }
  getTextContent() {
    const t = this.getNodes();
    if (t.length === 0) return "";
    const n = t[0], r = t[t.length - 1], i = this.anchor, o = this.focus, a = i.isBefore(o), [s, l] = rx(this);
    let c = "", f = !0;
    for (let d = 0; d < t.length; d++) {
      const p = t[d];
      if (ye(p) && !p.isInline()) f || (c += `
`), f = !p.isEmpty();
      else if (f = !1, Se(p)) {
        let m = p.getTextContent();
        p === n ? p === r ? i.type === "element" && o.type === "element" && o.offset !== i.offset || (m = s < l ? m.slice(s, l) : m.slice(l, s)) : m = a ? m.slice(s) : m.slice(l) : p === r && (m = a ? m.slice(0, l) : m.slice(0, s)), c += m;
      } else !Ht(p) && !Zu(p) || p === r && this.isCollapsed() || (c += p.getTextContent());
    }
    return c;
  }
  applyDOMRange(t) {
    const n = mn(), r = n.getEditorState()._selection, i = _2(t.startContainer, t.startOffset, t.endContainer, t.endOffset, n, r);
    if (i === null) return;
    const [o, a] = i;
    xa(this.anchor, o.key, o.offset, o.type), xa(this.focus, a.key, a.offset, a.type), this._cachedNodes = null;
  }
  clone() {
    const t = this.anchor, n = this.focus;
    return new Gs(Fa(t.key, t.offset, t.type), Fa(n.key, n.offset, n.type), this.format, this.style);
  }
  toggleFormat(t) {
    this.format = V0(this.format, t, null), this.dirty = !0;
  }
  setStyle(t) {
    this.style = t, this.dirty = !0;
  }
  hasFormat(t) {
    const n = Do[t];
    return !!(this.format & n);
  }
  insertRawText(t) {
    const n = t.split(/(\r?\n|\t)/), r = [], i = n.length;
    for (let o = 0; o < i; o++) {
      const a = n[o];
      a === `
` || a === `\r
` ? r.push(Of()) : a === "	" ? r.push(b_()) : r.push(Vn(a));
    }
    this.insertNodes(r);
  }
  insertText(t) {
    const n = this.anchor, r = this.focus, i = this.format, o = this.style;
    let a = n, s = r;
    !this.isCollapsed() && r.isBefore(n) && (a = r, s = n), a.type === "element" && function(v, x, w, S) {
      const A = v.getNode(), _ = A.getChildAtIndex(v.offset), O = Vn(), P = ur(A) ? Io().append(O) : O;
      O.setFormat(w), O.setStyle(S), _ === null ? A.append(P) : _.insertBefore(P), v.is(x) && x.set(O.__key, 0, "text"), v.set(O.__key, 0, "text");
    }(a, s, i, o);
    const l = a.offset;
    let c = s.offset;
    const f = this.getNodes(), d = f.length;
    let p = f[0];
    Se(p) || _e(26);
    const m = p.getTextContent().length, y = p.getParentOrThrow();
    let g = f[d - 1];
    if (d === 1 && s.type === "element" && (c = m, s.set(a.key, c, "text")), this.isCollapsed() && l === m && (p.isSegmented() || p.isToken() || !p.canInsertTextAfter() || !y.canInsertTextAfter() && p.getNextSibling() === null)) {
      let v = p.getNextSibling();
      if (Se(v) && v.canInsertTextBefore() && !Al(v) || (v = Vn(), v.setFormat(i), v.setStyle(o), y.canInsertTextAfter() ? p.insertAfter(v) : y.insertAfter(v)), v.select(0, 0), p = v, t !== "") return void this.insertText(t);
    } else if (this.isCollapsed() && l === 0 && (p.isSegmented() || p.isToken() || !p.canInsertTextBefore() || !y.canInsertTextBefore() && p.getPreviousSibling() === null)) {
      let v = p.getPreviousSibling();
      if (Se(v) && !Al(v) || (v = Vn(), v.setFormat(i), y.canInsertTextBefore() ? p.insertBefore(v) : y.insertBefore(v)), v.select(), p = v, t !== "") return void this.insertText(t);
    } else if (p.isSegmented() && l !== m) {
      const v = Vn(p.getTextContent());
      v.setFormat(i), p.replace(v), p = v;
    } else if (!this.isCollapsed() && t !== "") {
      const v = g.getParent();
      if (!y.canInsertTextBefore() || !y.canInsertTextAfter() || ye(v) && (!v.canInsertTextBefore() || !v.canInsertTextAfter())) return this.insertText(""), w2(this.anchor, this.focus, null), void this.insertText(t);
    }
    if (d === 1) {
      if (p.isToken()) {
        const S = Vn(t);
        return S.select(), void p.replace(S);
      }
      const v = p.getFormat(), x = p.getStyle();
      if (l !== c || v === i && x === o) {
        if (yJ(p)) {
          const S = Vn(t);
          return S.setFormat(i), S.setStyle(o), S.select(), void p.replace(S);
        }
      } else {
        if (p.getTextContent() !== "") {
          const S = Vn(t);
          if (S.setFormat(i), S.setStyle(o), S.select(), l === 0) p.insertBefore(S, !1);
          else {
            const [A] = p.splitText(l);
            A.insertAfter(S, !1);
          }
          return void (S.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length));
        }
        p.setFormat(i), p.setStyle(o);
      }
      const w = c - l;
      p = p.spliceText(l, w, t, !0), p.getTextContent() === "" ? p.remove() : this.anchor.type === "text" && (p.isComposing() ? this.anchor.offset -= t.length : (this.format = v, this.style = x));
    } else {
      const v = /* @__PURE__ */ new Set([...p.getParentKeys(), ...g.getParentKeys()]), x = ye(p) ? p : p.getParentOrThrow();
      let w = ye(g) ? g : g.getParentOrThrow(), S = g;
      if (!x.is(w) && w.isInline()) do
        S = w, w = w.getParentOrThrow();
      while (w.isInline());
      if (s.type === "text" && (c !== 0 || g.getTextContent() === "") || s.type === "element" && g.getIndexWithinParent() < c) if (Se(g) && !g.isToken() && c !== g.getTextContentSize()) {
        if (g.isSegmented()) {
          const C = Vn(g.getTextContent());
          g.replace(C), g = C;
        }
        ur(s.getNode()) || s.type !== "text" || (g = g.spliceText(0, c, "")), v.add(g.__key);
      } else {
        const C = g.getParentOrThrow();
        C.canBeEmpty() || C.getChildrenSize() !== 1 ? g.remove() : C.remove();
      }
      else v.add(g.__key);
      const A = w.getChildren(), _ = new Set(f), O = x.is(w), P = x.isInline() && p.getNextSibling() === null ? x : p;
      for (let C = A.length - 1; C >= 0; C--) {
        const k = A[C];
        if (k.is(p) || ye(k) && k.isParentOf(p)) break;
        k.isAttached() && (!_.has(k) || k.is(S) ? O || P.insertAfter(k, !1) : k.remove());
      }
      if (!O) {
        let C = w, k = null;
        for (; C !== null; ) {
          const D = C.getChildren(), $ = D.length;
          ($ === 0 || D[$ - 1].is(k)) && (v.delete(C.__key), k = C), C = C.getParent();
        }
      }
      if (p.isToken()) if (l === m) p.select();
      else {
        const C = Vn(t);
        C.select(), p.replace(C);
      }
      else p = p.spliceText(l, m - l, t, !0), p.getTextContent() === "" ? p.remove() : p.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length);
      for (let C = 1; C < d; C++) {
        const k = f[C], D = k.__key;
        v.has(D) || k.remove();
      }
    }
  }
  removeText() {
    this.insertText("");
  }
  formatText(t) {
    if (this.isCollapsed()) return this.toggleFormat(t), void Gn(null);
    const n = this.getNodes(), r = [];
    for (const w of n) Se(w) && r.push(w);
    const i = r.length;
    if (i === 0) return this.toggleFormat(t), void Gn(null);
    const o = this.anchor, a = this.focus, s = this.isBackward(), l = s ? a : o, c = s ? o : a;
    let f = 0, d = r[0], p = l.type === "element" ? 0 : l.offset;
    if (l.type === "text" && p === d.getTextContentSize() && (f = 1, d = r[1], p = 0), d == null) return;
    const m = d.getFormatFlags(t, null), y = i - 1;
    let g = r[y];
    const v = c.type === "text" ? c.offset : g.getTextContentSize();
    if (d.is(g)) {
      if (p === v) return;
      if (Al(d) || p === 0 && v === d.getTextContentSize()) d.setFormat(m);
      else {
        const w = d.splitText(p, v), S = p === 0 ? w[0] : w[1];
        S.setFormat(m), l.type === "text" && l.set(S.__key, 0, "text"), c.type === "text" && c.set(S.__key, v - p, "text");
      }
      return void (this.format = m);
    }
    p === 0 || Al(d) || ([, d] = d.splitText(p), p = 0), d.setFormat(m);
    const x = g.getFormatFlags(t, m);
    v > 0 && (v === g.getTextContentSize() || Al(g) || ([g] = g.splitText(v)), g.setFormat(x));
    for (let w = f + 1; w < y; w++) {
      const S = r[w], A = S.getFormatFlags(t, x);
      S.setFormat(A);
    }
    l.type === "text" && l.set(d.__key, p, "text"), c.type === "text" && c.set(g.__key, v, "text"), this.format = m | x;
  }
  insertNodes(t) {
    if (t.length === 0) return;
    if (this.anchor.key === "root") {
      this.insertParagraph();
      const m = Ne();
      return we(m) || _e(134), m.insertNodes(t);
    }
    const n = gb((this.isBackward() ? this.focus : this.anchor).getNode(), Tl), r = t[t.length - 1];
    if ("__language" in n && ye(n)) {
      if ("__language" in t[0]) this.insertText(t[0].getTextContent());
      else {
        const m = _b(this);
        n.splice(m, 0, t), r.selectEnd();
      }
      return;
    }
    if (!t.some((m) => (ye(m) || Ht(m)) && !m.isInline())) {
      ye(n) || _e(135);
      const m = _b(this);
      return n.splice(m, 0, t), void r.selectEnd();
    }
    const i = function(m) {
      const y = Io();
      let g = null;
      for (let v = 0; v < m.length; v++) {
        const x = m[v], w = Zu(x);
        if (w || Ht(x) && x.isInline() || ye(x) && x.isInline() || Se(x) || x.isParentRequired()) {
          if (g === null && (g = x.createParentElementNode(), y.append(g), w)) continue;
          g !== null && g.append(x);
        } else y.append(x), g = null;
      }
      return y;
    }(t), o = i.getLastDescendant(), a = i.getChildren(), s = !ye(n) || !n.isEmpty() ? this.insertParagraph() : null, l = a[a.length - 1];
    let c = a[0];
    var f;
    ye(f = c) && Tl(f) && !f.isEmpty() && ye(n) && (!n.isEmpty() || n.canMergeWhenEmpty()) && (ye(n) || _e(135), n.append(...c.getChildren()), c = a[1]), c && function(m, y, g) {
      const v = y.getParentOrThrow().getLastChild();
      let x = y;
      const w = [y];
      for (; x !== v; ) x.getNextSibling() || _e(140), x = x.getNextSibling(), w.push(x);
      let S = m;
      for (const A of w) S = S.insertAfter(A);
    }(n, c);
    const d = gb(o, Tl);
    s && ye(d) && (s.canMergeWhenEmpty() || Tl(l)) && (d.append(...s.getChildren()), s.remove()), ye(n) && n.isEmpty() && n.remove(), o.selectEnd();
    const p = ye(n) ? n.getLastChild() : null;
    Zu(p) && d !== n && p.remove();
  }
  insertParagraph() {
    if (this.anchor.key === "root") {
      const a = Io();
      return ir().splice(this.anchor.offset, 0, [a]), a.select(), a;
    }
    const t = _b(this), n = gb(this.anchor.getNode(), Tl);
    ye(n) || _e(136);
    const r = n.getChildAtIndex(t), i = r ? [r, ...r.getNextSiblings()] : [], o = n.insertNewAfter(this, !1);
    return o ? (o.append(...i), o.selectStart(), o) : null;
  }
  insertLineBreak(t) {
    const n = Of();
    if (this.insertNodes([n]), t) {
      const r = n.getParentOrThrow(), i = n.getIndexWithinParent();
      r.select(i, i);
    }
  }
  extract() {
    const t = this.getNodes(), n = t.length, r = n - 1, i = this.anchor, o = this.focus;
    let a = t[0], s = t[r];
    const [l, c] = rx(this);
    if (n === 0) return [];
    if (n === 1) {
      if (Se(a) && !this.isCollapsed()) {
        const d = l > c ? c : l, p = l > c ? l : c, m = a.splitText(d, p), y = d === 0 ? m[0] : m[1];
        return y != null ? [y] : [];
      }
      return [a];
    }
    const f = i.isBefore(o);
    if (Se(a)) {
      const d = f ? l : c;
      d === a.getTextContentSize() ? t.shift() : d !== 0 && ([, a] = a.splitText(d), t[0] = a);
    }
    if (Se(s)) {
      const d = s.getTextContent().length, p = f ? c : l;
      p === 0 ? t.pop() : p !== d && ([s] = s.splitText(p), t[r] = s);
    }
    return t;
  }
  modify(t, n, r) {
    const i = this.focus, o = this.anchor, a = t === "move", s = U0(i, n);
    if (Ht(s) && !s.isIsolated()) {
      if (a && s.isKeyboardSelectable()) {
        const m = WC();
        return m.add(s.__key), void zo(m);
      }
      const p = n ? s.getPreviousSibling() : s.getNextSibling();
      if (Se(p)) {
        const m = p.__key, y = n ? p.getTextContent().length : 0;
        return i.set(m, y, "text"), void (a && o.set(m, y, "text"));
      }
      {
        const m = s.getParentOrThrow();
        let y, g;
        return ye(p) ? (g = p.__key, y = n ? p.getChildrenSize() : 0) : (y = s.getIndexWithinParent(), g = m.__key, n || y++), i.set(g, y, "element"), void (a && o.set(g, y, "element"));
      }
    }
    const l = mn(), c = to(l._window);
    if (!c) return;
    const f = l._blockCursorElement, d = l._rootElement;
    if (d === null || f === null || !ye(s) || s.isInline() || s.canBeEmpty() || g_(f, l, d), function(p, m, y, g) {
      p.modify(m, y, g);
    }(c, t, n ? "backward" : "forward", r), c.rangeCount > 0) {
      const p = c.getRangeAt(0), m = this.anchor.getNode(), y = ur(m) ? m : nJ(m);
      if (this.applyDOMRange(p), this.dirty = !0, !a) {
        const g = this.getNodes(), v = [];
        let x = !1;
        for (let w = 0; w < g.length; w++) {
          const S = g[w];
          H0(S, y) ? v.push(S) : x = !0;
        }
        if (x && v.length > 0) if (n) {
          const w = v[0];
          ye(w) ? w.selectStart() : w.getParentOrThrow().selectStart();
        } else {
          const w = v[v.length - 1];
          ye(w) ? w.selectEnd() : w.getParentOrThrow().selectEnd();
        }
        c.anchorNode === p.startContainer && c.anchorOffset === p.startOffset || function(w) {
          const S = w.focus, A = w.anchor, _ = A.key, O = A.offset, P = A.type;
          xa(A, S.key, S.offset, S.type), xa(S, _, O, P), w._cachedNodes = null;
        }(this);
      }
    }
  }
  forwardDeletion(t, n, r) {
    if (!r && (t.type === "element" && ye(n) && t.offset === n.getChildrenSize() || t.type === "text" && t.offset === n.getTextContentSize())) {
      const i = n.getParent(), o = n.getNextSibling() || (i === null ? null : i.getNextSibling());
      if (ye(o) && o.isShadowRoot()) return !0;
    }
    return !1;
  }
  deleteCharacter(t) {
    const n = this.isCollapsed();
    if (this.isCollapsed()) {
      const r = this.anchor;
      let i = r.getNode();
      if (this.forwardDeletion(r, i, t)) return;
      const o = this.focus, a = U0(o, t);
      if (Ht(a) && !a.isIsolated()) {
        if (a.isKeyboardSelectable() && ye(i) && i.getChildrenSize() === 0) {
          i.remove();
          const s = WC();
          s.add(a.__key), zo(s);
        } else
          a.remove(), mn().dispatchCommand(K1, void 0);
        return;
      }
      if (!t && ye(a) && ye(i) && i.isEmpty()) return i.remove(), void a.selectStart();
      if (this.modify("extend", t, "character"), this.isCollapsed()) {
        if (t && r.offset === 0 && (r.type === "element" ? r.getNode() : r.getNode().getParentOrThrow()).collapseAtStart(this))
          return;
      } else {
        const s = o.type === "text" ? o.getNode() : null;
        if (i = r.type === "text" ? r.getNode() : null, s !== null && s.isSegmented()) {
          const l = o.offset, c = s.getTextContentSize();
          if (s.is(i) || t && l !== c || !t && l !== 0) return void LC(s, t, l);
        } else if (i !== null && i.isSegmented()) {
          const l = r.offset, c = i.getTextContentSize();
          if (i.is(s) || t && l !== 0 || !t && l !== c) return void LC(i, t, l);
        }
        (function(l, c) {
          const f = l.anchor, d = l.focus, p = f.getNode(), m = d.getNode();
          if (p === m && f.type === "text" && d.type === "text") {
            const y = f.offset, g = d.offset, v = y < g, x = v ? y : g, w = v ? g : y, S = w - 1;
            x !== S && (JR(p.getTextContent().slice(x, w)) || (c ? d.offset = S : f.offset = S));
          }
        })(this, t);
      }
    }
    if (this.removeText(), t && !n && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0) {
      const r = this.anchor.getNode();
      r.isEmpty() && ur(r.getParent()) && r.getIndexWithinParent() === 0 && r.collapseAtStart(this);
    }
  }
  deleteLine(t) {
    if (this.isCollapsed()) {
      const n = this.anchor.type === "element";
      if (n && this.insertText(" "), this.modify("extend", t, "lineboundary"), (t ? this.focus : this.anchor).offset === 0 && this.modify("extend", t, "character"), n) {
        const r = t ? this.anchor : this.focus;
        r.set(r.key, r.offset + 1, r.type);
      }
    }
    this.removeText();
  }
  deleteWord(t) {
    if (this.isCollapsed()) {
      const n = this.anchor, r = n.getNode();
      if (this.forwardDeletion(n, r, t)) return;
      this.modify("extend", t, "word");
    }
    this.removeText();
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  getStartEndPoints() {
    return [this.anchor, this.focus];
  }
}
function Rg(e) {
  return e instanceof b2;
}
function jC(e) {
  const t = e.offset;
  if (e.type === "text") return t;
  const n = e.getNode();
  return t === n.getChildrenSize() ? n.getTextContent().length : 0;
}
function rx(e) {
  const t = e.getStartEndPoints();
  if (t === null) return [0, 0];
  const [n, r] = t;
  return n.type === "element" && r.type === "element" && n.key === r.key && n.offset === r.offset ? [0, 0] : [jC(n), jC(r)];
}
function LC(e, t, n) {
  const r = e, i = r.getTextContent().split(/(?=\s)/g), o = i.length;
  let a = 0, s = 0;
  for (let c = 0; c < o; c++) {
    const f = c === o - 1;
    if (s = a, a += i[c].length, t && a === n || a > n || f) {
      i.splice(c, 1), f && (s = void 0);
      break;
    }
  }
  const l = i.join("").trim();
  l === "" ? r.remove() : (r.setTextContent(l), r.select(s, s));
}
function BC(e, t, n, r) {
  let i, o = t;
  if (e.nodeType === md) {
    let a = !1;
    const s = e.childNodes, l = s.length, c = r._blockCursorElement;
    o === l && (a = !0, o = l - 1);
    let f = s[o], d = !1;
    if (f === c) f = s[o + 1], d = !0;
    else if (c !== null) {
      const p = c.parentNode;
      e === p && t > Array.prototype.indexOf.call(p.children, c) && o--;
    }
    if (i = Il(f), Se(i)) o = xC(i, a);
    else {
      let p = Il(e);
      if (p === null) return null;
      if (ye(p)) {
        o = Math.min(p.getChildrenSize(), o);
        let m = p.getChildAtIndex(o);
        if (ye(m) && function(y, g, v) {
          const x = y.getParent();
          return v === null || x === null || !x.canBeEmpty() || x !== v.getNode();
        }(m, 0, n)) {
          const y = a ? m.getLastDescendant() : m.getFirstDescendant();
          y === null ? p = m : (m = y, p = ye(m) ? m : m.getParentOrThrow()), o = 0;
        }
        Se(m) ? (i = m, p = null, o = xC(m, a)) : m !== p && a && !d && o++;
      } else {
        const m = p.getIndexWithinParent();
        o = t === 0 && Ht(p) && Il(e) === p ? m : m + 1, p = p.getParentOrThrow();
      }
      if (ye(p)) return Fa(p.__key, o, "element");
    }
  } else i = Il(e);
  return Se(i) ? Fa(i.__key, o, "text") : null;
}
function FC(e, t, n) {
  const r = e.offset, i = e.getNode();
  if (r === 0) {
    const o = i.getPreviousSibling(), a = i.getParent();
    if (t) {
      if ((n || !t) && o === null && ye(a) && a.isInline()) {
        const s = a.getPreviousSibling();
        Se(s) && (e.key = s.__key, e.offset = s.getTextContent().length);
      }
    } else ye(o) && !n && o.isInline() ? (e.key = o.__key, e.offset = o.getChildrenSize(), e.type = "element") : Se(o) && (e.key = o.__key, e.offset = o.getTextContent().length);
  } else if (r === i.getTextContent().length) {
    const o = i.getNextSibling(), a = i.getParent();
    if (t && ye(o) && o.isInline()) e.key = o.__key, e.offset = 0, e.type = "element";
    else if ((n || t) && o === null && ye(a) && a.isInline() && !a.canInsertTextAfter()) {
      const s = a.getNextSibling();
      Se(s) && (e.key = s.__key, e.offset = 0);
    }
  }
}
function w2(e, t, n) {
  if (e.type === "text" && t.type === "text") {
    const r = e.isBefore(t), i = e.is(t);
    FC(e, r, i), FC(t, !r, i), i && (t.key = e.key, t.offset = e.offset, t.type = e.type);
    const o = mn();
    if (o.isComposing() && o._compositionKey !== e.key && we(n)) {
      const a = n.anchor, s = n.focus;
      xa(e, a.key, a.offset, a.type), xa(t, s.key, s.offset, s.type);
    }
  }
}
function _2(e, t, n, r, i, o) {
  if (e === null || n === null || !Pg(i, e, n)) return null;
  const a = BC(e, t, we(o) ? o.anchor : null, i);
  if (a === null) return null;
  const s = BC(n, r, we(o) ? o.focus : null, i);
  if (s === null) return null;
  if (a.type === "element" && s.type === "element") {
    const l = Il(e), c = Il(n);
    if (Ht(l) && Ht(c)) return null;
  }
  return w2(a, s, o), [a, s];
}
function S2(e, t, n, r, i, o) {
  const a = Yo(), s = new Gs(Fa(e, t, i), Fa(n, r, o), 0, "");
  return s.dirty = !0, a._selection = s, s;
}
function WC() {
  return new b2(/* @__PURE__ */ new Set());
}
function x_(e, t, n, r) {
  const i = n._window;
  if (i === null) return null;
  const o = r || i.event, a = o ? o.type : void 0, s = a === "selectionchange", l = !z0 && (s || a === "beforeinput" || a === "compositionstart" || a === "compositionend" || a === "click" && o && o.detail === 3 || a === "drop" || a === void 0);
  let c, f, d, p;
  if (we(e) && !l) return e.clone();
  if (t === null) return null;
  if (c = t.anchorNode, f = t.focusNode, d = t.anchorOffset, p = t.focusOffset, s && we(e) && !Pg(n, c, f)) return e.clone();
  const m = _2(c, d, f, p, n, e);
  if (m === null) return null;
  const [y, g] = m;
  return new Gs(y, g, we(e) ? e.format : 0, we(e) ? e.style : "");
}
function Ne() {
  return Yo()._selection;
}
function jg() {
  return mn()._editorState._selection;
}
function Vp(e, t, n, r = 1) {
  const i = e.anchor, o = e.focus, a = i.getNode(), s = o.getNode();
  if (!t.is(a) && !t.is(s)) return;
  const l = t.__key;
  if (e.isCollapsed()) {
    const c = i.offset;
    if (n <= c && r > 0 || n < c && r < 0) {
      const f = Math.max(0, c + r);
      i.set(l, f, "element"), o.set(l, f, "element"), zC(e);
    }
  } else {
    const c = e.isBackward(), f = c ? o : i, d = f.getNode(), p = c ? i : o, m = p.getNode();
    if (t.is(d)) {
      const y = f.offset;
      (n <= y && r > 0 || n < y && r < 0) && f.set(l, Math.max(0, y + r), "element");
    }
    if (t.is(m)) {
      const y = p.offset;
      (n <= y && r > 0 || n < y && r < 0) && p.set(l, Math.max(0, y + r), "element");
    }
  }
  zC(e);
}
function zC(e) {
  const t = e.anchor, n = t.offset, r = e.focus, i = r.offset, o = t.getNode(), a = r.getNode();
  if (e.isCollapsed()) {
    if (!ye(o)) return;
    const s = o.getChildrenSize(), l = n >= s, c = l ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n);
    if (Se(c)) {
      let f = 0;
      l && (f = c.getTextContentSize()), t.set(c.__key, f, "text"), r.set(c.__key, f, "text");
    }
  } else {
    if (ye(o)) {
      const s = o.getChildrenSize(), l = n >= s, c = l ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(n);
      if (Se(c)) {
        let f = 0;
        l && (f = c.getTextContentSize()), t.set(c.__key, f, "text");
      }
    }
    if (ye(a)) {
      const s = a.getChildrenSize(), l = i >= s, c = l ? a.getChildAtIndex(s - 1) : a.getChildAtIndex(i);
      if (Se(c)) {
        let f = 0;
        l && (f = c.getTextContentSize()), r.set(c.__key, f, "text");
      }
    }
  }
}
function Up(e, t, n, r, i) {
  let o = null, a = 0, s = null;
  r !== null ? (o = r.__key, Se(r) ? (a = r.getTextContentSize(), s = "text") : ye(r) && (a = r.getChildrenSize(), s = "element")) : i !== null && (o = i.__key, Se(i) ? s = "text" : ye(i) && (s = "element")), o !== null && s !== null ? e.set(o, a, s) : (a = t.getIndexWithinParent(), a === -1 && (a = n.getChildrenSize()), e.set(n.__key, a, "element"));
}
function VC(e, t, n, r, i) {
  e.type === "text" ? (e.key = n, t || (e.offset += i)) : e.offset > r.getIndexWithinParent() && (e.offset -= 1);
}
function bJ(e, t, n, r, i, o, a) {
  const s = r.anchorNode, l = r.focusNode, c = r.anchorOffset, f = r.focusOffset, d = document.activeElement;
  if (i.has("collaboration") && d !== o || d !== null && GR(d)) return;
  if (!we(t)) return void (e !== null && Pg(n, s, l) && r.removeAllRanges());
  const p = t.anchor, m = t.focus, y = p.key, g = m.key, v = Lp(n, y), x = Lp(n, g), w = p.offset, S = m.offset, A = t.format, _ = t.style, O = t.isCollapsed();
  let P = v, C = x, k = !1;
  if (p.type === "text") {
    P = Rp(v);
    const F = p.getNode();
    k = F.getFormat() !== A || F.getStyle() !== _;
  } else we(e) && e.anchor.type === "text" && (k = !0);
  var D, $, N, R, L;
  if (m.type === "text" && (C = Rp(x)), P !== null && C !== null && (O && (e === null || k || we(e) && (e.format !== A || e.style !== _)) && (D = A, $ = _, N = w, R = y, L = performance.now(), d2 = [D, $, N, R, L]), c !== w || f !== S || s !== P || l !== C || r.type === "Range" && O || (d !== null && o.contains(d) || o.focus({ preventScroll: !0 }), p.type === "element"))) {
    try {
      r.setBaseAndExtent(P, w, C, S);
    } catch {
    }
    if (!i.has("skip-scroll-into-view") && t.isCollapsed() && o !== null && o === document.activeElement) {
      const F = t instanceof Gs && t.anchor.type === "element" ? P.childNodes[w] || null : r.rangeCount > 0 ? r.getRangeAt(0) : null;
      if (F !== null) {
        let W;
        if (F instanceof Text) {
          const z = document.createRange();
          z.selectNode(F), W = z.getBoundingClientRect();
        } else W = F.getBoundingClientRect();
        (function(z, G, U) {
          const V = U.ownerDocument, Y = V.defaultView;
          if (Y === null) return;
          let { top: ee, bottom: ie } = G, re = 0, le = 0, ae = U;
          for (; ae !== null; ) {
            const ue = ae === V.body;
            if (ue) re = 0, le = Ng(z).innerHeight;
            else {
              const J = ae.getBoundingClientRect();
              re = J.top, le = J.bottom;
            }
            let ne = 0;
            if (ee < re ? ne = -(re - ee) : ie > le && (ne = ie - le), ne !== 0) if (ue) Y.scrollBy(0, ne);
            else {
              const J = ae.scrollTop;
              ae.scrollTop += ne;
              const fe = ae.scrollTop - J;
              ee -= fe, ie -= fe;
            }
            if (ue) break;
            ae = Mg(ae);
          }
        })(n, W, o);
      }
    }
    ex = !0;
  }
}
function _b(e) {
  let t = e;
  e.isCollapsed() || t.removeText();
  const n = Ne();
  we(n) && (t = n), we(t) || _e(161);
  const r = t.anchor;
  let i = r.getNode(), o = r.offset;
  for (; !Tl(i); ) [i, o] = xJ(i, o);
  return o;
}
function xJ(e, t) {
  const n = e.getParent();
  if (!n) {
    const i = Io();
    return ir().append(i), i.select(), [ir(), 0];
  }
  if (Se(e)) {
    const i = e.splitText(t);
    if (i.length === 0) return [n, e.getIndexWithinParent()];
    const o = t === 0 ? 0 : 1;
    return [n, i[0].getIndexWithinParent() + o];
  }
  if (!ye(e) || t === 0) return [n, e.getIndexWithinParent()];
  const r = e.getChildAtIndex(t);
  if (r) {
    const i = new Gs(Fa(e.__key, t, "element"), Fa(e.__key, t, "element"), 0, ""), o = e.insertNewAfter(i);
    o && o.append(r, ...r.getNextSiblings());
  }
  return [n, e.getIndexWithinParent() + 1];
}
let Dn = null, In = null, Ar = !1, Sb = !1, fp = 0;
const UC = { characterData: !0, childList: !0, subtree: !0 };
function bd() {
  return Ar || Dn !== null && Dn._readOnly;
}
function wr() {
  Ar && _e(13);
}
function O2() {
  fp > 99 && _e(14);
}
function Yo() {
  return Dn === null && _e(195, A2()), Dn;
}
function mn() {
  return In === null && _e(196, A2()), In;
}
function A2() {
  let e = 0;
  const t = /* @__PURE__ */ new Set(), n = Fg.version;
  if (typeof window < "u") for (const i of document.querySelectorAll("[contenteditable]")) {
    const o = Cg(i);
    if (f_(o)) e++;
    else if (o) {
      let a = String(o.constructor.version || "<0.17.1");
      a === n && (a += " (separately built, likely a bundler configuration issue)"), t.add(a);
    }
  }
  let r = ` Detected on the page: ${e} compatible editor(s) with version ${n}`;
  return t.size && (r += ` and incompatible editors with versions ${Array.from(t).join(", ")}`), r;
}
function wJ() {
  return In;
}
function HC(e, t, n) {
  const r = t.__type, i = function(s, l) {
    const c = s._nodes.get(l);
    return c === void 0 && _e(30, l), c;
  }(e, r);
  let o = n.get(r);
  o === void 0 && (o = Array.from(i.transforms), n.set(r, o));
  const a = o.length;
  for (let s = 0; s < a && (o[s](t), t.isAttached()); s++) ;
}
function KC(e, t) {
  return e !== void 0 && e.__key !== t && e.isAttached();
}
function T2(e, t) {
  const n = e.type, r = t.get(n);
  r === void 0 && _e(17, n);
  const i = r.klass;
  e.type !== i.getType() && _e(18, i.name);
  const o = i.importJSON(e), a = e.children;
  if (ye(o) && Array.isArray(a)) for (let s = 0; s < a.length; s++) {
    const l = T2(a[s], t);
    o.append(l);
  }
  return o;
}
function GC(e, t, n) {
  const r = Dn, i = Ar, o = In;
  Dn = t, Ar = !0, In = e;
  try {
    return n();
  } finally {
    Dn = r, Ar = i, In = o;
  }
}
function Oa(e, t) {
  const n = e._pendingEditorState, r = e._rootElement, i = e._headless || r === null;
  if (n === null) return;
  const o = e._editorState, a = o._selection, s = n._selection, l = e._dirtyType !== Rs, c = Dn, f = Ar, d = In, p = e._updating, m = e._observer;
  let y = null;
  if (e._pendingEditorState = null, e._editorState = n, !i && l && m !== null) {
    In = e, Dn = n, Ar = !1, e._updating = !0;
    try {
      const O = e._dirtyType, P = e._dirtyElements, C = e._dirtyLeaves;
      m.disconnect(), y = cJ(o, n, e, O, P, C);
    } catch (O) {
      if (O instanceof Error && e._onError(O), Sb) throw O;
      return M2(e, null, r, n), KR(e), e._dirtyType = ec, Sb = !0, Oa(e, o), void (Sb = !1);
    } finally {
      m.observe(r, UC), e._updating = p, Dn = c, Ar = f, In = d;
    }
  }
  n._readOnly || (n._readOnly = !0);
  const g = e._dirtyLeaves, v = e._dirtyElements, x = e._normalizedNodes, w = e._updateTags, S = e._deferred;
  l && (e._dirtyType = Rs, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements = /* @__PURE__ */ new Map(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set()), function(O, P) {
    const C = O._decorators;
    let k = O._pendingDecorators || C;
    const D = P._nodeMap;
    let $;
    for ($ in k) D.has($) || (k === C && (k = XR(O)), delete k[$]);
  }(e, n);
  const A = i ? null : to(e._window);
  if (e._editable && A !== null && (l || s === null || s.dirty)) {
    In = e, Dn = n;
    try {
      if (m !== null && m.disconnect(), l || s === null || s.dirty) {
        const O = e._blockCursorElement;
        O !== null && g_(O, e, r), bJ(a, s, e, A, w, r);
      }
      rJ(e, r, s), m !== null && m.observe(r, UC);
    } finally {
      In = d, Dn = c;
    }
  }
  y !== null && function(O, P, C, k, D) {
    const $ = Array.from(O._listeners.mutation), N = $.length;
    for (let R = 0; R < N; R++) {
      const [L, F] = $[R], W = P.get(F);
      W !== void 0 && L(W, { dirtyLeaves: k, prevEditorState: D, updateTags: C });
    }
  }(e, y, w, g, o), we(s) || s === null || a !== null && a.is(s) || e.dispatchCommand(K1, void 0);
  const _ = e._pendingDecorators;
  _ !== null && (e._decorators = _, e._pendingDecorators = null, Ju("decorator", e, !0, _)), function(O, P, C) {
    const k = bC(P), D = bC(C);
    k !== D && Ju("textcontent", O, !0, D);
  }(e, t || o, n), Ju("update", e, !0, { dirtyElements: v, dirtyLeaves: g, editorState: n, normalizedNodes: x, prevEditorState: t || o, tags: w }), function(O, P) {
    if (O._deferred = [], P.length !== 0) {
      const C = O._updating;
      O._updating = !0;
      try {
        for (let k = 0; k < P.length; k++) P[k]();
      } finally {
        O._updating = C;
      }
    }
  }(e, S), function(O) {
    const P = O._updates;
    if (P.length !== 0) {
      const C = P.shift();
      if (C) {
        const [k, D] = C;
        C2(O, k, D);
      }
    }
  }(e);
}
function Ju(e, t, n, ...r) {
  const i = t._updating;
  t._updating = n;
  try {
    const o = Array.from(t._listeners[e]);
    for (let a = 0; a < o.length; a++) o[a].apply(null, r);
  } finally {
    t._updating = i;
  }
}
function P2(e, t, n) {
  if (e._updating === !1 || In !== e) {
    let i = !1;
    return e.update(() => {
      i = P2(e, t, n);
    }), i;
  }
  const r = d_(e);
  for (let i = 4; i >= 0; i--) for (let o = 0; o < r.length; o++) {
    const a = r[o]._commands.get(t);
    if (a !== void 0) {
      const s = a[i];
      if (s !== void 0) {
        const l = Array.from(s), c = l.length;
        for (let f = 0; f < c; f++) if (l[f](n, e) === !0) return !0;
      }
    }
  }
  return !1;
}
function YC(e, t) {
  const n = e._updates;
  let r = t || !1;
  for (; n.length !== 0; ) {
    const i = n.shift();
    if (i) {
      const [o, a] = i;
      let s, l;
      if (a !== void 0) {
        if (s = a.onUpdate, l = a.tag, a.skipTransforms && (r = !0), a.discrete) {
          const c = e._pendingEditorState;
          c === null && _e(191), c._flushSync = !0;
        }
        s && e._deferred.push(s), l && e._updateTags.add(l);
      }
      o();
    }
  }
  return r;
}
function C2(e, t, n) {
  const r = e._updateTags;
  let i, o, a = !1, s = !1;
  n !== void 0 && (i = n.onUpdate, o = n.tag, o != null && r.add(o), a = n.skipTransforms || !1, s = n.discrete || !1), i && e._deferred.push(i);
  const l = e._editorState;
  let c = e._pendingEditorState, f = !1;
  (c === null || c._readOnly) && (c = e._pendingEditorState = new Bg(new Map((c || l)._nodeMap)), f = !0), c._flushSync = s;
  const d = Dn, p = Ar, m = In, y = e._updating;
  Dn = c, Ar = !1, e._updating = !0, In = e;
  try {
    f && (e._headless ? l._selection !== null && (c._selection = l._selection.clone()) : c._selection = function(w) {
      const S = w.getEditorState()._selection, A = to(w._window);
      return we(S) || S == null ? x_(S, A, w, null) : S.clone();
    }(e));
    const v = e._compositionKey;
    t(), a = YC(e, a), function(w, S) {
      const A = S.getEditorState()._selection, _ = w._selection;
      if (we(_)) {
        const O = _.anchor, P = _.focus;
        let C;
        if (O.type === "text" && (C = O.getNode(), C.selectionTransform(A, _)), P.type === "text") {
          const k = P.getNode();
          C !== k && k.selectionTransform(A, _);
        }
      }
    }(c, e), e._dirtyType !== Rs && (a ? function(w, S) {
      const A = S._dirtyLeaves, _ = w._nodeMap;
      for (const O of A) {
        const P = _.get(O);
        Se(P) && P.isAttached() && P.isSimpleText() && !P.isUnmergeable() && yC(P);
      }
    }(c, e) : function(w, S) {
      const A = S._dirtyLeaves, _ = S._dirtyElements, O = w._nodeMap, P = Sa(), C = /* @__PURE__ */ new Map();
      let k = A, D = k.size, $ = _, N = $.size;
      for (; D > 0 || N > 0; ) {
        if (D > 0) {
          S._dirtyLeaves = /* @__PURE__ */ new Set();
          for (const R of k) {
            const L = O.get(R);
            Se(L) && L.isAttached() && L.isSimpleText() && !L.isUnmergeable() && yC(L), L !== void 0 && KC(L, P) && HC(S, L, C), A.add(R);
          }
          if (k = S._dirtyLeaves, D = k.size, D > 0) {
            fp++;
            continue;
          }
        }
        S._dirtyLeaves = /* @__PURE__ */ new Set(), S._dirtyElements = /* @__PURE__ */ new Map();
        for (const R of $) {
          const L = R[0], F = R[1];
          if (L !== "root" && !F) continue;
          const W = O.get(L);
          W !== void 0 && KC(W, P) && HC(S, W, C), _.set(L, F);
        }
        k = S._dirtyLeaves, D = k.size, $ = S._dirtyElements, N = $.size, fp++;
      }
      S._dirtyLeaves = A, S._dirtyElements = _;
    }(c, e), YC(e), function(w, S, A, _) {
      const O = w._nodeMap, P = S._nodeMap, C = [];
      for (const [k] of _) {
        const D = P.get(k);
        D !== void 0 && (D.isAttached() || (ye(D) && r2(D, k, O, P, C, _), O.has(k) || _.delete(k), C.push(k)));
      }
      for (const k of C) P.delete(k);
      for (const k of A) {
        const D = P.get(k);
        D === void 0 || D.isAttached() || (O.has(k) || A.delete(k), P.delete(k));
      }
    }(l, c, e._dirtyLeaves, e._dirtyElements)), v !== e._compositionKey && (c._flushSync = !0);
    const x = c._selection;
    if (we(x)) {
      const w = c._nodeMap, S = x.anchor.key, A = x.focus.key;
      w.get(S) !== void 0 && w.get(A) !== void 0 || _e(19);
    } else Rg(x) && x._nodes.size === 0 && (c._selection = null);
  } catch (v) {
    return v instanceof Error && e._onError(v), e._pendingEditorState = l, e._dirtyType = ec, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), void Oa(e);
  } finally {
    Dn = d, Ar = p, In = m, e._updating = y, fp = 0;
  }
  e._dirtyType !== Rs || function(v, x) {
    const w = x.getEditorState()._selection, S = v._selection;
    if (S !== null) {
      if (S.dirty || !S.is(w)) return !0;
    } else if (w !== null) return !0;
    return !1;
  }(c, e) ? c._flushSync ? (c._flushSync = !1, Oa(e)) : f && ZZ(() => {
    Oa(e);
  }) : (c._flushSync = !1, f && (r.clear(), e._deferred = [], e._pendingEditorState = null));
}
function Fr(e, t, n) {
  e._updating ? e._updates.push([t, n]) : C2(e, t, n);
}
class Lg extends Ig {
  constructor(t) {
    super(t), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__style = "", this.__indent = 0, this.__dir = null;
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__first = t.__first, this.__last = t.__last, this.__size = t.__size, this.__indent = t.__indent, this.__format = t.__format, this.__style = t.__style, this.__dir = t.__dir;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getFormatType() {
    const t = this.getFormat();
    return WZ[t] || "";
  }
  getStyle() {
    return this.getLatest().__style;
  }
  getIndent() {
    return this.getLatest().__indent;
  }
  getChildren() {
    const t = [];
    let n = this.getFirstChild();
    for (; n !== null; ) t.push(n), n = n.getNextSibling();
    return t;
  }
  getChildrenKeys() {
    const t = [];
    let n = this.getFirstChild();
    for (; n !== null; ) t.push(n.__key), n = n.getNextSibling();
    return t;
  }
  getChildrenSize() {
    return this.getLatest().__size;
  }
  isEmpty() {
    return this.getChildrenSize() === 0;
  }
  isDirty() {
    const t = mn()._dirtyElements;
    return t !== null && t.has(this.__key);
  }
  isLastChild() {
    const t = this.getLatest(), n = this.getParentOrThrow().getLastChild();
    return n !== null && n.is(t);
  }
  getAllTextNodes() {
    const t = [];
    let n = this.getFirstChild();
    for (; n !== null; ) {
      if (Se(n) && t.push(n), ye(n)) {
        const r = n.getAllTextNodes();
        t.push(...r);
      }
      n = n.getNextSibling();
    }
    return t;
  }
  getFirstDescendant() {
    let t = this.getFirstChild();
    for (; ye(t); ) {
      const n = t.getFirstChild();
      if (n === null) break;
      t = n;
    }
    return t;
  }
  getLastDescendant() {
    let t = this.getLastChild();
    for (; ye(t); ) {
      const n = t.getLastChild();
      if (n === null) break;
      t = n;
    }
    return t;
  }
  getDescendantByIndex(t) {
    const n = this.getChildren(), r = n.length;
    if (t >= r) {
      const o = n[r - 1];
      return ye(o) && o.getLastDescendant() || o || null;
    }
    const i = n[t];
    return ye(i) && i.getFirstDescendant() || i || null;
  }
  getFirstChild() {
    const t = this.getLatest().__first;
    return t === null ? null : $n(t);
  }
  getFirstChildOrThrow() {
    const t = this.getFirstChild();
    return t === null && _e(45, this.__key), t;
  }
  getLastChild() {
    const t = this.getLatest().__last;
    return t === null ? null : $n(t);
  }
  getLastChildOrThrow() {
    const t = this.getLastChild();
    return t === null && _e(96, this.__key), t;
  }
  getChildAtIndex(t) {
    const n = this.getChildrenSize();
    let r, i;
    if (t < n / 2) {
      for (r = this.getFirstChild(), i = 0; r !== null && i <= t; ) {
        if (i === t) return r;
        r = r.getNextSibling(), i++;
      }
      return null;
    }
    for (r = this.getLastChild(), i = n - 1; r !== null && i >= t; ) {
      if (i === t) return r;
      r = r.getPreviousSibling(), i--;
    }
    return null;
  }
  getTextContent() {
    let t = "";
    const n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      const o = n[i];
      t += o.getTextContent(), ye(o) && i !== r - 1 && !o.isInline() && (t += Wo);
    }
    return t;
  }
  getTextContentSize() {
    let t = 0;
    const n = this.getChildren(), r = n.length;
    for (let i = 0; i < r; i++) {
      const o = n[i];
      t += o.getTextContentSize(), ye(o) && i !== r - 1 && !o.isInline() && (t += Wo.length);
    }
    return t;
  }
  getDirection() {
    return this.getLatest().__dir;
  }
  hasFormat(t) {
    if (t !== "") {
      const n = pC[t];
      return !!(this.getFormat() & n);
    }
    return !1;
  }
  select(t, n) {
    wr();
    const r = Ne();
    let i = t, o = n;
    const a = this.getChildrenSize();
    if (!this.canBeEmpty()) {
      if (t === 0 && n === 0) {
        const l = this.getFirstChild();
        if (Se(l) || ye(l)) return l.select(0, 0);
      } else if (!(t !== void 0 && t !== a || n !== void 0 && n !== a)) {
        const l = this.getLastChild();
        if (Se(l) || ye(l)) return l.select();
      }
    }
    i === void 0 && (i = a), o === void 0 && (o = a);
    const s = this.__key;
    return we(r) ? (r.anchor.set(s, i, "element"), r.focus.set(s, o, "element"), r.dirty = !0, r) : S2(s, i, s, o, "element", "element");
  }
  selectStart() {
    const t = this.getFirstDescendant();
    return t ? t.selectStart() : this.select();
  }
  selectEnd() {
    const t = this.getLastDescendant();
    return t ? t.selectEnd() : this.select();
  }
  clear() {
    const t = this.getWritable();
    return this.getChildren().forEach((n) => n.remove()), t;
  }
  append(...t) {
    return this.splice(this.getChildrenSize(), 0, t);
  }
  setDirection(t) {
    const n = this.getWritable();
    return n.__dir = t, n;
  }
  setFormat(t) {
    return this.getWritable().__format = t !== "" ? pC[t] : 0, this;
  }
  setStyle(t) {
    return this.getWritable().__style = t || "", this;
  }
  setIndent(t) {
    return this.getWritable().__indent = t, this;
  }
  splice(t, n, r) {
    const i = r.length, o = this.getChildrenSize(), a = this.getWritable(), s = a.__key, l = [], c = [], f = this.getChildAtIndex(t + n);
    let d = null, p = o - n + i;
    if (t !== 0) if (t === o) d = this.getLastChild();
    else {
      const y = this.getChildAtIndex(t);
      y !== null && (d = y.getPreviousSibling());
    }
    if (n > 0) {
      let y = d === null ? this.getFirstChild() : d.getNextSibling();
      for (let g = 0; g < n; g++) {
        y === null && _e(100);
        const v = y.getNextSibling(), x = y.__key;
        Es(y.getWritable()), c.push(x), y = v;
      }
    }
    let m = d;
    for (let y = 0; y < i; y++) {
      const g = r[y];
      m !== null && g.is(m) && (d = m = m.getPreviousSibling());
      const v = g.getWritable();
      v.__parent === s && p--, Es(v);
      const x = g.__key;
      if (m === null) a.__first = x, v.__prev = null;
      else {
        const w = m.getWritable();
        w.__next = x, v.__prev = w.__key;
      }
      g.__key === s && _e(76), v.__parent = s, l.push(x), m = g;
    }
    if (t + n === o)
      m !== null && (m.getWritable().__next = null, a.__last = m.__key);
    else if (f !== null) {
      const y = f.getWritable();
      if (m !== null) {
        const g = m.getWritable();
        y.__prev = m.__key, g.__next = f.__key;
      } else y.__prev = null;
    }
    if (a.__size = p, c.length) {
      const y = Ne();
      if (we(y)) {
        const g = new Set(c), v = new Set(l), { anchor: x, focus: w } = y;
        qC(x, g, v) && Up(x, x.getNode(), this, d, f), qC(w, g, v) && Up(w, w.getNode(), this, d, f), p !== 0 || this.canBeEmpty() || gd(this) || this.remove();
      }
    }
    return a;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
  }
  insertNewAfter(t, n) {
    return null;
  }
  canIndent() {
    return !0;
  }
  collapseAtStart(t) {
    return !1;
  }
  excludeFromCopy(t) {
    return !1;
  }
  canReplaceWith(t) {
    return !0;
  }
  canInsertAfter(t) {
    return !0;
  }
  canBeEmpty() {
    return !0;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  isInline() {
    return !1;
  }
  isShadowRoot() {
    return !1;
  }
  canMergeWith(t) {
    return !1;
  }
  extractWithChild(t, n, r) {
    return !1;
  }
  canMergeWhenEmpty() {
    return !1;
  }
}
function ye(e) {
  return e instanceof Lg;
}
function qC(e, t, n) {
  let r = e.getNode();
  for (; r; ) {
    const i = r.__key;
    if (t.has(i) && !n.has(i)) return !0;
    r = r.getParent();
  }
  return !1;
}
class E2 extends Ig {
  constructor(t) {
    super(t);
  }
  decorate(t, n) {
    _e(47);
  }
  isIsolated() {
    return !1;
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
}
function Ht(e) {
  return e instanceof E2;
}
class xd extends Lg {
  static getType() {
    return "root";
  }
  static clone() {
    return new xd();
  }
  constructor() {
    super("root"), this.__cachedText = null;
  }
  getTopLevelElementOrThrow() {
    _e(51);
  }
  getTextContent() {
    const t = this.__cachedText;
    return !bd() && mn()._dirtyType !== Rs || t === null ? super.getTextContent() : t;
  }
  remove() {
    _e(52);
  }
  replace(t) {
    _e(53);
  }
  insertBefore(t) {
    _e(54);
  }
  insertAfter(t) {
    _e(55);
  }
  updateDOM(t, n) {
    return !1;
  }
  append(...t) {
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      ye(r) || Ht(r) || _e(56);
    }
    return super.append(...t);
  }
  static importJSON(t) {
    const n = ir();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
  }
  collapseAtStart() {
    return !0;
  }
}
function ur(e) {
  return e instanceof xd;
}
function w_() {
  return new Bg(/* @__PURE__ */ new Map([["root", new xd()]]));
}
function k2(e) {
  const t = e.exportJSON(), n = e.constructor;
  if (t.type !== n.getType() && _e(130, n.name), ye(e)) {
    const r = t.children;
    Array.isArray(r) || _e(59, n.name);
    const i = e.getChildren();
    for (let o = 0; o < i.length; o++) {
      const a = k2(i[o]);
      r.push(a);
    }
  }
  return t;
}
class Bg {
  constructor(t, n) {
    this._nodeMap = t, this._selection = n || null, this._flushSync = !1, this._readOnly = !1;
  }
  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }
  read(t, n) {
    return GC(n && n.editor || null, this, t);
  }
  clone(t) {
    const n = new Bg(this._nodeMap, t === void 0 ? this._selection : t);
    return n._readOnly = !0, n;
  }
  toJSON() {
    return GC(null, this, () => ({ root: k2(ir()) }));
  }
}
class _J extends Lg {
  static getType() {
    return "artificial";
  }
  createDOM(t) {
    return document.createElement("div");
  }
}
class jc extends Lg {
  constructor(t) {
    super(t), this.__textFormat = 0, this.__textStyle = "";
  }
  static getType() {
    return "paragraph";
  }
  getTextFormat() {
    return this.getLatest().__textFormat;
  }
  setTextFormat(t) {
    const n = this.getWritable();
    return n.__textFormat = t, n;
  }
  hasTextFormat(t) {
    const n = Do[t];
    return !!(this.getTextFormat() & n);
  }
  getTextStyle() {
    return this.getLatest().__textStyle;
  }
  setTextStyle(t) {
    const n = this.getWritable();
    return n.__textStyle = t, n;
  }
  static clone(t) {
    return new jc(t.__key);
  }
  afterCloneFrom(t) {
    super.afterCloneFrom(t), this.__textFormat = t.__textFormat, this.__textStyle = t.__textStyle;
  }
  createDOM(t) {
    const n = document.createElement("p"), r = Yu(t.theme, "paragraph");
    return r !== void 0 && n.classList.add(...r), n;
  }
  updateDOM(t, n, r) {
    return !1;
  }
  static importDOM() {
    return { p: (t) => ({ conversion: SJ, priority: 0 }) };
  }
  exportDOM(t) {
    const { element: n } = super.exportDOM(t);
    if (n && y_(n)) {
      this.isEmpty() && n.append(document.createElement("br"));
      const r = this.getFormatType();
      n.style.textAlign = r;
      const i = this.getDirection();
      i && (n.dir = i);
      const o = this.getIndent();
      o > 0 && (n.style.textIndent = 20 * o + "px");
    }
    return { element: n };
  }
  static importJSON(t) {
    const n = Io();
    return n.setFormat(t.format), n.setIndent(t.indent), n.setDirection(t.direction), n.setTextFormat(t.textFormat), n;
  }
  exportJSON() {
    return { ...super.exportJSON(), textFormat: this.getTextFormat(), textStyle: this.getTextStyle(), type: "paragraph", version: 1 };
  }
  insertNewAfter(t, n) {
    const r = Io();
    r.setTextFormat(t.format), r.setTextStyle(t.style);
    const i = this.getDirection();
    return r.setDirection(i), r.setFormat(this.getFormatType()), r.setStyle(this.getTextStyle()), this.insertAfter(r, n), r;
  }
  collapseAtStart() {
    const t = this.getChildren();
    if (t.length === 0 || Se(t[0]) && t[0].getTextContent().trim() === "") {
      if (this.getNextSibling() !== null) return this.selectNext(), this.remove(), !0;
      if (this.getPreviousSibling() !== null) return this.selectPrevious(), this.remove(), !0;
    }
    return !1;
  }
}
function SJ(e) {
  const t = Io();
  if (e.style) {
    t.setFormat(e.style.textAlign);
    const n = parseInt(e.style.textIndent, 10) / 20;
    n > 0 && t.setIndent(n);
  }
  return { node: t };
}
function Io() {
  return $g(new jc());
}
function ix(e) {
  return e instanceof jc;
}
const nn = 0, tc = 1;
function M2(e, t, n, r) {
  const i = e._keyToDOMMap;
  i.clear(), e._editorState = w_(), e._pendingEditorState = r, e._compositionKey = null, e._dirtyType = Rs, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set(), e._updates = [], e._blockCursorElement = null;
  const o = e._observer;
  o !== null && (o.disconnect(), e._observer = null), t !== null && (t.textContent = ""), n !== null && (n.textContent = "", i.set("root", n));
}
function OJ(e) {
  const t = e || {}, n = wJ(), r = t.theme || {}, i = e === void 0 ? n : t.parentEditor || null, o = t.disableEvents || !1, a = w_(), s = t.namespace || (i !== null ? i._config.namespace : QR()), l = t.editorState, c = [xd, Rc, yd, vd, jc, _J, ...t.nodes || []], { onError: f, html: d } = t, p = t.editable === void 0 || t.editable;
  let m;
  if (e === void 0 && n !== null) m = n._nodes;
  else {
    m = /* @__PURE__ */ new Map();
    for (let g = 0; g < c.length; g++) {
      let v = c[g], x = null, w = null;
      if (typeof v != "function") {
        const O = v;
        v = O.replace, x = O.with, w = O.withKlass || null;
      }
      const S = v.getType(), A = v.transform(), _ = /* @__PURE__ */ new Set();
      A !== null && _.add(A), m.set(S, { exportDOM: d && d.export ? d.export.get(v) : void 0, klass: v, replace: x, replaceWithKlass: w, transforms: _ });
    }
  }
  const y = new Fg(a, i, m, { disableEvents: o, namespace: s, theme: r }, f || console.error, function(g, v) {
    const x = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Set(), S = (A) => {
      Object.keys(A).forEach((_) => {
        let O = x.get(_);
        O === void 0 && (O = [], x.set(_, O)), O.push(A[_]);
      });
    };
    return g.forEach((A) => {
      const _ = A.klass.importDOM;
      if (_ == null || w.has(_)) return;
      w.add(_);
      const O = _.call(A.klass);
      O !== null && S(O);
    }), v && S(v), x;
  }(m, d ? d.import : void 0), p);
  return l !== void 0 && (y._pendingEditorState = l, y._dirtyType = ec), y;
}
class Fg {
  constructor(t, n, r, i, o, a, s) {
    this._parentEditor = n, this._rootElement = null, this._editorState = t, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = i, this._nodes = r, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = Rs, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = QR(), this._onError = o, this._htmlConversions = a, this._editable = s, this._headless = n !== null && n._headless, this._window = null, this._blockCursorElement = null;
  }
  isComposing() {
    return this._compositionKey != null;
  }
  registerUpdateListener(t) {
    const n = this._listeners.update;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerEditableListener(t) {
    const n = this._listeners.editable;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerDecoratorListener(t) {
    const n = this._listeners.decorator;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerTextContentListener(t) {
    const n = this._listeners.textcontent;
    return n.add(t), () => {
      n.delete(t);
    };
  }
  registerRootListener(t) {
    const n = this._listeners.root;
    return t(this._rootElement, null), n.add(t), () => {
      t(null, this._rootElement), n.delete(t);
    };
  }
  registerCommand(t, n, r) {
    r === void 0 && _e(35);
    const i = this._commands;
    i.has(t) || i.set(t, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
    const o = i.get(t);
    o === void 0 && _e(36, String(t));
    const a = o[r];
    return a.add(n), () => {
      a.delete(n), o.every((s) => s.size === 0) && i.delete(t);
    };
  }
  registerMutationListener(t, n, r) {
    const i = this.resolveRegisteredNodeAfterReplacements(this.getRegisteredNode(t)).klass, o = this._listeners.mutation;
    o.set(n, i);
    const a = r && r.skipInitialization;
    return a === void 0 || a || this.initializeMutationListener(n, i), () => {
      o.delete(n);
    };
  }
  getRegisteredNode(t) {
    const n = this._nodes.get(t.getType());
    return n === void 0 && _e(37, t.name), n;
  }
  resolveRegisteredNodeAfterReplacements(t) {
    for (; t.replaceWithKlass; ) t = this.getRegisteredNode(t.replaceWithKlass);
    return t;
  }
  initializeMutationListener(t, n) {
    const r = this._editorState, i = aJ(r).get(n.getType());
    if (!i) return;
    const o = /* @__PURE__ */ new Map();
    for (const a of i.keys()) o.set(a, "created");
    o.size > 0 && t(o, { dirtyLeaves: /* @__PURE__ */ new Set(), prevEditorState: r, updateTags: /* @__PURE__ */ new Set(["registerMutationListener"]) });
  }
  registerNodeTransformToKlass(t, n) {
    const r = this.getRegisteredNode(t);
    return r.transforms.add(n), r;
  }
  registerNodeTransform(t, n) {
    const r = this.registerNodeTransformToKlass(t, n), i = [r], o = r.replaceWithKlass;
    if (o != null) {
      const l = this.registerNodeTransformToKlass(o, n);
      i.push(l);
    }
    var a, s;
    return a = this, s = t.getType(), Fr(a, () => {
      const l = Yo();
      if (l.isEmpty()) return;
      if (s === "root") return void ir().markDirty();
      const c = l._nodeMap;
      for (const [, f] of c) f.markDirty();
    }, a._pendingEditorState === null ? { tag: "history-merge" } : void 0), () => {
      i.forEach((l) => l.transforms.delete(n));
    };
  }
  hasNode(t) {
    return this._nodes.has(t.getType());
  }
  hasNodes(t) {
    return t.every(this.hasNode.bind(this));
  }
  dispatchCommand(t, n) {
    return Ae(this, t, n);
  }
  getDecorators() {
    return this._decorators;
  }
  getRootElement() {
    return this._rootElement;
  }
  getKey() {
    return this._key;
  }
  setRootElement(t) {
    const n = this._rootElement;
    if (t !== n) {
      const r = Yu(this._config.theme, "root"), i = this._pendingEditorState || this._editorState;
      if (this._rootElement = t, M2(this, n, t, i), n !== null && (this._config.disableEvents || uJ(n), r != null && n.classList.remove(...r)), t !== null) {
        const o = function(s) {
          const l = s.ownerDocument;
          return l && l.defaultView || null;
        }(t), a = t.style;
        a.userSelect = "text", a.whiteSpace = "pre-wrap", a.wordBreak = "break-word", t.setAttribute("data-lexical-editor", "true"), this._window = o, this._dirtyType = ec, KR(this), this._updateTags.add("history-merge"), Oa(this), this._config.disableEvents || function(s, l) {
          const c = s.ownerDocument, f = zp.get(c);
          (f === void 0 || f < 1) && c.addEventListener("selectionchange", g2), zp.set(c, (f || 0) + 1), s.__lexicalEditor = l;
          const d = m2(s);
          for (let p = 0; p < Q0.length; p++) {
            const [m, y] = Q0[p], g = typeof y == "function" ? (v) => {
              NC(v) || (MC(v), (l.isEditable() || m === "click") && y(v, l));
            } : (v) => {
              if (NC(v)) return;
              MC(v);
              const x = l.isEditable();
              switch (m) {
                case "cut":
                  return x && Ae(l, e_, v);
                case "copy":
                  return Ae(l, Q1, v);
                case "paste":
                  return x && Ae(l, G1, v);
                case "dragstart":
                  return x && Ae(l, BR, v);
                case "dragover":
                  return x && Ae(l, SZ, v);
                case "dragend":
                  return x && Ae(l, OZ, v);
                case "focus":
                  return x && Ae(l, PZ, v);
                case "blur":
                  return x && Ae(l, CZ, v);
                case "drop":
                  return x && Ae(l, LR, v);
              }
            };
            s.addEventListener(m, g), d.push(() => {
              s.removeEventListener(m, g);
            });
          }
        }(t, this), r != null && t.classList.add(...r);
      } else this._editorState = i, this._pendingEditorState = null, this._window = null;
      Ju("root", this, !1, t, n);
    }
  }
  getElementByKey(t) {
    return this._keyToDOMMap.get(t) || null;
  }
  getEditorState() {
    return this._editorState;
  }
  setEditorState(t, n) {
    t.isEmpty() && _e(38), HR(this);
    const r = this._pendingEditorState, i = this._updateTags, o = n !== void 0 ? n.tag : null;
    r === null || r.isEmpty() || (o != null && i.add(o), Oa(this)), this._pendingEditorState = t, this._dirtyType = ec, this._dirtyElements.set("root", !1), this._compositionKey = null, o != null && i.add(o), Oa(this);
  }
  parseEditorState(t, n) {
    return function(r, i, o) {
      const a = w_(), s = Dn, l = Ar, c = In, f = i._dirtyElements, d = i._dirtyLeaves, p = i._cloneNotNeeded, m = i._dirtyType;
      i._dirtyElements = /* @__PURE__ */ new Map(), i._dirtyLeaves = /* @__PURE__ */ new Set(), i._cloneNotNeeded = /* @__PURE__ */ new Set(), i._dirtyType = 0, Dn = a, Ar = !1, In = i;
      try {
        const y = i._nodes;
        T2(r.root, y), o && o(), a._readOnly = !0;
      } catch (y) {
        y instanceof Error && i._onError(y);
      } finally {
        i._dirtyElements = f, i._dirtyLeaves = d, i._cloneNotNeeded = p, i._dirtyType = m, Dn = s, Ar = l, In = c;
      }
      return a;
    }(typeof t == "string" ? JSON.parse(t) : t, this, n);
  }
  read(t) {
    return Oa(this), this.getEditorState().read(t, { editor: this });
  }
  update(t, n) {
    Fr(this, t, n);
  }
  focus(t, n = {}) {
    const r = this._rootElement;
    r !== null && (r.setAttribute("autocapitalize", "off"), Fr(this, () => {
      const i = Ne(), o = ir();
      i !== null ? i.dirty = !0 : o.getChildrenSize() !== 0 && (n.defaultSelection === "rootStart" ? o.selectStart() : o.selectEnd());
    }, { onUpdate: () => {
      r.removeAttribute("autocapitalize"), t && t();
    }, tag: "focus" }), this._pendingEditorState === null && r.removeAttribute("autocapitalize"));
  }
  blur() {
    const t = this._rootElement;
    t !== null && t.blur();
    const n = to(this._window);
    n !== null && n.removeAllRanges();
  }
  isEditable() {
    return this._editable;
  }
  setEditable(t) {
    this._editable !== t && (this._editable = t, Ju("editable", this, !0, t));
  }
  toJSON() {
    return { editorState: this._editorState.toJSON() };
  }
}
Fg.version = "0.17.1+prod.esm";
const N2 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, AJ = N2 ? di : Xe, Fh = { tag: "history-merge" };
function TJ({ initialConfig: e, children: t }) {
  const n = Fe(() => {
    const { theme: r, namespace: i, nodes: o, onError: a, editorState: s, html: l } = e, c = gZ(null, r), f = OJ({ editable: e.editable, html: l, namespace: i, nodes: o, onError: (d) => a(d, f), theme: r });
    return function(d, p) {
      if (p !== null) {
        if (p === void 0) d.update(() => {
          const m = ir();
          if (m.isEmpty()) {
            const y = Io();
            m.append(y);
            const g = N2 ? document.activeElement : null;
            (Ne() !== null || g !== null && g === d.getRootElement()) && y.select();
          }
        }, Fh);
        else if (p !== null) switch (typeof p) {
          case "string": {
            const m = d.parseEditorState(p);
            d.setEditorState(m, Fh);
            break;
          }
          case "object":
            d.setEditorState(p, Fh);
            break;
          case "function":
            d.update(() => {
              ir().isEmpty() && p(d);
            }, Fh);
        }
      }
    }(f, s), [f, c];
  }, []);
  return AJ(() => {
    const r = e.editable, [i] = n;
    i.setEditable(r === void 0 || r);
  }, []), E(MR.Provider, { value: n, children: t });
}
const PJ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? di : Xe;
function CJ(e) {
  return { initialValueFn: () => e.isEditable(), subscribe: (t) => e.registerEditableListener(t) };
}
function EJ() {
  return function(e) {
    const [t] = Gr(), n = Fe(() => e(t), [t, e]), r = ut(n.initialValueFn()), [i, o] = Me(r.current);
    return PJ(() => {
      const { initialValueFn: a, subscribe: s } = n, l = a();
      return r.current !== l && (r.current = l, o(l)), s((c) => {
        r.current = c, o(c);
      });
    }, [n, e]), i;
  }(CJ);
}
function kJ() {
  return ir().getTextContent();
}
function MJ(e, t = !0) {
  if (e) return !1;
  let n = kJ();
  return t && (n = n.trim()), n === "";
}
function NJ(e) {
  if (!MJ(e, !1)) return !1;
  const t = ir().getChildren(), n = t.length;
  if (n > 1) return !1;
  for (let r = 0; r < n; r++) {
    const i = t[r];
    if (Ht(i)) return !1;
    if (ye(i)) {
      if (!ix(i) || i.__indent !== 0) return !1;
      const o = i.getChildren(), a = o.length;
      for (let s = 0; s < a; s++) {
        const l = o[r];
        if (!Se(l)) return !1;
      }
    }
  }
  return !0;
}
function $2(e) {
  return () => NJ(e);
}
function $J(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
$J(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function DJ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
DJ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function IJ(e, t) {
  const n = e.getStartEndPoints();
  if (t.isSelected(e) && !t.isSegmented() && !t.isToken() && n !== null) {
    const [r, i] = n, o = e.isBackward(), a = r.getNode(), s = i.getNode(), l = t.is(a), c = t.is(s);
    if (l || c) {
      const [f, d] = rx(e), p = a.is(s), m = t.is(o ? s : a), y = t.is(o ? a : s);
      let g, v = 0;
      return p ? (v = f > d ? d : f, g = f > d ? f : d) : m ? (v = o ? d : f, g = void 0) : y && (v = 0, g = o ? f : d), t.__text = t.__text.slice(v, g), t;
    }
  }
  return t;
}
function XC(e, t) {
  const n = U0(e.focus, t);
  return Ht(n) && !n.isIsolated() || ye(n) && !n.isInline() && !n.canBeEmpty();
}
function RJ(e, t, n, r) {
  e.modify(t ? "extend" : "move", n, r);
}
function jJ(e) {
  const t = e.anchor.getNode();
  return (ur(t) ? t : t.getParentOrThrow()).getDirection() === "rtl";
}
function ZC(e, t, n) {
  const r = jJ(e);
  RJ(e, t, n ? !r : r, "character");
}
function LJ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
LJ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
const D2 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, BJ = D2 && "documentMode" in document ? document.documentMode : null;
!(!D2 || !("InputEvent" in window) || BJ) && "getTargetRanges" in new window.InputEvent("input");
function Vo(...e) {
  return () => {
    for (let t = e.length - 1; t >= 0; t--) e[t]();
    e.length = 0;
  };
}
function FJ(e, t) {
  return e !== null && Object.getPrototypeOf(e).constructor.name === t.name;
}
function WJ(e) {
  const t = window.location.origin, n = (r) => {
    if (r.origin !== t) return;
    const i = e.getRootElement();
    if (document.activeElement !== i) return;
    const o = r.data;
    if (typeof o == "string") {
      let a;
      try {
        a = JSON.parse(o);
      } catch {
        return;
      }
      if (a && a.protocol === "nuanria_messaging" && a.type === "request") {
        const s = a.payload;
        if (s && s.functionId === "makeChanges") {
          const l = s.args;
          if (l) {
            const [c, f, d, p, m, y] = l;
            e.update(() => {
              const g = Ne();
              if (we(g)) {
                const v = g.anchor;
                let x = v.getNode(), w = 0, S = 0;
                if (Se(x) && c >= 0 && f >= 0 && (w = c, S = c + f, g.setTextNodeRange(x, w, x, S)), w === S && d === "" || (g.insertRawText(d), x = v.getNode()), Se(x)) {
                  w = p, S = p + m;
                  const A = x.getTextContentSize();
                  w = w > A ? A : w, S = S > A ? A : S, g.setTextNodeRange(x, w, x, S);
                }
                r.stopImmediatePropagation();
              }
            });
          }
        }
      }
    }
  };
  return window.addEventListener("message", n, !0), () => {
    window.removeEventListener("message", n, !0);
  };
}
function zJ(e, t) {
  if (typeof document > "u" || typeof window > "u" && global.window === void 0) throw new Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  const n = document.createElement("div"), r = ir().getChildren();
  for (let i = 0; i < r.length; i++)
    I2(e, r[i], n, t);
  return n.innerHTML;
}
function I2(e, t, n, r = null) {
  let i = r === null || t.isSelected(r);
  const o = ye(t) && t.excludeFromCopy("html");
  let a = t;
  if (r !== null) {
    let m = n2(t);
    m = Se(m) && r !== null ? IJ(r, m) : m, a = m;
  }
  const s = ye(a) ? a.getChildren() : [], l = e._nodes.get(a.getType());
  let c;
  c = l && l.exportDOM !== void 0 ? l.exportDOM(e, a) : a.exportDOM(e);
  const { element: f, after: d } = c;
  if (!f) return !1;
  const p = document.createDocumentFragment();
  for (let m = 0; m < s.length; m++) {
    const y = s[m], g = I2(e, y, p, r);
    !i && ye(t) && g && t.extractWithChild(y, r, "html") && (i = !0);
  }
  if (i && !o) {
    if (y_(f) && f.append(p), n.append(f), d) {
      const m = d.call(a, f);
      m && f.replaceWith(m);
    }
  } else n.append(p);
  return i;
}
function VJ(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var UJ = VJ(function(e) {
  const t = new URLSearchParams();
  t.append("code", e);
  for (let n = 1; n < arguments.length; n++) t.append("v", arguments[n]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
});
function HJ(e, t = Ne()) {
  return t == null && UJ(166), we(t) && t.isCollapsed() || t.getNodes().length === 0 ? "" : zJ(e, t);
}
function JC(e, t) {
  const n = e.getData("text/plain") || e.getData("text/uri-list");
  n != null && t.insertRawText(n);
}
const Lc = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, KJ = Lc && "documentMode" in document ? document.documentMode : null, GJ = !(!Lc || !("InputEvent" in window) || KJ) && "getTargetRanges" in new window.InputEvent("input"), YJ = Lc && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), qJ = Lc && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, XJ = Lc && /^(?=.*Chrome).*/i.test(navigator.userAgent), ZJ = Lc && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !XJ;
function QC(e, t) {
  t.update(() => {
    if (e !== null) {
      const n = FJ(e, KeyboardEvent) ? null : e.clipboardData, r = Ne();
      if (r !== null && n != null) {
        e.preventDefault();
        const i = HJ(t);
        i !== null && n.setData("text/html", i), n.setData("text/plain", r.getTextContent());
      }
    }
  });
}
function JJ(e) {
  return Vo(e.registerCommand(Cs, (t) => {
    const n = Ne();
    return !!we(n) && (n.deleteCharacter(t), !0);
  }, nn), e.registerCommand(vf, (t) => {
    const n = Ne();
    return !!we(n) && (n.deleteWord(t), !0);
  }, nn), e.registerCommand(bf, (t) => {
    const n = Ne();
    return !!we(n) && (n.deleteLine(t), !0);
  }, nn), e.registerCommand(Ul, (t) => {
    const n = Ne();
    if (!we(n)) return !1;
    if (typeof t == "string") n.insertText(t);
    else {
      const r = t.dataTransfer;
      if (r != null) JC(r, n);
      else {
        const i = t.data;
        i && n.insertText(i);
      }
    }
    return !0;
  }, nn), e.registerCommand(F0, () => {
    const t = Ne();
    return !!we(t) && (t.removeText(), !0);
  }, nn), e.registerCommand(Vl, (t) => {
    const n = Ne();
    return !!we(n) && (n.insertLineBreak(t), !0);
  }, nn), e.registerCommand(B0, () => {
    const t = Ne();
    return !!we(t) && (t.insertLineBreak(), !0);
  }, nn), e.registerCommand(Z1, (t) => {
    const n = Ne();
    if (!we(n)) return !1;
    const r = t, i = r.shiftKey;
    return !!XC(n, !0) && (r.preventDefault(), ZC(n, i, !0), !0);
  }, nn), e.registerCommand(X1, (t) => {
    const n = Ne();
    if (!we(n)) return !1;
    const r = t, i = r.shiftKey;
    return !!XC(n, !1) && (r.preventDefault(), ZC(n, i, !1), !0);
  }, nn), e.registerCommand(J1, (t) => {
    const n = Ne();
    return !!we(n) && (t.preventDefault(), e.dispatchCommand(Cs, !0));
  }, nn), e.registerCommand(RR, (t) => {
    const n = Ne();
    return !!we(n) && (t.preventDefault(), e.dispatchCommand(Cs, !1));
  }, nn), e.registerCommand(xf, (t) => {
    const n = Ne();
    if (!we(n)) return !1;
    if (t !== null) {
      if ((qJ || YJ || ZJ) && GJ) return !1;
      t.preventDefault();
    }
    return e.dispatchCommand(Vl, !1);
  }, nn), e.registerCommand(W0, () => (tJ(), !0), nn), e.registerCommand(Q1, (t) => {
    const n = Ne();
    return !!we(n) && (QC(t, e), !0);
  }, nn), e.registerCommand(e_, (t) => {
    const n = Ne();
    return !!we(n) && (function(r, i) {
      QC(r, i), i.update(() => {
        const o = Ne();
        we(o) && o.removeText();
      });
    }(t, e), !0);
  }, nn), e.registerCommand(G1, (t) => {
    const n = Ne();
    return !!we(n) && (function(r, i) {
      r.preventDefault(), i.update(() => {
        const o = Ne(), { clipboardData: a } = r;
        a != null && we(o) && JC(a, o);
      }, { tag: "paste" });
    }(t, e), !0);
  }, nn), e.registerCommand(LR, (t) => {
    const n = Ne();
    return !!we(n) && (t.preventDefault(), !0);
  }, nn), e.registerCommand(BR, (t) => {
    const n = Ne();
    return !!we(n) && (t.preventDefault(), !0);
  }, nn));
}
const ox = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? di : Xe;
function eE(e) {
  return e.getEditorState().read($2(e.isComposing()));
}
function QJ({ contentEditable: e, placeholder: t = null, ErrorBoundary: n }) {
  const [r] = Gr(), i = function(o, a) {
    const [s, l] = Me(() => o.getDecorators());
    return ox(() => o.registerDecoratorListener((c) => {
      U$(() => {
        l(c);
      });
    }), [o]), Xe(() => {
      l(o.getDecorators());
    }, [o]), Fe(() => {
      const c = [], f = Object.keys(s);
      for (let d = 0; d < f.length; d++) {
        const p = f[d], m = E(a, { onError: (g) => o._onError(g), children: E(iH, { fallback: null, children: s[p] }) }), y = o.getElementByKey(p);
        y !== null && c.push(Yw(m, y, p));
      }
      return c;
    }, [a, s, o]);
  }(r, n);
  return function(o) {
    ox(() => Vo(JJ(o), WJ(o)), [o]);
  }(r), he(Ut, { children: [e, E(eQ, { content: t }), i] });
}
function eQ({ content: e }) {
  const [t] = Gr(), n = function(i) {
    const [o, a] = Me(() => eE(i));
    return ox(() => {
      function s() {
        const l = eE(i);
        a(l);
      }
      return s(), Vo(i.registerUpdateListener(() => {
        s();
      }), i.registerEditableListener(() => {
        s();
      }));
    }, [i]), o;
  }(t), r = EJ();
  return n ? typeof e == "function" ? e(r) : e : null;
}
const R2 = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? di : Xe;
function tQ({ editor: e, ariaActiveDescendant: t, ariaAutoComplete: n, ariaControls: r, ariaDescribedBy: i, ariaExpanded: o, ariaLabel: a, ariaLabelledBy: s, ariaMultiline: l, ariaOwns: c, ariaRequired: f, autoCapitalize: d, className: p, id: m, role: y = "textbox", spellCheck: g = !0, style: v, tabIndex: x, "data-testid": w, ...S }, A) {
  const [_, O] = Me(e.isEditable()), P = qe((k) => {
    k && k.ownerDocument && k.ownerDocument.defaultView ? e.setRootElement(k) : e.setRootElement(null);
  }, [e]), C = Fe(() => /* @__PURE__ */ function(...k) {
    return (D) => {
      k.forEach(($) => {
        typeof $ == "function" ? $(D) : $ != null && ($.current = D);
      });
    };
  }(A, P), [P, A]);
  return R2(() => (O(e.isEditable()), e.registerEditableListener((k) => {
    O(k);
  })), [e]), E("div", { ...S, "aria-activedescendant": _ ? t : void 0, "aria-autocomplete": _ ? n : "none", "aria-controls": _ ? r : void 0, "aria-describedby": i, "aria-expanded": _ && y === "combobox" ? !!o : void 0, "aria-label": a, "aria-labelledby": s, "aria-multiline": l, "aria-owns": _ ? c : void 0, "aria-readonly": !_ || void 0, "aria-required": f, autoCapitalize: d, className: p, contentEditable: _, "data-testid": w, id: m, ref: C, role: _ ? y : void 0, spellCheck: g, style: v, tabIndex: x });
}
const nQ = Dt(tQ);
function tE(e) {
  return e.getEditorState().read($2(e.isComposing()));
}
const rQ = Dt(iQ);
function iQ(e, t) {
  const { placeholder: n, ...r } = e, [i] = Gr();
  return he(Ut, { children: [E(nQ, { editor: i, ...r, ref: t }), n != null && E(oQ, { editor: i, content: n })] });
}
function oQ({ content: e, editor: t }) {
  const n = function(a) {
    const [s, l] = Me(() => tE(a));
    return R2(() => {
      function c() {
        const f = tE(a);
        l(f);
      }
      return c(), Vo(a.registerUpdateListener(() => {
        c();
      }), a.registerEditableListener(() => {
        c();
      }));
    }, [a]), s;
  }(t), [r, i] = Me(t.isEditable());
  if (di(() => (i(t.isEditable()), t.registerEditableListener((a) => {
    i(a);
  })), [t]), !n) return null;
  let o = null;
  return typeof e == "function" ? o = e(r) : e !== null && (o = e), o === null ? null : E("div", { "aria-hidden": !0, children: o });
}
const Wh = 0, ax = 1, sx = 2, Si = 0, aQ = 1, nE = 2, sQ = 3, lQ = 4;
function cQ(e, t, n, r, i) {
  if (e === null || n.size === 0 && r.size === 0 && !i) return Si;
  const o = t._selection, a = e._selection;
  if (i) return aQ;
  if (!(we(o) && we(a) && a.isCollapsed() && o.isCollapsed())) return Si;
  const s = function(x, w, S) {
    const A = x._nodeMap, _ = [];
    for (const O of w) {
      const P = A.get(O);
      P !== void 0 && _.push(P);
    }
    for (const [O, P] of S) {
      if (!P) continue;
      const C = A.get(O);
      C === void 0 || ur(C) || _.push(C);
    }
    return _;
  }(t, n, r);
  if (s.length === 0) return Si;
  if (s.length > 1) {
    const x = t._nodeMap, w = x.get(o.anchor.key), S = x.get(a.anchor.key);
    return w && S && !e._nodeMap.has(w.__key) && Se(w) && w.__text.length === 1 && o.anchor.offset === 1 ? nE : Si;
  }
  const l = s[0], c = e._nodeMap.get(l.__key);
  if (!Se(c) || !Se(l) || c.__mode !== l.__mode) return Si;
  const f = c.__text, d = l.__text;
  if (f === d) return Si;
  const p = o.anchor, m = a.anchor;
  if (p.key !== m.key || p.type !== "text") return Si;
  const y = p.offset, g = m.offset, v = d.length - f.length;
  return v === 1 && g === y - 1 ? nE : v === -1 && g === y + 1 ? sQ : v === -1 && g === y ? lQ : Si;
}
function uQ(e, t) {
  let n = Date.now(), r = Si;
  return (i, o, a, s, l, c) => {
    const f = Date.now();
    if (c.has("historic")) return r = Si, n = f, sx;
    const d = cQ(i, o, s, l, e.isComposing()), p = (() => {
      const m = a === null || a.editor === e, y = c.has("history-push");
      if (!y && m && c.has("history-merge")) return Wh;
      if (i === null) return ax;
      const g = o._selection;
      return s.size > 0 || l.size > 0 ? y === !1 && d !== Si && d === r && f < n + t && m || s.size === 1 && function(v, x, w) {
        const S = x._nodeMap.get(v), A = w._nodeMap.get(v), _ = x._selection, O = w._selection;
        return !(we(_) && we(O) && _.anchor.type === "element" && _.focus.type === "element" && O.anchor.type === "text" && O.focus.type === "text" || !Se(S) || !Se(A) || S.__parent !== A.__parent) && JSON.stringify(x.read(() => S.exportJSON())) === JSON.stringify(w.read(() => A.exportJSON()));
      }(Array.from(s)[0], i, o) ? Wh : ax : g !== null ? Wh : sx;
    })();
    return n = f, r = d, p;
  };
}
function rE(e) {
  e.undoStack = [], e.redoStack = [], e.current = null;
}
function fQ(e, t, n) {
  const r = uQ(e, n);
  return Vo(e.registerCommand(Y1, () => (function(o, a) {
    const s = a.redoStack, l = a.undoStack;
    if (l.length !== 0) {
      const c = a.current, f = l.pop();
      c !== null && (s.push(c), o.dispatchCommand(Rh, !0)), l.length === 0 && o.dispatchCommand(jh, !1), a.current = f || null, f && f.editor.setEditorState(f.editorState, { tag: "historic" });
    }
  }(e, t), !0), nn), e.registerCommand(q1, () => (function(o, a) {
    const s = a.redoStack, l = a.undoStack;
    if (s.length !== 0) {
      const c = a.current;
      c !== null && (l.push(c), o.dispatchCommand(jh, !0));
      const f = s.pop();
      s.length === 0 && o.dispatchCommand(Rh, !1), a.current = f || null, f && f.editor.setEditorState(f.editorState, { tag: "historic" });
    }
  }(e, t), !0), nn), e.registerCommand(AZ, () => (rE(t), !1), nn), e.registerCommand(TZ, () => (rE(t), e.dispatchCommand(Rh, !1), e.dispatchCommand(jh, !1), !0), nn), e.registerUpdateListener(({ editorState: o, prevEditorState: a, dirtyLeaves: s, dirtyElements: l, tags: c }) => {
    const f = t.current, d = t.redoStack, p = t.undoStack, m = f === null ? null : f.editorState;
    if (f !== null && o === m) return;
    const y = r(a, o, f, s, l, c);
    if (y === ax) d.length !== 0 && (t.redoStack = [], e.dispatchCommand(Rh, !1)), f !== null && (p.push({ ...f }), e.dispatchCommand(jh, !0));
    else if (y === sx) return;
    t.current = { editor: e, editorState: o };
  }));
}
function dQ() {
  return { current: null, redoStack: [], undoStack: [] };
}
function hQ({ delay: e, externalHistoryState: t }) {
  const [n] = Gr();
  return function(r, i, o = 1e3) {
    const a = Fe(() => i || dQ(), [i]);
    Xe(() => fQ(r, a, o), [o, r, a]);
  }(n, t, e), null;
}
function lx(e, t) {
  return lx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, lx(e, t);
}
var iE = { error: null }, pQ = function(e) {
  var t, n;
  function r() {
    for (var o, a = arguments.length, s = new Array(a), l = 0; l < a; l++) s[l] = arguments[l];
    return (o = e.call.apply(e, [this].concat(s)) || this).state = iE, o.resetErrorBoundary = function() {
      for (var c, f = arguments.length, d = new Array(f), p = 0; p < f; p++) d[p] = arguments[p];
      o.props.onReset == null || (c = o.props).onReset.apply(c, d), o.reset();
    }, o;
  }
  n = e, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, lx(t, n), r.getDerivedStateFromError = function(o) {
    return { error: o };
  };
  var i = r.prototype;
  return i.reset = function() {
    this.setState(iE);
  }, i.componentDidCatch = function(o, a) {
    var s, l;
    (s = (l = this.props).onError) == null || s.call(l, o, a);
  }, i.componentDidUpdate = function(o, a) {
    var s, l, c, f, d = this.state.error, p = this.props.resetKeys;
    d !== null && a.error !== null && ((c = o.resetKeys) === void 0 && (c = []), (f = p) === void 0 && (f = []), c.length !== f.length || c.some(function(m, y) {
      return !Object.is(m, f[y]);
    })) && ((s = (l = this.props).onResetKeysChange) == null || s.call(l, o.resetKeys, p), this.reset());
  }, i.render = function() {
    var o = this.state.error, a = this.props, s = a.fallbackRender, l = a.FallbackComponent, c = a.fallback;
    if (o !== null) {
      var f = { error: o, resetErrorBoundary: this.resetErrorBoundary };
      if (te.isValidElement(c)) return c;
      if (typeof s == "function") return s(f);
      if (l) return te.createElement(l, f);
      throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, r;
}(te.Component);
function mQ({ children: e, onError: t }) {
  return E(pQ, { fallback: E("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" }, children: "An error was thrown." }), onError: t, children: e });
}
const gQ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? di : Xe;
function yQ({ ignoreHistoryMergeTagChange: e = !0, ignoreSelectionChange: t = !1, onChange: n }) {
  const [r] = Gr();
  return gQ(() => {
    if (n) return r.registerUpdateListener(({ editorState: i, dirtyElements: o, dirtyLeaves: a, prevEditorState: s, tags: l }) => {
      t && o.size === 0 && a.size === 0 || e && l.has("history-merge") || s.isEmpty() || n(i, r, l);
    });
  }, [r, e, t, n]), null;
}
function vQ({ editorRef: e }) {
  const [t] = Gr();
  return te.useEffect(() => {
    typeof e == "function" ? e(t) : typeof e == "object" && (e.current = t);
  }, [t]), null;
}
const bQ = "w-full [&>p]:w-full [&>p]:m-0", xQ = "focus-within:ring-2 focus-within:ring-offset-2 hover:outline-border-strong hover:focus-within:outline-focus-border focus-within:outline-focus-border focus-within:ring-focus transition-[color,outline,box-shadow] duration-150 ease-in-out outline outline-1 outline-field-border", wQ = "bg-field-secondary-background outline-field-border-disabled hover:outline-field-border-disabled [&_p]:text-badge-color-disabled cursor-not-allowed", _Q = {
  sm: "px-3 py-1.5 rounded [&_.editor-content>p]:text-xs [&_.editor-content>p]:font-normal [&_.pointer-events-none]:text-xs [&_.pointer-events-none]:font-normal [&_.editor-content>p]:content-center [&_.editor-content>p]:min-h-5",
  md: "px-3.5 py-2 rounded-md [&_.editor-content>p]:text-sm [&_.editor-content>p]:font-normal [&_.pointer-events-none]:text-sm [&_.pointer-events-none]:font-normal [&_.editor-content>p]:content-center [&_.editor-content>p]:min-h-6",
  lg: "px-4 py-2.5 rounded-md [&_.editor-content>p]:text-base [&_.editor-content>p]:font-normal [&_.pointer-events-none]:text-base [&_.pointer-events-none]:font-normal [&_.editor-content>p]:content-center [&_.editor-content>p]:min-h-7"
}, SQ = "absolute inset-x-0 top-full mt-2 mx-0 mb-0 w-full h-auto overflow-y-auto overflow-x-hidden z-10 bg-background-primary border border-solid border-border-subtle shadow-lg", OQ = {
  sm: "p-1.5 rounded-md max-h-[10.75rem]",
  md: "p-2 rounded-lg max-h-[13.5rem]",
  lg: "p-2 rounded-lg max-h-[13.5rem]"
}, AQ = "m-0 text-text-primary cursor-pointer", TQ = {
  sm: "p-1.5 rounded text-xs leading-5 font-normal",
  md: "p-2 rounded-md text-sm leading-6 font-normal",
  lg: "p-2 rounded-md text-base leading-6 font-normal"
}, PQ = "bg-button-tertiary-hover", oE = "startTransition", CQ = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? di : Xe, aE = (e) => {
  const t = document.getElementById("typeahead-menu");
  if (!t) return;
  const n = t.getBoundingClientRect();
  n.top + n.height > window.innerHeight && t.scrollIntoView({ block: "center" }), n.top < 0 && t.scrollIntoView({ block: "center" }), e.scrollIntoView({ block: "nearest" });
};
function sE(e, t) {
  const n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
  return n.top > r.top && n.top < r.bottom;
}
function EQ(e, t, n, r) {
  const [i] = Gr();
  Xe(() => {
    if (t != null && e != null) {
      const o = i.getRootElement(), a = o != null ? function(d, p) {
        let m = getComputedStyle(d);
        const y = m.position === "absolute", g = /(auto|scroll)/;
        if (m.position === "fixed") return document.body;
        for (let v = d; v = v.parentElement; ) if (m = getComputedStyle(v), (!y || m.position !== "static") && g.test(m.overflow + m.overflowY + m.overflowX)) return v;
        return document.body;
      }(o) : document.body;
      let s = !1, l = sE(t, a);
      const c = function() {
        s || (window.requestAnimationFrame(function() {
          n(), s = !1;
        }), s = !0);
        const d = sE(t, a);
        d !== l && (l = d, r != null && r(d));
      }, f = new ResizeObserver(n);
      return window.addEventListener("resize", n), document.addEventListener("scroll", c, { capture: !0, passive: !0 }), f.observe(t), () => {
        f.unobserve(t), window.removeEventListener("resize", n), document.removeEventListener("scroll", c, !0);
      };
    }
  }, [t, i, r, n, e]);
}
const lE = vZ();
function kQ({ close: e, editor: t, anchorElementRef: n, resolution: r, options: i, menuRenderFn: o, onSelectOption: a, shouldSplitNodeWithQuery: s = !1, commandPriority: l = tc }) {
  const [c, f] = Me(null), d = r.match && r.match.matchingString;
  Xe(() => {
    f(0);
  }, [d]);
  const p = qe((y) => {
    t.update(() => {
      const g = r.match != null && s ? function(v) {
        const x = Ne();
        if (!we(x) || !x.isCollapsed()) return null;
        const w = x.anchor;
        if (w.type !== "text") return null;
        const S = w.getNode();
        if (!S.isSimpleText()) return null;
        const A = w.offset, _ = S.getTextContent().slice(0, A), O = v.replaceableString.length, P = A - function(k, D, $) {
          let N = $;
          for (let R = N; R <= D.length; R++) k.substr(-R) === D.substr(0, R) && (N = R);
          return N;
        }(_, v.matchingString, O);
        if (P < 0) return null;
        let C;
        return P === 0 ? [C] = S.splitText(A) : [, C] = S.splitText(P, A), C;
      }(r.match) : null;
      a(y, g, e, r.match ? r.match.matchingString : "");
    });
  }, [t, s, r.match, a, e]), m = qe((y) => {
    const g = t.getRootElement();
    g !== null && (g.setAttribute("aria-activedescendant", "typeahead-item-" + y), f(y));
  }, [t]);
  return Xe(() => () => {
    const y = t.getRootElement();
    y !== null && y.removeAttribute("aria-activedescendant");
  }, [t]), CQ(() => {
    i === null ? f(null) : c === null && m(0);
  }, [i, c, m]), Xe(() => Vo(t.registerCommand(lE, ({ option: y }) => !(!y.ref || y.ref.current == null) && (aE(y.ref.current), !0), l)), [t, m, l]), Xe(() => Vo(t.registerCommand(DR, (y) => {
    const g = y;
    if (i !== null && i.length && c !== null) {
      const v = c !== i.length - 1 ? c + 1 : 0;
      m(v);
      const x = i[v];
      x.ref != null && x.ref.current && t.dispatchCommand(lE, { index: v, option: x }), g.preventDefault(), g.stopImmediatePropagation();
    }
    return !0;
  }, l), t.registerCommand($R, (y) => {
    const g = y;
    if (i !== null && i.length && c !== null) {
      const v = c !== 0 ? c - 1 : i.length - 1;
      m(v);
      const x = i[v];
      x.ref != null && x.ref.current && aE(x.ref.current), g.preventDefault(), g.stopImmediatePropagation();
    }
    return !0;
  }, l), t.registerCommand(IR, (y) => {
    const g = y;
    return g.preventDefault(), g.stopImmediatePropagation(), e(), !0;
  }, l), t.registerCommand(jR, (y) => {
    const g = y;
    return i !== null && c !== null && i[c] != null && (g.preventDefault(), g.stopImmediatePropagation(), p(i[c]), !0);
  }, l), t.registerCommand(xf, (y) => i !== null && c !== null && i[c] != null && (y !== null && (y.preventDefault(), y.stopImmediatePropagation()), p(i[c]), !0), l)), [p, e, t, i, c, m, l]), o(n, Fe(() => ({ options: i, selectOptionAndCleanUp: p, selectedIndex: c, setHighlightedIndex: f }), [p, c, i]), r.match ? r.match.matchingString : "");
}
function MQ({ options: e, onQueryChange: t, onSelectOption: n, onOpen: r, onClose: i, menuRenderFn: o, triggerFn: a, anchorClassName: s, commandPriority: l = tc, parent: c }) {
  const [f] = Gr(), [d, p] = Me(null), m = function(v, x, w, S = document.body) {
    const [A] = Gr(), _ = ut(document.createElement("div")), O = qe(() => {
      _.current.style.top = _.current.style.bottom;
      const C = A.getRootElement(), k = _.current, D = k.firstChild;
      if (C !== null && v !== null) {
        const { left: $, top: N, width: R, height: L } = v.getRect(), F = _.current.offsetHeight;
        if (k.style.top = `${N + window.pageYOffset + F + 3}px`, k.style.left = `${$ + window.pageXOffset}px`, k.style.height = `${L}px`, k.style.width = `${R}px`, D !== null) {
          D.style.top = `${N}`;
          const W = D.getBoundingClientRect(), z = W.height, G = W.width, U = C.getBoundingClientRect();
          $ + G > U.right && (k.style.left = `${U.right - G + window.pageXOffset}px`), (N + z > window.innerHeight || N + z > U.bottom) && N - U.top > z + L && (k.style.top = N - z + window.pageYOffset - L + "px");
        }
        k.isConnected || (w != null && (k.className = w), k.setAttribute("aria-label", "Typeahead menu"), k.setAttribute("id", "typeahead-menu"), k.setAttribute("role", "listbox"), k.style.display = "block", k.style.position = "absolute", S.append(k)), _.current = k, C.setAttribute("aria-controls", "typeahead-menu");
      }
    }, [A, v, w, S]);
    Xe(() => {
      const C = A.getRootElement();
      if (v !== null) return O(), () => {
        C !== null && C.removeAttribute("aria-controls");
        const k = _.current;
        k !== null && k.isConnected && k.remove();
      };
    }, [A, O, v]);
    const P = qe((C) => {
      v !== null && (C || x(null));
    }, [v, x]);
    return EQ(v, _.current, O, P), _;
  }(d, p, s, c), y = qe(() => {
    p(null), i != null && d !== null && i();
  }, [i, d]), g = qe((v) => {
    p(v), r != null && d === null && r(v);
  }, [r, d]);
  return Xe(() => {
    const v = f.registerUpdateListener(() => {
      f.getEditorState().read(() => {
        const x = f._window || window, w = x.document.createRange(), S = Ne(), A = function(P) {
          let C = null;
          return P.getEditorState().read(() => {
            const k = Ne();
            we(k) && (C = function(D) {
              const $ = D.anchor;
              if ($.type !== "text") return null;
              const N = $.getNode();
              if (!N.isSimpleText()) return null;
              const R = $.offset;
              return N.getTextContent().slice(0, R);
            }(k));
          }), C;
        }(f);
        if (!we(S) || !S.isCollapsed() || A === null || w === null) return void y();
        const _ = a(A, f);
        if (t(_ ? _.matchingString : null), _ !== null && !function(P, C) {
          return C === 0 && P.getEditorState().read(() => {
            const k = Ne();
            if (we(k)) {
              const D = k.anchor.getNode().getPreviousSibling();
              return Se(D) && D.isTextEntity();
            }
            return !1;
          });
        }(f, _.leadOffset) && function(C, k, D) {
          const $ = D.getSelection();
          if ($ === null || !$.isCollapsed) return !1;
          const N = $.anchorNode, R = C, L = $.anchorOffset;
          if (N == null || L == null) return !1;
          try {
            k.setStart(N, R), k.setEnd(N, L);
          } catch {
            return !1;
          }
          return !0;
        }(_.leadOffset, w, x) !== null)
          return O = () => g({ getRect: () => w.getBoundingClientRect(), match: _ }), void (oE in I ? I[oE](O) : O());
        var O;
        y();
      });
    });
    return () => {
      v();
    };
  }, [f, a, t, d, y, g]), d === null || f === null ? null : E(kQ, { close: y, resolution: d, editor: f, anchorElementRef: m, options: e, menuRenderFn: o, shouldSplitNodeWithQuery: !0, onSelectOption: n, commandPriority: l });
}
const NQ = (e) => {
  switch (e) {
    case "sm":
      return "xs";
    case "md":
      return "sm";
    case "lg":
      return "md";
    default:
      return "sm";
  }
}, $Q = ({
  data: e,
  by: t,
  size: n,
  nodeKey: r
}) => {
  const [i] = Gr(), o = !i.isEditable(), a = (f) => {
    f.stopPropagation(), f.preventDefault(), !o && i.update(() => {
      const d = $n(r);
      d && d.remove();
    });
  };
  let s = e;
  typeof e == "object" && (s = e[t]);
  const l = qe(
    (f) => {
      const d = $n(r);
      if (!d || !d.isSelected())
        return !1;
      let p = !1;
      const m = d.getPreviousSibling();
      return ye(m) && (m.selectEnd(), p = !0), Se(m) && (m.select(), p = !0), Ht(m) && (m.selectNext(), p = !0), m === null && (d.selectPrevious(), p = !0), p && f.preventDefault(), p;
    },
    [r]
  ), c = qe(
    (f) => {
      const d = $n(r);
      if (!d || !d.isSelected())
        return !1;
      let p = !1;
      const m = d.getNextSibling();
      return ye(m) && (m.selectStart(), p = !0), Se(m) && (m.select(0, 0), p = !0), Ht(m) && (m.selectPrevious(), p = !0), m === null && (d.selectNext(), p = !0), p && f.preventDefault(), p;
    },
    [r]
  );
  return Xe(() => {
    const f = Vo(
      i.registerCommand(
        Z1,
        l,
        tc
      ),
      i.registerCommand(
        X1,
        c,
        tc
      )
    );
    return () => {
      f();
    };
  }, [i, l, c]), /* @__PURE__ */ E(
    mg,
    {
      className: "inline-flex mr-0.5",
      type: "rounded",
      size: NQ(n),
      label: s,
      icon: null,
      closable: !0,
      onClose: a,
      disabled: o
    }
  );
};
class nc extends E2 {
  constructor(n, r, i, o) {
    super(o);
    da(this, "__data");
    da(this, "__by");
    da(this, "__size");
    this.__data = n, this.__by = r, this.__size = i;
  }
  static getType() {
    return "mention";
  }
  static clone(n) {
    return new nc(n.__data, n.__by, n.__size, n.__key);
  }
  static importJSON(n) {
    return j2(
      n.data,
      n.by,
      n.size
    );
  }
  createDOM() {
    return document.createElement("span");
  }
  updateDOM() {
    return !1;
  }
  exportDOM() {
    return { element: document.createElement("span") };
  }
  exportJSON() {
    return {
      type: nc.getType(),
      data: this.__data,
      by: this.__by,
      size: this.__size,
      version: 1
    };
  }
  decorate() {
    return /* @__PURE__ */ E(
      $Q,
      {
        data: this.__data,
        by: this.__by,
        size: this.__size,
        nodeKey: this.__key
      }
    );
  }
}
const j2 = (e, t, n) => new nc(e, t, n), DQ = (e) => e instanceof nc;
class IQ {
  constructor(t) {
    da(this, "data");
    da(this, "key");
    da(this, "ref");
    da(this, "setRefElement");
    this.initData = t, this.key = "", this.data = t, this.ref = { current: null }, this.setRefElement = (n) => {
      this.ref.current = n;
    };
  }
}
const Ob = /* @__PURE__ */ new Map();
function RQ(e, t, n = "name") {
  const [r, i] = Me([]);
  return Xe(() => {
    if (t === null) {
      i([]);
      return;
    }
    const o = Ob.get(t);
    if (o !== null) {
      if (o !== void 0) {
        i(o);
        return;
      }
      Ob.set(t, null), jQ.search(
        e,
        t,
        (a) => {
          Ob.set(t, a), i(a);
        },
        n
      );
    }
  }, [t]), r;
}
const jQ = {
  search(e, t, n, r) {
    setTimeout(() => {
      if (!Array.isArray(e))
        return [];
      const i = e.filter(
        (o) => {
          var s;
          if (typeof o == "string")
            return o.toLowerCase().includes(t.toLowerCase());
          const a = (s = o == null ? void 0 : o[r]) == null ? void 0 : s.toString();
          return a ? a.toLowerCase().includes(t.toLowerCase()) : !1;
        }
      );
      n(i);
    }, 500);
  }
}, Hp = ({ size: e, className: t, children: n }) => /* @__PURE__ */ E(
  "ul",
  {
    role: "menu",
    className: K(
      SQ,
      OQ[e],
      t
    ),
    children: n
  }
);
Hp.displayName = "EditorCombobox";
const L2 = Dt(
  ({ size: e, children: t, selected: n = !1, className: r, ...i }, o) => /* @__PURE__ */ E(
    "li",
    {
      role: "option",
      ref: o,
      className: K(
        AQ,
        TQ[e],
        n && PQ,
        r
      ),
      ...i,
      children: t
    }
  )
);
L2.displayName = "EditorCombobox.Item";
Hp.Item = L2;
const LQ = ({
  optionsArray: e,
  by: t = "name",
  size: n = "md",
  trigger: r = "@",
  // Default trigger value
  menuComponent: i = Hp,
  menuItemComponent: o = Hp.Item,
  autoSpace: a = !0
}) => {
  const s = ut(!1), l = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`, c = [r].join(""), f = "[^" + c + l + "\\s]", d = "(?:\\.[ |$]| |[" + l + "]|)", p = 75, m = new RegExp(
    `(^|\\s|\\()([${c}]((?:${f}${d}){0,${p}}))$`
  ), y = 50, g = new RegExp(
    `(^|\\s|\\()([${c}]((?:${f}){0,${y}}))$`
  ), v = (k) => {
    let D = m.exec(k);
    if (D === null && (D = g.exec(k)), D !== null) {
      const $ = D[1], N = D[3];
      if (N.length >= 0)
        return {
          leadOffset: D.index + $.length,
          matchingString: N,
          replaceableString: D[2]
        };
    }
    return null;
  }, [x] = Gr(), [w, S] = Me(null), A = RQ(e, w, t), _ = qe(
    (k, D, $) => {
      x.update(() => {
        const N = j2(
          k.data,
          t,
          n
        );
        D && D.replace(N), $();
      });
    },
    [x]
  ), O = Fe(() => A.map((k) => new IQ(k)), [x, A]), P = qe(
    (k) => {
      if (!a)
        return !1;
      const { key: D, ctrlKey: $, metaKey: N } = k;
      if ($ || N || D === " " || D.length > 1 || s.current)
        return s.current && (s.current = !1), !1;
      const R = Ne(), { focus: L, anchor: F } = R, [W] = R.getNodes();
      if (!F || !L || (F == null ? void 0 : F.key) !== (L == null ? void 0 : L.key) || (F == null ? void 0 : F.offset) !== (L == null ? void 0 : L.offset) || !W)
        return !1;
      if (DQ(W)) {
        const z = Vn(" ");
        return W.insertAfter(z), !0;
      }
      return !1;
    },
    [x, r, a]
  ), C = qe(
    (k) => {
      const { key: D } = k;
      return D === "Backspace" ? (s.current = !0, !0) : !1;
    },
    [s]
  );
  return Xe(() => {
    if (x)
      return Vo(
        x.registerCommand(
          NR,
          P,
          tc
        ),
        x.registerCommand(
          J1,
          C,
          tc
        )
      );
  }, [x, P]), /* @__PURE__ */ E(
    MQ,
    {
      onQueryChange: S,
      onSelectOption: _,
      triggerFn: v,
      options: O,
      menuRenderFn: (k, { selectedIndex: D, selectOptionAndCleanUp: $, setHighlightedIndex: N }) => k.current && (O != null && O.length) ? /* @__PURE__ */ E(i, { size: n, children: O.map((R, L) => {
        var F;
        return /* @__PURE__ */ E(
          o,
          {
            ref: R.ref,
            size: n,
            selected: L === D,
            onMouseEnter: () => {
              N(L);
            },
            onClick: () => $(R),
            children: typeof R.data == "string" ? R.data : (F = R.data) == null ? void 0 : F[t]
          },
          L
        );
      }) }) : null
    }
  );
}, BQ = {
  ltr: "ltr",
  rtl: "rtl",
  paragraph: "editor-paragraph",
  quote: "editor-quote",
  heading: {
    h1: "editor-heading-h1",
    h2: "editor-heading-h2",
    h3: "editor-heading-h3",
    h4: "editor-heading-h4",
    h5: "editor-heading-h5",
    h6: "editor-heading-h6"
  },
  list: {
    nested: {
      listitem: "editor-nested-listitem"
    },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
    listitem: "editor-listItem",
    listitemChecked: "editor-listItemChecked",
    listitemUnchecked: "editor-listItemUnchecked"
  },
  hashtag: "editor-hashtag",
  image: "editor-image",
  link: "editor-link",
  text: {
    bold: "editor-textBold",
    code: "editor-textCode",
    italic: "editor-textItalic",
    strikethrough: "editor-textStrikethrough",
    subscript: "editor-textSubscript",
    superscript: "editor-textSuperscript",
    underline: "editor-textUnderline",
    underlineStrikethrough: "editor-textUnderlineStrikethrough"
  },
  code: "editor-code",
  codeHighlight: {
    atrule: "editor-tokenAttr",
    attr: "editor-tokenAttr",
    boolean: "editor-tokenProperty",
    builtin: "editor-tokenSelector",
    cdata: "editor-tokenComment",
    char: "editor-tokenSelector",
    class: "editor-tokenFunction",
    "class-name": "editor-tokenFunction",
    comment: "editor-tokenComment",
    constant: "editor-tokenProperty",
    deleted: "editor-tokenProperty",
    doctype: "editor-tokenComment",
    entity: "editor-tokenOperator",
    function: "editor-tokenFunction",
    important: "editor-tokenVariable",
    inserted: "editor-tokenSelector",
    keyword: "editor-tokenAttr",
    namespace: "editor-tokenVariable",
    number: "editor-tokenProperty",
    operator: "editor-tokenOperator",
    prolog: "editor-tokenComment",
    property: "editor-tokenProperty",
    punctuation: "editor-tokenPunctuation",
    regex: "editor-tokenVariable",
    selector: "editor-tokenSelector",
    string: "editor-tokenSelector",
    symbol: "editor-tokenProperty",
    tag: "editor-tokenProperty",
    url: "editor-tokenOperator",
    variable: "editor-tokenVariable"
  }
}, FQ = ({ content: e }) => /* @__PURE__ */ E(
  "div",
  {
    "aria-hidden": "true",
    className: "pointer-events-none absolute inset-0 flex items-center justify-start text-field-placeholder w-full",
    children: /* @__PURE__ */ E("span", { className: "truncate", children: e })
  }
);
function WQ(e) {
  console.error(e);
}
const zQ = `{
    "root": {
        "children": [
            {
                "children": [],
                "direction": null,
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1,
                "textFormat": 0,
                "textStyle": ""
            }
        ],
        "direction": null,
        "format": "",
        "indent": 0,
        "type": "root",
        "version": 1
    }
}`, VQ = Dt(
  ({
    defaultValue: e = "",
    placeholder: t = "Press @ to view variable suggestions",
    onChange: n,
    size: r = "md",
    autoFocus: i = !1,
    options: o,
    by: a = "name",
    trigger: s = "@",
    menuComponent: l,
    menuItemComponent: c,
    className: f,
    wrapperClassName: d,
    disabled: p = !1,
    autoSpaceAfterMention: m = !1
  }, y) => {
    const g = {
      namespace: "Editor",
      editorTheme: BQ,
      onError: WQ,
      nodes: [nc],
      editorState: e || zQ,
      editable: !p
    }, v = (S, A) => {
      typeof n == "function" && n(S, A);
    };
    let x, w;
    return rt(l) && (x = l), rt(c) && (w = c), /* @__PURE__ */ E(
      "div",
      {
        className: K(
          "relative w-full",
          xQ,
          _Q[r],
          p && wQ,
          d
        ),
        children: /* @__PURE__ */ he(TJ, { initialConfig: g, children: [
          /* @__PURE__ */ E("div", { className: "relative w-full [&_p]:m-0", children: /* @__PURE__ */ E(
            QJ,
            {
              contentEditable: /* @__PURE__ */ E(
                rQ,
                {
                  className: K(
                    "editor-content focus-visible:outline-none outline-none",
                    bQ,
                    f
                  )
                }
              ),
              placeholder: /* @__PURE__ */ E(FQ, { content: t }),
              ErrorBoundary: mQ
            }
          ) }),
          /* @__PURE__ */ E(hQ, {}),
          /* @__PURE__ */ E(
            LQ,
            {
              menuComponent: x,
              menuItemComponent: w,
              size: r,
              by: a,
              optionsArray: o,
              trigger: s,
              autoSpace: m
            }
          ),
          /* @__PURE__ */ E(
            yQ,
            {
              onChange: v,
              ignoreSelectionChange: !0
            }
          ),
          y && /* @__PURE__ */ E(vQ, { editorRef: y }),
          i && /* @__PURE__ */ E(yZ, {})
        ] })
      }
    );
  }
);
VQ.displayName = "EditorInput";
const UQ = (e, t, n, r) => {
  const i = `absolute rounded-full transition-colors duration-500 ${n[r].dot}`;
  return e === "dot" ? K(
    i,
    n[r].dot,
    t ? "bg-brand-primary-600" : "bg-text-tertiary"
  ) : e === "number" ? K(
    i,
    n[r].dot,
    t ? "text-brand-primary-600" : "text-text-tertiary",
    "flex items-center justify-center"
  ) : e === "icon" ? K(
    i,
    t ? "text-brand-primary-600" : "text-text-tertiary",
    "flex items-center justify-center"
  ) : "";
}, HQ = (e, t, n) => K(
  "relative flex items-center rounded-full justify-center transition-colors z-10 duration-500 ring-1",
  e ? "ring-brand-primary-600" : "ring-border-subtle",
  t[n].ring
), KQ = (e, t) => K(
  "rounded-full text-brand-primary-600 transition-colors duration-300",
  e[t].dot,
  e[t].ring
), GQ = {
  sm: {
    dot: "size-2.5",
    ring: "size-5",
    numberIcon: "size-5 text-tiny",
    icon: "size-5",
    label: "text-xs"
  },
  md: {
    dot: "size-3",
    ring: "size-6",
    numberIcon: "size-6 text-sm",
    icon: "size-6",
    label: "text-sm"
  },
  lg: {
    dot: "size-3.5",
    ring: "size-7",
    numberIcon: "size-7 text-md",
    icon: "size-7",
    label: "text-sm"
  }
}, YQ = ({
  variant: e = "dot",
  size: t = "sm",
  type: n = "inline",
  currentStep: r = 1,
  children: i,
  className: o,
  lineClassName: a = "min-w-10",
  ...s
}) => {
  const l = I.Children.count(i);
  r === -1 && (r = l + 1);
  const c = I.Children.map(i, (f, d) => {
    const p = d + 1 < r, m = d + 1 === r, y = d + 1 === l, g = {
      isCompleted: p,
      isCurrent: m,
      sizeClasses: GQ,
      size: t,
      variant: e,
      type: n,
      isLast: y,
      index: d,
      lineClassName: a
    };
    return /* @__PURE__ */ E(I.Fragment, { children: I.isValidElement(f) ? I.cloneElement(f, g) : f }, d);
  });
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex w-full",
        o,
        n === "inline" ? "items-center justify-between" : ""
      ),
      ...s,
      children: c
    }
  );
}, B2 = ({
  labelText: e = "",
  icon: t = /* @__PURE__ */ E(tD, {}),
  isCurrent: n,
  isCompleted: r,
  className: i,
  type: o,
  variant: a,
  sizeClasses: s,
  size: l,
  isLast: c,
  index: f,
  lineClassName: d,
  ...p
}) => {
  const m = qQ(
    a,
    r,
    n,
    s,
    l,
    t,
    f
  ), y = {
    lg: "left-[calc(50%+14px)] right-[calc(-50%+14px)]",
    md: "left-[calc(50%+12px)] right-[calc(-50%+12px)]",
    sm: "left-[calc(50%+10px)] right-[calc(-50%+10px)]"
  }, g = {
    lg: "top-3.5",
    md: "top-3",
    sm: "top-2.5"
  }, v = () => {
    if (e) {
      const w = K(
        s[l].label,
        "text-text-tertiary",
        n ? "text-brand-primary-600" : "",
        "break-word",
        // max width for inline and stack
        o === "stack" ? "mt-2 transform max-w-xs" : "mx-2 max-w-32"
      );
      return /* @__PURE__ */ E("span", { className: w, children: e });
    }
    return null;
  }, x = () => {
    if (!c) {
      const w = K(
        "block",
        r ? "border-brand-primary-600" : "border-border-subtle",
        d
      );
      return o === "stack" ? /* @__PURE__ */ E(
        "div",
        {
          className: K(
            "relative",
            "flex",
            "border-solid",
            "border-y",
            "absolute",
            r ? "border-brand-primary-600" : "border-border-subtle",
            g[l],
            y[l]
          ),
          children: /* @__PURE__ */ E("span", { className: "block" })
        }
      ) : /* @__PURE__ */ E("div", { className: "flex-1", children: /* @__PURE__ */ E(
        "span",
        {
          className: K(
            "mr-2 border-y border-solid",
            !e && "ml-2",
            w
          )
        }
      ) });
    }
    return null;
  };
  return o === "stack" ? /* @__PURE__ */ he("div", { className: "relative flex-1 justify-center", children: [
    /* @__PURE__ */ he(
      "div",
      {
        className: K("flex items-center flex-col", i),
        ...p,
        children: [
          m,
          v()
        ]
      }
    ),
    x()
  ] }) : /* @__PURE__ */ he(Ut, { children: [
    /* @__PURE__ */ he("div", { className: K("flex items-center", i), ...p, children: [
      m,
      v()
    ] }),
    x()
  ] });
};
B2.displayName = "ProgressSteps.Step";
const qQ = (e, t, n, r, i, o, a) => {
  if (t)
    return /* @__PURE__ */ E(ad, { className: KQ(r, i) });
  const s = HQ(!!n, r, i), l = UQ(
    e,
    n,
    r,
    i
  );
  let c = null;
  return e === "number" ? c = a + 1 : e === "icon" && o && (c = o), /* @__PURE__ */ E("span", { className: s, children: /* @__PURE__ */ E("span", { className: l, children: c }) });
};
YQ.Step = B2;
const tke = ({
  variant: e = "rectangular",
  // rectangular, circular
  className: t,
  ...n
}) => {
  const r = {
    circular: "rounded-full bg-gray-200 ",
    rectangular: "rounded-md bg-gray-200"
  }[e], i = {
    circular: "size-10",
    rectangular: "w-96 h-3"
  }[e];
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        r,
        "animate-pulse",
        i,
        t
      ),
      ...n
    }
  );
}, F2 = dt({}), W2 = () => Ve(F2), Ua = ({ size: e = "md", children: t, className: n }) => /* @__PURE__ */ E(F2.Provider, { value: { size: e }, children: /* @__PURE__ */ E("div", { className: K("flex flex-col bg-background-primary p-2", n), children: t }) });
Ua.displayName = "Menu";
const z2 = ({
  heading: e,
  arrow: t = !1,
  showArrowOnHover: n = !1,
  // Prop to toggle hover-based arrow display
  open: r = !0,
  onClick: i,
  children: o,
  className: a
}) => {
  const [s, l] = Me(r), [c, f] = Me(!1), { size: d } = W2(), p = "text-text-primary bg-transparent cursor-pointer flex justify-between items-center gap-1", m = {
    sm: "text-xs",
    md: "text-sm"
  }[d ?? "md"], y = {
    sm: "size-4",
    md: "size-5"
  }[d ?? "md"], g = () => {
    l(!s), i && i(!s);
  }, v = {
    open: { rotate: 180 },
    closed: { rotate: 0 }
  }, x = {
    open: { height: "auto", opacity: 1 },
    closed: { height: 0, opacity: 0 }
  }, w = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
  }, S = () => n ? s || c ? "visible" : "hidden" : "visible";
  return /* @__PURE__ */ he("div", { children: [
    !!e && /* @__PURE__ */ he(
      "div",
      {
        role: "button",
        tabIndex: 0,
        onClick: g,
        onKeyDown: (A) => {
          (A.key === "Enter" || A.key === " ") && g();
        },
        onMouseEnter: () => n && f(!0),
        onMouseLeave: () => n && f(!1),
        className: K(
          p,
          m,
          e ? "p-1" : "p-0",
          a
        ),
        "aria-expanded": s,
        children: [
          /* @__PURE__ */ E("span", { className: "text-text-tertiary", children: e }),
          t && /* @__PURE__ */ E(
            An.span,
            {
              className: "flex items-center text-border-strong",
              initial: "hidden",
              animate: S(),
              exit: "hidden",
              variants: w,
              transition: { duration: 0.15 },
              children: /* @__PURE__ */ E(
                An.span,
                {
                  className: "inline-flex p-1",
                  variants: v,
                  animate: s ? "open" : "closed",
                  transition: { duration: 0.15 },
                  children: /* @__PURE__ */ E(
                    Xw,
                    {
                      className: K("shrink-0", y)
                    }
                  )
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ E(Ks, { initial: !1, children: s && /* @__PURE__ */ E(
      An.ul,
      {
        role: "menu",
        variants: x,
        initial: "closed",
        animate: "open",
        exit: "closed",
        transition: { duration: 0.3, ease: "easeInOut" },
        className: "overflow flex gap-0.5 flex-col m-0 bg-white rounded p-0",
        children: o
      }
    ) })
  ] });
};
z2.displayName = "Menu.List";
const V2 = ({
  disabled: e = !1,
  active: t,
  onClick: n,
  children: r,
  className: i
}) => {
  const { size: o } = W2(), a = "flex p-1 gap-1 items-center bg-transparent border-none rounded text-text-secondary cursor-pointer m-0", s = {
    sm: "[&>svg]:size-4 [&>svg]:m-1 [&>*:not(svg)]:mx-1 [&>*:not(svg)]:my-0.5 text-sm",
    md: "[&>svg]:size-5 [&>svg]:m-1.5 [&>*:not(svg)]:m-1 text-base"
  }[o ?? "md"];
  return /* @__PURE__ */ E(
    "li",
    {
      role: "menuitem",
      tabIndex: 0,
      onClick: n,
      onKeyDown: (p) => {
        (p.key === "Enter" || p.key === " ") && (n == null || n());
      },
      className: K(
        a,
        s,
        "hover:bg-background-secondary hover:text-text-primary",
        e ? "text-text-disabled hover:text-text-disabled cursor-not-allowed hover:bg-transparent" : "",
        t ? "text-icon-primary [&>svg]:text-icon-interactive bg-background-secondary" : "",
        "transition-colors duration-300 ease-in-out",
        i
      ),
      children: r
    }
  );
};
V2.displayName = "Menu.Item";
const U2 = ({
  variant: e = "solid",
  className: t
}) => {
  const n = {
    solid: "border-solid",
    dashed: "border-dashed",
    dotted: "border-dotted",
    double: "border-double",
    hidden: "border-hidden",
    none: "border-none"
  }[e];
  return /* @__PURE__ */ E("li", { className: "m-0 p-0 list-none", role: "separator", "aria-hidden": "true", children: /* @__PURE__ */ E(
    "hr",
    {
      className: K(
        "w-full border-0 border-t border-border-subtle",
        n,
        t
      )
    }
  ) });
};
U2.displayName = "Menu.Separator";
Ua.List = z2;
Ua.Item = V2;
Ua.Separator = U2;
const H2 = dt({
  isCollapsed: !1,
  setIsCollapsed: () => {
  },
  collapsible: !0
}), K2 = ({
  children: e,
  className: t,
  onCollapseChange: n,
  collapsible: r = !0,
  borderOn: i = !0,
  ...o
}) => {
  const a = ut(null), [s, l] = Me(() => {
    const c = Ru.get("sidebar-collapsed"), f = window.innerWidth < 1280;
    return c || f;
  });
  return Xe(() => {
    n && n(s);
  }, [s, n]), Xe(() => {
    const c = () => {
      const f = window.innerWidth < 1280;
      if (!r)
        l(!1), Ru.remove("sidebar-collapsed");
      else if (f)
        l(!0), Ru.set("sidebar-collapsed", !0);
      else {
        const d = Ru.get("sidebar-collapsed");
        l(d || !1);
      }
    };
    return window.addEventListener("resize", c), c(), () => {
      window.removeEventListener("resize", c);
    };
  }, [r]), /* @__PURE__ */ E(
    H2.Provider,
    {
      value: { isCollapsed: s, setIsCollapsed: l, collapsible: r },
      children: /* @__PURE__ */ E(
        "div",
        {
          ref: a,
          className: K(
            "h-full overflow-auto w-72 px-4 py-4 gap-4 flex flex-col bg-background-primary",
            i && "border-0 border-r border-solid border-border-subtle",
            "transition-all duration-200",
            s && "w-16 px-2",
            t
          ),
          ...o,
          children: e
        }
      )
    }
  );
};
K2.displayName = "Sidebar";
const G2 = ({ children: e }) => /* @__PURE__ */ E("div", { className: "space-y-2", children: e });
G2.displayName = "Sidebar.Header";
const Y2 = ({ children: e }) => /* @__PURE__ */ E("div", { className: K("space-y-4 grow items-start"), children: e });
Y2.displayName = "Sidebar.Body";
const q2 = ({ children: e }) => {
  const { isCollapsed: t, setIsCollapsed: n, collapsible: r } = Ve(H2);
  return /* @__PURE__ */ he("div", { className: "space-y-4", children: [
    e,
    r && /* @__PURE__ */ E(
      "button",
      {
        className: K(
          "bg-transparent w-full border-0 p-0 m-0 flex items-center gap-2 text-base cursor-pointer",
          t && "justify-center"
        ),
        onClick: () => {
          n(!t), Ru.set("sidebar-collapsed", !t);
        },
        "aria-label": t ? "Expand sidebar" : "Collapse sidebar",
        children: t ? /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(f1, { title: "Expand", children: /* @__PURE__ */ E(tK, { className: "size-5" }) }) }) : /* @__PURE__ */ he(Ut, { children: [
          /* @__PURE__ */ E(eK, { className: "size-5" }),
          " Collapse"
        ] })
      }
    )
  ] });
};
q2.displayName = "Sidebar.Footer";
const X2 = ({ children: e, className: t }) => /* @__PURE__ */ E("div", { className: K("w-full", t), children: e });
X2.displayName = "Sidebar.Item";
const nke = Object.assign(K2, {
  Header: G2,
  Body: Y2,
  Footer: q2,
  Item: X2
}), cx = {
  sm: {
    text: "text-sm",
    separator: "text-sm",
    separatorIconSize: 16
  },
  md: {
    text: "text-base",
    separator: "text-base",
    separatorIconSize: 18
  }
}, wd = dt({ sizes: cx.sm }), Ys = ({ children: e, size: t = "sm" }) => {
  const n = cx[t] || cx.sm;
  return /* @__PURE__ */ E(wd.Provider, { value: { sizes: n }, children: /* @__PURE__ */ E("nav", { className: "flex m-0", "aria-label": "Breadcrumb", children: /* @__PURE__ */ E("ul", { className: "m-0 inline-flex items-center space-x-1 md:space-x-1", children: e }) }) });
};
Ys.displayName = "Breadcrumb";
const Z2 = ({ children: e }) => /* @__PURE__ */ E(Ut, { children: e });
Z2.displayName = "Breadcrumb.List";
const J2 = ({ children: e }) => /* @__PURE__ */ E("li", { className: "m-0 inline-flex items-center gap-2", children: e });
J2.displayName = "Breadcrumb.Item";
const Q2 = ({
  href: e,
  children: t,
  className: n,
  as: r = "a",
  ...i
}) => {
  const { sizes: o } = Ve(wd);
  return /* @__PURE__ */ E(
    r,
    {
      href: e,
      className: K(
        o.text,
        "px-1 font-medium no-underline text-text-tertiary hover:text-text-primary hover:underline",
        "focus:outline-none focus:ring-1 focus:ring-border-interactive focus:border-border-interactive focus:rounded-sm",
        "transition-all duration-200",
        n
      ),
      ...i,
      children: t
    }
  );
};
Q2.displayName = "Breadcrumb.Link";
const ej = ({ type: e }) => {
  const { sizes: t } = Ve(wd), n = {
    slash: /* @__PURE__ */ E("span", { className: K("mx-1", t.separator), children: "/" }),
    arrow: /* @__PURE__ */ E(Zw, { size: t.separatorIconSize })
  };
  return /* @__PURE__ */ E(
    "li",
    {
      role: "separator",
      className: "flex items-center text-text-tertiary mx-2 p-0 list-none",
      "aria-hidden": "true",
      children: n[e] || n.arrow
    }
  );
};
ej.displayName = "Breadcrumb.Separator";
const tj = () => {
  const { sizes: e } = Ve(wd);
  return /* @__PURE__ */ E(
    XH,
    {
      className: "mt-[2px] cursor-pointer text-text-tertiary hover:text-text-primary",
      size: e.separatorIconSize + 4
    }
  );
};
tj.displayName = "Breadcrumb.Ellipsis";
const nj = ({ children: e }) => {
  const { sizes: t } = Ve(wd);
  return /* @__PURE__ */ E("span", { className: K(t.text, "font-medium text-text-primary"), children: e });
};
nj.displayName = "Breadcrumb.Page";
Ys.List = Z2;
Ys.Item = J2;
Ys.Link = Q2;
Ys.Separator = ej;
Ys.Ellipsis = tj;
Ys.Page = nj;
const rj = dt({}), Wg = () => Ve(rj), ij = {
  open: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, oj = { duration: 0.2 }, qo = ({
  open: e,
  setOpen: t,
  children: n,
  trigger: r = null,
  className: i,
  exitOnClickOutside: o = !1,
  exitOnEsc: a = !0,
  design: s = "simple",
  scrollLock: l = !0
}) => {
  const c = e !== void 0 && t !== void 0, [f, d] = Me(!1), p = ut(null), m = ut(null), y = Fe(
    () => c ? e : f,
    [e, f]
  ), g = Fe(
    () => c ? t : d,
    [d, d]
  ), v = () => {
    y || g(!0);
  }, x = () => {
    y && g(!1);
  }, w = qe(() => {
    var _;
    return rt(r) ? ht(r, {
      onClick: lf(v, (_ = r == null ? void 0 : r.props) == null ? void 0 : _.onClick)
    }) : typeof r == "function" ? r({ onClick: v }) : null;
  }, [r, v, x]), S = (_) => {
    switch (_.key) {
      case "Escape":
        a && x();
        break;
    }
  }, A = (_) => {
    o && p.current && !p.current.contains(_.target) && x();
  };
  return Xe(() => (window.addEventListener("keydown", S), document.addEventListener("mousedown", A), () => {
    window.removeEventListener("keydown", S), document.removeEventListener("mousedown", A);
  }), [y]), Xe(() => {
    if (!l)
      return;
    const _ = document.querySelector("html");
    return y && _ && (_.style.overflow = "hidden"), () => {
      _ && (_.style.overflow = "");
    };
  }, [y]), /* @__PURE__ */ he(Ut, { children: [
    w(),
    /* @__PURE__ */ E(
      rj.Provider,
      {
        value: {
          open: y,
          setOpen: g,
          handleClose: x,
          design: s,
          dialogContainerRef: m,
          dialogRef: p
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            ref: m,
            className: K(
              "fixed z-999999 w-0 h-0 overflow-visible",
              i
            ),
            children: n
          }
        )
      }
    )
  ] });
};
qo.displayName = "Dialog";
const aj = ({
  children: e,
  className: t
}) => {
  const { open: n, handleClose: r, dialogRef: i } = Wg();
  return /* @__PURE__ */ E(Ks, { children: n && /* @__PURE__ */ E(
    An.div,
    {
      className: "fixed inset-0 overflow-y-auto",
      initial: "exit",
      animate: "open",
      exit: "exit",
      variants: ij,
      role: "dialog",
      transition: oj,
      children: /* @__PURE__ */ E("div", { className: "flex items-center justify-center min-h-full", children: /* @__PURE__ */ E(
        "div",
        {
          ref: i,
          className: K(
            "flex flex-col gap-5 w-120 h-fit bg-background-primary border border-solid border-border-subtle rounded-xl shadow-soft-shadow-2xl my-5 overflow-hidden",
            t
          ),
          children: typeof e == "function" ? e({ close: r }) : e
        }
      ) })
    }
  ) });
};
aj.displayName = "Dialog.Panel";
const sj = ({
  className: e,
  ...t
}) => {
  const { open: n, dialogContainerRef: r } = Wg();
  return r != null && r.current ? /* @__PURE__ */ E(Ut, { children: Yw(
    /* @__PURE__ */ E(Ks, { children: n && /* @__PURE__ */ E(
      An.div,
      {
        className: K(
          "fixed inset-0 -z-10 bg-background-inverse/90",
          e
        ),
        ...t,
        initial: "exit",
        animate: "open",
        exit: "exit",
        variants: ij,
        transition: oj
      }
    ) }),
    r.current
  ) }) : null;
};
sj.displayName = "Dialog.Backdrop";
const lj = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E("div", { className: K("space-y-2 px-5 pt-5 pb-1", t), ...n, children: e });
lj.displayName = "Dialog.Header";
const cj = ({
  children: e,
  as: t = "h3",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: K(
      "text-base font-semibold text-text-primary m-0 p-0",
      n
    ),
    ...r,
    children: e
  }
);
cj.displayName = "Dialog.Title";
const uj = ({
  children: e,
  as: t = "p",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: K(
      "text-sm font-normal text-text-secondary my-0 ml-0 mr-1 p-0",
      n
    ),
    ...r,
    children: e
  }
);
uj.displayName = "Dialog.Description";
const XQ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ E(
  "button",
  {
    className: K(
      "bg-transparent inline-flex justify-center items-center border-0 p-1 m-0 cursor-pointer focus:outline-none outline-none shadow-none",
      e
    ),
    "aria-label": "Close dialog",
    ...t,
    children: /* @__PURE__ */ E(Na, { className: "size-4 text-text-primary shrink-0" })
  }
), fj = ({
  children: e,
  as: t = Ur,
  ...n
}) => {
  const { handleClose: r } = Wg();
  return e ? t === Ur ? typeof e == "function" ? e({
    close: r
  }) : ht(e, {
    onClick: r
  }) : /* @__PURE__ */ E(t, { ...n, onClick: r, children: e }) : /* @__PURE__ */ E(XQ, { onClick: r, ...n });
};
fj.displayName = "Dialog.CloseButton";
const dj = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E("div", { className: K("px-5", t), ...n, children: e });
dj.displayName = "Dialog.Body";
const hj = ({
  children: e,
  className: t
}) => {
  const { design: n, handleClose: r } = Wg(), i = () => e ? typeof e == "function" ? e({ close: r }) : e : null;
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "p-4 flex justify-end gap-3",
        {
          "bg-background-secondary": n === "footer-divided"
        },
        t
      ),
      children: i()
    }
  );
};
hj.displayName = "Dialog.Footer";
qo.Panel = aj;
qo.Title = cj;
qo.Description = uj;
qo.CloseButton = fj;
qo.Header = lj;
qo.Body = dj;
qo.Footer = hj;
qo.Backdrop = sj;
const _d = ({
  children: e,
  gap: t = "lg",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  "div",
  {
    className: K(
      "w-full box-border flex items-center justify-between bg-background-primary p-5 min-h-16",
      Jm(t),
      n
    ),
    ...r,
    children: e
  }
);
_d.displayName = "Topbar";
const pj = ({ gap: e = "sm", children: t, className: n }) => /* @__PURE__ */ E("div", { className: K("flex items-center", Jm(e), n), children: t });
pj.displayName = "Topbar.Left";
const mj = ({
  gap: e = "md",
  children: t,
  align: n = "center",
  className: r
}) => {
  const i = {
    left: "justify-start",
    center: "justify-center",
    right: "justify-end"
  }[n];
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex items-center grow",
        Jm(e),
        i,
        r
      ),
      children: t
    }
  );
};
mj.displayName = "Topbar.Middle";
const gj = ({ gap: e = "sm", children: t, className: n }) => /* @__PURE__ */ E("div", { className: K("flex items-center", Jm(e), n), children: t });
gj.displayName = "Topbar.Right";
const yj = ({ children: e, className: t }) => /* @__PURE__ */ E(
  "div",
  {
    className: K("flex items-center [&>svg]:block h-full", t),
    children: e
  }
);
yj.displayName = "Topbar.Item";
_d.Left = pj;
_d.Middle = mj;
_d.Right = gj;
_d.Item = yj;
const ZQ = (e) => {
  if (!e)
    return { error: "Element not found." };
  const t = e.getBoundingClientRect(), n = window.innerWidth, r = n / 2, i = t.right < r, o = t.left > r;
  return {
    isLeft: i,
    isRight: o,
    isCenter: !i && !o,
    elementRect: {
      left: t.left,
      right: t.right,
      width: t.width
    },
    viewport: {
      width: n,
      center: r
    }
  };
}, vj = dt({}), JQ = vj.Provider, bj = () => Ve(vj), QQ = (e) => {
  const t = ut({ width: 0, height: 0 });
  return Xe(() => {
    e.current && (t.current.width = e.current.offsetWidth, t.current.height = e.current.offsetHeight);
  }, []), t.current;
}, eee = (e, t, n) => {
  if (!e || !t)
    return {
      open: () => ({}),
      closed: () => ({})
    };
  const r = e == null ? void 0 : e.getBoundingClientRect(), i = t == null ? void 0 : t.getBoundingClientRect(), o = n ? (r == null ? void 0 : r.x) - (i == null ? void 0 : i.x) + (r == null ? void 0 : r.width) / 2 : (i == null ? void 0 : i.width) - ((i == null ? void 0 : i.right) - (r == null ? void 0 : r.x)) + (r == null ? void 0 : r.width) / 2, a = (r == null ? void 0 : r.y) - (i == null ? void 0 : i.y) + (r == null ? void 0 : r.height) / 2, s = (r == null ? void 0 : r.width) / 2;
  return {
    open: (l = 1e3) => ({
      clipPath: `circle(${l * 2 + 200}px at ${o}px ${a}px)`,
      background: "rgb(255, 255, 255, 1)",
      transition: {
        type: "spring",
        stiffness: 20,
        restDelta: 2,
        background: {
          duration: 0
        }
      }
    }),
    closed: {
      clipPath: `circle(${s}px at ${o}px ${a}px)`,
      background: "rgb(255, 255, 255, 0)",
      transition: {
        delay: 0.5,
        type: "spring",
        stiffness: 400,
        damping: 40,
        background: {
          duration: 0,
          delay: 1e3
        }
      }
    }
  };
}, Ab = (e) => (
  // @ts-expect-error Framer Motion types are not compatible with SVGPathElement
  /* @__PURE__ */ E(
    An.path,
    {
      className: "stroke-icon-primary",
      fill: "transparent",
      strokeWidth: "3",
      strokeLinecap: "round",
      ...e
    }
  )
), xj = ({ className: e }) => {
  const { toggleOpen: t, setTriggerRef: n } = bj();
  return /* @__PURE__ */ E(
    Hn,
    {
      ref: n,
      className: K(
        "relative z-[1] rounded-full hover:shadow-sm focus:[box-shadow:none] pointer-events-auto bg-background-primary",
        e
      ),
      variant: "ghost",
      size: "xs",
      onClick: t,
      "aria-label": "Toggle menu",
      icon: /* @__PURE__ */ he(
        An.svg,
        {
          className: "shrink-0 stroke-icon-primary",
          width: "23",
          height: "23",
          variants: {
            open: {
              viewBox: "0 0 20 20"
            },
            closed: {
              viewBox: "0 0 23 18"
            }
          },
          children: [
            /* @__PURE__ */ E(
              Ab,
              {
                variants: {
                  closed: { d: "M 2 2.5 L 20 2.5" },
                  open: { d: "M 3 16.5 L 17 2.5" }
                }
              }
            ),
            /* @__PURE__ */ E(
              Ab,
              {
                d: "M 2 9.423 L 20 9.423",
                variants: {
                  closed: { opacity: 1 },
                  open: { opacity: 0 }
                },
                transition: { duration: 0.1 }
              }
            ),
            /* @__PURE__ */ E(
              Ab,
              {
                variants: {
                  closed: { d: "M 2 16.346 L 20 16.346" },
                  open: { d: "M 3 2.5 L 17 16.346" }
                }
              }
            )
          ]
        }
      )
    }
  );
}, tee = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
}, wj = ({
  tag: e = "a",
  active: t,
  icon: n,
  iconPosition: r = "left",
  className: i,
  children: o,
  ...a
}) => {
  var f;
  let s = null, l = null;
  const c = n && rt(n) ? ht(n, {
    key: "left-icon",
    className: K(
      "size-5",
      t ? "text-brand-800" : "text-icon-secondary",
      ((f = n.props) == null ? void 0 : f.className) ?? ""
    )
  }) : null;
  switch (r) {
    case "left":
      s = c;
      break;
    case "right":
      l = c;
      break;
    default:
      s = null, l = null;
      break;
  }
  return /* @__PURE__ */ E(ree, { children: /* @__PURE__ */ he(
    e,
    {
      className: K(
        "w-full no-underline hover:no-underline text-text-primary text-lg font-medium flex items-center gap-2 px-2.5 py-1.5 rounded-md hover:bg-background-secondary hover:text-text-primary focus:outline-none focus:shadow-none transition ease-in-out duration-150",
        t ? "text-text-primary bg-background-secondary" : "text-text-secondary",
        i
      ),
      ...a,
      children: [
        !!s && s,
        /* @__PURE__ */ E("span", { className: "contents", children: o }),
        !!l && l
      ]
    }
  ) });
}, nee = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1e3, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1e3 }
    }
  }
}, ree = ({ children: e }) => /* @__PURE__ */ E(
  An.li,
  {
    className: "m-0 p-0 flex items-center justify-start w-full",
    variants: nee,
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 },
    children: e
  }
), _j = ({ children: e, className: t }) => {
  const { triggerRef: n, triggerOnRight: r, triggerOnLeft: i } = bj(), [o, a] = Me(null);
  return n ? /* @__PURE__ */ he(
    An.div,
    {
      ref: a,
      className: K(
        "absolute top-0 bottom-0 w-80 h-screen",
        r ? "right-0" : "left-0",
        t
      ),
      children: [
        o && /* @__PURE__ */ E(
          An.div,
          {
            className: K(
              "bg-background-primary shadow-lg absolute top-0 bottom-0 w-80 border-y-0 border-l-0 border-r border-solid border-border-subtle",
              r ? "right-0" : "left-0"
            ),
            variants: eee(
              n,
              o,
              i ?? !1
            )
          }
        ),
        /* @__PURE__ */ E(
          An.ul,
          {
            variants: tee,
            className: K(
              "relative mt-14 mb-0 w-full px-5 pb-5 pt-2 flex flex-col items-start justify-start gap-0.5",
              t
            ),
            children: e
          }
        )
      ]
    }
  ) : null;
}, zg = ({ className: e, children: t }) => {
  const [n, r] = KX(!1, !0), [i, o] = Me(null), a = ut(null), { height: s } = QQ(a), { isRight: l = !1, isLeft: c = !0 } = ZQ(i);
  return /* @__PURE__ */ E(JQ, { value: {
    isOpen: n,
    toggleOpen: r,
    setTriggerRef: (p) => {
      oH(() => {
        o(p);
      });
    },
    triggerRef: i,
    triggerOnRight: l,
    triggerOnLeft: c
  }, children: /* @__PURE__ */ E("div", { className: K("size-6 z-[1]", e), children: /* @__PURE__ */ E(
    An.nav,
    {
      className: "h-full",
      initial: !1,
      animate: n ? "open" : "closed",
      custom: s,
      variants: {
        open: {
          pointerEvents: "auto"
        },
        closed: {
          pointerEvents: "none"
        }
      },
      ref: a,
      children: t
    }
  ) }) });
};
zg.displayName = "HamburgerMenu";
xj.displayName = "HamburgerMenu.Toggle";
_j.displayName = "HamburgerMenu.Options";
wj.displayName = "HamburgerMenu.Option";
zg.Options = _j;
zg.Option = wj;
zg.Toggle = xj;
var Kp = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Kp.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, f = "__lodash_placeholder__", d = 1, p = 2, m = 4, y = 1, g = 2, v = 1, x = 2, w = 4, S = 8, A = 16, _ = 32, O = 64, P = 128, C = 256, k = 512, D = 30, $ = "...", N = 800, R = 16, L = 1, F = 2, W = 3, z = 1 / 0, G = 9007199254740991, U = 17976931348623157e292, V = NaN, Y = 4294967295, ee = Y - 1, ie = Y >>> 1, re = [
      ["ary", P],
      ["bind", v],
      ["bindKey", x],
      ["curry", S],
      ["curryRight", A],
      ["flip", k],
      ["partial", _],
      ["partialRight", O],
      ["rearg", C]
    ], le = "[object Arguments]", ae = "[object Array]", ue = "[object AsyncFunction]", ne = "[object Boolean]", J = "[object Date]", fe = "[object DOMException]", be = "[object Error]", X = "[object Function]", De = "[object GeneratorFunction]", pe = "[object Map]", ke = "[object Number]", it = "[object Null]", st = "[object Object]", Xn = "[object Promise]", Ie = "[object Proxy]", lt = "[object RegExp]", Oe = "[object Set]", Ke = "[object String]", Zt = "[object Symbol]", mt = "[object Undefined]", en = "[object WeakMap]", Yr = "[object WeakSet]", Cn = "[object ArrayBuffer]", yn = "[object DataView]", mr = "[object Float32Array]", tt = "[object Float64Array]", Kt = "[object Int8Array]", St = "[object Int16Array]", jn = "[object Int32Array]", qr = "[object Uint8Array]", so = "[object Uint8ClampedArray]", un = "[object Uint16Array]", Pr = "[object Uint32Array]", fn = /\b__p \+= '';/g, Xr = /\b(__p \+=) '' \+/g, yt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Rd = /&(?:amp|lt|gt|quot|#39);/g, jd = /[&<>"']/g, Ey = RegExp(Rd.source), tu = RegExp(jd.source), nu = /<%-([\s\S]+?)%>/g, Cz = /<%([\s\S]+?)%>/g, FS = /<%=([\s\S]+?)%>/g, Ez = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, kz = /^\w*$/, Mz = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ky = /[\\^$.*+?()[\]{}|]/g, Nz = RegExp(ky.source), My = /^\s+/, $z = /\s/, Dz = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Iz = /\{\n\/\* \[wrapped with (.+)\] \*/, Rz = /,? & /, jz = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Lz = /[()=,{}\[\]\/\s]/, Bz = /\\(\\)?/g, Fz = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, WS = /\w*$/, Wz = /^[-+]0x[0-9a-f]+$/i, zz = /^0b[01]+$/i, Vz = /^\[object .+?Constructor\]$/, Uz = /^0o[0-7]+$/i, Hz = /^(?:0|[1-9]\d*)$/, Kz = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ld = /($^)/, Gz = /['\n\r\u2028\u2029\\]/g, Bd = "\\ud800-\\udfff", Yz = "\\u0300-\\u036f", qz = "\\ufe20-\\ufe2f", Xz = "\\u20d0-\\u20ff", zS = Yz + qz + Xz, VS = "\\u2700-\\u27bf", US = "a-z\\xdf-\\xf6\\xf8-\\xff", Zz = "\\xac\\xb1\\xd7\\xf7", Jz = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Qz = "\\u2000-\\u206f", e5 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", HS = "A-Z\\xc0-\\xd6\\xd8-\\xde", KS = "\\ufe0e\\ufe0f", GS = Zz + Jz + Qz + e5, Ny = "['’]", t5 = "[" + Bd + "]", YS = "[" + GS + "]", Fd = "[" + zS + "]", qS = "\\d+", n5 = "[" + VS + "]", XS = "[" + US + "]", ZS = "[^" + Bd + GS + qS + VS + US + HS + "]", $y = "\\ud83c[\\udffb-\\udfff]", r5 = "(?:" + Fd + "|" + $y + ")", JS = "[^" + Bd + "]", Dy = "(?:\\ud83c[\\udde6-\\uddff]){2}", Iy = "[\\ud800-\\udbff][\\udc00-\\udfff]", il = "[" + HS + "]", QS = "\\u200d", eO = "(?:" + XS + "|" + ZS + ")", i5 = "(?:" + il + "|" + ZS + ")", tO = "(?:" + Ny + "(?:d|ll|m|re|s|t|ve))?", nO = "(?:" + Ny + "(?:D|LL|M|RE|S|T|VE))?", rO = r5 + "?", iO = "[" + KS + "]?", o5 = "(?:" + QS + "(?:" + [JS, Dy, Iy].join("|") + ")" + iO + rO + ")*", a5 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", s5 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", oO = iO + rO + o5, l5 = "(?:" + [n5, Dy, Iy].join("|") + ")" + oO, c5 = "(?:" + [JS + Fd + "?", Fd, Dy, Iy, t5].join("|") + ")", u5 = RegExp(Ny, "g"), f5 = RegExp(Fd, "g"), Ry = RegExp($y + "(?=" + $y + ")|" + c5 + oO, "g"), d5 = RegExp([
      il + "?" + XS + "+" + tO + "(?=" + [YS, il, "$"].join("|") + ")",
      i5 + "+" + nO + "(?=" + [YS, il + eO, "$"].join("|") + ")",
      il + "?" + eO + "+" + tO,
      il + "+" + nO,
      s5,
      a5,
      qS,
      l5
    ].join("|"), "g"), h5 = RegExp("[" + QS + Bd + zS + KS + "]"), p5 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, m5 = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], g5 = -1, Ft = {};
    Ft[mr] = Ft[tt] = Ft[Kt] = Ft[St] = Ft[jn] = Ft[qr] = Ft[so] = Ft[un] = Ft[Pr] = !0, Ft[le] = Ft[ae] = Ft[Cn] = Ft[ne] = Ft[yn] = Ft[J] = Ft[be] = Ft[X] = Ft[pe] = Ft[ke] = Ft[st] = Ft[lt] = Ft[Oe] = Ft[Ke] = Ft[en] = !1;
    var It = {};
    It[le] = It[ae] = It[Cn] = It[yn] = It[ne] = It[J] = It[mr] = It[tt] = It[Kt] = It[St] = It[jn] = It[pe] = It[ke] = It[st] = It[lt] = It[Oe] = It[Ke] = It[Zt] = It[qr] = It[so] = It[un] = It[Pr] = !0, It[be] = It[X] = It[en] = !1;
    var y5 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, v5 = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, b5 = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, x5 = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, w5 = parseFloat, _5 = parseInt, aO = typeof So == "object" && So && So.Object === Object && So, S5 = typeof self == "object" && self && self.Object === Object && self, Ln = aO || S5 || Function("return this")(), jy = t && !t.nodeType && t, Xa = jy && !0 && e && !e.nodeType && e, sO = Xa && Xa.exports === jy, Ly = sO && aO.process, Zr = function() {
      try {
        var Z = Xa && Xa.require && Xa.require("util").types;
        return Z || Ly && Ly.binding && Ly.binding("util");
      } catch {
      }
    }(), lO = Zr && Zr.isArrayBuffer, cO = Zr && Zr.isDate, uO = Zr && Zr.isMap, fO = Zr && Zr.isRegExp, dO = Zr && Zr.isSet, hO = Zr && Zr.isTypedArray;
    function Cr(Z, ce, oe) {
      switch (oe.length) {
        case 0:
          return Z.call(ce);
        case 1:
          return Z.call(ce, oe[0]);
        case 2:
          return Z.call(ce, oe[0], oe[1]);
        case 3:
          return Z.call(ce, oe[0], oe[1], oe[2]);
      }
      return Z.apply(ce, oe);
    }
    function O5(Z, ce, oe, Te) {
      for (var He = -1, gt = Z == null ? 0 : Z.length; ++He < gt; ) {
        var vn = Z[He];
        ce(Te, vn, oe(vn), Z);
      }
      return Te;
    }
    function Jr(Z, ce) {
      for (var oe = -1, Te = Z == null ? 0 : Z.length; ++oe < Te && ce(Z[oe], oe, Z) !== !1; )
        ;
      return Z;
    }
    function A5(Z, ce) {
      for (var oe = Z == null ? 0 : Z.length; oe-- && ce(Z[oe], oe, Z) !== !1; )
        ;
      return Z;
    }
    function pO(Z, ce) {
      for (var oe = -1, Te = Z == null ? 0 : Z.length; ++oe < Te; )
        if (!ce(Z[oe], oe, Z))
          return !1;
      return !0;
    }
    function ra(Z, ce) {
      for (var oe = -1, Te = Z == null ? 0 : Z.length, He = 0, gt = []; ++oe < Te; ) {
        var vn = Z[oe];
        ce(vn, oe, Z) && (gt[He++] = vn);
      }
      return gt;
    }
    function Wd(Z, ce) {
      var oe = Z == null ? 0 : Z.length;
      return !!oe && ol(Z, ce, 0) > -1;
    }
    function By(Z, ce, oe) {
      for (var Te = -1, He = Z == null ? 0 : Z.length; ++Te < He; )
        if (oe(ce, Z[Te]))
          return !0;
      return !1;
    }
    function Gt(Z, ce) {
      for (var oe = -1, Te = Z == null ? 0 : Z.length, He = Array(Te); ++oe < Te; )
        He[oe] = ce(Z[oe], oe, Z);
      return He;
    }
    function ia(Z, ce) {
      for (var oe = -1, Te = ce.length, He = Z.length; ++oe < Te; )
        Z[He + oe] = ce[oe];
      return Z;
    }
    function Fy(Z, ce, oe, Te) {
      var He = -1, gt = Z == null ? 0 : Z.length;
      for (Te && gt && (oe = Z[++He]); ++He < gt; )
        oe = ce(oe, Z[He], He, Z);
      return oe;
    }
    function T5(Z, ce, oe, Te) {
      var He = Z == null ? 0 : Z.length;
      for (Te && He && (oe = Z[--He]); He--; )
        oe = ce(oe, Z[He], He, Z);
      return oe;
    }
    function Wy(Z, ce) {
      for (var oe = -1, Te = Z == null ? 0 : Z.length; ++oe < Te; )
        if (ce(Z[oe], oe, Z))
          return !0;
      return !1;
    }
    var P5 = zy("length");
    function C5(Z) {
      return Z.split("");
    }
    function E5(Z) {
      return Z.match(jz) || [];
    }
    function mO(Z, ce, oe) {
      var Te;
      return oe(Z, function(He, gt, vn) {
        if (ce(He, gt, vn))
          return Te = gt, !1;
      }), Te;
    }
    function zd(Z, ce, oe, Te) {
      for (var He = Z.length, gt = oe + (Te ? 1 : -1); Te ? gt-- : ++gt < He; )
        if (ce(Z[gt], gt, Z))
          return gt;
      return -1;
    }
    function ol(Z, ce, oe) {
      return ce === ce ? W5(Z, ce, oe) : zd(Z, gO, oe);
    }
    function k5(Z, ce, oe, Te) {
      for (var He = oe - 1, gt = Z.length; ++He < gt; )
        if (Te(Z[He], ce))
          return He;
      return -1;
    }
    function gO(Z) {
      return Z !== Z;
    }
    function yO(Z, ce) {
      var oe = Z == null ? 0 : Z.length;
      return oe ? Uy(Z, ce) / oe : V;
    }
    function zy(Z) {
      return function(ce) {
        return ce == null ? n : ce[Z];
      };
    }
    function Vy(Z) {
      return function(ce) {
        return Z == null ? n : Z[ce];
      };
    }
    function vO(Z, ce, oe, Te, He) {
      return He(Z, function(gt, vn, Mt) {
        oe = Te ? (Te = !1, gt) : ce(oe, gt, vn, Mt);
      }), oe;
    }
    function M5(Z, ce) {
      var oe = Z.length;
      for (Z.sort(ce); oe--; )
        Z[oe] = Z[oe].value;
      return Z;
    }
    function Uy(Z, ce) {
      for (var oe, Te = -1, He = Z.length; ++Te < He; ) {
        var gt = ce(Z[Te]);
        gt !== n && (oe = oe === n ? gt : oe + gt);
      }
      return oe;
    }
    function Hy(Z, ce) {
      for (var oe = -1, Te = Array(Z); ++oe < Z; )
        Te[oe] = ce(oe);
      return Te;
    }
    function N5(Z, ce) {
      return Gt(ce, function(oe) {
        return [oe, Z[oe]];
      });
    }
    function bO(Z) {
      return Z && Z.slice(0, SO(Z) + 1).replace(My, "");
    }
    function Er(Z) {
      return function(ce) {
        return Z(ce);
      };
    }
    function Ky(Z, ce) {
      return Gt(ce, function(oe) {
        return Z[oe];
      });
    }
    function ru(Z, ce) {
      return Z.has(ce);
    }
    function xO(Z, ce) {
      for (var oe = -1, Te = Z.length; ++oe < Te && ol(ce, Z[oe], 0) > -1; )
        ;
      return oe;
    }
    function wO(Z, ce) {
      for (var oe = Z.length; oe-- && ol(ce, Z[oe], 0) > -1; )
        ;
      return oe;
    }
    function $5(Z, ce) {
      for (var oe = Z.length, Te = 0; oe--; )
        Z[oe] === ce && ++Te;
      return Te;
    }
    var D5 = Vy(y5), I5 = Vy(v5);
    function R5(Z) {
      return "\\" + x5[Z];
    }
    function j5(Z, ce) {
      return Z == null ? n : Z[ce];
    }
    function al(Z) {
      return h5.test(Z);
    }
    function L5(Z) {
      return p5.test(Z);
    }
    function B5(Z) {
      for (var ce, oe = []; !(ce = Z.next()).done; )
        oe.push(ce.value);
      return oe;
    }
    function Gy(Z) {
      var ce = -1, oe = Array(Z.size);
      return Z.forEach(function(Te, He) {
        oe[++ce] = [He, Te];
      }), oe;
    }
    function _O(Z, ce) {
      return function(oe) {
        return Z(ce(oe));
      };
    }
    function oa(Z, ce) {
      for (var oe = -1, Te = Z.length, He = 0, gt = []; ++oe < Te; ) {
        var vn = Z[oe];
        (vn === ce || vn === f) && (Z[oe] = f, gt[He++] = oe);
      }
      return gt;
    }
    function Vd(Z) {
      var ce = -1, oe = Array(Z.size);
      return Z.forEach(function(Te) {
        oe[++ce] = Te;
      }), oe;
    }
    function F5(Z) {
      var ce = -1, oe = Array(Z.size);
      return Z.forEach(function(Te) {
        oe[++ce] = [Te, Te];
      }), oe;
    }
    function W5(Z, ce, oe) {
      for (var Te = oe - 1, He = Z.length; ++Te < He; )
        if (Z[Te] === ce)
          return Te;
      return -1;
    }
    function z5(Z, ce, oe) {
      for (var Te = oe + 1; Te--; )
        if (Z[Te] === ce)
          return Te;
      return Te;
    }
    function sl(Z) {
      return al(Z) ? U5(Z) : P5(Z);
    }
    function gi(Z) {
      return al(Z) ? H5(Z) : C5(Z);
    }
    function SO(Z) {
      for (var ce = Z.length; ce-- && $z.test(Z.charAt(ce)); )
        ;
      return ce;
    }
    var V5 = Vy(b5);
    function U5(Z) {
      for (var ce = Ry.lastIndex = 0; Ry.test(Z); )
        ++ce;
      return ce;
    }
    function H5(Z) {
      return Z.match(Ry) || [];
    }
    function K5(Z) {
      return Z.match(d5) || [];
    }
    var G5 = function Z(ce) {
      ce = ce == null ? Ln : ll.defaults(Ln.Object(), ce, ll.pick(Ln, m5));
      var oe = ce.Array, Te = ce.Date, He = ce.Error, gt = ce.Function, vn = ce.Math, Mt = ce.Object, Yy = ce.RegExp, Y5 = ce.String, Qr = ce.TypeError, Ud = oe.prototype, q5 = gt.prototype, cl = Mt.prototype, Hd = ce["__core-js_shared__"], Kd = q5.toString, Ot = cl.hasOwnProperty, X5 = 0, OO = function() {
        var u = /[^.]+$/.exec(Hd && Hd.keys && Hd.keys.IE_PROTO || "");
        return u ? "Symbol(src)_1." + u : "";
      }(), Gd = cl.toString, Z5 = Kd.call(Mt), J5 = Ln._, Q5 = Yy(
        "^" + Kd.call(Ot).replace(ky, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Yd = sO ? ce.Buffer : n, aa = ce.Symbol, qd = ce.Uint8Array, AO = Yd ? Yd.allocUnsafe : n, Xd = _O(Mt.getPrototypeOf, Mt), TO = Mt.create, PO = cl.propertyIsEnumerable, Zd = Ud.splice, CO = aa ? aa.isConcatSpreadable : n, iu = aa ? aa.iterator : n, Za = aa ? aa.toStringTag : n, Jd = function() {
        try {
          var u = ns(Mt, "defineProperty");
          return u({}, "", {}), u;
        } catch {
        }
      }(), e3 = ce.clearTimeout !== Ln.clearTimeout && ce.clearTimeout, t3 = Te && Te.now !== Ln.Date.now && Te.now, n3 = ce.setTimeout !== Ln.setTimeout && ce.setTimeout, Qd = vn.ceil, eh = vn.floor, qy = Mt.getOwnPropertySymbols, r3 = Yd ? Yd.isBuffer : n, EO = ce.isFinite, i3 = Ud.join, o3 = _O(Mt.keys, Mt), bn = vn.max, Zn = vn.min, a3 = Te.now, s3 = ce.parseInt, kO = vn.random, l3 = Ud.reverse, Xy = ns(ce, "DataView"), ou = ns(ce, "Map"), Zy = ns(ce, "Promise"), ul = ns(ce, "Set"), au = ns(ce, "WeakMap"), su = ns(Mt, "create"), th = au && new au(), fl = {}, c3 = rs(Xy), u3 = rs(ou), f3 = rs(Zy), d3 = rs(ul), h3 = rs(au), nh = aa ? aa.prototype : n, lu = nh ? nh.valueOf : n, MO = nh ? nh.toString : n;
      function j(u) {
        if (tn(u) && !Ge(u) && !(u instanceof ct)) {
          if (u instanceof ei)
            return u;
          if (Ot.call(u, "__wrapped__"))
            return NA(u);
        }
        return new ei(u);
      }
      var dl = /* @__PURE__ */ function() {
        function u() {
        }
        return function(h) {
          if (!Jt(h))
            return {};
          if (TO)
            return TO(h);
          u.prototype = h;
          var b = new u();
          return u.prototype = n, b;
        };
      }();
      function rh() {
      }
      function ei(u, h) {
        this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!h, this.__index__ = 0, this.__values__ = n;
      }
      j.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: nu,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Cz,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: FS,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: j
        }
      }, j.prototype = rh.prototype, j.prototype.constructor = j, ei.prototype = dl(rh.prototype), ei.prototype.constructor = ei;
      function ct(u) {
        this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Y, this.__views__ = [];
      }
      function p3() {
        var u = new ct(this.__wrapped__);
        return u.__actions__ = gr(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = gr(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = gr(this.__views__), u;
      }
      function m3() {
        if (this.__filtered__) {
          var u = new ct(this);
          u.__dir__ = -1, u.__filtered__ = !0;
        } else
          u = this.clone(), u.__dir__ *= -1;
        return u;
      }
      function g3() {
        var u = this.__wrapped__.value(), h = this.__dir__, b = Ge(u), T = h < 0, M = b ? u.length : 0, B = CV(0, M, this.__views__), H = B.start, q = B.end, Q = q - H, de = T ? q : H - 1, me = this.__iteratees__, ge = me.length, xe = 0, Ce = Zn(Q, this.__takeCount__);
        if (!b || !T && M == Q && Ce == Q)
          return tA(u, this.__actions__);
        var Re = [];
        e:
          for (; Q-- && xe < Ce; ) {
            de += h;
            for (var et = -1, je = u[de]; ++et < ge; ) {
              var ot = me[et], ft = ot.iteratee, Nr = ot.type, sr = ft(je);
              if (Nr == F)
                je = sr;
              else if (!sr) {
                if (Nr == L)
                  continue e;
                break e;
              }
            }
            Re[xe++] = je;
          }
        return Re;
      }
      ct.prototype = dl(rh.prototype), ct.prototype.constructor = ct;
      function Ja(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.clear(); ++h < b; ) {
          var T = u[h];
          this.set(T[0], T[1]);
        }
      }
      function y3() {
        this.__data__ = su ? su(null) : {}, this.size = 0;
      }
      function v3(u) {
        var h = this.has(u) && delete this.__data__[u];
        return this.size -= h ? 1 : 0, h;
      }
      function b3(u) {
        var h = this.__data__;
        if (su) {
          var b = h[u];
          return b === l ? n : b;
        }
        return Ot.call(h, u) ? h[u] : n;
      }
      function x3(u) {
        var h = this.__data__;
        return su ? h[u] !== n : Ot.call(h, u);
      }
      function w3(u, h) {
        var b = this.__data__;
        return this.size += this.has(u) ? 0 : 1, b[u] = su && h === n ? l : h, this;
      }
      Ja.prototype.clear = y3, Ja.prototype.delete = v3, Ja.prototype.get = b3, Ja.prototype.has = x3, Ja.prototype.set = w3;
      function lo(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.clear(); ++h < b; ) {
          var T = u[h];
          this.set(T[0], T[1]);
        }
      }
      function _3() {
        this.__data__ = [], this.size = 0;
      }
      function S3(u) {
        var h = this.__data__, b = ih(h, u);
        if (b < 0)
          return !1;
        var T = h.length - 1;
        return b == T ? h.pop() : Zd.call(h, b, 1), --this.size, !0;
      }
      function O3(u) {
        var h = this.__data__, b = ih(h, u);
        return b < 0 ? n : h[b][1];
      }
      function A3(u) {
        return ih(this.__data__, u) > -1;
      }
      function T3(u, h) {
        var b = this.__data__, T = ih(b, u);
        return T < 0 ? (++this.size, b.push([u, h])) : b[T][1] = h, this;
      }
      lo.prototype.clear = _3, lo.prototype.delete = S3, lo.prototype.get = O3, lo.prototype.has = A3, lo.prototype.set = T3;
      function co(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.clear(); ++h < b; ) {
          var T = u[h];
          this.set(T[0], T[1]);
        }
      }
      function P3() {
        this.size = 0, this.__data__ = {
          hash: new Ja(),
          map: new (ou || lo)(),
          string: new Ja()
        };
      }
      function C3(u) {
        var h = gh(this, u).delete(u);
        return this.size -= h ? 1 : 0, h;
      }
      function E3(u) {
        return gh(this, u).get(u);
      }
      function k3(u) {
        return gh(this, u).has(u);
      }
      function M3(u, h) {
        var b = gh(this, u), T = b.size;
        return b.set(u, h), this.size += b.size == T ? 0 : 1, this;
      }
      co.prototype.clear = P3, co.prototype.delete = C3, co.prototype.get = E3, co.prototype.has = k3, co.prototype.set = M3;
      function Qa(u) {
        var h = -1, b = u == null ? 0 : u.length;
        for (this.__data__ = new co(); ++h < b; )
          this.add(u[h]);
      }
      function N3(u) {
        return this.__data__.set(u, l), this;
      }
      function $3(u) {
        return this.__data__.has(u);
      }
      Qa.prototype.add = Qa.prototype.push = N3, Qa.prototype.has = $3;
      function yi(u) {
        var h = this.__data__ = new lo(u);
        this.size = h.size;
      }
      function D3() {
        this.__data__ = new lo(), this.size = 0;
      }
      function I3(u) {
        var h = this.__data__, b = h.delete(u);
        return this.size = h.size, b;
      }
      function R3(u) {
        return this.__data__.get(u);
      }
      function j3(u) {
        return this.__data__.has(u);
      }
      function L3(u, h) {
        var b = this.__data__;
        if (b instanceof lo) {
          var T = b.__data__;
          if (!ou || T.length < i - 1)
            return T.push([u, h]), this.size = ++b.size, this;
          b = this.__data__ = new co(T);
        }
        return b.set(u, h), this.size = b.size, this;
      }
      yi.prototype.clear = D3, yi.prototype.delete = I3, yi.prototype.get = R3, yi.prototype.has = j3, yi.prototype.set = L3;
      function NO(u, h) {
        var b = Ge(u), T = !b && is(u), M = !b && !T && fa(u), B = !b && !T && !M && gl(u), H = b || T || M || B, q = H ? Hy(u.length, Y5) : [], Q = q.length;
        for (var de in u)
          (h || Ot.call(u, de)) && !(H && // Safari 9 has enumerable `arguments.length` in strict mode.
          (de == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          M && (de == "offset" || de == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          B && (de == "buffer" || de == "byteLength" || de == "byteOffset") || // Skip index properties.
          po(de, Q))) && q.push(de);
        return q;
      }
      function $O(u) {
        var h = u.length;
        return h ? u[lv(0, h - 1)] : n;
      }
      function B3(u, h) {
        return yh(gr(u), es(h, 0, u.length));
      }
      function F3(u) {
        return yh(gr(u));
      }
      function Jy(u, h, b) {
        (b !== n && !vi(u[h], b) || b === n && !(h in u)) && uo(u, h, b);
      }
      function cu(u, h, b) {
        var T = u[h];
        (!(Ot.call(u, h) && vi(T, b)) || b === n && !(h in u)) && uo(u, h, b);
      }
      function ih(u, h) {
        for (var b = u.length; b--; )
          if (vi(u[b][0], h))
            return b;
        return -1;
      }
      function W3(u, h, b, T) {
        return sa(u, function(M, B, H) {
          h(T, M, b(M), H);
        }), T;
      }
      function DO(u, h) {
        return u && ji(h, En(h), u);
      }
      function z3(u, h) {
        return u && ji(h, vr(h), u);
      }
      function uo(u, h, b) {
        h == "__proto__" && Jd ? Jd(u, h, {
          configurable: !0,
          enumerable: !0,
          value: b,
          writable: !0
        }) : u[h] = b;
      }
      function Qy(u, h) {
        for (var b = -1, T = h.length, M = oe(T), B = u == null; ++b < T; )
          M[b] = B ? n : $v(u, h[b]);
        return M;
      }
      function es(u, h, b) {
        return u === u && (b !== n && (u = u <= b ? u : b), h !== n && (u = u >= h ? u : h)), u;
      }
      function ti(u, h, b, T, M, B) {
        var H, q = h & d, Q = h & p, de = h & m;
        if (b && (H = M ? b(u, T, M, B) : b(u)), H !== n)
          return H;
        if (!Jt(u))
          return u;
        var me = Ge(u);
        if (me) {
          if (H = kV(u), !q)
            return gr(u, H);
        } else {
          var ge = Jn(u), xe = ge == X || ge == De;
          if (fa(u))
            return iA(u, q);
          if (ge == st || ge == le || xe && !M) {
            if (H = Q || xe ? {} : SA(u), !q)
              return Q ? bV(u, z3(H, u)) : vV(u, DO(H, u));
          } else {
            if (!It[ge])
              return M ? u : {};
            H = MV(u, ge, q);
          }
        }
        B || (B = new yi());
        var Ce = B.get(u);
        if (Ce)
          return Ce;
        B.set(u, H), JA(u) ? u.forEach(function(je) {
          H.add(ti(je, h, b, je, u, B));
        }) : XA(u) && u.forEach(function(je, ot) {
          H.set(ot, ti(je, h, b, ot, u, B));
        });
        var Re = de ? Q ? bv : vv : Q ? vr : En, et = me ? n : Re(u);
        return Jr(et || u, function(je, ot) {
          et && (ot = je, je = u[ot]), cu(H, ot, ti(je, h, b, ot, u, B));
        }), H;
      }
      function V3(u) {
        var h = En(u);
        return function(b) {
          return IO(b, u, h);
        };
      }
      function IO(u, h, b) {
        var T = b.length;
        if (u == null)
          return !T;
        for (u = Mt(u); T--; ) {
          var M = b[T], B = h[M], H = u[M];
          if (H === n && !(M in u) || !B(H))
            return !1;
        }
        return !0;
      }
      function RO(u, h, b) {
        if (typeof u != "function")
          throw new Qr(a);
        return gu(function() {
          u.apply(n, b);
        }, h);
      }
      function uu(u, h, b, T) {
        var M = -1, B = Wd, H = !0, q = u.length, Q = [], de = h.length;
        if (!q)
          return Q;
        b && (h = Gt(h, Er(b))), T ? (B = By, H = !1) : h.length >= i && (B = ru, H = !1, h = new Qa(h));
        e:
          for (; ++M < q; ) {
            var me = u[M], ge = b == null ? me : b(me);
            if (me = T || me !== 0 ? me : 0, H && ge === ge) {
              for (var xe = de; xe--; )
                if (h[xe] === ge)
                  continue e;
              Q.push(me);
            } else B(h, ge, T) || Q.push(me);
          }
        return Q;
      }
      var sa = cA(Ri), jO = cA(tv, !0);
      function U3(u, h) {
        var b = !0;
        return sa(u, function(T, M, B) {
          return b = !!h(T, M, B), b;
        }), b;
      }
      function oh(u, h, b) {
        for (var T = -1, M = u.length; ++T < M; ) {
          var B = u[T], H = h(B);
          if (H != null && (q === n ? H === H && !Mr(H) : b(H, q)))
            var q = H, Q = B;
        }
        return Q;
      }
      function H3(u, h, b, T) {
        var M = u.length;
        for (b = Ze(b), b < 0 && (b = -b > M ? 0 : M + b), T = T === n || T > M ? M : Ze(T), T < 0 && (T += M), T = b > T ? 0 : eT(T); b < T; )
          u[b++] = h;
        return u;
      }
      function LO(u, h) {
        var b = [];
        return sa(u, function(T, M, B) {
          h(T, M, B) && b.push(T);
        }), b;
      }
      function Bn(u, h, b, T, M) {
        var B = -1, H = u.length;
        for (b || (b = $V), M || (M = []); ++B < H; ) {
          var q = u[B];
          h > 0 && b(q) ? h > 1 ? Bn(q, h - 1, b, T, M) : ia(M, q) : T || (M[M.length] = q);
        }
        return M;
      }
      var ev = uA(), BO = uA(!0);
      function Ri(u, h) {
        return u && ev(u, h, En);
      }
      function tv(u, h) {
        return u && BO(u, h, En);
      }
      function ah(u, h) {
        return ra(h, function(b) {
          return mo(u[b]);
        });
      }
      function ts(u, h) {
        h = ca(h, u);
        for (var b = 0, T = h.length; u != null && b < T; )
          u = u[Li(h[b++])];
        return b && b == T ? u : n;
      }
      function FO(u, h, b) {
        var T = h(u);
        return Ge(u) ? T : ia(T, b(u));
      }
      function or(u) {
        return u == null ? u === n ? mt : it : Za && Za in Mt(u) ? PV(u) : FV(u);
      }
      function nv(u, h) {
        return u > h;
      }
      function K3(u, h) {
        return u != null && Ot.call(u, h);
      }
      function G3(u, h) {
        return u != null && h in Mt(u);
      }
      function Y3(u, h, b) {
        return u >= Zn(h, b) && u < bn(h, b);
      }
      function rv(u, h, b) {
        for (var T = b ? By : Wd, M = u[0].length, B = u.length, H = B, q = oe(B), Q = 1 / 0, de = []; H--; ) {
          var me = u[H];
          H && h && (me = Gt(me, Er(h))), Q = Zn(me.length, Q), q[H] = !b && (h || M >= 120 && me.length >= 120) ? new Qa(H && me) : n;
        }
        me = u[0];
        var ge = -1, xe = q[0];
        e:
          for (; ++ge < M && de.length < Q; ) {
            var Ce = me[ge], Re = h ? h(Ce) : Ce;
            if (Ce = b || Ce !== 0 ? Ce : 0, !(xe ? ru(xe, Re) : T(de, Re, b))) {
              for (H = B; --H; ) {
                var et = q[H];
                if (!(et ? ru(et, Re) : T(u[H], Re, b)))
                  continue e;
              }
              xe && xe.push(Re), de.push(Ce);
            }
          }
        return de;
      }
      function q3(u, h, b, T) {
        return Ri(u, function(M, B, H) {
          h(T, b(M), B, H);
        }), T;
      }
      function fu(u, h, b) {
        h = ca(h, u), u = PA(u, h);
        var T = u == null ? u : u[Li(ri(h))];
        return T == null ? n : Cr(T, u, b);
      }
      function WO(u) {
        return tn(u) && or(u) == le;
      }
      function X3(u) {
        return tn(u) && or(u) == Cn;
      }
      function Z3(u) {
        return tn(u) && or(u) == J;
      }
      function du(u, h, b, T, M) {
        return u === h ? !0 : u == null || h == null || !tn(u) && !tn(h) ? u !== u && h !== h : J3(u, h, b, T, du, M);
      }
      function J3(u, h, b, T, M, B) {
        var H = Ge(u), q = Ge(h), Q = H ? ae : Jn(u), de = q ? ae : Jn(h);
        Q = Q == le ? st : Q, de = de == le ? st : de;
        var me = Q == st, ge = de == st, xe = Q == de;
        if (xe && fa(u)) {
          if (!fa(h))
            return !1;
          H = !0, me = !1;
        }
        if (xe && !me)
          return B || (B = new yi()), H || gl(u) ? xA(u, h, b, T, M, B) : AV(u, h, Q, b, T, M, B);
        if (!(b & y)) {
          var Ce = me && Ot.call(u, "__wrapped__"), Re = ge && Ot.call(h, "__wrapped__");
          if (Ce || Re) {
            var et = Ce ? u.value() : u, je = Re ? h.value() : h;
            return B || (B = new yi()), M(et, je, b, T, B);
          }
        }
        return xe ? (B || (B = new yi()), TV(u, h, b, T, M, B)) : !1;
      }
      function Q3(u) {
        return tn(u) && Jn(u) == pe;
      }
      function iv(u, h, b, T) {
        var M = b.length, B = M, H = !T;
        if (u == null)
          return !B;
        for (u = Mt(u); M--; ) {
          var q = b[M];
          if (H && q[2] ? q[1] !== u[q[0]] : !(q[0] in u))
            return !1;
        }
        for (; ++M < B; ) {
          q = b[M];
          var Q = q[0], de = u[Q], me = q[1];
          if (H && q[2]) {
            if (de === n && !(Q in u))
              return !1;
          } else {
            var ge = new yi();
            if (T)
              var xe = T(de, me, Q, u, h, ge);
            if (!(xe === n ? du(me, de, y | g, T, ge) : xe))
              return !1;
          }
        }
        return !0;
      }
      function zO(u) {
        if (!Jt(u) || IV(u))
          return !1;
        var h = mo(u) ? Q5 : Vz;
        return h.test(rs(u));
      }
      function eV(u) {
        return tn(u) && or(u) == lt;
      }
      function tV(u) {
        return tn(u) && Jn(u) == Oe;
      }
      function nV(u) {
        return tn(u) && Sh(u.length) && !!Ft[or(u)];
      }
      function VO(u) {
        return typeof u == "function" ? u : u == null ? br : typeof u == "object" ? Ge(u) ? KO(u[0], u[1]) : HO(u) : fT(u);
      }
      function ov(u) {
        if (!mu(u))
          return o3(u);
        var h = [];
        for (var b in Mt(u))
          Ot.call(u, b) && b != "constructor" && h.push(b);
        return h;
      }
      function rV(u) {
        if (!Jt(u))
          return BV(u);
        var h = mu(u), b = [];
        for (var T in u)
          T == "constructor" && (h || !Ot.call(u, T)) || b.push(T);
        return b;
      }
      function av(u, h) {
        return u < h;
      }
      function UO(u, h) {
        var b = -1, T = yr(u) ? oe(u.length) : [];
        return sa(u, function(M, B, H) {
          T[++b] = h(M, B, H);
        }), T;
      }
      function HO(u) {
        var h = wv(u);
        return h.length == 1 && h[0][2] ? AA(h[0][0], h[0][1]) : function(b) {
          return b === u || iv(b, u, h);
        };
      }
      function KO(u, h) {
        return Sv(u) && OA(h) ? AA(Li(u), h) : function(b) {
          var T = $v(b, u);
          return T === n && T === h ? Dv(b, u) : du(h, T, y | g);
        };
      }
      function sh(u, h, b, T, M) {
        u !== h && ev(h, function(B, H) {
          if (M || (M = new yi()), Jt(B))
            iV(u, h, H, b, sh, T, M);
          else {
            var q = T ? T(Av(u, H), B, H + "", u, h, M) : n;
            q === n && (q = B), Jy(u, H, q);
          }
        }, vr);
      }
      function iV(u, h, b, T, M, B, H) {
        var q = Av(u, b), Q = Av(h, b), de = H.get(Q);
        if (de) {
          Jy(u, b, de);
          return;
        }
        var me = B ? B(q, Q, b + "", u, h, H) : n, ge = me === n;
        if (ge) {
          var xe = Ge(Q), Ce = !xe && fa(Q), Re = !xe && !Ce && gl(Q);
          me = Q, xe || Ce || Re ? Ge(q) ? me = q : an(q) ? me = gr(q) : Ce ? (ge = !1, me = iA(Q, !0)) : Re ? (ge = !1, me = oA(Q, !0)) : me = [] : yu(Q) || is(Q) ? (me = q, is(q) ? me = tT(q) : (!Jt(q) || mo(q)) && (me = SA(Q))) : ge = !1;
        }
        ge && (H.set(Q, me), M(me, Q, T, B, H), H.delete(Q)), Jy(u, b, me);
      }
      function GO(u, h) {
        var b = u.length;
        if (b)
          return h += h < 0 ? b : 0, po(h, b) ? u[h] : n;
      }
      function YO(u, h, b) {
        h.length ? h = Gt(h, function(B) {
          return Ge(B) ? function(H) {
            return ts(H, B.length === 1 ? B[0] : B);
          } : B;
        }) : h = [br];
        var T = -1;
        h = Gt(h, Er($e()));
        var M = UO(u, function(B, H, q) {
          var Q = Gt(h, function(de) {
            return de(B);
          });
          return { criteria: Q, index: ++T, value: B };
        });
        return M5(M, function(B, H) {
          return yV(B, H, b);
        });
      }
      function oV(u, h) {
        return qO(u, h, function(b, T) {
          return Dv(u, T);
        });
      }
      function qO(u, h, b) {
        for (var T = -1, M = h.length, B = {}; ++T < M; ) {
          var H = h[T], q = ts(u, H);
          b(q, H) && hu(B, ca(H, u), q);
        }
        return B;
      }
      function aV(u) {
        return function(h) {
          return ts(h, u);
        };
      }
      function sv(u, h, b, T) {
        var M = T ? k5 : ol, B = -1, H = h.length, q = u;
        for (u === h && (h = gr(h)), b && (q = Gt(u, Er(b))); ++B < H; )
          for (var Q = 0, de = h[B], me = b ? b(de) : de; (Q = M(q, me, Q, T)) > -1; )
            q !== u && Zd.call(q, Q, 1), Zd.call(u, Q, 1);
        return u;
      }
      function XO(u, h) {
        for (var b = u ? h.length : 0, T = b - 1; b--; ) {
          var M = h[b];
          if (b == T || M !== B) {
            var B = M;
            po(M) ? Zd.call(u, M, 1) : fv(u, M);
          }
        }
        return u;
      }
      function lv(u, h) {
        return u + eh(kO() * (h - u + 1));
      }
      function sV(u, h, b, T) {
        for (var M = -1, B = bn(Qd((h - u) / (b || 1)), 0), H = oe(B); B--; )
          H[T ? B : ++M] = u, u += b;
        return H;
      }
      function cv(u, h) {
        var b = "";
        if (!u || h < 1 || h > G)
          return b;
        do
          h % 2 && (b += u), h = eh(h / 2), h && (u += u);
        while (h);
        return b;
      }
      function nt(u, h) {
        return Tv(TA(u, h, br), u + "");
      }
      function lV(u) {
        return $O(yl(u));
      }
      function cV(u, h) {
        var b = yl(u);
        return yh(b, es(h, 0, b.length));
      }
      function hu(u, h, b, T) {
        if (!Jt(u))
          return u;
        h = ca(h, u);
        for (var M = -1, B = h.length, H = B - 1, q = u; q != null && ++M < B; ) {
          var Q = Li(h[M]), de = b;
          if (Q === "__proto__" || Q === "constructor" || Q === "prototype")
            return u;
          if (M != H) {
            var me = q[Q];
            de = T ? T(me, Q, q) : n, de === n && (de = Jt(me) ? me : po(h[M + 1]) ? [] : {});
          }
          cu(q, Q, de), q = q[Q];
        }
        return u;
      }
      var ZO = th ? function(u, h) {
        return th.set(u, h), u;
      } : br, uV = Jd ? function(u, h) {
        return Jd(u, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Rv(h),
          writable: !0
        });
      } : br;
      function fV(u) {
        return yh(yl(u));
      }
      function ni(u, h, b) {
        var T = -1, M = u.length;
        h < 0 && (h = -h > M ? 0 : M + h), b = b > M ? M : b, b < 0 && (b += M), M = h > b ? 0 : b - h >>> 0, h >>>= 0;
        for (var B = oe(M); ++T < M; )
          B[T] = u[T + h];
        return B;
      }
      function dV(u, h) {
        var b;
        return sa(u, function(T, M, B) {
          return b = h(T, M, B), !b;
        }), !!b;
      }
      function lh(u, h, b) {
        var T = 0, M = u == null ? T : u.length;
        if (typeof h == "number" && h === h && M <= ie) {
          for (; T < M; ) {
            var B = T + M >>> 1, H = u[B];
            H !== null && !Mr(H) && (b ? H <= h : H < h) ? T = B + 1 : M = B;
          }
          return M;
        }
        return uv(u, h, br, b);
      }
      function uv(u, h, b, T) {
        var M = 0, B = u == null ? 0 : u.length;
        if (B === 0)
          return 0;
        h = b(h);
        for (var H = h !== h, q = h === null, Q = Mr(h), de = h === n; M < B; ) {
          var me = eh((M + B) / 2), ge = b(u[me]), xe = ge !== n, Ce = ge === null, Re = ge === ge, et = Mr(ge);
          if (H)
            var je = T || Re;
          else de ? je = Re && (T || xe) : q ? je = Re && xe && (T || !Ce) : Q ? je = Re && xe && !Ce && (T || !et) : Ce || et ? je = !1 : je = T ? ge <= h : ge < h;
          je ? M = me + 1 : B = me;
        }
        return Zn(B, ee);
      }
      function JO(u, h) {
        for (var b = -1, T = u.length, M = 0, B = []; ++b < T; ) {
          var H = u[b], q = h ? h(H) : H;
          if (!b || !vi(q, Q)) {
            var Q = q;
            B[M++] = H === 0 ? 0 : H;
          }
        }
        return B;
      }
      function QO(u) {
        return typeof u == "number" ? u : Mr(u) ? V : +u;
      }
      function kr(u) {
        if (typeof u == "string")
          return u;
        if (Ge(u))
          return Gt(u, kr) + "";
        if (Mr(u))
          return MO ? MO.call(u) : "";
        var h = u + "";
        return h == "0" && 1 / u == -z ? "-0" : h;
      }
      function la(u, h, b) {
        var T = -1, M = Wd, B = u.length, H = !0, q = [], Q = q;
        if (b)
          H = !1, M = By;
        else if (B >= i) {
          var de = h ? null : SV(u);
          if (de)
            return Vd(de);
          H = !1, M = ru, Q = new Qa();
        } else
          Q = h ? [] : q;
        e:
          for (; ++T < B; ) {
            var me = u[T], ge = h ? h(me) : me;
            if (me = b || me !== 0 ? me : 0, H && ge === ge) {
              for (var xe = Q.length; xe--; )
                if (Q[xe] === ge)
                  continue e;
              h && Q.push(ge), q.push(me);
            } else M(Q, ge, b) || (Q !== q && Q.push(ge), q.push(me));
          }
        return q;
      }
      function fv(u, h) {
        return h = ca(h, u), u = PA(u, h), u == null || delete u[Li(ri(h))];
      }
      function eA(u, h, b, T) {
        return hu(u, h, b(ts(u, h)), T);
      }
      function ch(u, h, b, T) {
        for (var M = u.length, B = T ? M : -1; (T ? B-- : ++B < M) && h(u[B], B, u); )
          ;
        return b ? ni(u, T ? 0 : B, T ? B + 1 : M) : ni(u, T ? B + 1 : 0, T ? M : B);
      }
      function tA(u, h) {
        var b = u;
        return b instanceof ct && (b = b.value()), Fy(h, function(T, M) {
          return M.func.apply(M.thisArg, ia([T], M.args));
        }, b);
      }
      function dv(u, h, b) {
        var T = u.length;
        if (T < 2)
          return T ? la(u[0]) : [];
        for (var M = -1, B = oe(T); ++M < T; )
          for (var H = u[M], q = -1; ++q < T; )
            q != M && (B[M] = uu(B[M] || H, u[q], h, b));
        return la(Bn(B, 1), h, b);
      }
      function nA(u, h, b) {
        for (var T = -1, M = u.length, B = h.length, H = {}; ++T < M; ) {
          var q = T < B ? h[T] : n;
          b(H, u[T], q);
        }
        return H;
      }
      function hv(u) {
        return an(u) ? u : [];
      }
      function pv(u) {
        return typeof u == "function" ? u : br;
      }
      function ca(u, h) {
        return Ge(u) ? u : Sv(u, h) ? [u] : MA(vt(u));
      }
      var hV = nt;
      function ua(u, h, b) {
        var T = u.length;
        return b = b === n ? T : b, !h && b >= T ? u : ni(u, h, b);
      }
      var rA = e3 || function(u) {
        return Ln.clearTimeout(u);
      };
      function iA(u, h) {
        if (h)
          return u.slice();
        var b = u.length, T = AO ? AO(b) : new u.constructor(b);
        return u.copy(T), T;
      }
      function mv(u) {
        var h = new u.constructor(u.byteLength);
        return new qd(h).set(new qd(u)), h;
      }
      function pV(u, h) {
        var b = h ? mv(u.buffer) : u.buffer;
        return new u.constructor(b, u.byteOffset, u.byteLength);
      }
      function mV(u) {
        var h = new u.constructor(u.source, WS.exec(u));
        return h.lastIndex = u.lastIndex, h;
      }
      function gV(u) {
        return lu ? Mt(lu.call(u)) : {};
      }
      function oA(u, h) {
        var b = h ? mv(u.buffer) : u.buffer;
        return new u.constructor(b, u.byteOffset, u.length);
      }
      function aA(u, h) {
        if (u !== h) {
          var b = u !== n, T = u === null, M = u === u, B = Mr(u), H = h !== n, q = h === null, Q = h === h, de = Mr(h);
          if (!q && !de && !B && u > h || B && H && Q && !q && !de || T && H && Q || !b && Q || !M)
            return 1;
          if (!T && !B && !de && u < h || de && b && M && !T && !B || q && b && M || !H && M || !Q)
            return -1;
        }
        return 0;
      }
      function yV(u, h, b) {
        for (var T = -1, M = u.criteria, B = h.criteria, H = M.length, q = b.length; ++T < H; ) {
          var Q = aA(M[T], B[T]);
          if (Q) {
            if (T >= q)
              return Q;
            var de = b[T];
            return Q * (de == "desc" ? -1 : 1);
          }
        }
        return u.index - h.index;
      }
      function sA(u, h, b, T) {
        for (var M = -1, B = u.length, H = b.length, q = -1, Q = h.length, de = bn(B - H, 0), me = oe(Q + de), ge = !T; ++q < Q; )
          me[q] = h[q];
        for (; ++M < H; )
          (ge || M < B) && (me[b[M]] = u[M]);
        for (; de--; )
          me[q++] = u[M++];
        return me;
      }
      function lA(u, h, b, T) {
        for (var M = -1, B = u.length, H = -1, q = b.length, Q = -1, de = h.length, me = bn(B - q, 0), ge = oe(me + de), xe = !T; ++M < me; )
          ge[M] = u[M];
        for (var Ce = M; ++Q < de; )
          ge[Ce + Q] = h[Q];
        for (; ++H < q; )
          (xe || M < B) && (ge[Ce + b[H]] = u[M++]);
        return ge;
      }
      function gr(u, h) {
        var b = -1, T = u.length;
        for (h || (h = oe(T)); ++b < T; )
          h[b] = u[b];
        return h;
      }
      function ji(u, h, b, T) {
        var M = !b;
        b || (b = {});
        for (var B = -1, H = h.length; ++B < H; ) {
          var q = h[B], Q = T ? T(b[q], u[q], q, b, u) : n;
          Q === n && (Q = u[q]), M ? uo(b, q, Q) : cu(b, q, Q);
        }
        return b;
      }
      function vV(u, h) {
        return ji(u, _v(u), h);
      }
      function bV(u, h) {
        return ji(u, wA(u), h);
      }
      function uh(u, h) {
        return function(b, T) {
          var M = Ge(b) ? O5 : W3, B = h ? h() : {};
          return M(b, u, $e(T, 2), B);
        };
      }
      function hl(u) {
        return nt(function(h, b) {
          var T = -1, M = b.length, B = M > 1 ? b[M - 1] : n, H = M > 2 ? b[2] : n;
          for (B = u.length > 3 && typeof B == "function" ? (M--, B) : n, H && ar(b[0], b[1], H) && (B = M < 3 ? n : B, M = 1), h = Mt(h); ++T < M; ) {
            var q = b[T];
            q && u(h, q, T, B);
          }
          return h;
        });
      }
      function cA(u, h) {
        return function(b, T) {
          if (b == null)
            return b;
          if (!yr(b))
            return u(b, T);
          for (var M = b.length, B = h ? M : -1, H = Mt(b); (h ? B-- : ++B < M) && T(H[B], B, H) !== !1; )
            ;
          return b;
        };
      }
      function uA(u) {
        return function(h, b, T) {
          for (var M = -1, B = Mt(h), H = T(h), q = H.length; q--; ) {
            var Q = H[u ? q : ++M];
            if (b(B[Q], Q, B) === !1)
              break;
          }
          return h;
        };
      }
      function xV(u, h, b) {
        var T = h & v, M = pu(u);
        function B() {
          var H = this && this !== Ln && this instanceof B ? M : u;
          return H.apply(T ? b : this, arguments);
        }
        return B;
      }
      function fA(u) {
        return function(h) {
          h = vt(h);
          var b = al(h) ? gi(h) : n, T = b ? b[0] : h.charAt(0), M = b ? ua(b, 1).join("") : h.slice(1);
          return T[u]() + M;
        };
      }
      function pl(u) {
        return function(h) {
          return Fy(cT(lT(h).replace(u5, "")), u, "");
        };
      }
      function pu(u) {
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return new u();
            case 1:
              return new u(h[0]);
            case 2:
              return new u(h[0], h[1]);
            case 3:
              return new u(h[0], h[1], h[2]);
            case 4:
              return new u(h[0], h[1], h[2], h[3]);
            case 5:
              return new u(h[0], h[1], h[2], h[3], h[4]);
            case 6:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5]);
            case 7:
              return new u(h[0], h[1], h[2], h[3], h[4], h[5], h[6]);
          }
          var b = dl(u.prototype), T = u.apply(b, h);
          return Jt(T) ? T : b;
        };
      }
      function wV(u, h, b) {
        var T = pu(u);
        function M() {
          for (var B = arguments.length, H = oe(B), q = B, Q = ml(M); q--; )
            H[q] = arguments[q];
          var de = B < 3 && H[0] !== Q && H[B - 1] !== Q ? [] : oa(H, Q);
          if (B -= de.length, B < b)
            return gA(
              u,
              h,
              fh,
              M.placeholder,
              n,
              H,
              de,
              n,
              n,
              b - B
            );
          var me = this && this !== Ln && this instanceof M ? T : u;
          return Cr(me, this, H);
        }
        return M;
      }
      function dA(u) {
        return function(h, b, T) {
          var M = Mt(h);
          if (!yr(h)) {
            var B = $e(b, 3);
            h = En(h), b = function(q) {
              return B(M[q], q, M);
            };
          }
          var H = u(h, b, T);
          return H > -1 ? M[B ? h[H] : H] : n;
        };
      }
      function hA(u) {
        return ho(function(h) {
          var b = h.length, T = b, M = ei.prototype.thru;
          for (u && h.reverse(); T--; ) {
            var B = h[T];
            if (typeof B != "function")
              throw new Qr(a);
            if (M && !H && mh(B) == "wrapper")
              var H = new ei([], !0);
          }
          for (T = H ? T : b; ++T < b; ) {
            B = h[T];
            var q = mh(B), Q = q == "wrapper" ? xv(B) : n;
            Q && Ov(Q[0]) && Q[1] == (P | S | _ | C) && !Q[4].length && Q[9] == 1 ? H = H[mh(Q[0])].apply(H, Q[3]) : H = B.length == 1 && Ov(B) ? H[q]() : H.thru(B);
          }
          return function() {
            var de = arguments, me = de[0];
            if (H && de.length == 1 && Ge(me))
              return H.plant(me).value();
            for (var ge = 0, xe = b ? h[ge].apply(this, de) : me; ++ge < b; )
              xe = h[ge].call(this, xe);
            return xe;
          };
        });
      }
      function fh(u, h, b, T, M, B, H, q, Q, de) {
        var me = h & P, ge = h & v, xe = h & x, Ce = h & (S | A), Re = h & k, et = xe ? n : pu(u);
        function je() {
          for (var ot = arguments.length, ft = oe(ot), Nr = ot; Nr--; )
            ft[Nr] = arguments[Nr];
          if (Ce)
            var sr = ml(je), $r = $5(ft, sr);
          if (T && (ft = sA(ft, T, M, Ce)), B && (ft = lA(ft, B, H, Ce)), ot -= $r, Ce && ot < de) {
            var sn = oa(ft, sr);
            return gA(
              u,
              h,
              fh,
              je.placeholder,
              b,
              ft,
              sn,
              q,
              Q,
              de - ot
            );
          }
          var bi = ge ? b : this, yo = xe ? bi[u] : u;
          return ot = ft.length, q ? ft = WV(ft, q) : Re && ot > 1 && ft.reverse(), me && Q < ot && (ft.length = Q), this && this !== Ln && this instanceof je && (yo = et || pu(yo)), yo.apply(bi, ft);
        }
        return je;
      }
      function pA(u, h) {
        return function(b, T) {
          return q3(b, u, h(T), {});
        };
      }
      function dh(u, h) {
        return function(b, T) {
          var M;
          if (b === n && T === n)
            return h;
          if (b !== n && (M = b), T !== n) {
            if (M === n)
              return T;
            typeof b == "string" || typeof T == "string" ? (b = kr(b), T = kr(T)) : (b = QO(b), T = QO(T)), M = u(b, T);
          }
          return M;
        };
      }
      function gv(u) {
        return ho(function(h) {
          return h = Gt(h, Er($e())), nt(function(b) {
            var T = this;
            return u(h, function(M) {
              return Cr(M, T, b);
            });
          });
        });
      }
      function hh(u, h) {
        h = h === n ? " " : kr(h);
        var b = h.length;
        if (b < 2)
          return b ? cv(h, u) : h;
        var T = cv(h, Qd(u / sl(h)));
        return al(h) ? ua(gi(T), 0, u).join("") : T.slice(0, u);
      }
      function _V(u, h, b, T) {
        var M = h & v, B = pu(u);
        function H() {
          for (var q = -1, Q = arguments.length, de = -1, me = T.length, ge = oe(me + Q), xe = this && this !== Ln && this instanceof H ? B : u; ++de < me; )
            ge[de] = T[de];
          for (; Q--; )
            ge[de++] = arguments[++q];
          return Cr(xe, M ? b : this, ge);
        }
        return H;
      }
      function mA(u) {
        return function(h, b, T) {
          return T && typeof T != "number" && ar(h, b, T) && (b = T = n), h = go(h), b === n ? (b = h, h = 0) : b = go(b), T = T === n ? h < b ? 1 : -1 : go(T), sV(h, b, T, u);
        };
      }
      function ph(u) {
        return function(h, b) {
          return typeof h == "string" && typeof b == "string" || (h = ii(h), b = ii(b)), u(h, b);
        };
      }
      function gA(u, h, b, T, M, B, H, q, Q, de) {
        var me = h & S, ge = me ? H : n, xe = me ? n : H, Ce = me ? B : n, Re = me ? n : B;
        h |= me ? _ : O, h &= ~(me ? O : _), h & w || (h &= ~(v | x));
        var et = [
          u,
          h,
          M,
          Ce,
          ge,
          Re,
          xe,
          q,
          Q,
          de
        ], je = b.apply(n, et);
        return Ov(u) && CA(je, et), je.placeholder = T, EA(je, u, h);
      }
      function yv(u) {
        var h = vn[u];
        return function(b, T) {
          if (b = ii(b), T = T == null ? 0 : Zn(Ze(T), 292), T && EO(b)) {
            var M = (vt(b) + "e").split("e"), B = h(M[0] + "e" + (+M[1] + T));
            return M = (vt(B) + "e").split("e"), +(M[0] + "e" + (+M[1] - T));
          }
          return h(b);
        };
      }
      var SV = ul && 1 / Vd(new ul([, -0]))[1] == z ? function(u) {
        return new ul(u);
      } : Bv;
      function yA(u) {
        return function(h) {
          var b = Jn(h);
          return b == pe ? Gy(h) : b == Oe ? F5(h) : N5(h, u(h));
        };
      }
      function fo(u, h, b, T, M, B, H, q) {
        var Q = h & x;
        if (!Q && typeof u != "function")
          throw new Qr(a);
        var de = T ? T.length : 0;
        if (de || (h &= ~(_ | O), T = M = n), H = H === n ? H : bn(Ze(H), 0), q = q === n ? q : Ze(q), de -= M ? M.length : 0, h & O) {
          var me = T, ge = M;
          T = M = n;
        }
        var xe = Q ? n : xv(u), Ce = [
          u,
          h,
          b,
          T,
          M,
          me,
          ge,
          B,
          H,
          q
        ];
        if (xe && LV(Ce, xe), u = Ce[0], h = Ce[1], b = Ce[2], T = Ce[3], M = Ce[4], q = Ce[9] = Ce[9] === n ? Q ? 0 : u.length : bn(Ce[9] - de, 0), !q && h & (S | A) && (h &= ~(S | A)), !h || h == v)
          var Re = xV(u, h, b);
        else h == S || h == A ? Re = wV(u, h, q) : (h == _ || h == (v | _)) && !M.length ? Re = _V(u, h, b, T) : Re = fh.apply(n, Ce);
        var et = xe ? ZO : CA;
        return EA(et(Re, Ce), u, h);
      }
      function vA(u, h, b, T) {
        return u === n || vi(u, cl[b]) && !Ot.call(T, b) ? h : u;
      }
      function bA(u, h, b, T, M, B) {
        return Jt(u) && Jt(h) && (B.set(h, u), sh(u, h, n, bA, B), B.delete(h)), u;
      }
      function OV(u) {
        return yu(u) ? n : u;
      }
      function xA(u, h, b, T, M, B) {
        var H = b & y, q = u.length, Q = h.length;
        if (q != Q && !(H && Q > q))
          return !1;
        var de = B.get(u), me = B.get(h);
        if (de && me)
          return de == h && me == u;
        var ge = -1, xe = !0, Ce = b & g ? new Qa() : n;
        for (B.set(u, h), B.set(h, u); ++ge < q; ) {
          var Re = u[ge], et = h[ge];
          if (T)
            var je = H ? T(et, Re, ge, h, u, B) : T(Re, et, ge, u, h, B);
          if (je !== n) {
            if (je)
              continue;
            xe = !1;
            break;
          }
          if (Ce) {
            if (!Wy(h, function(ot, ft) {
              if (!ru(Ce, ft) && (Re === ot || M(Re, ot, b, T, B)))
                return Ce.push(ft);
            })) {
              xe = !1;
              break;
            }
          } else if (!(Re === et || M(Re, et, b, T, B))) {
            xe = !1;
            break;
          }
        }
        return B.delete(u), B.delete(h), xe;
      }
      function AV(u, h, b, T, M, B, H) {
        switch (b) {
          case yn:
            if (u.byteLength != h.byteLength || u.byteOffset != h.byteOffset)
              return !1;
            u = u.buffer, h = h.buffer;
          case Cn:
            return !(u.byteLength != h.byteLength || !B(new qd(u), new qd(h)));
          case ne:
          case J:
          case ke:
            return vi(+u, +h);
          case be:
            return u.name == h.name && u.message == h.message;
          case lt:
          case Ke:
            return u == h + "";
          case pe:
            var q = Gy;
          case Oe:
            var Q = T & y;
            if (q || (q = Vd), u.size != h.size && !Q)
              return !1;
            var de = H.get(u);
            if (de)
              return de == h;
            T |= g, H.set(u, h);
            var me = xA(q(u), q(h), T, M, B, H);
            return H.delete(u), me;
          case Zt:
            if (lu)
              return lu.call(u) == lu.call(h);
        }
        return !1;
      }
      function TV(u, h, b, T, M, B) {
        var H = b & y, q = vv(u), Q = q.length, de = vv(h), me = de.length;
        if (Q != me && !H)
          return !1;
        for (var ge = Q; ge--; ) {
          var xe = q[ge];
          if (!(H ? xe in h : Ot.call(h, xe)))
            return !1;
        }
        var Ce = B.get(u), Re = B.get(h);
        if (Ce && Re)
          return Ce == h && Re == u;
        var et = !0;
        B.set(u, h), B.set(h, u);
        for (var je = H; ++ge < Q; ) {
          xe = q[ge];
          var ot = u[xe], ft = h[xe];
          if (T)
            var Nr = H ? T(ft, ot, xe, h, u, B) : T(ot, ft, xe, u, h, B);
          if (!(Nr === n ? ot === ft || M(ot, ft, b, T, B) : Nr)) {
            et = !1;
            break;
          }
          je || (je = xe == "constructor");
        }
        if (et && !je) {
          var sr = u.constructor, $r = h.constructor;
          sr != $r && "constructor" in u && "constructor" in h && !(typeof sr == "function" && sr instanceof sr && typeof $r == "function" && $r instanceof $r) && (et = !1);
        }
        return B.delete(u), B.delete(h), et;
      }
      function ho(u) {
        return Tv(TA(u, n, IA), u + "");
      }
      function vv(u) {
        return FO(u, En, _v);
      }
      function bv(u) {
        return FO(u, vr, wA);
      }
      var xv = th ? function(u) {
        return th.get(u);
      } : Bv;
      function mh(u) {
        for (var h = u.name + "", b = fl[h], T = Ot.call(fl, h) ? b.length : 0; T--; ) {
          var M = b[T], B = M.func;
          if (B == null || B == u)
            return M.name;
        }
        return h;
      }
      function ml(u) {
        var h = Ot.call(j, "placeholder") ? j : u;
        return h.placeholder;
      }
      function $e() {
        var u = j.iteratee || jv;
        return u = u === jv ? VO : u, arguments.length ? u(arguments[0], arguments[1]) : u;
      }
      function gh(u, h) {
        var b = u.__data__;
        return DV(h) ? b[typeof h == "string" ? "string" : "hash"] : b.map;
      }
      function wv(u) {
        for (var h = En(u), b = h.length; b--; ) {
          var T = h[b], M = u[T];
          h[b] = [T, M, OA(M)];
        }
        return h;
      }
      function ns(u, h) {
        var b = j5(u, h);
        return zO(b) ? b : n;
      }
      function PV(u) {
        var h = Ot.call(u, Za), b = u[Za];
        try {
          u[Za] = n;
          var T = !0;
        } catch {
        }
        var M = Gd.call(u);
        return T && (h ? u[Za] = b : delete u[Za]), M;
      }
      var _v = qy ? function(u) {
        return u == null ? [] : (u = Mt(u), ra(qy(u), function(h) {
          return PO.call(u, h);
        }));
      } : Fv, wA = qy ? function(u) {
        for (var h = []; u; )
          ia(h, _v(u)), u = Xd(u);
        return h;
      } : Fv, Jn = or;
      (Xy && Jn(new Xy(new ArrayBuffer(1))) != yn || ou && Jn(new ou()) != pe || Zy && Jn(Zy.resolve()) != Xn || ul && Jn(new ul()) != Oe || au && Jn(new au()) != en) && (Jn = function(u) {
        var h = or(u), b = h == st ? u.constructor : n, T = b ? rs(b) : "";
        if (T)
          switch (T) {
            case c3:
              return yn;
            case u3:
              return pe;
            case f3:
              return Xn;
            case d3:
              return Oe;
            case h3:
              return en;
          }
        return h;
      });
      function CV(u, h, b) {
        for (var T = -1, M = b.length; ++T < M; ) {
          var B = b[T], H = B.size;
          switch (B.type) {
            case "drop":
              u += H;
              break;
            case "dropRight":
              h -= H;
              break;
            case "take":
              h = Zn(h, u + H);
              break;
            case "takeRight":
              u = bn(u, h - H);
              break;
          }
        }
        return { start: u, end: h };
      }
      function EV(u) {
        var h = u.match(Iz);
        return h ? h[1].split(Rz) : [];
      }
      function _A(u, h, b) {
        h = ca(h, u);
        for (var T = -1, M = h.length, B = !1; ++T < M; ) {
          var H = Li(h[T]);
          if (!(B = u != null && b(u, H)))
            break;
          u = u[H];
        }
        return B || ++T != M ? B : (M = u == null ? 0 : u.length, !!M && Sh(M) && po(H, M) && (Ge(u) || is(u)));
      }
      function kV(u) {
        var h = u.length, b = new u.constructor(h);
        return h && typeof u[0] == "string" && Ot.call(u, "index") && (b.index = u.index, b.input = u.input), b;
      }
      function SA(u) {
        return typeof u.constructor == "function" && !mu(u) ? dl(Xd(u)) : {};
      }
      function MV(u, h, b) {
        var T = u.constructor;
        switch (h) {
          case Cn:
            return mv(u);
          case ne:
          case J:
            return new T(+u);
          case yn:
            return pV(u, b);
          case mr:
          case tt:
          case Kt:
          case St:
          case jn:
          case qr:
          case so:
          case un:
          case Pr:
            return oA(u, b);
          case pe:
            return new T();
          case ke:
          case Ke:
            return new T(u);
          case lt:
            return mV(u);
          case Oe:
            return new T();
          case Zt:
            return gV(u);
        }
      }
      function NV(u, h) {
        var b = h.length;
        if (!b)
          return u;
        var T = b - 1;
        return h[T] = (b > 1 ? "& " : "") + h[T], h = h.join(b > 2 ? ", " : " "), u.replace(Dz, `{
/* [wrapped with ` + h + `] */
`);
      }
      function $V(u) {
        return Ge(u) || is(u) || !!(CO && u && u[CO]);
      }
      function po(u, h) {
        var b = typeof u;
        return h = h ?? G, !!h && (b == "number" || b != "symbol" && Hz.test(u)) && u > -1 && u % 1 == 0 && u < h;
      }
      function ar(u, h, b) {
        if (!Jt(b))
          return !1;
        var T = typeof h;
        return (T == "number" ? yr(b) && po(h, b.length) : T == "string" && h in b) ? vi(b[h], u) : !1;
      }
      function Sv(u, h) {
        if (Ge(u))
          return !1;
        var b = typeof u;
        return b == "number" || b == "symbol" || b == "boolean" || u == null || Mr(u) ? !0 : kz.test(u) || !Ez.test(u) || h != null && u in Mt(h);
      }
      function DV(u) {
        var h = typeof u;
        return h == "string" || h == "number" || h == "symbol" || h == "boolean" ? u !== "__proto__" : u === null;
      }
      function Ov(u) {
        var h = mh(u), b = j[h];
        if (typeof b != "function" || !(h in ct.prototype))
          return !1;
        if (u === b)
          return !0;
        var T = xv(b);
        return !!T && u === T[0];
      }
      function IV(u) {
        return !!OO && OO in u;
      }
      var RV = Hd ? mo : Wv;
      function mu(u) {
        var h = u && u.constructor, b = typeof h == "function" && h.prototype || cl;
        return u === b;
      }
      function OA(u) {
        return u === u && !Jt(u);
      }
      function AA(u, h) {
        return function(b) {
          return b == null ? !1 : b[u] === h && (h !== n || u in Mt(b));
        };
      }
      function jV(u) {
        var h = wh(u, function(T) {
          return b.size === c && b.clear(), T;
        }), b = h.cache;
        return h;
      }
      function LV(u, h) {
        var b = u[1], T = h[1], M = b | T, B = M < (v | x | P), H = T == P && b == S || T == P && b == C && u[7].length <= h[8] || T == (P | C) && h[7].length <= h[8] && b == S;
        if (!(B || H))
          return u;
        T & v && (u[2] = h[2], M |= b & v ? 0 : w);
        var q = h[3];
        if (q) {
          var Q = u[3];
          u[3] = Q ? sA(Q, q, h[4]) : q, u[4] = Q ? oa(u[3], f) : h[4];
        }
        return q = h[5], q && (Q = u[5], u[5] = Q ? lA(Q, q, h[6]) : q, u[6] = Q ? oa(u[5], f) : h[6]), q = h[7], q && (u[7] = q), T & P && (u[8] = u[8] == null ? h[8] : Zn(u[8], h[8])), u[9] == null && (u[9] = h[9]), u[0] = h[0], u[1] = M, u;
      }
      function BV(u) {
        var h = [];
        if (u != null)
          for (var b in Mt(u))
            h.push(b);
        return h;
      }
      function FV(u) {
        return Gd.call(u);
      }
      function TA(u, h, b) {
        return h = bn(h === n ? u.length - 1 : h, 0), function() {
          for (var T = arguments, M = -1, B = bn(T.length - h, 0), H = oe(B); ++M < B; )
            H[M] = T[h + M];
          M = -1;
          for (var q = oe(h + 1); ++M < h; )
            q[M] = T[M];
          return q[h] = b(H), Cr(u, this, q);
        };
      }
      function PA(u, h) {
        return h.length < 2 ? u : ts(u, ni(h, 0, -1));
      }
      function WV(u, h) {
        for (var b = u.length, T = Zn(h.length, b), M = gr(u); T--; ) {
          var B = h[T];
          u[T] = po(B, b) ? M[B] : n;
        }
        return u;
      }
      function Av(u, h) {
        if (!(h === "constructor" && typeof u[h] == "function") && h != "__proto__")
          return u[h];
      }
      var CA = kA(ZO), gu = n3 || function(u, h) {
        return Ln.setTimeout(u, h);
      }, Tv = kA(uV);
      function EA(u, h, b) {
        var T = h + "";
        return Tv(u, NV(T, zV(EV(T), b)));
      }
      function kA(u) {
        var h = 0, b = 0;
        return function() {
          var T = a3(), M = R - (T - b);
          if (b = T, M > 0) {
            if (++h >= N)
              return arguments[0];
          } else
            h = 0;
          return u.apply(n, arguments);
        };
      }
      function yh(u, h) {
        var b = -1, T = u.length, M = T - 1;
        for (h = h === n ? T : h; ++b < h; ) {
          var B = lv(b, M), H = u[B];
          u[B] = u[b], u[b] = H;
        }
        return u.length = h, u;
      }
      var MA = jV(function(u) {
        var h = [];
        return u.charCodeAt(0) === 46 && h.push(""), u.replace(Mz, function(b, T, M, B) {
          h.push(M ? B.replace(Bz, "$1") : T || b);
        }), h;
      });
      function Li(u) {
        if (typeof u == "string" || Mr(u))
          return u;
        var h = u + "";
        return h == "0" && 1 / u == -z ? "-0" : h;
      }
      function rs(u) {
        if (u != null) {
          try {
            return Kd.call(u);
          } catch {
          }
          try {
            return u + "";
          } catch {
          }
        }
        return "";
      }
      function zV(u, h) {
        return Jr(re, function(b) {
          var T = "_." + b[0];
          h & b[1] && !Wd(u, T) && u.push(T);
        }), u.sort();
      }
      function NA(u) {
        if (u instanceof ct)
          return u.clone();
        var h = new ei(u.__wrapped__, u.__chain__);
        return h.__actions__ = gr(u.__actions__), h.__index__ = u.__index__, h.__values__ = u.__values__, h;
      }
      function VV(u, h, b) {
        (b ? ar(u, h, b) : h === n) ? h = 1 : h = bn(Ze(h), 0);
        var T = u == null ? 0 : u.length;
        if (!T || h < 1)
          return [];
        for (var M = 0, B = 0, H = oe(Qd(T / h)); M < T; )
          H[B++] = ni(u, M, M += h);
        return H;
      }
      function UV(u) {
        for (var h = -1, b = u == null ? 0 : u.length, T = 0, M = []; ++h < b; ) {
          var B = u[h];
          B && (M[T++] = B);
        }
        return M;
      }
      function HV() {
        var u = arguments.length;
        if (!u)
          return [];
        for (var h = oe(u - 1), b = arguments[0], T = u; T--; )
          h[T - 1] = arguments[T];
        return ia(Ge(b) ? gr(b) : [b], Bn(h, 1));
      }
      var KV = nt(function(u, h) {
        return an(u) ? uu(u, Bn(h, 1, an, !0)) : [];
      }), GV = nt(function(u, h) {
        var b = ri(h);
        return an(b) && (b = n), an(u) ? uu(u, Bn(h, 1, an, !0), $e(b, 2)) : [];
      }), YV = nt(function(u, h) {
        var b = ri(h);
        return an(b) && (b = n), an(u) ? uu(u, Bn(h, 1, an, !0), n, b) : [];
      });
      function qV(u, h, b) {
        var T = u == null ? 0 : u.length;
        return T ? (h = b || h === n ? 1 : Ze(h), ni(u, h < 0 ? 0 : h, T)) : [];
      }
      function XV(u, h, b) {
        var T = u == null ? 0 : u.length;
        return T ? (h = b || h === n ? 1 : Ze(h), h = T - h, ni(u, 0, h < 0 ? 0 : h)) : [];
      }
      function ZV(u, h) {
        return u && u.length ? ch(u, $e(h, 3), !0, !0) : [];
      }
      function JV(u, h) {
        return u && u.length ? ch(u, $e(h, 3), !0) : [];
      }
      function QV(u, h, b, T) {
        var M = u == null ? 0 : u.length;
        return M ? (b && typeof b != "number" && ar(u, h, b) && (b = 0, T = M), H3(u, h, b, T)) : [];
      }
      function $A(u, h, b) {
        var T = u == null ? 0 : u.length;
        if (!T)
          return -1;
        var M = b == null ? 0 : Ze(b);
        return M < 0 && (M = bn(T + M, 0)), zd(u, $e(h, 3), M);
      }
      function DA(u, h, b) {
        var T = u == null ? 0 : u.length;
        if (!T)
          return -1;
        var M = T - 1;
        return b !== n && (M = Ze(b), M = b < 0 ? bn(T + M, 0) : Zn(M, T - 1)), zd(u, $e(h, 3), M, !0);
      }
      function IA(u) {
        var h = u == null ? 0 : u.length;
        return h ? Bn(u, 1) : [];
      }
      function e4(u) {
        var h = u == null ? 0 : u.length;
        return h ? Bn(u, z) : [];
      }
      function t4(u, h) {
        var b = u == null ? 0 : u.length;
        return b ? (h = h === n ? 1 : Ze(h), Bn(u, h)) : [];
      }
      function n4(u) {
        for (var h = -1, b = u == null ? 0 : u.length, T = {}; ++h < b; ) {
          var M = u[h];
          T[M[0]] = M[1];
        }
        return T;
      }
      function RA(u) {
        return u && u.length ? u[0] : n;
      }
      function r4(u, h, b) {
        var T = u == null ? 0 : u.length;
        if (!T)
          return -1;
        var M = b == null ? 0 : Ze(b);
        return M < 0 && (M = bn(T + M, 0)), ol(u, h, M);
      }
      function i4(u) {
        var h = u == null ? 0 : u.length;
        return h ? ni(u, 0, -1) : [];
      }
      var o4 = nt(function(u) {
        var h = Gt(u, hv);
        return h.length && h[0] === u[0] ? rv(h) : [];
      }), a4 = nt(function(u) {
        var h = ri(u), b = Gt(u, hv);
        return h === ri(b) ? h = n : b.pop(), b.length && b[0] === u[0] ? rv(b, $e(h, 2)) : [];
      }), s4 = nt(function(u) {
        var h = ri(u), b = Gt(u, hv);
        return h = typeof h == "function" ? h : n, h && b.pop(), b.length && b[0] === u[0] ? rv(b, n, h) : [];
      });
      function l4(u, h) {
        return u == null ? "" : i3.call(u, h);
      }
      function ri(u) {
        var h = u == null ? 0 : u.length;
        return h ? u[h - 1] : n;
      }
      function c4(u, h, b) {
        var T = u == null ? 0 : u.length;
        if (!T)
          return -1;
        var M = T;
        return b !== n && (M = Ze(b), M = M < 0 ? bn(T + M, 0) : Zn(M, T - 1)), h === h ? z5(u, h, M) : zd(u, gO, M, !0);
      }
      function u4(u, h) {
        return u && u.length ? GO(u, Ze(h)) : n;
      }
      var f4 = nt(jA);
      function jA(u, h) {
        return u && u.length && h && h.length ? sv(u, h) : u;
      }
      function d4(u, h, b) {
        return u && u.length && h && h.length ? sv(u, h, $e(b, 2)) : u;
      }
      function h4(u, h, b) {
        return u && u.length && h && h.length ? sv(u, h, n, b) : u;
      }
      var p4 = ho(function(u, h) {
        var b = u == null ? 0 : u.length, T = Qy(u, h);
        return XO(u, Gt(h, function(M) {
          return po(M, b) ? +M : M;
        }).sort(aA)), T;
      });
      function m4(u, h) {
        var b = [];
        if (!(u && u.length))
          return b;
        var T = -1, M = [], B = u.length;
        for (h = $e(h, 3); ++T < B; ) {
          var H = u[T];
          h(H, T, u) && (b.push(H), M.push(T));
        }
        return XO(u, M), b;
      }
      function Pv(u) {
        return u == null ? u : l3.call(u);
      }
      function g4(u, h, b) {
        var T = u == null ? 0 : u.length;
        return T ? (b && typeof b != "number" && ar(u, h, b) ? (h = 0, b = T) : (h = h == null ? 0 : Ze(h), b = b === n ? T : Ze(b)), ni(u, h, b)) : [];
      }
      function y4(u, h) {
        return lh(u, h);
      }
      function v4(u, h, b) {
        return uv(u, h, $e(b, 2));
      }
      function b4(u, h) {
        var b = u == null ? 0 : u.length;
        if (b) {
          var T = lh(u, h);
          if (T < b && vi(u[T], h))
            return T;
        }
        return -1;
      }
      function x4(u, h) {
        return lh(u, h, !0);
      }
      function w4(u, h, b) {
        return uv(u, h, $e(b, 2), !0);
      }
      function _4(u, h) {
        var b = u == null ? 0 : u.length;
        if (b) {
          var T = lh(u, h, !0) - 1;
          if (vi(u[T], h))
            return T;
        }
        return -1;
      }
      function S4(u) {
        return u && u.length ? JO(u) : [];
      }
      function O4(u, h) {
        return u && u.length ? JO(u, $e(h, 2)) : [];
      }
      function A4(u) {
        var h = u == null ? 0 : u.length;
        return h ? ni(u, 1, h) : [];
      }
      function T4(u, h, b) {
        return u && u.length ? (h = b || h === n ? 1 : Ze(h), ni(u, 0, h < 0 ? 0 : h)) : [];
      }
      function P4(u, h, b) {
        var T = u == null ? 0 : u.length;
        return T ? (h = b || h === n ? 1 : Ze(h), h = T - h, ni(u, h < 0 ? 0 : h, T)) : [];
      }
      function C4(u, h) {
        return u && u.length ? ch(u, $e(h, 3), !1, !0) : [];
      }
      function E4(u, h) {
        return u && u.length ? ch(u, $e(h, 3)) : [];
      }
      var k4 = nt(function(u) {
        return la(Bn(u, 1, an, !0));
      }), M4 = nt(function(u) {
        var h = ri(u);
        return an(h) && (h = n), la(Bn(u, 1, an, !0), $e(h, 2));
      }), N4 = nt(function(u) {
        var h = ri(u);
        return h = typeof h == "function" ? h : n, la(Bn(u, 1, an, !0), n, h);
      });
      function $4(u) {
        return u && u.length ? la(u) : [];
      }
      function D4(u, h) {
        return u && u.length ? la(u, $e(h, 2)) : [];
      }
      function I4(u, h) {
        return h = typeof h == "function" ? h : n, u && u.length ? la(u, n, h) : [];
      }
      function Cv(u) {
        if (!(u && u.length))
          return [];
        var h = 0;
        return u = ra(u, function(b) {
          if (an(b))
            return h = bn(b.length, h), !0;
        }), Hy(h, function(b) {
          return Gt(u, zy(b));
        });
      }
      function LA(u, h) {
        if (!(u && u.length))
          return [];
        var b = Cv(u);
        return h == null ? b : Gt(b, function(T) {
          return Cr(h, n, T);
        });
      }
      var R4 = nt(function(u, h) {
        return an(u) ? uu(u, h) : [];
      }), j4 = nt(function(u) {
        return dv(ra(u, an));
      }), L4 = nt(function(u) {
        var h = ri(u);
        return an(h) && (h = n), dv(ra(u, an), $e(h, 2));
      }), B4 = nt(function(u) {
        var h = ri(u);
        return h = typeof h == "function" ? h : n, dv(ra(u, an), n, h);
      }), F4 = nt(Cv);
      function W4(u, h) {
        return nA(u || [], h || [], cu);
      }
      function z4(u, h) {
        return nA(u || [], h || [], hu);
      }
      var V4 = nt(function(u) {
        var h = u.length, b = h > 1 ? u[h - 1] : n;
        return b = typeof b == "function" ? (u.pop(), b) : n, LA(u, b);
      });
      function BA(u) {
        var h = j(u);
        return h.__chain__ = !0, h;
      }
      function U4(u, h) {
        return h(u), u;
      }
      function vh(u, h) {
        return h(u);
      }
      var H4 = ho(function(u) {
        var h = u.length, b = h ? u[0] : 0, T = this.__wrapped__, M = function(B) {
          return Qy(B, u);
        };
        return h > 1 || this.__actions__.length || !(T instanceof ct) || !po(b) ? this.thru(M) : (T = T.slice(b, +b + (h ? 1 : 0)), T.__actions__.push({
          func: vh,
          args: [M],
          thisArg: n
        }), new ei(T, this.__chain__).thru(function(B) {
          return h && !B.length && B.push(n), B;
        }));
      });
      function K4() {
        return BA(this);
      }
      function G4() {
        return new ei(this.value(), this.__chain__);
      }
      function Y4() {
        this.__values__ === n && (this.__values__ = QA(this.value()));
        var u = this.__index__ >= this.__values__.length, h = u ? n : this.__values__[this.__index__++];
        return { done: u, value: h };
      }
      function q4() {
        return this;
      }
      function X4(u) {
        for (var h, b = this; b instanceof rh; ) {
          var T = NA(b);
          T.__index__ = 0, T.__values__ = n, h ? M.__wrapped__ = T : h = T;
          var M = T;
          b = b.__wrapped__;
        }
        return M.__wrapped__ = u, h;
      }
      function Z4() {
        var u = this.__wrapped__;
        if (u instanceof ct) {
          var h = u;
          return this.__actions__.length && (h = new ct(this)), h = h.reverse(), h.__actions__.push({
            func: vh,
            args: [Pv],
            thisArg: n
          }), new ei(h, this.__chain__);
        }
        return this.thru(Pv);
      }
      function J4() {
        return tA(this.__wrapped__, this.__actions__);
      }
      var Q4 = uh(function(u, h, b) {
        Ot.call(u, b) ? ++u[b] : uo(u, b, 1);
      });
      function eU(u, h, b) {
        var T = Ge(u) ? pO : U3;
        return b && ar(u, h, b) && (h = n), T(u, $e(h, 3));
      }
      function tU(u, h) {
        var b = Ge(u) ? ra : LO;
        return b(u, $e(h, 3));
      }
      var nU = dA($A), rU = dA(DA);
      function iU(u, h) {
        return Bn(bh(u, h), 1);
      }
      function oU(u, h) {
        return Bn(bh(u, h), z);
      }
      function aU(u, h, b) {
        return b = b === n ? 1 : Ze(b), Bn(bh(u, h), b);
      }
      function FA(u, h) {
        var b = Ge(u) ? Jr : sa;
        return b(u, $e(h, 3));
      }
      function WA(u, h) {
        var b = Ge(u) ? A5 : jO;
        return b(u, $e(h, 3));
      }
      var sU = uh(function(u, h, b) {
        Ot.call(u, b) ? u[b].push(h) : uo(u, b, [h]);
      });
      function lU(u, h, b, T) {
        u = yr(u) ? u : yl(u), b = b && !T ? Ze(b) : 0;
        var M = u.length;
        return b < 0 && (b = bn(M + b, 0)), Oh(u) ? b <= M && u.indexOf(h, b) > -1 : !!M && ol(u, h, b) > -1;
      }
      var cU = nt(function(u, h, b) {
        var T = -1, M = typeof h == "function", B = yr(u) ? oe(u.length) : [];
        return sa(u, function(H) {
          B[++T] = M ? Cr(h, H, b) : fu(H, h, b);
        }), B;
      }), uU = uh(function(u, h, b) {
        uo(u, b, h);
      });
      function bh(u, h) {
        var b = Ge(u) ? Gt : UO;
        return b(u, $e(h, 3));
      }
      function fU(u, h, b, T) {
        return u == null ? [] : (Ge(h) || (h = h == null ? [] : [h]), b = T ? n : b, Ge(b) || (b = b == null ? [] : [b]), YO(u, h, b));
      }
      var dU = uh(function(u, h, b) {
        u[b ? 0 : 1].push(h);
      }, function() {
        return [[], []];
      });
      function hU(u, h, b) {
        var T = Ge(u) ? Fy : vO, M = arguments.length < 3;
        return T(u, $e(h, 4), b, M, sa);
      }
      function pU(u, h, b) {
        var T = Ge(u) ? T5 : vO, M = arguments.length < 3;
        return T(u, $e(h, 4), b, M, jO);
      }
      function mU(u, h) {
        var b = Ge(u) ? ra : LO;
        return b(u, _h($e(h, 3)));
      }
      function gU(u) {
        var h = Ge(u) ? $O : lV;
        return h(u);
      }
      function yU(u, h, b) {
        (b ? ar(u, h, b) : h === n) ? h = 1 : h = Ze(h);
        var T = Ge(u) ? B3 : cV;
        return T(u, h);
      }
      function vU(u) {
        var h = Ge(u) ? F3 : fV;
        return h(u);
      }
      function bU(u) {
        if (u == null)
          return 0;
        if (yr(u))
          return Oh(u) ? sl(u) : u.length;
        var h = Jn(u);
        return h == pe || h == Oe ? u.size : ov(u).length;
      }
      function xU(u, h, b) {
        var T = Ge(u) ? Wy : dV;
        return b && ar(u, h, b) && (h = n), T(u, $e(h, 3));
      }
      var wU = nt(function(u, h) {
        if (u == null)
          return [];
        var b = h.length;
        return b > 1 && ar(u, h[0], h[1]) ? h = [] : b > 2 && ar(h[0], h[1], h[2]) && (h = [h[0]]), YO(u, Bn(h, 1), []);
      }), xh = t3 || function() {
        return Ln.Date.now();
      };
      function _U(u, h) {
        if (typeof h != "function")
          throw new Qr(a);
        return u = Ze(u), function() {
          if (--u < 1)
            return h.apply(this, arguments);
        };
      }
      function zA(u, h, b) {
        return h = b ? n : h, h = u && h == null ? u.length : h, fo(u, P, n, n, n, n, h);
      }
      function VA(u, h) {
        var b;
        if (typeof h != "function")
          throw new Qr(a);
        return u = Ze(u), function() {
          return --u > 0 && (b = h.apply(this, arguments)), u <= 1 && (h = n), b;
        };
      }
      var Ev = nt(function(u, h, b) {
        var T = v;
        if (b.length) {
          var M = oa(b, ml(Ev));
          T |= _;
        }
        return fo(u, T, h, b, M);
      }), UA = nt(function(u, h, b) {
        var T = v | x;
        if (b.length) {
          var M = oa(b, ml(UA));
          T |= _;
        }
        return fo(h, T, u, b, M);
      });
      function HA(u, h, b) {
        h = b ? n : h;
        var T = fo(u, S, n, n, n, n, n, h);
        return T.placeholder = HA.placeholder, T;
      }
      function KA(u, h, b) {
        h = b ? n : h;
        var T = fo(u, A, n, n, n, n, n, h);
        return T.placeholder = KA.placeholder, T;
      }
      function GA(u, h, b) {
        var T, M, B, H, q, Q, de = 0, me = !1, ge = !1, xe = !0;
        if (typeof u != "function")
          throw new Qr(a);
        h = ii(h) || 0, Jt(b) && (me = !!b.leading, ge = "maxWait" in b, B = ge ? bn(ii(b.maxWait) || 0, h) : B, xe = "trailing" in b ? !!b.trailing : xe);
        function Ce(sn) {
          var bi = T, yo = M;
          return T = M = n, de = sn, H = u.apply(yo, bi), H;
        }
        function Re(sn) {
          return de = sn, q = gu(ot, h), me ? Ce(sn) : H;
        }
        function et(sn) {
          var bi = sn - Q, yo = sn - de, dT = h - bi;
          return ge ? Zn(dT, B - yo) : dT;
        }
        function je(sn) {
          var bi = sn - Q, yo = sn - de;
          return Q === n || bi >= h || bi < 0 || ge && yo >= B;
        }
        function ot() {
          var sn = xh();
          if (je(sn))
            return ft(sn);
          q = gu(ot, et(sn));
        }
        function ft(sn) {
          return q = n, xe && T ? Ce(sn) : (T = M = n, H);
        }
        function Nr() {
          q !== n && rA(q), de = 0, T = Q = M = q = n;
        }
        function sr() {
          return q === n ? H : ft(xh());
        }
        function $r() {
          var sn = xh(), bi = je(sn);
          if (T = arguments, M = this, Q = sn, bi) {
            if (q === n)
              return Re(Q);
            if (ge)
              return rA(q), q = gu(ot, h), Ce(Q);
          }
          return q === n && (q = gu(ot, h)), H;
        }
        return $r.cancel = Nr, $r.flush = sr, $r;
      }
      var SU = nt(function(u, h) {
        return RO(u, 1, h);
      }), OU = nt(function(u, h, b) {
        return RO(u, ii(h) || 0, b);
      });
      function AU(u) {
        return fo(u, k);
      }
      function wh(u, h) {
        if (typeof u != "function" || h != null && typeof h != "function")
          throw new Qr(a);
        var b = function() {
          var T = arguments, M = h ? h.apply(this, T) : T[0], B = b.cache;
          if (B.has(M))
            return B.get(M);
          var H = u.apply(this, T);
          return b.cache = B.set(M, H) || B, H;
        };
        return b.cache = new (wh.Cache || co)(), b;
      }
      wh.Cache = co;
      function _h(u) {
        if (typeof u != "function")
          throw new Qr(a);
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return !u.call(this);
            case 1:
              return !u.call(this, h[0]);
            case 2:
              return !u.call(this, h[0], h[1]);
            case 3:
              return !u.call(this, h[0], h[1], h[2]);
          }
          return !u.apply(this, h);
        };
      }
      function TU(u) {
        return VA(2, u);
      }
      var PU = hV(function(u, h) {
        h = h.length == 1 && Ge(h[0]) ? Gt(h[0], Er($e())) : Gt(Bn(h, 1), Er($e()));
        var b = h.length;
        return nt(function(T) {
          for (var M = -1, B = Zn(T.length, b); ++M < B; )
            T[M] = h[M].call(this, T[M]);
          return Cr(u, this, T);
        });
      }), kv = nt(function(u, h) {
        var b = oa(h, ml(kv));
        return fo(u, _, n, h, b);
      }), YA = nt(function(u, h) {
        var b = oa(h, ml(YA));
        return fo(u, O, n, h, b);
      }), CU = ho(function(u, h) {
        return fo(u, C, n, n, n, h);
      });
      function EU(u, h) {
        if (typeof u != "function")
          throw new Qr(a);
        return h = h === n ? h : Ze(h), nt(u, h);
      }
      function kU(u, h) {
        if (typeof u != "function")
          throw new Qr(a);
        return h = h == null ? 0 : bn(Ze(h), 0), nt(function(b) {
          var T = b[h], M = ua(b, 0, h);
          return T && ia(M, T), Cr(u, this, M);
        });
      }
      function MU(u, h, b) {
        var T = !0, M = !0;
        if (typeof u != "function")
          throw new Qr(a);
        return Jt(b) && (T = "leading" in b ? !!b.leading : T, M = "trailing" in b ? !!b.trailing : M), GA(u, h, {
          leading: T,
          maxWait: h,
          trailing: M
        });
      }
      function NU(u) {
        return zA(u, 1);
      }
      function $U(u, h) {
        return kv(pv(h), u);
      }
      function DU() {
        if (!arguments.length)
          return [];
        var u = arguments[0];
        return Ge(u) ? u : [u];
      }
      function IU(u) {
        return ti(u, m);
      }
      function RU(u, h) {
        return h = typeof h == "function" ? h : n, ti(u, m, h);
      }
      function jU(u) {
        return ti(u, d | m);
      }
      function LU(u, h) {
        return h = typeof h == "function" ? h : n, ti(u, d | m, h);
      }
      function BU(u, h) {
        return h == null || IO(u, h, En(h));
      }
      function vi(u, h) {
        return u === h || u !== u && h !== h;
      }
      var FU = ph(nv), WU = ph(function(u, h) {
        return u >= h;
      }), is = WO(/* @__PURE__ */ function() {
        return arguments;
      }()) ? WO : function(u) {
        return tn(u) && Ot.call(u, "callee") && !PO.call(u, "callee");
      }, Ge = oe.isArray, zU = lO ? Er(lO) : X3;
      function yr(u) {
        return u != null && Sh(u.length) && !mo(u);
      }
      function an(u) {
        return tn(u) && yr(u);
      }
      function VU(u) {
        return u === !0 || u === !1 || tn(u) && or(u) == ne;
      }
      var fa = r3 || Wv, UU = cO ? Er(cO) : Z3;
      function HU(u) {
        return tn(u) && u.nodeType === 1 && !yu(u);
      }
      function KU(u) {
        if (u == null)
          return !0;
        if (yr(u) && (Ge(u) || typeof u == "string" || typeof u.splice == "function" || fa(u) || gl(u) || is(u)))
          return !u.length;
        var h = Jn(u);
        if (h == pe || h == Oe)
          return !u.size;
        if (mu(u))
          return !ov(u).length;
        for (var b in u)
          if (Ot.call(u, b))
            return !1;
        return !0;
      }
      function GU(u, h) {
        return du(u, h);
      }
      function YU(u, h, b) {
        b = typeof b == "function" ? b : n;
        var T = b ? b(u, h) : n;
        return T === n ? du(u, h, n, b) : !!T;
      }
      function Mv(u) {
        if (!tn(u))
          return !1;
        var h = or(u);
        return h == be || h == fe || typeof u.message == "string" && typeof u.name == "string" && !yu(u);
      }
      function qU(u) {
        return typeof u == "number" && EO(u);
      }
      function mo(u) {
        if (!Jt(u))
          return !1;
        var h = or(u);
        return h == X || h == De || h == ue || h == Ie;
      }
      function qA(u) {
        return typeof u == "number" && u == Ze(u);
      }
      function Sh(u) {
        return typeof u == "number" && u > -1 && u % 1 == 0 && u <= G;
      }
      function Jt(u) {
        var h = typeof u;
        return u != null && (h == "object" || h == "function");
      }
      function tn(u) {
        return u != null && typeof u == "object";
      }
      var XA = uO ? Er(uO) : Q3;
      function XU(u, h) {
        return u === h || iv(u, h, wv(h));
      }
      function ZU(u, h, b) {
        return b = typeof b == "function" ? b : n, iv(u, h, wv(h), b);
      }
      function JU(u) {
        return ZA(u) && u != +u;
      }
      function QU(u) {
        if (RV(u))
          throw new He(o);
        return zO(u);
      }
      function e6(u) {
        return u === null;
      }
      function t6(u) {
        return u == null;
      }
      function ZA(u) {
        return typeof u == "number" || tn(u) && or(u) == ke;
      }
      function yu(u) {
        if (!tn(u) || or(u) != st)
          return !1;
        var h = Xd(u);
        if (h === null)
          return !0;
        var b = Ot.call(h, "constructor") && h.constructor;
        return typeof b == "function" && b instanceof b && Kd.call(b) == Z5;
      }
      var Nv = fO ? Er(fO) : eV;
      function n6(u) {
        return qA(u) && u >= -G && u <= G;
      }
      var JA = dO ? Er(dO) : tV;
      function Oh(u) {
        return typeof u == "string" || !Ge(u) && tn(u) && or(u) == Ke;
      }
      function Mr(u) {
        return typeof u == "symbol" || tn(u) && or(u) == Zt;
      }
      var gl = hO ? Er(hO) : nV;
      function r6(u) {
        return u === n;
      }
      function i6(u) {
        return tn(u) && Jn(u) == en;
      }
      function o6(u) {
        return tn(u) && or(u) == Yr;
      }
      var a6 = ph(av), s6 = ph(function(u, h) {
        return u <= h;
      });
      function QA(u) {
        if (!u)
          return [];
        if (yr(u))
          return Oh(u) ? gi(u) : gr(u);
        if (iu && u[iu])
          return B5(u[iu]());
        var h = Jn(u), b = h == pe ? Gy : h == Oe ? Vd : yl;
        return b(u);
      }
      function go(u) {
        if (!u)
          return u === 0 ? u : 0;
        if (u = ii(u), u === z || u === -z) {
          var h = u < 0 ? -1 : 1;
          return h * U;
        }
        return u === u ? u : 0;
      }
      function Ze(u) {
        var h = go(u), b = h % 1;
        return h === h ? b ? h - b : h : 0;
      }
      function eT(u) {
        return u ? es(Ze(u), 0, Y) : 0;
      }
      function ii(u) {
        if (typeof u == "number")
          return u;
        if (Mr(u))
          return V;
        if (Jt(u)) {
          var h = typeof u.valueOf == "function" ? u.valueOf() : u;
          u = Jt(h) ? h + "" : h;
        }
        if (typeof u != "string")
          return u === 0 ? u : +u;
        u = bO(u);
        var b = zz.test(u);
        return b || Uz.test(u) ? _5(u.slice(2), b ? 2 : 8) : Wz.test(u) ? V : +u;
      }
      function tT(u) {
        return ji(u, vr(u));
      }
      function l6(u) {
        return u ? es(Ze(u), -G, G) : u === 0 ? u : 0;
      }
      function vt(u) {
        return u == null ? "" : kr(u);
      }
      var c6 = hl(function(u, h) {
        if (mu(h) || yr(h)) {
          ji(h, En(h), u);
          return;
        }
        for (var b in h)
          Ot.call(h, b) && cu(u, b, h[b]);
      }), nT = hl(function(u, h) {
        ji(h, vr(h), u);
      }), Ah = hl(function(u, h, b, T) {
        ji(h, vr(h), u, T);
      }), u6 = hl(function(u, h, b, T) {
        ji(h, En(h), u, T);
      }), f6 = ho(Qy);
      function d6(u, h) {
        var b = dl(u);
        return h == null ? b : DO(b, h);
      }
      var h6 = nt(function(u, h) {
        u = Mt(u);
        var b = -1, T = h.length, M = T > 2 ? h[2] : n;
        for (M && ar(h[0], h[1], M) && (T = 1); ++b < T; )
          for (var B = h[b], H = vr(B), q = -1, Q = H.length; ++q < Q; ) {
            var de = H[q], me = u[de];
            (me === n || vi(me, cl[de]) && !Ot.call(u, de)) && (u[de] = B[de]);
          }
        return u;
      }), p6 = nt(function(u) {
        return u.push(n, bA), Cr(rT, n, u);
      });
      function m6(u, h) {
        return mO(u, $e(h, 3), Ri);
      }
      function g6(u, h) {
        return mO(u, $e(h, 3), tv);
      }
      function y6(u, h) {
        return u == null ? u : ev(u, $e(h, 3), vr);
      }
      function v6(u, h) {
        return u == null ? u : BO(u, $e(h, 3), vr);
      }
      function b6(u, h) {
        return u && Ri(u, $e(h, 3));
      }
      function x6(u, h) {
        return u && tv(u, $e(h, 3));
      }
      function w6(u) {
        return u == null ? [] : ah(u, En(u));
      }
      function _6(u) {
        return u == null ? [] : ah(u, vr(u));
      }
      function $v(u, h, b) {
        var T = u == null ? n : ts(u, h);
        return T === n ? b : T;
      }
      function S6(u, h) {
        return u != null && _A(u, h, K3);
      }
      function Dv(u, h) {
        return u != null && _A(u, h, G3);
      }
      var O6 = pA(function(u, h, b) {
        h != null && typeof h.toString != "function" && (h = Gd.call(h)), u[h] = b;
      }, Rv(br)), A6 = pA(function(u, h, b) {
        h != null && typeof h.toString != "function" && (h = Gd.call(h)), Ot.call(u, h) ? u[h].push(b) : u[h] = [b];
      }, $e), T6 = nt(fu);
      function En(u) {
        return yr(u) ? NO(u) : ov(u);
      }
      function vr(u) {
        return yr(u) ? NO(u, !0) : rV(u);
      }
      function P6(u, h) {
        var b = {};
        return h = $e(h, 3), Ri(u, function(T, M, B) {
          uo(b, h(T, M, B), T);
        }), b;
      }
      function C6(u, h) {
        var b = {};
        return h = $e(h, 3), Ri(u, function(T, M, B) {
          uo(b, M, h(T, M, B));
        }), b;
      }
      var E6 = hl(function(u, h, b) {
        sh(u, h, b);
      }), rT = hl(function(u, h, b, T) {
        sh(u, h, b, T);
      }), k6 = ho(function(u, h) {
        var b = {};
        if (u == null)
          return b;
        var T = !1;
        h = Gt(h, function(B) {
          return B = ca(B, u), T || (T = B.length > 1), B;
        }), ji(u, bv(u), b), T && (b = ti(b, d | p | m, OV));
        for (var M = h.length; M--; )
          fv(b, h[M]);
        return b;
      });
      function M6(u, h) {
        return iT(u, _h($e(h)));
      }
      var N6 = ho(function(u, h) {
        return u == null ? {} : oV(u, h);
      });
      function iT(u, h) {
        if (u == null)
          return {};
        var b = Gt(bv(u), function(T) {
          return [T];
        });
        return h = $e(h), qO(u, b, function(T, M) {
          return h(T, M[0]);
        });
      }
      function $6(u, h, b) {
        h = ca(h, u);
        var T = -1, M = h.length;
        for (M || (M = 1, u = n); ++T < M; ) {
          var B = u == null ? n : u[Li(h[T])];
          B === n && (T = M, B = b), u = mo(B) ? B.call(u) : B;
        }
        return u;
      }
      function D6(u, h, b) {
        return u == null ? u : hu(u, h, b);
      }
      function I6(u, h, b, T) {
        return T = typeof T == "function" ? T : n, u == null ? u : hu(u, h, b, T);
      }
      var oT = yA(En), aT = yA(vr);
      function R6(u, h, b) {
        var T = Ge(u), M = T || fa(u) || gl(u);
        if (h = $e(h, 4), b == null) {
          var B = u && u.constructor;
          M ? b = T ? new B() : [] : Jt(u) ? b = mo(B) ? dl(Xd(u)) : {} : b = {};
        }
        return (M ? Jr : Ri)(u, function(H, q, Q) {
          return h(b, H, q, Q);
        }), b;
      }
      function j6(u, h) {
        return u == null ? !0 : fv(u, h);
      }
      function L6(u, h, b) {
        return u == null ? u : eA(u, h, pv(b));
      }
      function B6(u, h, b, T) {
        return T = typeof T == "function" ? T : n, u == null ? u : eA(u, h, pv(b), T);
      }
      function yl(u) {
        return u == null ? [] : Ky(u, En(u));
      }
      function F6(u) {
        return u == null ? [] : Ky(u, vr(u));
      }
      function W6(u, h, b) {
        return b === n && (b = h, h = n), b !== n && (b = ii(b), b = b === b ? b : 0), h !== n && (h = ii(h), h = h === h ? h : 0), es(ii(u), h, b);
      }
      function z6(u, h, b) {
        return h = go(h), b === n ? (b = h, h = 0) : b = go(b), u = ii(u), Y3(u, h, b);
      }
      function V6(u, h, b) {
        if (b && typeof b != "boolean" && ar(u, h, b) && (h = b = n), b === n && (typeof h == "boolean" ? (b = h, h = n) : typeof u == "boolean" && (b = u, u = n)), u === n && h === n ? (u = 0, h = 1) : (u = go(u), h === n ? (h = u, u = 0) : h = go(h)), u > h) {
          var T = u;
          u = h, h = T;
        }
        if (b || u % 1 || h % 1) {
          var M = kO();
          return Zn(u + M * (h - u + w5("1e-" + ((M + "").length - 1))), h);
        }
        return lv(u, h);
      }
      var U6 = pl(function(u, h, b) {
        return h = h.toLowerCase(), u + (b ? sT(h) : h);
      });
      function sT(u) {
        return Iv(vt(u).toLowerCase());
      }
      function lT(u) {
        return u = vt(u), u && u.replace(Kz, D5).replace(f5, "");
      }
      function H6(u, h, b) {
        u = vt(u), h = kr(h);
        var T = u.length;
        b = b === n ? T : es(Ze(b), 0, T);
        var M = b;
        return b -= h.length, b >= 0 && u.slice(b, M) == h;
      }
      function K6(u) {
        return u = vt(u), u && tu.test(u) ? u.replace(jd, I5) : u;
      }
      function G6(u) {
        return u = vt(u), u && Nz.test(u) ? u.replace(ky, "\\$&") : u;
      }
      var Y6 = pl(function(u, h, b) {
        return u + (b ? "-" : "") + h.toLowerCase();
      }), q6 = pl(function(u, h, b) {
        return u + (b ? " " : "") + h.toLowerCase();
      }), X6 = fA("toLowerCase");
      function Z6(u, h, b) {
        u = vt(u), h = Ze(h);
        var T = h ? sl(u) : 0;
        if (!h || T >= h)
          return u;
        var M = (h - T) / 2;
        return hh(eh(M), b) + u + hh(Qd(M), b);
      }
      function J6(u, h, b) {
        u = vt(u), h = Ze(h);
        var T = h ? sl(u) : 0;
        return h && T < h ? u + hh(h - T, b) : u;
      }
      function Q6(u, h, b) {
        u = vt(u), h = Ze(h);
        var T = h ? sl(u) : 0;
        return h && T < h ? hh(h - T, b) + u : u;
      }
      function e8(u, h, b) {
        return b || h == null ? h = 0 : h && (h = +h), s3(vt(u).replace(My, ""), h || 0);
      }
      function t8(u, h, b) {
        return (b ? ar(u, h, b) : h === n) ? h = 1 : h = Ze(h), cv(vt(u), h);
      }
      function n8() {
        var u = arguments, h = vt(u[0]);
        return u.length < 3 ? h : h.replace(u[1], u[2]);
      }
      var r8 = pl(function(u, h, b) {
        return u + (b ? "_" : "") + h.toLowerCase();
      });
      function i8(u, h, b) {
        return b && typeof b != "number" && ar(u, h, b) && (h = b = n), b = b === n ? Y : b >>> 0, b ? (u = vt(u), u && (typeof h == "string" || h != null && !Nv(h)) && (h = kr(h), !h && al(u)) ? ua(gi(u), 0, b) : u.split(h, b)) : [];
      }
      var o8 = pl(function(u, h, b) {
        return u + (b ? " " : "") + Iv(h);
      });
      function a8(u, h, b) {
        return u = vt(u), b = b == null ? 0 : es(Ze(b), 0, u.length), h = kr(h), u.slice(b, b + h.length) == h;
      }
      function s8(u, h, b) {
        var T = j.templateSettings;
        b && ar(u, h, b) && (h = n), u = vt(u), h = Ah({}, h, T, vA);
        var M = Ah({}, h.imports, T.imports, vA), B = En(M), H = Ky(M, B), q, Q, de = 0, me = h.interpolate || Ld, ge = "__p += '", xe = Yy(
          (h.escape || Ld).source + "|" + me.source + "|" + (me === FS ? Fz : Ld).source + "|" + (h.evaluate || Ld).source + "|$",
          "g"
        ), Ce = "//# sourceURL=" + (Ot.call(h, "sourceURL") ? (h.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++g5 + "]") + `
`;
        u.replace(xe, function(je, ot, ft, Nr, sr, $r) {
          return ft || (ft = Nr), ge += u.slice(de, $r).replace(Gz, R5), ot && (q = !0, ge += `' +
__e(` + ot + `) +
'`), sr && (Q = !0, ge += `';
` + sr + `;
__p += '`), ft && (ge += `' +
((__t = (` + ft + `)) == null ? '' : __t) +
'`), de = $r + je.length, je;
        }), ge += `';
`;
        var Re = Ot.call(h, "variable") && h.variable;
        if (!Re)
          ge = `with (obj) {
` + ge + `
}
`;
        else if (Lz.test(Re))
          throw new He(s);
        ge = (Q ? ge.replace(fn, "") : ge).replace(Xr, "$1").replace(yt, "$1;"), ge = "function(" + (Re || "obj") + `) {
` + (Re ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (q ? ", __e = _.escape" : "") + (Q ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ge + `return __p
}`;
        var et = uT(function() {
          return gt(B, Ce + "return " + ge).apply(n, H);
        });
        if (et.source = ge, Mv(et))
          throw et;
        return et;
      }
      function l8(u) {
        return vt(u).toLowerCase();
      }
      function c8(u) {
        return vt(u).toUpperCase();
      }
      function u8(u, h, b) {
        if (u = vt(u), u && (b || h === n))
          return bO(u);
        if (!u || !(h = kr(h)))
          return u;
        var T = gi(u), M = gi(h), B = xO(T, M), H = wO(T, M) + 1;
        return ua(T, B, H).join("");
      }
      function f8(u, h, b) {
        if (u = vt(u), u && (b || h === n))
          return u.slice(0, SO(u) + 1);
        if (!u || !(h = kr(h)))
          return u;
        var T = gi(u), M = wO(T, gi(h)) + 1;
        return ua(T, 0, M).join("");
      }
      function d8(u, h, b) {
        if (u = vt(u), u && (b || h === n))
          return u.replace(My, "");
        if (!u || !(h = kr(h)))
          return u;
        var T = gi(u), M = xO(T, gi(h));
        return ua(T, M).join("");
      }
      function h8(u, h) {
        var b = D, T = $;
        if (Jt(h)) {
          var M = "separator" in h ? h.separator : M;
          b = "length" in h ? Ze(h.length) : b, T = "omission" in h ? kr(h.omission) : T;
        }
        u = vt(u);
        var B = u.length;
        if (al(u)) {
          var H = gi(u);
          B = H.length;
        }
        if (b >= B)
          return u;
        var q = b - sl(T);
        if (q < 1)
          return T;
        var Q = H ? ua(H, 0, q).join("") : u.slice(0, q);
        if (M === n)
          return Q + T;
        if (H && (q += Q.length - q), Nv(M)) {
          if (u.slice(q).search(M)) {
            var de, me = Q;
            for (M.global || (M = Yy(M.source, vt(WS.exec(M)) + "g")), M.lastIndex = 0; de = M.exec(me); )
              var ge = de.index;
            Q = Q.slice(0, ge === n ? q : ge);
          }
        } else if (u.indexOf(kr(M), q) != q) {
          var xe = Q.lastIndexOf(M);
          xe > -1 && (Q = Q.slice(0, xe));
        }
        return Q + T;
      }
      function p8(u) {
        return u = vt(u), u && Ey.test(u) ? u.replace(Rd, V5) : u;
      }
      var m8 = pl(function(u, h, b) {
        return u + (b ? " " : "") + h.toUpperCase();
      }), Iv = fA("toUpperCase");
      function cT(u, h, b) {
        return u = vt(u), h = b ? n : h, h === n ? L5(u) ? K5(u) : E5(u) : u.match(h) || [];
      }
      var uT = nt(function(u, h) {
        try {
          return Cr(u, n, h);
        } catch (b) {
          return Mv(b) ? b : new He(b);
        }
      }), g8 = ho(function(u, h) {
        return Jr(h, function(b) {
          b = Li(b), uo(u, b, Ev(u[b], u));
        }), u;
      });
      function y8(u) {
        var h = u == null ? 0 : u.length, b = $e();
        return u = h ? Gt(u, function(T) {
          if (typeof T[1] != "function")
            throw new Qr(a);
          return [b(T[0]), T[1]];
        }) : [], nt(function(T) {
          for (var M = -1; ++M < h; ) {
            var B = u[M];
            if (Cr(B[0], this, T))
              return Cr(B[1], this, T);
          }
        });
      }
      function v8(u) {
        return V3(ti(u, d));
      }
      function Rv(u) {
        return function() {
          return u;
        };
      }
      function b8(u, h) {
        return u == null || u !== u ? h : u;
      }
      var x8 = hA(), w8 = hA(!0);
      function br(u) {
        return u;
      }
      function jv(u) {
        return VO(typeof u == "function" ? u : ti(u, d));
      }
      function _8(u) {
        return HO(ti(u, d));
      }
      function S8(u, h) {
        return KO(u, ti(h, d));
      }
      var O8 = nt(function(u, h) {
        return function(b) {
          return fu(b, u, h);
        };
      }), A8 = nt(function(u, h) {
        return function(b) {
          return fu(u, b, h);
        };
      });
      function Lv(u, h, b) {
        var T = En(h), M = ah(h, T);
        b == null && !(Jt(h) && (M.length || !T.length)) && (b = h, h = u, u = this, M = ah(h, En(h)));
        var B = !(Jt(b) && "chain" in b) || !!b.chain, H = mo(u);
        return Jr(M, function(q) {
          var Q = h[q];
          u[q] = Q, H && (u.prototype[q] = function() {
            var de = this.__chain__;
            if (B || de) {
              var me = u(this.__wrapped__), ge = me.__actions__ = gr(this.__actions__);
              return ge.push({ func: Q, args: arguments, thisArg: u }), me.__chain__ = de, me;
            }
            return Q.apply(u, ia([this.value()], arguments));
          });
        }), u;
      }
      function T8() {
        return Ln._ === this && (Ln._ = J5), this;
      }
      function Bv() {
      }
      function P8(u) {
        return u = Ze(u), nt(function(h) {
          return GO(h, u);
        });
      }
      var C8 = gv(Gt), E8 = gv(pO), k8 = gv(Wy);
      function fT(u) {
        return Sv(u) ? zy(Li(u)) : aV(u);
      }
      function M8(u) {
        return function(h) {
          return u == null ? n : ts(u, h);
        };
      }
      var N8 = mA(), $8 = mA(!0);
      function Fv() {
        return [];
      }
      function Wv() {
        return !1;
      }
      function D8() {
        return {};
      }
      function I8() {
        return "";
      }
      function R8() {
        return !0;
      }
      function j8(u, h) {
        if (u = Ze(u), u < 1 || u > G)
          return [];
        var b = Y, T = Zn(u, Y);
        h = $e(h), u -= Y;
        for (var M = Hy(T, h); ++b < u; )
          h(b);
        return M;
      }
      function L8(u) {
        return Ge(u) ? Gt(u, Li) : Mr(u) ? [u] : gr(MA(vt(u)));
      }
      function B8(u) {
        var h = ++X5;
        return vt(u) + h;
      }
      var F8 = dh(function(u, h) {
        return u + h;
      }, 0), W8 = yv("ceil"), z8 = dh(function(u, h) {
        return u / h;
      }, 1), V8 = yv("floor");
      function U8(u) {
        return u && u.length ? oh(u, br, nv) : n;
      }
      function H8(u, h) {
        return u && u.length ? oh(u, $e(h, 2), nv) : n;
      }
      function K8(u) {
        return yO(u, br);
      }
      function G8(u, h) {
        return yO(u, $e(h, 2));
      }
      function Y8(u) {
        return u && u.length ? oh(u, br, av) : n;
      }
      function q8(u, h) {
        return u && u.length ? oh(u, $e(h, 2), av) : n;
      }
      var X8 = dh(function(u, h) {
        return u * h;
      }, 1), Z8 = yv("round"), J8 = dh(function(u, h) {
        return u - h;
      }, 0);
      function Q8(u) {
        return u && u.length ? Uy(u, br) : 0;
      }
      function eH(u, h) {
        return u && u.length ? Uy(u, $e(h, 2)) : 0;
      }
      return j.after = _U, j.ary = zA, j.assign = c6, j.assignIn = nT, j.assignInWith = Ah, j.assignWith = u6, j.at = f6, j.before = VA, j.bind = Ev, j.bindAll = g8, j.bindKey = UA, j.castArray = DU, j.chain = BA, j.chunk = VV, j.compact = UV, j.concat = HV, j.cond = y8, j.conforms = v8, j.constant = Rv, j.countBy = Q4, j.create = d6, j.curry = HA, j.curryRight = KA, j.debounce = GA, j.defaults = h6, j.defaultsDeep = p6, j.defer = SU, j.delay = OU, j.difference = KV, j.differenceBy = GV, j.differenceWith = YV, j.drop = qV, j.dropRight = XV, j.dropRightWhile = ZV, j.dropWhile = JV, j.fill = QV, j.filter = tU, j.flatMap = iU, j.flatMapDeep = oU, j.flatMapDepth = aU, j.flatten = IA, j.flattenDeep = e4, j.flattenDepth = t4, j.flip = AU, j.flow = x8, j.flowRight = w8, j.fromPairs = n4, j.functions = w6, j.functionsIn = _6, j.groupBy = sU, j.initial = i4, j.intersection = o4, j.intersectionBy = a4, j.intersectionWith = s4, j.invert = O6, j.invertBy = A6, j.invokeMap = cU, j.iteratee = jv, j.keyBy = uU, j.keys = En, j.keysIn = vr, j.map = bh, j.mapKeys = P6, j.mapValues = C6, j.matches = _8, j.matchesProperty = S8, j.memoize = wh, j.merge = E6, j.mergeWith = rT, j.method = O8, j.methodOf = A8, j.mixin = Lv, j.negate = _h, j.nthArg = P8, j.omit = k6, j.omitBy = M6, j.once = TU, j.orderBy = fU, j.over = C8, j.overArgs = PU, j.overEvery = E8, j.overSome = k8, j.partial = kv, j.partialRight = YA, j.partition = dU, j.pick = N6, j.pickBy = iT, j.property = fT, j.propertyOf = M8, j.pull = f4, j.pullAll = jA, j.pullAllBy = d4, j.pullAllWith = h4, j.pullAt = p4, j.range = N8, j.rangeRight = $8, j.rearg = CU, j.reject = mU, j.remove = m4, j.rest = EU, j.reverse = Pv, j.sampleSize = yU, j.set = D6, j.setWith = I6, j.shuffle = vU, j.slice = g4, j.sortBy = wU, j.sortedUniq = S4, j.sortedUniqBy = O4, j.split = i8, j.spread = kU, j.tail = A4, j.take = T4, j.takeRight = P4, j.takeRightWhile = C4, j.takeWhile = E4, j.tap = U4, j.throttle = MU, j.thru = vh, j.toArray = QA, j.toPairs = oT, j.toPairsIn = aT, j.toPath = L8, j.toPlainObject = tT, j.transform = R6, j.unary = NU, j.union = k4, j.unionBy = M4, j.unionWith = N4, j.uniq = $4, j.uniqBy = D4, j.uniqWith = I4, j.unset = j6, j.unzip = Cv, j.unzipWith = LA, j.update = L6, j.updateWith = B6, j.values = yl, j.valuesIn = F6, j.without = R4, j.words = cT, j.wrap = $U, j.xor = j4, j.xorBy = L4, j.xorWith = B4, j.zip = F4, j.zipObject = W4, j.zipObjectDeep = z4, j.zipWith = V4, j.entries = oT, j.entriesIn = aT, j.extend = nT, j.extendWith = Ah, Lv(j, j), j.add = F8, j.attempt = uT, j.camelCase = U6, j.capitalize = sT, j.ceil = W8, j.clamp = W6, j.clone = IU, j.cloneDeep = jU, j.cloneDeepWith = LU, j.cloneWith = RU, j.conformsTo = BU, j.deburr = lT, j.defaultTo = b8, j.divide = z8, j.endsWith = H6, j.eq = vi, j.escape = K6, j.escapeRegExp = G6, j.every = eU, j.find = nU, j.findIndex = $A, j.findKey = m6, j.findLast = rU, j.findLastIndex = DA, j.findLastKey = g6, j.floor = V8, j.forEach = FA, j.forEachRight = WA, j.forIn = y6, j.forInRight = v6, j.forOwn = b6, j.forOwnRight = x6, j.get = $v, j.gt = FU, j.gte = WU, j.has = S6, j.hasIn = Dv, j.head = RA, j.identity = br, j.includes = lU, j.indexOf = r4, j.inRange = z6, j.invoke = T6, j.isArguments = is, j.isArray = Ge, j.isArrayBuffer = zU, j.isArrayLike = yr, j.isArrayLikeObject = an, j.isBoolean = VU, j.isBuffer = fa, j.isDate = UU, j.isElement = HU, j.isEmpty = KU, j.isEqual = GU, j.isEqualWith = YU, j.isError = Mv, j.isFinite = qU, j.isFunction = mo, j.isInteger = qA, j.isLength = Sh, j.isMap = XA, j.isMatch = XU, j.isMatchWith = ZU, j.isNaN = JU, j.isNative = QU, j.isNil = t6, j.isNull = e6, j.isNumber = ZA, j.isObject = Jt, j.isObjectLike = tn, j.isPlainObject = yu, j.isRegExp = Nv, j.isSafeInteger = n6, j.isSet = JA, j.isString = Oh, j.isSymbol = Mr, j.isTypedArray = gl, j.isUndefined = r6, j.isWeakMap = i6, j.isWeakSet = o6, j.join = l4, j.kebabCase = Y6, j.last = ri, j.lastIndexOf = c4, j.lowerCase = q6, j.lowerFirst = X6, j.lt = a6, j.lte = s6, j.max = U8, j.maxBy = H8, j.mean = K8, j.meanBy = G8, j.min = Y8, j.minBy = q8, j.stubArray = Fv, j.stubFalse = Wv, j.stubObject = D8, j.stubString = I8, j.stubTrue = R8, j.multiply = X8, j.nth = u4, j.noConflict = T8, j.noop = Bv, j.now = xh, j.pad = Z6, j.padEnd = J6, j.padStart = Q6, j.parseInt = e8, j.random = V6, j.reduce = hU, j.reduceRight = pU, j.repeat = t8, j.replace = n8, j.result = $6, j.round = Z8, j.runInContext = Z, j.sample = gU, j.size = bU, j.snakeCase = r8, j.some = xU, j.sortedIndex = y4, j.sortedIndexBy = v4, j.sortedIndexOf = b4, j.sortedLastIndex = x4, j.sortedLastIndexBy = w4, j.sortedLastIndexOf = _4, j.startCase = o8, j.startsWith = a8, j.subtract = J8, j.sum = Q8, j.sumBy = eH, j.template = s8, j.times = j8, j.toFinite = go, j.toInteger = Ze, j.toLength = eT, j.toLower = l8, j.toNumber = ii, j.toSafeInteger = l6, j.toString = vt, j.toUpper = c8, j.trim = u8, j.trimEnd = f8, j.trimStart = d8, j.truncate = h8, j.unescape = p8, j.uniqueId = B8, j.upperCase = m8, j.upperFirst = Iv, j.each = FA, j.eachRight = WA, j.first = RA, Lv(j, function() {
        var u = {};
        return Ri(j, function(h, b) {
          Ot.call(j.prototype, b) || (u[b] = h);
        }), u;
      }(), { chain: !1 }), j.VERSION = r, Jr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
        j[u].placeholder = j;
      }), Jr(["drop", "take"], function(u, h) {
        ct.prototype[u] = function(b) {
          b = b === n ? 1 : bn(Ze(b), 0);
          var T = this.__filtered__ && !h ? new ct(this) : this.clone();
          return T.__filtered__ ? T.__takeCount__ = Zn(b, T.__takeCount__) : T.__views__.push({
            size: Zn(b, Y),
            type: u + (T.__dir__ < 0 ? "Right" : "")
          }), T;
        }, ct.prototype[u + "Right"] = function(b) {
          return this.reverse()[u](b).reverse();
        };
      }), Jr(["filter", "map", "takeWhile"], function(u, h) {
        var b = h + 1, T = b == L || b == W;
        ct.prototype[u] = function(M) {
          var B = this.clone();
          return B.__iteratees__.push({
            iteratee: $e(M, 3),
            type: b
          }), B.__filtered__ = B.__filtered__ || T, B;
        };
      }), Jr(["head", "last"], function(u, h) {
        var b = "take" + (h ? "Right" : "");
        ct.prototype[u] = function() {
          return this[b](1).value()[0];
        };
      }), Jr(["initial", "tail"], function(u, h) {
        var b = "drop" + (h ? "" : "Right");
        ct.prototype[u] = function() {
          return this.__filtered__ ? new ct(this) : this[b](1);
        };
      }), ct.prototype.compact = function() {
        return this.filter(br);
      }, ct.prototype.find = function(u) {
        return this.filter(u).head();
      }, ct.prototype.findLast = function(u) {
        return this.reverse().find(u);
      }, ct.prototype.invokeMap = nt(function(u, h) {
        return typeof u == "function" ? new ct(this) : this.map(function(b) {
          return fu(b, u, h);
        });
      }), ct.prototype.reject = function(u) {
        return this.filter(_h($e(u)));
      }, ct.prototype.slice = function(u, h) {
        u = Ze(u);
        var b = this;
        return b.__filtered__ && (u > 0 || h < 0) ? new ct(b) : (u < 0 ? b = b.takeRight(-u) : u && (b = b.drop(u)), h !== n && (h = Ze(h), b = h < 0 ? b.dropRight(-h) : b.take(h - u)), b);
      }, ct.prototype.takeRightWhile = function(u) {
        return this.reverse().takeWhile(u).reverse();
      }, ct.prototype.toArray = function() {
        return this.take(Y);
      }, Ri(ct.prototype, function(u, h) {
        var b = /^(?:filter|find|map|reject)|While$/.test(h), T = /^(?:head|last)$/.test(h), M = j[T ? "take" + (h == "last" ? "Right" : "") : h], B = T || /^find/.test(h);
        M && (j.prototype[h] = function() {
          var H = this.__wrapped__, q = T ? [1] : arguments, Q = H instanceof ct, de = q[0], me = Q || Ge(H), ge = function(ot) {
            var ft = M.apply(j, ia([ot], q));
            return T && xe ? ft[0] : ft;
          };
          me && b && typeof de == "function" && de.length != 1 && (Q = me = !1);
          var xe = this.__chain__, Ce = !!this.__actions__.length, Re = B && !xe, et = Q && !Ce;
          if (!B && me) {
            H = et ? H : new ct(this);
            var je = u.apply(H, q);
            return je.__actions__.push({ func: vh, args: [ge], thisArg: n }), new ei(je, xe);
          }
          return Re && et ? u.apply(this, q) : (je = this.thru(ge), Re ? T ? je.value()[0] : je.value() : je);
        });
      }), Jr(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
        var h = Ud[u], b = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", T = /^(?:pop|shift)$/.test(u);
        j.prototype[u] = function() {
          var M = arguments;
          if (T && !this.__chain__) {
            var B = this.value();
            return h.apply(Ge(B) ? B : [], M);
          }
          return this[b](function(H) {
            return h.apply(Ge(H) ? H : [], M);
          });
        };
      }), Ri(ct.prototype, function(u, h) {
        var b = j[h];
        if (b) {
          var T = b.name + "";
          Ot.call(fl, T) || (fl[T] = []), fl[T].push({ name: h, func: b });
        }
      }), fl[fh(n, x).name] = [{
        name: "wrapper",
        func: n
      }], ct.prototype.clone = p3, ct.prototype.reverse = m3, ct.prototype.value = g3, j.prototype.at = H4, j.prototype.chain = K4, j.prototype.commit = G4, j.prototype.next = Y4, j.prototype.plant = X4, j.prototype.reverse = Z4, j.prototype.toJSON = j.prototype.valueOf = j.prototype.value = J4, j.prototype.first = j.prototype.head, iu && (j.prototype[iu] = q4), j;
    }, ll = G5();
    Xa ? ((Xa.exports = ll)._ = ll, jy._ = ll) : Ln._ = ll;
  }).call(So);
})(Kp, Kp.exports);
var iee = Kp.exports;
const ux = {
  sm: "text-xs [&>svg]:size-4 rounded",
  md: "text-sm [&>svg]:size-5 rounded-md",
  lg: "text-base [&>svg]:size-6 rounded-md"
}, qi = {
  input: {
    sm: "py-1.5 px-2 rounded",
    md: "p-2.5 rounded-md",
    lg: "p-3 rounded-md"
  },
  content: {
    sm: "p-1.5",
    md: "p-1.5",
    lg: "p-2"
  },
  title: {
    sm: "p-2 text-xs",
    md: "p-2 text-sm",
    lg: "p-2 text-sm"
  },
  item: {
    sm: "text-sm text-text-secondary rounded",
    md: "text-base text-text-secondary rounded-md",
    lg: "text-base text-text-secondary rounded-md"
  },
  icon: {
    sm: "p-1 text-sm [&>svg]:size-4 text-icon-secondary",
    md: "p-2 text-base [&>svg]:size-5 text-icon-secondary",
    lg: "p-2 text-base [&>svg]:size-5 text-icon-secondary"
  },
  dialog: {
    sm: "mt-1 rounded-md",
    md: "mt-1.5 rounded-lg",
    lg: "mt-1.5 rounded-lg"
  },
  slashIcon: {
    sm: "px-2 py-0.5",
    md: "px-3 py-1",
    lg: "px-3.5 py-1"
  }
}, oee = {
  primary: "bg-field-primary-background outline outline-1 outline-field-border hover:outline-border-strong",
  secondary: "bg-field-secondary-background outline outline-1 outline-field-border hover:outline-border-strong",
  ghost: "bg-field-secondary-background outline outline-1 outline-transparent"
}, aee = "text-icon-secondary group-hover:text-icon-primary group-focus-within:text-icon-primary", cE = {
  ghost: "cursor-not-allowed text-text-disabled placeholder:text-text-disabled",
  primary: "border-border-disabled hover:border-border-disabled bg-field-background-disabled cursor-not-allowed text-text-disabled placeholder:text-text-disabled",
  secondary: "border-border-disabled hover:border-border-disabled cursor-not-allowed text-text-disabled placeholder:text-text-disabled"
}, Sj = dt({}), qs = () => Ve(Sj), Xo = Dt(
  ({
    className: e,
    size: t = "sm",
    open: n = !1,
    onOpenChange: r = () => {
    },
    loading: i = !1,
    ...o
  }, a) => {
    const [s, l] = Me(""), [c, f] = Me(i ?? !1), { refs: d, floatingStyles: p, context: m } = dg({
      open: n,
      onOpenChange: r,
      placement: "bottom-start",
      whileElementsMounted: ig,
      middleware: [
        og(t === "sm" ? 4 : 6),
        ag({ padding: 10 }),
        _D({
          apply({ rects: x, elements: w, availableHeight: S }) {
            w.floating.style.maxHeight = `${S}px`, w.floating.style.width = `${x.reference.width}px`, w.floating.style.fontFamily = window.getComputedStyle(
              w.reference
            ).fontFamily;
          }
        })
      ]
    }), y = fg(m), { getReferenceProps: g, getFloatingProps: v } = hg([
      y
    ]);
    return Xe(() => {
      const x = FH(), w = (S) => {
        const _ = x === "Mac OS" ? S.metaKey : S.ctrlKey;
        if (S.key === "/" && _ && (S.preventDefault(), d.reference && d.reference.current)) {
          const O = d.reference.current instanceof HTMLElement ? d.reference.current.querySelector("input") : null;
          O && O.focus();
        }
      };
      return window.addEventListener("keydown", w), () => {
        window.removeEventListener("keydown", w);
      };
    }, [d.reference]), /* @__PURE__ */ E(
      Sj.Provider,
      {
        value: {
          size: t,
          open: n,
          onOpenChange: r,
          refs: d,
          floatingStyles: p,
          context: m,
          getReferenceProps: g,
          getFloatingProps: v,
          searchTerm: s,
          setSearchTerm: l,
          isLoading: c,
          setIsLoading: f
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            className: K(
              "searchbox-wrapper box-border relative w-full",
              e
            ),
            ...o,
            ref: a
          }
        )
      }
    );
  }
);
Xo.displayName = "SearchBox";
const Oj = Dt(
  ({
    className: e,
    type: t = "text",
    placeholder: n = "Search...",
    variant: r = "primary",
    disabled: i = !1,
    onChange: o = () => {
    },
    ...a
  }, s) => {
    const {
      size: l,
      onOpenChange: c,
      refs: f,
      getReferenceProps: d,
      searchTerm: p,
      setSearchTerm: m
    } = qs(), y = l === "lg" ? "sm" : "xs", g = (v) => {
      const x = v.target.value;
      m(x), o(x), typeof c == "function" && (x.trim() ? c(!0) : c(!1));
    };
    return /* @__PURE__ */ he(
      "div",
      {
        ref: f.setReference,
        className: K(
          "w-full group relative flex justify-center items-center gap-1.5 focus-within:z-10 transition-colors ease-in-out duration-150",
          oee[r],
          qi.input[l],
          i ? cE[r] : "focus-within:ring-2 focus-within:ring-focus focus-within:ring-offset-2 focus-within:border-focus-border focus-within:hover:border-focus-border"
        ),
        ...d,
        children: [
          /* @__PURE__ */ E(
            "span",
            {
              className: K(
                ux[l],
                i ? "text-icon-disabled" : aee,
                "flex justify-center items-center"
              ),
              children: /* @__PURE__ */ E(nD, {})
            }
          ),
          /* @__PURE__ */ E(
            "input",
            {
              type: t,
              ref: s,
              className: K(
                ux[l],
                "flex-grow font-medium bg-transparent border-none outline-none border-transparent focus:ring-0 py-0",
                i ? cE[r] : [
                  "text-field-placeholder focus-within:text-field-input group-hover:text-field-input",
                  "placeholder:text-field-placeholder"
                ],
                e
              ),
              disabled: i,
              value: p,
              onChange: g,
              placeholder: n,
              ...iee.omit(a, [
                "size",
                "open",
                "onOpenChange",
                "loading"
              ])
            }
          ),
          /* @__PURE__ */ E(
            mg,
            {
              label: "⌘/",
              size: y,
              type: "rounded",
              variant: "neutral"
            }
          )
        ]
      }
    );
  }
);
Oj.displayName = "SearchBox.Input";
const Aj = ({
  className: e,
  dropdownPortalRoot: t = null,
  // Root element where the dropdown will be rendered.
  dropdownPortalId: n = "",
  // Id of the dropdown portal where the dropdown will be rendered.
  children: r,
  ...i
}) => {
  const { size: o, open: a, refs: s, floatingStyles: l, getFloatingProps: c } = qs();
  return a ? /* @__PURE__ */ E(ug, { id: n, root: t, children: /* @__PURE__ */ E(
    "div",
    {
      ref: s.setFloating,
      style: {
        ...l
      },
      className: K(
        "bg-background-primary rounded-md border border-solid border-border-subtle shadow-soft-shadow-lg overflow-y-auto text-wrap",
        qi.dialog[o],
        e
      ),
      ...c(),
      ...i,
      children: r
    }
  ) }) : null;
};
Aj.displayName = "SearchBox.Content";
const Tj = ({
  filter: e = !0,
  children: t
}) => {
  const { searchTerm: n, isLoading: r } = qs();
  if (!e)
    return /* @__PURE__ */ E("div", { children: t });
  const i = Yt.toArray(t).map((o) => {
    if (I.isValidElement(o) && o.type === S_) {
      const a = Yt.toArray(
        o.props.children
      ).filter(
        (s) => I.isValidElement(s) && typeof s.props.children == "string" && s.props.children.toLowerCase().includes(n.toLowerCase())
      );
      return a.length > 0 ? ht(o, {
        children: a
      }) : null;
    }
    return o;
  }).filter(Boolean);
  return r ? /* @__PURE__ */ E(O_, {}) : /* @__PURE__ */ E("div", { children: i.some(
    (o) => I.isValidElement(o) && o.type !== A_
  ) ? i : /* @__PURE__ */ E(__, {}) });
};
Tj.displayName = "SearchBox.List";
const __ = ({
  children: e = "No results found."
}) => {
  const { size: t } = qs();
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex justify-center items-center",
        qi.item[t],
        "text-text-tertiary p-4"
      ),
      children: e
    }
  );
};
__.displayName = "SearchBox.Empty";
const S_ = ({ heading: e, children: t }) => {
  const { size: n } = qs();
  return /* @__PURE__ */ he(
    "div",
    {
      className: K(
        qi.content[n],
        qi.item[n]
      ),
      children: [
        e && /* @__PURE__ */ E(
          "div",
          {
            className: K(
              qi.title[n],
              "text-text-secondary"
            ),
            children: e
          }
        ),
        t
      ]
    }
  );
};
S_.displayName = "SearchBox.Group";
const Pj = Dt(
  ({ className: e, icon: t, children: n, ...r }, i) => {
    const { size: o } = qs();
    return /* @__PURE__ */ he(
      "div",
      {
        ref: i,
        className: K(
          "flex items-center justify-start gap-1 p-1 hover:bg-background-secondary focus:bg-background-secondary cursor-pointer",
          qi.item[o]
        ),
        ...r,
        children: [
          t && /* @__PURE__ */ E(
            "span",
            {
              className: K(
                qi.icon[o],
                "flex items-center justify-center"
              ),
              children: t
            }
          ),
          /* @__PURE__ */ E(
            "span",
            {
              className: K(
                "flex-grow p-1 font-normal cursor-pointer",
                qi.item[o],
                e
              ),
              children: n
            }
          )
        ]
      }
    );
  }
);
Pj.displayName = "SearchBox.Item";
const O_ = ({
  loadingIcon: e = /* @__PURE__ */ E(RD, {})
}) => {
  const { size: t } = qs(), n = I.isValidElement(e) ? ht(e, { size: t }) : e;
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex justify-center p-4",
        ux[t],
        qi.item[t]
      ),
      children: n
    }
  );
};
O_.displayName = "SearchBox.Loading";
const A_ = Dt(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "hr",
  {
    ref: n,
    className: K(
      "border-0 border-t border-border-subtle border-solid m-0",
      e
    ),
    ...t
  }
));
A_.displayName = "SearchBox.Separator";
Xo.Input = Oj;
Xo.Loading = O_;
Xo.Separator = A_;
Xo.Content = Aj;
Xo.List = Tj;
Xo.Empty = __;
Xo.Group = S_;
Xo.Item = Pj;
const Cj = dt({}), Ej = () => Ve(Cj), Xs = ({
  placement: e = "bottom",
  offset: t = 10,
  boundary: n = "clippingAncestors",
  children: r,
  className: i
}) => {
  const [o, a] = Me(!1), { refs: s, floatingStyles: l, context: c } = dg({
    open: o,
    onOpenChange: a,
    placement: e,
    strategy: "absolute",
    middleware: [
      og(t),
      ag({ boundary: n }),
      wD({ boundary: n })
    ],
    whileElementsMounted: ig
  }), f = c1(c), d = fg(c), p = u1(c, { role: "menu" }), { getReferenceProps: m, getFloatingProps: y } = hg([
    f,
    d,
    p
  ]), { isMounted: g, styles: v } = MD(c, {
    duration: 150,
    initial: { opacity: 0, scale: 0.95 },
    open: { opacity: 1, scale: 1 },
    close: { opacity: 0, scale: 0.95 }
  }), x = () => a((S) => !S), w = () => a(!1);
  return /* @__PURE__ */ E(
    Cj.Provider,
    {
      value: {
        refs: s,
        handleClose: w,
        isMounted: g,
        styles: v,
        floatingStyles: l,
        getFloatingProps: y
      },
      children: /* @__PURE__ */ he("div", { className: K("relative inline-block", i), children: [
        I.Children.map(r, (S) => {
          var A;
          return I.isValidElement(S) && ((A = S == null ? void 0 : S.type) == null ? void 0 : A.displayName) === "DropdownMenu.Trigger" ? ht(S, {
            ref: s.setReference,
            onClick: x,
            ...m()
          }) : null;
        }),
        I.Children.map(r, (S) => {
          var A;
          return I.isValidElement(S) && ((A = S == null ? void 0 : S.type) == null ? void 0 : A.displayName) === "DropdownMenu.Portal" ? S : null;
        })
      ] })
    }
  );
};
Xs.displayName = "DropdownMenu";
const kj = ({
  children: e,
  className: t,
  root: n,
  id: r
}) => {
  const { refs: i, floatingStyles: o, getFloatingProps: a, isMounted: s, styles: l } = Ej();
  return s && /* @__PURE__ */ E(ug, { id: r, root: n, children: /* @__PURE__ */ E(
    "div",
    {
      ref: i.setFloating,
      className: t,
      style: {
        ...o,
        ...l
      },
      ...a(),
      children: I.Children.map(e, (c) => {
        var f;
        return ((f = c == null ? void 0 : c.type) == null ? void 0 : f.displayName) === "DropdownMenu.Content" ? c : null;
      })
    }
  ) });
};
kj.displayName = "DropdownMenu.Portal";
const Mj = I.forwardRef(({ children: e, className: t, ...n }, r) => rt(e) ? I.cloneElement(e, {
  className: K(t, e.props.className),
  ref: r,
  ...n
}) : /* @__PURE__ */ E(
  "div",
  {
    ref: r,
    className: K("cursor-pointer", t),
    role: "button",
    tabIndex: 0,
    ...n,
    children: e
  }
));
Mj.displayName = "DropdownMenu.Trigger";
const Nj = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "div",
  {
    className: K(
      "border border-solid border-border-subtle rounded-md shadow-lg overflow-hidden",
      t
    ),
    children: /* @__PURE__ */ E(Ua, { ...n, children: e })
  }
);
Nj.displayName = "DropdownMenu.Content";
const $j = (e) => /* @__PURE__ */ E(Ua.List, { ...e });
$j.displayName = "DropdownMenu.List";
const Dj = ({
  children: e,
  as: t = Ua.Item,
  ...n
}) => {
  var i;
  const { handleClose: r } = Ej();
  return e ? t === Ur && rt(e) ? ht(e, {
    onClick: lf(
      (i = e.props) == null ? void 0 : i.onClick,
      r
    )
  }) : /* @__PURE__ */ E(
    t,
    {
      ...n,
      className: K("px-2", n.className),
      onClick: lf(n.onClick, r),
      children: e
    }
  ) : null;
};
Dj.displayName = "DropdownMenu.Item";
const Ij = (e) => /* @__PURE__ */ E(Ua.Separator, { ...e });
Ij.displayName = "DropdownMenu.Separator";
Xs.Trigger = Mj;
Xs.Content = Nj;
Xs.List = $j;
Xs.Item = Dj;
Xs.Separator = Ij;
Xs.Portal = kj;
const see = {
  left: {
    open: {
      x: 0
    },
    exit: {
      x: "-100%"
    }
  },
  right: {
    open: {
      x: 0
    },
    exit: {
      x: "100%"
    }
  }
}, Rj = ({ children: e, className: t }) => {
  const { open: n, position: r, handleClose: i, drawerRef: o, transitionDuration: a } = Vg();
  return /* @__PURE__ */ E(Ks, { children: n && /* @__PURE__ */ E("div", { className: "fixed inset-0", children: /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "flex items-center justify-center h-full",
        {
          "justify-start": r === "left",
          "justify-end": r === "right"
        }
      ),
      children: /* @__PURE__ */ E(
        An.div,
        {
          ref: o,
          className: K(
            "flex flex-col w-120 h-full bg-background-primary shadow-2xl my-5 overflow-hidden",
            t
          ),
          initial: "exit",
          animate: "open",
          exit: "exit",
          variants: see[r],
          transition: a,
          children: typeof e == "function" ? e({ close: i }) : e
        }
      )
    }
  ) }) });
};
Rj.displayName = "Drawer.Panel";
const jj = ({ children: e, className: t, ...n }) => /* @__PURE__ */ E("div", { className: K("space-y-2 px-5 pt-5 pb-4", t), ...n, children: e });
jj.displayName = "Drawer.Header";
const Lj = ({
  children: e,
  as: t = "h3",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: K(
      "text-base font-semibold text-text-primary m-0 p-0",
      n
    ),
    ...r,
    children: e
  }
);
Lj.displayName = "Drawer.Title";
const Bj = ({
  children: e,
  as: t = "p",
  className: n,
  ...r
}) => /* @__PURE__ */ E(
  t,
  {
    className: K(
      "text-sm font-normal text-text-secondary my-0 ml-0 mr-1 p-0",
      n
    ),
    ...r,
    children: e
  }
);
Bj.displayName = "Drawer.Description";
const Fj = ({ children: e, className: t, ...n }) => /* @__PURE__ */ E(
  "div",
  {
    className: K(
      "px-5 pb-4 pt-2 flex flex-col flex-1 overflow-y-auto overflow-x-hidden",
      t
    ),
    ...n,
    children: e
  }
);
Fj.displayName = "Drawer.Body";
const Wj = ({ children: e, className: t }) => {
  const { design: n, handleClose: r } = Vg(), i = () => e ? typeof e == "function" ? e({ close: r }) : e : null;
  return /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "px-5 py-4 flex justify-end gap-3 mt-auto",
        {
          "bg-background-secondary": n === "footer-divided",
          "border-t border-b-0 border-x-0 border-solid border-border-subtle": n === "footer-bordered"
        },
        t
      ),
      children: i()
    }
  );
};
Wj.displayName = "Drawer.Footer";
const uE = ({
  className: e,
  ...t
}) => /* @__PURE__ */ E(
  "button",
  {
    className: K(
      "bg-transparent inline-flex justify-center items-center border-0 p-1 m-0 cursor-pointer focus:outline-none outline-none shadow-none",
      e
    ),
    "aria-label": "Close drawer",
    ...t,
    children: /* @__PURE__ */ E(Na, { className: "size-4 text-text-primary shrink-0" })
  }
), zj = ({
  children: e,
  as: t = Ur,
  ...n
}) => {
  const { handleClose: r } = Vg();
  return e ? t === Ur ? typeof e == "function" ? e({ close: r }) : rt(e) ? ht(e, {
    onClick: r
  }) : /* @__PURE__ */ E(uE, { onClick: r, ...n }) : /* @__PURE__ */ E(t, { ...n, onClick: r, children: e }) : /* @__PURE__ */ E(uE, { onClick: r, ...n });
};
zj.displayName = "Drawer.CloseButton";
const lee = {
  open: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, Vj = ({ className: e, ...t }) => {
  const { open: n, drawerContainerRef: r, transitionDuration: i } = Vg();
  return r != null && r.current ? !!r.current && Yw(
    /* @__PURE__ */ E(Ks, { children: n && /* @__PURE__ */ E(
      An.div,
      {
        className: K(
          "fixed inset-0 -z-10 bg-background-inverse/90",
          e
        ),
        ...t,
        initial: "exit",
        animate: "open",
        exit: "exit",
        variants: lee,
        transition: i
      }
    ) }),
    r.current
  ) : null;
};
Vj.displayName = "Drawer.Backdrop";
const cee = 0.2, Uj = dt({}), Vg = () => Ve(Uj), Zo = ({
  open: e,
  setOpen: t,
  children: n,
  trigger: r,
  className: i,
  exitOnClickOutside: o = !1,
  exitOnEsc: a = !0,
  design: s = "simple",
  position: l = "right",
  transitionDuration: c = cee,
  scrollLock: f = !0
}) => {
  const d = e !== void 0 && t !== void 0, [p, m] = Me(!1), y = ut(null), g = ut(null), v = Fe(
    () => d ? e : p,
    [e, p]
  ), x = Fe(
    () => d ? t : m,
    [m, m]
  ), w = () => {
    v || x(!0);
  }, S = () => {
    v && x(!1);
  }, A = qe(() => rt(r) ? ht(r, {
    onClick: lf(w, r.props.onClick)
  }) : typeof r == "function" ? r({ onClick: w }) : null, [r, w, S]), _ = (P) => {
    switch (P.key) {
      case "Escape":
        a && S();
        break;
    }
  }, O = (P) => {
    o && y.current && !y.current.contains(P.target) && S();
  };
  return Xe(() => (window.addEventListener("keydown", _), document.addEventListener("mousedown", O), () => {
    window.removeEventListener("keydown", _), document.removeEventListener("mousedown", O);
  }), [v]), Xe(() => {
    if (!f)
      return;
    const P = document.querySelector("html");
    return v && P && (P.style.overflow = "hidden"), () => {
      P && (P.style.overflow = "");
    };
  }, [v]), /* @__PURE__ */ he(Ut, { children: [
    A(),
    /* @__PURE__ */ E(
      Uj.Provider,
      {
        value: {
          open: v,
          setOpen: x,
          handleClose: S,
          design: s,
          position: l,
          drawerContainerRef: g,
          drawerRef: y,
          transitionDuration: { duration: c }
        },
        children: /* @__PURE__ */ E(
          "div",
          {
            className: K(
              "fixed z-auto w-0 h-0 overflow-visible",
              i
            ),
            ref: g,
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "drawer",
            children: n
          }
        )
      }
    )
  ] });
};
Zo.displayName = "Drawer";
Zo.Panel = Rj;
Zo.Header = jj;
Zo.Title = Lj;
Zo.Description = Bj;
Zo.Body = Fj;
Zo.CloseButton = zj;
Zo.Footer = Wj;
Zo.Backdrop = Vj;
const Ug = {
  xs: {
    general: "text-xs min-w-6 h-6",
    ellipse: "text-xs min-w-6",
    icon: "size-4"
  },
  sm: {
    general: "text-xs min-w-8 h-8",
    ellipse: "text-xs min-w-8",
    icon: "size-4"
  },
  md: {
    general: "text-sm min-w-10 h-10",
    ellipse: "text-sm min-w-10",
    icon: "size-5"
  },
  lg: {
    general: "text-base min-w-12 h-12",
    ellipse: "text-base min-w-12",
    icon: "size-6"
  }
}, Ls = {
  general: "group disabled:border-field-border-disabled opacity-50",
  text: "group-disabled:text-field-color-disabled"
}, Hj = dt({
  size: "sm",
  disabled: !1
}), Sd = () => Ve(Hj), Bc = ({
  size: e = "sm",
  disabled: t = !1,
  children: n,
  className: r,
  ...i
}) => /* @__PURE__ */ E(Hj.Provider, { value: { size: e, disabled: t }, children: /* @__PURE__ */ E(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: K(
      "flex w-full justify-center box-border m-0",
      r
    ),
    ...i,
    children: n
  }
) });
Bc.displayName = "Pagination";
const Kj = Dt(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "ul",
  {
    ref: n,
    className: K(
      "m-0 p-0 w-full flex justify-center flex-row items-center gap-1",
      "list-none",
      e
    ),
    ...t
  }
));
Kj.displayName = "Pagination.Content";
const Gj = Dt(
  ({ isActive: e = !1, className: t, children: n, ...r }, i) => {
    const { disabled: o } = Sd();
    return /* @__PURE__ */ E(
      "li",
      {
        ref: i,
        className: K("flex", o && Ls.general),
        children: /* @__PURE__ */ E(
          T_,
          {
            isActive: e,
            disabled: o,
            className: t,
            ...r,
            children: n
          }
        )
      }
    );
  }
);
Gj.displayName = "Pagination.Item";
const T_ = ({
  isActive: e = !1,
  tag: t = "a",
  children: n,
  className: r,
  ...i
}) => {
  const { size: o, disabled: a } = Sd(), s = (l) => l.preventDefault();
  return /* @__PURE__ */ E(
    Hn,
    {
      tag: t,
      size: o,
      variant: "ghost",
      className: K(
        "no-underline bg-transparent p-0 m-0 border-none",
        "flex justify-center items-center rounded text-button-secondary",
        "focus:outline focus:outline-1 focus:outline-border-subtle focus:bg-button-tertiary-hover",
        Ug[o].general,
        !a && e && "text-button-primary active:text-button-primary bg-brand-background-50",
        a && [
          Ls.general,
          Ls.text,
          "focus:ring-transparent cursor-not-allowed"
        ],
        r
      ),
      disabled: a,
      ...i,
      onClick: (l) => lf(
        i.onClick || (() => {
        }),
        a ? s : () => {
        }
      )(l),
      children: /* @__PURE__ */ E("span", { className: "px-1 flex", children: n })
    }
  );
}, Yj = (e) => {
  const { size: t, disabled: n } = Sd();
  return /* @__PURE__ */ E(
    "li",
    {
      className: K("flex", n && Ls.general),
      "aria-label": "Go to previous page",
      children: /* @__PURE__ */ E(
        T_,
        {
          className: K("[&>span]:flex [&>span]:items-center"),
          ...e,
          children: /* @__PURE__ */ E(Q$, { className: K(Ug[t].icon) })
        }
      )
    }
  );
};
Yj.displayName = "Pagination.Previous";
const qj = (e) => {
  const { size: t, disabled: n } = Sd();
  return /* @__PURE__ */ E(
    "li",
    {
      className: K("flex", n && Ls.general),
      "aria-label": "Go to next page",
      children: /* @__PURE__ */ E(
        T_,
        {
          className: K("[&>span]:flex [&>span]:items-center"),
          ...e,
          children: /* @__PURE__ */ E(Zw, { className: K(Ug[t].icon) })
        }
      )
    }
  );
};
qj.displayName = "Pagination.Next";
const Xj = (e) => {
  const { size: t, disabled: n } = Sd();
  return /* @__PURE__ */ E("li", { className: K("flex", n && Ls.general), children: /* @__PURE__ */ E(
    "span",
    {
      className: K(
        "flex justify-center",
        Ug[t].ellipse,
        n && Ls.general
      ),
      ...e,
      children: "•••"
    }
  ) });
};
Xj.displayName = "Pagination.Ellipsis";
Bc.Content = Kj;
Bc.Item = Gj;
Bc.Previous = Yj;
Bc.Next = qj;
Bc.Ellipsis = Xj;
var Le;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Le || (Le = {}));
var Lt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Lt || (Lt = {}));
var Ei;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Ei || (Ei = {}));
const Zj = 6048e5, uee = 864e5, fE = Symbol.for("constructDateFrom");
function Tn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && fE in e ? e[fE](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Et(e, t) {
  return Tn(t || e, e);
}
function P_(e, t, n) {
  const r = Et(e, n == null ? void 0 : n.in);
  return isNaN(t) ? Tn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function C_(e, t, n) {
  const r = Et(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return Tn(e, NaN);
  if (!t)
    return r;
  const i = r.getDate(), o = Tn(e, r.getTime());
  o.setMonth(r.getMonth() + t + 1, 0);
  const a = o.getDate();
  return i >= a ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    i
  ), r);
}
let fee = {};
function Od() {
  return fee;
}
function Bs(e, t) {
  var s, l, c, f;
  const n = Od(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, i = Et(e, t == null ? void 0 : t.in), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Af(e, t) {
  return Bs(e, { ...t, weekStartsOn: 1 });
}
function Jj(e, t) {
  const n = Et(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = Tn(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const o = Af(i), a = Tn(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Af(a);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function dE(e) {
  const t = Et(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Ad(e, ...t) {
  const n = Tn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function rc(e, t) {
  const n = Et(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Qj(e, t, n) {
  const [r, i] = Ad(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = rc(r), a = rc(i), s = +o - dE(o), l = +a - dE(a);
  return Math.round((s - l) / uee);
}
function dee(e, t) {
  const n = Jj(e, t), r = Tn(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Af(r);
}
function hee(e, t, n) {
  return P_(e, t * 7, n);
}
function pee(e, t, n) {
  return C_(e, t * 12, n);
}
function mee(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = Tn.bind(null, i));
    const o = Et(i, r);
    (!n || n < o || isNaN(+o)) && (n = o);
  }), Tn(r, n || NaN);
}
function gee(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = Tn.bind(null, i));
    const o = Et(i, r);
    (!n || n > o || isNaN(+o)) && (n = o);
  }), Tn(r, n || NaN);
}
function hE(e) {
  return Tn(e, Date.now());
}
function yee(e, t, n) {
  const [r, i] = Ad(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +rc(r) == +rc(i);
}
function eL(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function vee(e) {
  return !(!eL(e) && typeof e != "number" || isNaN(+Et(e)));
}
function bee(e, t, n) {
  const [r, i] = Ad(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = r.getFullYear() - i.getFullYear(), a = r.getMonth() - i.getMonth();
  return o * 12 + a;
}
function tL(e, t) {
  const n = Et(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function nL(e, t) {
  const n = Et(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function xee(e, t) {
  const n = Et(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function rL(e, t) {
  const n = Et(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function E_(e, t) {
  var s, l, c, f;
  const n = Od(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, i = Et(e, t == null ? void 0 : t.in), o = i.getDay(), a = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + a), i.setHours(23, 59, 59, 999), i;
}
function wee(e, t) {
  return E_(e, { ...t, weekStartsOn: 1 });
}
const _ee = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, See = (e, t, n) => {
  let r;
  const i = _ee[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Tb(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Oee = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Aee = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Tee = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Pee = {
  date: Tb({
    formats: Oee,
    defaultWidth: "full"
  }),
  time: Tb({
    formats: Aee,
    defaultWidth: "full"
  }),
  dateTime: Tb({
    formats: Tee,
    defaultWidth: "full"
  })
}, Cee = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Eee = (e, t, n, r) => Cee[e];
function Ou(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[a];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[o];
  };
}
const kee = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Mee = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Nee = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, $ee = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Dee = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Iee = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ree = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, jee = {
  ordinalNumber: Ree,
  era: Ou({
    values: kee,
    defaultWidth: "wide"
  }),
  quarter: Ou({
    values: Mee,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ou({
    values: Nee,
    defaultWidth: "wide"
  }),
  day: Ou({
    values: $ee,
    defaultWidth: "wide"
  }),
  dayPeriod: Ou({
    values: Dee,
    defaultWidth: "wide",
    formattingValues: Iee,
    defaultFormattingWidth: "wide"
  })
};
function Au(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    const a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? Bee(s, (d) => d.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      Lee(s, (d) => d.test(a))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const f = t.slice(a.length);
    return { value: c, rest: f };
  };
}
function Lee(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Bee(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Fee(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(i.length);
    return { value: a, rest: s };
  };
}
const Wee = /^(\d+)(th|st|nd|rd)?/i, zee = /\d+/i, Vee = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Uee = {
  any: [/^b/i, /^(a|c)/i]
}, Hee = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Kee = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Gee = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Yee = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, qee = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Xee = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Zee = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Jee = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Qee = {
  ordinalNumber: Fee({
    matchPattern: Wee,
    parsePattern: zee,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Au({
    matchPatterns: Vee,
    defaultMatchWidth: "wide",
    parsePatterns: Uee,
    defaultParseWidth: "any"
  }),
  quarter: Au({
    matchPatterns: Hee,
    defaultMatchWidth: "wide",
    parsePatterns: Kee,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Au({
    matchPatterns: Gee,
    defaultMatchWidth: "wide",
    parsePatterns: Yee,
    defaultParseWidth: "any"
  }),
  day: Au({
    matchPatterns: qee,
    defaultMatchWidth: "wide",
    parsePatterns: Xee,
    defaultParseWidth: "any"
  }),
  dayPeriod: Au({
    matchPatterns: Zee,
    defaultMatchWidth: "any",
    parsePatterns: Jee,
    defaultParseWidth: "any"
  })
}, Hg = {
  code: "en-US",
  formatDistance: See,
  formatLong: Pee,
  formatRelative: Eee,
  localize: jee,
  match: Qee,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ete(e, t) {
  const n = Et(e, t == null ? void 0 : t.in);
  return Qj(n, rL(n)) + 1;
}
function iL(e, t) {
  const n = Et(e, t == null ? void 0 : t.in), r = +Af(n) - +dee(n);
  return Math.round(r / Zj) + 1;
}
function oL(e, t) {
  var f, d, p, m;
  const n = Et(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = Od(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : d.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((m = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = Tn((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const s = Bs(a, t), l = Tn((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const c = Bs(l, t);
  return +n >= +s ? r + 1 : +n >= +c ? r : r - 1;
}
function tte(e, t) {
  var s, l, c, f;
  const n = Od(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = oL(e, t), o = Tn((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), Bs(o, t);
}
function aL(e, t) {
  const n = Et(e, t == null ? void 0 : t.in), r = +Bs(n, t) - +tte(n, t);
  return Math.round(r / Zj) + 1;
}
function At(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const ga = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return At(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : At(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return At(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return At(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return At(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return At(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return At(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return At(i, t.length);
  }
}, xl = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, pE = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return ga.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = oL(e, r), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const a = o % 100;
      return At(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : At(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Jj(e);
    return At(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return At(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return At(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return At(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ga.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return At(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = aL(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : At(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = iL(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : At(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ga.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = ete(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : At(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return At(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return At(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return At(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = xl.noon : r === 0 ? i = xl.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = xl.evening : r >= 12 ? i = xl.afternoon : r >= 4 ? i = xl.morning : i = xl.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return ga.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ga.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : At(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : At(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ga.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ga.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return ga.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return gE(r);
      case "XXXX":
      case "XX":
        return ps(r);
      case "XXXXX":
      case "XXX":
      default:
        return ps(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return gE(r);
      case "xxxx":
      case "xx":
        return ps(r);
      case "xxxxx":
      case "xxx":
      default:
        return ps(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + mE(r, ":");
      case "OOOO":
      default:
        return "GMT" + ps(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + mE(r, ":");
      case "zzzz":
      default:
        return "GMT" + ps(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return At(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return At(+e, t.length);
  }
};
function mE(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + t + At(o, 2);
}
function gE(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + At(Math.abs(e) / 60, 2) : ps(e, t);
}
function ps(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = At(Math.trunc(r / 60), 2), o = At(r % 60, 2);
  return n + i + t + o;
}
const yE = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, sL = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, nte = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return yE(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", yE(r, t)).replace("{{time}}", sL(i, t));
}, rte = {
  p: sL,
  P: nte
}, ite = /^D+$/, ote = /^Y+$/, ate = ["D", "DD", "YY", "YYYY"];
function ste(e) {
  return ite.test(e);
}
function lte(e) {
  return ote.test(e);
}
function cte(e, t, n) {
  const r = ute(e, t, n);
  if (console.warn(r), ate.includes(e)) throw new RangeError(r);
}
function ute(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const fte = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, dte = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, hte = /^'([^]*?)'?$/, pte = /''/g, mte = /[a-zA-Z]/;
function Fn(e, t, n) {
  var f, d, p, m, y, g, v, x;
  const r = Od(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? Hg, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((x = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : x.weekStartsOn) ?? 0, s = Et(e, n == null ? void 0 : n.in);
  if (!vee(s))
    throw new RangeError("Invalid time value");
  let l = t.match(dte).map((w) => {
    const S = w[0];
    if (S === "p" || S === "P") {
      const A = rte[S];
      return A(w, i.formatLong);
    }
    return w;
  }).join("").match(fte).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const S = w[0];
    if (S === "'")
      return { isToken: !1, value: gte(w) };
    if (pE[S])
      return { isToken: !0, value: w };
    if (S.match(mte))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + S + "`"
      );
    return { isToken: !1, value: w };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return l.map((w) => {
    if (!w.isToken) return w.value;
    const S = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && lte(S) || !(n != null && n.useAdditionalDayOfYearTokens) && ste(S)) && cte(S, t, String(e));
    const A = pE[S[0]];
    return A(s, S, i.localize, c);
  }).join("");
}
function gte(e) {
  const t = e.match(hte);
  return t ? t[1].replace(pte, "'") : e;
}
function yte(e, t) {
  const n = Et(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = n.getMonth(), o = Tn(n, 0);
  return o.setFullYear(r, i + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function fx(e, t) {
  return +Et(e) > +Et(t);
}
function dx(e, t) {
  return +Et(e) < +Et(t);
}
function vE(e, t) {
  return +Et(e) == +Et(t);
}
function vte(e, t, n) {
  const [r, i] = Ad(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function bte(e, t, n) {
  const [r, i] = Ad(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear();
}
function bE(e, t, n) {
  return P_(e, -t, n);
}
function xte(e, t, n) {
  const r = Et(e, n == null ? void 0 : n.in), i = r.getFullYear(), o = r.getDate(), a = Tn(e, 0);
  a.setFullYear(i, t, 15), a.setHours(0, 0, 0, 0);
  const s = yte(a);
  return r.setMonth(t, Math.min(o, s)), r;
}
function wte(e, t, n) {
  const r = Et(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? Tn(e, NaN) : (r.setFullYear(t), r);
}
function xE(e) {
  return rc(Date.now(), e);
}
function wE(e) {
  const t = hE(e == null ? void 0 : e.in), n = t.getFullYear(), r = t.getMonth(), i = t.getDate(), o = hE(e == null ? void 0 : e.in);
  return o.setFullYear(n, r, i - 1), o.setHours(0, 0, 0, 0), o;
}
function _te(e, t, n) {
  return C_(e, -t, n);
}
class Jo {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.addDays = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addDays ? this.overrides.addDays(r, i) : P_(r, i);
    }, this.addMonths = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addMonths ? this.overrides.addMonths(r, i) : C_(r, i);
    }, this.addWeeks = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addWeeks ? this.overrides.addWeeks(r, i) : hee(r, i);
    }, this.addYears = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.addYears ? this.overrides.addYears(r, i) : pee(r, i);
    }, this.differenceInCalendarDays = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : Qj(r, i);
    }, this.differenceInCalendarMonths = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : bee(r, i);
    }, this.endOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfISOWeek ? this.overrides.endOfISOWeek(r) : wee(r);
    }, this.endOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfMonth ? this.overrides.endOfMonth(r) : tL(r);
    }, this.endOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, this.options) : E_(r, this.options);
    }, this.endOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfYear ? this.overrides.endOfYear(r) : xee(r);
    }, this.format = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.format ? this.overrides.format(r, i, this.options) : Fn(r, i, this.options);
    }, this.getISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getISOWeek ? this.overrides.getISOWeek(r) : iL(r);
    }, this.getWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : aL(r, this.options);
    }, this.isAfter = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isAfter ? this.overrides.isAfter(r, i) : fx(r, i);
    }, this.isBefore = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isBefore ? this.overrides.isBefore(r, i) : dx(r, i);
    }, this.isDate = (r) => {
      var i;
      return (i = this.overrides) != null && i.isDate ? this.overrides.isDate(r) : eL(r);
    }, this.isSameDay = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameDay ? this.overrides.isSameDay(r, i) : yee(r, i);
    }, this.isSameMonth = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameMonth ? this.overrides.isSameMonth(r, i) : vte(r, i);
    }, this.isSameYear = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.isSameYear ? this.overrides.isSameYear(r, i) : bte(r, i);
    }, this.max = (r) => {
      var i;
      return (i = this.overrides) != null && i.max ? this.overrides.max(r) : mee(r);
    }, this.min = (r) => {
      var i;
      return (i = this.overrides) != null && i.min ? this.overrides.min(r) : gee(r);
    }, this.setMonth = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.setMonth ? this.overrides.setMonth(r, i) : xte(r, i);
    }, this.setYear = (r, i) => {
      var o;
      return (o = this.overrides) != null && o.setYear ? this.overrides.setYear(r, i) : wte(r, i);
    }, this.startOfDay = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfDay ? this.overrides.startOfDay(r) : rc(r);
    }, this.startOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Af(r);
    }, this.startOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfMonth ? this.overrides.startOfMonth(r) : nL(r);
    }, this.startOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Bs(r, this.options);
    }, this.startOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfYear ? this.overrides.startOfYear(r) : rL(r);
    }, this.options = { locale: Hg, ...t }, this.overrides = n;
  }
}
const Zs = new Jo();
function Ste(e, t, n = {}) {
  return Object.entries(e).filter(([, i]) => i === !0).reduce((i, [o]) => (n[o] ? i.push(n[o]) : t[Lt[o]] ? i.push(t[Lt[o]]) : t[Ei[o]] && i.push(t[Ei[o]]), i), [t[Le.Day]]);
}
function Ote(e) {
  return I.createElement("button", { ...e });
}
function Ate(e) {
  return I.createElement("span", { ...e });
}
function Tte(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return I.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && I.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && I.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && I.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && I.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function Pte(e) {
  const { day: t, modifiers: n, ...r } = e;
  return I.createElement("td", { ...r });
}
function Cte(e) {
  const { day: t, modifiers: n, ...r } = e, i = I.useRef(null);
  return I.useEffect(() => {
    var o;
    n.focused && ((o = i.current) == null || o.focus());
  }, [n.focused]), I.createElement("button", { ref: i, ...r });
}
function Ete(e) {
  const { options: t, className: n, components: r, classNames: i, ...o } = e, a = [i[Le.Dropdown], n].join(" "), s = t == null ? void 0 : t.find(({ value: l }) => l === o.value);
  return I.createElement(
    "span",
    { "data-disabled": o.disabled, className: i[Le.DropdownRoot] },
    I.createElement(r.Select, { className: a, ...o }, t == null ? void 0 : t.map(({ value: l, label: c, disabled: f }) => I.createElement(r.Option, { key: l, value: l, disabled: f }, c))),
    I.createElement(
      "span",
      { className: i[Le.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      I.createElement(r.Chevron, { orientation: "down", size: 18, className: i[Le.Chevron] })
    )
  );
}
function kte(e) {
  return I.createElement("div", { ...e });
}
function Mte(e) {
  return I.createElement("div", { ...e });
}
function Nte(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return I.createElement("div", { ...r }, e.children);
}
function $te(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return I.createElement("div", { ...r });
}
function Dte(e) {
  return I.createElement("table", { ...e });
}
function Ite(e) {
  return I.createElement("div", { ...e });
}
const lL = dt(void 0);
function Fc() {
  const e = Ve(lL);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function Rte(e) {
  const { components: t } = Fc();
  return I.createElement(t.Dropdown, { ...e });
}
function jte(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: i, ...o } = e, { components: a, classNames: s, labels: { labelPrevious: l, labelNext: c } } = Fc();
  return I.createElement(
    "nav",
    { ...o },
    I.createElement(
      a.PreviousMonthButton,
      { type: "button", className: s[Le.PreviousMonthButton], tabIndex: r ? void 0 : -1, disabled: r ? void 0 : !0, "aria-label": l(r), onClick: e.onPreviousClick },
      I.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: s[Le.Chevron], orientation: "left" })
    ),
    I.createElement(
      a.NextMonthButton,
      { type: "button", className: s[Le.NextMonthButton], tabIndex: i ? void 0 : -1, disabled: i ? void 0 : !0, "aria-label": c(i), onClick: e.onNextClick },
      I.createElement(a.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: s[Le.Chevron] })
    )
  );
}
function Lte(e) {
  const { components: t } = Fc();
  return I.createElement(t.Button, { ...e });
}
function Bte(e) {
  return I.createElement("option", { ...e });
}
function Fte(e) {
  const { components: t } = Fc();
  return I.createElement(t.Button, { ...e });
}
function Wte(e) {
  return I.createElement("div", { ...e });
}
function zte(e) {
  return I.createElement("select", { ...e });
}
function Vte(e) {
  const { week: t, ...n } = e;
  return I.createElement("tr", { ...n });
}
function Ute(e) {
  return I.createElement("th", { ...e });
}
function Hte(e) {
  return I.createElement(
    "thead",
    null,
    I.createElement("tr", { ...e })
  );
}
function Kte(e) {
  const { week: t, ...n } = e;
  return I.createElement("th", { ...n });
}
function Gte(e) {
  return I.createElement("th", { ...e });
}
function Yte(e) {
  return I.createElement("tbody", { ...e });
}
function qte(e) {
  const { components: t } = Fc();
  return I.createElement(t.Dropdown, { ...e });
}
const Xte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Ote,
  CaptionLabel: Ate,
  Chevron: Tte,
  Day: Pte,
  DayButton: Cte,
  Dropdown: Ete,
  DropdownNav: kte,
  Footer: Mte,
  Month: Nte,
  MonthCaption: $te,
  MonthGrid: Dte,
  Months: Ite,
  MonthsDropdown: Rte,
  Nav: jte,
  NextMonthButton: Lte,
  Option: Bte,
  PreviousMonthButton: Fte,
  Root: Wte,
  Select: zte,
  Week: Vte,
  WeekNumber: Kte,
  WeekNumberHeader: Gte,
  Weekday: Ute,
  Weekdays: Hte,
  Weeks: Yte,
  YearsDropdown: qte
}, Symbol.toStringTag, { value: "Module" }));
function Zte(e) {
  return {
    ...Xte,
    ...e
  };
}
function Jte(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function Qte() {
  const e = {};
  for (const t in Le)
    e[Le[t]] = `rdp-${Le[t]}`;
  for (const t in Lt)
    e[Lt[t]] = `rdp-${Lt[t]}`;
  for (const t in Ei)
    e[Ei[t]] = `rdp-${Ei[t]}`;
  return e;
}
function cL(e, t, n) {
  return (n ?? new Jo(t)).format(e, "LLLL y");
}
const ene = cL;
function tne(e, t, n) {
  return (n ?? new Jo(t)).format(e, "d");
}
function nne(e, t) {
  var n;
  return (n = t.localize) == null ? void 0 : n.month(e);
}
function rne(e) {
  return e < 10 ? `0${e.toLocaleString()}` : `${e.toLocaleString()}`;
}
function ine() {
  return "";
}
function one(e, t, n) {
  return (n ?? new Jo(t)).format(e, "cccccc");
}
function uL(e) {
  return e.toString();
}
const ane = uL, sne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: cL,
  formatDay: tne,
  formatMonthCaption: ene,
  formatMonthDropdown: nne,
  formatWeekNumber: rne,
  formatWeekNumberHeader: ine,
  formatWeekdayName: one,
  formatYearCaption: ane,
  formatYearDropdown: uL
}, Symbol.toStringTag, { value: "Module" }));
function lne(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...sne,
    ...e
  };
}
function cne(e, t, n, r, i) {
  if (!t || !n)
    return;
  const { addMonths: o, startOfMonth: a, isBefore: s } = i, l = e.getFullYear(), c = [];
  let f = t;
  for (; c.length < 12 && s(f, o(n, 1)); )
    c.push(f.getMonth()), f = o(f, 1);
  return c.sort((m, y) => m - y).map((m) => {
    const y = r.formatMonthDropdown(m, i.options.locale ?? Hg), g = i.Date ? new i.Date(l, m) : new Date(l, m), v = t && g < a(t) || n && g > a(n) || !1;
    return { value: m, label: y, disabled: v };
  });
}
function une(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[Le.Day] };
  return Object.entries(e).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[i]
    };
  }), r;
}
const Pb = {}, Wu = {};
function Qu(e, t) {
  try {
    const r = (Pb[e] || (Pb[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in Wu ? Wu[r] : _E(r, r.split(":"));
  } catch {
    if (e in Wu) return Wu[e];
    const n = e == null ? void 0 : e.match(fne);
    return n ? _E(e, n.slice(1)) : NaN;
  }
}
const fne = /([+-]\d\d):?(\d\d)?/;
function _E(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return Wu[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Wi extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Qu(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), fL(this), hx(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Wi(...n, t) : new Wi(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Wi(+this, t);
  }
  getTimezoneOffset() {
    return -Qu(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), hx(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Wi(+new Date(t), this.timeZone);
  }
  //#endregion
}
const SE = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!SE.test(e)) return;
  const t = e.replace(SE, "$1UTC");
  Wi.prototype[t] && (e.startsWith("get") ? Wi.prototype[e] = function() {
    return this.internal[t]();
  } : (Wi.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), dne(this), +this;
  }, Wi.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), hx(this), +this;
  }));
});
function hx(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function dne(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), fL(e);
}
function fL(e) {
  const t = Qu(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), o = r - i, a = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  o && a && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + o);
  const s = r - t;
  s && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + s);
  const l = Qu(e.timeZone, e), f = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - l, d = l !== t, p = f - s;
  if (d && p) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + p);
    const m = Qu(e.timeZone, e), y = l - m;
    y && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + y), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y));
  }
}
class zi extends Wi {
  //#region static
  static tz(t, ...n) {
    return n.length ? new zi(...n, t) : new zi(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), i = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, i] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${t} GMT${n}${r}${i} (${hne(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), i = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(t) {
    return new zi(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new zi(+new Date(t), this.timeZone);
  }
  //#endregion
}
function hne(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
function pne(e, t, n) {
  const r = n ? zi.tz(n) : e.Date ? new e.Date() : /* @__PURE__ */ new Date(), i = t ? e.startOfISOWeek(r) : e.startOfWeek(r), o = [];
  for (let a = 0; a < 7; a++) {
    const s = e.addDays(i, a);
    o.push(s);
  }
  return o;
}
function mne(e, t, n, r, i) {
  if (!t || !n)
    return;
  const { startOfMonth: o, startOfYear: a, endOfYear: s, addYears: l, isBefore: c, isSameYear: f } = i, d = e.getMonth(), p = a(t), m = s(n), y = [];
  let g = p;
  for (; c(g, m) || f(g, m); )
    y.push(g.getFullYear()), g = l(g, 1);
  return y.map((v) => {
    const x = i.Date ? new i.Date(v, d) : new Date(v, d), w = t && x < o(t) || d && n && x > o(n) || !1, S = r.formatYearDropdown(v);
    return {
      value: v,
      label: S,
      disabled: w
    };
  });
}
function dL(e, t, n) {
  return (n ?? new Jo(t)).format(e, "LLLL y");
}
const gne = dL;
function yne(e, t, n, r) {
  let i = (r ?? new Jo(n)).format(e, "PPPP");
  return t != null && t.today && (i = `Today, ${i}`), i;
}
function hL(e, t, n, r) {
  let i = (r ?? new Jo(n)).format(e, "PPPP");
  return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
const vne = hL;
function bne() {
  return "";
}
function xne(e) {
  return "Choose the Month";
}
function wne(e) {
  return "Go to the Next Month";
}
function _ne(e) {
  return "Go to the Previous Month";
}
function Sne(e, t, n) {
  return (n ?? new Jo(t)).format(e, "cccc");
}
function One(e, t) {
  return `Week ${e}`;
}
function Ane(e) {
  return "Week Number";
}
function Tne(e) {
  return "Choose the Year";
}
const Pne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: gne,
  labelDay: vne,
  labelDayButton: hL,
  labelGrid: dL,
  labelGridcell: yne,
  labelMonthDropdown: xne,
  labelNav: bne,
  labelNext: wne,
  labelPrevious: _ne,
  labelWeekNumber: One,
  labelWeekNumberHeader: Ane,
  labelWeekday: Sne,
  labelYearDropdown: Tne
}, Symbol.toStringTag, { value: "Module" })), px = 42;
function Cne(e, t, n, r) {
  const i = e[0], o = e[e.length - 1], { ISOWeek: a, fixedWeeks: s } = n ?? {}, { startOfWeek: l, endOfWeek: c, startOfISOWeek: f, endOfISOWeek: d, addDays: p, differenceInCalendarDays: m, differenceInCalendarMonths: y, isAfter: g, endOfMonth: v } = r, x = a ? f(i) : l(i), w = a ? d(v(o)) : c(v(o)), S = m(w, x), A = y(o, i) + 1, _ = [];
  for (let P = 0; P <= S; P++) {
    const C = p(x, P);
    if (t && g(C, t))
      break;
    _.push(C);
  }
  const O = px * A;
  if (s && _.length < O) {
    const P = O - _.length;
    for (let C = 0; C < P; C++) {
      const k = p(_[_.length - 1], 1);
      _.push(k);
    }
  }
  return _;
}
function Ene(e) {
  const t = [];
  return e.reduce((n, r) => {
    const i = [], o = r.weeks.reduce((a, s) => [...a, ...s.days], i);
    return [...n, ...o];
  }, t);
}
function kne(e, t, n, r) {
  const { numberOfMonths: i = 1 } = n, o = [];
  for (let a = 0; a < i; a++) {
    const s = r.addMonths(e, a);
    if (t && s > t)
      break;
    o.push(s);
  }
  return o;
}
function OE(e, t) {
  const { month: n, defaultMonth: r, today: i = e.timeZone ? zi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date(), numberOfMonths: o = 1, endMonth: a, startMonth: s } = e;
  let l = n || r || i;
  const { differenceInCalendarMonths: c, addMonths: f, startOfMonth: d } = t;
  if (a && c(a, l) < 0) {
    const p = -1 * (o - 1);
    l = f(a, p);
  }
  return s && c(l, s) < 0 && (l = s), d(l);
}
class pL {
  constructor(t, n, r = Zs) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Mne {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class Nne {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function $ne(e, t, n, r) {
  const { startOfWeek: i, endOfWeek: o, startOfISOWeek: a, endOfISOWeek: s, endOfMonth: l, addDays: c, getWeek: f, getISOWeek: d } = r, p = e.reduce((m, y) => {
    const g = n.ISOWeek ? a(y) : i(y), v = n.ISOWeek ? s(l(y)) : o(l(y)), x = t.filter((A) => A >= g && A <= v);
    if (n.fixedWeeks && x.length < px) {
      const A = t.filter((_) => {
        const O = px - x.length;
        return _ > v && _ <= c(v, O);
      });
      x.push(...A);
    }
    const w = x.reduce((A, _) => {
      const O = n.ISOWeek ? d(_) : f(_), P = A.find((k) => k.weekNumber === O), C = new pL(_, y, r);
      return P ? P.days.push(C) : A.push(new Nne(O, [C])), A;
    }, []), S = new Mne(y, w);
    return m.push(S), m;
  }, []);
  return n.reverseMonths ? p.reverse() : p;
}
function Dne(e, t) {
  var g;
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: i, startOfDay: o, startOfMonth: a, endOfMonth: s, addYears: l, endOfYear: c } = t, { fromYear: f, toYear: d, fromMonth: p, toMonth: m } = e;
  !n && p && (n = p), !n && f && (n = new Date(f, 0, 1)), !r && m && (r = m), !r && d && (r = new Date(d, 11, 31));
  const y = (g = e.captionLayout) == null ? void 0 : g.startsWith("dropdown");
  if (n)
    n = a(n);
  else if (f)
    n = new Date(f, 0, 1);
  else if (!n && y) {
    const v = e.today ?? (e.timeZone ? zi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    n = i(l(v, -100));
  }
  if (r)
    r = s(r);
  else if (d)
    r = new Date(d, 11, 31);
  else if (!r && y) {
    const v = e.today ?? (e.timeZone ? zi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    r = c(v);
  }
  return [
    n && o(n),
    r && o(r)
  ];
}
function Ine(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: o = 1 } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = i ? o : 1, f = a(e);
  if (!t)
    return s(f, c);
  if (!(l(t, e) < o))
    return s(f, c);
}
function Rne(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: o } = n, { startOfMonth: a, addMonths: s, differenceInCalendarMonths: l } = r, c = i ? o ?? 1 : 1, f = a(e);
  if (!t)
    return s(f, -c);
  if (!(l(f, t) <= 0))
    return s(f, -c);
}
function jne(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function Kg(e, t) {
  const [n, r] = Me(e);
  return [t === void 0 ? n : t, r];
}
function Lne(e, t) {
  const [n, r] = Dne(e, t), { startOfMonth: i, endOfMonth: o } = t, a = OE(e, t), [s, l] = Kg(a, e.month ? i(e.month) : void 0);
  Xe(() => {
    const O = OE(e, t);
    l(O);
  }, [e.timeZone]);
  const c = kne(s, r, e, t), f = Cne(c, e.endMonth ? o(e.endMonth) : void 0, e, t), d = $ne(c, f, e, t), p = jne(d), m = Ene(d), y = Rne(s, n, e, t), g = Ine(s, r, e, t), { disableNavigation: v, onMonthChange: x } = e, w = (O) => p.some((P) => P.days.some((C) => C.isEqualTo(O))), S = (O) => {
    if (v)
      return;
    let P = i(O);
    n && P < i(n) && (P = i(n)), r && P > i(r) && (P = i(r)), l(P), x == null || x(P);
  };
  return {
    months: d,
    weeks: p,
    days: m,
    navStart: n,
    navEnd: r,
    previousMonth: y,
    nextMonth: g,
    goToMonth: S,
    goToDay: (O) => {
      w(O) || S(O.date);
    }
  };
}
function Bne(e, t, n, r) {
  let i, o = 0, a = !1;
  for (; o < e.length && !a; ) {
    const s = e[o], l = t(s);
    !l[Lt.disabled] && !l[Lt.hidden] && !l[Lt.outside] && (l[Lt.focused] || r != null && r.isEqualTo(s) || n(s.date) || l[Lt.today]) && (i = s, a = !0), o++;
  }
  return i || (i = e.find((s) => {
    const l = t(s);
    return !l[Lt.disabled] && !l[Lt.hidden] && !l[Lt.outside];
  })), i;
}
function To(e, t, n = !1, r = Zs) {
  let { from: i, to: o } = e;
  const { differenceInCalendarDays: a, isSameDay: s } = r;
  return i && o ? (a(o, i) < 0 && ([i, o] = [o, i]), a(t, i) >= (n ? 1 : 0) && a(o, t) >= (n ? 1 : 0)) : !n && o ? s(o, t) : !n && i ? s(i, t) : !1;
}
function mL(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function k_(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function gL(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function yL(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function vL(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function bL(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Po(e, t, n = Zs) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: o, isAfter: a } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return i(e, s);
    if (bL(s, n))
      return s.includes(e);
    if (k_(s))
      return To(s, e, !1, n);
    if (vL(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(e.getDay()) : s.dayOfWeek === e.getDay();
    if (mL(s)) {
      const l = o(s.before, e), c = o(s.after, e), f = l > 0, d = c < 0;
      return a(s.before, s.after) ? d && f : f || d;
    }
    return gL(s) ? o(e, s.after) > 0 : yL(s) ? o(s.before, e) > 0 : typeof s == "function" ? s(e) : !1;
  });
}
function Fne(e, t, n, r, i, o, a) {
  const { ISOWeek: s } = o, { addDays: l, addMonths: c, addYears: f, addWeeks: d, startOfISOWeek: p, endOfISOWeek: m, startOfWeek: y, endOfWeek: g, max: v, min: x } = a;
  let S = {
    day: l,
    week: d,
    month: c,
    year: f,
    startOfWeek: (A) => s ? p(A) : y(A),
    endOfWeek: (A) => s ? m(A) : g(A)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? S = v([r, S]) : t === "after" && i && (S = x([i, S])), S;
}
function xL(e, t, n, r, i, o, a, s = 0) {
  if (s > 365)
    return;
  const l = Fne(
    e,
    t,
    n.date,
    // should be refDay? or refDay.date?
    r,
    i,
    o,
    a
  ), c = !!(o.disabled && Po(l, o.disabled, a)), f = !!(o.hidden && Po(l, o.hidden, a)), d = l, p = new pL(l, d, a);
  return !c && !f ? p : xL(e, t, p, r, i, o, a, s + 1);
}
function Wne(e, t, n, r, i) {
  const { autoFocus: o } = e, [a, s] = Me(), l = Bne(t.days, n, r || (() => !1), a), [c, f] = Me(o ? l : void 0);
  return {
    isFocusTarget: (g) => !!(l != null && l.isEqualTo(g)),
    setFocused: f,
    focused: c,
    blur: () => {
      s(c), f(void 0);
    },
    moveFocus: (g, v) => {
      if (!c)
        return;
      const x = xL(g, v, c, t.navStart, t.navEnd, e, i);
      x && (t.goToDay(x), f(x));
    }
  };
}
function zne(e, t, n) {
  const { disabled: r, hidden: i, modifiers: o, showOutsideDays: a, today: s } = t, { isSameDay: l, isSameMonth: c, startOfMonth: f, isBefore: d, endOfMonth: p, isAfter: m } = n, y = t.startMonth && f(t.startMonth), g = t.endMonth && p(t.endMonth), v = {
    [Lt.focused]: [],
    [Lt.outside]: [],
    [Lt.disabled]: [],
    [Lt.hidden]: [],
    [Lt.today]: []
  }, x = {};
  for (const w of e) {
    const { date: S, displayMonth: A } = w, _ = !!(A && !c(S, A)), O = !!(y && d(S, y)), P = !!(g && m(S, g)), C = !!(r && Po(S, r, n)), k = !!(i && Po(S, i, n)) || O || P || !a && _, D = l(S, s ?? (t.timeZone ? zi.tz(t.timeZone) : n.Date ? new n.Date() : /* @__PURE__ */ new Date()));
    _ && v.outside.push(w), C && v.disabled.push(w), k && v.hidden.push(w), D && v.today.push(w), o && Object.keys(o).forEach(($) => {
      const N = o == null ? void 0 : o[$];
      N && Po(S, N, n) && (x[$] ? x[$].push(w) : x[$] = [w]);
    });
  }
  return (w) => {
    const S = {
      [Lt.focused]: !1,
      [Lt.disabled]: !1,
      [Lt.hidden]: !1,
      [Lt.outside]: !1,
      [Lt.today]: !1
    }, A = {};
    for (const _ in v) {
      const O = v[_];
      S[_] = O.some((P) => P === w);
    }
    for (const _ in x)
      A[_] = x[_].some((O) => O === w);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...A
    };
  };
}
function Vne(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [o, a] = Kg(n, i ? n : void 0), s = i ? n : o, { isSameDay: l } = t, c = (m) => (s == null ? void 0 : s.some((y) => l(y, m))) ?? !1, { min: f, max: d } = e;
  return {
    selected: s,
    select: (m, y, g) => {
      let v = [...s ?? []];
      if (c(m)) {
        if ((s == null ? void 0 : s.length) === f || r && (s == null ? void 0 : s.length) === 1)
          return;
        v = s == null ? void 0 : s.filter((x) => !l(x, m));
      } else
        (s == null ? void 0 : s.length) === d ? v = [m] : v = [...v, m];
      return i || a(v), i == null || i(v, m, y, g), v;
    },
    isSelected: c
  };
}
function Une(e, t, n = 0, r = 0, i = !1, o = Zs) {
  const { from: a, to: s } = t || {}, { isSameDay: l, isAfter: c, isBefore: f } = o;
  let d;
  if (!a && !s)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !s)
    l(a, e) ? i ? d = { from: a, to: void 0 } : d = void 0 : f(e, a) ? d = { from: e, to: a } : d = { from: a, to: e };
  else if (a && s)
    if (l(a, e) && l(s, e))
      i ? d = { from: a, to: s } : d = void 0;
    else if (l(a, e))
      d = { from: a, to: n > 0 ? void 0 : e };
    else if (l(s, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, a))
      d = { from: e, to: s };
    else if (c(e, a))
      d = { from: a, to: e };
    else if (c(e, s))
      d = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const p = o.differenceInCalendarDays(d.to, d.from);
    r > 0 && p > r ? d = { from: e, to: void 0 } : n > 1 && p < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function Hne(e, t, n = Zs) {
  const r = Array.isArray(t) ? t : [t];
  let i = e.from;
  const o = n.differenceInCalendarDays(e.to, e.from), a = Math.min(o, 6);
  for (let s = 0; s <= a; s++) {
    if (r.includes(i.getDay()))
      return !0;
    i = n.addDays(i, 1);
  }
  return !1;
}
function AE(e, t, n = Zs) {
  return To(e, t.from, !1, n) || To(e, t.to, !1, n) || To(t, e.from, !1, n) || To(t, e.to, !1, n);
}
function Kne(e, t, n = Zs) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? To(e, s, !1, n) : bL(s, n) ? s.some((l) => To(e, l, !1, n)) : k_(s) ? s.from && s.to ? AE(e, { from: s.from, to: s.to }, n) : !1 : vL(s) ? Hne(e, s.dayOfWeek, n) : mL(s) ? n.isAfter(s.before, s.after) ? AE(e, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : Po(e.from, s, n) || Po(e.to, s, n) : gL(s) || yL(s) ? Po(e.from, s, n) || Po(e.to, s, n) : !1))
    return !0;
  const a = r.filter((s) => typeof s == "function");
  if (a.length) {
    let s = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (a.some((f) => f(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function Gne(e, t) {
  const { disabled: n, excludeDisabled: r, selected: i, required: o, onSelect: a } = e, [s, l] = Kg(i, a ? i : void 0), c = a ? i : s;
  return {
    selected: c,
    select: (p, m, y) => {
      const { min: g, max: v } = e, x = p ? Une(p, c, g, v, o, t) : void 0;
      return r && n && (x != null && x.from) && x.to && Kne({ from: x.from, to: x.to }, n, t) && (x.from = p, x.to = void 0), a || l(x), a == null || a(x, p, m, y), x;
    },
    isSelected: (p) => c && To(c, p, !1, t)
  };
}
function Yne(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [o, a] = Kg(n, i ? n : void 0), s = i ? n : o, { isSameDay: l } = t;
  return {
    selected: s,
    select: (d, p, m) => {
      let y = d;
      return !r && s && s && l(d, s) && (y = void 0), i || a(y), i == null || i(y, d, p, m), y;
    },
    isSelected: (d) => s ? l(s, d) : !1
  };
}
function qne(e, t) {
  const n = Yne(e, t), r = Vne(e, t), i = Gne(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function Xne(e) {
  const { components: t, formatters: n, labels: r, dateLib: i, locale: o, classNames: a } = Fe(() => {
    const tt = { ...Hg, ...e.locale };
    return {
      dateLib: new Jo({
        locale: tt,
        weekStartsOn: e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens
      }, e.dateLib),
      components: Zte(e.components),
      formatters: lne(e.formatters),
      labels: { ...Pne, ...e.labels },
      locale: tt,
      classNames: { ...Qte(), ...e.classNames }
    };
  }, [
    e.classNames,
    e.components,
    e.dateLib,
    e.firstWeekContainsDate,
    e.formatters,
    e.labels,
    e.locale,
    e.useAdditionalDayOfYearTokens,
    e.useAdditionalWeekYearTokens,
    e.weekStartsOn
  ]), { captionLayout: s, mode: l, onDayBlur: c, onDayClick: f, onDayFocus: d, onDayKeyDown: p, onDayMouseEnter: m, onDayMouseLeave: y, onNextClick: g, onPrevClick: v, showWeekNumber: x, styles: w } = e, { formatCaption: S, formatDay: A, formatMonthDropdown: _, formatWeekNumber: O, formatWeekNumberHeader: P, formatWeekdayName: C, formatYearDropdown: k } = n, D = Lne(e, i), { days: $, months: N, navStart: R, navEnd: L, previousMonth: F, nextMonth: W, goToMonth: z } = D, G = zne($, e, i), { isSelected: U, select: V, selected: Y } = qne(e, i) ?? {}, { blur: ee, focused: ie, isFocusTarget: re, moveFocus: le, setFocused: ae } = Wne(e, D, G, U ?? (() => !1), i), { labelDayButton: ue, labelGridcell: ne, labelGrid: J, labelMonthDropdown: fe, labelNav: be, labelWeekday: X, labelWeekNumber: De, labelWeekNumberHeader: pe, labelYearDropdown: ke } = r, it = Fe(() => pne(i, e.ISOWeek, e.timeZone), [i, e.ISOWeek, e.timeZone]), st = l !== void 0 || f !== void 0, Xn = qe(() => {
    F && (z(F), v == null || v(F));
  }, [F, z, v]), Ie = qe(() => {
    W && (z(W), g == null || g(W));
  }, [z, W, g]), lt = qe((tt, Kt) => (St) => {
    St.preventDefault(), St.stopPropagation(), ae(tt), V == null || V(tt.date, Kt, St), f == null || f(tt.date, Kt, St);
  }, [V, f, ae]), Oe = qe((tt, Kt) => (St) => {
    ae(tt), d == null || d(tt.date, Kt, St);
  }, [d, ae]), Ke = qe((tt, Kt) => (St) => {
    ee(), c == null || c(tt.date, Kt, St);
  }, [ee, c]), Zt = qe((tt, Kt) => (St) => {
    const jn = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [St.shiftKey ? "year" : "month", "before"],
      PageDown: [St.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (jn[St.key]) {
      St.preventDefault(), St.stopPropagation();
      const [qr, so] = jn[St.key];
      le(qr, so);
    }
    p == null || p(tt.date, Kt, St);
  }, [le, p, e.dir]), mt = qe((tt, Kt) => (St) => {
    m == null || m(tt.date, Kt, St);
  }, [m]), en = qe((tt, Kt) => (St) => {
    y == null || y(tt.date, Kt, St);
  }, [y]), { className: Yr, style: Cn } = Fe(() => ({
    className: [a[Le.Root], e.className].filter(Boolean).join(" "),
    style: { ...w == null ? void 0 : w[Le.Root], ...e.style }
  }), [a, e.className, e.style, w]), yn = Jte(e), mr = {
    dayPickerProps: e,
    selected: Y,
    select: V,
    isSelected: U,
    months: N,
    nextMonth: W,
    previousMonth: F,
    goToMonth: z,
    getModifiers: G,
    components: t,
    classNames: a,
    styles: w,
    labels: r,
    formatters: n
  };
  return I.createElement(
    lL.Provider,
    { value: mr },
    I.createElement(
      t.Root,
      { className: Yr, style: Cn, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, ...yn },
      I.createElement(
        t.Months,
        { className: a[Le.Months], style: w == null ? void 0 : w[Le.Months] },
        !e.hideNavigation && I.createElement(t.Nav, { className: a[Le.Nav], style: w == null ? void 0 : w[Le.Nav], "aria-label": be(), onPreviousClick: Xn, onNextClick: Ie, previousMonth: F, nextMonth: W }),
        N.map((tt, Kt) => {
          const St = (un) => {
            const Pr = Number(un.target.value), fn = i.setMonth(i.startOfMonth(tt.date), Pr);
            z(fn);
          }, jn = (un) => {
            const Pr = i.setYear(i.startOfMonth(tt.date), Number(un.target.value));
            z(Pr);
          }, qr = cne(tt.date, R, L, n, i), so = mne(N[0].date, R, L, n, i);
          return I.createElement(
            t.Month,
            { className: a[Le.Month], style: w == null ? void 0 : w[Le.Month], key: Kt, displayIndex: Kt, calendarMonth: tt },
            I.createElement(t.MonthCaption, { className: a[Le.MonthCaption], style: w == null ? void 0 : w[Le.MonthCaption], calendarMonth: tt, displayIndex: Kt }, s != null && s.startsWith("dropdown") ? I.createElement(
              t.DropdownNav,
              { className: a[Le.Dropdowns], style: w == null ? void 0 : w[Le.Dropdowns] },
              s === "dropdown" || s === "dropdown-months" ? I.createElement(t.MonthsDropdown, { className: a[Le.MonthsDropdown], "aria-label": fe(), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: St, options: qr, style: w == null ? void 0 : w[Le.Dropdown], value: tt.date.getMonth() }) : I.createElement("span", { role: "status", "aria-live": "polite" }, _(tt.date.getMonth(), o)),
              s === "dropdown" || s === "dropdown-years" ? I.createElement(t.YearsDropdown, { className: a[Le.YearsDropdown], "aria-label": ke(i.options), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: jn, options: so, style: w == null ? void 0 : w[Le.Dropdown], value: tt.date.getFullYear() }) : I.createElement("span", { role: "status", "aria-live": "polite" }, k(tt.date.getFullYear()))
            ) : I.createElement(t.CaptionLabel, { className: a[Le.CaptionLabel], role: "status", "aria-live": "polite" }, S(tt.date, i.options, i))),
            I.createElement(
              t.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": J(tt.date, i.options, i) || void 0, className: a[Le.MonthGrid], style: w == null ? void 0 : w[Le.MonthGrid] },
              !e.hideWeekdays && I.createElement(
                t.Weekdays,
                { className: a[Le.Weekdays], style: w == null ? void 0 : w[Le.Weekdays] },
                x && I.createElement(t.WeekNumberHeader, { "aria-label": pe(i.options), className: a[Le.WeekNumberHeader], style: w == null ? void 0 : w[Le.WeekNumberHeader], scope: "col" }, P()),
                it.map((un, Pr) => I.createElement(t.Weekday, { "aria-label": X(un, i.options, i), className: a[Le.Weekday], key: Pr, style: w == null ? void 0 : w[Le.Weekday], scope: "col" }, C(un, i.options, i)))
              ),
              I.createElement(t.Weeks, { className: a[Le.Weeks], style: w == null ? void 0 : w[Le.Weeks] }, tt.weeks.map((un, Pr) => I.createElement(
                t.Week,
                { className: a[Le.Week], key: un.weekNumber, style: w == null ? void 0 : w[Le.Week], week: un },
                x && I.createElement(t.WeekNumber, { week: un, style: w == null ? void 0 : w[Le.WeekNumber], "aria-label": De(un.weekNumber, {
                  locale: o
                }), className: a[Le.WeekNumber], scope: "row" }, O(un.weekNumber)),
                un.days.map((fn) => {
                  const { date: Xr } = fn, yt = G(fn);
                  if (yt[Lt.focused] = !yt.hidden && !!(ie != null && ie.isEqualTo(fn)), yt[Ei.selected] = !yt.disabled && ((U == null ? void 0 : U(Xr)) || yt.selected), k_(Y)) {
                    const { from: tu, to: nu } = Y;
                    yt[Ei.range_start] = !!(tu && nu && i.isSameDay(Xr, tu)), yt[Ei.range_end] = !!(tu && nu && i.isSameDay(Xr, nu)), yt[Ei.range_middle] = To(Y, Xr, !0, i);
                  }
                  const Rd = une(yt, w, e.modifiersStyles), jd = Ste(yt, a, e.modifiersClassNames), Ey = st ? void 0 : ne(Xr, yt, i.options, i);
                  return I.createElement(t.Day, { key: `${i.format(Xr, "yyyy-MM-dd")}_${i.format(fn.displayMonth, "yyyy-MM")}`, day: fn, modifiers: yt, className: jd.join(" "), style: Rd, "aria-hidden": yt.hidden || void 0, "aria-selected": yt.selected || void 0, "aria-label": Ey, "data-day": i.format(Xr, "yyyy-MM-dd"), "data-month": fn.outside ? i.format(Xr, "yyyy-MM") : void 0, "data-selected": yt.selected || void 0, "data-disabled": yt.disabled || void 0, "data-hidden": yt.hidden || void 0, "data-outside": fn.outside || void 0, "data-focused": yt.focused || void 0, "data-today": yt.today || void 0 }, st ? I.createElement(t.DayButton, { className: a[Le.DayButton], style: w == null ? void 0 : w[Le.DayButton], type: "button", day: fn, modifiers: yt, disabled: yt.disabled || void 0, tabIndex: re(fn) ? 0 : -1, "aria-label": ue(Xr, yt, i.options, i), onClick: lt(fn, yt), onBlur: Ke(fn, yt), onFocus: Oe(fn, yt), onKeyDown: Zt(fn, yt), onMouseEnter: mt(fn, yt), onMouseLeave: en(fn, yt) }, A(Xr, i.options, i)) : A(fn.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      e.footer && I.createElement(t.Footer, { className: a[Le.Footer], style: w == null ? void 0 : w[Le.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const TE = () => /* @__PURE__ */ E("span", { className: "bg-icon-interactive h-1 w-1 absolute rounded-full inline-block bottom-0 left-1/2 right-1/2" }), PE = (e) => Fn(e, "E").slice(0, 1), Zne = (e, t = 24) => Array.from({ length: t }, (n, r) => e + r), CE = (e) => {
  if (e === "multiple")
    return [];
  if (e === "range")
    return { from: void 0, to: void 0 };
}, Cb = ({
  width: e,
  className: t,
  // Renamed to avoid shadowing
  classNames: n,
  selectedDates: r,
  setSelectedDates: i,
  showOutsideDays: o = !0,
  mode: a = "single",
  variant: s = "normal",
  alignment: l = "horizontal",
  numberOfMonths: c,
  disabled: f,
  ...d
}) => {
  const p = I.isValidElement(d.footer) || typeof d.footer == "function", [m, y] = Me(!1), [g, v] = Me(!1), [x, w] = Me((/* @__PURE__ */ new Date()).getFullYear()), [S, A] = Me(
    x - x % 24
  );
  r === void 0 && (a === "multiple" ? r = [] : a === "range" ? r = { from: void 0, to: void 0 } : r = void 0);
  function _($) {
    const { goToMonth: N, nextMonth: R, previousMonth: L } = Fc(), F = Fn(
      $.calendarMonth.date,
      "yyyy"
    ), W = Fn($.calendarMonth.date, "MMMM"), z = new Date($.calendarMonth.date);
    z.setDate(z.getDate() - z.getDay());
    const G = Array.from({ length: 7 }, (ie, re) => {
      const le = new Date(z);
      return le.setDate(z.getDate() + re), PE(le);
    }), U = () => {
      if (g)
        A(S - 24);
      else if (m) {
        const ie = new Date(
          x - 1,
          $.calendarMonth.date.getMonth()
        );
        w(ie.getFullYear()), N(ie);
      } else
        N(L);
    }, V = () => {
      if (g)
        A(S + 24);
      else if (m) {
        const ie = new Date(
          x + 1,
          $.calendarMonth.date.getMonth()
        );
        w(ie.getFullYear()), N(ie);
      } else
        N(R);
    }, Y = (ie) => {
      w(ie), v(!1), y(!0), N(
        new Date(
          ie,
          $.calendarMonth.date.getMonth()
        )
      );
    };
    let ee;
    return g ? ee = `${S} - ${S + 23}` : m ? ee = F : ee = `${W} ${F}`, /* @__PURE__ */ he(Ut, { children: [
      /* @__PURE__ */ he("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ E(
          Hn,
          {
            variant: "ghost",
            onClick: U,
            className: "bg-background-primary border-none cursor-pointer",
            "aria-label": "Previous Button",
            icon: /* @__PURE__ */ E(Q$, { className: "h-4 w-4 text-button-tertiary-color" })
          }
        ),
        /* @__PURE__ */ E(
          Hn,
          {
            variant: "ghost",
            onClick: () => {
              c > 1 || (m ? (v(!0), y(!1)) : g ? v(!1) : y(!m));
            },
            children: ee
          }
        ),
        /* @__PURE__ */ E(
          Hn,
          {
            variant: "ghost",
            onClick: V,
            className: "bg-background-primary border-none cursor-pointer",
            "aria-label": "Next Button",
            icon: /* @__PURE__ */ E(Zw, { className: "h-4 w-4 text-button-tertiary-color" })
          }
        )
      ] }),
      g && /* @__PURE__ */ E("div", { className: "grid grid-cols-4 w-full", children: Zne(S).map((ie) => /* @__PURE__ */ he(
        Hn,
        {
          variant: "ghost",
          onClick: () => Y(ie),
          className: K(
            "h-10 w-full text-center font-normal relative",
            ie === x && ie !== (/* @__PURE__ */ new Date()).getFullYear() && "bg-background-brand text-text-on-color hover:bg-background-brand hover:text-black",
            ie === (/* @__PURE__ */ new Date()).getFullYear() && "font-semibold"
          ),
          children: [
            ie,
            ie === (/* @__PURE__ */ new Date()).getFullYear() && TE()
          ]
        },
        ie
      )) }),
      m && !g && /* @__PURE__ */ E("div", { className: "grid grid-cols-4 gap-2 my-12", children: Array.from({ length: 12 }, (ie, re) => /* @__PURE__ */ he(
        Hn,
        {
          variant: "ghost",
          onClick: () => {
            y(!1), N(
              new Date(x, re)
            );
          },
          className: K(
            "px-1.5 py-2 h-10 w-[4.375rem] text-center font-normal relative",
            re === $.calendarMonth.date.getMonth() && re !== (/* @__PURE__ */ new Date()).getMonth() && x === $.calendarMonth.date.getFullYear() && $.calendarMonth.date.getFullYear() !== (/* @__PURE__ */ new Date()).getFullYear() && "bg-background-brand text-text-on-color hover:bg-background-brand hover:text-black",
            re === (/* @__PURE__ */ new Date()).getMonth() && (/* @__PURE__ */ new Date()).getFullYear() === x && "font-semibold"
          ),
          children: [
            Fn(new Date(0, re), "MMM"),
            (/* @__PURE__ */ new Date()).getMonth() === re && (/* @__PURE__ */ new Date()).getFullYear() === x && TE()
          ]
        },
        re
      )) }),
      !m && !g && /* @__PURE__ */ E(O, { weekdays: G })
    ] });
  }
  const O = ({ weekdays: $ }) => /* @__PURE__ */ E("div", { className: "flex justify-between", children: $.map((N, R) => /* @__PURE__ */ E(
    "button",
    {
      className: "h-10 w-10 px-1.5 py-2 text-center text-text-secondary text-sm font-normal content-center bg-transparent border-none shrink-0",
      children: N
    },
    R
  )) }), P = ({
    day: $,
    modifiers: N,
    ...R
  }) => {
    const {
      selected: L,
      today: F,
      disabled: W,
      outside: z,
      range_middle: G,
      range_start: U,
      range_end: V
    } = N, Y = U || V || G, ee = /* @__PURE__ */ new Date(), ie = r == null ? void 0 : r.to, re = Fn($.displayMonth, "yyyy-MM") === Fn(ee, "yyyy-MM"), le = ie && Fn(ie, "yyyy-MM") === Fn($.date, "yyyy-MM"), ae = _te(ee, 1), ue = Fn($.date, "yyyy-MM") === Fn(ae, "yyyy-MM"), ne = re || le || Y, J = !o && z, be = K(
      "h-10 w-10 flex items-center justify-center transition text-text-secondary relative text-sm",
      "border-none rounded",
      (L || Y) && !z ? "bg-background-brand text-text-on-color" : "bg-transparent hover:bg-button-tertiary-hover",
      G && ne && !z ? "bg-brand-background-50 text-text-secondary rounded-none" : "",
      W ? "opacity-50 cursor-not-allowed text-text-disabled" : "cursor-pointer",
      z && !Y || !ne && z || z && !ue || z ? "bg-transparent opacity-50 text-text-disabled cursor-auto" : ""
    ), X = (ke) => {
      typeof R.onMouseEnter == "function" && R.onMouseEnter(ke), ke.currentTarget.setAttribute("data-hover", "true");
    }, De = (ke) => {
      typeof R.onMouseLeave == "function" && R.onMouseLeave(ke), ke.currentTarget.setAttribute("data-hover", "false");
    }, pe = (ke) => {
      typeof R.onClick == "function" && R.onClick(ke);
    };
    return /* @__PURE__ */ he(
      "button",
      {
        className: K(
          be,
          F && "font-semibold",
          J && "opacity-0",
          U && "fui-range-start",
          V && "fui-range-end",
          G && "fui-range-middle",
          {
            "[&:is([data-hover=true])]:bg-brand-background-50 [&:is([data-hover=true])]:rounded-none": !Y && !L
          }
        ),
        disabled: W || z,
        onClick: pe,
        onMouseEnter: X,
        onMouseLeave: De,
        "aria-label": Fn($.date, "EEEE, MMMM do, yyyy"),
        "data-selected": L,
        "data-day": Fn($.date, "yyyy-MM-dd"),
        children: [
          (!J || Y && ne) && R.children,
          F && ne && /* @__PURE__ */ E("span", { className: "absolute h-1 w-1 bg-background-brand rounded-full bottom-1" })
        ]
      }
    );
  }, C = ($) => /* @__PURE__ */ E("div", { className: "flex flex-col bsf-force-ui-month-weeks", children: $.children[1].props.children.map(
    (N, R) => /* @__PURE__ */ E(
      "div",
      {
        className: "flex flex-row justify-between",
        children: N
      },
      R
    )
  ) }), k = ($, N) => {
    if (a === "range") {
      const R = r;
      if (!(R != null && R.from) && !(R != null && R.to) || R != null && R.from && (R != null && R.to)) {
        if (R.from && vE(N, R == null ? void 0 : R.from) || R.to && vE(N, R == null ? void 0 : R.to)) {
          i({ from: void 0, to: void 0 });
          return;
        }
        i({ from: N, to: void 0 });
        return;
      }
      if (R != null && R.from && !(R != null && R.to)) {
        if (N < R.from) {
          i({
            from: N,
            to: R.from
          });
          return;
        }
        i({
          from: R.from,
          to: N
        });
        return;
      }
      i($);
    } else a === "multiple" ? r.some(
      (R) => Fn(R, "yyyy-MM-dd") === Fn(N, "yyyy-MM-dd")
    ) ? i(
      r.filter(
        (R) => Fn(R, "yyyy-MM-dd") !== Fn(N, "yyyy-MM-dd")
      )
    ) : i([...r, N]) : a === "single" && i($);
  }, D = K(
    "relative bg-background-primary shadow-datepicker-wrapper",
    e,
    l === "vertical" ? "flex flex-col" : "flex flex-row  gap-3",
    s === "normal" ? "rounded-tr-md rounded-tl-md border border-solid border-border-subtle" : "",
    s === "presets" ? "rounded-tr-md border border-solid border-border-subtle" : "",
    s === "dualdate" ? "rounded-tr-md rounded-tl-md border border-solid border-border-subtle" : "",
    p ? "rounded-b-none" : "rounded-bl-md rounded-br-md"
  );
  return /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(
    Xne,
    {
      mode: a,
      selected: r,
      onSelect: k,
      hideNavigation: !0,
      captionLayout: "label",
      className: K(t),
      formatters: {
        formatWeekdayName: PE
      },
      classNames: {
        months: D,
        month: "flex flex-col p-2 gap-1 text-center w-full",
        caption: "relative flex justify-center items-center",
        table: "w-full border-separate border-spacing-0",
        head_row: "flex mb-1",
        head_cell: "text-muted-foreground rounded-md w-10 font-normal text-sm",
        row: "flex w-full mt-2",
        cell: "h-10 w-10 text-center text-sm p-0 relative",
        ...n
      },
      numberOfMonths: c,
      components: {
        MonthCaption: _,
        DayButton: P,
        Day: ($) => {
          const N = Object.entries(
            $
          ).reduce(
            (R, [L, F]) => (L.startsWith("data-") && (R[L] = F), R),
            {}
          );
          return /* @__PURE__ */ E(
            "div",
            {
              ...N,
              className: K(
                $.className,
                "inline-flex"
              ),
              children: $.children
            }
          );
        },
        Weekdays: () => /* @__PURE__ */ E(Ut, {}),
        Week: ($) => /* @__PURE__ */ E(
          "div",
          {
            className: K(
              "bsf-force-ui-month-week flex flex-row",
              $.className
            ),
            children: $.children
          }
        ),
        Months: ($) => {
          var N;
          return /* @__PURE__ */ E(Ut, { children: /* @__PURE__ */ E(
            "div",
            {
              className: K(
                "bsf-force-ui-date-picker-month",
                D
              ),
              children: (N = $ == null ? void 0 : $.children) == null ? void 0 : N.map((R, L) => R ? /* @__PURE__ */ E(I.Fragment, { children: R.map((F, W) => /* @__PURE__ */ he(
                I.Fragment,
                {
                  children: [
                    W > 0 && /* @__PURE__ */ E("div", { className: "border border-solid border-border-subtle border-l-0" }),
                    F
                  ]
                },
                W
              )) }, L) : null)
            }
          ) });
        },
        MonthGrid: ($) => !m && !g ? /* @__PURE__ */ E(C, { ...$ }) : /* @__PURE__ */ E(Ut, {})
      },
      ...a === "range" ? { required: !1 } : {},
      ...d,
      onDayMouseEnter: ($, N, R) => {
        var ae;
        if (a !== "range")
          return;
        const L = r;
        if (L != null && L.from && (L != null && L.to) || !(L != null && L.from) && !(L != null && L.to)) {
          Array.from(
            document.querySelectorAll("[data-hover]")
          ).forEach((ne) => {
            ne.setAttribute("data-hover", "false");
          });
          return;
        }
        const F = R.target, W = new Date(
          F.dataset.day
        ), z = dx(
          W,
          L.from
        ), G = fx(
          W,
          L.to
        );
        let U;
        switch (s) {
          case "dualdate":
          case "presets":
            U = F.closest(
              ".bsf-force-ui-date-picker-month"
            );
            break;
          case "normal":
          default:
            U = F.closest(
              ".bsf-force-ui-month-weeks"
            );
            break;
        }
        const V = Array.from(
          U.querySelectorAll("button")
        );
        G && V.sort(
          (ue, ne) => fx(
            new Date(ue.dataset.day),
            new Date(ne.dataset.day)
          ) ? -1 : 1
        ), z && V.sort(
          (ue, ne) => dx(
            new Date(ue.dataset.day),
            new Date(ne.dataset.day)
          ) ? 1 : -1
        );
        const Y = V.indexOf(F), ee = V.findIndex(
          (ue) => ue.getAttribute("data-selected") === "true"
        ), ie = [], re = Math.min(Y, ee), le = Math.max(Y, ee);
        for (let ue = re; ue <= le; ue++)
          (ae = V[ue]) != null && ae.disabled || ie.push(V[ue]);
        V.forEach((ue) => {
          ue.setAttribute(
            "data-hover",
            ie.includes(ue) ? "true" : "false"
          );
        });
      },
      disabled: f
    }
  ) });
}, rke = ({
  selectionType: e = "single",
  variant: t = "normal",
  presets: n = [],
  onCancel: r,
  onApply: i,
  onDateSelect: o,
  applyButtonText: a = "Apply",
  cancelButtonText: s = "Cancel",
  showOutsideDays: l = !0,
  isFooter: c = !0,
  selected: f,
  disabled: d,
  ...p
}) => {
  const [m, y] = Me(() => {
    if (!f)
      return CE(e);
    const _ = e === "multiple" && Array.isArray(f), O = e === "range" && "from" in f && "to" in f, P = e === "single" && f instanceof Date;
    return _ || O || P ? f : CE(e);
  }), g = (_) => {
    y(_), o && o(_);
  }, v = [
    {
      label: "Today",
      range: { from: xE(), to: xE() }
    },
    {
      label: "Yesterday",
      range: { from: wE(), to: wE() }
    },
    {
      label: "This Week",
      range: {
        from: Bs(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }),
        to: E_(/* @__PURE__ */ new Date(), { weekStartsOn: 1 })
      }
    },
    {
      label: "Last 7 Days",
      range: {
        from: bE(/* @__PURE__ */ new Date(), 6),
        to: /* @__PURE__ */ new Date()
      }
    },
    {
      label: "This Month",
      range: {
        from: nL(/* @__PURE__ */ new Date()),
        to: tL(/* @__PURE__ */ new Date())
      }
    },
    {
      label: "Last 30 Days",
      range: {
        from: bE(/* @__PURE__ */ new Date(), 29),
        to: /* @__PURE__ */ new Date()
      }
    }
  ], x = n.length > 0 ? n : v, w = (_) => {
    y(_);
  }, S = () => {
    y(
      e === "multiple" ? [] : { from: void 0, to: void 0 }
    ), r && r();
  }, A = () => {
    i && i(m);
  };
  if (t === "normal")
    return /* @__PURE__ */ E(
      Cb,
      {
        ...p,
        mode: e,
        variant: t,
        width: "w-[18.5rem]",
        selectedDates: m,
        showOutsideDays: l,
        setSelectedDates: g,
        footer: c && /* @__PURE__ */ he("div", { className: "flex bg-background-primary justify-end p-2 gap-3 border border-solid border-border-subtle border-t-0 rounded-md rounded-tl-none rounded-tr-none", children: [
          /* @__PURE__ */ E(
            Hn,
            {
              variant: "outline",
              onClick: S,
              children: s
            }
          ),
          /* @__PURE__ */ E(Hn, { onClick: A, children: a })
        ] }),
        disabled: d
      }
    );
  if (t === "dualdate")
    return /* @__PURE__ */ E(
      Cb,
      {
        mode: e,
        numberOfMonths: 2,
        alignment: "horizontal",
        selectedDates: m,
        setSelectedDates: g,
        showOutsideDays: l,
        variant: t,
        width: "w-auto",
        footer: /* @__PURE__ */ he("div", { className: "flex bg-background-primary justify-end p-2 gap-3 border border-solid border-border-subtle border-t-0 rounded-md rounded-tl-none rounded-tr-none", children: [
          /* @__PURE__ */ E(Hn, { variant: "outline", onClick: S, children: s }),
          /* @__PURE__ */ E(Hn, { onClick: A, children: a })
        ] }),
        disabled: d,
        ...p
      }
    );
  if (t === "presets")
    return /* @__PURE__ */ he("div", { className: "flex flex-row shadow-datepicker-wrapper", children: [
      /* @__PURE__ */ E("div", { className: "flex flex-col gap-1 p-3 items-start border border-solid border-border-subtle border-r-0 rounded-tl-md rounded-bl-md bg-background-primary", children: x.map((_, O) => /* @__PURE__ */ E(
        Hn,
        {
          onClick: () => w(_.range),
          variant: "ghost",
          className: "text-left font-medium text-sm text-nowrap w-full",
          children: _.label
        },
        O
      )) }),
      /* @__PURE__ */ E(
        Cb,
        {
          ...p,
          mode: e,
          selectedDates: m,
          setSelectedDates: g,
          variant: t,
          showOutsideDays: l,
          width: "w-auto",
          numberOfMonths: 2,
          footer: /* @__PURE__ */ he("div", { className: "flex justify-end p-2 gap-3 border-l border-r border-t-0 border-b border-solid border-border-subtle bg-background-primary rounded-br-md", children: [
            /* @__PURE__ */ E(
              Hn,
              {
                variant: "outline",
                onClick: S,
                children: s
              }
            ),
            /* @__PURE__ */ E(Hn, { onClick: A, children: a })
          ] }),
          disabled: d
        }
      )
    ] });
}, wL = ({
  type: e = "simple",
  defaultValue: t = [],
  autoClose: n = !1,
  disabled: r = !1,
  children: i,
  className: o
}) => {
  const [a, s] = Me(
    Array.isArray(t) ? t : [t]
  ), l = (f) => {
    s((d) => n ? d.includes(f) ? [] : [f] : d.includes(f) ? d.filter((p) => p !== f) : [...d, f]);
  };
  return /* @__PURE__ */ E("div", { className: K(e === "boxed" ? "space-y-3" : "", o), children: I.Children.map(i, (f) => I.isValidElement(f) && "value" in f.props ? I.cloneElement(
    f,
    {
      isOpen: a.includes(f.props.value),
      onToggle: () => l(f.props.value),
      type: e,
      disabled: r || f.props.disabled
    }
  ) : f) });
};
wL.displayName = "Accordion";
const _L = ({
  isOpen: e,
  onToggle: t,
  type: n = "simple",
  disabled: r = !1,
  children: i,
  className: o
}) => {
  const a = {
    simple: "border-0",
    separator: "border-0 border-b border-solid border-border-subtle",
    boxed: "border border-solid border-border-subtle rounded-md"
  }[n];
  return /* @__PURE__ */ E("div", { className: K(a, o), children: I.Children.map(
    i,
    (s) => I.isValidElement(s) ? I.cloneElement(s, {
      isOpen: e,
      onToggle: t,
      type: n,
      disabled: r
    }) : s
  ) });
};
_L.displayName = "Accordion.Item";
const SL = ({
  onToggle: e,
  isOpen: t,
  iconType: n = "arrow",
  // arrow, plus-minus
  disabled: r = !1,
  tag: i = "h3",
  type: o = "simple",
  children: a,
  className: s,
  ...l
}) => {
  const c = {
    simple: "px-2 py-3",
    separator: "px-2 py-4",
    boxed: "px-3 py-4"
  }[o], f = () => n === "arrow" ? /* @__PURE__ */ E(
    Xw,
    {
      className: K(
        "flex-shrink-0 text-icon-secondary size-5 transition-transform duration-300 ease-in-out",
        t ? "rotate-180" : "rotate-0"
      )
    }
  ) : n === "plus-minus" ? /* @__PURE__ */ E(
    An.span,
    {
      initial: { opacity: 0, rotate: t ? -180 : 0 },
      animate: { opacity: 1, rotate: t ? 0 : 180 },
      exit: { opacity: 0 },
      transition: { duration: 0.3, ease: "easeInOut" },
      className: "flex items-center flex-shrink-0 text-icon-secondary",
      children: t ? /* @__PURE__ */ E(eD, {}) : /* @__PURE__ */ E(tD, {})
    },
    t ? "minus" : "plus"
  ) : null;
  return /* @__PURE__ */ E(i, { className: "flex m-0 hover:bg-background-secondary transition duration-150 ease-in-out", children: /* @__PURE__ */ he(
    "button",
    {
      className: K(
        "flex w-full items-center justify-between text-sm font-medium transition-all appearance-none bg-transparent border-0 cursor-pointer gap-3",
        c,
        r && "cursor-not-allowed opacity-40",
        s
      ),
      onClick: r ? () => {
      } : e,
      "aria-expanded": t,
      disabled: r,
      ...l,
      children: [
        /* @__PURE__ */ E("div", { className: "flex items-center gap-2 text-text-primary font-semibold text-left", children: a }),
        f()
      ]
    }
  ) });
};
SL.displayName = "Accordion.Trigger";
const OL = ({
  isOpen: e,
  disabled: t = !1,
  type: n = "simple",
  children: r,
  className: i
}) => {
  const o = {
    open: { height: "auto", opacity: 1 },
    closed: { height: 0, opacity: 0 }
  }, a = {
    simple: "px-2 pb-3",
    separator: "px-2 pb-4",
    boxed: "px-3 pb-4"
  }[n];
  return /* @__PURE__ */ E(Ks, { initial: !1, children: e && /* @__PURE__ */ E(
    An.div,
    {
      variants: o,
      initial: "closed",
      animate: "open",
      exit: "closed",
      transition: { duration: 0.3, ease: "easeInOut" },
      className: K(
        "overflow-hidden text-text-secondary w-full text-sm transition-[height, opacity, transform] ease-in box-border",
        t && "opacity-40",
        i
      ),
      "aria-hidden": !e,
      children: /* @__PURE__ */ E("div", { className: K(a), children: r })
    },
    "content"
  ) });
};
OL.displayName = "Accordion.Content";
const ike = Object.assign(wL, {
  Item: _L,
  Trigger: SL,
  Content: OL
});
var Jne = Array.isArray, Tr = Jne, Qne = typeof So == "object" && So && So.Object === Object && So, AL = Qne, ere = AL, tre = typeof self == "object" && self && self.Object === Object && self, nre = ere || tre || Function("return this")(), oo = nre, rre = oo, ire = rre.Symbol, Td = ire, EE = Td, TL = Object.prototype, ore = TL.hasOwnProperty, are = TL.toString, Tu = EE ? EE.toStringTag : void 0;
function sre(e) {
  var t = ore.call(e, Tu), n = e[Tu];
  try {
    e[Tu] = void 0;
    var r = !0;
  } catch {
  }
  var i = are.call(e);
  return r && (t ? e[Tu] = n : delete e[Tu]), i;
}
var lre = sre, cre = Object.prototype, ure = cre.toString;
function fre(e) {
  return ure.call(e);
}
var dre = fre, kE = Td, hre = lre, pre = dre, mre = "[object Null]", gre = "[object Undefined]", ME = kE ? kE.toStringTag : void 0;
function yre(e) {
  return e == null ? e === void 0 ? gre : mre : ME && ME in Object(e) ? hre(e) : pre(e);
}
var Qo = yre;
function vre(e) {
  return e != null && typeof e == "object";
}
var ea = vre, bre = Qo, xre = ea, wre = "[object Symbol]";
function _re(e) {
  return typeof e == "symbol" || xre(e) && bre(e) == wre;
}
var Wc = _re, Sre = Tr, Ore = Wc, Are = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Tre = /^\w*$/;
function Pre(e, t) {
  if (Sre(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Ore(e) ? !0 : Tre.test(e) || !Are.test(e) || t != null && e in Object(t);
}
var M_ = Pre;
function Cre(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ha = Cre;
const zc = /* @__PURE__ */ kt(Ha);
var Ere = Qo, kre = Ha, Mre = "[object AsyncFunction]", Nre = "[object Function]", $re = "[object GeneratorFunction]", Dre = "[object Proxy]";
function Ire(e) {
  if (!kre(e))
    return !1;
  var t = Ere(e);
  return t == Nre || t == $re || t == Mre || t == Dre;
}
var N_ = Ire;
const ze = /* @__PURE__ */ kt(N_);
var Rre = oo, jre = Rre["__core-js_shared__"], Lre = jre, Eb = Lre, NE = function() {
  var e = /[^.]+$/.exec(Eb && Eb.keys && Eb.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Bre(e) {
  return !!NE && NE in e;
}
var Fre = Bre, Wre = Function.prototype, zre = Wre.toString;
function Vre(e) {
  if (e != null) {
    try {
      return zre.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var PL = Vre, Ure = N_, Hre = Fre, Kre = Ha, Gre = PL, Yre = /[\\^$.*+?()[\]{}|]/g, qre = /^\[object .+?Constructor\]$/, Xre = Function.prototype, Zre = Object.prototype, Jre = Xre.toString, Qre = Zre.hasOwnProperty, eie = RegExp(
  "^" + Jre.call(Qre).replace(Yre, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function tie(e) {
  if (!Kre(e) || Hre(e))
    return !1;
  var t = Ure(e) ? eie : qre;
  return t.test(Gre(e));
}
var nie = tie;
function rie(e, t) {
  return e == null ? void 0 : e[t];
}
var iie = rie, oie = nie, aie = iie;
function sie(e, t) {
  var n = aie(e, t);
  return oie(n) ? n : void 0;
}
var Js = sie, lie = Js, cie = lie(Object, "create"), Gg = cie, $E = Gg;
function uie() {
  this.__data__ = $E ? $E(null) : {}, this.size = 0;
}
var fie = uie;
function die(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var hie = die, pie = Gg, mie = "__lodash_hash_undefined__", gie = Object.prototype, yie = gie.hasOwnProperty;
function vie(e) {
  var t = this.__data__;
  if (pie) {
    var n = t[e];
    return n === mie ? void 0 : n;
  }
  return yie.call(t, e) ? t[e] : void 0;
}
var bie = vie, xie = Gg, wie = Object.prototype, _ie = wie.hasOwnProperty;
function Sie(e) {
  var t = this.__data__;
  return xie ? t[e] !== void 0 : _ie.call(t, e);
}
var Oie = Sie, Aie = Gg, Tie = "__lodash_hash_undefined__";
function Pie(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Aie && t === void 0 ? Tie : t, this;
}
var Cie = Pie, Eie = fie, kie = hie, Mie = bie, Nie = Oie, $ie = Cie;
function Vc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Vc.prototype.clear = Eie;
Vc.prototype.delete = kie;
Vc.prototype.get = Mie;
Vc.prototype.has = Nie;
Vc.prototype.set = $ie;
var Die = Vc;
function Iie() {
  this.__data__ = [], this.size = 0;
}
var Rie = Iie;
function jie(e, t) {
  return e === t || e !== e && t !== t;
}
var $_ = jie, Lie = $_;
function Bie(e, t) {
  for (var n = e.length; n--; )
    if (Lie(e[n][0], t))
      return n;
  return -1;
}
var Yg = Bie, Fie = Yg, Wie = Array.prototype, zie = Wie.splice;
function Vie(e) {
  var t = this.__data__, n = Fie(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : zie.call(t, n, 1), --this.size, !0;
}
var Uie = Vie, Hie = Yg;
function Kie(e) {
  var t = this.__data__, n = Hie(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Gie = Kie, Yie = Yg;
function qie(e) {
  return Yie(this.__data__, e) > -1;
}
var Xie = qie, Zie = Yg;
function Jie(e, t) {
  var n = this.__data__, r = Zie(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var Qie = Jie, eoe = Rie, toe = Uie, noe = Gie, roe = Xie, ioe = Qie;
function Uc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Uc.prototype.clear = eoe;
Uc.prototype.delete = toe;
Uc.prototype.get = noe;
Uc.prototype.has = roe;
Uc.prototype.set = ioe;
var qg = Uc, ooe = Js, aoe = oo, soe = ooe(aoe, "Map"), D_ = soe, DE = Die, loe = qg, coe = D_;
function uoe() {
  this.size = 0, this.__data__ = {
    hash: new DE(),
    map: new (coe || loe)(),
    string: new DE()
  };
}
var foe = uoe;
function doe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var hoe = doe, poe = hoe;
function moe(e, t) {
  var n = e.__data__;
  return poe(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Xg = moe, goe = Xg;
function yoe(e) {
  var t = goe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var voe = yoe, boe = Xg;
function xoe(e) {
  return boe(this, e).get(e);
}
var woe = xoe, _oe = Xg;
function Soe(e) {
  return _oe(this, e).has(e);
}
var Ooe = Soe, Aoe = Xg;
function Toe(e, t) {
  var n = Aoe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var Poe = Toe, Coe = foe, Eoe = voe, koe = woe, Moe = Ooe, Noe = Poe;
function Hc(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Hc.prototype.clear = Coe;
Hc.prototype.delete = Eoe;
Hc.prototype.get = koe;
Hc.prototype.has = Moe;
Hc.prototype.set = Noe;
var I_ = Hc, CL = I_, $oe = "Expected a function";
function R_(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError($oe);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (R_.Cache || CL)(), n;
}
R_.Cache = CL;
var EL = R_;
const Doe = /* @__PURE__ */ kt(EL);
var Ioe = EL, Roe = 500;
function joe(e) {
  var t = Ioe(e, function(r) {
    return n.size === Roe && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Loe = joe, Boe = Loe, Foe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Woe = /\\(\\)?/g, zoe = Boe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Foe, function(n, r, i, o) {
    t.push(i ? o.replace(Woe, "$1") : r || n);
  }), t;
}), Voe = zoe;
function Uoe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var j_ = Uoe, IE = Td, Hoe = j_, Koe = Tr, Goe = Wc, Yoe = 1 / 0, RE = IE ? IE.prototype : void 0, jE = RE ? RE.toString : void 0;
function kL(e) {
  if (typeof e == "string")
    return e;
  if (Koe(e))
    return Hoe(e, kL) + "";
  if (Goe(e))
    return jE ? jE.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Yoe ? "-0" : t;
}
var qoe = kL, Xoe = qoe;
function Zoe(e) {
  return e == null ? "" : Xoe(e);
}
var ML = Zoe, Joe = Tr, Qoe = M_, eae = Voe, tae = ML;
function nae(e, t) {
  return Joe(e) ? e : Qoe(e, t) ? [e] : eae(tae(e));
}
var NL = nae, rae = Wc, iae = 1 / 0;
function oae(e) {
  if (typeof e == "string" || rae(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -iae ? "-0" : t;
}
var Zg = oae, aae = NL, sae = Zg;
function lae(e, t) {
  t = aae(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[sae(t[n++])];
  return n && n == r ? e : void 0;
}
var L_ = lae, cae = L_;
function uae(e, t, n) {
  var r = e == null ? void 0 : cae(e, t);
  return r === void 0 ? n : r;
}
var $L = uae;
const zr = /* @__PURE__ */ kt($L);
function fae(e) {
  return e == null;
}
var dae = fae;
const Ue = /* @__PURE__ */ kt(dae);
var hae = Qo, pae = Tr, mae = ea, gae = "[object String]";
function yae(e) {
  return typeof e == "string" || !pae(e) && mae(e) && hae(e) == gae;
}
var vae = yae;
const Pd = /* @__PURE__ */ kt(vae);
var mx = { exports: {} }, bt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LE;
function bae() {
  if (LE) return bt;
  LE = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function g(v) {
    if (typeof v == "object" && v !== null) {
      var x = v.$$typeof;
      switch (x) {
        case e:
          switch (v = v.type, v) {
            case n:
            case i:
            case r:
            case c:
            case f:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case a:
                case l:
                case p:
                case d:
                case o:
                  return v;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return bt.ContextConsumer = a, bt.ContextProvider = o, bt.Element = e, bt.ForwardRef = l, bt.Fragment = n, bt.Lazy = p, bt.Memo = d, bt.Portal = t, bt.Profiler = i, bt.StrictMode = r, bt.Suspense = c, bt.SuspenseList = f, bt.isAsyncMode = function() {
    return !1;
  }, bt.isConcurrentMode = function() {
    return !1;
  }, bt.isContextConsumer = function(v) {
    return g(v) === a;
  }, bt.isContextProvider = function(v) {
    return g(v) === o;
  }, bt.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, bt.isForwardRef = function(v) {
    return g(v) === l;
  }, bt.isFragment = function(v) {
    return g(v) === n;
  }, bt.isLazy = function(v) {
    return g(v) === p;
  }, bt.isMemo = function(v) {
    return g(v) === d;
  }, bt.isPortal = function(v) {
    return g(v) === t;
  }, bt.isProfiler = function(v) {
    return g(v) === i;
  }, bt.isStrictMode = function(v) {
    return g(v) === r;
  }, bt.isSuspense = function(v) {
    return g(v) === c;
  }, bt.isSuspenseList = function(v) {
    return g(v) === f;
  }, bt.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === i || v === r || v === c || v === f || v === m || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === d || v.$$typeof === o || v.$$typeof === a || v.$$typeof === l || v.$$typeof === y || v.getModuleId !== void 0);
  }, bt.typeOf = g, bt;
}
var xt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BE;
function xae() {
  return BE || (BE = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), y = !1, g = !1, v = !1, x = !1, w = !1, S;
    S = Symbol.for("react.module.reference");
    function A(pe) {
      return !!(typeof pe == "string" || typeof pe == "function" || pe === n || pe === i || w || pe === r || pe === c || pe === f || x || pe === m || y || g || v || typeof pe == "object" && pe !== null && (pe.$$typeof === p || pe.$$typeof === d || pe.$$typeof === o || pe.$$typeof === a || pe.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      pe.$$typeof === S || pe.getModuleId !== void 0));
    }
    function _(pe) {
      if (typeof pe == "object" && pe !== null) {
        var ke = pe.$$typeof;
        switch (ke) {
          case e:
            var it = pe.type;
            switch (it) {
              case n:
              case i:
              case r:
              case c:
              case f:
                return it;
              default:
                var st = it && it.$$typeof;
                switch (st) {
                  case s:
                  case a:
                  case l:
                  case p:
                  case d:
                  case o:
                    return st;
                  default:
                    return ke;
                }
            }
          case t:
            return ke;
        }
      }
    }
    var O = a, P = o, C = e, k = l, D = n, $ = p, N = d, R = t, L = i, F = r, W = c, z = f, G = !1, U = !1;
    function V(pe) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(pe) {
      return U || (U = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ee(pe) {
      return _(pe) === a;
    }
    function ie(pe) {
      return _(pe) === o;
    }
    function re(pe) {
      return typeof pe == "object" && pe !== null && pe.$$typeof === e;
    }
    function le(pe) {
      return _(pe) === l;
    }
    function ae(pe) {
      return _(pe) === n;
    }
    function ue(pe) {
      return _(pe) === p;
    }
    function ne(pe) {
      return _(pe) === d;
    }
    function J(pe) {
      return _(pe) === t;
    }
    function fe(pe) {
      return _(pe) === i;
    }
    function be(pe) {
      return _(pe) === r;
    }
    function X(pe) {
      return _(pe) === c;
    }
    function De(pe) {
      return _(pe) === f;
    }
    xt.ContextConsumer = O, xt.ContextProvider = P, xt.Element = C, xt.ForwardRef = k, xt.Fragment = D, xt.Lazy = $, xt.Memo = N, xt.Portal = R, xt.Profiler = L, xt.StrictMode = F, xt.Suspense = W, xt.SuspenseList = z, xt.isAsyncMode = V, xt.isConcurrentMode = Y, xt.isContextConsumer = ee, xt.isContextProvider = ie, xt.isElement = re, xt.isForwardRef = le, xt.isFragment = ae, xt.isLazy = ue, xt.isMemo = ne, xt.isPortal = J, xt.isProfiler = fe, xt.isStrictMode = be, xt.isSuspense = X, xt.isSuspenseList = De, xt.isValidElementType = A, xt.typeOf = _;
  }()), xt;
}
process.env.NODE_ENV === "production" ? mx.exports = bae() : mx.exports = xae();
var wae = mx.exports, _ae = Qo, Sae = ea, Oae = "[object Number]";
function Aae(e) {
  return typeof e == "number" || Sae(e) && _ae(e) == Oae;
}
var DL = Aae;
const Tae = /* @__PURE__ */ kt(DL);
var Pae = DL;
function Cae(e) {
  return Pae(e) && e != +e;
}
var Eae = Cae;
const Kc = /* @__PURE__ */ kt(Eae);
var fr = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, ws = function(t) {
  return Pd(t) && t.indexOf("%") === t.length - 1;
}, ve = function(t) {
  return Tae(t) && !Kc(t);
}, On = function(t) {
  return ve(t) || Pd(t);
}, kae = 0, Qs = function(t) {
  var n = ++kae;
  return "".concat(t || "").concat(n);
}, dr = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!ve(t) && !Pd(t))
    return r;
  var o;
  if (ws(t)) {
    var a = t.indexOf("%");
    o = n * parseFloat(t.slice(0, a)) / 100;
  } else
    o = +t;
  return Kc(o) && (o = r), i && o > n && (o = n), o;
}, _a = function(t) {
  if (!t)
    return null;
  var n = Object.keys(t);
  return n && n.length ? t[n[0]] : null;
}, Mae = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var n = t.length, r = {}, i = 0; i < n; i++)
    if (!r[t[i]])
      r[t[i]] = !0;
    else
      return !0;
  return !1;
}, _n = function(t, n) {
  return ve(t) && ve(n) ? function(r) {
    return t + r * (n - t);
  } : function() {
    return n;
  };
};
function Gp(e, t, n) {
  return !e || !e.length ? null : e.find(function(r) {
    return r && (typeof t == "function" ? t(r) : zr(r, t)) === n;
  });
}
function Kl(e, t) {
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && (!{}.hasOwnProperty.call(t, n) || e[n] !== t[n]))
      return !1;
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && !{}.hasOwnProperty.call(e, r))
      return !1;
  return !0;
}
function gx(e) {
  "@babel/helpers - typeof";
  return gx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gx(e);
}
var Nae = ["viewBox", "children"], $ae = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], FE = ["points", "pathLength"], kb = {
  svg: Nae,
  polygon: FE,
  polyline: FE
}, B_ = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], Yp = function(t, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var r = t;
  if (/* @__PURE__ */ rt(t) && (r = t.props), !zc(r))
    return null;
  var i = {};
  return Object.keys(r).forEach(function(o) {
    B_.includes(o) && (i[o] = n || function(a) {
      return r[o](r, a);
    });
  }), i;
}, Dae = function(t, n, r) {
  return function(i) {
    return t(n, r, i), null;
  };
}, Fs = function(t, n, r) {
  if (!zc(t) || gx(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(o) {
    var a = t[o];
    B_.includes(o) && typeof a == "function" && (i || (i = {}), i[o] = Dae(a, n, r));
  }), i;
}, Iae = ["children"], Rae = ["children"];
function WE(e, t) {
  if (e == null) return {};
  var n = jae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function jae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function yx(e) {
  "@babel/helpers - typeof";
  return yx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yx(e);
}
var zE = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart"
}, Ro = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, VE = null, Mb = null, F_ = function e(t) {
  if (t === VE && Array.isArray(Mb))
    return Mb;
  var n = [];
  return Yt.forEach(t, function(r) {
    Ue(r) || (wae.isFragment(r) ? n = n.concat(e(r.props.children)) : n.push(r));
  }), Mb = n, VE = t, n;
};
function Vr(e, t) {
  var n = [], r = [];
  return Array.isArray(t) ? r = t.map(function(i) {
    return Ro(i);
  }) : r = [Ro(t)], F_(e).forEach(function(i) {
    var o = zr(i, "type.displayName") || zr(i, "type.name");
    r.indexOf(o) !== -1 && n.push(i);
  }), n;
}
function jr(e, t) {
  var n = Vr(e, t);
  return n && n[0];
}
var UE = function(t) {
  if (!t || !t.props)
    return !1;
  var n = t.props, r = n.width, i = n.height;
  return !(!ve(r) || r <= 0 || !ve(i) || i <= 0);
}, Lae = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], Bae = function(t) {
  return t && t.type && Pd(t.type) && Lae.indexOf(t.type) >= 0;
}, IL = function(t) {
  return t && yx(t) === "object" && "clipDot" in t;
}, Fae = function(t, n, r, i) {
  var o, a = (o = kb == null ? void 0 : kb[i]) !== null && o !== void 0 ? o : [];
  return !ze(t) && (i && a.includes(n) || $ae.includes(n)) || r && B_.includes(n);
}, Ee = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ rt(t) && (i = t.props), !zc(i))
    return null;
  var o = {};
  return Object.keys(i).forEach(function(a) {
    var s;
    Fae((s = i) === null || s === void 0 ? void 0 : s[a], a, n, r) && (o[a] = i[a]);
  }), o;
}, vx = function e(t, n) {
  if (t === n)
    return !0;
  var r = Yt.count(t);
  if (r !== Yt.count(n))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return HE(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n);
  for (var i = 0; i < r; i++) {
    var o = t[i], a = n[i];
    if (Array.isArray(o) || Array.isArray(a)) {
      if (!e(o, a))
        return !1;
    } else if (!HE(o, a))
      return !1;
  }
  return !0;
}, HE = function(t, n) {
  if (Ue(t) && Ue(n))
    return !0;
  if (!Ue(t) && !Ue(n)) {
    var r = t.props || {}, i = r.children, o = WE(r, Iae), a = n.props || {}, s = a.children, l = WE(a, Rae);
    return i && s ? Kl(o, l) && vx(i, s) : !i && !s ? Kl(o, l) : !1;
  }
  return !1;
}, KE = function(t, n) {
  var r = [], i = {};
  return F_(t).forEach(function(o, a) {
    if (Bae(o))
      r.push(o);
    else if (o) {
      var s = Ro(o.type), l = n[s] || {}, c = l.handler, f = l.once;
      if (c && (!f || !i[s])) {
        var d = c(o, s, a);
        r.push(d), i[s] = !0;
      }
    }
  }), r;
}, Wae = function(t) {
  var n = t && t.type;
  return n && zE[n] ? zE[n] : null;
}, zae = function(t, n) {
  return F_(n).indexOf(t);
}, Vae = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function bx() {
  return bx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bx.apply(this, arguments);
}
function Uae(e, t) {
  if (e == null) return {};
  var n = Hae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Hae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function xx(e) {
  var t = e.children, n = e.width, r = e.height, i = e.viewBox, o = e.className, a = e.style, s = e.title, l = e.desc, c = Uae(e, Vae), f = i || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, d = Ye("recharts-surface", o);
  return /* @__PURE__ */ I.createElement("svg", bx({}, Ee(c, !0, "svg"), {
    className: d,
    width: n,
    height: r,
    style: a,
    viewBox: "".concat(f.x, " ").concat(f.y, " ").concat(f.width, " ").concat(f.height)
  }), /* @__PURE__ */ I.createElement("title", null, s), /* @__PURE__ */ I.createElement("desc", null, l), t);
}
var Kae = ["children", "className"];
function wx() {
  return wx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wx.apply(this, arguments);
}
function Gae(e, t) {
  if (e == null) return {};
  var n = Yae(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Yae(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var at = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = Gae(e, Kae), o = Ye("recharts-layer", r);
  return /* @__PURE__ */ I.createElement("g", wx({
    className: o
  }, Ee(i, !0), {
    ref: t
  }), n);
}), qae = process.env.NODE_ENV !== "production", Mi = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  if (qae && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = 0;
      console.warn(n.replace(/%s/g, function() {
        return i[a++];
      }));
    }
};
function Xae(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var Zae = Xae, Jae = Zae;
function Qae(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : Jae(e, t, n);
}
var ese = Qae, tse = "\\ud800-\\udfff", nse = "\\u0300-\\u036f", rse = "\\ufe20-\\ufe2f", ise = "\\u20d0-\\u20ff", ose = nse + rse + ise, ase = "\\ufe0e\\ufe0f", sse = "\\u200d", lse = RegExp("[" + sse + tse + ose + ase + "]");
function cse(e) {
  return lse.test(e);
}
var RL = cse;
function use(e) {
  return e.split("");
}
var fse = use, jL = "\\ud800-\\udfff", dse = "\\u0300-\\u036f", hse = "\\ufe20-\\ufe2f", pse = "\\u20d0-\\u20ff", mse = dse + hse + pse, gse = "\\ufe0e\\ufe0f", yse = "[" + jL + "]", _x = "[" + mse + "]", Sx = "\\ud83c[\\udffb-\\udfff]", vse = "(?:" + _x + "|" + Sx + ")", LL = "[^" + jL + "]", BL = "(?:\\ud83c[\\udde6-\\uddff]){2}", FL = "[\\ud800-\\udbff][\\udc00-\\udfff]", bse = "\\u200d", WL = vse + "?", zL = "[" + gse + "]?", xse = "(?:" + bse + "(?:" + [LL, BL, FL].join("|") + ")" + zL + WL + ")*", wse = zL + WL + xse, _se = "(?:" + [LL + _x + "?", _x, BL, FL, yse].join("|") + ")", Sse = RegExp(Sx + "(?=" + Sx + ")|" + _se + wse, "g");
function Ose(e) {
  return e.match(Sse) || [];
}
var Ase = Ose, Tse = fse, Pse = RL, Cse = Ase;
function Ese(e) {
  return Pse(e) ? Cse(e) : Tse(e);
}
var kse = Ese, Mse = ese, Nse = RL, $se = kse, Dse = ML;
function Ise(e) {
  return function(t) {
    t = Dse(t);
    var n = Nse(t) ? $se(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? Mse(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var Rse = Ise, jse = Rse, Lse = jse("toUpperCase"), Bse = Lse;
const Jg = /* @__PURE__ */ kt(Bse);
function jt(e) {
  return function() {
    return e;
  };
}
const VL = Math.cos, qp = Math.sin, Ii = Math.sqrt, Xp = Math.PI, Qg = 2 * Xp, Ox = Math.PI, Ax = 2 * Ox, ms = 1e-6, Fse = Ax - ms;
function UL(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function Wse(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return UL;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class zse {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? UL : Wse(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, l = r - t, c = i - n, f = a - t, d = s - n, p = f * f + d * d;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (p > ms) if (!(Math.abs(d * l - c * f) > ms) || !o)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let m = r - a, y = i - s, g = l * l + c * c, v = m * m + y * y, x = Math.sqrt(g), w = Math.sqrt(p), S = o * Math.tan((Ox - Math.acos((g + p - v) / (2 * x * w))) / 2), A = S / w, _ = S / x;
      Math.abs(A - 1) > ms && this._append`L${t + A * f},${n + A * d}`, this._append`A${o},${o},0,0,${+(d * m > f * y)},${this._x1 = t + _ * l},${this._y1 = n + _ * c}`;
    }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), l = r * Math.sin(i), c = t + s, f = n + l, d = 1 ^ a, p = a ? i - o : o - i;
    this._x1 === null ? this._append`M${c},${f}` : (Math.abs(this._x1 - c) > ms || Math.abs(this._y1 - f) > ms) && this._append`L${c},${f}`, r && (p < 0 && (p = p % Ax + Ax), p > Fse ? this._append`A${r},${r},0,1,${d},${t - s},${n - l}A${r},${r},0,1,${d},${this._x1 = c},${this._y1 = f}` : p > ms && this._append`A${r},${r},0,${+(p >= Ox)},${d},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function W_(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new zse(t);
}
function z_(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function HL(e) {
  this._context = e;
}
HL.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function ey(e) {
  return new HL(e);
}
function KL(e) {
  return e[0];
}
function GL(e) {
  return e[1];
}
function YL(e, t) {
  var n = jt(!0), r = null, i = ey, o = null, a = W_(s);
  e = typeof e == "function" ? e : e === void 0 ? KL : jt(e), t = typeof t == "function" ? t : t === void 0 ? GL : jt(t);
  function s(l) {
    var c, f = (l = z_(l)).length, d, p = !1, m;
    for (r == null && (o = i(m = a())), c = 0; c <= f; ++c)
      !(c < f && n(d = l[c], c, l)) === p && ((p = !p) ? o.lineStart() : o.lineEnd()), p && o.point(+e(d, c, l), +t(d, c, l));
    if (m) return o = null, m + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : jt(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : jt(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : jt(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (i = l, r != null && (o = i(r)), s) : i;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = o = null : o = i(r = l), s) : r;
  }, s;
}
function zh(e, t, n) {
  var r = null, i = jt(!0), o = null, a = ey, s = null, l = W_(c);
  e = typeof e == "function" ? e : e === void 0 ? KL : jt(+e), t = typeof t == "function" ? t : jt(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? GL : jt(+n);
  function c(d) {
    var p, m, y, g = (d = z_(d)).length, v, x = !1, w, S = new Array(g), A = new Array(g);
    for (o == null && (s = a(w = l())), p = 0; p <= g; ++p) {
      if (!(p < g && i(v = d[p], p, d)) === x)
        if (x = !x)
          m = p, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), y = p - 1; y >= m; --y)
            s.point(S[y], A[y]);
          s.lineEnd(), s.areaEnd();
        }
      x && (S[p] = +e(v, p, d), A[p] = +t(v, p, d), s.point(r ? +r(v, p, d) : S[p], n ? +n(v, p, d) : A[p]));
    }
    if (w) return s = null, w + "" || null;
  }
  function f() {
    return YL().defined(i).curve(a).context(o);
  }
  return c.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : jt(+d), r = null, c) : e;
  }, c.x0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : jt(+d), c) : e;
  }, c.x1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : jt(+d), c) : r;
  }, c.y = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : jt(+d), n = null, c) : t;
  }, c.y0 = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : jt(+d), c) : t;
  }, c.y1 = function(d) {
    return arguments.length ? (n = d == null ? null : typeof d == "function" ? d : jt(+d), c) : n;
  }, c.lineX0 = c.lineY0 = function() {
    return f().x(e).y(t);
  }, c.lineY1 = function() {
    return f().x(e).y(n);
  }, c.lineX1 = function() {
    return f().x(r).y(t);
  }, c.defined = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : jt(!!d), c) : i;
  }, c.curve = function(d) {
    return arguments.length ? (a = d, o != null && (s = a(o)), c) : a;
  }, c.context = function(d) {
    return arguments.length ? (d == null ? o = s = null : s = a(o = d), c) : o;
  }, c;
}
class qL {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
function Vse(e) {
  return new qL(e, !0);
}
function Use(e) {
  return new qL(e, !1);
}
const V_ = {
  draw(e, t) {
    const n = Ii(t / Xp);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, Qg);
  }
}, Hse = {
  draw(e, t) {
    const n = Ii(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, XL = Ii(1 / 3), Kse = XL * 2, Gse = {
  draw(e, t) {
    const n = Ii(t / Kse), r = n * XL;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, Yse = {
  draw(e, t) {
    const n = Ii(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, qse = 0.8908130915292852, ZL = qp(Xp / 10) / qp(7 * Xp / 10), Xse = qp(Qg / 10) * ZL, Zse = -VL(Qg / 10) * ZL, Jse = {
  draw(e, t) {
    const n = Ii(t * qse), r = Xse * n, i = Zse * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const a = Qg * o / 5, s = VL(a), l = qp(a);
      e.lineTo(l * n, -s * n), e.lineTo(s * r - l * i, l * r + s * i);
    }
    e.closePath();
  }
}, Nb = Ii(3), Qse = {
  draw(e, t) {
    const n = -Ii(t / (Nb * 3));
    e.moveTo(0, n * 2), e.lineTo(-Nb * n, -n), e.lineTo(Nb * n, -n), e.closePath();
  }
}, ai = -0.5, si = Ii(3) / 2, Tx = 1 / Ii(12), ele = (Tx / 2 + 1) * 3, tle = {
  draw(e, t) {
    const n = Ii(t / ele), r = n / 2, i = n * Tx, o = r, a = n * Tx + n, s = -o, l = a;
    e.moveTo(r, i), e.lineTo(o, a), e.lineTo(s, l), e.lineTo(ai * r - si * i, si * r + ai * i), e.lineTo(ai * o - si * a, si * o + ai * a), e.lineTo(ai * s - si * l, si * s + ai * l), e.lineTo(ai * r + si * i, ai * i - si * r), e.lineTo(ai * o + si * a, ai * a - si * o), e.lineTo(ai * s + si * l, ai * l - si * s), e.closePath();
  }
};
function nle(e, t) {
  let n = null, r = W_(i);
  e = typeof e == "function" ? e : jt(e || V_), t = typeof t == "function" ? t : jt(t === void 0 ? 64 : +t);
  function i() {
    let o;
    if (n || (n = o = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o) return n = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : jt(o), i) : e;
  }, i.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : jt(+o), i) : t;
  }, i.context = function(o) {
    return arguments.length ? (n = o ?? null, i) : n;
  }, i;
}
function Zp() {
}
function Jp(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function JL(e) {
  this._context = e;
}
JL.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Jp(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Jp(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function rle(e) {
  return new JL(e);
}
function QL(e) {
  this._context = e;
}
QL.prototype = {
  areaStart: Zp,
  areaEnd: Zp,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Jp(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function ile(e) {
  return new QL(e);
}
function eB(e) {
  this._context = e;
}
eB.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        Jp(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function ole(e) {
  return new eB(e);
}
function tB(e) {
  this._context = e;
}
tB.prototype = {
  areaStart: Zp,
  areaEnd: Zp,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function ale(e) {
  return new tB(e);
}
function GE(e) {
  return e < 0 ? -1 : 1;
}
function YE(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (r || i < 0 && -0), a = (n - e._y1) / (i || r < 0 && -0), s = (o * i + a * r) / (r + i);
  return (GE(o) + GE(a)) * Math.min(Math.abs(o), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function qE(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function $b(e, t, n) {
  var r = e._x0, i = e._y0, o = e._x1, a = e._y1, s = (o - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}
function Qp(e) {
  this._context = e;
}
Qp.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        $b(this, this._t0, qE(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, $b(this, qE(this, n = YE(this, e, t)), n);
          break;
        default:
          $b(this, this._t0, n = YE(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function nB(e) {
  this._context = new rB(e);
}
(nB.prototype = Object.create(Qp.prototype)).point = function(e, t) {
  Qp.prototype.point.call(this, t, e);
};
function rB(e) {
  this._context = e;
}
rB.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
};
function sle(e) {
  return new Qp(e);
}
function lle(e) {
  return new nB(e);
}
function iB(e) {
  this._context = e;
}
iB.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = XE(e), i = XE(t), o = 0, a = 1; a < n; ++o, ++a)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function XE(e) {
  var t, n = e.length - 1, r, i = new Array(n), o = new Array(n), a = new Array(n);
  for (i[0] = 0, o[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, o[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / o[t - 1], o[t] -= r, a[t] -= r * a[t - 1];
  for (i[n - 1] = a[n - 1] / o[n - 1], t = n - 2; t >= 0; --t) i[t] = (a[t] - i[t + 1]) / o[t];
  for (o[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) o[t] = 2 * e[t + 1] - i[t + 1];
  return [i, o];
}
function cle(e) {
  return new iB(e);
}
function ty(e, t) {
  this._context = e, this._t = t;
}
ty.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function ule(e) {
  return new ty(e, 0.5);
}
function fle(e) {
  return new ty(e, 0);
}
function dle(e) {
  return new ty(e, 1);
}
function ic(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, i, o = e[t[0]], a, s = o.length; n < a; ++n)
      for (i = o, o = e[t[n]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function Px(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function hle(e, t) {
  return e[t];
}
function ple(e) {
  const t = [];
  return t.key = e, t;
}
function mle() {
  var e = jt([]), t = Px, n = ic, r = hle;
  function i(o) {
    var a = Array.from(e.apply(this, arguments), ple), s, l = a.length, c = -1, f;
    for (const d of o)
      for (s = 0, ++c; s < l; ++s)
        (a[s][c] = [0, +r(d, a[s].key, c, o)]).data = d;
    for (s = 0, f = z_(t(a)); s < l; ++s)
      a[f[s]].index = s;
    return n(a, f), a;
  }
  return i.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : jt(Array.from(o)), i) : e;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : jt(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (t = o == null ? Px : typeof o == "function" ? o : jt(Array.from(o)), i) : t;
  }, i.offset = function(o) {
    return arguments.length ? (n = o ?? ic, i) : n;
  }, i;
}
function gle(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, o = e[0].length, a; i < o; ++i) {
      for (a = n = 0; n < r; ++n) a += e[n][i][1] || 0;
      if (a) for (n = 0; n < r; ++n) e[n][i][1] /= a;
    }
    ic(e, t);
  }
}
function yle(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, o = r.length; n < o; ++n) {
      for (var a = 0, s = 0; a < i; ++a) s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    ic(e, t);
  }
}
function vle(e, t) {
  if (!(!((a = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, o, a; r < o; ++r) {
      for (var s = 0, l = 0, c = 0; s < a; ++s) {
        for (var f = e[t[s]], d = f[r][1] || 0, p = f[r - 1][1] || 0, m = (d - p) / 2, y = 0; y < s; ++y) {
          var g = e[t[y]], v = g[r][1] || 0, x = g[r - 1][1] || 0;
          m += v - x;
        }
        l += d, c += m * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, l && (n -= c / l);
    }
    i[r - 1][1] += i[r - 1][0] = n, ic(e, t);
  }
}
function Tf(e) {
  "@babel/helpers - typeof";
  return Tf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tf(e);
}
var ble = ["type", "size", "sizeType"];
function Cx() {
  return Cx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cx.apply(this, arguments);
}
function ZE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function JE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZE(Object(n), !0).forEach(function(r) {
      xle(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ZE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xle(e, t, n) {
  return t = wle(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wle(e) {
  var t = _le(e, "string");
  return Tf(t) == "symbol" ? t : t + "";
}
function _le(e, t) {
  if (Tf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Tf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Sle(e, t) {
  if (e == null) return {};
  var n = Ole(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Ole(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var oB = {
  symbolCircle: V_,
  symbolCross: Hse,
  symbolDiamond: Gse,
  symbolSquare: Yse,
  symbolStar: Jse,
  symbolTriangle: Qse,
  symbolWye: tle
}, Ale = Math.PI / 180, Tle = function(t) {
  var n = "symbol".concat(Jg(t));
  return oB[n] || V_;
}, Ple = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * Ale;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, Cle = function(t, n) {
  oB["symbol".concat(Jg(t))] = n;
}, U_ = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, i = t.size, o = i === void 0 ? 64 : i, a = t.sizeType, s = a === void 0 ? "area" : a, l = Sle(t, ble), c = JE(JE({}, l), {}, {
    type: r,
    size: o,
    sizeType: s
  }), f = function() {
    var v = Tle(r), x = nle().type(v).size(Ple(o, s, r));
    return x();
  }, d = c.className, p = c.cx, m = c.cy, y = Ee(c, !0);
  return p === +p && m === +m && o === +o ? /* @__PURE__ */ I.createElement("path", Cx({}, y, {
    className: Ye("recharts-symbols", d),
    transform: "translate(".concat(p, ", ").concat(m, ")"),
    d: f()
  })) : null;
};
U_.registerSymbol = Cle;
function oc(e) {
  "@babel/helpers - typeof";
  return oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oc(e);
}
function Ex() {
  return Ex = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ex.apply(this, arguments);
}
function QE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ele(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QE(Object(n), !0).forEach(function(r) {
      Pf(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : QE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kle(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Mle(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, sB(r.key), r);
  }
}
function Nle(e, t, n) {
  return t && Mle(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function $le(e, t, n) {
  return t = em(t), Dle(e, aB() ? Reflect.construct(t, n || [], em(e).constructor) : t.apply(e, n));
}
function Dle(e, t) {
  if (t && (oc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ile(e);
}
function Ile(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function aB() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aB = function() {
    return !!e;
  })();
}
function em(e) {
  return em = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, em(e);
}
function Rle(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && kx(e, t);
}
function kx(e, t) {
  return kx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, kx(e, t);
}
function Pf(e, t, n) {
  return t = sB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sB(e) {
  var t = jle(e, "string");
  return oc(t) == "symbol" ? t : t + "";
}
function jle(e, t) {
  if (oc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (oc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var li = 32, H_ = /* @__PURE__ */ function(e) {
  function t() {
    return kle(this, t), $le(this, t, arguments);
  }
  return Rle(t, e), Nle(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var i = this.props.inactiveColor, o = li / 2, a = li / 6, s = li / 3, l = r.inactive ? i : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ I.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: o,
            x2: li,
            y2: o,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ I.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(o, "h").concat(s, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(2 * s, ",").concat(o, `
            H`).concat(li, "M").concat(2 * s, ",").concat(o, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(s, ",").concat(o),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ I.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(li / 8, "h").concat(li, "v").concat(li * 3 / 4, "h").concat(-li, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ I.isValidElement(r.legendIcon)) {
          var c = Ele({}, r);
          return delete c.legendIcon, /* @__PURE__ */ I.cloneElement(r.legendIcon, c);
        }
        return /* @__PURE__ */ I.createElement(U_, {
          fill: l,
          cx: o,
          cy: o,
          size: li,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, i = this.props, o = i.payload, a = i.iconSize, s = i.layout, l = i.formatter, c = i.inactiveColor, f = {
        x: 0,
        y: 0,
        width: li,
        height: li
      }, d = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, p = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return o.map(function(m, y) {
        var g = m.formatter || l, v = Ye(Pf(Pf({
          "recharts-legend-item": !0
        }, "legend-item-".concat(y), !0), "inactive", m.inactive));
        if (m.type === "none")
          return null;
        var x = ze(m.value) ? null : m.value;
        Mi(
          !ze(m.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var w = m.inactive ? c : m.color;
        return /* @__PURE__ */ I.createElement("li", Ex({
          className: v,
          style: d,
          key: "legend-item-".concat(y)
        }, Fs(r.props, m, y)), /* @__PURE__ */ I.createElement(xx, {
          width: a,
          height: a,
          viewBox: f,
          style: p
        }, r.renderIcon(m)), /* @__PURE__ */ I.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: w
          }
        }, g ? g(x, m, y) : x));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.payload, o = r.layout, a = r.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: o === "horizontal" ? a : "left"
      };
      return /* @__PURE__ */ I.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(pi);
Pf(H_, "displayName", "Legend");
Pf(H_, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Lle = qg;
function Ble() {
  this.__data__ = new Lle(), this.size = 0;
}
var Fle = Ble;
function Wle(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var zle = Wle;
function Vle(e) {
  return this.__data__.get(e);
}
var Ule = Vle;
function Hle(e) {
  return this.__data__.has(e);
}
var Kle = Hle, Gle = qg, Yle = D_, qle = I_, Xle = 200;
function Zle(e, t) {
  var n = this.__data__;
  if (n instanceof Gle) {
    var r = n.__data__;
    if (!Yle || r.length < Xle - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new qle(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Jle = Zle, Qle = qg, ece = Fle, tce = zle, nce = Ule, rce = Kle, ice = Jle;
function Gc(e) {
  var t = this.__data__ = new Qle(e);
  this.size = t.size;
}
Gc.prototype.clear = ece;
Gc.prototype.delete = tce;
Gc.prototype.get = nce;
Gc.prototype.has = rce;
Gc.prototype.set = ice;
var lB = Gc, oce = "__lodash_hash_undefined__";
function ace(e) {
  return this.__data__.set(e, oce), this;
}
var sce = ace;
function lce(e) {
  return this.__data__.has(e);
}
var cce = lce, uce = I_, fce = sce, dce = cce;
function tm(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new uce(); ++t < n; )
    this.add(e[t]);
}
tm.prototype.add = tm.prototype.push = fce;
tm.prototype.has = dce;
var cB = tm;
function hce(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var uB = hce;
function pce(e, t) {
  return e.has(t);
}
var fB = pce, mce = cB, gce = uB, yce = fB, vce = 1, bce = 2;
function xce(e, t, n, r, i, o) {
  var a = n & vce, s = e.length, l = t.length;
  if (s != l && !(a && l > s))
    return !1;
  var c = o.get(e), f = o.get(t);
  if (c && f)
    return c == t && f == e;
  var d = -1, p = !0, m = n & bce ? new mce() : void 0;
  for (o.set(e, t), o.set(t, e); ++d < s; ) {
    var y = e[d], g = t[d];
    if (r)
      var v = a ? r(g, y, d, t, e, o) : r(y, g, d, e, t, o);
    if (v !== void 0) {
      if (v)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!gce(t, function(x, w) {
        if (!yce(m, w) && (y === x || i(y, x, n, r, o)))
          return m.push(w);
      })) {
        p = !1;
        break;
      }
    } else if (!(y === g || i(y, g, n, r, o))) {
      p = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), p;
}
var dB = xce, wce = oo, _ce = wce.Uint8Array, Sce = _ce;
function Oce(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var Ace = Oce;
function Tce(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var K_ = Tce, ek = Td, tk = Sce, Pce = $_, Cce = dB, Ece = Ace, kce = K_, Mce = 1, Nce = 2, $ce = "[object Boolean]", Dce = "[object Date]", Ice = "[object Error]", Rce = "[object Map]", jce = "[object Number]", Lce = "[object RegExp]", Bce = "[object Set]", Fce = "[object String]", Wce = "[object Symbol]", zce = "[object ArrayBuffer]", Vce = "[object DataView]", nk = ek ? ek.prototype : void 0, Db = nk ? nk.valueOf : void 0;
function Uce(e, t, n, r, i, o, a) {
  switch (n) {
    case Vce:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case zce:
      return !(e.byteLength != t.byteLength || !o(new tk(e), new tk(t)));
    case $ce:
    case Dce:
    case jce:
      return Pce(+e, +t);
    case Ice:
      return e.name == t.name && e.message == t.message;
    case Lce:
    case Fce:
      return e == t + "";
    case Rce:
      var s = Ece;
    case Bce:
      var l = r & Mce;
      if (s || (s = kce), e.size != t.size && !l)
        return !1;
      var c = a.get(e);
      if (c)
        return c == t;
      r |= Nce, a.set(e, t);
      var f = Cce(s(e), s(t), r, i, o, a);
      return a.delete(e), f;
    case Wce:
      if (Db)
        return Db.call(e) == Db.call(t);
  }
  return !1;
}
var Hce = Uce;
function Kce(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var hB = Kce, Gce = hB, Yce = Tr;
function qce(e, t, n) {
  var r = t(e);
  return Yce(e) ? r : Gce(r, n(e));
}
var Xce = qce;
function Zce(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
var Jce = Zce;
function Qce() {
  return [];
}
var eue = Qce, tue = Jce, nue = eue, rue = Object.prototype, iue = rue.propertyIsEnumerable, rk = Object.getOwnPropertySymbols, oue = rk ? function(e) {
  return e == null ? [] : (e = Object(e), tue(rk(e), function(t) {
    return iue.call(e, t);
  }));
} : nue, aue = oue;
function sue(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var lue = sue, cue = Qo, uue = ea, fue = "[object Arguments]";
function due(e) {
  return uue(e) && cue(e) == fue;
}
var hue = due, ik = hue, pue = ea, pB = Object.prototype, mue = pB.hasOwnProperty, gue = pB.propertyIsEnumerable, yue = ik(/* @__PURE__ */ function() {
  return arguments;
}()) ? ik : function(e) {
  return pue(e) && mue.call(e, "callee") && !gue.call(e, "callee");
}, G_ = yue, nm = { exports: {} };
function vue() {
  return !1;
}
var bue = vue;
nm.exports;
(function(e, t) {
  var n = oo, r = bue, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || r;
  e.exports = c;
})(nm, nm.exports);
var mB = nm.exports, xue = 9007199254740991, wue = /^(?:0|[1-9]\d*)$/;
function _ue(e, t) {
  var n = typeof e;
  return t = t ?? xue, !!t && (n == "number" || n != "symbol" && wue.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Y_ = _ue, Sue = 9007199254740991;
function Oue(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Sue;
}
var q_ = Oue, Aue = Qo, Tue = q_, Pue = ea, Cue = "[object Arguments]", Eue = "[object Array]", kue = "[object Boolean]", Mue = "[object Date]", Nue = "[object Error]", $ue = "[object Function]", Due = "[object Map]", Iue = "[object Number]", Rue = "[object Object]", jue = "[object RegExp]", Lue = "[object Set]", Bue = "[object String]", Fue = "[object WeakMap]", Wue = "[object ArrayBuffer]", zue = "[object DataView]", Vue = "[object Float32Array]", Uue = "[object Float64Array]", Hue = "[object Int8Array]", Kue = "[object Int16Array]", Gue = "[object Int32Array]", Yue = "[object Uint8Array]", que = "[object Uint8ClampedArray]", Xue = "[object Uint16Array]", Zue = "[object Uint32Array]", zt = {};
zt[Vue] = zt[Uue] = zt[Hue] = zt[Kue] = zt[Gue] = zt[Yue] = zt[que] = zt[Xue] = zt[Zue] = !0;
zt[Cue] = zt[Eue] = zt[Wue] = zt[kue] = zt[zue] = zt[Mue] = zt[Nue] = zt[$ue] = zt[Due] = zt[Iue] = zt[Rue] = zt[jue] = zt[Lue] = zt[Bue] = zt[Fue] = !1;
function Jue(e) {
  return Pue(e) && Tue(e.length) && !!zt[Aue(e)];
}
var Que = Jue;
function efe(e) {
  return function(t) {
    return e(t);
  };
}
var gB = efe, rm = { exports: {} };
rm.exports;
(function(e, t) {
  var n = AL, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(rm, rm.exports);
var tfe = rm.exports, nfe = Que, rfe = gB, ok = tfe, ak = ok && ok.isTypedArray, ife = ak ? rfe(ak) : nfe, yB = ife, ofe = lue, afe = G_, sfe = Tr, lfe = mB, cfe = Y_, ufe = yB, ffe = Object.prototype, dfe = ffe.hasOwnProperty;
function hfe(e, t) {
  var n = sfe(e), r = !n && afe(e), i = !n && !r && lfe(e), o = !n && !r && !i && ufe(e), a = n || r || i || o, s = a ? ofe(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || dfe.call(e, c)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    cfe(c, l))) && s.push(c);
  return s;
}
var pfe = hfe, mfe = Object.prototype;
function gfe(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || mfe;
  return e === n;
}
var yfe = gfe;
function vfe(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var vB = vfe, bfe = vB, xfe = bfe(Object.keys, Object), wfe = xfe, _fe = yfe, Sfe = wfe, Ofe = Object.prototype, Afe = Ofe.hasOwnProperty;
function Tfe(e) {
  if (!_fe(e))
    return Sfe(e);
  var t = [];
  for (var n in Object(e))
    Afe.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var Pfe = Tfe, Cfe = N_, Efe = q_;
function kfe(e) {
  return e != null && Efe(e.length) && !Cfe(e);
}
var Cd = kfe, Mfe = pfe, Nfe = Pfe, $fe = Cd;
function Dfe(e) {
  return $fe(e) ? Mfe(e) : Nfe(e);
}
var ny = Dfe, Ife = Xce, Rfe = aue, jfe = ny;
function Lfe(e) {
  return Ife(e, jfe, Rfe);
}
var Bfe = Lfe, sk = Bfe, Ffe = 1, Wfe = Object.prototype, zfe = Wfe.hasOwnProperty;
function Vfe(e, t, n, r, i, o) {
  var a = n & Ffe, s = sk(e), l = s.length, c = sk(t), f = c.length;
  if (l != f && !a)
    return !1;
  for (var d = l; d--; ) {
    var p = s[d];
    if (!(a ? p in t : zfe.call(t, p)))
      return !1;
  }
  var m = o.get(e), y = o.get(t);
  if (m && y)
    return m == t && y == e;
  var g = !0;
  o.set(e, t), o.set(t, e);
  for (var v = a; ++d < l; ) {
    p = s[d];
    var x = e[p], w = t[p];
    if (r)
      var S = a ? r(w, x, p, t, e, o) : r(x, w, p, e, t, o);
    if (!(S === void 0 ? x === w || i(x, w, n, r, o) : S)) {
      g = !1;
      break;
    }
    v || (v = p == "constructor");
  }
  if (g && !v) {
    var A = e.constructor, _ = t.constructor;
    A != _ && "constructor" in e && "constructor" in t && !(typeof A == "function" && A instanceof A && typeof _ == "function" && _ instanceof _) && (g = !1);
  }
  return o.delete(e), o.delete(t), g;
}
var Ufe = Vfe, Hfe = Js, Kfe = oo, Gfe = Hfe(Kfe, "DataView"), Yfe = Gfe, qfe = Js, Xfe = oo, Zfe = qfe(Xfe, "Promise"), Jfe = Zfe, Qfe = Js, ede = oo, tde = Qfe(ede, "Set"), bB = tde, nde = Js, rde = oo, ide = nde(rde, "WeakMap"), ode = ide, Mx = Yfe, Nx = D_, $x = Jfe, Dx = bB, Ix = ode, xB = Qo, Yc = PL, lk = "[object Map]", ade = "[object Object]", ck = "[object Promise]", uk = "[object Set]", fk = "[object WeakMap]", dk = "[object DataView]", sde = Yc(Mx), lde = Yc(Nx), cde = Yc($x), ude = Yc(Dx), fde = Yc(Ix), gs = xB;
(Mx && gs(new Mx(new ArrayBuffer(1))) != dk || Nx && gs(new Nx()) != lk || $x && gs($x.resolve()) != ck || Dx && gs(new Dx()) != uk || Ix && gs(new Ix()) != fk) && (gs = function(e) {
  var t = xB(e), n = t == ade ? e.constructor : void 0, r = n ? Yc(n) : "";
  if (r)
    switch (r) {
      case sde:
        return dk;
      case lde:
        return lk;
      case cde:
        return ck;
      case ude:
        return uk;
      case fde:
        return fk;
    }
  return t;
});
var dde = gs, Ib = lB, hde = dB, pde = Hce, mde = Ufe, hk = dde, pk = Tr, mk = mB, gde = yB, yde = 1, gk = "[object Arguments]", yk = "[object Array]", Vh = "[object Object]", vde = Object.prototype, vk = vde.hasOwnProperty;
function bde(e, t, n, r, i, o) {
  var a = pk(e), s = pk(t), l = a ? yk : hk(e), c = s ? yk : hk(t);
  l = l == gk ? Vh : l, c = c == gk ? Vh : c;
  var f = l == Vh, d = c == Vh, p = l == c;
  if (p && mk(e)) {
    if (!mk(t))
      return !1;
    a = !0, f = !1;
  }
  if (p && !f)
    return o || (o = new Ib()), a || gde(e) ? hde(e, t, n, r, i, o) : pde(e, t, l, n, r, i, o);
  if (!(n & yde)) {
    var m = f && vk.call(e, "__wrapped__"), y = d && vk.call(t, "__wrapped__");
    if (m || y) {
      var g = m ? e.value() : e, v = y ? t.value() : t;
      return o || (o = new Ib()), i(g, v, n, r, o);
    }
  }
  return p ? (o || (o = new Ib()), mde(e, t, n, r, i, o)) : !1;
}
var xde = bde, wde = xde, bk = ea;
function wB(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !bk(e) && !bk(t) ? e !== e && t !== t : wde(e, t, n, r, wB, i);
}
var X_ = wB, _de = lB, Sde = X_, Ode = 1, Ade = 2;
function Tde(e, t, n, r) {
  var i = n.length, o = i, a = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var l = s[0], c = e[l], f = s[1];
    if (a && s[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var d = new _de();
      if (r)
        var p = r(c, f, l, e, t, d);
      if (!(p === void 0 ? Sde(f, c, Ode | Ade, r, d) : p))
        return !1;
    }
  }
  return !0;
}
var Pde = Tde, Cde = Ha;
function Ede(e) {
  return e === e && !Cde(e);
}
var _B = Ede, kde = _B, Mde = ny;
function Nde(e) {
  for (var t = Mde(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, kde(i)];
  }
  return t;
}
var $de = Nde;
function Dde(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var SB = Dde, Ide = Pde, Rde = $de, jde = SB;
function Lde(e) {
  var t = Rde(e);
  return t.length == 1 && t[0][2] ? jde(t[0][0], t[0][1]) : function(n) {
    return n === e || Ide(n, e, t);
  };
}
var Bde = Lde;
function Fde(e, t) {
  return e != null && t in Object(e);
}
var Wde = Fde, zde = NL, Vde = G_, Ude = Tr, Hde = Y_, Kde = q_, Gde = Zg;
function Yde(e, t, n) {
  t = zde(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var a = Gde(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && Kde(i) && Hde(a, i) && (Ude(e) || Vde(e)));
}
var qde = Yde, Xde = Wde, Zde = qde;
function Jde(e, t) {
  return e != null && Zde(e, t, Xde);
}
var Qde = Jde, ehe = X_, the = $L, nhe = Qde, rhe = M_, ihe = _B, ohe = SB, ahe = Zg, she = 1, lhe = 2;
function che(e, t) {
  return rhe(e) && ihe(t) ? ohe(ahe(e), t) : function(n) {
    var r = the(n, e);
    return r === void 0 && r === t ? nhe(n, e) : ehe(t, r, she | lhe);
  };
}
var uhe = che;
function fhe(e) {
  return e;
}
var qc = fhe;
function dhe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var hhe = dhe, phe = L_;
function mhe(e) {
  return function(t) {
    return phe(t, e);
  };
}
var ghe = mhe, yhe = hhe, vhe = ghe, bhe = M_, xhe = Zg;
function whe(e) {
  return bhe(e) ? yhe(xhe(e)) : vhe(e);
}
var _he = whe, She = Bde, Ohe = uhe, Ahe = qc, The = Tr, Phe = _he;
function Che(e) {
  return typeof e == "function" ? e : e == null ? Ahe : typeof e == "object" ? The(e) ? Ohe(e[0], e[1]) : She(e) : Phe(e);
}
var ao = Che;
function Ehe(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var OB = Ehe;
function khe(e) {
  return e !== e;
}
var Mhe = khe;
function Nhe(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
var $he = Nhe, Dhe = OB, Ihe = Mhe, Rhe = $he;
function jhe(e, t, n) {
  return t === t ? Rhe(e, t, n) : Dhe(e, Ihe, n);
}
var Lhe = jhe, Bhe = Lhe;
function Fhe(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && Bhe(e, t, 0) > -1;
}
var Whe = Fhe;
function zhe(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var Vhe = zhe;
function Uhe() {
}
var Hhe = Uhe, Rb = bB, Khe = Hhe, Ghe = K_, Yhe = 1 / 0, qhe = Rb && 1 / Ghe(new Rb([, -0]))[1] == Yhe ? function(e) {
  return new Rb(e);
} : Khe, Xhe = qhe, Zhe = cB, Jhe = Whe, Qhe = Vhe, epe = fB, tpe = Xhe, npe = K_, rpe = 200;
function ipe(e, t, n) {
  var r = -1, i = Jhe, o = e.length, a = !0, s = [], l = s;
  if (n)
    a = !1, i = Qhe;
  else if (o >= rpe) {
    var c = t ? null : tpe(e);
    if (c)
      return npe(c);
    a = !1, i = epe, l = new Zhe();
  } else
    l = t ? [] : s;
  e:
    for (; ++r < o; ) {
      var f = e[r], d = t ? t(f) : f;
      if (f = n || f !== 0 ? f : 0, a && d === d) {
        for (var p = l.length; p--; )
          if (l[p] === d)
            continue e;
        t && l.push(d), s.push(f);
      } else i(l, d, n) || (l !== s && l.push(d), s.push(f));
    }
  return s;
}
var ope = ipe, ape = ao, spe = ope;
function lpe(e, t) {
  return e && e.length ? spe(e, ape(t)) : [];
}
var cpe = lpe;
const xk = /* @__PURE__ */ kt(cpe);
function AB(e, t, n) {
  return t === !0 ? xk(e, n) : ze(t) ? xk(e, t) : e;
}
function ac(e) {
  "@babel/helpers - typeof";
  return ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ac(e);
}
var upe = ["ref"];
function wk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wk(Object(n), !0).forEach(function(r) {
      ry(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fpe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _k(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, PB(r.key), r);
  }
}
function dpe(e, t, n) {
  return t && _k(e.prototype, t), n && _k(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function hpe(e, t, n) {
  return t = im(t), ppe(e, TB() ? Reflect.construct(t, n || [], im(e).constructor) : t.apply(e, n));
}
function ppe(e, t) {
  if (t && (ac(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return mpe(e);
}
function mpe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function TB() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (TB = function() {
    return !!e;
  })();
}
function im(e) {
  return im = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, im(e);
}
function gpe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rx(e, t);
}
function Rx(e, t) {
  return Rx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Rx(e, t);
}
function ry(e, t, n) {
  return t = PB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PB(e) {
  var t = ype(e, "string");
  return ac(t) == "symbol" ? t : t + "";
}
function ype(e, t) {
  if (ac(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ac(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vpe(e, t) {
  if (e == null) return {};
  var n = bpe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function bpe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function xpe(e) {
  return e.value;
}
function wpe(e, t) {
  if (/* @__PURE__ */ I.isValidElement(e))
    return /* @__PURE__ */ I.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ I.createElement(e, t);
  t.ref;
  var n = vpe(t, upe);
  return /* @__PURE__ */ I.createElement(H_, n);
}
var Sk = 1, jo = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    fpe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = hpe(this, t, [].concat(i)), ry(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return gpe(t, e), dpe(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > Sk || Math.abs(i.height - this.lastBoundingBox.height) > Sk) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, r && r(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? xo({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var i = this.props, o = i.layout, a = i.align, s = i.verticalAlign, l = i.margin, c = i.chartWidth, f = i.chartHeight, d, p;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (a === "center" && o === "vertical") {
          var m = this.getBBoxSnapshot();
          d = {
            left: ((c || 0) - m.width) / 2
          };
        } else
          d = a === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var y = this.getBBoxSnapshot();
          p = {
            top: ((f || 0) - y.height) / 2
          };
        } else
          p = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return xo(xo({}, d), p);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.content, a = i.width, s = i.height, l = i.wrapperStyle, c = i.payloadUniqBy, f = i.payload, d = xo(xo({
        position: "absolute",
        width: a || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ I.createElement("div", {
        className: "recharts-legend-wrapper",
        style: d,
        ref: function(m) {
          r.wrapperNode = m;
        }
      }, wpe(o, xo(xo({}, this.props), {}, {
        payload: AB(f, c, xpe)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, i) {
      var o = xo(xo({}, this.defaultProps), r.props), a = o.layout;
      return a === "vertical" && ve(r.props.height) ? {
        height: r.props.height
      } : a === "horizontal" ? {
        width: r.props.width || i
      } : null;
    }
  }]);
}(pi);
ry(jo, "displayName", "Legend");
ry(jo, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Ok = Td, _pe = G_, Spe = Tr, Ak = Ok ? Ok.isConcatSpreadable : void 0;
function Ope(e) {
  return Spe(e) || _pe(e) || !!(Ak && e && e[Ak]);
}
var Ape = Ope, Tpe = hB, Ppe = Ape;
function CB(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = Ppe), i || (i = []); ++o < a; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? CB(s, t - 1, n, r, i) : Tpe(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var EB = CB;
function Cpe(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var l = a[e ? s : ++i];
      if (n(o[l], l, o) === !1)
        break;
    }
    return t;
  };
}
var Epe = Cpe, kpe = Epe, Mpe = kpe(), Npe = Mpe, $pe = Npe, Dpe = ny;
function Ipe(e, t) {
  return e && $pe(e, t, Dpe);
}
var kB = Ipe, Rpe = Cd;
function jpe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Rpe(n))
      return e(n, r);
    for (var i = n.length, o = t ? i : -1, a = Object(n); (t ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var Lpe = jpe, Bpe = kB, Fpe = Lpe, Wpe = Fpe(Bpe), Z_ = Wpe, zpe = Z_, Vpe = Cd;
function Upe(e, t) {
  var n = -1, r = Vpe(e) ? Array(e.length) : [];
  return zpe(e, function(i, o, a) {
    r[++n] = t(i, o, a);
  }), r;
}
var MB = Upe;
function Hpe(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var Kpe = Hpe, Tk = Wc;
function Gpe(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e === e, o = Tk(e), a = t !== void 0, s = t === null, l = t === t, c = Tk(t);
    if (!s && !c && !o && e > t || o && a && l && !s && !c || r && a && l || !n && l || !i)
      return 1;
    if (!r && !o && !c && e < t || c && n && i && !r && !o || s && n && i || !a && i || !l)
      return -1;
  }
  return 0;
}
var Ype = Gpe, qpe = Ype;
function Xpe(e, t, n) {
  for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a; ) {
    var l = qpe(i[r], o[r]);
    if (l) {
      if (r >= s)
        return l;
      var c = n[r];
      return l * (c == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var Zpe = Xpe, jb = j_, Jpe = L_, Qpe = ao, eme = MB, tme = Kpe, nme = gB, rme = Zpe, ime = qc, ome = Tr;
function ame(e, t, n) {
  t.length ? t = jb(t, function(o) {
    return ome(o) ? function(a) {
      return Jpe(a, o.length === 1 ? o[0] : o);
    } : o;
  }) : t = [ime];
  var r = -1;
  t = jb(t, nme(Qpe));
  var i = eme(e, function(o, a, s) {
    var l = jb(t, function(c) {
      return c(o);
    });
    return { criteria: l, index: ++r, value: o };
  });
  return tme(i, function(o, a) {
    return rme(o, a, n);
  });
}
var sme = ame;
function lme(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var cme = lme, ume = cme, Pk = Math.max;
function fme(e, t, n) {
  return t = Pk(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = Pk(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), ume(e, this, s);
  };
}
var dme = fme;
function hme(e) {
  return function() {
    return e;
  };
}
var pme = hme, mme = Js, gme = function() {
  try {
    var e = mme(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), NB = gme, yme = pme, Ck = NB, vme = qc, bme = Ck ? function(e, t) {
  return Ck(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: yme(t),
    writable: !0
  });
} : vme, xme = bme, wme = 800, _me = 16, Sme = Date.now;
function Ome(e) {
  var t = 0, n = 0;
  return function() {
    var r = Sme(), i = _me - (r - n);
    if (n = r, i > 0) {
      if (++t >= wme)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Ame = Ome, Tme = xme, Pme = Ame, Cme = Pme(Tme), Eme = Cme, kme = qc, Mme = dme, Nme = Eme;
function $me(e, t) {
  return Nme(Mme(e, t, kme), e + "");
}
var Dme = $me, Ime = $_, Rme = Cd, jme = Y_, Lme = Ha;
function Bme(e, t, n) {
  if (!Lme(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? Rme(n) && jme(t, n.length) : r == "string" && t in n) ? Ime(n[t], e) : !1;
}
var iy = Bme, Fme = EB, Wme = sme, zme = Dme, Ek = iy, Vme = zme(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && Ek(e, t[0], t[1]) ? t = [] : n > 2 && Ek(t[0], t[1], t[2]) && (t = [t[0]]), Wme(e, Fme(t, 1), []);
}), Ume = Vme;
const J_ = /* @__PURE__ */ kt(Ume);
function Cf(e) {
  "@babel/helpers - typeof";
  return Cf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cf(e);
}
function jx() {
  return jx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jx.apply(this, arguments);
}
function Hme(e, t) {
  return qme(e) || Yme(e, t) || Gme(e, t) || Kme();
}
function Kme() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gme(e, t) {
  if (e) {
    if (typeof e == "string") return kk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kk(e, t);
  }
}
function kk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Yme(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function qme(e) {
  if (Array.isArray(e)) return e;
}
function Mk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mk(Object(n), !0).forEach(function(r) {
      Xme(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Xme(e, t, n) {
  return t = Zme(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Zme(e) {
  var t = Jme(e, "string");
  return Cf(t) == "symbol" ? t : t + "";
}
function Jme(e, t) {
  if (Cf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Cf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Qme(e) {
  return Array.isArray(e) && On(e[0]) && On(e[1]) ? e.join(" ~ ") : e;
}
var ege = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, i = t.contentStyle, o = i === void 0 ? {} : i, a = t.itemStyle, s = a === void 0 ? {} : a, l = t.labelStyle, c = l === void 0 ? {} : l, f = t.payload, d = t.formatter, p = t.itemSorter, m = t.wrapperClassName, y = t.labelClassName, g = t.label, v = t.labelFormatter, x = t.accessibilityLayer, w = x === void 0 ? !1 : x, S = function() {
    if (f && f.length) {
      var N = {
        padding: 0,
        margin: 0
      }, R = (p ? J_(f, p) : f).map(function(L, F) {
        if (L.type === "none")
          return null;
        var W = Lb({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: L.color || "#000"
        }, s), z = L.formatter || d || Qme, G = L.value, U = L.name, V = G, Y = U;
        if (z && V != null && Y != null) {
          var ee = z(G, U, L, F, f);
          if (Array.isArray(ee)) {
            var ie = Hme(ee, 2);
            V = ie[0], Y = ie[1];
          } else
            V = ee;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ I.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(F),
            style: W
          }, On(Y) ? /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, Y) : null, On(Y) ? /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, V), /* @__PURE__ */ I.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, L.unit || ""))
        );
      });
      return /* @__PURE__ */ I.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: N
      }, R);
    }
    return null;
  }, A = Lb({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, o), _ = Lb({
    margin: 0
  }, c), O = !Ue(g), P = O ? g : "", C = Ye("recharts-default-tooltip", m), k = Ye("recharts-tooltip-label", y);
  O && v && f !== void 0 && f !== null && (P = v(g, f));
  var D = w ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ I.createElement("div", jx({
    className: C,
    style: A
  }, D), /* @__PURE__ */ I.createElement("p", {
    className: k,
    style: _
  }, /* @__PURE__ */ I.isValidElement(P) ? P : "".concat(P)), S());
};
function Ef(e) {
  "@babel/helpers - typeof";
  return Ef = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ef(e);
}
function Uh(e, t, n) {
  return t = tge(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tge(e) {
  var t = nge(e, "string");
  return Ef(t) == "symbol" ? t : t + "";
}
function nge(e, t) {
  if (Ef(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ef(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Pu = "recharts-tooltip-wrapper", rge = {
  visibility: "hidden"
};
function ige(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return Ye(Pu, Uh(Uh(Uh(Uh({}, "".concat(Pu, "-right"), ve(n) && t && ve(t.x) && n >= t.x), "".concat(Pu, "-left"), ve(n) && t && ve(t.x) && n < t.x), "".concat(Pu, "-bottom"), ve(r) && t && ve(t.y) && r >= t.y), "".concat(Pu, "-top"), ve(r) && t && ve(t.y) && r < t.y));
}
function Nk(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, i = e.offsetTopLeft, o = e.position, a = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, c = e.viewBoxDimension;
  if (o && ve(o[r]))
    return o[r];
  var f = n[r] - s - i, d = n[r] + i;
  if (t[r])
    return a[r] ? f : d;
  if (a[r]) {
    var p = f, m = l[r];
    return p < m ? Math.max(d, l[r]) : Math.max(f, l[r]);
  }
  var y = d + s, g = l[r] + c;
  return y > g ? Math.max(f, l[r]) : Math.max(d, l[r]);
}
function oge(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function age(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, i = e.position, o = e.reverseDirection, a = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, c, f, d;
  return a.height > 0 && a.width > 0 && n ? (f = Nk({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), d = Nk({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = oge({
    translateX: f,
    translateY: d,
    useTranslate3d: s
  })) : c = rge, {
    cssProperties: c,
    cssClasses: ige({
      translateX: f,
      translateY: d,
      coordinate: n
    })
  };
}
function sc(e) {
  "@babel/helpers - typeof";
  return sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sc(e);
}
function $k(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Dk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $k(Object(n), !0).forEach(function(r) {
      Bx(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $k(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function sge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lge(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, DB(r.key), r);
  }
}
function cge(e, t, n) {
  return t && lge(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function uge(e, t, n) {
  return t = om(t), fge(e, $B() ? Reflect.construct(t, n || [], om(e).constructor) : t.apply(e, n));
}
function fge(e, t) {
  if (t && (sc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dge(e);
}
function dge(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $B() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($B = function() {
    return !!e;
  })();
}
function om(e) {
  return om = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, om(e);
}
function hge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lx(e, t);
}
function Lx(e, t) {
  return Lx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Lx(e, t);
}
function Bx(e, t, n) {
  return t = DB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function DB(e) {
  var t = pge(e, "string");
  return sc(t) == "symbol" ? t : t + "";
}
function pge(e, t) {
  if (sc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (sc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ik = 1, mge = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    sge(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = uge(this, t, [].concat(i)), Bx(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Bx(n, "handleKeyDown", function(a) {
      if (a.key === "Escape") {
        var s, l, c, f;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = n.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (c = (f = n.props.coordinate) === null || f === void 0 ? void 0 : f.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), n;
  }
  return hge(t, e), cge(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > Ik || Math.abs(r.height - this.state.lastBoundingBox.height) > Ik) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, l = i.animationEasing, c = i.children, f = i.coordinate, d = i.hasPayload, p = i.isAnimationActive, m = i.offset, y = i.position, g = i.reverseDirection, v = i.useTranslate3d, x = i.viewBox, w = i.wrapperStyle, S = age({
        allowEscapeViewBox: a,
        coordinate: f,
        offsetTopLeft: m,
        position: y,
        reverseDirection: g,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: v,
        viewBox: x
      }), A = S.cssClasses, _ = S.cssProperties, O = Dk(Dk({
        transition: p && o ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, _), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && o && d ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, w);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ I.createElement("div", {
          tabIndex: -1,
          className: A,
          style: O,
          ref: function(C) {
            r.wrapperNode = C;
          }
        }, c)
      );
    }
  }]);
}(pi), gge = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Ni = {
  isSsr: gge(),
  get: function(t) {
    return Ni[t];
  },
  set: function(t, n) {
    if (typeof t == "string")
      Ni[t] = n;
    else {
      var r = Object.keys(t);
      r && r.length && r.forEach(function(i) {
        Ni[i] = t[i];
      });
    }
  }
};
function lc(e) {
  "@babel/helpers - typeof";
  return lc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lc(e);
}
function Rk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rk(Object(n), !0).forEach(function(r) {
      Q_(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function yge(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vge(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, RB(r.key), r);
  }
}
function bge(e, t, n) {
  return t && vge(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xge(e, t, n) {
  return t = am(t), wge(e, IB() ? Reflect.construct(t, n || [], am(e).constructor) : t.apply(e, n));
}
function wge(e, t) {
  if (t && (lc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _ge(e);
}
function _ge(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function IB() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (IB = function() {
    return !!e;
  })();
}
function am(e) {
  return am = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, am(e);
}
function Sge(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fx(e, t);
}
function Fx(e, t) {
  return Fx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Fx(e, t);
}
function Q_(e, t, n) {
  return t = RB(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function RB(e) {
  var t = Oge(e, "string");
  return lc(t) == "symbol" ? t : t + "";
}
function Oge(e, t) {
  if (lc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (lc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Age(e) {
  return e.dataKey;
}
function Tge(e, t) {
  return /* @__PURE__ */ I.isValidElement(e) ? /* @__PURE__ */ I.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ I.createElement(e, t) : /* @__PURE__ */ I.createElement(ege, t);
}
var Lr = /* @__PURE__ */ function(e) {
  function t() {
    return yge(this, t), xge(this, t, arguments);
  }
  return Sge(t, e), bge(t, [{
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, l = i.animationEasing, c = i.content, f = i.coordinate, d = i.filterNull, p = i.isAnimationActive, m = i.offset, y = i.payload, g = i.payloadUniqBy, v = i.position, x = i.reverseDirection, w = i.useTranslate3d, S = i.viewBox, A = i.wrapperStyle, _ = y ?? [];
      d && _.length && (_ = AB(y.filter(function(P) {
        return P.value != null && (P.hide !== !0 || r.props.includeHidden);
      }), g, Age));
      var O = _.length > 0;
      return /* @__PURE__ */ I.createElement(mge, {
        allowEscapeViewBox: a,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: p,
        active: o,
        coordinate: f,
        hasPayload: O,
        offset: m,
        position: v,
        reverseDirection: x,
        useTranslate3d: w,
        viewBox: S,
        wrapperStyle: A
      }, Tge(c, jk(jk({}, this.props), {}, {
        payload: _
      })));
    }
  }]);
}(pi);
Q_(Lr, "displayName", "Tooltip");
Q_(Lr, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Ni.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Pge = oo, Cge = function() {
  return Pge.Date.now();
}, Ege = Cge, kge = /\s/;
function Mge(e) {
  for (var t = e.length; t-- && kge.test(e.charAt(t)); )
    ;
  return t;
}
var Nge = Mge, $ge = Nge, Dge = /^\s+/;
function Ige(e) {
  return e && e.slice(0, $ge(e) + 1).replace(Dge, "");
}
var Rge = Ige, jge = Rge, Lk = Ha, Lge = Wc, Bk = NaN, Bge = /^[-+]0x[0-9a-f]+$/i, Fge = /^0b[01]+$/i, Wge = /^0o[0-7]+$/i, zge = parseInt;
function Vge(e) {
  if (typeof e == "number")
    return e;
  if (Lge(e))
    return Bk;
  if (Lk(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Lk(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = jge(e);
  var n = Fge.test(e);
  return n || Wge.test(e) ? zge(e.slice(2), n ? 2 : 8) : Bge.test(e) ? Bk : +e;
}
var jB = Vge, Uge = Ha, Bb = Ege, Fk = jB, Hge = "Expected a function", Kge = Math.max, Gge = Math.min;
function Yge(e, t, n) {
  var r, i, o, a, s, l, c = 0, f = !1, d = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(Hge);
  t = Fk(t) || 0, Uge(n) && (f = !!n.leading, d = "maxWait" in n, o = d ? Kge(Fk(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p);
  function m(O) {
    var P = r, C = i;
    return r = i = void 0, c = O, a = e.apply(C, P), a;
  }
  function y(O) {
    return c = O, s = setTimeout(x, t), f ? m(O) : a;
  }
  function g(O) {
    var P = O - l, C = O - c, k = t - P;
    return d ? Gge(k, o - C) : k;
  }
  function v(O) {
    var P = O - l, C = O - c;
    return l === void 0 || P >= t || P < 0 || d && C >= o;
  }
  function x() {
    var O = Bb();
    if (v(O))
      return w(O);
    s = setTimeout(x, g(O));
  }
  function w(O) {
    return s = void 0, p && r ? m(O) : (r = i = void 0, a);
  }
  function S() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = i = s = void 0;
  }
  function A() {
    return s === void 0 ? a : w(Bb());
  }
  function _() {
    var O = Bb(), P = v(O);
    if (r = arguments, i = this, l = O, P) {
      if (s === void 0)
        return y(l);
      if (d)
        return clearTimeout(s), s = setTimeout(x, t), m(l);
    }
    return s === void 0 && (s = setTimeout(x, t)), a;
  }
  return _.cancel = S, _.flush = A, _;
}
var qge = Yge, Xge = qge, Zge = Ha, Jge = "Expected a function";
function Qge(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Jge);
  return Zge(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Xge(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
var eye = Qge;
const LB = /* @__PURE__ */ kt(eye);
function kf(e) {
  "@babel/helpers - typeof";
  return kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kf(e);
}
function Wk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wk(Object(n), !0).forEach(function(r) {
      tye(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function tye(e, t, n) {
  return t = nye(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nye(e) {
  var t = rye(e, "string");
  return kf(t) == "symbol" ? t : t + "";
}
function rye(e, t) {
  if (kf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (kf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function iye(e, t) {
  return lye(e) || sye(e, t) || aye(e, t) || oye();
}
function oye() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aye(e, t) {
  if (e) {
    if (typeof e == "string") return zk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zk(e, t);
  }
}
function zk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function sye(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function lye(e) {
  if (Array.isArray(e)) return e;
}
var eS = /* @__PURE__ */ Dt(function(e, t) {
  var n = e.aspect, r = e.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, o = e.width, a = o === void 0 ? "100%" : o, s = e.height, l = s === void 0 ? "100%" : s, c = e.minWidth, f = c === void 0 ? 0 : c, d = e.minHeight, p = e.maxHeight, m = e.children, y = e.debounce, g = y === void 0 ? 0 : y, v = e.id, x = e.className, w = e.onResize, S = e.style, A = S === void 0 ? {} : S, _ = ut(null), O = ut();
  O.current = w, aH(t, function() {
    return Object.defineProperty(_.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), _.current;
      },
      configurable: !0
    });
  });
  var P = Me({
    containerWidth: i.width,
    containerHeight: i.height
  }), C = iye(P, 2), k = C[0], D = C[1], $ = qe(function(R, L) {
    D(function(F) {
      var W = Math.round(R), z = Math.round(L);
      return F.containerWidth === W && F.containerHeight === z ? F : {
        containerWidth: W,
        containerHeight: z
      };
    });
  }, []);
  Xe(function() {
    var R = function(U) {
      var V, Y = U[0].contentRect, ee = Y.width, ie = Y.height;
      $(ee, ie), (V = O.current) === null || V === void 0 || V.call(O, ee, ie);
    };
    g > 0 && (R = LB(R, g, {
      trailing: !0,
      leading: !1
    }));
    var L = new ResizeObserver(R), F = _.current.getBoundingClientRect(), W = F.width, z = F.height;
    return $(W, z), L.observe(_.current), function() {
      L.disconnect();
    };
  }, [$, g]);
  var N = Fe(function() {
    var R = k.containerWidth, L = k.containerHeight;
    if (R < 0 || L < 0)
      return null;
    Mi(ws(a) || ws(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, a, l), Mi(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var F = ws(a) ? R : a, W = ws(l) ? L : l;
    n && n > 0 && (F ? W = F / n : W && (F = W * n), p && W > p && (W = p)), Mi(F > 0 || W > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, F, W, a, l, f, d, n);
    var z = !Array.isArray(m) && Ro(m.type).endsWith("Chart");
    return I.Children.map(m, function(G) {
      return /* @__PURE__ */ I.isValidElement(G) ? /* @__PURE__ */ ht(G, Hh({
        width: F,
        height: W
      }, z ? {
        style: Hh({
          height: "100%",
          width: "100%",
          maxHeight: W,
          maxWidth: F
        }, G.props.style)
      } : {})) : G;
    });
  }, [n, m, l, p, d, f, k, a]);
  return /* @__PURE__ */ I.createElement("div", {
    id: v ? "".concat(v) : void 0,
    className: Ye("recharts-responsive-container", x),
    style: Hh(Hh({}, A), {}, {
      width: a,
      height: l,
      minWidth: f,
      minHeight: d,
      maxHeight: p
    }),
    ref: _
  }, N);
}), tS = function(t) {
  return null;
};
tS.displayName = "Cell";
function Mf(e) {
  "@babel/helpers - typeof";
  return Mf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mf(e);
}
function Vk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wx(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vk(Object(n), !0).forEach(function(r) {
      cye(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vk(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cye(e, t, n) {
  return t = uye(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function uye(e) {
  var t = fye(e, "string");
  return Mf(t) == "symbol" ? t : t + "";
}
function fye(e, t) {
  if (Mf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Mf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wl = {
  widthCache: {},
  cacheCount: 0
}, dye = 2e3, hye = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, Uk = "recharts_measurement_span";
function pye(e) {
  var t = Wx({}, e);
  return Object.keys(t).forEach(function(n) {
    t[n] || delete t[n];
  }), t;
}
var ef = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Ni.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = pye(n), i = JSON.stringify({
    text: t,
    copyStyle: r
  });
  if (wl.widthCache[i])
    return wl.widthCache[i];
  try {
    var o = document.getElementById(Uk);
    o || (o = document.createElement("span"), o.setAttribute("id", Uk), o.setAttribute("aria-hidden", "true"), document.body.appendChild(o));
    var a = Wx(Wx({}, hye), r);
    Object.assign(o.style, a), o.textContent = "".concat(t);
    var s = o.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return wl.widthCache[i] = l, ++wl.cacheCount > dye && (wl.cacheCount = 0, wl.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, mye = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Nf(e) {
  "@babel/helpers - typeof";
  return Nf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nf(e);
}
function sm(e, t) {
  return bye(e) || vye(e, t) || yye(e, t) || gye();
}
function gye() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yye(e, t) {
  if (e) {
    if (typeof e == "string") return Hk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Hk(e, t);
  }
}
function Hk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function vye(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function bye(e) {
  if (Array.isArray(e)) return e;
}
function xye(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Kk(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _ye(r.key), r);
  }
}
function wye(e, t, n) {
  return t && Kk(e.prototype, t), n && Kk(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _ye(e) {
  var t = Sye(e, "string");
  return Nf(t) == "symbol" ? t : t + "";
}
function Sye(e, t) {
  if (Nf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Nf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Gk = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Yk = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Oye = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, Aye = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, BB = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, Tye = Object.keys(BB), Rl = "NaN";
function Pye(e, t) {
  return e * BB[t];
}
var Kh = /* @__PURE__ */ function() {
  function e(t, n) {
    xye(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !Oye.test(n) && (this.num = NaN, this.unit = ""), Tye.includes(n) && (this.num = Pye(t, n), this.unit = "px");
  }
  return wye(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, i = (r = Aye.exec(n)) !== null && r !== void 0 ? r : [], o = sm(i, 3), a = o[1], s = o[2];
      return new e(parseFloat(a), s ?? "");
    }
  }]);
}();
function FB(e) {
  if (e.includes(Rl))
    return Rl;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = Gk.exec(t)) !== null && n !== void 0 ? n : [], i = sm(r, 4), o = i[1], a = i[2], s = i[3], l = Kh.parse(o ?? ""), c = Kh.parse(s ?? ""), f = a === "*" ? l.multiply(c) : l.divide(c);
    if (f.isNaN())
      return Rl;
    t = t.replace(Gk, f.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var d, p = (d = Yk.exec(t)) !== null && d !== void 0 ? d : [], m = sm(p, 4), y = m[1], g = m[2], v = m[3], x = Kh.parse(y ?? ""), w = Kh.parse(v ?? ""), S = g === "+" ? x.add(w) : x.subtract(w);
    if (S.isNaN())
      return Rl;
    t = t.replace(Yk, S.toString());
  }
  return t;
}
var qk = /\(([^()]*)\)/;
function Cye(e) {
  for (var t = e; t.includes("("); ) {
    var n = qk.exec(t), r = sm(n, 2), i = r[1];
    t = t.replace(qk, FB(i));
  }
  return t;
}
function Eye(e) {
  var t = e.replace(/\s+/g, "");
  return t = Cye(t), t = FB(t), t;
}
function kye(e) {
  try {
    return Eye(e);
  } catch {
    return Rl;
  }
}
function Fb(e) {
  var t = kye(e.slice(5, -1));
  return t === Rl ? "" : t;
}
var Mye = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], Nye = ["dx", "dy", "angle", "className", "breakAll"];
function zx() {
  return zx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zx.apply(this, arguments);
}
function Xk(e, t) {
  if (e == null) return {};
  var n = $ye(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $ye(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Zk(e, t) {
  return jye(e) || Rye(e, t) || Iye(e, t) || Dye();
}
function Dye() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Iye(e, t) {
  if (e) {
    if (typeof e == "string") return Jk(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Jk(e, t);
  }
}
function Jk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Rye(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function jye(e) {
  if (Array.isArray(e)) return e;
}
var WB = /[ \f\n\r\t\v\u2028\u2029]+/, zB = function(t) {
  var n = t.children, r = t.breakAll, i = t.style;
  try {
    var o = [];
    Ue(n) || (r ? o = n.toString().split("") : o = n.toString().split(WB));
    var a = o.map(function(l) {
      return {
        word: l,
        width: ef(l, i).width
      };
    }), s = r ? 0 : ef(" ", i).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, Lye = function(t, n, r, i, o) {
  var a = t.maxLines, s = t.children, l = t.style, c = t.breakAll, f = ve(a), d = s, p = function() {
    var F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return F.reduce(function(W, z) {
      var G = z.word, U = z.width, V = W[W.length - 1];
      if (V && (i == null || o || V.width + U + r < Number(i)))
        V.words.push(G), V.width += U + r;
      else {
        var Y = {
          words: [G],
          width: U
        };
        W.push(Y);
      }
      return W;
    }, []);
  }, m = p(n), y = function(F) {
    return F.reduce(function(W, z) {
      return W.width > z.width ? W : z;
    });
  };
  if (!f)
    return m;
  for (var g = "…", v = function(F) {
    var W = d.slice(0, F), z = zB({
      breakAll: c,
      style: l,
      children: W + g
    }).wordsWithComputedWidth, G = p(z), U = G.length > a || y(G).width > Number(i);
    return [U, G];
  }, x = 0, w = d.length - 1, S = 0, A; x <= w && S <= d.length - 1; ) {
    var _ = Math.floor((x + w) / 2), O = _ - 1, P = v(O), C = Zk(P, 2), k = C[0], D = C[1], $ = v(_), N = Zk($, 1), R = N[0];
    if (!k && !R && (x = _ + 1), k && R && (w = _ - 1), !k && R) {
      A = D;
      break;
    }
    S++;
  }
  return A || m;
}, Qk = function(t) {
  var n = Ue(t) ? [] : t.toString().split(WB);
  return [{
    words: n
  }];
}, Bye = function(t) {
  var n = t.width, r = t.scaleToFit, i = t.children, o = t.style, a = t.breakAll, s = t.maxLines;
  if ((n || r) && !Ni.isSsr) {
    var l, c, f = zB({
      breakAll: a,
      children: i,
      style: o
    });
    if (f) {
      var d = f.wordsWithComputedWidth, p = f.spaceWidth;
      l = d, c = p;
    } else
      return Qk(i);
    return Lye({
      breakAll: a,
      children: i,
      maxLines: s,
      style: o
    }, l, c, n, r);
  }
  return Qk(i);
}, eM = "#808080", Ws = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.lineHeight, s = a === void 0 ? "1em" : a, l = t.capHeight, c = l === void 0 ? "0.71em" : l, f = t.scaleToFit, d = f === void 0 ? !1 : f, p = t.textAnchor, m = p === void 0 ? "start" : p, y = t.verticalAnchor, g = y === void 0 ? "end" : y, v = t.fill, x = v === void 0 ? eM : v, w = Xk(t, Mye), S = Fe(function() {
    return Bye({
      breakAll: w.breakAll,
      children: w.children,
      maxLines: w.maxLines,
      scaleToFit: d,
      style: w.style,
      width: w.width
    });
  }, [w.breakAll, w.children, w.maxLines, d, w.style, w.width]), A = w.dx, _ = w.dy, O = w.angle, P = w.className, C = w.breakAll, k = Xk(w, Nye);
  if (!On(r) || !On(o))
    return null;
  var D = r + (ve(A) ? A : 0), $ = o + (ve(_) ? _ : 0), N;
  switch (g) {
    case "start":
      N = Fb("calc(".concat(c, ")"));
      break;
    case "middle":
      N = Fb("calc(".concat((S.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      N = Fb("calc(".concat(S.length - 1, " * -").concat(s, ")"));
      break;
  }
  var R = [];
  if (d) {
    var L = S[0].width, F = w.width;
    R.push("scale(".concat((ve(F) ? F / L : 1) / L, ")"));
  }
  return O && R.push("rotate(".concat(O, ", ").concat(D, ", ").concat($, ")")), R.length && (k.transform = R.join(" ")), /* @__PURE__ */ I.createElement("text", zx({}, Ee(k, !0), {
    x: D,
    y: $,
    className: Ye("recharts-text", P),
    textAnchor: m,
    fill: x.includes("url") ? eM : x
  }), S.map(function(W, z) {
    var G = W.words.join(C ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ I.createElement("tspan", {
        x: D,
        dy: z === 0 ? N : s,
        key: "".concat(G, "-").concat(z)
      }, G)
    );
  }));
};
function Ma(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Fye(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function nS(e) {
  let t, n, r;
  e.length !== 2 ? (t = Ma, n = (s, l) => Ma(e(s), l), r = (s, l) => e(s) - l) : (t = e === Ma || e === Fye ? e : Wye, n = e, r = e);
  function i(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const d = c + f >>> 1;
        n(s[d], l) < 0 ? c = d + 1 : f = d;
      } while (c < f);
    }
    return c;
  }
  function o(s, l, c = 0, f = s.length) {
    if (c < f) {
      if (t(l, l) !== 0) return f;
      do {
        const d = c + f >>> 1;
        n(s[d], l) <= 0 ? c = d + 1 : f = d;
      } while (c < f);
    }
    return c;
  }
  function a(s, l, c = 0, f = s.length) {
    const d = i(s, l, c, f - 1);
    return d > c && r(s[d - 1], l) > -r(s[d], l) ? d - 1 : d;
  }
  return { left: i, center: a, right: o };
}
function Wye() {
  return 0;
}
function VB(e) {
  return e === null ? NaN : +e;
}
function* zye(e, t) {
  for (let n of e)
    n != null && (n = +n) >= n && (yield n);
}
const Vye = nS(Ma), Ed = Vye.right;
nS(VB).center;
class tM extends Map {
  constructor(t, n = Kye) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, i] of t) this.set(r, i);
  }
  get(t) {
    return super.get(nM(this, t));
  }
  has(t) {
    return super.has(nM(this, t));
  }
  set(t, n) {
    return super.set(Uye(this, t), n);
  }
  delete(t) {
    return super.delete(Hye(this, t));
  }
}
function nM({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function Uye({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function Hye({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function Kye(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Gye(e = Ma) {
  if (e === Ma) return UB;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function UB(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const Yye = Math.sqrt(50), qye = Math.sqrt(10), Xye = Math.sqrt(2);
function lm(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= Yye ? 10 : o >= qye ? 5 : o >= Xye ? 2 : 1;
  let s, l, c;
  return i < 0 ? (c = Math.pow(10, -i) / a, s = Math.round(e * c), l = Math.round(t * c), s / c < e && ++s, l / c > t && --l, c = -c) : (c = Math.pow(10, i) * a, s = Math.round(e / c), l = Math.round(t / c), s * c < e && ++s, l * c > t && --l), l < s && 0.5 <= n && n < 2 ? lm(e, t, n * 2) : [s, l, c];
}
function Vx(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [i, o, a] = r ? lm(t, e, n) : lm(e, t, n);
  if (!(o >= i)) return [];
  const s = o - i + 1, l = new Array(s);
  if (r)
    if (a < 0) for (let c = 0; c < s; ++c) l[c] = (o - c) / -a;
    else for (let c = 0; c < s; ++c) l[c] = (o - c) * a;
  else if (a < 0) for (let c = 0; c < s; ++c) l[c] = (i + c) / -a;
  else for (let c = 0; c < s; ++c) l[c] = (i + c) * a;
  return l;
}
function Ux(e, t, n) {
  return t = +t, e = +e, n = +n, lm(e, t, n)[2];
}
function Hx(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? Ux(t, e, n) : Ux(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function rM(e, t) {
  let n;
  for (const r of e)
    r != null && (n < r || n === void 0 && r >= r) && (n = r);
  return n;
}
function iM(e, t) {
  let n;
  for (const r of e)
    r != null && (n > r || n === void 0 && r >= r) && (n = r);
  return n;
}
function HB(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r)) return e;
  for (i = i === void 0 ? UB : Gye(i); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, c = t - n + 1, f = Math.log(l), d = 0.5 * Math.exp(2 * f / 3), p = 0.5 * Math.sqrt(f * d * (l - d) / l) * (c - l / 2 < 0 ? -1 : 1), m = Math.max(n, Math.floor(t - c * d / l + p)), y = Math.min(r, Math.floor(t + (l - c) * d / l + p));
      HB(e, t, m, y, i);
    }
    const o = e[t];
    let a = n, s = r;
    for (Cu(e, n, t), i(e[r], o) > 0 && Cu(e, n, r); a < s; ) {
      for (Cu(e, a, s), ++a, --s; i(e[a], o) < 0; ) ++a;
      for (; i(e[s], o) > 0; ) --s;
    }
    i(e[n], o) === 0 ? Cu(e, n, s) : (++s, Cu(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function Cu(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function Zye(e, t, n) {
  if (e = Float64Array.from(zye(e)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return iM(e);
    if (t >= 1) return rM(e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = rM(HB(e, o).subarray(0, o + 1)), s = iM(e.subarray(o + 1));
    return a + (s - a) * (i - o);
  }
}
function Jye(e, t, n = VB) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = +n(e[o], o, e), s = +n(e[o + 1], o + 1, e);
    return a + (s - a) * (i - o);
  }
}
function Qye(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = e + r * n;
  return o;
}
function mi(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function ta(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Kx = Symbol("implicit");
function rS() {
  var e = new tM(), t = [], n = [], r = Kx;
  function i(o) {
    let a = e.get(o);
    if (a === void 0) {
      if (r !== Kx) return r;
      e.set(o, a = t.push(o) - 1);
    }
    return n[a % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [], e = new tM();
    for (const a of o)
      e.has(a) || e.set(a, t.push(a) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return rS(t, n).unknown(r);
  }, mi.apply(i, arguments), i;
}
function $f() {
  var e = rS().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, o, a, s = !1, l = 0, c = 0, f = 0.5;
  delete e.unknown;
  function d() {
    var p = t().length, m = i < r, y = m ? i : r, g = m ? r : i;
    o = (g - y) / Math.max(1, p - l + c * 2), s && (o = Math.floor(o)), y += (g - y - o * (p - l)) * f, a = o * (1 - l), s && (y = Math.round(y), a = Math.round(a));
    var v = Qye(p).map(function(x) {
      return y + o * x;
    });
    return n(m ? v.reverse() : v);
  }
  return e.domain = function(p) {
    return arguments.length ? (t(p), d()) : t();
  }, e.range = function(p) {
    return arguments.length ? ([r, i] = p, r = +r, i = +i, d()) : [r, i];
  }, e.rangeRound = function(p) {
    return [r, i] = p, r = +r, i = +i, s = !0, d();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return o;
  }, e.round = function(p) {
    return arguments.length ? (s = !!p, d()) : s;
  }, e.padding = function(p) {
    return arguments.length ? (l = Math.min(1, c = +p), d()) : l;
  }, e.paddingInner = function(p) {
    return arguments.length ? (l = Math.min(1, p), d()) : l;
  }, e.paddingOuter = function(p) {
    return arguments.length ? (c = +p, d()) : c;
  }, e.align = function(p) {
    return arguments.length ? (f = Math.max(0, Math.min(1, p)), d()) : f;
  }, e.copy = function() {
    return $f(t(), [r, i]).round(s).paddingInner(l).paddingOuter(c).align(f);
  }, mi.apply(d(), arguments);
}
function KB(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return KB(t());
  }, e;
}
function tf() {
  return KB($f.apply(null, arguments).paddingInner(1));
}
function iS(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function GB(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function kd() {
}
var Df = 0.7, cm = 1 / Df, Gl = "\\s*([+-]?\\d+)\\s*", If = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Xi = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", eve = /^#([0-9a-f]{3,8})$/, tve = new RegExp(`^rgb\\(${Gl},${Gl},${Gl}\\)$`), nve = new RegExp(`^rgb\\(${Xi},${Xi},${Xi}\\)$`), rve = new RegExp(`^rgba\\(${Gl},${Gl},${Gl},${If}\\)$`), ive = new RegExp(`^rgba\\(${Xi},${Xi},${Xi},${If}\\)$`), ove = new RegExp(`^hsl\\(${If},${Xi},${Xi}\\)$`), ave = new RegExp(`^hsla\\(${If},${Xi},${Xi},${If}\\)$`), oM = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
iS(kd, Rf, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: aM,
  // Deprecated! Use color.formatHex.
  formatHex: aM,
  formatHex8: sve,
  formatHsl: lve,
  formatRgb: sM,
  toString: sM
});
function aM() {
  return this.rgb().formatHex();
}
function sve() {
  return this.rgb().formatHex8();
}
function lve() {
  return YB(this).formatHsl();
}
function sM() {
  return this.rgb().formatRgb();
}
function Rf(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = eve.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? lM(t) : n === 3 ? new _r(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Gh(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Gh(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = tve.exec(e)) ? new _r(t[1], t[2], t[3], 1) : (t = nve.exec(e)) ? new _r(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = rve.exec(e)) ? Gh(t[1], t[2], t[3], t[4]) : (t = ive.exec(e)) ? Gh(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = ove.exec(e)) ? fM(t[1], t[2] / 100, t[3] / 100, 1) : (t = ave.exec(e)) ? fM(t[1], t[2] / 100, t[3] / 100, t[4]) : oM.hasOwnProperty(e) ? lM(oM[e]) : e === "transparent" ? new _r(NaN, NaN, NaN, 0) : null;
}
function lM(e) {
  return new _r(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Gh(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new _r(e, t, n, r);
}
function cve(e) {
  return e instanceof kd || (e = Rf(e)), e ? (e = e.rgb(), new _r(e.r, e.g, e.b, e.opacity)) : new _r();
}
function Gx(e, t, n, r) {
  return arguments.length === 1 ? cve(e) : new _r(e, t, n, r ?? 1);
}
function _r(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
iS(_r, Gx, GB(kd, {
  brighter(e) {
    return e = e == null ? cm : Math.pow(cm, e), new _r(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Df : Math.pow(Df, e), new _r(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new _r(ks(this.r), ks(this.g), ks(this.b), um(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: cM,
  // Deprecated! Use color.formatHex.
  formatHex: cM,
  formatHex8: uve,
  formatRgb: uM,
  toString: uM
}));
function cM() {
  return `#${_s(this.r)}${_s(this.g)}${_s(this.b)}`;
}
function uve() {
  return `#${_s(this.r)}${_s(this.g)}${_s(this.b)}${_s((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function uM() {
  const e = um(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${ks(this.r)}, ${ks(this.g)}, ${ks(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function um(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function ks(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function _s(e) {
  return e = ks(e), (e < 16 ? "0" : "") + e.toString(16);
}
function fM(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Ci(e, t, n, r);
}
function YB(e) {
  if (e instanceof Ci) return new Ci(e.h, e.s, e.l, e.opacity);
  if (e instanceof kd || (e = Rf(e)), !e) return new Ci();
  if (e instanceof Ci) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, l = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? o + i : 2 - o - i, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new Ci(a, s, l, e.opacity);
}
function fve(e, t, n, r) {
  return arguments.length === 1 ? YB(e) : new Ci(e, t, n, r ?? 1);
}
function Ci(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
iS(Ci, fve, GB(kd, {
  brighter(e) {
    return e = e == null ? cm : Math.pow(cm, e), new Ci(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Df : Math.pow(Df, e), new Ci(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new _r(
      Wb(e >= 240 ? e - 240 : e + 120, i, r),
      Wb(e, i, r),
      Wb(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Ci(dM(this.h), Yh(this.s), Yh(this.l), um(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = um(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${dM(this.h)}, ${Yh(this.s) * 100}%, ${Yh(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function dM(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Yh(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Wb(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const oS = (e) => () => e;
function dve(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function hve(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function pve(e) {
  return (e = +e) == 1 ? qB : function(t, n) {
    return n - t ? hve(t, n, e) : oS(isNaN(t) ? n : t);
  };
}
function qB(e, t) {
  var n = t - e;
  return n ? dve(e, n) : oS(isNaN(e) ? t : e);
}
const hM = function e(t) {
  var n = pve(t);
  function r(i, o) {
    var a = n((i = Gx(i)).r, (o = Gx(o)).r), s = n(i.g, o.g), l = n(i.b, o.b), c = qB(i.opacity, o.opacity);
    return function(f) {
      return i.r = a(f), i.g = s(f), i.b = l(f), i.opacity = c(f), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function mve(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function gve(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function yve(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a) i[a] = Xc(e[a], t[a]);
  for (; a < n; ++a) o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) o[a] = i[a](s);
    return o;
  };
}
function vve(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function fm(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function bve(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Xc(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n) r[i] = n[i](o);
    return r;
  };
}
var Yx = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, zb = new RegExp(Yx.source, "g");
function xve(e) {
  return function() {
    return e;
  };
}
function wve(e) {
  return function(t) {
    return e(t) + "";
  };
}
function _ve(e, t) {
  var n = Yx.lastIndex = zb.lastIndex = 0, r, i, o, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = Yx.exec(e)) && (i = zb.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, l.push({ i: a, x: fm(r, i) })), n = zb.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? l[0] ? wve(l[0].x) : xve(t) : (t = l.length, function(c) {
    for (var f = 0, d; f < t; ++f) s[(d = l[f]).i] = d.x(c);
    return s.join("");
  });
}
function Xc(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? oS(t) : (n === "number" ? fm : n === "string" ? (r = Rf(t)) ? (t = r, hM) : _ve : t instanceof Rf ? hM : t instanceof Date ? vve : gve(t) ? mve : Array.isArray(t) ? yve : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? bve : fm)(e, t);
}
function aS(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function Sve(e, t) {
  t === void 0 && (t = e, e = Xc);
  for (var n = 0, r = t.length - 1, i = t[0], o = new Array(r < 0 ? 0 : r); n < r; ) o[n] = e(i, i = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return o[s](a - s);
  };
}
function Ove(e) {
  return function() {
    return e;
  };
}
function dm(e) {
  return +e;
}
var pM = [0, 1];
function hr(e) {
  return e;
}
function qx(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Ove(isNaN(t) ? NaN : 0.5);
}
function Ave(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function Tve(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = qx(i, r), o = n(a, o)) : (r = qx(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function Pve(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = qx(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = Ed(e, s, 1, r) - 1;
    return o[l](i[l](s));
  };
}
function Md(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function oy() {
  var e = pM, t = pM, n = Xc, r, i, o, a = hr, s, l, c;
  function f() {
    var p = Math.min(e.length, t.length);
    return a !== hr && (a = Ave(e[0], e[p - 1])), s = p > 2 ? Pve : Tve, l = c = null, d;
  }
  function d(p) {
    return p == null || isNaN(p = +p) ? o : (l || (l = s(e.map(r), t, n)))(r(a(p)));
  }
  return d.invert = function(p) {
    return a(i((c || (c = s(t, e.map(r), fm)))(p)));
  }, d.domain = function(p) {
    return arguments.length ? (e = Array.from(p, dm), f()) : e.slice();
  }, d.range = function(p) {
    return arguments.length ? (t = Array.from(p), f()) : t.slice();
  }, d.rangeRound = function(p) {
    return t = Array.from(p), n = aS, f();
  }, d.clamp = function(p) {
    return arguments.length ? (a = p ? !0 : hr, f()) : a !== hr;
  }, d.interpolate = function(p) {
    return arguments.length ? (n = p, f()) : n;
  }, d.unknown = function(p) {
    return arguments.length ? (o = p, d) : o;
  }, function(p, m) {
    return r = p, i = m, f();
  };
}
function sS() {
  return oy()(hr, hr);
}
function Cve(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function hm(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function cc(e) {
  return e = hm(Math.abs(e)), e ? e[1] : NaN;
}
function Eve(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), o.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function kve(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var Mve = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function jf(e) {
  if (!(t = Mve.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new lS({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
jf.prototype = lS.prototype;
function lS(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
lS.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function Nve(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var XB;
function $ve(e, t) {
  var n = hm(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], o = i - (XB = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + hm(e, Math.max(0, t + o - 1))[0];
}
function mM(e, t) {
  var n = hm(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const gM = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: Cve,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => mM(e * 100, t),
  r: mM,
  s: $ve,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function yM(e) {
  return e;
}
var vM = Array.prototype.map, bM = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Dve(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? yM : Eve(vM.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? yM : kve(vM.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(d) {
    d = jf(d);
    var p = d.fill, m = d.align, y = d.sign, g = d.symbol, v = d.zero, x = d.width, w = d.comma, S = d.precision, A = d.trim, _ = d.type;
    _ === "n" ? (w = !0, _ = "g") : gM[_] || (S === void 0 && (S = 12), A = !0, _ = "g"), (v || p === "0" && m === "=") && (v = !0, p = "0", m = "=");
    var O = g === "$" ? n : g === "#" && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "", P = g === "$" ? r : /[%p]/.test(_) ? a : "", C = gM[_], k = /[defgprs%]/.test(_);
    S = S === void 0 ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function D($) {
      var N = O, R = P, L, F, W;
      if (_ === "c")
        R = C($) + R, $ = "";
      else {
        $ = +$;
        var z = $ < 0 || 1 / $ < 0;
        if ($ = isNaN($) ? l : C(Math.abs($), S), A && ($ = Nve($)), z && +$ == 0 && y !== "+" && (z = !1), N = (z ? y === "(" ? y : s : y === "-" || y === "(" ? "" : y) + N, R = (_ === "s" ? bM[8 + XB / 3] : "") + R + (z && y === "(" ? ")" : ""), k) {
          for (L = -1, F = $.length; ++L < F; )
            if (W = $.charCodeAt(L), 48 > W || W > 57) {
              R = (W === 46 ? i + $.slice(L + 1) : $.slice(L)) + R, $ = $.slice(0, L);
              break;
            }
        }
      }
      w && !v && ($ = t($, 1 / 0));
      var G = N.length + $.length + R.length, U = G < x ? new Array(x - G + 1).join(p) : "";
      switch (w && v && ($ = t(U + $, U.length ? x - R.length : 1 / 0), U = ""), m) {
        case "<":
          $ = N + $ + R + U;
          break;
        case "=":
          $ = N + U + $ + R;
          break;
        case "^":
          $ = U.slice(0, G = U.length >> 1) + N + $ + R + U.slice(G);
          break;
        default:
          $ = U + N + $ + R;
          break;
      }
      return o($);
    }
    return D.toString = function() {
      return d + "";
    }, D;
  }
  function f(d, p) {
    var m = c((d = jf(d), d.type = "f", d)), y = Math.max(-8, Math.min(8, Math.floor(cc(p) / 3))) * 3, g = Math.pow(10, -y), v = bM[8 + y / 3];
    return function(x) {
      return m(g * x) + v;
    };
  }
  return {
    format: c,
    formatPrefix: f
  };
}
var qh, cS, ZB;
Ive({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Ive(e) {
  return qh = Dve(e), cS = qh.format, ZB = qh.formatPrefix, qh;
}
function Rve(e) {
  return Math.max(0, -cc(Math.abs(e)));
}
function jve(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(cc(t) / 3))) * 3 - cc(Math.abs(e)));
}
function Lve(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, cc(t) - cc(e)) + 1;
}
function JB(e, t, n, r) {
  var i = Hx(e, t, n), o;
  switch (r = jf(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = jve(i, a)) && (r.precision = o), ZB(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = Lve(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = Rve(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return cS(r);
}
function Ka(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Vx(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return JB(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], l, c, f = 10;
    for (s < a && (c = a, a = s, s = c, c = i, i = o, o = c); f-- > 0; ) {
      if (c = Ux(a, s, n), c === l)
        return r[i] = a, r[o] = s, t(r);
      if (c > 0)
        a = Math.floor(a / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        a = Math.ceil(a * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function pm() {
  var e = sS();
  return e.copy = function() {
    return Md(e, pm());
  }, mi.apply(e, arguments), Ka(e);
}
function QB(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, dm), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return QB(e).unknown(t);
  }, e = arguments.length ? Array.from(e, dm) : [0, 1], Ka(n);
}
function eF(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], o = e[r], a;
  return o < i && (a = n, n = r, r = a, a = i, i = o, o = a), e[n] = t.floor(i), e[r] = t.ceil(o), e;
}
function xM(e) {
  return Math.log(e);
}
function wM(e) {
  return Math.exp(e);
}
function Bve(e) {
  return -Math.log(-e);
}
function Fve(e) {
  return -Math.exp(-e);
}
function Wve(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function zve(e) {
  return e === 10 ? Wve : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function Vve(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function _M(e) {
  return (t, n) => -e(-t, n);
}
function uS(e) {
  const t = e(xM, wM), n = t.domain;
  let r = 10, i, o;
  function a() {
    return i = Vve(r), o = zve(r), n()[0] < 0 ? (i = _M(i), o = _M(o), e(Bve, Fve)) : e(xM, wM), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let c = l[0], f = l[l.length - 1];
    const d = f < c;
    d && ([c, f] = [f, c]);
    let p = i(c), m = i(f), y, g;
    const v = s == null ? 10 : +s;
    let x = [];
    if (!(r % 1) && m - p < v) {
      if (p = Math.floor(p), m = Math.ceil(m), c > 0) {
        for (; p <= m; ++p)
          for (y = 1; y < r; ++y)
            if (g = p < 0 ? y / o(-p) : y * o(p), !(g < c)) {
              if (g > f) break;
              x.push(g);
            }
      } else for (; p <= m; ++p)
        for (y = r - 1; y >= 1; --y)
          if (g = p > 0 ? y / o(-p) : y * o(p), !(g < c)) {
            if (g > f) break;
            x.push(g);
          }
      x.length * 2 < v && (x = Vx(c, f, v));
    } else
      x = Vx(p, m, Math.min(m - p, v)).map(o);
    return d ? x.reverse() : x;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = jf(l)).precision == null && (l.trim = !0), l = cS(l)), s === 1 / 0) return l;
    const c = Math.max(1, r * s / t.ticks().length);
    return (f) => {
      let d = f / o(Math.round(i(f)));
      return d * r < r - 0.5 && (d *= r), d <= c ? l(f) : "";
    };
  }, t.nice = () => n(eF(n(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), t;
}
function tF() {
  const e = uS(oy()).domain([1, 10]);
  return e.copy = () => Md(e, tF()).base(e.base()), mi.apply(e, arguments), e;
}
function SM(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function OM(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function fS(e) {
  var t = 1, n = e(SM(t), OM(t));
  return n.constant = function(r) {
    return arguments.length ? e(SM(t = +r), OM(t)) : t;
  }, Ka(n);
}
function nF() {
  var e = fS(oy());
  return e.copy = function() {
    return Md(e, nF()).constant(e.constant());
  }, mi.apply(e, arguments);
}
function AM(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function Uve(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function Hve(e) {
  return e < 0 ? -e * e : e * e;
}
function dS(e) {
  var t = e(hr, hr), n = 1;
  function r() {
    return n === 1 ? e(hr, hr) : n === 0.5 ? e(Uve, Hve) : e(AM(n), AM(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, Ka(t);
}
function hS() {
  var e = dS(oy());
  return e.copy = function() {
    return Md(e, hS()).exponent(e.exponent());
  }, mi.apply(e, arguments), e;
}
function Kve() {
  return hS.apply(null, arguments).exponent(0.5);
}
function TM(e) {
  return Math.sign(e) * e * e;
}
function Gve(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function rF() {
  var e = sS(), t = [0, 1], n = !1, r;
  function i(o) {
    var a = Gve(e(o));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return i.invert = function(o) {
    return e.invert(TM(o));
  }, i.domain = function(o) {
    return arguments.length ? (e.domain(o), i) : e.domain();
  }, i.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, dm)).map(TM)), i) : t.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (n = !!o, i) : n;
  }, i.clamp = function(o) {
    return arguments.length ? (e.clamp(o), i) : e.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return rF(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, mi.apply(i, arguments), Ka(i);
}
function iF() {
  var e = [], t = [], n = [], r;
  function i() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; ) n[a - 1] = Jye(e, a / s);
    return o;
  }
  function o(a) {
    return a == null || isNaN(a = +a) ? r : t[Ed(n, a)];
  }
  return o.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, o.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of a) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(Ma), i();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), i()) : t.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return iF().domain(e).range(t).unknown(r);
  }, mi.apply(o, arguments);
}
function oF() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], o;
  function a(l) {
    return l != null && l <= l ? i[Ed(r, l, 0, n)] : o;
  }
  function s() {
    var l = -1;
    for (r = new Array(n); ++l < n; ) r[l] = ((l + 1) * t - (l - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(l) {
    return arguments.length ? (n = (i = Array.from(l)).length - 1, s()) : i.slice();
  }, a.invertExtent = function(l) {
    var c = i.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, r[0]] : c >= n ? [r[n - 1], t] : [r[c - 1], r[c]];
  }, a.unknown = function(l) {
    return arguments.length && (o = l), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return oF().domain([e, t]).range(i).unknown(o);
  }, mi.apply(Ka(a), arguments);
}
function aF() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? t[Ed(e, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(o) {
    var a = t.indexOf(o);
    return [e[a - 1], e[a]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return aF().domain(e).range(t).unknown(n);
  }, mi.apply(i, arguments);
}
const Vb = /* @__PURE__ */ new Date(), Ub = /* @__PURE__ */ new Date();
function Pn(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const l = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (c < o && o < a);
    return l;
  }, i.filter = (o) => Pn((a) => {
    if (a >= a) for (; e(a), !o(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !o(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !o(a); )
          ;
  }), n && (i.count = (o, a) => (Vb.setTime(+o), Ub.setTime(+a), e(Vb), e(Ub), Math.floor(n(Vb, Ub))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const mm = Pn(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
mm.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Pn((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : mm);
mm.range;
const Co = 1e3, fi = Co * 60, Eo = fi * 60, Uo = Eo * 24, pS = Uo * 7, PM = Uo * 30, Hb = Uo * 365, Ss = Pn((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Co);
}, (e, t) => (t - e) / Co, (e) => e.getUTCSeconds());
Ss.range;
const mS = Pn((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Co);
}, (e, t) => {
  e.setTime(+e + t * fi);
}, (e, t) => (t - e) / fi, (e) => e.getMinutes());
mS.range;
const gS = Pn((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * fi);
}, (e, t) => (t - e) / fi, (e) => e.getUTCMinutes());
gS.range;
const yS = Pn((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Co - e.getMinutes() * fi);
}, (e, t) => {
  e.setTime(+e + t * Eo);
}, (e, t) => (t - e) / Eo, (e) => e.getHours());
yS.range;
const vS = Pn((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Eo);
}, (e, t) => (t - e) / Eo, (e) => e.getUTCHours());
vS.range;
const Nd = Pn(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * fi) / Uo,
  (e) => e.getDate() - 1
);
Nd.range;
const ay = Pn((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Uo, (e) => e.getUTCDate() - 1);
ay.range;
const sF = Pn((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Uo, (e) => Math.floor(e / Uo));
sF.range;
function el(e) {
  return Pn((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * fi) / pS);
}
const sy = el(0), gm = el(1), Yve = el(2), qve = el(3), uc = el(4), Xve = el(5), Zve = el(6);
sy.range;
gm.range;
Yve.range;
qve.range;
uc.range;
Xve.range;
Zve.range;
function tl(e) {
  return Pn((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / pS);
}
const ly = tl(0), ym = tl(1), Jve = tl(2), Qve = tl(3), fc = tl(4), ebe = tl(5), tbe = tl(6);
ly.range;
ym.range;
Jve.range;
Qve.range;
fc.range;
ebe.range;
tbe.range;
const bS = Pn((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
bS.range;
const xS = Pn((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
xS.range;
const Ho = Pn((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Ho.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Pn((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Ho.range;
const Ko = Pn((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Ko.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Pn((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
Ko.range;
function lF(e, t, n, r, i, o) {
  const a = [
    [Ss, 1, Co],
    [Ss, 5, 5 * Co],
    [Ss, 15, 15 * Co],
    [Ss, 30, 30 * Co],
    [o, 1, fi],
    [o, 5, 5 * fi],
    [o, 15, 15 * fi],
    [o, 30, 30 * fi],
    [i, 1, Eo],
    [i, 3, 3 * Eo],
    [i, 6, 6 * Eo],
    [i, 12, 12 * Eo],
    [r, 1, Uo],
    [r, 2, 2 * Uo],
    [n, 1, pS],
    [t, 1, PM],
    [t, 3, 3 * PM],
    [e, 1, Hb]
  ];
  function s(c, f, d) {
    const p = f < c;
    p && ([c, f] = [f, c]);
    const m = d && typeof d.range == "function" ? d : l(c, f, d), y = m ? m.range(c, +f + 1) : [];
    return p ? y.reverse() : y;
  }
  function l(c, f, d) {
    const p = Math.abs(f - c) / d, m = nS(([, , v]) => v).right(a, p);
    if (m === a.length) return e.every(Hx(c / Hb, f / Hb, d));
    if (m === 0) return mm.every(Math.max(Hx(c, f, d), 1));
    const [y, g] = a[p / a[m - 1][2] < a[m][2] / p ? m - 1 : m];
    return y.every(g);
  }
  return [s, l];
}
const [nbe, rbe] = lF(Ko, xS, ly, sF, vS, gS), [ibe, obe] = lF(Ho, bS, sy, Nd, yS, mS);
function Kb(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Gb(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Eu(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function abe(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, o = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, c = ku(i), f = Mu(i), d = ku(o), p = Mu(o), m = ku(a), y = Mu(a), g = ku(s), v = Mu(s), x = ku(l), w = Mu(l), S = {
    a: z,
    A: G,
    b: U,
    B: V,
    c: null,
    d: $M,
    e: $M,
    f: Ebe,
    g: Bbe,
    G: Wbe,
    H: Tbe,
    I: Pbe,
    j: Cbe,
    L: cF,
    m: kbe,
    M: Mbe,
    p: Y,
    q: ee,
    Q: RM,
    s: jM,
    S: Nbe,
    u: $be,
    U: Dbe,
    V: Ibe,
    w: Rbe,
    W: jbe,
    x: null,
    X: null,
    y: Lbe,
    Y: Fbe,
    Z: zbe,
    "%": IM
  }, A = {
    a: ie,
    A: re,
    b: le,
    B: ae,
    c: null,
    d: DM,
    e: DM,
    f: Kbe,
    g: n0e,
    G: i0e,
    H: Vbe,
    I: Ube,
    j: Hbe,
    L: fF,
    m: Gbe,
    M: Ybe,
    p: ue,
    q: ne,
    Q: RM,
    s: jM,
    S: qbe,
    u: Xbe,
    U: Zbe,
    V: Jbe,
    w: Qbe,
    W: e0e,
    x: null,
    X: null,
    y: t0e,
    Y: r0e,
    Z: o0e,
    "%": IM
  }, _ = {
    a: D,
    A: $,
    b: N,
    B: R,
    c: L,
    d: MM,
    e: MM,
    f: _be,
    g: kM,
    G: EM,
    H: NM,
    I: NM,
    j: vbe,
    L: wbe,
    m: ybe,
    M: bbe,
    p: k,
    q: gbe,
    Q: Obe,
    s: Abe,
    S: xbe,
    u: fbe,
    U: dbe,
    V: hbe,
    w: ube,
    W: pbe,
    x: F,
    X: W,
    y: kM,
    Y: EM,
    Z: mbe,
    "%": Sbe
  };
  S.x = O(n, S), S.X = O(r, S), S.c = O(t, S), A.x = O(n, A), A.X = O(r, A), A.c = O(t, A);
  function O(J, fe) {
    return function(be) {
      var X = [], De = -1, pe = 0, ke = J.length, it, st, Xn;
      for (be instanceof Date || (be = /* @__PURE__ */ new Date(+be)); ++De < ke; )
        J.charCodeAt(De) === 37 && (X.push(J.slice(pe, De)), (st = CM[it = J.charAt(++De)]) != null ? it = J.charAt(++De) : st = it === "e" ? " " : "0", (Xn = fe[it]) && (it = Xn(be, st)), X.push(it), pe = De + 1);
      return X.push(J.slice(pe, De)), X.join("");
    };
  }
  function P(J, fe) {
    return function(be) {
      var X = Eu(1900, void 0, 1), De = C(X, J, be += "", 0), pe, ke;
      if (De != be.length) return null;
      if ("Q" in X) return new Date(X.Q);
      if ("s" in X) return new Date(X.s * 1e3 + ("L" in X ? X.L : 0));
      if (fe && !("Z" in X) && (X.Z = 0), "p" in X && (X.H = X.H % 12 + X.p * 12), X.m === void 0 && (X.m = "q" in X ? X.q : 0), "V" in X) {
        if (X.V < 1 || X.V > 53) return null;
        "w" in X || (X.w = 1), "Z" in X ? (pe = Gb(Eu(X.y, 0, 1)), ke = pe.getUTCDay(), pe = ke > 4 || ke === 0 ? ym.ceil(pe) : ym(pe), pe = ay.offset(pe, (X.V - 1) * 7), X.y = pe.getUTCFullYear(), X.m = pe.getUTCMonth(), X.d = pe.getUTCDate() + (X.w + 6) % 7) : (pe = Kb(Eu(X.y, 0, 1)), ke = pe.getDay(), pe = ke > 4 || ke === 0 ? gm.ceil(pe) : gm(pe), pe = Nd.offset(pe, (X.V - 1) * 7), X.y = pe.getFullYear(), X.m = pe.getMonth(), X.d = pe.getDate() + (X.w + 6) % 7);
      } else ("W" in X || "U" in X) && ("w" in X || (X.w = "u" in X ? X.u % 7 : "W" in X ? 1 : 0), ke = "Z" in X ? Gb(Eu(X.y, 0, 1)).getUTCDay() : Kb(Eu(X.y, 0, 1)).getDay(), X.m = 0, X.d = "W" in X ? (X.w + 6) % 7 + X.W * 7 - (ke + 5) % 7 : X.w + X.U * 7 - (ke + 6) % 7);
      return "Z" in X ? (X.H += X.Z / 100 | 0, X.M += X.Z % 100, Gb(X)) : Kb(X);
    };
  }
  function C(J, fe, be, X) {
    for (var De = 0, pe = fe.length, ke = be.length, it, st; De < pe; ) {
      if (X >= ke) return -1;
      if (it = fe.charCodeAt(De++), it === 37) {
        if (it = fe.charAt(De++), st = _[it in CM ? fe.charAt(De++) : it], !st || (X = st(J, be, X)) < 0) return -1;
      } else if (it != be.charCodeAt(X++))
        return -1;
    }
    return X;
  }
  function k(J, fe, be) {
    var X = c.exec(fe.slice(be));
    return X ? (J.p = f.get(X[0].toLowerCase()), be + X[0].length) : -1;
  }
  function D(J, fe, be) {
    var X = m.exec(fe.slice(be));
    return X ? (J.w = y.get(X[0].toLowerCase()), be + X[0].length) : -1;
  }
  function $(J, fe, be) {
    var X = d.exec(fe.slice(be));
    return X ? (J.w = p.get(X[0].toLowerCase()), be + X[0].length) : -1;
  }
  function N(J, fe, be) {
    var X = x.exec(fe.slice(be));
    return X ? (J.m = w.get(X[0].toLowerCase()), be + X[0].length) : -1;
  }
  function R(J, fe, be) {
    var X = g.exec(fe.slice(be));
    return X ? (J.m = v.get(X[0].toLowerCase()), be + X[0].length) : -1;
  }
  function L(J, fe, be) {
    return C(J, t, fe, be);
  }
  function F(J, fe, be) {
    return C(J, n, fe, be);
  }
  function W(J, fe, be) {
    return C(J, r, fe, be);
  }
  function z(J) {
    return a[J.getDay()];
  }
  function G(J) {
    return o[J.getDay()];
  }
  function U(J) {
    return l[J.getMonth()];
  }
  function V(J) {
    return s[J.getMonth()];
  }
  function Y(J) {
    return i[+(J.getHours() >= 12)];
  }
  function ee(J) {
    return 1 + ~~(J.getMonth() / 3);
  }
  function ie(J) {
    return a[J.getUTCDay()];
  }
  function re(J) {
    return o[J.getUTCDay()];
  }
  function le(J) {
    return l[J.getUTCMonth()];
  }
  function ae(J) {
    return s[J.getUTCMonth()];
  }
  function ue(J) {
    return i[+(J.getUTCHours() >= 12)];
  }
  function ne(J) {
    return 1 + ~~(J.getUTCMonth() / 3);
  }
  return {
    format: function(J) {
      var fe = O(J += "", S);
      return fe.toString = function() {
        return J;
      }, fe;
    },
    parse: function(J) {
      var fe = P(J += "", !1);
      return fe.toString = function() {
        return J;
      }, fe;
    },
    utcFormat: function(J) {
      var fe = O(J += "", A);
      return fe.toString = function() {
        return J;
      }, fe;
    },
    utcParse: function(J) {
      var fe = P(J += "", !0);
      return fe.toString = function() {
        return J;
      }, fe;
    }
  };
}
var CM = { "-": "", _: " ", 0: "0" }, Rn = /^\s*\d+/, sbe = /^%/, lbe = /[\\^$*+?|[\]().{}]/g;
function pt(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}
function cbe(e) {
  return e.replace(lbe, "\\$&");
}
function ku(e) {
  return new RegExp("^(?:" + e.map(cbe).join("|") + ")", "i");
}
function Mu(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function ube(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function fbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function dbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function hbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function pbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function EM(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function kM(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function mbe(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function gbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function ybe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function MM(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function vbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function NM(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function bbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function xbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function wbe(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function _be(e, t, n) {
  var r = Rn.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Sbe(e, t, n) {
  var r = sbe.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function Obe(e, t, n) {
  var r = Rn.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function Abe(e, t, n) {
  var r = Rn.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function $M(e, t) {
  return pt(e.getDate(), t, 2);
}
function Tbe(e, t) {
  return pt(e.getHours(), t, 2);
}
function Pbe(e, t) {
  return pt(e.getHours() % 12 || 12, t, 2);
}
function Cbe(e, t) {
  return pt(1 + Nd.count(Ho(e), e), t, 3);
}
function cF(e, t) {
  return pt(e.getMilliseconds(), t, 3);
}
function Ebe(e, t) {
  return cF(e, t) + "000";
}
function kbe(e, t) {
  return pt(e.getMonth() + 1, t, 2);
}
function Mbe(e, t) {
  return pt(e.getMinutes(), t, 2);
}
function Nbe(e, t) {
  return pt(e.getSeconds(), t, 2);
}
function $be(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function Dbe(e, t) {
  return pt(sy.count(Ho(e) - 1, e), t, 2);
}
function uF(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? uc(e) : uc.ceil(e);
}
function Ibe(e, t) {
  return e = uF(e), pt(uc.count(Ho(e), e) + (Ho(e).getDay() === 4), t, 2);
}
function Rbe(e) {
  return e.getDay();
}
function jbe(e, t) {
  return pt(gm.count(Ho(e) - 1, e), t, 2);
}
function Lbe(e, t) {
  return pt(e.getFullYear() % 100, t, 2);
}
function Bbe(e, t) {
  return e = uF(e), pt(e.getFullYear() % 100, t, 2);
}
function Fbe(e, t) {
  return pt(e.getFullYear() % 1e4, t, 4);
}
function Wbe(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? uc(e) : uc.ceil(e), pt(e.getFullYear() % 1e4, t, 4);
}
function zbe(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + pt(t / 60 | 0, "0", 2) + pt(t % 60, "0", 2);
}
function DM(e, t) {
  return pt(e.getUTCDate(), t, 2);
}
function Vbe(e, t) {
  return pt(e.getUTCHours(), t, 2);
}
function Ube(e, t) {
  return pt(e.getUTCHours() % 12 || 12, t, 2);
}
function Hbe(e, t) {
  return pt(1 + ay.count(Ko(e), e), t, 3);
}
function fF(e, t) {
  return pt(e.getUTCMilliseconds(), t, 3);
}
function Kbe(e, t) {
  return fF(e, t) + "000";
}
function Gbe(e, t) {
  return pt(e.getUTCMonth() + 1, t, 2);
}
function Ybe(e, t) {
  return pt(e.getUTCMinutes(), t, 2);
}
function qbe(e, t) {
  return pt(e.getUTCSeconds(), t, 2);
}
function Xbe(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function Zbe(e, t) {
  return pt(ly.count(Ko(e) - 1, e), t, 2);
}
function dF(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? fc(e) : fc.ceil(e);
}
function Jbe(e, t) {
  return e = dF(e), pt(fc.count(Ko(e), e) + (Ko(e).getUTCDay() === 4), t, 2);
}
function Qbe(e) {
  return e.getUTCDay();
}
function e0e(e, t) {
  return pt(ym.count(Ko(e) - 1, e), t, 2);
}
function t0e(e, t) {
  return pt(e.getUTCFullYear() % 100, t, 2);
}
function n0e(e, t) {
  return e = dF(e), pt(e.getUTCFullYear() % 100, t, 2);
}
function r0e(e, t) {
  return pt(e.getUTCFullYear() % 1e4, t, 4);
}
function i0e(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? fc(e) : fc.ceil(e), pt(e.getUTCFullYear() % 1e4, t, 4);
}
function o0e() {
  return "+0000";
}
function IM() {
  return "%";
}
function RM(e) {
  return +e;
}
function jM(e) {
  return Math.floor(+e / 1e3);
}
var _l, hF, pF;
a0e({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function a0e(e) {
  return _l = abe(e), hF = _l.format, _l.parse, pF = _l.utcFormat, _l.utcParse, _l;
}
function s0e(e) {
  return new Date(e);
}
function l0e(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function wS(e, t, n, r, i, o, a, s, l, c) {
  var f = sS(), d = f.invert, p = f.domain, m = c(".%L"), y = c(":%S"), g = c("%I:%M"), v = c("%I %p"), x = c("%a %d"), w = c("%b %d"), S = c("%B"), A = c("%Y");
  function _(O) {
    return (l(O) < O ? m : s(O) < O ? y : a(O) < O ? g : o(O) < O ? v : r(O) < O ? i(O) < O ? x : w : n(O) < O ? S : A)(O);
  }
  return f.invert = function(O) {
    return new Date(d(O));
  }, f.domain = function(O) {
    return arguments.length ? p(Array.from(O, l0e)) : p().map(s0e);
  }, f.ticks = function(O) {
    var P = p();
    return e(P[0], P[P.length - 1], O ?? 10);
  }, f.tickFormat = function(O, P) {
    return P == null ? _ : c(P);
  }, f.nice = function(O) {
    var P = p();
    return (!O || typeof O.range != "function") && (O = t(P[0], P[P.length - 1], O ?? 10)), O ? p(eF(P, O)) : f;
  }, f.copy = function() {
    return Md(f, wS(e, t, n, r, i, o, a, s, l, c));
  }, f;
}
function c0e() {
  return mi.apply(wS(ibe, obe, Ho, bS, sy, Nd, yS, mS, Ss, hF).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function u0e() {
  return mi.apply(wS(nbe, rbe, Ko, xS, ly, ay, vS, gS, Ss, pF).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function cy() {
  var e = 0, t = 1, n, r, i, o, a = hr, s = !1, l;
  function c(d) {
    return d == null || isNaN(d = +d) ? l : a(i === 0 ? 0.5 : (d = (o(d) - n) * i, s ? Math.max(0, Math.min(1, d)) : d));
  }
  c.domain = function(d) {
    return arguments.length ? ([e, t] = d, n = o(e = +e), r = o(t = +t), i = n === r ? 0 : 1 / (r - n), c) : [e, t];
  }, c.clamp = function(d) {
    return arguments.length ? (s = !!d, c) : s;
  }, c.interpolator = function(d) {
    return arguments.length ? (a = d, c) : a;
  };
  function f(d) {
    return function(p) {
      var m, y;
      return arguments.length ? ([m, y] = p, a = d(m, y), c) : [a(0), a(1)];
    };
  }
  return c.range = f(Xc), c.rangeRound = f(aS), c.unknown = function(d) {
    return arguments.length ? (l = d, c) : l;
  }, function(d) {
    return o = d, n = d(e), r = d(t), i = n === r ? 0 : 1 / (r - n), c;
  };
}
function Ga(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function mF() {
  var e = Ka(cy()(hr));
  return e.copy = function() {
    return Ga(e, mF());
  }, ta.apply(e, arguments);
}
function gF() {
  var e = uS(cy()).domain([1, 10]);
  return e.copy = function() {
    return Ga(e, gF()).base(e.base());
  }, ta.apply(e, arguments);
}
function yF() {
  var e = fS(cy());
  return e.copy = function() {
    return Ga(e, yF()).constant(e.constant());
  }, ta.apply(e, arguments);
}
function _S() {
  var e = dS(cy());
  return e.copy = function() {
    return Ga(e, _S()).exponent(e.exponent());
  }, ta.apply(e, arguments);
}
function f0e() {
  return _S.apply(null, arguments).exponent(0.5);
}
function vF() {
  var e = [], t = hr;
  function n(r) {
    if (r != null && !isNaN(r = +r)) return t((Ed(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of r) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(Ma), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => Zye(e, o / r));
  }, n.copy = function() {
    return vF(t).domain(e);
  }, ta.apply(n, arguments);
}
function uy() {
  var e = 0, t = 0.5, n = 1, r = 1, i, o, a, s, l, c = hr, f, d = !1, p;
  function m(g) {
    return isNaN(g = +g) ? p : (g = 0.5 + ((g = +f(g)) - o) * (r * g < r * o ? s : l), c(d ? Math.max(0, Math.min(1, g)) : g));
  }
  m.domain = function(g) {
    return arguments.length ? ([e, t, n] = g, i = f(e = +e), o = f(t = +t), a = f(n = +n), s = i === o ? 0 : 0.5 / (o - i), l = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, m) : [e, t, n];
  }, m.clamp = function(g) {
    return arguments.length ? (d = !!g, m) : d;
  }, m.interpolator = function(g) {
    return arguments.length ? (c = g, m) : c;
  };
  function y(g) {
    return function(v) {
      var x, w, S;
      return arguments.length ? ([x, w, S] = v, c = Sve(g, [x, w, S]), m) : [c(0), c(0.5), c(1)];
    };
  }
  return m.range = y(Xc), m.rangeRound = y(aS), m.unknown = function(g) {
    return arguments.length ? (p = g, m) : p;
  }, function(g) {
    return f = g, i = g(e), o = g(t), a = g(n), s = i === o ? 0 : 0.5 / (o - i), l = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, m;
  };
}
function bF() {
  var e = Ka(uy()(hr));
  return e.copy = function() {
    return Ga(e, bF());
  }, ta.apply(e, arguments);
}
function xF() {
  var e = uS(uy()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return Ga(e, xF()).base(e.base());
  }, ta.apply(e, arguments);
}
function wF() {
  var e = fS(uy());
  return e.copy = function() {
    return Ga(e, wF()).constant(e.constant());
  }, ta.apply(e, arguments);
}
function SS() {
  var e = dS(uy());
  return e.copy = function() {
    return Ga(e, SS()).exponent(e.exponent());
  }, ta.apply(e, arguments);
}
function d0e() {
  return SS.apply(null, arguments).exponent(0.5);
}
const LM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: $f,
  scaleDiverging: bF,
  scaleDivergingLog: xF,
  scaleDivergingPow: SS,
  scaleDivergingSqrt: d0e,
  scaleDivergingSymlog: wF,
  scaleIdentity: QB,
  scaleImplicit: Kx,
  scaleLinear: pm,
  scaleLog: tF,
  scaleOrdinal: rS,
  scalePoint: tf,
  scalePow: hS,
  scaleQuantile: iF,
  scaleQuantize: oF,
  scaleRadial: rF,
  scaleSequential: mF,
  scaleSequentialLog: gF,
  scaleSequentialPow: _S,
  scaleSequentialQuantile: vF,
  scaleSequentialSqrt: f0e,
  scaleSequentialSymlog: yF,
  scaleSqrt: Kve,
  scaleSymlog: nF,
  scaleThreshold: aF,
  scaleTime: c0e,
  scaleUtc: u0e,
  tickFormat: JB
}, Symbol.toStringTag, { value: "Module" }));
var h0e = Wc;
function p0e(e, t, n) {
  for (var r = -1, i = e.length; ++r < i; ) {
    var o = e[r], a = t(o);
    if (a != null && (s === void 0 ? a === a && !h0e(a) : n(a, s)))
      var s = a, l = o;
  }
  return l;
}
var fy = p0e;
function m0e(e, t) {
  return e > t;
}
var _F = m0e, g0e = fy, y0e = _F, v0e = qc;
function b0e(e) {
  return e && e.length ? g0e(e, v0e, y0e) : void 0;
}
var x0e = b0e;
const Aa = /* @__PURE__ */ kt(x0e);
function w0e(e, t) {
  return e < t;
}
var SF = w0e, _0e = fy, S0e = SF, O0e = qc;
function A0e(e) {
  return e && e.length ? _0e(e, O0e, S0e) : void 0;
}
var T0e = A0e;
const dy = /* @__PURE__ */ kt(T0e);
var P0e = j_, C0e = ao, E0e = MB, k0e = Tr;
function M0e(e, t) {
  var n = k0e(e) ? P0e : E0e;
  return n(e, C0e(t));
}
var N0e = M0e, $0e = EB, D0e = N0e;
function I0e(e, t) {
  return $0e(D0e(e, t), 1);
}
var R0e = I0e;
const j0e = /* @__PURE__ */ kt(R0e);
var L0e = X_;
function B0e(e, t) {
  return L0e(e, t);
}
var F0e = B0e;
const zs = /* @__PURE__ */ kt(F0e);
var Zc = 1e9, W0e = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, AS, Xt = !0, hi = "[DecimalError] ", Ms = hi + "Invalid argument: ", OS = hi + "Exponent out of range: ", Jc = Math.floor, ys = Math.pow, z0e = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Wr, Mn = 1e7, Vt = 7, OF = 9007199254740991, vm = Jc(OF / Vt), Pe = {};
Pe.absoluteValue = Pe.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Pe.comparedTo = Pe.cmp = function(e) {
  var t, n, r, i, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (r = o.d.length, i = e.d.length, t = 0, n = r < i ? r : i; t < n; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ o.s < 0 ? 1 : -1;
};
Pe.decimalPlaces = Pe.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * Vt;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
Pe.dividedBy = Pe.div = function(e) {
  return Lo(this, new this.constructor(e));
};
Pe.dividedToIntegerBy = Pe.idiv = function(e) {
  var t = this, n = t.constructor;
  return $t(Lo(t, new n(e), 0, 1), n.precision);
};
Pe.equals = Pe.eq = function(e) {
  return !this.cmp(e);
};
Pe.exponent = function() {
  return gn(this);
};
Pe.greaterThan = Pe.gt = function(e) {
  return this.cmp(e) > 0;
};
Pe.greaterThanOrEqualTo = Pe.gte = function(e) {
  return this.cmp(e) >= 0;
};
Pe.isInteger = Pe.isint = function() {
  return this.e > this.d.length - 2;
};
Pe.isNegative = Pe.isneg = function() {
  return this.s < 0;
};
Pe.isPositive = Pe.ispos = function() {
  return this.s > 0;
};
Pe.isZero = function() {
  return this.s === 0;
};
Pe.lessThan = Pe.lt = function(e) {
  return this.cmp(e) < 0;
};
Pe.lessThanOrEqualTo = Pe.lte = function(e) {
  return this.cmp(e) < 1;
};
Pe.logarithm = Pe.log = function(e) {
  var t, n = this, r = n.constructor, i = r.precision, o = i + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(Wr)) throw Error(hi + "NaN");
  if (n.s < 1) throw Error(hi + (n.s ? "NaN" : "-Infinity"));
  return n.eq(Wr) ? new r(0) : (Xt = !1, t = Lo(Lf(n, o), Lf(e, o), o), Xt = !0, $t(t, i));
};
Pe.minus = Pe.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? PF(t, e) : AF(t, (e.s = -e.s, e));
};
Pe.modulo = Pe.mod = function(e) {
  var t, n = this, r = n.constructor, i = r.precision;
  if (e = new r(e), !e.s) throw Error(hi + "NaN");
  return n.s ? (Xt = !1, t = Lo(n, e, 0, 1).times(e), Xt = !0, n.minus(t)) : $t(new r(n), i);
};
Pe.naturalExponential = Pe.exp = function() {
  return TF(this);
};
Pe.naturalLogarithm = Pe.ln = function() {
  return Lf(this);
};
Pe.negated = Pe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Pe.plus = Pe.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? AF(t, e) : PF(t, (e.s = -e.s, e));
};
Pe.precision = Pe.sd = function(e) {
  var t, n, r, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Ms + e);
  if (t = gn(i) + 1, r = i.d.length - 1, n = r * Vt + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = i.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
Pe.squareRoot = Pe.sqrt = function() {
  var e, t, n, r, i, o, a, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new l(0);
    throw Error(hi + "NaN");
  }
  for (e = gn(s), Xt = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Vi(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = Jc((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new l(t)) : r = new l(i.toString()), n = l.precision, i = a = n + 3; ; )
    if (o = r, r = o.plus(Lo(s, o, a + 2)).times(0.5), Vi(o.d).slice(0, a) === (t = Vi(r.d)).slice(0, a)) {
      if (t = t.slice(a - 3, a + 1), i == a && t == "4999") {
        if ($t(o, n + 1, 0), o.times(o).eq(s)) {
          r = o;
          break;
        }
      } else if (t != "9999")
        break;
      a += 4;
    }
  return Xt = !0, $t(r, n);
};
Pe.times = Pe.mul = function(e) {
  var t, n, r, i, o, a, s, l, c, f = this, d = f.constructor, p = f.d, m = (e = new d(e)).d;
  if (!f.s || !e.s) return new d(0);
  for (e.s *= f.s, n = f.e + e.e, l = p.length, c = m.length, l < c && (o = p, p = m, m = o, a = l, l = c, c = a), o = [], a = l + c, r = a; r--; ) o.push(0);
  for (r = c; --r >= 0; ) {
    for (t = 0, i = l + r; i > r; )
      s = o[i] + m[r] * p[i - r - 1] + t, o[i--] = s % Mn | 0, t = s / Mn | 0;
    o[i] = (o[i] + t) % Mn | 0;
  }
  for (; !o[--a]; ) o.pop();
  return t ? ++n : o.shift(), e.d = o, e.e = n, Xt ? $t(e, d.precision) : e;
};
Pe.toDecimalPlaces = Pe.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (no(e, 0, Zc), t === void 0 ? t = r.rounding : no(t, 0, 8), $t(n, e + gn(n) + 1, t));
};
Pe.toExponential = function(e, t) {
  var n, r = this, i = r.constructor;
  return e === void 0 ? n = Vs(r, !0) : (no(e, 0, Zc), t === void 0 ? t = i.rounding : no(t, 0, 8), r = $t(new i(r), e + 1, t), n = Vs(r, !0, e + 1)), n;
};
Pe.toFixed = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? Vs(i) : (no(e, 0, Zc), t === void 0 ? t = o.rounding : no(t, 0, 8), r = $t(new o(i), e + gn(i) + 1, t), n = Vs(r.abs(), !1, e + gn(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
Pe.toInteger = Pe.toint = function() {
  var e = this, t = e.constructor;
  return $t(new t(e), gn(e) + 1, t.rounding);
};
Pe.toNumber = function() {
  return +this;
};
Pe.toPower = Pe.pow = function(e) {
  var t, n, r, i, o, a, s = this, l = s.constructor, c = 12, f = +(e = new l(e));
  if (!e.s) return new l(Wr);
  if (s = new l(s), !s.s) {
    if (e.s < 1) throw Error(hi + "Infinity");
    return s;
  }
  if (s.eq(Wr)) return s;
  if (r = l.precision, e.eq(Wr)) return $t(s, r);
  if (t = e.e, n = e.d.length - 1, a = t >= n, o = s.s, a) {
    if ((n = f < 0 ? -f : f) <= OF) {
      for (i = new l(Wr), t = Math.ceil(r / Vt + 4), Xt = !1; n % 2 && (i = i.times(s), FM(i.d, t)), n = Jc(n / 2), n !== 0; )
        s = s.times(s), FM(s.d, t);
      return Xt = !0, e.s < 0 ? new l(Wr).div(i) : $t(i, r);
    }
  } else if (o < 0) throw Error(hi + "NaN");
  return o = o < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, Xt = !1, i = e.times(Lf(s, r + c)), Xt = !0, i = TF(i), i.s = o, i;
};
Pe.toPrecision = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? (n = gn(i), r = Vs(i, n <= o.toExpNeg || n >= o.toExpPos)) : (no(e, 1, Zc), t === void 0 ? t = o.rounding : no(t, 0, 8), i = $t(new o(i), e, t), n = gn(i), r = Vs(i, e <= n || n <= o.toExpNeg, e)), r;
};
Pe.toSignificantDigits = Pe.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (no(e, 1, Zc), t === void 0 ? t = r.rounding : no(t, 0, 8)), $t(new r(n), e, t);
};
Pe.toString = Pe.valueOf = Pe.val = Pe.toJSON = Pe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = gn(e), n = e.constructor;
  return Vs(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function AF(e, t) {
  var n, r, i, o, a, s, l, c, f = e.constructor, d = f.precision;
  if (!e.s || !t.s)
    return t.s || (t = new f(e)), Xt ? $t(t, d) : t;
  if (l = e.d, c = t.d, a = e.e, i = t.e, l = l.slice(), o = a - i, o) {
    for (o < 0 ? (r = l, o = -o, s = c.length) : (r = c, i = a, s = l.length), a = Math.ceil(d / Vt), s = a > s ? a + 1 : s + 1, o > s && (o = s, r.length = 1), r.reverse(); o--; ) r.push(0);
    r.reverse();
  }
  for (s = l.length, o = c.length, s - o < 0 && (o = s, r = c, c = l, l = r), n = 0; o; )
    n = (l[--o] = l[o] + c[o] + n) / Mn | 0, l[o] %= Mn;
  for (n && (l.unshift(n), ++i), s = l.length; l[--s] == 0; ) l.pop();
  return t.d = l, t.e = i, Xt ? $t(t, d) : t;
}
function no(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(Ms + e);
}
function Vi(e) {
  var t, n, r, i = e.length - 1, o = "", a = e[0];
  if (i > 0) {
    for (o += a, t = 1; t < i; t++)
      r = e[t] + "", n = Vt - r.length, n && (o += wa(n)), o += r;
    a = e[t], r = a + "", n = Vt - r.length, n && (o += wa(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return o + a;
}
var Lo = /* @__PURE__ */ function() {
  function e(r, i) {
    var o, a = 0, s = r.length;
    for (r = r.slice(); s--; )
      o = r[s] * i + a, r[s] = o % Mn | 0, a = o / Mn | 0;
    return a && r.unshift(a), r;
  }
  function t(r, i, o, a) {
    var s, l;
    if (o != a)
      l = o > a ? 1 : -1;
    else
      for (s = l = 0; s < o; s++)
        if (r[s] != i[s]) {
          l = r[s] > i[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function n(r, i, o) {
    for (var a = 0; o--; )
      r[o] -= a, a = r[o] < i[o] ? 1 : 0, r[o] = a * Mn + r[o] - i[o];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, o, a) {
    var s, l, c, f, d, p, m, y, g, v, x, w, S, A, _, O, P, C, k = r.constructor, D = r.s == i.s ? 1 : -1, $ = r.d, N = i.d;
    if (!r.s) return new k(r);
    if (!i.s) throw Error(hi + "Division by zero");
    for (l = r.e - i.e, P = N.length, _ = $.length, m = new k(D), y = m.d = [], c = 0; N[c] == ($[c] || 0); ) ++c;
    if (N[c] > ($[c] || 0) && --l, o == null ? w = o = k.precision : a ? w = o + (gn(r) - gn(i)) + 1 : w = o, w < 0) return new k(0);
    if (w = w / Vt + 2 | 0, c = 0, P == 1)
      for (f = 0, N = N[0], w++; (c < _ || f) && w--; c++)
        S = f * Mn + ($[c] || 0), y[c] = S / N | 0, f = S % N | 0;
    else {
      for (f = Mn / (N[0] + 1) | 0, f > 1 && (N = e(N, f), $ = e($, f), P = N.length, _ = $.length), A = P, g = $.slice(0, P), v = g.length; v < P; ) g[v++] = 0;
      C = N.slice(), C.unshift(0), O = N[0], N[1] >= Mn / 2 && ++O;
      do
        f = 0, s = t(N, g, P, v), s < 0 ? (x = g[0], P != v && (x = x * Mn + (g[1] || 0)), f = x / O | 0, f > 1 ? (f >= Mn && (f = Mn - 1), d = e(N, f), p = d.length, v = g.length, s = t(d, g, p, v), s == 1 && (f--, n(d, P < p ? C : N, p))) : (f == 0 && (s = f = 1), d = N.slice()), p = d.length, p < v && d.unshift(0), n(g, d, v), s == -1 && (v = g.length, s = t(N, g, P, v), s < 1 && (f++, n(g, P < v ? C : N, v))), v = g.length) : s === 0 && (f++, g = [0]), y[c++] = f, s && g[0] ? g[v++] = $[A] || 0 : (g = [$[A]], v = 1);
      while ((A++ < _ || g[0] !== void 0) && w--);
    }
    return y[0] || y.shift(), m.e = l, $t(m, a ? o + gn(m) + 1 : o);
  };
}();
function TF(e, t) {
  var n, r, i, o, a, s, l = 0, c = 0, f = e.constructor, d = f.precision;
  if (gn(e) > 16) throw Error(OS + gn(e));
  if (!e.s) return new f(Wr);
  for (t == null ? (Xt = !1, s = d) : s = t, a = new f(0.03125); e.abs().gte(0.1); )
    e = e.times(a), c += 5;
  for (r = Math.log(ys(2, c)) / Math.LN10 * 2 + 5 | 0, s += r, n = i = o = new f(Wr), f.precision = s; ; ) {
    if (i = $t(i.times(e), s), n = n.times(++l), a = o.plus(Lo(i, n, s)), Vi(a.d).slice(0, s) === Vi(o.d).slice(0, s)) {
      for (; c--; ) o = $t(o.times(o), s);
      return f.precision = d, t == null ? (Xt = !0, $t(o, d)) : o;
    }
    o = a;
  }
}
function gn(e) {
  for (var t = e.e * Vt, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function Yb(e, t, n) {
  if (t > e.LN10.sd())
    throw Xt = !0, n && (e.precision = n), Error(hi + "LN10 precision limit exceeded");
  return $t(new e(e.LN10), t);
}
function wa(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Lf(e, t) {
  var n, r, i, o, a, s, l, c, f, d = 1, p = 10, m = e, y = m.d, g = m.constructor, v = g.precision;
  if (m.s < 1) throw Error(hi + (m.s ? "NaN" : "-Infinity"));
  if (m.eq(Wr)) return new g(0);
  if (t == null ? (Xt = !1, c = v) : c = t, m.eq(10))
    return t == null && (Xt = !0), Yb(g, c);
  if (c += p, g.precision = c, n = Vi(y), r = n.charAt(0), o = gn(m), Math.abs(o) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      m = m.times(e), n = Vi(m.d), r = n.charAt(0), d++;
    o = gn(m), r > 1 ? (m = new g("0." + n), o++) : m = new g(r + "." + n.slice(1));
  } else
    return l = Yb(g, c + 2, v).times(o + ""), m = Lf(new g(r + "." + n.slice(1)), c - p).plus(l), g.precision = v, t == null ? (Xt = !0, $t(m, v)) : m;
  for (s = a = m = Lo(m.minus(Wr), m.plus(Wr), c), f = $t(m.times(m), c), i = 3; ; ) {
    if (a = $t(a.times(f), c), l = s.plus(Lo(a, new g(i), c)), Vi(l.d).slice(0, c) === Vi(s.d).slice(0, c))
      return s = s.times(2), o !== 0 && (s = s.plus(Yb(g, c + 2, v).times(o + ""))), s = Lo(s, new g(d), c), g.precision = v, t == null ? (Xt = !0, $t(s, v)) : s;
    s = l, i += 2;
  }
}
function BM(e, t) {
  var n, r, i;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(r, i), t) {
    if (i -= r, n = n - r - 1, e.e = Jc(n / Vt), e.d = [], r = (n + 1) % Vt, n < 0 && (r += Vt), r < i) {
      for (r && e.d.push(+t.slice(0, r)), i -= Vt; r < i; ) e.d.push(+t.slice(r, r += Vt));
      t = t.slice(r), r = Vt - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    if (e.d.push(+t), Xt && (e.e > vm || e.e < -vm)) throw Error(OS + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function $t(e, t, n) {
  var r, i, o, a, s, l, c, f, d = e.d;
  for (a = 1, o = d[0]; o >= 10; o /= 10) a++;
  if (r = t - a, r < 0)
    r += Vt, i = t, c = d[f = 0];
  else {
    if (f = Math.ceil((r + 1) / Vt), o = d.length, f >= o) return e;
    for (c = o = d[f], a = 1; o >= 10; o /= 10) a++;
    r %= Vt, i = r - Vt + a;
  }
  if (n !== void 0 && (o = ys(10, a - i - 1), s = c / o % 10 | 0, l = t < 0 || d[f + 1] !== void 0 || c % o, l = n < 4 ? (s || l) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || l || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? c / ys(10, a - i) : 0 : d[f - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !d[0])
    return l ? (o = gn(e), d.length = 1, t = t - o - 1, d[0] = ys(10, (Vt - t % Vt) % Vt), e.e = Jc(-t / Vt) || 0) : (d.length = 1, d[0] = e.e = e.s = 0), e;
  if (r == 0 ? (d.length = f, o = 1, f--) : (d.length = f + 1, o = ys(10, Vt - r), d[f] = i > 0 ? (c / ys(10, a - i) % ys(10, i) | 0) * o : 0), l)
    for (; ; )
      if (f == 0) {
        (d[0] += o) == Mn && (d[0] = 1, ++e.e);
        break;
      } else {
        if (d[f] += o, d[f] != Mn) break;
        d[f--] = 0, o = 1;
      }
  for (r = d.length; d[--r] === 0; ) d.pop();
  if (Xt && (e.e > vm || e.e < -vm))
    throw Error(OS + gn(e));
  return e;
}
function PF(e, t) {
  var n, r, i, o, a, s, l, c, f, d, p = e.constructor, m = p.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new p(e), Xt ? $t(t, m) : t;
  if (l = e.d, d = t.d, r = t.e, c = e.e, l = l.slice(), a = c - r, a) {
    for (f = a < 0, f ? (n = l, a = -a, s = d.length) : (n = d, r = c, s = l.length), i = Math.max(Math.ceil(m / Vt), s) + 2, a > i && (a = i, n.length = 1), n.reverse(), i = a; i--; ) n.push(0);
    n.reverse();
  } else {
    for (i = l.length, s = d.length, f = i < s, f && (s = i), i = 0; i < s; i++)
      if (l[i] != d[i]) {
        f = l[i] < d[i];
        break;
      }
    a = 0;
  }
  for (f && (n = l, l = d, d = n, t.s = -t.s), s = l.length, i = d.length - s; i > 0; --i) l[s++] = 0;
  for (i = d.length; i > a; ) {
    if (l[--i] < d[i]) {
      for (o = i; o && l[--o] === 0; ) l[o] = Mn - 1;
      --l[o], l[i] += Mn;
    }
    l[i] -= d[i];
  }
  for (; l[--s] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (t.d = l, t.e = r, Xt ? $t(t, m) : t) : new p(0);
}
function Vs(e, t, n) {
  var r, i = gn(e), o = Vi(e.d), a = o.length;
  return t ? (n && (r = n - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + wa(r) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + wa(-i - 1) + o, n && (r = n - a) > 0 && (o += wa(r))) : i >= a ? (o += wa(i + 1 - a), n && (r = n - i - 1) > 0 && (o = o + "." + wa(r))) : ((r = i + 1) < a && (o = o.slice(0, r) + "." + o.slice(r)), n && (r = n - a) > 0 && (i + 1 === a && (o += "."), o += wa(r))), e.s < 0 ? "-" + o : o;
}
function FM(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function CF(e) {
  var t, n, r;
  function i(o) {
    var a = this;
    if (!(a instanceof i)) return new i(o);
    if (a.constructor = i, o instanceof i) {
      a.s = o.s, a.e = o.e, a.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(Ms + o);
      if (o > 0)
        a.s = 1;
      else if (o < 0)
        o = -o, a.s = -1;
      else {
        a.s = 0, a.e = 0, a.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        a.e = 0, a.d = [o];
        return;
      }
      return BM(a, o.toString());
    } else if (typeof o != "string")
      throw Error(Ms + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), a.s = -1) : a.s = 1, z0e.test(o)) BM(a, o);
    else throw Error(Ms + o);
  }
  if (i.prototype = Pe, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = CF, i.config = i.set = V0e, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return i.config(e), i;
}
function V0e(e) {
  if (!e || typeof e != "object")
    throw Error(hi + "Object expected");
  var t, n, r, i = [
    "precision",
    1,
    Zc,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((r = e[n = i[t]]) !== void 0)
      if (Jc(r) === r && r >= i[t + 1] && r <= i[t + 2]) this[n] = r;
      else throw Error(Ms + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(Ms + n + ": " + r);
  return this;
}
var AS = CF(W0e);
Wr = new AS(1);
const Pt = AS;
function U0e(e) {
  return Y0e(e) || G0e(e) || K0e(e) || H0e();
}
function H0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function K0e(e, t) {
  if (e) {
    if (typeof e == "string") return Xx(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xx(e, t);
  }
}
function G0e(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function Y0e(e) {
  if (Array.isArray(e)) return Xx(e);
}
function Xx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var q0e = function(t) {
  return t;
}, EF = {
  "@@functional/placeholder": !0
}, kF = function(t) {
  return t === EF;
}, WM = function(t) {
  return function n() {
    return arguments.length === 0 || arguments.length === 1 && kF(arguments.length <= 0 ? void 0 : arguments[0]) ? n : t.apply(void 0, arguments);
  };
}, X0e = function e(t, n) {
  return t === 1 ? n : WM(function() {
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i.filter(function(s) {
      return s !== EF;
    }).length;
    return a >= t ? n.apply(void 0, i) : e(t - a, WM(function() {
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      var f = i.map(function(d) {
        return kF(d) ? l.shift() : d;
      });
      return n.apply(void 0, U0e(f).concat(l));
    }));
  });
}, hy = function(t) {
  return X0e(t.length, t);
}, Zx = function(t, n) {
  for (var r = [], i = t; i < n; ++i)
    r[i - t] = i;
  return r;
}, Z0e = hy(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(n) {
    return t[n];
  }).map(e);
}), J0e = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (!n.length)
    return q0e;
  var i = n.reverse(), o = i[0], a = i.slice(1);
  return function() {
    return a.reduce(function(s, l) {
      return l(s);
    }, o.apply(void 0, arguments));
  };
}, Jx = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, MF = function(t) {
  var n = null, r = null;
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return n && o.every(function(s, l) {
      return s === n[l];
    }) || (n = o, r = t.apply(void 0, o)), r;
  };
};
function Q0e(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new Pt(e).abs().log(10).toNumber()) + 1, t;
}
function exe(e, t, n) {
  for (var r = new Pt(e), i = 0, o = []; r.lt(t) && i < 1e5; )
    o.push(r.toNumber()), r = r.add(n), i++;
  return o;
}
var txe = hy(function(e, t, n) {
  var r = +e, i = +t;
  return r + n * (i - r);
}), nxe = hy(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, (n - e) / r;
}), rxe = hy(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (n - e) / r));
});
const py = {
  rangeStep: exe,
  getDigitCount: Q0e,
  interpolateNumber: txe,
  uninterpolateNumber: nxe,
  uninterpolateTruncation: rxe
};
function Qx(e) {
  return axe(e) || oxe(e) || NF(e) || ixe();
}
function ixe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oxe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function axe(e) {
  if (Array.isArray(e)) return ew(e);
}
function Bf(e, t) {
  return cxe(e) || lxe(e, t) || NF(e, t) || sxe();
}
function sxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NF(e, t) {
  if (e) {
    if (typeof e == "string") return ew(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ew(e, t);
  }
}
function ew(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function lxe(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (l) {
      i = !0, o = l;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (i) throw o;
      }
    }
    return n;
  }
}
function cxe(e) {
  if (Array.isArray(e)) return e;
}
function $F(e) {
  var t = Bf(e, 2), n = t[0], r = t[1], i = n, o = r;
  return n > r && (i = r, o = n), [i, o];
}
function DF(e, t, n) {
  if (e.lte(0))
    return new Pt(0);
  var r = py.getDigitCount(e.toNumber()), i = new Pt(10).pow(r), o = e.div(i), a = r !== 1 ? 0.05 : 0.1, s = new Pt(Math.ceil(o.div(a).toNumber())).add(n).mul(a), l = s.mul(i);
  return t ? l : new Pt(Math.ceil(l));
}
function uxe(e, t, n) {
  var r = 1, i = new Pt(e);
  if (!i.isint() && n) {
    var o = Math.abs(e);
    o < 1 ? (r = new Pt(10).pow(py.getDigitCount(e) - 1), i = new Pt(Math.floor(i.div(r).toNumber())).mul(r)) : o > 1 && (i = new Pt(Math.floor(e)));
  } else e === 0 ? i = new Pt(Math.floor((t - 1) / 2)) : n || (i = new Pt(Math.floor(e)));
  var a = Math.floor((t - 1) / 2), s = J0e(Z0e(function(l) {
    return i.add(new Pt(l - a).mul(r)).toNumber();
  }), Zx);
  return s(0, t);
}
function IF(e, t, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (n - 1)))
    return {
      step: new Pt(0),
      tickMin: new Pt(0),
      tickMax: new Pt(0)
    };
  var o = DF(new Pt(t).sub(e).div(n - 1), r, i), a;
  e <= 0 && t >= 0 ? a = new Pt(0) : (a = new Pt(e).add(t).div(2), a = a.sub(new Pt(a).mod(o)));
  var s = Math.ceil(a.sub(e).div(o).toNumber()), l = Math.ceil(new Pt(t).sub(a).div(o).toNumber()), c = s + l + 1;
  return c > n ? IF(e, t, n, r, i + 1) : (c < n && (l = t > 0 ? l + (n - c) : l, s = t > 0 ? s : s + (n - c)), {
    step: o,
    tickMin: a.sub(new Pt(s).mul(o)),
    tickMax: a.add(new Pt(l).mul(o))
  });
}
function fxe(e) {
  var t = Bf(e, 2), n = t[0], r = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = Math.max(i, 2), s = $F([n, r]), l = Bf(s, 2), c = l[0], f = l[1];
  if (c === -1 / 0 || f === 1 / 0) {
    var d = f === 1 / 0 ? [c].concat(Qx(Zx(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Qx(Zx(0, i - 1).map(function() {
      return -1 / 0;
    })), [f]);
    return n > r ? Jx(d) : d;
  }
  if (c === f)
    return uxe(c, i, o);
  var p = IF(c, f, a, o), m = p.step, y = p.tickMin, g = p.tickMax, v = py.rangeStep(y, g.add(new Pt(0.1).mul(m)), m);
  return n > r ? Jx(v) : v;
}
function dxe(e, t) {
  var n = Bf(e, 2), r = n[0], i = n[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = $F([r, i]), s = Bf(a, 2), l = s[0], c = s[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [r, i];
  if (l === c)
    return [l];
  var f = Math.max(t, 2), d = DF(new Pt(c).sub(l).div(f - 1), o, 0), p = [].concat(Qx(py.rangeStep(new Pt(l), new Pt(c).sub(new Pt(0.99).mul(d)), d)), [c]);
  return r > i ? Jx(p) : p;
}
var hxe = MF(fxe), pxe = MF(dxe), mxe = process.env.NODE_ENV === "production", qb = "Invariant failed";
function Sr(e, t) {
  if (mxe)
    throw new Error(qb);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(qb, ": ").concat(n) : qb;
  throw new Error(r);
}
var gxe = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function dc(e) {
  "@babel/helpers - typeof";
  return dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dc(e);
}
function bm() {
  return bm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bm.apply(this, arguments);
}
function yxe(e, t) {
  return wxe(e) || xxe(e, t) || bxe(e, t) || vxe();
}
function vxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bxe(e, t) {
  if (e) {
    if (typeof e == "string") return zM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zM(e, t);
  }
}
function zM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function xxe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function wxe(e) {
  if (Array.isArray(e)) return e;
}
function _xe(e, t) {
  if (e == null) return {};
  var n = Sxe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Sxe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Oxe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Axe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, LF(r.key), r);
  }
}
function Txe(e, t, n) {
  return t && Axe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Pxe(e, t, n) {
  return t = xm(t), Cxe(e, RF() ? Reflect.construct(t, n || [], xm(e).constructor) : t.apply(e, n));
}
function Cxe(e, t) {
  if (t && (dc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Exe(e);
}
function Exe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function RF() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (RF = function() {
    return !!e;
  })();
}
function xm(e) {
  return xm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, xm(e);
}
function kxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && tw(e, t);
}
function tw(e, t) {
  return tw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, tw(e, t);
}
function jF(e, t, n) {
  return t = LF(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function LF(e) {
  var t = Mxe(e, "string");
  return dc(t) == "symbol" ? t : t + "";
}
function Mxe(e, t) {
  if (dc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (dc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $d = /* @__PURE__ */ function(e) {
  function t() {
    return Oxe(this, t), Pxe(this, t, arguments);
  }
  return kxe(t, e), Txe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.offset, o = r.layout, a = r.width, s = r.dataKey, l = r.data, c = r.dataPointFormatter, f = r.xAxis, d = r.yAxis, p = _xe(r, gxe), m = Ee(p, !1);
      this.props.direction === "x" && f.type !== "number" && (process.env.NODE_ENV !== "production" ? Sr(!1, 'ErrorBar requires Axis type property to be "number".') : Sr());
      var y = l.map(function(g) {
        var v = c(g, s), x = v.x, w = v.y, S = v.value, A = v.errorVal;
        if (!A)
          return null;
        var _ = [], O, P;
        if (Array.isArray(A)) {
          var C = yxe(A, 2);
          O = C[0], P = C[1];
        } else
          O = P = A;
        if (o === "vertical") {
          var k = f.scale, D = w + i, $ = D + a, N = D - a, R = k(S - O), L = k(S + P);
          _.push({
            x1: L,
            y1: $,
            x2: L,
            y2: N
          }), _.push({
            x1: R,
            y1: D,
            x2: L,
            y2: D
          }), _.push({
            x1: R,
            y1: $,
            x2: R,
            y2: N
          });
        } else if (o === "horizontal") {
          var F = d.scale, W = x + i, z = W - a, G = W + a, U = F(S - O), V = F(S + P);
          _.push({
            x1: z,
            y1: V,
            x2: G,
            y2: V
          }), _.push({
            x1: W,
            y1: U,
            x2: W,
            y2: V
          }), _.push({
            x1: z,
            y1: U,
            x2: G,
            y2: U
          });
        }
        return /* @__PURE__ */ I.createElement(at, bm({
          className: "recharts-errorBar",
          key: "bar-".concat(_.map(function(Y) {
            return "".concat(Y.x1, "-").concat(Y.x2, "-").concat(Y.y1, "-").concat(Y.y2);
          }))
        }, m), _.map(function(Y) {
          return /* @__PURE__ */ I.createElement("line", bm({}, Y, {
            key: "line-".concat(Y.x1, "-").concat(Y.x2, "-").concat(Y.y1, "-").concat(Y.y2)
          }));
        }));
      });
      return /* @__PURE__ */ I.createElement(at, {
        className: "recharts-errorBars"
      }, y);
    }
  }]);
}(I.Component);
jF($d, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
jF($d, "displayName", "ErrorBar");
function Ff(e) {
  "@babel/helpers - typeof";
  return Ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ff(e);
}
function VM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ls(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VM(Object(n), !0).forEach(function(r) {
      Nxe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nxe(e, t, n) {
  return t = $xe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function $xe(e) {
  var t = Dxe(e, "string");
  return Ff(t) == "symbol" ? t : t + "";
}
function Dxe(e, t) {
  if (Ff(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ff(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var BF = function(t) {
  var n = t.children, r = t.formattedGraphicalItems, i = t.legendWidth, o = t.legendContent, a = jr(n, jo);
  if (!a)
    return null;
  var s = jo.defaultProps, l = s !== void 0 ? ls(ls({}, s), a.props) : {}, c;
  return a.props && a.props.payload ? c = a.props && a.props.payload : o === "children" ? c = (r || []).reduce(function(f, d) {
    var p = d.item, m = d.props, y = m.sectors || m.data || [];
    return f.concat(y.map(function(g) {
      return {
        type: a.props.iconType || p.props.legendType,
        value: g.name,
        color: g.fill,
        payload: g
      };
    }));
  }, []) : c = (r || []).map(function(f) {
    var d = f.item, p = d.type.defaultProps, m = p !== void 0 ? ls(ls({}, p), d.props) : {}, y = m.dataKey, g = m.name, v = m.legendType, x = m.hide;
    return {
      inactive: x,
      dataKey: y,
      type: l.iconType || v || "square",
      color: TS(d),
      value: g || y,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: m
    };
  }), ls(ls(ls({}, l), jo.getWithHeight(a, i)), {}, {
    payload: c,
    item: a
  });
};
function Wf(e) {
  "@babel/helpers - typeof";
  return Wf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Wf(e);
}
function UM(e) {
  return Lxe(e) || jxe(e) || Rxe(e) || Ixe();
}
function Ixe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rxe(e, t) {
  if (e) {
    if (typeof e == "string") return nw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nw(e, t);
  }
}
function jxe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Lxe(e) {
  if (Array.isArray(e)) return nw(e);
}
function nw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function HM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function rn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HM(Object(n), !0).forEach(function(r) {
      Yl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Yl(e, t, n) {
  return t = Bxe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Bxe(e) {
  var t = Fxe(e, "string");
  return Wf(t) == "symbol" ? t : t + "";
}
function Fxe(e, t) {
  if (Wf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Wf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cn(e, t, n) {
  return Ue(e) || Ue(t) ? n : On(t) ? zr(e, t, n) : ze(t) ? t(e) : n;
}
function nf(e, t, n, r) {
  var i = j0e(e, function(s) {
    return cn(s, t);
  });
  if (n === "number") {
    var o = i.filter(function(s) {
      return ve(s) || parseFloat(s);
    });
    return o.length ? [dy(o), Aa(o)] : [1 / 0, -1 / 0];
  }
  var a = r ? i.filter(function(s) {
    return !Ue(s);
  }) : i;
  return a.map(function(s) {
    return On(s) || s instanceof Date ? s : "";
  });
}
var Wxe = function(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, a = -1, s = (n = r == null ? void 0 : r.length) !== null && n !== void 0 ? n : 0;
  if (s <= 1)
    return 0;
  if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
    for (var l = o.range, c = 0; c < s; c++) {
      var f = c > 0 ? i[c - 1].coordinate : i[s - 1].coordinate, d = i[c].coordinate, p = c >= s - 1 ? i[0].coordinate : i[c + 1].coordinate, m = void 0;
      if (fr(d - f) !== fr(p - d)) {
        var y = [];
        if (fr(p - d) === fr(l[1] - l[0])) {
          m = p;
          var g = d + l[1] - l[0];
          y[0] = Math.min(g, (g + f) / 2), y[1] = Math.max(g, (g + f) / 2);
        } else {
          m = f;
          var v = p + l[1] - l[0];
          y[0] = Math.min(d, (v + d) / 2), y[1] = Math.max(d, (v + d) / 2);
        }
        var x = [Math.min(d, (m + d) / 2), Math.max(d, (m + d) / 2)];
        if (t > x[0] && t <= x[1] || t >= y[0] && t <= y[1]) {
          a = i[c].index;
          break;
        }
      } else {
        var w = Math.min(f, p), S = Math.max(f, p);
        if (t > (w + d) / 2 && t <= (S + d) / 2) {
          a = i[c].index;
          break;
        }
      }
    }
  else
    for (var A = 0; A < s; A++)
      if (A === 0 && t <= (r[A].coordinate + r[A + 1].coordinate) / 2 || A > 0 && A < s - 1 && t > (r[A].coordinate + r[A - 1].coordinate) / 2 && t <= (r[A].coordinate + r[A + 1].coordinate) / 2 || A === s - 1 && t > (r[A].coordinate + r[A - 1].coordinate) / 2) {
        a = r[A].index;
        break;
      }
  return a;
}, TS = function(t) {
  var n, r = t, i = r.type.displayName, o = (n = t.type) !== null && n !== void 0 && n.defaultProps ? rn(rn({}, t.type.defaultProps), t.props) : t.props, a = o.stroke, s = o.fill, l;
  switch (i) {
    case "Line":
      l = a;
      break;
    case "Area":
    case "Radar":
      l = a && a !== "none" ? a : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, zxe = function(t) {
  var n = t.barSize, r = t.totalSize, i = t.stackGroups, o = i === void 0 ? {} : i;
  if (!o)
    return {};
  for (var a = {}, s = Object.keys(o), l = 0, c = s.length; l < c; l++)
    for (var f = o[s[l]].stackGroups, d = Object.keys(f), p = 0, m = d.length; p < m; p++) {
      var y = f[d[p]], g = y.items, v = y.cateAxisId, x = g.filter(function(P) {
        return Ro(P.type).indexOf("Bar") >= 0;
      });
      if (x && x.length) {
        var w = x[0].type.defaultProps, S = w !== void 0 ? rn(rn({}, w), x[0].props) : x[0].props, A = S.barSize, _ = S[v];
        a[_] || (a[_] = []);
        var O = Ue(A) ? n : A;
        a[_].push({
          item: x[0],
          stackList: x.slice(1),
          barSize: Ue(O) ? void 0 : dr(O, r, 0)
        });
      }
    }
  return a;
}, Vxe = function(t) {
  var n = t.barGap, r = t.barCategoryGap, i = t.bandSize, o = t.sizeList, a = o === void 0 ? [] : o, s = t.maxBarSize, l = a.length;
  if (l < 1) return null;
  var c = dr(n, i, 0, !0), f, d = [];
  if (a[0].barSize === +a[0].barSize) {
    var p = !1, m = i / l, y = a.reduce(function(A, _) {
      return A + _.barSize || 0;
    }, 0);
    y += (l - 1) * c, y >= i && (y -= (l - 1) * c, c = 0), y >= i && m > 0 && (p = !0, m *= 0.9, y = l * m);
    var g = (i - y) / 2 >> 0, v = {
      offset: g - c,
      size: 0
    };
    f = a.reduce(function(A, _) {
      var O = {
        item: _.item,
        position: {
          offset: v.offset + v.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: p ? m : _.barSize
        }
      }, P = [].concat(UM(A), [O]);
      return v = P[P.length - 1].position, _.stackList && _.stackList.length && _.stackList.forEach(function(C) {
        P.push({
          item: C,
          position: v
        });
      }), P;
    }, d);
  } else {
    var x = dr(r, i, 0, !0);
    i - 2 * x - (l - 1) * c <= 0 && (c = 0);
    var w = (i - 2 * x - (l - 1) * c) / l;
    w > 1 && (w >>= 0);
    var S = s === +s ? Math.min(w, s) : w;
    f = a.reduce(function(A, _, O) {
      var P = [].concat(UM(A), [{
        item: _.item,
        position: {
          offset: x + (w + c) * O + (w - S) / 2,
          size: S
        }
      }]);
      return _.stackList && _.stackList.length && _.stackList.forEach(function(C) {
        P.push({
          item: C,
          position: P[P.length - 1].position
        });
      }), P;
    }, d);
  }
  return f;
}, Uxe = function(t, n, r, i) {
  var o = r.children, a = r.width, s = r.margin, l = a - (s.left || 0) - (s.right || 0), c = BF({
    children: o,
    legendWidth: l
  });
  if (c) {
    var f = i || {}, d = f.width, p = f.height, m = c.align, y = c.verticalAlign, g = c.layout;
    if ((g === "vertical" || g === "horizontal" && y === "middle") && m !== "center" && ve(t[m]))
      return rn(rn({}, t), {}, Yl({}, m, t[m] + (d || 0)));
    if ((g === "horizontal" || g === "vertical" && m === "center") && y !== "middle" && ve(t[y]))
      return rn(rn({}, t), {}, Yl({}, y, t[y] + (p || 0)));
  }
  return t;
}, Hxe = function(t, n, r) {
  return Ue(n) ? !0 : t === "horizontal" ? n === "yAxis" : t === "vertical" || r === "x" ? n === "xAxis" : r === "y" ? n === "yAxis" : !0;
}, FF = function(t, n, r, i, o) {
  var a = n.props.children, s = Vr(a, $d).filter(function(c) {
    return Hxe(i, o, c.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, f) {
      var d = cn(f, r);
      if (Ue(d)) return c;
      var p = Array.isArray(d) ? [dy(d), Aa(d)] : [d, d], m = l.reduce(function(y, g) {
        var v = cn(f, g, 0), x = p[0] - Math.abs(Array.isArray(v) ? v[0] : v), w = p[1] + Math.abs(Array.isArray(v) ? v[1] : v);
        return [Math.min(x, y[0]), Math.max(w, y[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(m[0], c[0]), Math.max(m[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, Kxe = function(t, n, r, i, o) {
  var a = n.map(function(s) {
    return FF(t, s, r, o, i);
  }).filter(function(s) {
    return !Ue(s);
  });
  return a && a.length ? a.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, WF = function(t, n, r, i, o) {
  var a = n.map(function(l) {
    var c = l.props.dataKey;
    return r === "number" && c && FF(t, l, c, i) || nf(t, c, r, o);
  });
  if (r === "number")
    return a.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return a.reduce(function(l, c) {
    for (var f = 0, d = c.length; f < d; f++)
      s[c[f]] || (s[c[f]] = !0, l.push(c[f]));
    return l;
  }, []);
}, zF = function(t, n) {
  return t === "horizontal" && n === "xAxis" || t === "vertical" && n === "yAxis" || t === "centric" && n === "angleAxis" || t === "radial" && n === "radiusAxis";
}, VF = function(t, n, r, i) {
  if (i)
    return t.map(function(l) {
      return l.coordinate;
    });
  var o, a, s = t.map(function(l) {
    return l.coordinate === n && (o = !0), l.coordinate === r && (a = !0), l.coordinate;
  });
  return o || s.push(n), a || s.push(r), s;
}, ko = function(t, n, r) {
  if (!t) return null;
  var i = t.scale, o = t.duplicateDomain, a = t.type, s = t.range, l = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, c = (n || r) && a === "category" && i.bandwidth ? i.bandwidth() / l : 0;
  if (c = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? fr(s[0] - s[1]) * 2 * c : c, n && (t.ticks || t.niceTicks)) {
    var f = (t.ticks || t.niceTicks).map(function(d) {
      var p = o ? o.indexOf(d) : d;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(p) + c,
        value: d,
        offset: c
      };
    });
    return f.filter(function(d) {
      return !Kc(d.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(d, p) {
    return {
      coordinate: i(d) + c,
      value: d,
      index: p,
      offset: c
    };
  }) : i.ticks && !r ? i.ticks(t.tickCount).map(function(d) {
    return {
      coordinate: i(d) + c,
      value: d,
      offset: c
    };
  }) : i.domain().map(function(d, p) {
    return {
      coordinate: i(d) + c,
      value: o ? o[d] : d,
      index: p,
      offset: c
    };
  });
}, Xb = /* @__PURE__ */ new WeakMap(), Xh = function(t, n) {
  if (typeof n != "function")
    return t;
  Xb.has(t) || Xb.set(t, /* @__PURE__ */ new WeakMap());
  var r = Xb.get(t);
  if (r.has(n))
    return r.get(n);
  var i = function() {
    t.apply(void 0, arguments), n.apply(void 0, arguments);
  };
  return r.set(n, i), i;
}, UF = function(t, n, r) {
  var i = t.scale, o = t.type, a = t.layout, s = t.axisType;
  if (i === "auto")
    return a === "radial" && s === "radiusAxis" ? {
      scale: $f(),
      realScaleType: "band"
    } : a === "radial" && s === "angleAxis" ? {
      scale: pm(),
      realScaleType: "linear"
    } : o === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: tf(),
      realScaleType: "point"
    } : o === "category" ? {
      scale: $f(),
      realScaleType: "band"
    } : {
      scale: pm(),
      realScaleType: "linear"
    };
  if (Pd(i)) {
    var l = "scale".concat(Jg(i));
    return {
      scale: (LM[l] || tf)(),
      realScaleType: LM[l] ? l : "point"
    };
  }
  return ze(i) ? {
    scale: i
  } : {
    scale: tf(),
    realScaleType: "point"
  };
}, KM = 1e-4, HF = function(t) {
  var n = t.domain();
  if (!(!n || n.length <= 2)) {
    var r = n.length, i = t.range(), o = Math.min(i[0], i[1]) - KM, a = Math.max(i[0], i[1]) + KM, s = t(n[0]), l = t(n[r - 1]);
    (s < o || s > a || l < o || l > a) && t.domain([n[0], n[r - 1]]);
  }
}, Gxe = function(t, n) {
  if (!t)
    return null;
  for (var r = 0, i = t.length; r < i; r++)
    if (t[r].item === n)
      return t[r].position;
  return null;
}, Yxe = function(t, n) {
  if (!n || n.length !== 2 || !ve(n[0]) || !ve(n[1]))
    return t;
  var r = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]), o = [t[0], t[1]];
  return (!ve(t[0]) || t[0] < r) && (o[0] = r), (!ve(t[1]) || t[1] > i) && (o[1] = i), o[0] > i && (o[0] = i), o[1] < r && (o[1] = r), o;
}, qxe = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0, s = 0; s < n; ++s) {
        var l = Kc(t[s][r][1]) ? t[s][r][0] : t[s][r][1];
        l >= 0 ? (t[s][r][0] = o, t[s][r][1] = o + l, o = t[s][r][1]) : (t[s][r][0] = a, t[s][r][1] = a + l, a = t[s][r][1]);
      }
}, Xxe = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0; a < n; ++a) {
        var s = Kc(t[a][r][1]) ? t[a][r][0] : t[a][r][1];
        s >= 0 ? (t[a][r][0] = o, t[a][r][1] = o + s, o = t[a][r][1]) : (t[a][r][0] = 0, t[a][r][1] = 0);
      }
}, Zxe = {
  sign: qxe,
  // @ts-expect-error definitelytyped types are incorrect
  expand: gle,
  // @ts-expect-error definitelytyped types are incorrect
  none: ic,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: yle,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: vle,
  positive: Xxe
}, Jxe = function(t, n, r) {
  var i = n.map(function(s) {
    return s.props.dataKey;
  }), o = Zxe[r], a = mle().keys(i).value(function(s, l) {
    return +cn(s, l, 0);
  }).order(Px).offset(o);
  return a(t);
}, Qxe = function(t, n, r, i, o, a) {
  if (!t)
    return null;
  var s = a ? n.reverse() : n, l = {}, c = s.reduce(function(d, p) {
    var m, y = (m = p.type) !== null && m !== void 0 && m.defaultProps ? rn(rn({}, p.type.defaultProps), p.props) : p.props, g = y.stackId, v = y.hide;
    if (v)
      return d;
    var x = y[r], w = d[x] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (On(g)) {
      var S = w.stackGroups[g] || {
        numericAxisId: r,
        cateAxisId: i,
        items: []
      };
      S.items.push(p), w.hasStack = !0, w.stackGroups[g] = S;
    } else
      w.stackGroups[Qs("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: i,
        items: [p]
      };
    return rn(rn({}, d), {}, Yl({}, x, w));
  }, l), f = {};
  return Object.keys(c).reduce(function(d, p) {
    var m = c[p];
    if (m.hasStack) {
      var y = {};
      m.stackGroups = Object.keys(m.stackGroups).reduce(function(g, v) {
        var x = m.stackGroups[v];
        return rn(rn({}, g), {}, Yl({}, v, {
          numericAxisId: r,
          cateAxisId: i,
          items: x.items,
          stackedData: Jxe(t, x.items, o)
        }));
      }, y);
    }
    return rn(rn({}, d), {}, Yl({}, p, m));
  }, f);
}, KF = function(t, n) {
  var r = n.realScaleType, i = n.type, o = n.tickCount, a = n.originalDomain, s = n.allowDecimals, l = r || n.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (o && i === "number" && a && (a[0] === "auto" || a[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var f = hxe(c, o, s);
    return t.domain([dy(f), Aa(f)]), {
      niceTicks: f
    };
  }
  if (o && i === "number") {
    var d = t.domain(), p = pxe(d, o, s);
    return {
      niceTicks: p
    };
  }
  return null;
};
function wm(e) {
  var t = e.axis, n = e.ticks, r = e.bandSize, i = e.entry, o = e.index, a = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !Ue(i[t.dataKey])) {
      var s = Gp(n, "value", i[t.dataKey]);
      if (s)
        return s.coordinate + r / 2;
    }
    return n[o] ? n[o].coordinate + r / 2 : null;
  }
  var l = cn(i, Ue(a) ? t.dataKey : a);
  return Ue(l) ? null : t.scale(l);
}
var GM = function(t) {
  var n = t.axis, r = t.ticks, i = t.offset, o = t.bandSize, a = t.entry, s = t.index;
  if (n.type === "category")
    return r[s] ? r[s].coordinate + i : null;
  var l = cn(a, n.dataKey, n.domain[s]);
  return Ue(l) ? null : n.scale(l) - o / 2 + i;
}, ewe = function(t) {
  var n = t.numericAxis, r = n.scale.domain();
  if (n.type === "number") {
    var i = Math.min(r[0], r[1]), o = Math.max(r[0], r[1]);
    return i <= 0 && o >= 0 ? 0 : o < 0 ? o : i;
  }
  return r[0];
}, twe = function(t, n) {
  var r, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? rn(rn({}, t.type.defaultProps), t.props) : t.props, o = i.stackId;
  if (On(o)) {
    var a = n[o];
    if (a) {
      var s = a.items.indexOf(t);
      return s >= 0 ? a.stackedData[s] : null;
    }
  }
  return null;
}, nwe = function(t) {
  return t.reduce(function(n, r) {
    return [dy(r.concat([n[0]]).filter(ve)), Aa(r.concat([n[1]]).filter(ve))];
  }, [1 / 0, -1 / 0]);
}, GF = function(t, n, r) {
  return Object.keys(t).reduce(function(i, o) {
    var a = t[o], s = a.stackedData, l = s.reduce(function(c, f) {
      var d = nwe(f.slice(n, r + 1));
      return [Math.min(c[0], d[0]), Math.max(c[1], d[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], i[0]), Math.max(l[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, YM = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, qM = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, rw = function(t, n, r) {
  if (ze(t))
    return t(n, r);
  if (!Array.isArray(t))
    return n;
  var i = [];
  if (ve(t[0]))
    i[0] = r ? t[0] : Math.min(t[0], n[0]);
  else if (YM.test(t[0])) {
    var o = +YM.exec(t[0])[1];
    i[0] = n[0] - o;
  } else ze(t[0]) ? i[0] = t[0](n[0]) : i[0] = n[0];
  if (ve(t[1]))
    i[1] = r ? t[1] : Math.max(t[1], n[1]);
  else if (qM.test(t[1])) {
    var a = +qM.exec(t[1])[1];
    i[1] = n[1] + a;
  } else ze(t[1]) ? i[1] = t[1](n[1]) : i[1] = n[1];
  return i;
}, _m = function(t, n, r) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!r || i > 0)
      return i;
  }
  if (t && n && n.length >= 2) {
    for (var o = J_(n, function(d) {
      return d.coordinate;
    }), a = 1 / 0, s = 1, l = o.length; s < l; s++) {
      var c = o[s], f = o[s - 1];
      a = Math.min((c.coordinate || 0) - (f.coordinate || 0), a);
    }
    return a === 1 / 0 ? 0 : a;
  }
  return r ? void 0 : 0;
}, XM = function(t, n, r) {
  return !t || !t.length || zs(t, zr(r, "type.defaultProps.domain")) ? n : t;
}, YF = function(t, n) {
  var r = t.type.defaultProps ? rn(rn({}, t.type.defaultProps), t.props) : t.props, i = r.dataKey, o = r.name, a = r.unit, s = r.formatter, l = r.tooltipType, c = r.chartType, f = r.hide;
  return rn(rn({}, Ee(t, !1)), {}, {
    dataKey: i,
    unit: a,
    formatter: s,
    name: o || i,
    color: TS(t),
    value: cn(n, i),
    type: l,
    payload: n,
    chartType: c,
    hide: f
  });
};
function zf(e) {
  "@babel/helpers - typeof";
  return zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zf(e);
}
function ZM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZM(Object(n), !0).forEach(function(r) {
      qF(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ZM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qF(e, t, n) {
  return t = rwe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rwe(e) {
  var t = iwe(e, "string");
  return zf(t) == "symbol" ? t : t + "";
}
function iwe(e, t) {
  if (zf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (zf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function owe(e, t) {
  return cwe(e) || lwe(e, t) || swe(e, t) || awe();
}
function awe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function swe(e, t) {
  if (e) {
    if (typeof e == "string") return JM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return JM(e, t);
  }
}
function JM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function lwe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function cwe(e) {
  if (Array.isArray(e)) return e;
}
var Sm = Math.PI / 180, uwe = function(t) {
  return t * 180 / Math.PI;
}, Bt = function(t, n, r, i) {
  return {
    x: t + Math.cos(-Sm * i) * r,
    y: n + Math.sin(-Sm * i) * r
  };
}, XF = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (r.left || 0) - (r.right || 0)), Math.abs(n - (r.top || 0) - (r.bottom || 0))) / 2;
}, fwe = function(t, n, r, i, o) {
  var a = t.width, s = t.height, l = t.startAngle, c = t.endAngle, f = dr(t.cx, a, a / 2), d = dr(t.cy, s, s / 2), p = XF(a, s, r), m = dr(t.innerRadius, p, 0), y = dr(t.outerRadius, p, p * 0.8), g = Object.keys(n);
  return g.reduce(function(v, x) {
    var w = n[x], S = w.domain, A = w.reversed, _;
    if (Ue(w.range))
      i === "angleAxis" ? _ = [l, c] : i === "radiusAxis" && (_ = [m, y]), A && (_ = [_[1], _[0]]);
    else {
      _ = w.range;
      var O = _, P = owe(O, 2);
      l = P[0], c = P[1];
    }
    var C = UF(w, o), k = C.realScaleType, D = C.scale;
    D.domain(S).range(_), HF(D);
    var $ = KF(D, wo(wo({}, w), {}, {
      realScaleType: k
    })), N = wo(wo(wo({}, w), $), {}, {
      range: _,
      radius: y,
      realScaleType: k,
      scale: D,
      cx: f,
      cy: d,
      innerRadius: m,
      outerRadius: y,
      startAngle: l,
      endAngle: c
    });
    return wo(wo({}, v), {}, qF({}, x, N));
  }, {});
}, dwe = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return Math.sqrt(Math.pow(r - o, 2) + Math.pow(i - a, 2));
}, hwe = function(t, n) {
  var r = t.x, i = t.y, o = n.cx, a = n.cy, s = dwe({
    x: r,
    y: i
  }, {
    x: o,
    y: a
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (r - o) / s, c = Math.acos(l);
  return i > a && (c = 2 * Math.PI - c), {
    radius: s,
    angle: uwe(c),
    angleInRadian: c
  };
}, pwe = function(t) {
  var n = t.startAngle, r = t.endAngle, i = Math.floor(n / 360), o = Math.floor(r / 360), a = Math.min(i, o);
  return {
    startAngle: n - a * 360,
    endAngle: r - a * 360
  };
}, mwe = function(t, n) {
  var r = n.startAngle, i = n.endAngle, o = Math.floor(r / 360), a = Math.floor(i / 360), s = Math.min(o, a);
  return t + s * 360;
}, QM = function(t, n) {
  var r = t.x, i = t.y, o = hwe({
    x: r,
    y: i
  }, n), a = o.radius, s = o.angle, l = n.innerRadius, c = n.outerRadius;
  if (a < l || a > c)
    return !1;
  if (a === 0)
    return !0;
  var f = pwe(n), d = f.startAngle, p = f.endAngle, m = s, y;
  if (d <= p) {
    for (; m > p; )
      m -= 360;
    for (; m < d; )
      m += 360;
    y = m >= d && m <= p;
  } else {
    for (; m > d; )
      m -= 360;
    for (; m < p; )
      m += 360;
    y = m >= p && m <= d;
  }
  return y ? wo(wo({}, n), {}, {
    radius: a,
    angle: mwe(m, n)
  }) : null;
}, ZF = function(t) {
  return !/* @__PURE__ */ rt(t) && !ze(t) && typeof t != "boolean" ? t.className : "";
};
function Vf(e) {
  "@babel/helpers - typeof";
  return Vf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vf(e);
}
var gwe = ["offset"];
function ywe(e) {
  return wwe(e) || xwe(e) || bwe(e) || vwe();
}
function vwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bwe(e, t) {
  if (e) {
    if (typeof e == "string") return iw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return iw(e, t);
  }
}
function xwe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wwe(e) {
  if (Array.isArray(e)) return iw(e);
}
function iw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _we(e, t) {
  if (e == null) return {};
  var n = Swe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Swe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function eN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eN(Object(n), !0).forEach(function(r) {
      Owe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : eN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Owe(e, t, n) {
  return t = Awe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Awe(e) {
  var t = Twe(e, "string");
  return Vf(t) == "symbol" ? t : t + "";
}
function Twe(e, t) {
  if (Vf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Vf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Uf() {
  return Uf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Uf.apply(this, arguments);
}
var Pwe = function(t) {
  var n = t.value, r = t.formatter, i = Ue(t.children) ? n : t.children;
  return ze(r) ? r(i) : i;
}, Cwe = function(t, n) {
  var r = fr(n - t), i = Math.min(Math.abs(n - t), 360);
  return r * i;
}, Ewe = function(t, n, r) {
  var i = t.position, o = t.viewBox, a = t.offset, s = t.className, l = o, c = l.cx, f = l.cy, d = l.innerRadius, p = l.outerRadius, m = l.startAngle, y = l.endAngle, g = l.clockWise, v = (d + p) / 2, x = Cwe(m, y), w = x >= 0 ? 1 : -1, S, A;
  i === "insideStart" ? (S = m + w * a, A = g) : i === "insideEnd" ? (S = y - w * a, A = !g) : i === "end" && (S = y + w * a, A = g), A = x <= 0 ? A : !A;
  var _ = Bt(c, f, v, S), O = Bt(c, f, v, S + (A ? 1 : -1) * 359), P = "M".concat(_.x, ",").concat(_.y, `
    A`).concat(v, ",").concat(v, ",0,1,").concat(A ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), C = Ue(t.id) ? Qs("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ I.createElement("text", Uf({}, r, {
    dominantBaseline: "central",
    className: Ye("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("path", {
    id: C,
    d: P
  })), /* @__PURE__ */ I.createElement("textPath", {
    xlinkHref: "#".concat(C)
  }, n));
}, kwe = function(t) {
  var n = t.viewBox, r = t.offset, i = t.position, o = n, a = o.cx, s = o.cy, l = o.innerRadius, c = o.outerRadius, f = o.startAngle, d = o.endAngle, p = (f + d) / 2;
  if (i === "outside") {
    var m = Bt(a, s, c + r, p), y = m.x, g = m.y;
    return {
      x: y,
      y: g,
      textAnchor: y >= a ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var v = (l + c) / 2, x = Bt(a, s, v, p), w = x.x, S = x.y;
  return {
    x: w,
    y: S,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, Mwe = function(t) {
  var n = t.viewBox, r = t.parentViewBox, i = t.offset, o = t.position, a = n, s = a.x, l = a.y, c = a.width, f = a.height, d = f >= 0 ? 1 : -1, p = d * i, m = d > 0 ? "end" : "start", y = d > 0 ? "start" : "end", g = c >= 0 ? 1 : -1, v = g * i, x = g > 0 ? "end" : "start", w = g > 0 ? "start" : "end";
  if (o === "top") {
    var S = {
      x: s + c / 2,
      y: l - d * i,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return xn(xn({}, S), r ? {
      height: Math.max(l - r.y, 0),
      width: c
    } : {});
  }
  if (o === "bottom") {
    var A = {
      x: s + c / 2,
      y: l + f + p,
      textAnchor: "middle",
      verticalAnchor: y
    };
    return xn(xn({}, A), r ? {
      height: Math.max(r.y + r.height - (l + f), 0),
      width: c
    } : {});
  }
  if (o === "left") {
    var _ = {
      x: s - v,
      y: l + f / 2,
      textAnchor: x,
      verticalAnchor: "middle"
    };
    return xn(xn({}, _), r ? {
      width: Math.max(_.x - r.x, 0),
      height: f
    } : {});
  }
  if (o === "right") {
    var O = {
      x: s + c + v,
      y: l + f / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return xn(xn({}, O), r ? {
      width: Math.max(r.x + r.width - O.x, 0),
      height: f
    } : {});
  }
  var P = r ? {
    width: c,
    height: f
  } : {};
  return o === "insideLeft" ? xn({
    x: s + v,
    y: l + f / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, P) : o === "insideRight" ? xn({
    x: s + c - v,
    y: l + f / 2,
    textAnchor: x,
    verticalAnchor: "middle"
  }, P) : o === "insideTop" ? xn({
    x: s + c / 2,
    y: l + p,
    textAnchor: "middle",
    verticalAnchor: y
  }, P) : o === "insideBottom" ? xn({
    x: s + c / 2,
    y: l + f - p,
    textAnchor: "middle",
    verticalAnchor: m
  }, P) : o === "insideTopLeft" ? xn({
    x: s + v,
    y: l + p,
    textAnchor: w,
    verticalAnchor: y
  }, P) : o === "insideTopRight" ? xn({
    x: s + c - v,
    y: l + p,
    textAnchor: x,
    verticalAnchor: y
  }, P) : o === "insideBottomLeft" ? xn({
    x: s + v,
    y: l + f - p,
    textAnchor: w,
    verticalAnchor: m
  }, P) : o === "insideBottomRight" ? xn({
    x: s + c - v,
    y: l + f - p,
    textAnchor: x,
    verticalAnchor: m
  }, P) : zc(o) && (ve(o.x) || ws(o.x)) && (ve(o.y) || ws(o.y)) ? xn({
    x: s + dr(o.x, c),
    y: l + dr(o.y, f),
    textAnchor: "end",
    verticalAnchor: "end"
  }, P) : xn({
    x: s + c / 2,
    y: l + f / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, P);
}, Nwe = function(t) {
  return "cx" in t && ve(t.cx);
};
function Sn(e) {
  var t = e.offset, n = t === void 0 ? 5 : t, r = _we(e, gwe), i = xn({
    offset: n
  }, r), o = i.viewBox, a = i.position, s = i.value, l = i.children, c = i.content, f = i.className, d = f === void 0 ? "" : f, p = i.textBreakAll;
  if (!o || Ue(s) && Ue(l) && !/* @__PURE__ */ rt(c) && !ze(c))
    return null;
  if (/* @__PURE__ */ rt(c))
    return /* @__PURE__ */ ht(c, i);
  var m;
  if (ze(c)) {
    if (m = /* @__PURE__ */ ql(c, i), /* @__PURE__ */ rt(m))
      return m;
  } else
    m = Pwe(i);
  var y = Nwe(o), g = Ee(i, !0);
  if (y && (a === "insideStart" || a === "insideEnd" || a === "end"))
    return Ewe(i, m, g);
  var v = y ? kwe(i) : Mwe(i);
  return /* @__PURE__ */ I.createElement(Ws, Uf({
    className: Ye("recharts-label", d)
  }, g, v, {
    breakAll: p
  }), m);
}
Sn.displayName = "Label";
var JF = function(t) {
  var n = t.cx, r = t.cy, i = t.angle, o = t.startAngle, a = t.endAngle, s = t.r, l = t.radius, c = t.innerRadius, f = t.outerRadius, d = t.x, p = t.y, m = t.top, y = t.left, g = t.width, v = t.height, x = t.clockWise, w = t.labelViewBox;
  if (w)
    return w;
  if (ve(g) && ve(v)) {
    if (ve(d) && ve(p))
      return {
        x: d,
        y: p,
        width: g,
        height: v
      };
    if (ve(m) && ve(y))
      return {
        x: m,
        y,
        width: g,
        height: v
      };
  }
  return ve(d) && ve(p) ? {
    x: d,
    y: p,
    width: 0,
    height: 0
  } : ve(n) && ve(r) ? {
    cx: n,
    cy: r,
    startAngle: o || i || 0,
    endAngle: a || i || 0,
    innerRadius: c || 0,
    outerRadius: f || l || s || 0,
    clockWise: x
  } : t.viewBox ? t.viewBox : {};
}, $we = function(t, n) {
  return t ? t === !0 ? /* @__PURE__ */ I.createElement(Sn, {
    key: "label-implicit",
    viewBox: n
  }) : On(t) ? /* @__PURE__ */ I.createElement(Sn, {
    key: "label-implicit",
    viewBox: n,
    value: t
  }) : /* @__PURE__ */ rt(t) ? t.type === Sn ? /* @__PURE__ */ ht(t, {
    key: "label-implicit",
    viewBox: n
  }) : /* @__PURE__ */ I.createElement(Sn, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : ze(t) ? /* @__PURE__ */ I.createElement(Sn, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : zc(t) ? /* @__PURE__ */ I.createElement(Sn, Uf({
    viewBox: n
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, Dwe = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var i = t.children, o = JF(t), a = Vr(i, Sn).map(function(l, c) {
    return /* @__PURE__ */ ht(l, {
      viewBox: n || o,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!r)
    return a;
  var s = $we(t.label, n || o);
  return [s].concat(ywe(a));
};
Sn.parseViewBox = JF;
Sn.renderCallByParent = Dwe;
function Iwe(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Rwe = Iwe;
const jwe = /* @__PURE__ */ kt(Rwe);
function Hf(e) {
  "@babel/helpers - typeof";
  return Hf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hf(e);
}
var Lwe = ["valueAccessor"], Bwe = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function Fwe(e) {
  return Uwe(e) || Vwe(e) || zwe(e) || Wwe();
}
function Wwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zwe(e, t) {
  if (e) {
    if (typeof e == "string") return ow(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ow(e, t);
  }
}
function Vwe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Uwe(e) {
  if (Array.isArray(e)) return ow(e);
}
function ow(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Om() {
  return Om = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Om.apply(this, arguments);
}
function tN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function nN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tN(Object(n), !0).forEach(function(r) {
      Hwe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Hwe(e, t, n) {
  return t = Kwe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kwe(e) {
  var t = Gwe(e, "string");
  return Hf(t) == "symbol" ? t : t + "";
}
function Gwe(e, t) {
  if (Hf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Hf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function rN(e, t) {
  if (e == null) return {};
  var n = Ywe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Ywe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var qwe = function(t) {
  return Array.isArray(t.value) ? jwe(t.value) : t.value;
};
function Zi(e) {
  var t = e.valueAccessor, n = t === void 0 ? qwe : t, r = rN(e, Lwe), i = r.data, o = r.dataKey, a = r.clockWise, s = r.id, l = r.textBreakAll, c = rN(r, Bwe);
  return !i || !i.length ? null : /* @__PURE__ */ I.createElement(at, {
    className: "recharts-label-list"
  }, i.map(function(f, d) {
    var p = Ue(o) ? n(f, d) : cn(f && f.payload, o), m = Ue(s) ? {} : {
      id: "".concat(s, "-").concat(d)
    };
    return /* @__PURE__ */ I.createElement(Sn, Om({}, Ee(f, !0), c, m, {
      parentViewBox: f.parentViewBox,
      value: p,
      textBreakAll: l,
      viewBox: Sn.parseViewBox(Ue(a) ? f : nN(nN({}, f), {}, {
        clockWise: a
      })),
      key: "label-".concat(d),
      index: d
    }));
  }));
}
Zi.displayName = "LabelList";
function Xwe(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ I.createElement(Zi, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ I.isValidElement(e) || ze(e) ? /* @__PURE__ */ I.createElement(Zi, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : zc(e) ? /* @__PURE__ */ I.createElement(Zi, Om({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function Zwe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var r = e.children, i = Vr(r, Zi).map(function(a, s) {
    return /* @__PURE__ */ ht(a, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!n)
    return i;
  var o = Xwe(e.label, t);
  return [o].concat(Fwe(i));
}
Zi.renderCallByParent = Zwe;
function Kf(e) {
  "@babel/helpers - typeof";
  return Kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kf(e);
}
function aw() {
  return aw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, aw.apply(this, arguments);
}
function iN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? iN(Object(n), !0).forEach(function(r) {
      Jwe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : iN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Jwe(e, t, n) {
  return t = Qwe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qwe(e) {
  var t = e1e(e, "string");
  return Kf(t) == "symbol" ? t : t + "";
}
function e1e(e, t) {
  if (Kf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Kf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var t1e = function(t, n) {
  var r = fr(n - t), i = Math.min(Math.abs(n - t), 359.999);
  return r * i;
}, Zh = function(t) {
  var n = t.cx, r = t.cy, i = t.radius, o = t.angle, a = t.sign, s = t.isExternal, l = t.cornerRadius, c = t.cornerIsExternal, f = l * (s ? 1 : -1) + i, d = Math.asin(l / f) / Sm, p = c ? o : o + a * d, m = Bt(n, r, f, p), y = Bt(n, r, i, p), g = c ? o - a * d : o, v = Bt(n, r, f * Math.cos(d * Sm), g);
  return {
    center: m,
    circleTangency: y,
    lineTangency: v,
    theta: d
  };
}, QF = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.startAngle, s = t.endAngle, l = t1e(a, s), c = a + l, f = Bt(n, r, o, a), d = Bt(n, r, o, c), p = "M ".concat(f.x, ",").concat(f.y, `
    A `).concat(o, ",").concat(o, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(a > c), `,
    `).concat(d.x, ",").concat(d.y, `
  `);
  if (i > 0) {
    var m = Bt(n, r, i, a), y = Bt(n, r, i, c);
    p += "L ".concat(y.x, ",").concat(y.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(a <= c), `,
            `).concat(m.x, ",").concat(m.y, " Z");
  } else
    p += "L ".concat(n, ",").concat(r, " Z");
  return p;
}, n1e = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.cornerRadius, s = t.forceCornerRadius, l = t.cornerIsExternal, c = t.startAngle, f = t.endAngle, d = fr(f - c), p = Zh({
    cx: n,
    cy: r,
    radius: o,
    angle: c,
    sign: d,
    cornerRadius: a,
    cornerIsExternal: l
  }), m = p.circleTangency, y = p.lineTangency, g = p.theta, v = Zh({
    cx: n,
    cy: r,
    radius: o,
    angle: f,
    sign: -d,
    cornerRadius: a,
    cornerIsExternal: l
  }), x = v.circleTangency, w = v.lineTangency, S = v.theta, A = l ? Math.abs(c - f) : Math.abs(c - f) - g - S;
  if (A < 0)
    return s ? "M ".concat(y.x, ",").concat(y.y, `
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(a * 2, `,0
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(-a * 2, `,0
      `) : QF({
      cx: n,
      cy: r,
      innerRadius: i,
      outerRadius: o,
      startAngle: c,
      endAngle: f
    });
  var _ = "M ".concat(y.x, ",").concat(y.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,").concat(+(A > 180), ",").concat(+(d < 0), ",").concat(x.x, ",").concat(x.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(w.x, ",").concat(w.y, `
  `);
  if (i > 0) {
    var O = Zh({
      cx: n,
      cy: r,
      radius: i,
      angle: c,
      sign: d,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), P = O.circleTangency, C = O.lineTangency, k = O.theta, D = Zh({
      cx: n,
      cy: r,
      radius: i,
      angle: f,
      sign: -d,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), $ = D.circleTangency, N = D.lineTangency, R = D.theta, L = l ? Math.abs(c - f) : Math.abs(c - f) - k - R;
    if (L < 0 && a === 0)
      return "".concat(_, "L").concat(n, ",").concat(r, "Z");
    _ += "L".concat(N.x, ",").concat(N.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat($.x, ",").concat($.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(L > 180), ",").concat(+(d > 0), ",").concat(P.x, ",").concat(P.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(d < 0), ",").concat(C.x, ",").concat(C.y, "Z");
  } else
    _ += "L".concat(n, ",").concat(r, "Z");
  return _;
}, r1e = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, eW = function(t) {
  var n = oN(oN({}, r1e), t), r = n.cx, i = n.cy, o = n.innerRadius, a = n.outerRadius, s = n.cornerRadius, l = n.forceCornerRadius, c = n.cornerIsExternal, f = n.startAngle, d = n.endAngle, p = n.className;
  if (a < o || f === d)
    return null;
  var m = Ye("recharts-sector", p), y = a - o, g = dr(s, y, 0, !0), v;
  return g > 0 && Math.abs(f - d) < 360 ? v = n1e({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    cornerRadius: Math.min(g, y / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: f,
    endAngle: d
  }) : v = QF({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    startAngle: f,
    endAngle: d
  }), /* @__PURE__ */ I.createElement("path", aw({}, Ee(n, !0), {
    className: m,
    d: v,
    role: "img"
  }));
};
function Gf(e) {
  "@babel/helpers - typeof";
  return Gf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gf(e);
}
function sw() {
  return sw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sw.apply(this, arguments);
}
function aN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? aN(Object(n), !0).forEach(function(r) {
      i1e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : aN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function i1e(e, t, n) {
  return t = o1e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function o1e(e) {
  var t = a1e(e, "string");
  return Gf(t) == "symbol" ? t : t + "";
}
function a1e(e, t) {
  if (Gf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Gf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lN = {
  curveBasisClosed: ile,
  curveBasisOpen: ole,
  curveBasis: rle,
  curveBumpX: Vse,
  curveBumpY: Use,
  curveLinearClosed: ale,
  curveLinear: ey,
  curveMonotoneX: sle,
  curveMonotoneY: lle,
  curveNatural: cle,
  curveStep: ule,
  curveStepAfter: dle,
  curveStepBefore: fle
}, Jh = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, Nu = function(t) {
  return t.x;
}, $u = function(t) {
  return t.y;
}, s1e = function(t, n) {
  if (ze(t))
    return t;
  var r = "curve".concat(Jg(t));
  return (r === "curveMonotone" || r === "curveBump") && n ? lN["".concat(r).concat(n === "vertical" ? "Y" : "X")] : lN[r] || ey;
}, l1e = function(t) {
  var n = t.type, r = n === void 0 ? "linear" : n, i = t.points, o = i === void 0 ? [] : i, a = t.baseLine, s = t.layout, l = t.connectNulls, c = l === void 0 ? !1 : l, f = s1e(r, s), d = c ? o.filter(function(g) {
    return Jh(g);
  }) : o, p;
  if (Array.isArray(a)) {
    var m = c ? a.filter(function(g) {
      return Jh(g);
    }) : a, y = d.map(function(g, v) {
      return sN(sN({}, g), {}, {
        base: m[v]
      });
    });
    return s === "vertical" ? p = zh().y($u).x1(Nu).x0(function(g) {
      return g.base.x;
    }) : p = zh().x(Nu).y1($u).y0(function(g) {
      return g.base.y;
    }), p.defined(Jh).curve(f), p(y);
  }
  return s === "vertical" && ve(a) ? p = zh().y($u).x1(Nu).x0(a) : ve(a) ? p = zh().x(Nu).y1($u).y0(a) : p = YL().x(Nu).y($u), p.defined(Jh).curve(f), p(d);
}, Ns = function(t) {
  var n = t.className, r = t.points, i = t.path, o = t.pathRef;
  if ((!r || !r.length) && !i)
    return null;
  var a = r && r.length ? l1e(t) : i;
  return /* @__PURE__ */ I.createElement("path", sw({}, Ee(t, !1), Yp(t), {
    className: Ye("recharts-curve", n),
    d: a,
    ref: o
  }));
}, lw = { exports: {} }, Qh = { exports: {} }, wt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cN;
function c1e() {
  if (cN) return wt;
  cN = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function S(_) {
    if (typeof _ == "object" && _ !== null) {
      var O = _.$$typeof;
      switch (O) {
        case t:
          switch (_ = _.type, _) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case d:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case f:
                case y:
                case m:
                case a:
                  return _;
                default:
                  return O;
              }
          }
        case n:
          return O;
      }
    }
  }
  function A(_) {
    return S(_) === c;
  }
  return wt.AsyncMode = l, wt.ConcurrentMode = c, wt.ContextConsumer = s, wt.ContextProvider = a, wt.Element = t, wt.ForwardRef = f, wt.Fragment = r, wt.Lazy = y, wt.Memo = m, wt.Portal = n, wt.Profiler = o, wt.StrictMode = i, wt.Suspense = d, wt.isAsyncMode = function(_) {
    return A(_) || S(_) === l;
  }, wt.isConcurrentMode = A, wt.isContextConsumer = function(_) {
    return S(_) === s;
  }, wt.isContextProvider = function(_) {
    return S(_) === a;
  }, wt.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === t;
  }, wt.isForwardRef = function(_) {
    return S(_) === f;
  }, wt.isFragment = function(_) {
    return S(_) === r;
  }, wt.isLazy = function(_) {
    return S(_) === y;
  }, wt.isMemo = function(_) {
    return S(_) === m;
  }, wt.isPortal = function(_) {
    return S(_) === n;
  }, wt.isProfiler = function(_) {
    return S(_) === o;
  }, wt.isStrictMode = function(_) {
    return S(_) === i;
  }, wt.isSuspense = function(_) {
    return S(_) === d;
  }, wt.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === c || _ === o || _ === i || _ === d || _ === p || typeof _ == "object" && _ !== null && (_.$$typeof === y || _.$$typeof === m || _.$$typeof === a || _.$$typeof === s || _.$$typeof === f || _.$$typeof === v || _.$$typeof === x || _.$$typeof === w || _.$$typeof === g);
  }, wt.typeOf = S, wt;
}
var _t = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uN;
function u1e() {
  return uN || (uN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function S(X) {
      return typeof X == "string" || typeof X == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      X === r || X === c || X === o || X === i || X === d || X === p || typeof X == "object" && X !== null && (X.$$typeof === y || X.$$typeof === m || X.$$typeof === a || X.$$typeof === s || X.$$typeof === f || X.$$typeof === v || X.$$typeof === x || X.$$typeof === w || X.$$typeof === g);
    }
    function A(X) {
      if (typeof X == "object" && X !== null) {
        var De = X.$$typeof;
        switch (De) {
          case t:
            var pe = X.type;
            switch (pe) {
              case l:
              case c:
              case r:
              case o:
              case i:
              case d:
                return pe;
              default:
                var ke = pe && pe.$$typeof;
                switch (ke) {
                  case s:
                  case f:
                  case y:
                  case m:
                  case a:
                    return ke;
                  default:
                    return De;
                }
            }
          case n:
            return De;
        }
      }
    }
    var _ = l, O = c, P = s, C = a, k = t, D = f, $ = r, N = y, R = m, L = n, F = o, W = i, z = d, G = !1;
    function U(X) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), V(X) || A(X) === l;
    }
    function V(X) {
      return A(X) === c;
    }
    function Y(X) {
      return A(X) === s;
    }
    function ee(X) {
      return A(X) === a;
    }
    function ie(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function re(X) {
      return A(X) === f;
    }
    function le(X) {
      return A(X) === r;
    }
    function ae(X) {
      return A(X) === y;
    }
    function ue(X) {
      return A(X) === m;
    }
    function ne(X) {
      return A(X) === n;
    }
    function J(X) {
      return A(X) === o;
    }
    function fe(X) {
      return A(X) === i;
    }
    function be(X) {
      return A(X) === d;
    }
    _t.AsyncMode = _, _t.ConcurrentMode = O, _t.ContextConsumer = P, _t.ContextProvider = C, _t.Element = k, _t.ForwardRef = D, _t.Fragment = $, _t.Lazy = N, _t.Memo = R, _t.Portal = L, _t.Profiler = F, _t.StrictMode = W, _t.Suspense = z, _t.isAsyncMode = U, _t.isConcurrentMode = V, _t.isContextConsumer = Y, _t.isContextProvider = ee, _t.isElement = ie, _t.isForwardRef = re, _t.isFragment = le, _t.isLazy = ae, _t.isMemo = ue, _t.isPortal = ne, _t.isProfiler = J, _t.isStrictMode = fe, _t.isSuspense = be, _t.isValidElementType = S, _t.typeOf = A;
  }()), _t;
}
var fN;
function tW() {
  return fN || (fN = 1, process.env.NODE_ENV === "production" ? Qh.exports = c1e() : Qh.exports = u1e()), Qh.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Zb, dN;
function f1e() {
  if (dN) return Zb;
  dN = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Zb = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), c, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          n.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, Zb;
}
var Jb, hN;
function PS() {
  if (hN) return Jb;
  hN = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Jb = e, Jb;
}
var Qb, pN;
function nW() {
  return pN || (pN = 1, Qb = Function.call.bind(Object.prototype.hasOwnProperty)), Qb;
}
var e0, mN;
function d1e() {
  if (mN) return e0;
  mN = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = PS(), n = {}, r = nW();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in o)
        if (r(o, f)) {
          var d;
          try {
            if (typeof o[f] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = o[f](a, f, l, s, null, t);
          } catch (y) {
            d = y;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, e0 = i, e0;
}
var t0, gN;
function h1e() {
  if (gN) return t0;
  gN = 1;
  var e = tW(), t = f1e(), n = PS(), r = nW(), i = d1e(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return t0 = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function d(V) {
      var Y = V && (c && V[c] || V[f]);
      if (typeof Y == "function")
        return Y;
    }
    var p = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: w(),
      arrayOf: S,
      element: A(),
      elementType: _(),
      instanceOf: O,
      node: D(),
      objectOf: C,
      oneOf: P,
      oneOfType: k,
      shape: N,
      exact: R
    };
    function y(V, Y) {
      return V === Y ? V !== 0 || 1 / V === 1 / Y : V !== V && Y !== Y;
    }
    function g(V, Y) {
      this.message = V, this.data = Y && typeof Y == "object" ? Y : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function v(V) {
      if (process.env.NODE_ENV !== "production")
        var Y = {}, ee = 0;
      function ie(le, ae, ue, ne, J, fe, be) {
        if (ne = ne || p, fe = fe || ue, be !== n) {
          if (l) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var De = ne + ":" + ue;
            !Y[De] && // Avoid spamming the console because they are often not actionable except for lib authors
            ee < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + fe + "` prop on `" + ne + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Y[De] = !0, ee++);
          }
        }
        return ae[ue] == null ? le ? ae[ue] === null ? new g("The " + J + " `" + fe + "` is marked as required " + ("in `" + ne + "`, but its value is `null`.")) : new g("The " + J + " `" + fe + "` is marked as required in " + ("`" + ne + "`, but its value is `undefined`.")) : null : V(ae, ue, ne, J, fe);
      }
      var re = ie.bind(null, !1);
      return re.isRequired = ie.bind(null, !0), re;
    }
    function x(V) {
      function Y(ee, ie, re, le, ae, ue) {
        var ne = ee[ie], J = W(ne);
        if (J !== V) {
          var fe = z(ne);
          return new g(
            "Invalid " + le + " `" + ae + "` of type " + ("`" + fe + "` supplied to `" + re + "`, expected ") + ("`" + V + "`."),
            { expectedType: V }
          );
        }
        return null;
      }
      return v(Y);
    }
    function w() {
      return v(a);
    }
    function S(V) {
      function Y(ee, ie, re, le, ae) {
        if (typeof V != "function")
          return new g("Property `" + ae + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var ue = ee[ie];
        if (!Array.isArray(ue)) {
          var ne = W(ue);
          return new g("Invalid " + le + " `" + ae + "` of type " + ("`" + ne + "` supplied to `" + re + "`, expected an array."));
        }
        for (var J = 0; J < ue.length; J++) {
          var fe = V(ue, J, re, le, ae + "[" + J + "]", n);
          if (fe instanceof Error)
            return fe;
        }
        return null;
      }
      return v(Y);
    }
    function A() {
      function V(Y, ee, ie, re, le) {
        var ae = Y[ee];
        if (!s(ae)) {
          var ue = W(ae);
          return new g("Invalid " + re + " `" + le + "` of type " + ("`" + ue + "` supplied to `" + ie + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(V);
    }
    function _() {
      function V(Y, ee, ie, re, le) {
        var ae = Y[ee];
        if (!e.isValidElementType(ae)) {
          var ue = W(ae);
          return new g("Invalid " + re + " `" + le + "` of type " + ("`" + ue + "` supplied to `" + ie + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(V);
    }
    function O(V) {
      function Y(ee, ie, re, le, ae) {
        if (!(ee[ie] instanceof V)) {
          var ue = V.name || p, ne = U(ee[ie]);
          return new g("Invalid " + le + " `" + ae + "` of type " + ("`" + ne + "` supplied to `" + re + "`, expected ") + ("instance of `" + ue + "`."));
        }
        return null;
      }
      return v(Y);
    }
    function P(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function Y(ee, ie, re, le, ae) {
        for (var ue = ee[ie], ne = 0; ne < V.length; ne++)
          if (y(ue, V[ne]))
            return null;
        var J = JSON.stringify(V, function(be, X) {
          var De = z(X);
          return De === "symbol" ? String(X) : X;
        });
        return new g("Invalid " + le + " `" + ae + "` of value `" + String(ue) + "` " + ("supplied to `" + re + "`, expected one of " + J + "."));
      }
      return v(Y);
    }
    function C(V) {
      function Y(ee, ie, re, le, ae) {
        if (typeof V != "function")
          return new g("Property `" + ae + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var ue = ee[ie], ne = W(ue);
        if (ne !== "object")
          return new g("Invalid " + le + " `" + ae + "` of type " + ("`" + ne + "` supplied to `" + re + "`, expected an object."));
        for (var J in ue)
          if (r(ue, J)) {
            var fe = V(ue, J, re, le, ae + "." + J, n);
            if (fe instanceof Error)
              return fe;
          }
        return null;
      }
      return v(Y);
    }
    function k(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Y = 0; Y < V.length; Y++) {
        var ee = V[Y];
        if (typeof ee != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(ee) + " at index " + Y + "."
          ), a;
      }
      function ie(re, le, ae, ue, ne) {
        for (var J = [], fe = 0; fe < V.length; fe++) {
          var be = V[fe], X = be(re, le, ae, ue, ne, n);
          if (X == null)
            return null;
          X.data && r(X.data, "expectedType") && J.push(X.data.expectedType);
        }
        var De = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new g("Invalid " + ue + " `" + ne + "` supplied to " + ("`" + ae + "`" + De + "."));
      }
      return v(ie);
    }
    function D() {
      function V(Y, ee, ie, re, le) {
        return L(Y[ee]) ? null : new g("Invalid " + re + " `" + le + "` supplied to " + ("`" + ie + "`, expected a ReactNode."));
      }
      return v(V);
    }
    function $(V, Y, ee, ie, re) {
      return new g(
        (V || "React class") + ": " + Y + " type `" + ee + "." + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function N(V) {
      function Y(ee, ie, re, le, ae) {
        var ue = ee[ie], ne = W(ue);
        if (ne !== "object")
          return new g("Invalid " + le + " `" + ae + "` of type `" + ne + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var J in V) {
          var fe = V[J];
          if (typeof fe != "function")
            return $(re, le, ae, J, z(fe));
          var be = fe(ue, J, re, le, ae + "." + J, n);
          if (be)
            return be;
        }
        return null;
      }
      return v(Y);
    }
    function R(V) {
      function Y(ee, ie, re, le, ae) {
        var ue = ee[ie], ne = W(ue);
        if (ne !== "object")
          return new g("Invalid " + le + " `" + ae + "` of type `" + ne + "` " + ("supplied to `" + re + "`, expected `object`."));
        var J = t({}, ee[ie], V);
        for (var fe in J) {
          var be = V[fe];
          if (r(V, fe) && typeof be != "function")
            return $(re, le, ae, fe, z(be));
          if (!be)
            return new g(
              "Invalid " + le + " `" + ae + "` key `" + fe + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(ee[ie], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var X = be(ue, fe, re, le, ae + "." + fe, n);
          if (X)
            return X;
        }
        return null;
      }
      return v(Y);
    }
    function L(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(L);
          if (V === null || s(V))
            return !0;
          var Y = d(V);
          if (Y) {
            var ee = Y.call(V), ie;
            if (Y !== V.entries) {
              for (; !(ie = ee.next()).done; )
                if (!L(ie.value))
                  return !1;
            } else
              for (; !(ie = ee.next()).done; ) {
                var re = ie.value;
                if (re && !L(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function F(V, Y) {
      return V === "symbol" ? !0 : Y ? Y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Y instanceof Symbol : !1;
    }
    function W(V) {
      var Y = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : F(Y, V) ? "symbol" : Y;
    }
    function z(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var Y = W(V);
      if (Y === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return Y;
    }
    function G(V) {
      var Y = z(V);
      switch (Y) {
        case "array":
        case "object":
          return "an " + Y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Y;
        default:
          return Y;
      }
    }
    function U(V) {
      return !V.constructor || !V.constructor.name ? p : V.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, t0;
}
var n0, yN;
function p1e() {
  if (yN) return n0;
  yN = 1;
  var e = PS();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, n0 = function() {
    function r(a, s, l, c, f, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, n0;
}
if (process.env.NODE_ENV !== "production") {
  var m1e = tW(), g1e = !0;
  lw.exports = h1e()(m1e.isElement, g1e);
} else
  lw.exports = p1e()();
var y1e = lw.exports;
const Qe = /* @__PURE__ */ kt(y1e);
var v1e = Object.getOwnPropertyNames, b1e = Object.getOwnPropertySymbols, x1e = Object.prototype.hasOwnProperty;
function vN(e, t) {
  return function(r, i, o) {
    return e(r, i, o) && t(r, i, o);
  };
}
function ep(e) {
  return function(n, r, i) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return e(n, r, i);
    var o = i.cache, a = o.get(n), s = o.get(r);
    if (a && s)
      return a === r && s === n;
    o.set(n, r), o.set(r, n);
    var l = e(n, r, i);
    return o.delete(n), o.delete(r), l;
  };
}
function bN(e) {
  return v1e(e).concat(b1e(e));
}
var rW = Object.hasOwn || function(e, t) {
  return x1e.call(e, t);
};
function Qc(e, t) {
  return e || t ? e === t : e === t || e !== e && t !== t;
}
var iW = "_owner", xN = Object.getOwnPropertyDescriptor, wN = Object.keys;
function w1e(e, t, n) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(e[r], t[r], r, r, e, t, n))
      return !1;
  return !0;
}
function _1e(e, t) {
  return Qc(e.getTime(), t.getTime());
}
function _N(e, t, n) {
  if (e.size !== t.size)
    return !1;
  for (var r = {}, i = e.entries(), o = 0, a, s; (a = i.next()) && !a.done; ) {
    for (var l = t.entries(), c = !1, f = 0; (s = l.next()) && !s.done; ) {
      var d = a.value, p = d[0], m = d[1], y = s.value, g = y[0], v = y[1];
      !c && !r[f] && (c = n.equals(p, g, o, f, e, t, n) && n.equals(m, v, p, g, e, t, n)) && (r[f] = !0), f++;
    }
    if (!c)
      return !1;
    o++;
  }
  return !0;
}
function S1e(e, t, n) {
  var r = wN(e), i = r.length;
  if (wN(t).length !== i)
    return !1;
  for (var o; i-- > 0; )
    if (o = r[i], o === iW && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !rW(t, o) || !n.equals(e[o], t[o], o, o, e, t, n))
      return !1;
  return !0;
}
function Du(e, t, n) {
  var r = bN(e), i = r.length;
  if (bN(t).length !== i)
    return !1;
  for (var o, a, s; i-- > 0; )
    if (o = r[i], o === iW && (e.$$typeof || t.$$typeof) && e.$$typeof !== t.$$typeof || !rW(t, o) || !n.equals(e[o], t[o], o, o, e, t, n) || (a = xN(e, o), s = xN(t, o), (a || s) && (!a || !s || a.configurable !== s.configurable || a.enumerable !== s.enumerable || a.writable !== s.writable)))
      return !1;
  return !0;
}
function O1e(e, t) {
  return Qc(e.valueOf(), t.valueOf());
}
function A1e(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function SN(e, t, n) {
  if (e.size !== t.size)
    return !1;
  for (var r = {}, i = e.values(), o, a; (o = i.next()) && !o.done; ) {
    for (var s = t.values(), l = !1, c = 0; (a = s.next()) && !a.done; )
      !l && !r[c] && (l = n.equals(o.value, a.value, o.value, a.value, e, t, n)) && (r[c] = !0), c++;
    if (!l)
      return !1;
  }
  return !0;
}
function T1e(e, t) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var P1e = "[object Arguments]", C1e = "[object Boolean]", E1e = "[object Date]", k1e = "[object Map]", M1e = "[object Number]", N1e = "[object Object]", $1e = "[object RegExp]", D1e = "[object Set]", I1e = "[object String]", R1e = Array.isArray, ON = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, AN = Object.assign, j1e = Object.prototype.toString.call.bind(Object.prototype.toString);
function L1e(e) {
  var t = e.areArraysEqual, n = e.areDatesEqual, r = e.areMapsEqual, i = e.areObjectsEqual, o = e.arePrimitiveWrappersEqual, a = e.areRegExpsEqual, s = e.areSetsEqual, l = e.areTypedArraysEqual;
  return function(f, d, p) {
    if (f === d)
      return !0;
    if (f == null || d == null || typeof f != "object" || typeof d != "object")
      return f !== f && d !== d;
    var m = f.constructor;
    if (m !== d.constructor)
      return !1;
    if (m === Object)
      return i(f, d, p);
    if (R1e(f))
      return t(f, d, p);
    if (ON != null && ON(f))
      return l(f, d, p);
    if (m === Date)
      return n(f, d, p);
    if (m === RegExp)
      return a(f, d, p);
    if (m === Map)
      return r(f, d, p);
    if (m === Set)
      return s(f, d, p);
    var y = j1e(f);
    return y === E1e ? n(f, d, p) : y === $1e ? a(f, d, p) : y === k1e ? r(f, d, p) : y === D1e ? s(f, d, p) : y === N1e ? typeof f.then != "function" && typeof d.then != "function" && i(f, d, p) : y === P1e ? i(f, d, p) : y === C1e || y === M1e || y === I1e ? o(f, d, p) : !1;
  };
}
function B1e(e) {
  var t = e.circular, n = e.createCustomConfig, r = e.strict, i = {
    areArraysEqual: r ? Du : w1e,
    areDatesEqual: _1e,
    areMapsEqual: r ? vN(_N, Du) : _N,
    areObjectsEqual: r ? Du : S1e,
    arePrimitiveWrappersEqual: O1e,
    areRegExpsEqual: A1e,
    areSetsEqual: r ? vN(SN, Du) : SN,
    areTypedArraysEqual: r ? Du : T1e
  };
  if (n && (i = AN({}, i, n(i))), t) {
    var o = ep(i.areArraysEqual), a = ep(i.areMapsEqual), s = ep(i.areObjectsEqual), l = ep(i.areSetsEqual);
    i = AN({}, i, {
      areArraysEqual: o,
      areMapsEqual: a,
      areObjectsEqual: s,
      areSetsEqual: l
    });
  }
  return i;
}
function F1e(e) {
  return function(t, n, r, i, o, a, s) {
    return e(t, n, s);
  };
}
function W1e(e) {
  var t = e.circular, n = e.comparator, r = e.createState, i = e.equals, o = e.strict;
  if (r)
    return function(l, c) {
      var f = r(), d = f.cache, p = d === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : d, m = f.meta;
      return n(l, c, {
        cache: p,
        equals: i,
        meta: m,
        strict: o
      });
    };
  if (t)
    return function(l, c) {
      return n(l, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: o
      });
    };
  var a = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: o
  };
  return function(l, c) {
    return n(l, c, a);
  };
}
var z1e = Ya();
Ya({ strict: !0 });
Ya({ circular: !0 });
Ya({
  circular: !0,
  strict: !0
});
Ya({
  createInternalComparator: function() {
    return Qc;
  }
});
Ya({
  strict: !0,
  createInternalComparator: function() {
    return Qc;
  }
});
Ya({
  circular: !0,
  createInternalComparator: function() {
    return Qc;
  }
});
Ya({
  circular: !0,
  createInternalComparator: function() {
    return Qc;
  },
  strict: !0
});
function Ya(e) {
  e === void 0 && (e = {});
  var t = e.circular, n = t === void 0 ? !1 : t, r = e.createInternalComparator, i = e.createState, o = e.strict, a = o === void 0 ? !1 : o, s = B1e(e), l = L1e(s), c = r ? r(l) : F1e(l);
  return W1e({ circular: n, comparator: l, createState: i, equals: c, strict: a });
}
function V1e(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function TN(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = -1, r = function i(o) {
    n < 0 && (n = o), o - n > t ? (e(o), n = -1) : V1e(i);
  };
  requestAnimationFrame(r);
}
function cw(e) {
  "@babel/helpers - typeof";
  return cw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cw(e);
}
function U1e(e) {
  return Y1e(e) || G1e(e) || K1e(e) || H1e();
}
function H1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function K1e(e, t) {
  if (e) {
    if (typeof e == "string") return PN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PN(e, t);
  }
}
function PN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function G1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Y1e(e) {
  if (Array.isArray(e)) return e;
}
function q1e() {
  var e = {}, t = function() {
    return null;
  }, n = !1, r = function i(o) {
    if (!n) {
      if (Array.isArray(o)) {
        if (!o.length)
          return;
        var a = o, s = U1e(a), l = s[0], c = s.slice(1);
        if (typeof l == "number") {
          TN(i.bind(null, c), l);
          return;
        }
        i(l), TN(i.bind(null, c));
        return;
      }
      cw(o) === "object" && (e = o, t(e)), typeof o == "function" && o();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(o) {
      n = !1, r(o);
    },
    subscribe: function(o) {
      return t = o, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Yf(e) {
  "@babel/helpers - typeof";
  return Yf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yf(e);
}
function CN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function EN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? CN(Object(n), !0).forEach(function(r) {
      oW(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : CN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function oW(e, t, n) {
  return t = X1e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function X1e(e) {
  var t = Z1e(e, "string");
  return Yf(t) === "symbol" ? t : String(t);
}
function Z1e(e, t) {
  if (Yf(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Yf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var J1e = function(t, n) {
  return [Object.keys(t), Object.keys(n)].reduce(function(r, i) {
    return r.filter(function(o) {
      return i.includes(o);
    });
  });
}, Q1e = function(t) {
  return t;
}, e_e = function(t) {
  return t.replace(/([A-Z])/g, function(n) {
    return "-".concat(n.toLowerCase());
  });
}, rf = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return EN(EN({}, r), {}, oW({}, i, t(i, n[i])));
  }, {});
}, kN = function(t, n, r) {
  return t.map(function(i) {
    return "".concat(e_e(i), " ").concat(n, "ms ").concat(r);
  }).join(",");
}, t_e = process.env.NODE_ENV !== "production", Am = function(t, n, r, i, o, a, s, l) {
  if (t_e && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [r, i, o, a, s, l], f = 0;
      console.warn(n.replace(/%s/g, function() {
        return c[f++];
      }));
    }
};
function n_e(e, t) {
  return o_e(e) || i_e(e, t) || aW(e, t) || r_e();
}
function r_e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function i_e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function o_e(e) {
  if (Array.isArray(e)) return e;
}
function a_e(e) {
  return c_e(e) || l_e(e) || aW(e) || s_e();
}
function s_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aW(e, t) {
  if (e) {
    if (typeof e == "string") return uw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return uw(e, t);
  }
}
function l_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function c_e(e) {
  if (Array.isArray(e)) return uw(e);
}
function uw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Tm = 1e-4, sW = function(t, n) {
  return [0, 3 * t, 3 * n - 6 * t, 3 * t - 3 * n + 1];
}, lW = function(t, n) {
  return t.map(function(r, i) {
    return r * Math.pow(n, i);
  }).reduce(function(r, i) {
    return r + i;
  });
}, MN = function(t, n) {
  return function(r) {
    var i = sW(t, n);
    return lW(i, r);
  };
}, u_e = function(t, n) {
  return function(r) {
    var i = sW(t, n), o = [].concat(a_e(i.map(function(a, s) {
      return a * s;
    }).slice(1)), [0]);
    return lW(o, r);
  };
}, NN = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0], o = n[1], a = n[2], s = n[3];
  if (n.length === 1)
    switch (n[0]) {
      case "linear":
        i = 0, o = 0, a = 1, s = 1;
        break;
      case "ease":
        i = 0.25, o = 0.1, a = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, o = 0, a = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, o = 0, a = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, o = 0, a = 0.58, s = 1;
        break;
      default: {
        var l = n[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(v) {
            return parseFloat(v);
          }), f = n_e(c, 4);
          i = f[0], o = f[1], a = f[2], s = f[3];
        } else
          Am(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", n);
      }
    }
  Am([i, a, o, s].every(function(v) {
    return typeof v == "number" && v >= 0 && v <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", n);
  var d = MN(i, a), p = MN(o, s), m = u_e(i, a), y = function(x) {
    return x > 1 ? 1 : x < 0 ? 0 : x;
  }, g = function(x) {
    for (var w = x > 1 ? 1 : x, S = w, A = 0; A < 8; ++A) {
      var _ = d(S) - w, O = m(S);
      if (Math.abs(_ - w) < Tm || O < Tm)
        return p(S);
      S = y(S - _ / O);
    }
    return p(S);
  };
  return g.isStepper = !1, g;
}, f_e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.stiff, r = n === void 0 ? 100 : n, i = t.damping, o = i === void 0 ? 8 : i, a = t.dt, s = a === void 0 ? 17 : a, l = function(f, d, p) {
    var m = -(f - d) * r, y = p * o, g = p + (m - y) * s / 1e3, v = p * s / 1e3 + f;
    return Math.abs(v - d) < Tm && Math.abs(g) < Tm ? [d, 0] : [v, g];
  };
  return l.isStepper = !0, l.dt = s, l;
}, d_e = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return NN(i);
      case "spring":
        return f_e();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return NN(i);
        Am(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", n);
    }
  return typeof i == "function" ? i : (Am(!1, "[configEasing]: first argument type should be function or string, instead received %s", n), null);
};
function qf(e) {
  "@babel/helpers - typeof";
  return qf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qf(e);
}
function $N(e) {
  return m_e(e) || p_e(e) || cW(e) || h_e();
}
function h_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function m_e(e) {
  if (Array.isArray(e)) return dw(e);
}
function DN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DN(Object(n), !0).forEach(function(r) {
      fw(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : DN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fw(e, t, n) {
  return t = g_e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function g_e(e) {
  var t = y_e(e, "string");
  return qf(t) === "symbol" ? t : String(t);
}
function y_e(e, t) {
  if (qf(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (qf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function v_e(e, t) {
  return w_e(e) || x_e(e, t) || cW(e, t) || b_e();
}
function b_e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cW(e, t) {
  if (e) {
    if (typeof e == "string") return dw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dw(e, t);
  }
}
function dw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function x_e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function w_e(e) {
  if (Array.isArray(e)) return e;
}
var Pm = function(t, n, r) {
  return t + (n - t) * r;
}, hw = function(t) {
  var n = t.from, r = t.to;
  return n !== r;
}, __e = function e(t, n, r) {
  var i = rf(function(o, a) {
    if (hw(a)) {
      var s = t(a.from, a.to, a.velocity), l = v_e(s, 2), c = l[0], f = l[1];
      return Wn(Wn({}, a), {}, {
        from: c,
        velocity: f
      });
    }
    return a;
  }, n);
  return r < 1 ? rf(function(o, a) {
    return hw(a) ? Wn(Wn({}, a), {}, {
      velocity: Pm(a.velocity, i[o].velocity, r),
      from: Pm(a.from, i[o].from, r)
    }) : a;
  }, n) : e(t, i, r - 1);
};
const S_e = function(e, t, n, r, i) {
  var o = J1e(e, t), a = o.reduce(function(v, x) {
    return Wn(Wn({}, v), {}, fw({}, x, [e[x], t[x]]));
  }, {}), s = o.reduce(function(v, x) {
    return Wn(Wn({}, v), {}, fw({}, x, {
      from: e[x],
      velocity: 0,
      to: t[x]
    }));
  }, {}), l = -1, c, f, d = function() {
    return null;
  }, p = function() {
    return rf(function(x, w) {
      return w.from;
    }, s);
  }, m = function() {
    return !Object.values(s).filter(hw).length;
  }, y = function(x) {
    c || (c = x);
    var w = x - c, S = w / n.dt;
    s = __e(n, s, S), i(Wn(Wn(Wn({}, e), t), p())), c = x, m() || (l = requestAnimationFrame(d));
  }, g = function(x) {
    f || (f = x);
    var w = (x - f) / r, S = rf(function(_, O) {
      return Pm.apply(void 0, $N(O).concat([n(w)]));
    }, a);
    if (i(Wn(Wn(Wn({}, e), t), S)), w < 1)
      l = requestAnimationFrame(d);
    else {
      var A = rf(function(_, O) {
        return Pm.apply(void 0, $N(O).concat([n(1)]));
      }, a);
      i(Wn(Wn(Wn({}, e), t), A));
    }
  };
  return d = n.isStepper ? y : g, function() {
    return requestAnimationFrame(d), function() {
      cancelAnimationFrame(l);
    };
  };
};
function hc(e) {
  "@babel/helpers - typeof";
  return hc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hc(e);
}
var O_e = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function A_e(e, t) {
  if (e == null) return {};
  var n = T_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function T_e(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function r0(e) {
  return k_e(e) || E_e(e) || C_e(e) || P_e();
}
function P_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C_e(e, t) {
  if (e) {
    if (typeof e == "string") return pw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pw(e, t);
  }
}
function E_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function k_e(e) {
  if (Array.isArray(e)) return pw(e);
}
function pw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function IN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IN(Object(n), !0).forEach(function(r) {
      zu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : IN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zu(e, t, n) {
  return t = uW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function M_e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function N_e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, uW(r.key), r);
  }
}
function $_e(e, t, n) {
  return t && N_e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function uW(e) {
  var t = D_e(e, "string");
  return hc(t) === "symbol" ? t : String(t);
}
function D_e(e, t) {
  if (hc(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (hc(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function I_e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && mw(e, t);
}
function mw(e, t) {
  return mw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, mw(e, t);
}
function R_e(e) {
  var t = j_e();
  return function() {
    var r = Cm(e), i;
    if (t) {
      var o = Cm(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return gw(this, i);
  };
}
function gw(e, t) {
  if (t && (hc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yw(e);
}
function yw(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function j_e() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Cm(e) {
  return Cm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cm(e);
}
var $i = /* @__PURE__ */ function(e) {
  I_e(n, e);
  var t = R_e(n);
  function n(r, i) {
    var o;
    M_e(this, n), o = t.call(this, r, i);
    var a = o.props, s = a.isActive, l = a.attributeName, c = a.from, f = a.to, d = a.steps, p = a.children, m = a.duration;
    if (o.handleStyleChange = o.handleStyleChange.bind(yw(o)), o.changeStyle = o.changeStyle.bind(yw(o)), !s || m <= 0)
      return o.state = {
        style: {}
      }, typeof p == "function" && (o.state = {
        style: f
      }), gw(o);
    if (d && d.length)
      o.state = {
        style: d[0].style
      };
    else if (c) {
      if (typeof p == "function")
        return o.state = {
          style: c
        }, gw(o);
      o.state = {
        style: l ? zu({}, l, c) : c
      };
    } else
      o.state = {
        style: {}
      };
    return o;
  }
  return $_e(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.isActive, a = i.canBegin;
      this.mounted = !0, !(!o || !a) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var o = this.props, a = o.isActive, s = o.canBegin, l = o.attributeName, c = o.shouldReAnimate, f = o.to, d = o.from, p = this.state.style;
      if (s) {
        if (!a) {
          var m = {
            style: l ? zu({}, l, f) : f
          };
          this.state && p && (l && p[l] !== f || !l && p !== f) && this.setState(m);
          return;
        }
        if (!(z1e(i.to, f) && i.canBegin && i.isActive)) {
          var y = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var g = y || c ? d : i.to;
          if (this.state && p) {
            var v = {
              style: l ? zu({}, l, g) : g
            };
            (l && p[l] !== g || !l && p !== g) && this.setState(v);
          }
          this.runAnimation(xi(xi({}, this.props), {}, {
            from: g,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var o = this, a = i.from, s = i.to, l = i.duration, c = i.easing, f = i.begin, d = i.onAnimationEnd, p = i.onAnimationStart, m = S_e(a, s, d_e(c), l, this.changeStyle), y = function() {
        o.stopJSAnimation = m();
      };
      this.manager.start([p, f, y, l, d]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var o = this, a = i.steps, s = i.begin, l = i.onAnimationStart, c = a[0], f = c.style, d = c.duration, p = d === void 0 ? 0 : d, m = function(g, v, x) {
        if (x === 0)
          return g;
        var w = v.duration, S = v.easing, A = S === void 0 ? "ease" : S, _ = v.style, O = v.properties, P = v.onAnimationEnd, C = x > 0 ? a[x - 1] : v, k = O || Object.keys(_);
        if (typeof A == "function" || A === "spring")
          return [].concat(r0(g), [o.runJSAnimation.bind(o, {
            from: C.style,
            to: _,
            duration: w,
            easing: A
          }), w]);
        var D = kN(k, w, A), $ = xi(xi(xi({}, C.style), _), {}, {
          transition: D
        });
        return [].concat(r0(g), [$, w, P]).filter(Q1e);
      };
      return this.manager.start([l].concat(r0(a.reduce(m, [f, Math.max(p, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = q1e());
      var o = i.begin, a = i.duration, s = i.attributeName, l = i.to, c = i.easing, f = i.onAnimationStart, d = i.onAnimationEnd, p = i.steps, m = i.children, y = this.manager;
      if (this.unSubscribe = y.subscribe(this.handleStyleChange), typeof c == "function" || typeof m == "function" || c === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (p.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var g = s ? zu({}, s, l) : l, v = kN(Object.keys(g), a, c);
      y.start([f, o, xi(xi({}, g), {}, {
        transition: v
      }), a, d]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, o = i.children;
      i.begin;
      var a = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var l = A_e(i, O_e), c = Yt.count(o), f = this.state.style;
      if (typeof o == "function")
        return o(f);
      if (!s || c === 0 || a <= 0)
        return o;
      var d = function(m) {
        var y = m.props, g = y.style, v = g === void 0 ? {} : g, x = y.className, w = /* @__PURE__ */ ht(m, xi(xi({}, l), {}, {
          style: xi(xi({}, v), f),
          className: x
        }));
        return w;
      };
      return c === 1 ? d(Yt.only(o)) : /* @__PURE__ */ I.createElement("div", null, Yt.map(o, function(p) {
        return d(p);
      }));
    }
  }]), n;
}(pi);
$i.displayName = "Animate";
$i.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
$i.propTypes = {
  from: Qe.oneOfType([Qe.object, Qe.string]),
  to: Qe.oneOfType([Qe.object, Qe.string]),
  attributeName: Qe.string,
  // animation duration
  duration: Qe.number,
  begin: Qe.number,
  easing: Qe.oneOfType([Qe.string, Qe.func]),
  steps: Qe.arrayOf(Qe.shape({
    duration: Qe.number.isRequired,
    style: Qe.object.isRequired,
    easing: Qe.oneOfType([Qe.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Qe.func]),
    // transition css properties(dash case), optional
    properties: Qe.arrayOf("string"),
    onAnimationEnd: Qe.func
  })),
  children: Qe.oneOfType([Qe.node, Qe.func]),
  isActive: Qe.bool,
  canBegin: Qe.bool,
  onAnimationEnd: Qe.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Qe.bool,
  onAnimationStart: Qe.func,
  onAnimationReStart: Qe.func
};
Qe.object, Qe.object, Qe.object, Qe.element;
Qe.object, Qe.object, Qe.object, Qe.oneOfType([Qe.array, Qe.element]), Qe.any;
function Xf(e) {
  "@babel/helpers - typeof";
  return Xf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xf(e);
}
function Em() {
  return Em = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Em.apply(this, arguments);
}
function L_e(e, t) {
  return z_e(e) || W_e(e, t) || F_e(e, t) || B_e();
}
function B_e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F_e(e, t) {
  if (e) {
    if (typeof e == "string") return RN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RN(e, t);
  }
}
function RN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function W_e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function z_e(e) {
  if (Array.isArray(e)) return e;
}
function jN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function LN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jN(Object(n), !0).forEach(function(r) {
      V_e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function V_e(e, t, n) {
  return t = U_e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function U_e(e) {
  var t = H_e(e, "string");
  return Xf(t) == "symbol" ? t : t + "";
}
function H_e(e, t) {
  if (Xf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Xf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var BN = function(t, n, r, i, o) {
  var a = Math.min(Math.abs(r) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, l = r >= 0 ? 1 : -1, c = i >= 0 && r >= 0 || i < 0 && r < 0 ? 1 : 0, f;
  if (a > 0 && o instanceof Array) {
    for (var d = [0, 0, 0, 0], p = 0, m = 4; p < m; p++)
      d[p] = o[p] > a ? a : o[p];
    f = "M".concat(t, ",").concat(n + s * d[0]), d[0] > 0 && (f += "A ".concat(d[0], ",").concat(d[0], ",0,0,").concat(c, ",").concat(t + l * d[0], ",").concat(n)), f += "L ".concat(t + r - l * d[1], ",").concat(n), d[1] > 0 && (f += "A ".concat(d[1], ",").concat(d[1], ",0,0,").concat(c, `,
        `).concat(t + r, ",").concat(n + s * d[1])), f += "L ".concat(t + r, ",").concat(n + i - s * d[2]), d[2] > 0 && (f += "A ".concat(d[2], ",").concat(d[2], ",0,0,").concat(c, `,
        `).concat(t + r - l * d[2], ",").concat(n + i)), f += "L ".concat(t + l * d[3], ",").concat(n + i), d[3] > 0 && (f += "A ".concat(d[3], ",").concat(d[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(n + i - s * d[3])), f += "Z";
  } else if (a > 0 && o === +o && o > 0) {
    var y = Math.min(a, o);
    f = "M ".concat(t, ",").concat(n + s * y, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t + l * y, ",").concat(n, `
            L `).concat(t + r - l * y, ",").concat(n, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t + r, ",").concat(n + s * y, `
            L `).concat(t + r, ",").concat(n + i - s * y, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t + r - l * y, ",").concat(n + i, `
            L `).concat(t + l * y, ",").concat(n + i, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t, ",").concat(n + i - s * y, " Z");
  } else
    f = "M ".concat(t, ",").concat(n, " h ").concat(r, " v ").concat(i, " h ").concat(-r, " Z");
  return f;
}, K_e = function(t, n) {
  if (!t || !n)
    return !1;
  var r = t.x, i = t.y, o = n.x, a = n.y, s = n.width, l = n.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var c = Math.min(o, o + s), f = Math.max(o, o + s), d = Math.min(a, a + l), p = Math.max(a, a + l);
    return r >= c && r <= f && i >= d && i <= p;
  }
  return !1;
}, G_e = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, CS = function(t) {
  var n = LN(LN({}, G_e), t), r = ut(), i = Me(-1), o = L_e(i, 2), a = o[0], s = o[1];
  Xe(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var A = r.current.getTotalLength();
        A && s(A);
      } catch {
      }
  }, []);
  var l = n.x, c = n.y, f = n.width, d = n.height, p = n.radius, m = n.className, y = n.animationEasing, g = n.animationDuration, v = n.animationBegin, x = n.isAnimationActive, w = n.isUpdateAnimationActive;
  if (l !== +l || c !== +c || f !== +f || d !== +d || f === 0 || d === 0)
    return null;
  var S = Ye("recharts-rectangle", m);
  return w ? /* @__PURE__ */ I.createElement($i, {
    canBegin: a > 0,
    from: {
      width: f,
      height: d,
      x: l,
      y: c
    },
    to: {
      width: f,
      height: d,
      x: l,
      y: c
    },
    duration: g,
    animationEasing: y,
    isActive: w
  }, function(A) {
    var _ = A.width, O = A.height, P = A.x, C = A.y;
    return /* @__PURE__ */ I.createElement($i, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: g,
      isActive: x,
      easing: y
    }, /* @__PURE__ */ I.createElement("path", Em({}, Ee(n, !0), {
      className: S,
      d: BN(P, C, _, O, p),
      ref: r
    })));
  }) : /* @__PURE__ */ I.createElement("path", Em({}, Ee(n, !0), {
    className: S,
    d: BN(l, c, f, d, p)
  }));
}, Y_e = ["points", "className", "baseLinePoints", "connectNulls"];
function jl() {
  return jl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jl.apply(this, arguments);
}
function q_e(e, t) {
  if (e == null) return {};
  var n = X_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function X_e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function FN(e) {
  return eSe(e) || Q_e(e) || J_e(e) || Z_e();
}
function Z_e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function J_e(e, t) {
  if (e) {
    if (typeof e == "string") return vw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vw(e, t);
  }
}
function Q_e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function eSe(e) {
  if (Array.isArray(e)) return vw(e);
}
function vw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var WN = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, tSe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [[]];
  return t.forEach(function(r) {
    WN(r) ? n[n.length - 1].push(r) : n[n.length - 1].length > 0 && n.push([]);
  }), WN(t[0]) && n[n.length - 1].push(t[0]), n[n.length - 1].length <= 0 && (n = n.slice(0, -1)), n;
}, of = function(t, n) {
  var r = tSe(t);
  n && (r = [r.reduce(function(o, a) {
    return [].concat(FN(o), FN(a));
  }, [])]);
  var i = r.map(function(o) {
    return o.reduce(function(a, s, l) {
      return "".concat(a).concat(l === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return r.length === 1 ? "".concat(i, "Z") : i;
}, nSe = function(t, n, r) {
  var i = of(t, r);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(of(n.reverse(), r).slice(1));
}, rSe = function(t) {
  var n = t.points, r = t.className, i = t.baseLinePoints, o = t.connectNulls, a = q_e(t, Y_e);
  if (!n || !n.length)
    return null;
  var s = Ye("recharts-polygon", r);
  if (i && i.length) {
    var l = a.stroke && a.stroke !== "none", c = nSe(n, i, o);
    return /* @__PURE__ */ I.createElement("g", {
      className: s
    }, /* @__PURE__ */ I.createElement("path", jl({}, Ee(a, !0), {
      fill: c.slice(-1) === "Z" ? a.fill : "none",
      stroke: "none",
      d: c
    })), l ? /* @__PURE__ */ I.createElement("path", jl({}, Ee(a, !0), {
      fill: "none",
      d: of(n, o)
    })) : null, l ? /* @__PURE__ */ I.createElement("path", jl({}, Ee(a, !0), {
      fill: "none",
      d: of(i, o)
    })) : null);
  }
  var f = of(n, o);
  return /* @__PURE__ */ I.createElement("path", jl({}, Ee(a, !0), {
    fill: f.slice(-1) === "Z" ? a.fill : "none",
    className: s,
    d: f
  }));
};
function bw() {
  return bw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bw.apply(this, arguments);
}
var Dd = function(t) {
  var n = t.cx, r = t.cy, i = t.r, o = t.className, a = Ye("recharts-dot", o);
  return n === +n && r === +r && i === +i ? /* @__PURE__ */ I.createElement("circle", bw({}, Ee(t, !1), Yp(t), {
    className: a,
    cx: n,
    cy: r,
    r: i
  })) : null;
};
function Zf(e) {
  "@babel/helpers - typeof";
  return Zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zf(e);
}
var iSe = ["x", "y", "top", "left", "width", "height", "className"];
function xw() {
  return xw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xw.apply(this, arguments);
}
function zN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oSe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zN(Object(n), !0).forEach(function(r) {
      aSe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aSe(e, t, n) {
  return t = sSe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sSe(e) {
  var t = lSe(e, "string");
  return Zf(t) == "symbol" ? t : t + "";
}
function lSe(e, t) {
  if (Zf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Zf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cSe(e, t) {
  if (e == null) return {};
  var n = uSe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function uSe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var fSe = function(t, n, r, i, o, a) {
  return "M".concat(t, ",").concat(o, "v").concat(i, "M").concat(a, ",").concat(n, "h").concat(r);
}, dSe = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.top, s = a === void 0 ? 0 : a, l = t.left, c = l === void 0 ? 0 : l, f = t.width, d = f === void 0 ? 0 : f, p = t.height, m = p === void 0 ? 0 : p, y = t.className, g = cSe(t, iSe), v = oSe({
    x: r,
    y: o,
    top: s,
    left: c,
    width: d,
    height: m
  }, g);
  return !ve(r) || !ve(o) || !ve(d) || !ve(m) || !ve(s) || !ve(c) ? null : /* @__PURE__ */ I.createElement("path", xw({}, Ee(v, !0), {
    className: Ye("recharts-cross", y),
    d: fSe(r, o, d, m, s, c)
  }));
}, hSe = fy, pSe = _F, mSe = ao;
function gSe(e, t) {
  return e && e.length ? hSe(e, mSe(t), pSe) : void 0;
}
var ySe = gSe;
const vSe = /* @__PURE__ */ kt(ySe);
var bSe = fy, xSe = ao, wSe = SF;
function _Se(e, t) {
  return e && e.length ? bSe(e, xSe(t), wSe) : void 0;
}
var SSe = _Se;
const OSe = /* @__PURE__ */ kt(SSe);
var ASe = ["cx", "cy", "angle", "ticks", "axisLine"], TSe = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function pc(e) {
  "@babel/helpers - typeof";
  return pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pc(e);
}
function af() {
  return af = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, af.apply(this, arguments);
}
function VN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VN(Object(n), !0).forEach(function(r) {
      my(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function UN(e, t) {
  if (e == null) return {};
  var n = PSe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function PSe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function CSe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function HN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, dW(r.key), r);
  }
}
function ESe(e, t, n) {
  return t && HN(e.prototype, t), n && HN(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function kSe(e, t, n) {
  return t = km(t), MSe(e, fW() ? Reflect.construct(t, n || [], km(e).constructor) : t.apply(e, n));
}
function MSe(e, t) {
  if (t && (pc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return NSe(e);
}
function NSe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fW = function() {
    return !!e;
  })();
}
function km(e) {
  return km = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, km(e);
}
function $Se(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ww(e, t);
}
function ww(e, t) {
  return ww = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ww(e, t);
}
function my(e, t, n) {
  return t = dW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dW(e) {
  var t = DSe(e, "string");
  return pc(t) == "symbol" ? t : t + "";
}
function DSe(e, t) {
  if (pc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (pc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gy = /* @__PURE__ */ function(e) {
  function t() {
    return CSe(this, t), kSe(this, t, arguments);
  }
  return $Se(t, e), ESe(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(r) {
        var i = r.coordinate, o = this.props, a = o.angle, s = o.cx, l = o.cy;
        return Bt(s, l, i, a);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props.orientation, i;
      switch (r) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, l = vSe(s, function(f) {
        return f.coordinate || 0;
      }), c = OSe(s, function(f) {
        return f.coordinate || 0;
      });
      return {
        cx: i,
        cy: o,
        startAngle: a,
        endAngle: a,
        innerRadius: c.coordinate || 0,
        outerRadius: l.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, l = r.axisLine, c = UN(r, ASe), f = s.reduce(function(y, g) {
        return [Math.min(y[0], g.coordinate), Math.max(y[1], g.coordinate)];
      }, [1 / 0, -1 / 0]), d = Bt(i, o, f[0], a), p = Bt(i, o, f[1], a), m = cs(cs(cs({}, Ee(c, !1)), {}, {
        fill: "none"
      }, Ee(l, !1)), {}, {
        x1: d.x,
        y1: d.y,
        x2: p.x,
        y2: p.y
      });
      return /* @__PURE__ */ I.createElement("line", af({
        className: "recharts-polar-radius-axis-line"
      }, m));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.angle, l = i.tickFormatter, c = i.stroke, f = UN(i, TSe), d = this.getTickTextAnchor(), p = Ee(f, !1), m = Ee(a, !1), y = o.map(function(g, v) {
        var x = r.getTickValueCoord(g), w = cs(cs(cs(cs({
          textAnchor: d,
          transform: "rotate(".concat(90 - s, ", ").concat(x.x, ", ").concat(x.y, ")")
        }, p), {}, {
          stroke: "none",
          fill: c
        }, m), {}, {
          index: v
        }, x), {}, {
          payload: g
        });
        return /* @__PURE__ */ I.createElement(at, af({
          className: Ye("recharts-polar-radius-axis-tick", ZF(a)),
          key: "tick-".concat(g.coordinate)
        }, Fs(r.props, g, v)), t.renderTickItem(a, w, l ? l(g.value, v) : g.value));
      });
      return /* @__PURE__ */ I.createElement(at, {
        className: "recharts-polar-radius-axis-ticks"
      }, y);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.axisLine, a = r.tick;
      return !i || !i.length ? null : /* @__PURE__ */ I.createElement(at, {
        className: Ye("recharts-polar-radius-axis", this.props.className)
      }, o && this.renderAxisLine(), a && this.renderTicks(), Sn.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ I.isValidElement(r) ? a = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? a = r(i) : a = /* @__PURE__ */ I.createElement(Ws, af({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), o), a;
    }
  }]);
}(pi);
my(gy, "displayName", "PolarRadiusAxis");
my(gy, "axisType", "radiusAxis");
my(gy, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function mc(e) {
  "@babel/helpers - typeof";
  return mc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mc(e);
}
function vs() {
  return vs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vs.apply(this, arguments);
}
function KN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function us(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? KN(Object(n), !0).forEach(function(r) {
      yy(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : KN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ISe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function GN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, pW(r.key), r);
  }
}
function RSe(e, t, n) {
  return t && GN(e.prototype, t), n && GN(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jSe(e, t, n) {
  return t = Mm(t), LSe(e, hW() ? Reflect.construct(t, n || [], Mm(e).constructor) : t.apply(e, n));
}
function LSe(e, t) {
  if (t && (mc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return BSe(e);
}
function BSe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hW = function() {
    return !!e;
  })();
}
function Mm(e) {
  return Mm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mm(e);
}
function FSe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _w(e, t);
}
function _w(e, t) {
  return _w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, _w(e, t);
}
function yy(e, t, n) {
  return t = pW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pW(e) {
  var t = WSe(e, "string");
  return mc(t) == "symbol" ? t : t + "";
}
function WSe(e, t) {
  if (mc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (mc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zSe = Math.PI / 180, YN = 1e-5, vy = /* @__PURE__ */ function(e) {
  function t() {
    return ISe(this, t), jSe(this, t, arguments);
  }
  return FSe(t, e), RSe(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(r) {
        var i = this.props, o = i.cx, a = i.cy, s = i.radius, l = i.orientation, c = i.tickSize, f = c || 8, d = Bt(o, a, s, r.coordinate), p = Bt(o, a, s + (l === "inner" ? -1 : 1) * f, r.coordinate);
        return {
          x1: d.x,
          y1: d.y,
          x2: p.x,
          y2: p.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(r) {
      var i = this.props.orientation, o = Math.cos(-r.coordinate * zSe), a;
      return o > YN ? a = i === "outer" ? "start" : "end" : o < -YN ? a = i === "outer" ? "end" : "start" : a = "middle", a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.radius, s = r.axisLine, l = r.axisLineType, c = us(us({}, Ee(this.props, !1)), {}, {
        fill: "none"
      }, Ee(s, !1));
      if (l === "circle")
        return /* @__PURE__ */ I.createElement(Dd, vs({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: i,
          cy: o,
          r: a
        }));
      var f = this.props.ticks, d = f.map(function(p) {
        return Bt(i, o, a, p.coordinate);
      });
      return /* @__PURE__ */ I.createElement(rSe, vs({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: d
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.tickLine, l = i.tickFormatter, c = i.stroke, f = Ee(this.props, !1), d = Ee(a, !1), p = us(us({}, f), {}, {
        fill: "none"
      }, Ee(s, !1)), m = o.map(function(y, g) {
        var v = r.getTickLineCoord(y), x = r.getTickTextAnchor(y), w = us(us(us({
          textAnchor: x
        }, f), {}, {
          stroke: "none",
          fill: c
        }, d), {}, {
          index: g,
          payload: y,
          x: v.x2,
          y: v.y2
        });
        return /* @__PURE__ */ I.createElement(at, vs({
          className: Ye("recharts-polar-angle-axis-tick", ZF(a)),
          key: "tick-".concat(y.coordinate)
        }, Fs(r.props, y, g)), s && /* @__PURE__ */ I.createElement("line", vs({
          className: "recharts-polar-angle-axis-tick-line"
        }, p, v)), a && t.renderTickItem(a, w, l ? l(y.value, g) : y.value));
      });
      return /* @__PURE__ */ I.createElement(at, {
        className: "recharts-polar-angle-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.radius, a = r.axisLine;
      return o <= 0 || !i || !i.length ? null : /* @__PURE__ */ I.createElement(at, {
        className: Ye("recharts-polar-angle-axis", this.props.className)
      }, a && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ I.isValidElement(r) ? a = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? a = r(i) : a = /* @__PURE__ */ I.createElement(Ws, vs({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), o), a;
    }
  }]);
}(pi);
yy(vy, "displayName", "PolarAngleAxis");
yy(vy, "axisType", "angleAxis");
yy(vy, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var VSe = vB, USe = VSe(Object.getPrototypeOf, Object), HSe = USe, KSe = Qo, GSe = HSe, YSe = ea, qSe = "[object Object]", XSe = Function.prototype, ZSe = Object.prototype, mW = XSe.toString, JSe = ZSe.hasOwnProperty, QSe = mW.call(Object);
function eOe(e) {
  if (!YSe(e) || KSe(e) != qSe)
    return !1;
  var t = GSe(e);
  if (t === null)
    return !0;
  var n = JSe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && mW.call(n) == QSe;
}
var tOe = eOe;
const nOe = /* @__PURE__ */ kt(tOe);
var rOe = Qo, iOe = ea, oOe = "[object Boolean]";
function aOe(e) {
  return e === !0 || e === !1 || iOe(e) && rOe(e) == oOe;
}
var sOe = aOe;
const lOe = /* @__PURE__ */ kt(sOe);
function Jf(e) {
  "@babel/helpers - typeof";
  return Jf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jf(e);
}
function Nm() {
  return Nm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nm.apply(this, arguments);
}
function cOe(e, t) {
  return hOe(e) || dOe(e, t) || fOe(e, t) || uOe();
}
function uOe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fOe(e, t) {
  if (e) {
    if (typeof e == "string") return qN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return qN(e, t);
  }
}
function qN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function dOe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function hOe(e) {
  if (Array.isArray(e)) return e;
}
function XN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ZN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? XN(Object(n), !0).forEach(function(r) {
      pOe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : XN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function pOe(e, t, n) {
  return t = mOe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mOe(e) {
  var t = gOe(e, "string");
  return Jf(t) == "symbol" ? t : t + "";
}
function gOe(e, t) {
  if (Jf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Jf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var JN = function(t, n, r, i, o) {
  var a = r - i, s;
  return s = "M ".concat(t, ",").concat(n), s += "L ".concat(t + r, ",").concat(n), s += "L ".concat(t + r - a / 2, ",").concat(n + o), s += "L ".concat(t + r - a / 2 - i, ",").concat(n + o), s += "L ".concat(t, ",").concat(n, " Z"), s;
}, yOe = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, vOe = function(t) {
  var n = ZN(ZN({}, yOe), t), r = ut(), i = Me(-1), o = cOe(i, 2), a = o[0], s = o[1];
  Xe(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var S = r.current.getTotalLength();
        S && s(S);
      } catch {
      }
  }, []);
  var l = n.x, c = n.y, f = n.upperWidth, d = n.lowerWidth, p = n.height, m = n.className, y = n.animationEasing, g = n.animationDuration, v = n.animationBegin, x = n.isUpdateAnimationActive;
  if (l !== +l || c !== +c || f !== +f || d !== +d || p !== +p || f === 0 && d === 0 || p === 0)
    return null;
  var w = Ye("recharts-trapezoid", m);
  return x ? /* @__PURE__ */ I.createElement($i, {
    canBegin: a > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: p,
      x: l,
      y: c
    },
    to: {
      upperWidth: f,
      lowerWidth: d,
      height: p,
      x: l,
      y: c
    },
    duration: g,
    animationEasing: y,
    isActive: x
  }, function(S) {
    var A = S.upperWidth, _ = S.lowerWidth, O = S.height, P = S.x, C = S.y;
    return /* @__PURE__ */ I.createElement($i, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: g,
      easing: y
    }, /* @__PURE__ */ I.createElement("path", Nm({}, Ee(n, !0), {
      className: w,
      d: JN(P, C, A, _, O),
      ref: r
    })));
  }) : /* @__PURE__ */ I.createElement("g", null, /* @__PURE__ */ I.createElement("path", Nm({}, Ee(n, !0), {
    className: w,
    d: JN(l, c, f, d, p)
  })));
}, bOe = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Qf(e) {
  "@babel/helpers - typeof";
  return Qf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qf(e);
}
function xOe(e, t) {
  if (e == null) return {};
  var n = wOe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function wOe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function QN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $m(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QN(Object(n), !0).forEach(function(r) {
      _Oe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : QN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _Oe(e, t, n) {
  return t = SOe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function SOe(e) {
  var t = OOe(e, "string");
  return Qf(t) == "symbol" ? t : t + "";
}
function OOe(e, t) {
  if (Qf(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Qf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function AOe(e, t) {
  return $m($m({}, t), e);
}
function TOe(e, t) {
  return e === "symbols";
}
function e$(e) {
  var t = e.shapeType, n = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ I.createElement(CS, n);
    case "trapezoid":
      return /* @__PURE__ */ I.createElement(vOe, n);
    case "sector":
      return /* @__PURE__ */ I.createElement(eW, n);
    case "symbols":
      if (TOe(t))
        return /* @__PURE__ */ I.createElement(U_, n);
      break;
    default:
      return null;
  }
}
function POe(e) {
  return /* @__PURE__ */ rt(e) ? e.props : e;
}
function gW(e) {
  var t = e.option, n = e.shapeType, r = e.propTransformer, i = r === void 0 ? AOe : r, o = e.activeClassName, a = o === void 0 ? "recharts-active-shape" : o, s = e.isActive, l = xOe(e, bOe), c;
  if (/* @__PURE__ */ rt(t))
    c = /* @__PURE__ */ ht(t, $m($m({}, l), POe(t)));
  else if (ze(t))
    c = t(l);
  else if (nOe(t) && !lOe(t)) {
    var f = i(t, l);
    c = /* @__PURE__ */ I.createElement(e$, {
      shapeType: n,
      elementProps: f
    });
  } else {
    var d = l;
    c = /* @__PURE__ */ I.createElement(e$, {
      shapeType: n,
      elementProps: d
    });
  }
  return s ? /* @__PURE__ */ I.createElement(at, {
    className: a
  }, c) : c;
}
function by(e, t) {
  return t != null && "trapezoids" in e.props;
}
function xy(e, t) {
  return t != null && "sectors" in e.props;
}
function ed(e, t) {
  return t != null && "points" in e.props;
}
function COe(e, t) {
  var n, r, i = e.x === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === t.x, o = e.y === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.y) || e.y === t.y;
  return i && o;
}
function EOe(e, t) {
  var n = e.endAngle === t.endAngle, r = e.startAngle === t.startAngle;
  return n && r;
}
function kOe(e, t) {
  var n = e.x === t.x, r = e.y === t.y, i = e.z === t.z;
  return n && r && i;
}
function MOe(e, t) {
  var n;
  return by(e, t) ? n = COe : xy(e, t) ? n = EOe : ed(e, t) && (n = kOe), n;
}
function NOe(e, t) {
  var n;
  return by(e, t) ? n = "trapezoids" : xy(e, t) ? n = "sectors" : ed(e, t) && (n = "points"), n;
}
function $Oe(e, t) {
  if (by(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if (xy(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return ed(e, t) ? t.payload : {};
}
function DOe(e) {
  var t = e.activeTooltipItem, n = e.graphicalItem, r = e.itemData, i = NOe(n, t), o = $Oe(n, t), a = r.filter(function(l, c) {
    var f = zs(o, l), d = n.props[i].filter(function(y) {
      var g = MOe(n, t);
      return g(y, t);
    }), p = n.props[i].indexOf(d[d.length - 1]), m = c === p;
    return f && m;
  }), s = r.indexOf(a[a.length - 1]);
  return s;
}
var dp;
function gc(e) {
  "@babel/helpers - typeof";
  return gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gc(e);
}
function Ll() {
  return Ll = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ll.apply(this, arguments);
}
function t$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t$(Object(n), !0).forEach(function(r) {
      ui(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : t$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function IOe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function n$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, vW(r.key), r);
  }
}
function ROe(e, t, n) {
  return t && n$(e.prototype, t), n && n$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jOe(e, t, n) {
  return t = Dm(t), LOe(e, yW() ? Reflect.construct(t, n || [], Dm(e).constructor) : t.apply(e, n));
}
function LOe(e, t) {
  if (t && (gc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return BOe(e);
}
function BOe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function yW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yW = function() {
    return !!e;
  })();
}
function Dm(e) {
  return Dm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Dm(e);
}
function FOe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sw(e, t);
}
function Sw(e, t) {
  return Sw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Sw(e, t);
}
function ui(e, t, n) {
  return t = vW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vW(e) {
  var t = WOe(e, "string");
  return gc(t) == "symbol" ? t : t + "";
}
function WOe(e, t) {
  if (gc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (gc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var na = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return IOe(this, t), r = jOe(this, t, [n]), ui(r, "pieRef", null), ui(r, "sectorRefs", []), ui(r, "id", Qs("recharts-pie-")), ui(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ze(i) && i();
    }), ui(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ze(i) && i();
    }), r.state = {
      isAnimationFinished: !n.isAnimationActive,
      prevIsAnimationActive: n.isAnimationActive,
      prevAnimationId: n.animationId,
      sectorToFocus: 0
    }, r;
  }
  return FOe(t, e), ROe(t, [{
    key: "isActiveIndex",
    value: function(r) {
      var i = this.props.activeIndex;
      return Array.isArray(i) ? i.indexOf(r) !== -1 : r === i;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var r = this.props.activeIndex;
      return Array.isArray(r) ? r.length !== 0 : r || r === 0;
    }
  }, {
    key: "renderLabels",
    value: function(r) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.label, s = o.labelLine, l = o.dataKey, c = o.valueKey, f = Ee(this.props, !1), d = Ee(a, !1), p = Ee(s, !1), m = a && a.offsetRadius || 20, y = r.map(function(g, v) {
        var x = (g.startAngle + g.endAngle) / 2, w = Bt(g.cx, g.cy, g.outerRadius + m, x), S = Rt(Rt(Rt(Rt({}, f), g), {}, {
          stroke: "none"
        }, d), {}, {
          index: v,
          textAnchor: t.getTextAnchor(w.x, g.cx)
        }, w), A = Rt(Rt(Rt(Rt({}, f), g), {}, {
          fill: "none",
          stroke: g.fill
        }, p), {}, {
          index: v,
          points: [Bt(g.cx, g.cy, g.outerRadius, x), w]
        }), _ = l;
        return Ue(l) && Ue(c) ? _ = "value" : Ue(l) && (_ = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ I.createElement(at, {
          key: "label-".concat(g.startAngle, "-").concat(g.endAngle, "-").concat(g.midAngle, "-").concat(v)
        }, s && t.renderLabelLineItem(s, A, "line"), t.renderLabelItem(a, S, cn(g, _)));
      });
      return /* @__PURE__ */ I.createElement(at, {
        className: "recharts-pie-labels"
      }, y);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.activeShape, s = o.blendStroke, l = o.inactiveShape;
      return r.map(function(c, f) {
        if ((c == null ? void 0 : c.startAngle) === 0 && (c == null ? void 0 : c.endAngle) === 0 && r.length !== 1) return null;
        var d = i.isActiveIndex(f), p = l && i.hasActiveIndex() ? l : null, m = d ? a : p, y = Rt(Rt({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ I.createElement(at, Ll({
          ref: function(v) {
            v && !i.sectorRefs.includes(v) && i.sectorRefs.push(v);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, Fs(i.props, c, f), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c == null ? void 0 : c.startAngle, "-").concat(c == null ? void 0 : c.endAngle, "-").concat(c.midAngle, "-").concat(f)
        }), /* @__PURE__ */ I.createElement(gW, Ll({
          option: m,
          isActive: d,
          shapeType: "sector"
        }, y)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.sectors, a = i.isAnimationActive, s = i.animationBegin, l = i.animationDuration, c = i.animationEasing, f = i.animationId, d = this.state, p = d.prevSectors, m = d.prevIsAnimationActive;
      return /* @__PURE__ */ I.createElement($i, {
        begin: s,
        duration: l,
        isActive: a,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(f, "-").concat(m),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(y) {
        var g = y.t, v = [], x = o && o[0], w = x.startAngle;
        return o.forEach(function(S, A) {
          var _ = p && p[A], O = A > 0 ? zr(S, "paddingAngle", 0) : 0;
          if (_) {
            var P = _n(_.endAngle - _.startAngle, S.endAngle - S.startAngle), C = Rt(Rt({}, S), {}, {
              startAngle: w + O,
              endAngle: w + P(g) + O
            });
            v.push(C), w = C.endAngle;
          } else {
            var k = S.endAngle, D = S.startAngle, $ = _n(0, k - D), N = $(g), R = Rt(Rt({}, S), {}, {
              startAngle: w + O,
              endAngle: w + N + O
            });
            v.push(R), w = R.endAngle;
          }
        }), /* @__PURE__ */ I.createElement(at, null, r.renderSectorsStatically(v));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(r) {
      var i = this;
      r.onkeydown = function(o) {
        if (!o.altKey)
          switch (o.key) {
            case "ArrowLeft": {
              var a = ++i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[a].focus(), i.setState({
                sectorToFocus: a
              });
              break;
            }
            case "ArrowRight": {
              var s = --i.state.sectorToFocus < 0 ? i.sectorRefs.length - 1 : i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[s].focus(), i.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              i.sectorRefs[i.state.sectorToFocus].blur(), i.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var r = this.props, i = r.sectors, o = r.isAnimationActive, a = this.state.prevSectors;
      return o && i && i.length && (!a || !zs(a, i)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(i);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.hide, a = i.sectors, s = i.className, l = i.label, c = i.cx, f = i.cy, d = i.innerRadius, p = i.outerRadius, m = i.isAnimationActive, y = this.state.isAnimationFinished;
      if (o || !a || !a.length || !ve(c) || !ve(f) || !ve(d) || !ve(p))
        return null;
      var g = Ye("recharts-pie", s);
      return /* @__PURE__ */ I.createElement(at, {
        tabIndex: this.props.rootTabIndex,
        className: g,
        ref: function(x) {
          r.pieRef = x;
        }
      }, this.renderSectors(), l && this.renderLabels(a), Sn.renderCallByParent(this.props, null, !1), (!m || y) && Zi.renderCallByParent(this.props, a, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return i.prevIsAnimationActive !== r.isAnimationActive ? {
        prevIsAnimationActive: r.isAnimationActive,
        prevAnimationId: r.animationId,
        curSectors: r.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : r.isAnimationActive && r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curSectors: r.sectors,
        prevSectors: i.curSectors,
        isAnimationFinished: !0
      } : r.sectors !== i.curSectors ? {
        curSectors: r.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(r, i) {
      return r > i ? "start" : r < i ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(r, i, o) {
      if (/* @__PURE__ */ I.isValidElement(r))
        return /* @__PURE__ */ I.cloneElement(r, i);
      if (ze(r))
        return r(i);
      var a = Ye("recharts-pie-label-line", typeof r != "boolean" ? r.className : "");
      return /* @__PURE__ */ I.createElement(Ns, Ll({}, i, {
        key: o,
        type: "linear",
        className: a
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(r, i, o) {
      if (/* @__PURE__ */ I.isValidElement(r))
        return /* @__PURE__ */ I.cloneElement(r, i);
      var a = o;
      if (ze(r) && (a = r(i), /* @__PURE__ */ I.isValidElement(a)))
        return a;
      var s = Ye("recharts-pie-label-text", typeof r != "boolean" && !ze(r) ? r.className : "");
      return /* @__PURE__ */ I.createElement(Ws, Ll({}, i, {
        alignmentBaseline: "middle",
        className: s
      }), a);
    }
  }]);
}(pi);
dp = na;
ui(na, "displayName", "Pie");
ui(na, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Ni.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
ui(na, "parseDeltaAngle", function(e, t) {
  var n = fr(t - e), r = Math.min(Math.abs(t - e), 360);
  return n * r;
});
ui(na, "getRealPieData", function(e) {
  var t = e.data, n = e.children, r = Ee(e, !1), i = Vr(n, tS);
  return t && t.length ? t.map(function(o, a) {
    return Rt(Rt(Rt({
      payload: o
    }, r), o), i && i[a] && i[a].props);
  }) : i && i.length ? i.map(function(o) {
    return Rt(Rt({}, r), o.props);
  }) : [];
});
ui(na, "parseCoordinateOfPie", function(e, t) {
  var n = t.top, r = t.left, i = t.width, o = t.height, a = XF(i, o), s = r + dr(e.cx, i, i / 2), l = n + dr(e.cy, o, o / 2), c = dr(e.innerRadius, a, 0), f = dr(e.outerRadius, a, a * 0.8), d = e.maxRadius || Math.sqrt(i * i + o * o) / 2;
  return {
    cx: s,
    cy: l,
    innerRadius: c,
    outerRadius: f,
    maxRadius: d
  };
});
ui(na, "getComposedData", function(e) {
  var t = e.item, n = e.offset, r = t.type.defaultProps !== void 0 ? Rt(Rt({}, t.type.defaultProps), t.props) : t.props, i = dp.getRealPieData(r);
  if (!i || !i.length)
    return null;
  var o = r.cornerRadius, a = r.startAngle, s = r.endAngle, l = r.paddingAngle, c = r.dataKey, f = r.nameKey, d = r.valueKey, p = r.tooltipType, m = Math.abs(r.minAngle), y = dp.parseCoordinateOfPie(r, n), g = dp.parseDeltaAngle(a, s), v = Math.abs(g), x = c;
  Ue(c) && Ue(d) ? (Mi(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), x = "value") : Ue(c) && (Mi(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), x = d);
  var w = i.filter(function(C) {
    return cn(C, x, 0) !== 0;
  }).length, S = (v >= 360 ? w : w - 1) * l, A = v - w * m - S, _ = i.reduce(function(C, k) {
    var D = cn(k, x, 0);
    return C + (ve(D) ? D : 0);
  }, 0), O;
  if (_ > 0) {
    var P;
    O = i.map(function(C, k) {
      var D = cn(C, x, 0), $ = cn(C, f, k), N = (ve(D) ? D : 0) / _, R;
      k ? R = P.endAngle + fr(g) * l * (D !== 0 ? 1 : 0) : R = a;
      var L = R + fr(g) * ((D !== 0 ? m : 0) + N * A), F = (R + L) / 2, W = (y.innerRadius + y.outerRadius) / 2, z = [{
        name: $,
        value: D,
        payload: C,
        dataKey: x,
        type: p
      }], G = Bt(y.cx, y.cy, W, F);
      return P = Rt(Rt(Rt({
        percent: N,
        cornerRadius: o,
        name: $,
        tooltipPayload: z,
        midAngle: F,
        middleRadius: W,
        tooltipPosition: G
      }, C), y), {}, {
        value: cn(C, x),
        startAngle: R,
        endAngle: L,
        payload: C,
        paddingAngle: fr(g) * l
      }), P;
    });
  }
  return Rt(Rt({}, y), {}, {
    sectors: O,
    data: i
  });
});
var zOe = Math.ceil, VOe = Math.max;
function UOe(e, t, n, r) {
  for (var i = -1, o = VOe(zOe((t - e) / (n || 1)), 0), a = Array(o); o--; )
    a[r ? o : ++i] = e, e += n;
  return a;
}
var HOe = UOe, KOe = jB, r$ = 1 / 0, GOe = 17976931348623157e292;
function YOe(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = KOe(e), e === r$ || e === -r$) {
    var t = e < 0 ? -1 : 1;
    return t * GOe;
  }
  return e === e ? e : 0;
}
var bW = YOe, qOe = HOe, XOe = iy, i0 = bW;
function ZOe(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && XOe(t, n, r) && (n = r = void 0), t = i0(t), n === void 0 ? (n = t, t = 0) : n = i0(n), r = r === void 0 ? t < n ? 1 : -1 : i0(r), qOe(t, n, r, e);
  };
}
var JOe = ZOe, QOe = JOe, eAe = QOe(), tAe = eAe;
const Im = /* @__PURE__ */ kt(tAe);
function td(e) {
  "@babel/helpers - typeof";
  return td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, td(e);
}
function i$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? i$(Object(n), !0).forEach(function(r) {
      xW(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xW(e, t, n) {
  return t = nAe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nAe(e) {
  var t = rAe(e, "string");
  return td(t) == "symbol" ? t : t + "";
}
function rAe(e, t) {
  if (td(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (td(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var iAe = ["Webkit", "Moz", "O", "ms"], oAe = function(t, n) {
  var r = t.replace(/(\w)/, function(o) {
    return o.toUpperCase();
  }), i = iAe.reduce(function(o, a) {
    return o$(o$({}, o), {}, xW({}, a + r, n));
  }, {});
  return i[t] = n, i;
};
function yc(e) {
  "@babel/helpers - typeof";
  return yc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yc(e);
}
function Rm() {
  return Rm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rm.apply(this, arguments);
}
function a$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? a$(Object(n), !0).forEach(function(r) {
      Rr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aAe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function s$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _W(r.key), r);
  }
}
function sAe(e, t, n) {
  return t && s$(e.prototype, t), n && s$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lAe(e, t, n) {
  return t = jm(t), cAe(e, wW() ? Reflect.construct(t, n || [], jm(e).constructor) : t.apply(e, n));
}
function cAe(e, t) {
  if (t && (yc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return uAe(e);
}
function uAe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wW = function() {
    return !!e;
  })();
}
function jm(e) {
  return jm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, jm(e);
}
function fAe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ow(e, t);
}
function Ow(e, t) {
  return Ow = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Ow(e, t);
}
function Rr(e, t, n) {
  return t = _W(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _W(e) {
  var t = dAe(e, "string");
  return yc(t) == "symbol" ? t : t + "";
}
function dAe(e, t) {
  if (yc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (yc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var hAe = function(t) {
  var n = t.data, r = t.startIndex, i = t.endIndex, o = t.x, a = t.width, s = t.travellerWidth;
  if (!n || !n.length)
    return {};
  var l = n.length, c = tf().domain(Im(0, l)).range([o, o + a - s]), f = c.domain().map(function(d) {
    return c(d);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(r),
    endX: c(i),
    scale: c,
    scaleValues: f
  };
}, l$ = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, vc = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return aAe(this, t), r = lAe(this, t, [n]), Rr(r, "handleDrag", function(i) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(i) : r.state.isSlideMoving && r.handleSlideDrag(i);
    }), Rr(r, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && r.handleDrag(i.changedTouches[0]);
    }), Rr(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = r.props, o = i.endIndex, a = i.onDragEnd, s = i.startIndex;
        a == null || a({
          endIndex: o,
          startIndex: s
        });
      }), r.detachDragEndListener();
    }), Rr(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), Rr(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), Rr(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), Rr(r, "handleSlideDragStart", function(i) {
      var o = l$(i) ? i.changedTouches[0] : i;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: o.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return fAe(t, e), sAe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var i = r.startX, o = r.endX, a = this.state.scaleValues, s = this.props, l = s.gap, c = s.data, f = c.length - 1, d = Math.min(i, o), p = Math.max(i, o), m = t.getIndexInRange(a, d), y = t.getIndexInRange(a, p);
      return {
        startIndex: m - m % l,
        endIndex: y === f ? f : y - y % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var i = this.props, o = i.data, a = i.tickFormatter, s = i.dataKey, l = cn(o[r], s, r);
      return ze(a) ? a(l, r) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var i = this.state, o = i.slideMoveStartX, a = i.startX, s = i.endX, l = this.props, c = l.x, f = l.width, d = l.travellerWidth, p = l.startIndex, m = l.endIndex, y = l.onChange, g = r.pageX - o;
      g > 0 ? g = Math.min(g, c + f - d - s, c + f - d - a) : g < 0 && (g = Math.max(g, c - a, c - s));
      var v = this.getIndex({
        startX: a + g,
        endX: s + g
      });
      (v.startIndex !== p || v.endIndex !== m) && y && y(v), this.setState({
        startX: a + g,
        endX: s + g,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, i) {
      var o = l$(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: o.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var i = this.state, o = i.brushMoveStartX, a = i.movingTravellerId, s = i.endX, l = i.startX, c = this.state[a], f = this.props, d = f.x, p = f.width, m = f.travellerWidth, y = f.onChange, g = f.gap, v = f.data, x = {
        startX: this.state.startX,
        endX: this.state.endX
      }, w = r.pageX - o;
      w > 0 ? w = Math.min(w, d + p - m - c) : w < 0 && (w = Math.max(w, d - c)), x[a] = c + w;
      var S = this.getIndex(x), A = S.startIndex, _ = S.endIndex, O = function() {
        var C = v.length - 1;
        return a === "startX" && (s > l ? A % g === 0 : _ % g === 0) || s < l && _ === C || a === "endX" && (s > l ? _ % g === 0 : A % g === 0) || s > l && _ === C;
      };
      this.setState(Rr(Rr({}, a, c + w), "brushMoveStartX", r.pageX), function() {
        y && O() && y(S);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, i) {
      var o = this, a = this.state, s = a.scaleValues, l = a.startX, c = a.endX, f = this.state[i], d = s.indexOf(f);
      if (d !== -1) {
        var p = d + r;
        if (!(p === -1 || p >= s.length)) {
          var m = s[p];
          i === "startX" && m >= c || i === "endX" && m <= l || this.setState(Rr({}, i, m), function() {
            o.props.onChange(o.getIndex({
              startX: o.state.startX,
              endX: o.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.fill, c = r.stroke;
      return /* @__PURE__ */ I.createElement("rect", {
        stroke: c,
        fill: l,
        x: i,
        y: o,
        width: a,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.data, c = r.children, f = r.padding, d = Yt.only(c);
      return d ? /* @__PURE__ */ I.cloneElement(d, {
        x: i,
        y: o,
        width: a,
        height: s,
        margin: f,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, i) {
      var o, a, s = this, l = this.props, c = l.y, f = l.travellerWidth, d = l.height, p = l.traveller, m = l.ariaLabel, y = l.data, g = l.startIndex, v = l.endIndex, x = Math.max(r, this.props.x), w = o0(o0({}, Ee(this.props, !1)), {}, {
        x,
        y: c,
        width: f,
        height: d
      }), S = m || "Min value: ".concat((o = y[g]) === null || o === void 0 ? void 0 : o.name, ", Max value: ").concat((a = y[v]) === null || a === void 0 ? void 0 : a.name);
      return /* @__PURE__ */ I.createElement(at, {
        tabIndex: 0,
        role: "slider",
        "aria-label": S,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(_) {
          ["ArrowLeft", "ArrowRight"].includes(_.key) && (_.preventDefault(), _.stopPropagation(), s.handleTravellerMoveKeyboard(_.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(p, w));
    }
  }, {
    key: "renderSlide",
    value: function(r, i) {
      var o = this.props, a = o.y, s = o.height, l = o.stroke, c = o.travellerWidth, f = Math.min(r, i) + c, d = Math.max(Math.abs(i - r) - c, 0);
      return /* @__PURE__ */ I.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: f,
        y: a,
        width: d,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, i = r.startIndex, o = r.endIndex, a = r.y, s = r.height, l = r.travellerWidth, c = r.stroke, f = this.state, d = f.startX, p = f.endX, m = 5, y = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ I.createElement(at, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ I.createElement(Ws, Rm({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(d, p) - m,
        y: a + s / 2
      }, y), this.getTextOfTick(i)), /* @__PURE__ */ I.createElement(Ws, Rm({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(d, p) + l + m,
        y: a + s / 2
      }, y), this.getTextOfTick(o)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.data, o = r.className, a = r.children, s = r.x, l = r.y, c = r.width, f = r.height, d = r.alwaysShowText, p = this.state, m = p.startX, y = p.endX, g = p.isTextActive, v = p.isSlideMoving, x = p.isTravellerMoving, w = p.isTravellerFocused;
      if (!i || !i.length || !ve(s) || !ve(l) || !ve(c) || !ve(f) || c <= 0 || f <= 0)
        return null;
      var S = Ye("recharts-brush", o), A = I.Children.count(a) === 1, _ = oAe("userSelect", "none");
      return /* @__PURE__ */ I.createElement(at, {
        className: S,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: _
      }, this.renderBackground(), A && this.renderPanorama(), this.renderSlide(m, y), this.renderTravellerLayer(m, "startX"), this.renderTravellerLayer(y, "endX"), (g || v || x || w || d) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var i = r.x, o = r.y, a = r.width, s = r.height, l = r.stroke, c = Math.floor(o + s / 2) - 1;
      return /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement("rect", {
        x: i,
        y: o,
        width: a,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ I.createElement("line", {
        x1: i + 1,
        y1: c,
        x2: i + a - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ I.createElement("line", {
        x1: i + 1,
        y1: c + 2,
        x2: i + a - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, i) {
      var o;
      return /* @__PURE__ */ I.isValidElement(r) ? o = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? o = r(i) : o = t.renderDefaultTraveller(i), o;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var o = r.data, a = r.width, s = r.x, l = r.travellerWidth, c = r.updateId, f = r.startIndex, d = r.endIndex;
      if (o !== i.prevData || c !== i.prevUpdateId)
        return o0({
          prevData: o,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: a
        }, o && o.length ? hAe({
          data: o,
          width: a,
          x: s,
          travellerWidth: l,
          startIndex: f,
          endIndex: d
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (a !== i.prevWidth || s !== i.prevX || l !== i.prevTravellerWidth)) {
        i.scale.range([s, s + a - l]);
        var p = i.scale.domain().map(function(m) {
          return i.scale(m);
        });
        return {
          prevData: o,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: a,
          startX: i.scale(r.startIndex),
          endX: i.scale(r.endIndex),
          scaleValues: p
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, i) {
      for (var o = r.length, a = 0, s = o - 1; s - a > 1; ) {
        var l = Math.floor((a + s) / 2);
        r[l] > i ? s = l : a = l;
      }
      return i >= r[s] ? s : a;
    }
  }]);
}(pi);
Rr(vc, "displayName", "Brush");
Rr(vc, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var pAe = Z_;
function mAe(e, t) {
  var n;
  return pAe(e, function(r, i, o) {
    return n = t(r, i, o), !n;
  }), !!n;
}
var gAe = mAe, yAe = uB, vAe = ao, bAe = gAe, xAe = Tr, wAe = iy;
function _Ae(e, t, n) {
  var r = xAe(e) ? yAe : bAe;
  return n && wAe(e, t, n) && (t = void 0), r(e, vAe(t));
}
var SAe = _Ae;
const OAe = /* @__PURE__ */ kt(SAe);
var Ji = function(t, n) {
  var r = t.alwaysShow, i = t.ifOverflow;
  return r && (i = "extendDomain"), i === n;
}, c$ = NB;
function AAe(e, t, n) {
  t == "__proto__" && c$ ? c$(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var TAe = AAe, PAe = TAe, CAe = kB, EAe = ao;
function kAe(e, t) {
  var n = {};
  return t = EAe(t), CAe(e, function(r, i, o) {
    PAe(n, i, t(r, i, o));
  }), n;
}
var MAe = kAe;
const NAe = /* @__PURE__ */ kt(MAe);
function $Ae(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (!t(e[n], n, e))
      return !1;
  return !0;
}
var DAe = $Ae, IAe = Z_;
function RAe(e, t) {
  var n = !0;
  return IAe(e, function(r, i, o) {
    return n = !!t(r, i, o), n;
  }), n;
}
var jAe = RAe, LAe = DAe, BAe = jAe, FAe = ao, WAe = Tr, zAe = iy;
function VAe(e, t, n) {
  var r = WAe(e) ? LAe : BAe;
  return n && zAe(e, t, n) && (t = void 0), r(e, FAe(t));
}
var UAe = VAe;
const SW = /* @__PURE__ */ kt(UAe);
var HAe = ["x", "y"];
function bc(e) {
  "@babel/helpers - typeof";
  return bc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bc(e);
}
function Aw() {
  return Aw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Aw.apply(this, arguments);
}
function u$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Iu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? u$(Object(n), !0).forEach(function(r) {
      KAe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function KAe(e, t, n) {
  return t = GAe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function GAe(e) {
  var t = YAe(e, "string");
  return bc(t) == "symbol" ? t : t + "";
}
function YAe(e, t) {
  if (bc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (bc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qAe(e, t) {
  if (e == null) return {};
  var n = XAe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function XAe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function ZAe(e, t) {
  var n = e.x, r = e.y, i = qAe(e, HAe), o = "".concat(n), a = parseInt(o, 10), s = "".concat(r), l = parseInt(s, 10), c = "".concat(t.height || i.height), f = parseInt(c, 10), d = "".concat(t.width || i.width), p = parseInt(d, 10);
  return Iu(Iu(Iu(Iu(Iu({}, t), i), a ? {
    x: a
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: f,
    width: p,
    name: t.name,
    radius: t.radius
  });
}
function f$(e) {
  return /* @__PURE__ */ I.createElement(gW, Aw({
    shapeType: "rectangle",
    propTransformer: ZAe,
    activeClassName: "recharts-active-bar"
  }, e));
}
var JAe = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof t == "number") return t;
    var o = typeof r == "number";
    return o ? t(r, i) : (o || (process.env.NODE_ENV !== "production" ? Sr(!1, "minPointSize callback function received a value with type of ".concat(bc(r), ". Currently only numbers are supported.")) : Sr()), n);
  };
}, QAe = ["value", "background"], OW;
function xc(e) {
  "@babel/helpers - typeof";
  return xc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xc(e);
}
function eTe(e, t) {
  if (e == null) return {};
  var n = tTe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function tTe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Lm() {
  return Lm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lm.apply(this, arguments);
}
function d$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? d$(Object(n), !0).forEach(function(r) {
      Ta(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function h$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, TW(r.key), r);
  }
}
function rTe(e, t, n) {
  return t && h$(e.prototype, t), n && h$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function iTe(e, t, n) {
  return t = Bm(t), oTe(e, AW() ? Reflect.construct(t, n || [], Bm(e).constructor) : t.apply(e, n));
}
function oTe(e, t) {
  if (t && (xc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return aTe(e);
}
function aTe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (AW = function() {
    return !!e;
  })();
}
function Bm(e) {
  return Bm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bm(e);
}
function sTe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tw(e, t);
}
function Tw(e, t) {
  return Tw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Tw(e, t);
}
function Ta(e, t, n) {
  return t = TW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function TW(e) {
  var t = lTe(e, "string");
  return xc(t) == "symbol" ? t : t + "";
}
function lTe(e, t) {
  if (xc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (xc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nl = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    nTe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = iTe(this, t, [].concat(i)), Ta(n, "state", {
      isAnimationFinished: !1
    }), Ta(n, "id", Qs("recharts-bar-")), Ta(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), a && a();
    }), Ta(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), a && a();
    }), n;
  }
  return sTe(t, e), rTe(t, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.shape, s = o.dataKey, l = o.activeIndex, c = o.activeBar, f = Ee(this.props, !1);
      return r && r.map(function(d, p) {
        var m = p === l, y = m ? c : a, g = dn(dn(dn({}, f), d), {}, {
          isActive: m,
          option: y,
          index: p,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ I.createElement(at, Lm({
          className: "recharts-bar-rectangle"
        }, Fs(i.props, d, p), {
          key: "rectangle-".concat(d == null ? void 0 : d.x, "-").concat(d == null ? void 0 : d.y, "-").concat(d == null ? void 0 : d.value)
        }), /* @__PURE__ */ I.createElement(f$, g));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.layout, s = i.isAnimationActive, l = i.animationBegin, c = i.animationDuration, f = i.animationEasing, d = i.animationId, p = this.state.prevData;
      return /* @__PURE__ */ I.createElement($i, {
        begin: l,
        duration: c,
        isActive: s,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(m) {
        var y = m.t, g = o.map(function(v, x) {
          var w = p && p[x];
          if (w) {
            var S = _n(w.x, v.x), A = _n(w.y, v.y), _ = _n(w.width, v.width), O = _n(w.height, v.height);
            return dn(dn({}, v), {}, {
              x: S(y),
              y: A(y),
              width: _(y),
              height: O(y)
            });
          }
          if (a === "horizontal") {
            var P = _n(0, v.height), C = P(y);
            return dn(dn({}, v), {}, {
              y: v.y + v.height - C,
              height: C
            });
          }
          var k = _n(0, v.width), D = k(y);
          return dn(dn({}, v), {}, {
            width: D
          });
        });
        return /* @__PURE__ */ I.createElement(at, null, r.renderRectanglesStatically(g));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, i = r.data, o = r.isAnimationActive, a = this.state.prevData;
      return o && i && i.length && (!a || !zs(a, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.dataKey, s = i.activeIndex, l = Ee(this.props.background, !1);
      return o.map(function(c, f) {
        c.value;
        var d = c.background, p = eTe(c, QAe);
        if (!d)
          return null;
        var m = dn(dn(dn(dn(dn({}, p), {}, {
          fill: "#eee"
        }, d), l), Fs(r.props, c, f)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: a,
          index: f,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ I.createElement(f$, Lm({
          key: "background-bar-".concat(f),
          option: r.props.background,
          isActive: f === s
        }, m));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.data, s = o.xAxis, l = o.yAxis, c = o.layout, f = o.children, d = Vr(f, $d);
      if (!d)
        return null;
      var p = c === "vertical" ? a[0].height / 2 : a[0].width / 2, m = function(v, x) {
        var w = Array.isArray(v.value) ? v.value[1] : v.value;
        return {
          x: v.x,
          y: v.y,
          value: w,
          errorVal: cn(v, x)
        };
      }, y = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ I.createElement(at, y, d.map(function(g) {
        return /* @__PURE__ */ I.cloneElement(g, {
          key: "error-bar-".concat(i, "-").concat(g.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: c,
          offset: p,
          dataPointFormatter: m
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, o = r.data, a = r.className, s = r.xAxis, l = r.yAxis, c = r.left, f = r.top, d = r.width, p = r.height, m = r.isAnimationActive, y = r.background, g = r.id;
      if (i || !o || !o.length)
        return null;
      var v = this.state.isAnimationFinished, x = Ye("recharts-bar", a), w = s && s.allowDataOverflow, S = l && l.allowDataOverflow, A = w || S, _ = Ue(g) ? this.id : g;
      return /* @__PURE__ */ I.createElement(at, {
        className: x
      }, w || S ? /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: w ? c : c - d / 2,
        y: S ? f : f - p / 2,
        width: w ? d : d * 2,
        height: S ? p : p * 2
      }))) : null, /* @__PURE__ */ I.createElement(at, {
        className: "recharts-bar-rectangles",
        clipPath: A ? "url(#clipPath-".concat(_, ")") : null
      }, y ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(A, _), (!m || v) && Zi.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: i.curData
      } : r.data !== i.curData ? {
        curData: r.data
      } : null;
    }
  }]);
}(pi);
OW = nl;
Ta(nl, "displayName", "Bar");
Ta(nl, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Ni.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Ta(nl, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.barPosition, i = e.bandSize, o = e.xAxis, a = e.yAxis, s = e.xAxisTicks, l = e.yAxisTicks, c = e.stackedData, f = e.dataStartIndex, d = e.displayedData, p = e.offset, m = Gxe(r, n);
  if (!m)
    return null;
  var y = t.layout, g = n.type.defaultProps, v = g !== void 0 ? dn(dn({}, g), n.props) : n.props, x = v.dataKey, w = v.children, S = v.minPointSize, A = y === "horizontal" ? a : o, _ = c ? A.scale.domain() : null, O = ewe({
    numericAxis: A
  }), P = Vr(w, tS), C = d.map(function(k, D) {
    var $, N, R, L, F, W;
    c ? $ = Yxe(c[f + D], _) : ($ = cn(k, x), Array.isArray($) || ($ = [O, $]));
    var z = JAe(S, OW.defaultProps.minPointSize)($[1], D);
    if (y === "horizontal") {
      var G, U = [a.scale($[0]), a.scale($[1])], V = U[0], Y = U[1];
      N = GM({
        axis: o,
        ticks: s,
        bandSize: i,
        offset: m.offset,
        entry: k,
        index: D
      }), R = (G = Y ?? V) !== null && G !== void 0 ? G : void 0, L = m.size;
      var ee = V - Y;
      if (F = Number.isNaN(ee) ? 0 : ee, W = {
        x: N,
        y: a.y,
        width: L,
        height: a.height
      }, Math.abs(z) > 0 && Math.abs(F) < Math.abs(z)) {
        var ie = fr(F || z) * (Math.abs(z) - Math.abs(F));
        R -= ie, F += ie;
      }
    } else {
      var re = [o.scale($[0]), o.scale($[1])], le = re[0], ae = re[1];
      if (N = le, R = GM({
        axis: a,
        ticks: l,
        bandSize: i,
        offset: m.offset,
        entry: k,
        index: D
      }), L = ae - le, F = m.size, W = {
        x: o.x,
        y: R,
        width: o.width,
        height: F
      }, Math.abs(z) > 0 && Math.abs(L) < Math.abs(z)) {
        var ue = fr(L || z) * (Math.abs(z) - Math.abs(L));
        L += ue;
      }
    }
    return dn(dn(dn({}, k), {}, {
      x: N,
      y: R,
      width: L,
      height: F,
      value: c ? $ : $[1],
      payload: k,
      background: W
    }, P && P[D] && P[D].props), {}, {
      tooltipPayload: [YF(n, k)],
      tooltipPosition: {
        x: N + L / 2,
        y: R + F / 2
      }
    });
  });
  return dn({
    data: C,
    layout: y
  }, p);
});
function nd(e) {
  "@babel/helpers - typeof";
  return nd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nd(e);
}
function cTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function p$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, PW(r.key), r);
  }
}
function uTe(e, t, n) {
  return t && p$(e.prototype, t), n && p$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function m$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Oi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m$(Object(n), !0).forEach(function(r) {
      wy(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wy(e, t, n) {
  return t = PW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PW(e) {
  var t = fTe(e, "string");
  return nd(t) == "symbol" ? t : t + "";
}
function fTe(e, t) {
  if (nd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (nd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ES = function(t, n, r, i, o) {
  var a = t.width, s = t.height, l = t.layout, c = t.children, f = Object.keys(n), d = {
    left: r.left,
    leftMirror: r.left,
    right: a - r.right,
    rightMirror: a - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: s - r.bottom,
    bottomMirror: s - r.bottom
  }, p = !!jr(c, nl);
  return f.reduce(function(m, y) {
    var g = n[y], v = g.orientation, x = g.domain, w = g.padding, S = w === void 0 ? {} : w, A = g.mirror, _ = g.reversed, O = "".concat(v).concat(A ? "Mirror" : ""), P, C, k, D, $;
    if (g.type === "number" && (g.padding === "gap" || g.padding === "no-gap")) {
      var N = x[1] - x[0], R = 1 / 0, L = g.categoricalDomain.sort();
      if (L.forEach(function(re, le) {
        le > 0 && (R = Math.min((re || 0) - (L[le - 1] || 0), R));
      }), Number.isFinite(R)) {
        var F = R / N, W = g.layout === "vertical" ? r.height : r.width;
        if (g.padding === "gap" && (P = F * W / 2), g.padding === "no-gap") {
          var z = dr(t.barCategoryGap, F * W), G = F * W / 2;
          P = G - z - (G - z) / W * z;
        }
      }
    }
    i === "xAxis" ? C = [r.left + (S.left || 0) + (P || 0), r.left + r.width - (S.right || 0) - (P || 0)] : i === "yAxis" ? C = l === "horizontal" ? [r.top + r.height - (S.bottom || 0), r.top + (S.top || 0)] : [r.top + (S.top || 0) + (P || 0), r.top + r.height - (S.bottom || 0) - (P || 0)] : C = g.range, _ && (C = [C[1], C[0]]);
    var U = UF(g, o, p), V = U.scale, Y = U.realScaleType;
    V.domain(x).range(C), HF(V);
    var ee = KF(V, Oi(Oi({}, g), {}, {
      realScaleType: Y
    }));
    i === "xAxis" ? ($ = v === "top" && !A || v === "bottom" && A, k = r.left, D = d[O] - $ * g.height) : i === "yAxis" && ($ = v === "left" && !A || v === "right" && A, k = d[O] - $ * g.width, D = r.top);
    var ie = Oi(Oi(Oi({}, g), ee), {}, {
      realScaleType: Y,
      x: k,
      y: D,
      scale: V,
      width: i === "xAxis" ? r.width : g.width,
      height: i === "yAxis" ? r.height : g.height
    });
    return ie.bandSize = _m(ie, ee), !g.hide && i === "xAxis" ? d[O] += ($ ? -1 : 1) * ie.height : g.hide || (d[O] += ($ ? -1 : 1) * ie.width), Oi(Oi({}, m), {}, wy({}, y, ie));
  }, {});
}, CW = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return {
    x: Math.min(r, o),
    y: Math.min(i, a),
    width: Math.abs(o - r),
    height: Math.abs(a - i)
  };
}, dTe = function(t) {
  var n = t.x1, r = t.y1, i = t.x2, o = t.y2;
  return CW({
    x: n,
    y: r
  }, {
    x: i,
    y: o
  });
}, EW = /* @__PURE__ */ function() {
  function e(t) {
    cTe(this, e), this.scale = t;
  }
  return uTe(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.bandAware, o = r.position;
      if (n !== void 0) {
        if (o)
          switch (o) {
            case "start":
              return this.scale(n);
            case "middle": {
              var a = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(n) + a;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(n) + s;
            }
            default:
              return this.scale(n);
          }
        if (i) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(n) + l;
        }
        return this.scale(n);
      }
    }
  }, {
    key: "isInRange",
    value: function(n) {
      var r = this.range(), i = r[0], o = r[r.length - 1];
      return i <= o ? n >= i && n <= o : n >= o && n <= i;
    }
  }], [{
    key: "create",
    value: function(n) {
      return new e(n);
    }
  }]);
}();
wy(EW, "EPS", 1e-4);
var kS = function(t) {
  var n = Object.keys(t).reduce(function(r, i) {
    return Oi(Oi({}, r), {}, wy({}, i, EW.create(t[i])));
  }, {});
  return Oi(Oi({}, n), {}, {
    apply: function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.bandAware, s = o.position;
      return NAe(i, function(l, c) {
        return n[c].apply(l, {
          bandAware: a,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return SW(i, function(o, a) {
        return n[a].isInRange(o);
      });
    }
  });
};
function hTe(e) {
  return (e % 180 + 180) % 180;
}
var pTe = function(t) {
  var n = t.width, r = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = hTe(i), a = o * Math.PI / 180, s = Math.atan(r / n), l = a > s && a < Math.PI - s ? r / Math.sin(a) : n / Math.cos(a);
  return Math.abs(l);
}, mTe = ao, gTe = Cd, yTe = ny;
function vTe(e) {
  return function(t, n, r) {
    var i = Object(t);
    if (!gTe(t)) {
      var o = mTe(n);
      t = yTe(t), n = function(s) {
        return o(i[s], s, i);
      };
    }
    var a = e(t, n, r);
    return a > -1 ? i[o ? t[a] : a] : void 0;
  };
}
var bTe = vTe, xTe = bW;
function wTe(e) {
  var t = xTe(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var _Te = wTe, STe = OB, OTe = ao, ATe = _Te, TTe = Math.max;
function PTe(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : ATe(n);
  return i < 0 && (i = TTe(r + i, 0)), STe(e, OTe(t), i);
}
var CTe = PTe, ETe = bTe, kTe = CTe, MTe = ETe(kTe), NTe = MTe;
const $Te = /* @__PURE__ */ kt(NTe);
var DTe = Doe(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function Fm(e) {
  "@babel/helpers - typeof";
  return Fm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fm(e);
}
var MS = /* @__PURE__ */ dt(void 0), NS = /* @__PURE__ */ dt(void 0), kW = /* @__PURE__ */ dt(void 0), MW = /* @__PURE__ */ dt({}), NW = /* @__PURE__ */ dt(void 0), $W = /* @__PURE__ */ dt(0), DW = /* @__PURE__ */ dt(0), g$ = function(t) {
  var n = t.state, r = n.xAxisMap, i = n.yAxisMap, o = n.offset, a = t.clipPathId, s = t.children, l = t.width, c = t.height, f = DTe(o);
  return /* @__PURE__ */ I.createElement(MS.Provider, {
    value: r
  }, /* @__PURE__ */ I.createElement(NS.Provider, {
    value: i
  }, /* @__PURE__ */ I.createElement(MW.Provider, {
    value: o
  }, /* @__PURE__ */ I.createElement(kW.Provider, {
    value: f
  }, /* @__PURE__ */ I.createElement(NW.Provider, {
    value: a
  }, /* @__PURE__ */ I.createElement($W.Provider, {
    value: c
  }, /* @__PURE__ */ I.createElement(DW.Provider, {
    value: l
  }, s)))))));
}, ITe = function() {
  return Ve(NW);
};
function IW(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var RW = function(t) {
  var n = Ve(MS);
  n == null && (process.env.NODE_ENV !== "production" ? Sr(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Sr());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? Sr(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Fm(t), "]. ").concat(IW(n))) : Sr()), r;
}, RTe = function() {
  var t = Ve(MS);
  return _a(t);
}, jTe = function() {
  var t = Ve(NS), n = $Te(t, function(r) {
    return SW(r.domain, Number.isFinite);
  });
  return n || _a(t);
}, jW = function(t) {
  var n = Ve(NS);
  n == null && (process.env.NODE_ENV !== "production" ? Sr(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Sr());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? Sr(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Fm(t), "]. ").concat(IW(n))) : Sr()), r;
}, LTe = function() {
  var t = Ve(kW);
  return t;
}, BTe = function() {
  return Ve(MW);
}, $S = function() {
  return Ve(DW);
}, DS = function() {
  return Ve($W);
};
function wc(e) {
  "@babel/helpers - typeof";
  return wc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wc(e);
}
function FTe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function WTe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, BW(r.key), r);
  }
}
function zTe(e, t, n) {
  return t && WTe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function VTe(e, t, n) {
  return t = Wm(t), UTe(e, LW() ? Reflect.construct(t, n || [], Wm(e).constructor) : t.apply(e, n));
}
function UTe(e, t) {
  if (t && (wc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return HTe(e);
}
function HTe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function LW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (LW = function() {
    return !!e;
  })();
}
function Wm(e) {
  return Wm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Wm(e);
}
function KTe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pw(e, t);
}
function Pw(e, t) {
  return Pw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Pw(e, t);
}
function y$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function v$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y$(Object(n), !0).forEach(function(r) {
      IS(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function IS(e, t, n) {
  return t = BW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function BW(e) {
  var t = GTe(e, "string");
  return wc(t) == "symbol" ? t : t + "";
}
function GTe(e, t) {
  if (wc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (wc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function YTe(e, t) {
  return JTe(e) || ZTe(e, t) || XTe(e, t) || qTe();
}
function qTe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XTe(e, t) {
  if (e) {
    if (typeof e == "string") return b$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return b$(e, t);
  }
}
function b$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ZTe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function JTe(e) {
  if (Array.isArray(e)) return e;
}
function Cw() {
  return Cw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cw.apply(this, arguments);
}
var QTe = function(t, n) {
  var r;
  return /* @__PURE__ */ I.isValidElement(t) ? r = /* @__PURE__ */ I.cloneElement(t, n) : ze(t) ? r = t(n) : r = /* @__PURE__ */ I.createElement("line", Cw({}, n, {
    className: "recharts-reference-line-line"
  })), r;
}, ePe = function(t, n, r, i, o, a, s, l, c) {
  var f = o.x, d = o.y, p = o.width, m = o.height;
  if (r) {
    var y = c.y, g = t.y.apply(y, {
      position: a
    });
    if (Ji(c, "discard") && !t.y.isInRange(g))
      return null;
    var v = [{
      x: f + p,
      y: g
    }, {
      x: f,
      y: g
    }];
    return l === "left" ? v.reverse() : v;
  }
  if (n) {
    var x = c.x, w = t.x.apply(x, {
      position: a
    });
    if (Ji(c, "discard") && !t.x.isInRange(w))
      return null;
    var S = [{
      x: w,
      y: d + m
    }, {
      x: w,
      y: d
    }];
    return s === "top" ? S.reverse() : S;
  }
  if (i) {
    var A = c.segment, _ = A.map(function(O) {
      return t.apply(O, {
        position: a
      });
    });
    return Ji(c, "discard") && OAe(_, function(O) {
      return !t.isInRange(O);
    }) ? null : _;
  }
  return null;
};
function tPe(e) {
  var t = e.x, n = e.y, r = e.segment, i = e.xAxisId, o = e.yAxisId, a = e.shape, s = e.className, l = e.alwaysShow, c = ITe(), f = RW(i), d = jW(o), p = LTe();
  if (!c || !p)
    return null;
  Mi(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var m = kS({
    x: f.scale,
    y: d.scale
  }), y = On(t), g = On(n), v = r && r.length === 2, x = ePe(m, y, g, v, p, e.position, f.orientation, d.orientation, e);
  if (!x)
    return null;
  var w = YTe(x, 2), S = w[0], A = S.x, _ = S.y, O = w[1], P = O.x, C = O.y, k = Ji(e, "hidden") ? "url(#".concat(c, ")") : void 0, D = v$(v$({
    clipPath: k
  }, Ee(e, !0)), {}, {
    x1: A,
    y1: _,
    x2: P,
    y2: C
  });
  return /* @__PURE__ */ I.createElement(at, {
    className: Ye("recharts-reference-line", s)
  }, QTe(a, D), Sn.renderCallByParent(e, dTe({
    x1: A,
    y1: _,
    x2: P,
    y2: C
  })));
}
var RS = /* @__PURE__ */ function(e) {
  function t() {
    return FTe(this, t), VTe(this, t, arguments);
  }
  return KTe(t, e), zTe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ I.createElement(tPe, this.props);
    }
  }]);
}(I.Component);
IS(RS, "displayName", "ReferenceLine");
IS(RS, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Ew() {
  return Ew = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ew.apply(this, arguments);
}
function _c(e) {
  "@babel/helpers - typeof";
  return _c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _c(e);
}
function x$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function w$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? x$(Object(n), !0).forEach(function(r) {
      _y(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nPe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function rPe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, WW(r.key), r);
  }
}
function iPe(e, t, n) {
  return t && rPe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oPe(e, t, n) {
  return t = zm(t), aPe(e, FW() ? Reflect.construct(t, n || [], zm(e).constructor) : t.apply(e, n));
}
function aPe(e, t) {
  if (t && (_c(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return sPe(e);
}
function sPe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (FW = function() {
    return !!e;
  })();
}
function zm(e) {
  return zm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, zm(e);
}
function lPe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && kw(e, t);
}
function kw(e, t) {
  return kw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, kw(e, t);
}
function _y(e, t, n) {
  return t = WW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function WW(e) {
  var t = cPe(e, "string");
  return _c(t) == "symbol" ? t : t + "";
}
function cPe(e, t) {
  if (_c(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (_c(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var uPe = function(t) {
  var n = t.x, r = t.y, i = t.xAxis, o = t.yAxis, a = kS({
    x: i.scale,
    y: o.scale
  }), s = a.apply({
    x: n,
    y: r
  }, {
    bandAware: !0
  });
  return Ji(t, "discard") && !a.isInRange(s) ? null : s;
}, Sy = /* @__PURE__ */ function(e) {
  function t() {
    return nPe(this, t), oPe(this, t, arguments);
  }
  return lPe(t, e), iPe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.r, s = r.alwaysShow, l = r.clipPathId, c = On(i), f = On(o);
      if (Mi(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !f)
        return null;
      var d = uPe(this.props);
      if (!d)
        return null;
      var p = d.x, m = d.y, y = this.props, g = y.shape, v = y.className, x = Ji(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, w = w$(w$({
        clipPath: x
      }, Ee(this.props, !0)), {}, {
        cx: p,
        cy: m
      });
      return /* @__PURE__ */ I.createElement(at, {
        className: Ye("recharts-reference-dot", v)
      }, t.renderDot(g, w), Sn.renderCallByParent(this.props, {
        x: p - a,
        y: m - a,
        width: 2 * a,
        height: 2 * a
      }));
    }
  }]);
}(I.Component);
_y(Sy, "displayName", "ReferenceDot");
_y(Sy, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
_y(Sy, "renderDot", function(e, t) {
  var n;
  return /* @__PURE__ */ I.isValidElement(e) ? n = /* @__PURE__ */ I.cloneElement(e, t) : ze(e) ? n = e(t) : n = /* @__PURE__ */ I.createElement(Dd, Ew({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), n;
});
function Mw() {
  return Mw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mw.apply(this, arguments);
}
function Sc(e) {
  "@babel/helpers - typeof";
  return Sc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sc(e);
}
function _$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function S$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _$(Object(n), !0).forEach(function(r) {
      Oy(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function fPe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dPe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, VW(r.key), r);
  }
}
function hPe(e, t, n) {
  return t && dPe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pPe(e, t, n) {
  return t = Vm(t), mPe(e, zW() ? Reflect.construct(t, n || [], Vm(e).constructor) : t.apply(e, n));
}
function mPe(e, t) {
  if (t && (Sc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gPe(e);
}
function gPe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zW = function() {
    return !!e;
  })();
}
function Vm(e) {
  return Vm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Vm(e);
}
function yPe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Nw(e, t);
}
function Nw(e, t) {
  return Nw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Nw(e, t);
}
function Oy(e, t, n) {
  return t = VW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VW(e) {
  var t = vPe(e, "string");
  return Sc(t) == "symbol" ? t : t + "";
}
function vPe(e, t) {
  if (Sc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Sc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bPe = function(t, n, r, i, o) {
  var a = o.x1, s = o.x2, l = o.y1, c = o.y2, f = o.xAxis, d = o.yAxis;
  if (!f || !d) return null;
  var p = kS({
    x: f.scale,
    y: d.scale
  }), m = {
    x: t ? p.x.apply(a, {
      position: "start"
    }) : p.x.rangeMin,
    y: r ? p.y.apply(l, {
      position: "start"
    }) : p.y.rangeMin
  }, y = {
    x: n ? p.x.apply(s, {
      position: "end"
    }) : p.x.rangeMax,
    y: i ? p.y.apply(c, {
      position: "end"
    }) : p.y.rangeMax
  };
  return Ji(o, "discard") && (!p.isInRange(m) || !p.isInRange(y)) ? null : CW(m, y);
}, Ay = /* @__PURE__ */ function(e) {
  function t() {
    return fPe(this, t), pPe(this, t, arguments);
  }
  return yPe(t, e), hPe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x1, o = r.x2, a = r.y1, s = r.y2, l = r.className, c = r.alwaysShow, f = r.clipPathId;
      Mi(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var d = On(i), p = On(o), m = On(a), y = On(s), g = this.props.shape;
      if (!d && !p && !m && !y && !g)
        return null;
      var v = bPe(d, p, m, y, this.props);
      if (!v && !g)
        return null;
      var x = Ji(this.props, "hidden") ? "url(#".concat(f, ")") : void 0;
      return /* @__PURE__ */ I.createElement(at, {
        className: Ye("recharts-reference-area", l)
      }, t.renderRect(g, S$(S$({
        clipPath: x
      }, Ee(this.props, !0)), v)), Sn.renderCallByParent(this.props, v));
    }
  }]);
}(I.Component);
Oy(Ay, "displayName", "ReferenceArea");
Oy(Ay, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
Oy(Ay, "renderRect", function(e, t) {
  var n;
  return /* @__PURE__ */ I.isValidElement(e) ? n = /* @__PURE__ */ I.cloneElement(e, t) : ze(e) ? n = e(t) : n = /* @__PURE__ */ I.createElement(CS, Mw({}, t, {
    className: "recharts-reference-area-rect"
  })), n;
});
function UW(e, t, n) {
  if (t < 1)
    return [];
  if (t === 1 && n === void 0)
    return e;
  for (var r = [], i = 0; i < e.length; i += t)
    r.push(e[i]);
  return r;
}
function xPe(e, t, n) {
  var r = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return pTe(r, n);
}
function wPe(e, t, n) {
  var r = n === "width", i = e.x, o = e.y, a = e.width, s = e.height;
  return t === 1 ? {
    start: r ? i : o,
    end: r ? i + a : o + s
  } : {
    start: r ? i + a : o + s,
    end: r ? i : o
  };
}
function Um(e, t, n, r, i) {
  if (e * t < e * r || e * t > e * i)
    return !1;
  var o = n();
  return e * (t - e * o / 2 - r) >= 0 && e * (t + e * o / 2 - i) <= 0;
}
function _Pe(e, t) {
  return UW(e, t + 1);
}
function SPe(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = t.start, s = t.end, l = 0, c = 1, f = a, d = function() {
    var y = r == null ? void 0 : r[l];
    if (y === void 0)
      return {
        v: UW(r, c)
      };
    var g = l, v, x = function() {
      return v === void 0 && (v = n(y, g)), v;
    }, w = y.coordinate, S = l === 0 || Um(e, w, x, f, s);
    S || (l = 0, f = a, c += 1), S && (f = w + e * (x() / 2 + i), l += c);
  }, p; c <= o.length; )
    if (p = d(), p) return p.v;
  return [];
}
function rd(e) {
  "@babel/helpers - typeof";
  return rd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rd(e);
}
function O$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O$(Object(n), !0).forEach(function(r) {
      OPe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : O$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function OPe(e, t, n) {
  return t = APe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function APe(e) {
  var t = TPe(e, "string");
  return rd(t) == "symbol" ? t : t + "";
}
function TPe(e, t) {
  if (rd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (rd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function PPe(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = o.length, s = t.start, l = t.end, c = function(p) {
    var m = o[p], y, g = function() {
      return y === void 0 && (y = n(m, p)), y;
    };
    if (p === a - 1) {
      var v = e * (m.coordinate + e * g() / 2 - l);
      o[p] = m = tr(tr({}, m), {}, {
        tickCoord: v > 0 ? m.coordinate - v * e : m.coordinate
      });
    } else
      o[p] = m = tr(tr({}, m), {}, {
        tickCoord: m.coordinate
      });
    var x = Um(e, m.tickCoord, g, s, l);
    x && (l = m.tickCoord - e * (g() / 2 + i), o[p] = tr(tr({}, m), {}, {
      isShow: !0
    }));
  }, f = a - 1; f >= 0; f--)
    c(f);
  return o;
}
function CPe(e, t, n, r, i, o) {
  var a = (r || []).slice(), s = a.length, l = t.start, c = t.end;
  if (o) {
    var f = r[s - 1], d = n(f, s - 1), p = e * (f.coordinate + e * d / 2 - c);
    a[s - 1] = f = tr(tr({}, f), {}, {
      tickCoord: p > 0 ? f.coordinate - p * e : f.coordinate
    });
    var m = Um(e, f.tickCoord, function() {
      return d;
    }, l, c);
    m && (c = f.tickCoord - e * (d / 2 + i), a[s - 1] = tr(tr({}, f), {}, {
      isShow: !0
    }));
  }
  for (var y = o ? s - 1 : s, g = function(w) {
    var S = a[w], A, _ = function() {
      return A === void 0 && (A = n(S, w)), A;
    };
    if (w === 0) {
      var O = e * (S.coordinate - e * _() / 2 - l);
      a[w] = S = tr(tr({}, S), {}, {
        tickCoord: O < 0 ? S.coordinate - O * e : S.coordinate
      });
    } else
      a[w] = S = tr(tr({}, S), {}, {
        tickCoord: S.coordinate
      });
    var P = Um(e, S.tickCoord, _, l, c);
    P && (l = S.tickCoord + e * (_() / 2 + i), a[w] = tr(tr({}, S), {}, {
      isShow: !0
    }));
  }, v = 0; v < y; v++)
    g(v);
  return a;
}
function jS(e, t, n) {
  var r = e.tick, i = e.ticks, o = e.viewBox, a = e.minTickGap, s = e.orientation, l = e.interval, c = e.tickFormatter, f = e.unit, d = e.angle;
  if (!i || !i.length || !r)
    return [];
  if (ve(l) || Ni.isSsr)
    return _Pe(i, typeof l == "number" && ve(l) ? l : 0);
  var p = [], m = s === "top" || s === "bottom" ? "width" : "height", y = f && m === "width" ? ef(f, {
    fontSize: t,
    letterSpacing: n
  }) : {
    width: 0,
    height: 0
  }, g = function(S, A) {
    var _ = ze(c) ? c(S.value, A) : S.value;
    return m === "width" ? xPe(ef(_, {
      fontSize: t,
      letterSpacing: n
    }), y, d) : ef(_, {
      fontSize: t,
      letterSpacing: n
    })[m];
  }, v = i.length >= 2 ? fr(i[1].coordinate - i[0].coordinate) : 1, x = wPe(o, v, m);
  return l === "equidistantPreserveStart" ? SPe(v, x, g, i, a) : (l === "preserveStart" || l === "preserveStartEnd" ? p = CPe(v, x, g, i, a, l === "preserveStartEnd") : p = PPe(v, x, g, i, a), p.filter(function(w) {
    return w.isShow;
  }));
}
var EPe = ["viewBox"], kPe = ["viewBox"], MPe = ["ticks"];
function Oc(e) {
  "@babel/helpers - typeof";
  return Oc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oc(e);
}
function Bl() {
  return Bl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bl.apply(this, arguments);
}
function A$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? A$(Object(n), !0).forEach(function(r) {
      LS(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : A$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function a0(e, t) {
  if (e == null) return {};
  var n = NPe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function NPe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function $Pe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function T$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, KW(r.key), r);
  }
}
function DPe(e, t, n) {
  return t && T$(e.prototype, t), n && T$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function IPe(e, t, n) {
  return t = Hm(t), RPe(e, HW() ? Reflect.construct(t, n || [], Hm(e).constructor) : t.apply(e, n));
}
function RPe(e, t) {
  if (t && (Oc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jPe(e);
}
function jPe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function HW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (HW = function() {
    return !!e;
  })();
}
function Hm(e) {
  return Hm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hm(e);
}
function LPe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $w(e, t);
}
function $w(e, t) {
  return $w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, $w(e, t);
}
function LS(e, t, n) {
  return t = KW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function KW(e) {
  var t = BPe(e, "string");
  return Oc(t) == "symbol" ? t : t + "";
}
function BPe(e, t) {
  if (Oc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Oc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var eu = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return $Pe(this, t), r = IPe(this, t, [n]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return LPe(t, e), DPe(t, [{
    key: "shouldComponentUpdate",
    value: function(r, i) {
      var o = r.viewBox, a = a0(r, EPe), s = this.props, l = s.viewBox, c = a0(s, kPe);
      return !Kl(o, l) || !Kl(a, c) || !Kl(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var i = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var i = this.props, o = i.x, a = i.y, s = i.width, l = i.height, c = i.orientation, f = i.tickSize, d = i.mirror, p = i.tickMargin, m, y, g, v, x, w, S = d ? -1 : 1, A = r.tickSize || f, _ = ve(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (c) {
        case "top":
          m = y = r.coordinate, v = a + +!d * l, g = v - S * A, w = g - S * p, x = _;
          break;
        case "left":
          g = v = r.coordinate, y = o + +!d * s, m = y - S * A, x = m - S * p, w = _;
          break;
        case "right":
          g = v = r.coordinate, y = o + +d * s, m = y + S * A, x = m + S * p, w = _;
          break;
        default:
          m = y = r.coordinate, v = a + +d * l, g = v + S * A, w = g + S * p, x = _;
          break;
      }
      return {
        line: {
          x1: m,
          y1: g,
          x2: y,
          y2: v
        },
        tick: {
          x,
          y: w
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a;
      switch (i) {
        case "left":
          a = o ? "start" : "end";
          break;
        case "right":
          a = o ? "end" : "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a = "end";
      switch (i) {
        case "left":
        case "right":
          a = "middle";
          break;
        case "top":
          a = o ? "start" : "end";
          break;
        default:
          a = o ? "end" : "start";
          break;
      }
      return a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.orientation, c = r.mirror, f = r.axisLine, d = lr(lr(lr({}, Ee(this.props, !1)), Ee(f, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var p = +(l === "top" && !c || l === "bottom" && c);
        d = lr(lr({}, d), {}, {
          x1: i,
          y1: o + p * s,
          x2: i + a,
          y2: o + p * s
        });
      } else {
        var m = +(l === "left" && !c || l === "right" && c);
        d = lr(lr({}, d), {}, {
          x1: i + m * a,
          y1: o,
          x2: i + m * a,
          y2: o + s
        });
      }
      return /* @__PURE__ */ I.createElement("line", Bl({}, d, {
        className: Ye("recharts-cartesian-axis-line", zr(f, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, i, o) {
        var a = this, s = this.props, l = s.tickLine, c = s.stroke, f = s.tick, d = s.tickFormatter, p = s.unit, m = jS(lr(lr({}, this.props), {}, {
          ticks: r
        }), i, o), y = this.getTickTextAnchor(), g = this.getTickVerticalAnchor(), v = Ee(this.props, !1), x = Ee(f, !1), w = lr(lr({}, v), {}, {
          fill: "none"
        }, Ee(l, !1)), S = m.map(function(A, _) {
          var O = a.getTickLineCoord(A), P = O.line, C = O.tick, k = lr(lr(lr(lr({
            textAnchor: y,
            verticalAnchor: g
          }, v), {}, {
            stroke: "none",
            fill: c
          }, x), C), {}, {
            index: _,
            payload: A,
            visibleTicksCount: m.length,
            tickFormatter: d
          });
          return /* @__PURE__ */ I.createElement(at, Bl({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(A.value, "-").concat(A.coordinate, "-").concat(A.tickCoord)
          }, Fs(a.props, A, _)), l && /* @__PURE__ */ I.createElement("line", Bl({}, w, P, {
            className: Ye("recharts-cartesian-axis-tick-line", zr(l, "className"))
          })), f && t.renderTickItem(f, k, "".concat(ze(d) ? d(A.value, _) : A.value).concat(p || "")));
        });
        return /* @__PURE__ */ I.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, S);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.axisLine, a = i.width, s = i.height, l = i.ticksGenerator, c = i.className, f = i.hide;
      if (f)
        return null;
      var d = this.props, p = d.ticks, m = a0(d, MPe), y = p;
      return ze(l) && (y = p && p.length > 0 ? l(this.props) : l(m)), a <= 0 || s <= 0 || !y || !y.length ? null : /* @__PURE__ */ I.createElement(at, {
        className: Ye("recharts-cartesian-axis", c),
        ref: function(v) {
          r.layerReference = v;
        }
      }, o && this.renderAxisLine(), this.renderTicks(y, this.state.fontSize, this.state.letterSpacing), Sn.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ I.isValidElement(r) ? a = /* @__PURE__ */ I.cloneElement(r, i) : ze(r) ? a = r(i) : a = /* @__PURE__ */ I.createElement(Ws, Bl({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), o), a;
    }
  }]);
}(Gw);
LS(eu, "displayName", "CartesianAxis");
LS(eu, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var FPe = ["x1", "y1", "x2", "y2", "key"], WPe = ["offset"];
function Us(e) {
  "@babel/helpers - typeof";
  return Us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Us(e);
}
function P$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function nr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P$(Object(n), !0).forEach(function(r) {
      zPe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zPe(e, t, n) {
  return t = VPe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VPe(e) {
  var t = UPe(e, "string");
  return Us(t) == "symbol" ? t : t + "";
}
function UPe(e, t) {
  if (Us(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Us(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Os() {
  return Os = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Os.apply(this, arguments);
}
function C$(e, t) {
  if (e == null) return {};
  var n = HPe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function HPe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var KPe = function(t) {
  var n = t.fill;
  if (!n || n === "none")
    return null;
  var r = t.fillOpacity, i = t.x, o = t.y, a = t.width, s = t.height, l = t.ry;
  return /* @__PURE__ */ I.createElement("rect", {
    x: i,
    y: o,
    ry: l,
    width: a,
    height: s,
    stroke: "none",
    fill: n,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function GW(e, t) {
  var n;
  if (/* @__PURE__ */ I.isValidElement(e))
    n = /* @__PURE__ */ I.cloneElement(e, t);
  else if (ze(e))
    n = e(t);
  else {
    var r = t.x1, i = t.y1, o = t.x2, a = t.y2, s = t.key, l = C$(t, FPe), c = Ee(l, !1);
    c.offset;
    var f = C$(c, WPe);
    n = /* @__PURE__ */ I.createElement("line", Os({}, f, {
      x1: r,
      y1: i,
      x2: o,
      y2: a,
      fill: "none",
      key: s
    }));
  }
  return n;
}
function GPe(e) {
  var t = e.x, n = e.width, r = e.horizontal, i = r === void 0 ? !0 : r, o = e.horizontalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, l) {
    var c = nr(nr({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + n,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return GW(i, c);
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, a);
}
function YPe(e) {
  var t = e.y, n = e.height, r = e.vertical, i = r === void 0 ? !0 : r, o = e.verticalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, l) {
    var c = nr(nr({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + n,
      key: "line-".concat(l),
      index: l
    });
    return GW(i, c);
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, a);
}
function qPe(e) {
  var t = e.horizontalFill, n = e.fillOpacity, r = e.x, i = e.y, o = e.width, a = e.height, s = e.horizontalPoints, l = e.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !t || !t.length)
    return null;
  var f = s.map(function(p) {
    return Math.round(p + i - i);
  }).sort(function(p, m) {
    return p - m;
  });
  i !== f[0] && f.unshift(0);
  var d = f.map(function(p, m) {
    var y = !f[m + 1], g = y ? i + a - p : f[m + 1] - p;
    if (g <= 0)
      return null;
    var v = m % t.length;
    return /* @__PURE__ */ I.createElement("rect", {
      key: "react-".concat(m),
      y: p,
      x: r,
      height: g,
      width: o,
      stroke: "none",
      fill: t[v],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, d);
}
function XPe(e) {
  var t = e.vertical, n = t === void 0 ? !0 : t, r = e.verticalFill, i = e.fillOpacity, o = e.x, a = e.y, s = e.width, l = e.height, c = e.verticalPoints;
  if (!n || !r || !r.length)
    return null;
  var f = c.map(function(p) {
    return Math.round(p + o - o);
  }).sort(function(p, m) {
    return p - m;
  });
  o !== f[0] && f.unshift(0);
  var d = f.map(function(p, m) {
    var y = !f[m + 1], g = y ? o + s - p : f[m + 1] - p;
    if (g <= 0)
      return null;
    var v = m % r.length;
    return /* @__PURE__ */ I.createElement("rect", {
      key: "react-".concat(m),
      x: p,
      y: a,
      width: g,
      height: l,
      stroke: "none",
      fill: r[v],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, d);
}
var ZPe = function(t, n) {
  var r = t.xAxis, i = t.width, o = t.height, a = t.offset;
  return VF(jS(nr(nr(nr({}, eu.defaultProps), r), {}, {
    ticks: ko(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.left, a.left + a.width, n);
}, JPe = function(t, n) {
  var r = t.yAxis, i = t.width, o = t.height, a = t.offset;
  return VF(jS(nr(nr(nr({}, eu.defaultProps), r), {}, {
    ticks: ko(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.top, a.top + a.height, n);
}, Sl = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function Ty(e) {
  var t, n, r, i, o, a, s = $S(), l = DS(), c = BTe(), f = nr(nr({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Sl.stroke,
    fill: (n = e.fill) !== null && n !== void 0 ? n : Sl.fill,
    horizontal: (r = e.horizontal) !== null && r !== void 0 ? r : Sl.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Sl.horizontalFill,
    vertical: (o = e.vertical) !== null && o !== void 0 ? o : Sl.vertical,
    verticalFill: (a = e.verticalFill) !== null && a !== void 0 ? a : Sl.verticalFill,
    x: ve(e.x) ? e.x : c.left,
    y: ve(e.y) ? e.y : c.top,
    width: ve(e.width) ? e.width : c.width,
    height: ve(e.height) ? e.height : c.height
  }), d = f.x, p = f.y, m = f.width, y = f.height, g = f.syncWithTicks, v = f.horizontalValues, x = f.verticalValues, w = RTe(), S = jTe();
  if (!ve(m) || m <= 0 || !ve(y) || y <= 0 || !ve(d) || d !== +d || !ve(p) || p !== +p)
    return null;
  var A = f.verticalCoordinatesGenerator || ZPe, _ = f.horizontalCoordinatesGenerator || JPe, O = f.horizontalPoints, P = f.verticalPoints;
  if ((!O || !O.length) && ze(_)) {
    var C = v && v.length, k = _({
      yAxis: S ? nr(nr({}, S), {}, {
        ticks: C ? v : S.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, C ? !0 : g);
    Mi(Array.isArray(k), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Us(k), "]")), Array.isArray(k) && (O = k);
  }
  if ((!P || !P.length) && ze(A)) {
    var D = x && x.length, $ = A({
      xAxis: w ? nr(nr({}, w), {}, {
        ticks: D ? x : w.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, D ? !0 : g);
    Mi(Array.isArray($), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Us($), "]")), Array.isArray($) && (P = $);
  }
  return /* @__PURE__ */ I.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ I.createElement(KPe, {
    fill: f.fill,
    fillOpacity: f.fillOpacity,
    x: f.x,
    y: f.y,
    width: f.width,
    height: f.height,
    ry: f.ry
  }), /* @__PURE__ */ I.createElement(GPe, Os({}, f, {
    offset: c,
    horizontalPoints: O,
    xAxis: w,
    yAxis: S
  })), /* @__PURE__ */ I.createElement(YPe, Os({}, f, {
    offset: c,
    verticalPoints: P,
    xAxis: w,
    yAxis: S
  })), /* @__PURE__ */ I.createElement(qPe, Os({}, f, {
    horizontalPoints: O
  })), /* @__PURE__ */ I.createElement(XPe, Os({}, f, {
    verticalPoints: P
  })));
}
Ty.displayName = "CartesianGrid";
var QPe = ["type", "layout", "connectNulls", "ref"], eCe = ["key"];
function Ac(e) {
  "@babel/helpers - typeof";
  return Ac = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ac(e);
}
function E$(e, t) {
  if (e == null) return {};
  var n = tCe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function tCe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function sf() {
  return sf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sf.apply(this, arguments);
}
function k$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ir(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k$(Object(n), !0).forEach(function(r) {
      Ai(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : k$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ol(e) {
  return oCe(e) || iCe(e) || rCe(e) || nCe();
}
function nCe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rCe(e, t) {
  if (e) {
    if (typeof e == "string") return Dw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Dw(e, t);
  }
}
function iCe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oCe(e) {
  if (Array.isArray(e)) return Dw(e);
}
function Dw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function aCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function M$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qW(r.key), r);
  }
}
function sCe(e, t, n) {
  return t && M$(e.prototype, t), n && M$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lCe(e, t, n) {
  return t = Km(t), cCe(e, YW() ? Reflect.construct(t, n || [], Km(e).constructor) : t.apply(e, n));
}
function cCe(e, t) {
  if (t && (Ac(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return uCe(e);
}
function uCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function YW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (YW = function() {
    return !!e;
  })();
}
function Km(e) {
  return Km = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Km(e);
}
function fCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Iw(e, t);
}
function Iw(e, t) {
  return Iw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Iw(e, t);
}
function Ai(e, t, n) {
  return t = qW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qW(e) {
  var t = dCe(e, "string");
  return Ac(t) == "symbol" ? t : t + "";
}
function dCe(e, t) {
  if (Ac(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ac(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Id = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    aCe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = lCe(this, t, [].concat(i)), Ai(n, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), Ai(n, "generateSimpleStrokeDasharray", function(a, s) {
      return "".concat(s, "px ").concat(a - s, "px");
    }), Ai(n, "getStrokeDasharray", function(a, s, l) {
      var c = l.reduce(function(x, w) {
        return x + w;
      });
      if (!c)
        return n.generateSimpleStrokeDasharray(s, a);
      for (var f = Math.floor(a / c), d = a % c, p = s - a, m = [], y = 0, g = 0; y < l.length; g += l[y], ++y)
        if (g + l[y] > d) {
          m = [].concat(Ol(l.slice(0, y)), [d - g]);
          break;
        }
      var v = m.length % 2 === 0 ? [0, p] : [p];
      return [].concat(Ol(t.repeat(l, f)), Ol(m), v).map(function(x) {
        return "".concat(x, "px");
      }).join(", ");
    }), Ai(n, "id", Qs("recharts-line-")), Ai(n, "pathRef", function(a) {
      n.mainCurve = a;
    }), Ai(n, "handleAnimationEnd", function() {
      n.setState({
        isAnimationFinished: !0
      }), n.props.onAnimationEnd && n.props.onAnimationEnd();
    }), Ai(n, "handleAnimationStart", function() {
      n.setState({
        isAnimationFinished: !1
      }), n.props.onAnimationStart && n.props.onAnimationStart();
    }), n;
  }
  return fCe(t, e), sCe(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var r = this.getTotalLength();
        r !== this.state.totalLength && this.setState({
          totalLength: r
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var r = this.mainCurve;
      try {
        return r && r.getTotalLength && r.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.points, s = o.xAxis, l = o.yAxis, c = o.layout, f = o.children, d = Vr(f, $d);
      if (!d)
        return null;
      var p = function(g, v) {
        return {
          x: g.x,
          y: g.y,
          value: g.value,
          errorVal: cn(g.payload, v)
        };
      }, m = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ I.createElement(at, m, d.map(function(y) {
        return /* @__PURE__ */ I.cloneElement(y, {
          key: "bar-".concat(y.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: c,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(r, i, o) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var s = this.props, l = s.dot, c = s.points, f = s.dataKey, d = Ee(this.props, !1), p = Ee(l, !0), m = c.map(function(g, v) {
        var x = Ir(Ir(Ir({
          key: "dot-".concat(v),
          r: 3
        }, d), p), {}, {
          value: g.value,
          dataKey: f,
          cx: g.x,
          cy: g.y,
          index: v,
          payload: g.payload
        });
        return t.renderDotItem(l, x);
      }), y = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ I.createElement(at, sf({
        className: "recharts-line-dots",
        key: "dots"
      }, y), m);
    }
  }, {
    key: "renderCurveStatically",
    value: function(r, i, o, a) {
      var s = this.props, l = s.type, c = s.layout, f = s.connectNulls;
      s.ref;
      var d = E$(s, QPe), p = Ir(Ir(Ir({}, Ee(d, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null,
        points: r
      }, a), {}, {
        type: l,
        layout: c,
        connectNulls: f
      });
      return /* @__PURE__ */ I.createElement(Ns, sf({}, p, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(r, i) {
      var o = this, a = this.props, s = a.points, l = a.strokeDasharray, c = a.isAnimationActive, f = a.animationBegin, d = a.animationDuration, p = a.animationEasing, m = a.animationId, y = a.animateNewValues, g = a.width, v = a.height, x = this.state, w = x.prevPoints, S = x.totalLength;
      return /* @__PURE__ */ I.createElement($i, {
        begin: f,
        duration: d,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(m),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(A) {
        var _ = A.t;
        if (w) {
          var O = w.length / s.length, P = s.map(function(N, R) {
            var L = Math.floor(R * O);
            if (w[L]) {
              var F = w[L], W = _n(F.x, N.x), z = _n(F.y, N.y);
              return Ir(Ir({}, N), {}, {
                x: W(_),
                y: z(_)
              });
            }
            if (y) {
              var G = _n(g * 2, N.x), U = _n(v / 2, N.y);
              return Ir(Ir({}, N), {}, {
                x: G(_),
                y: U(_)
              });
            }
            return Ir(Ir({}, N), {}, {
              x: N.x,
              y: N.y
            });
          });
          return o.renderCurveStatically(P, r, i);
        }
        var C = _n(0, S), k = C(_), D;
        if (l) {
          var $ = "".concat(l).split(/[,\s]+/gim).map(function(N) {
            return parseFloat(N);
          });
          D = o.getStrokeDasharray(k, S, $);
        } else
          D = o.generateSimpleStrokeDasharray(S, k);
        return o.renderCurveStatically(s, r, i, {
          strokeDasharray: D
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(r, i) {
      var o = this.props, a = o.points, s = o.isAnimationActive, l = this.state, c = l.prevPoints, f = l.totalLength;
      return s && a && a.length && (!c && f > 0 || !zs(c, a)) ? this.renderCurveWithAnimation(r, i) : this.renderCurveStatically(a, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, o = i.hide, a = i.dot, s = i.points, l = i.className, c = i.xAxis, f = i.yAxis, d = i.top, p = i.left, m = i.width, y = i.height, g = i.isAnimationActive, v = i.id;
      if (o || !s || !s.length)
        return null;
      var x = this.state.isAnimationFinished, w = s.length === 1, S = Ye("recharts-line", l), A = c && c.allowDataOverflow, _ = f && f.allowDataOverflow, O = A || _, P = Ue(v) ? this.id : v, C = (r = Ee(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, k = C.r, D = k === void 0 ? 3 : k, $ = C.strokeWidth, N = $ === void 0 ? 2 : $, R = IL(a) ? a : {}, L = R.clipDot, F = L === void 0 ? !0 : L, W = D * 2 + N;
      return /* @__PURE__ */ I.createElement(at, {
        className: S
      }, A || _ ? /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-".concat(P)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: A ? p : p - m / 2,
        y: _ ? d : d - y / 2,
        width: A ? m : m * 2,
        height: _ ? y : y * 2
      })), !F && /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-dots-".concat(P)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: p - W / 2,
        y: d - W / 2,
        width: m + W,
        height: y + W
      }))) : null, !w && this.renderCurve(O, P), this.renderErrorBar(O, P), (w || a) && this.renderDots(O, F, P), (!g || x) && Zi.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        prevPoints: i.curPoints
      } : r.points !== i.curPoints ? {
        curPoints: r.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(r, i) {
      for (var o = r.length % 2 !== 0 ? [].concat(Ol(r), [0]) : r, a = [], s = 0; s < i; ++s)
        a = [].concat(Ol(a), Ol(o));
      return a;
    }
  }, {
    key: "renderDotItem",
    value: function(r, i) {
      var o;
      if (/* @__PURE__ */ I.isValidElement(r))
        o = /* @__PURE__ */ I.cloneElement(r, i);
      else if (ze(r))
        o = r(i);
      else {
        var a = i.key, s = E$(i, eCe), l = Ye("recharts-line-dot", typeof r != "boolean" ? r.className : "");
        o = /* @__PURE__ */ I.createElement(Dd, sf({
          key: a
        }, s, {
          className: l
        }));
      }
      return o;
    }
  }]);
}(pi);
Ai(Id, "displayName", "Line");
Ai(Id, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Ni.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
Ai(Id, "getComposedData", function(e) {
  var t = e.props, n = e.xAxis, r = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, a = e.dataKey, s = e.bandSize, l = e.displayedData, c = e.offset, f = t.layout, d = l.map(function(p, m) {
    var y = cn(p, a);
    return f === "horizontal" ? {
      x: wm({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: p,
        index: m
      }),
      y: Ue(y) ? null : r.scale(y),
      value: y,
      payload: p
    } : {
      x: Ue(y) ? null : n.scale(y),
      y: wm({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: p,
        index: m
      }),
      value: y,
      payload: p
    };
  });
  return Ir({
    points: d,
    layout: f
  }, c);
});
var hCe = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], pCe = ["key"], XW;
function Tc(e) {
  "@babel/helpers - typeof";
  return Tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tc(e);
}
function ZW(e, t) {
  if (e == null) return {};
  var n = mCe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function mCe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function As() {
  return As = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, As.apply(this, arguments);
}
function N$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function va(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N$(Object(n), !0).forEach(function(r) {
      Ui(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : N$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, QW(r.key), r);
  }
}
function yCe(e, t, n) {
  return t && $$(e.prototype, t), n && $$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vCe(e, t, n) {
  return t = Gm(t), bCe(e, JW() ? Reflect.construct(t, n || [], Gm(e).constructor) : t.apply(e, n));
}
function bCe(e, t) {
  if (t && (Tc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xCe(e);
}
function xCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JW() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JW = function() {
    return !!e;
  })();
}
function Gm(e) {
  return Gm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gm(e);
}
function wCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rw(e, t);
}
function Rw(e, t) {
  return Rw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Rw(e, t);
}
function Ui(e, t, n) {
  return t = QW(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function QW(e) {
  var t = _Ce(e, "string");
  return Tc(t) == "symbol" ? t : t + "";
}
function _Ce(e, t) {
  if (Tc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Tc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var qa = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    gCe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = vCe(this, t, [].concat(i)), Ui(n, "state", {
      isAnimationFinished: !0
    }), Ui(n, "id", Qs("recharts-area-")), Ui(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ze(a) && a();
    }), Ui(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ze(a) && a();
    }), n;
  }
  return wCe(t, e), yCe(t, [{
    key: "renderDots",
    value: function(r, i, o) {
      var a = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (a && !s)
        return null;
      var l = this.props, c = l.dot, f = l.points, d = l.dataKey, p = Ee(this.props, !1), m = Ee(c, !0), y = f.map(function(v, x) {
        var w = va(va(va({
          key: "dot-".concat(x),
          r: 3
        }, p), m), {}, {
          index: x,
          cx: v.x,
          cy: v.y,
          dataKey: d,
          value: v.value,
          payload: v.payload,
          points: f
        });
        return t.renderDotItem(c, w);
      }), g = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ I.createElement(at, As({
        className: "recharts-area-dots"
      }, g), y);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(r) {
      var i = this.props, o = i.baseLine, a = i.points, s = i.strokeWidth, l = a[0].x, c = a[a.length - 1].x, f = r * Math.abs(l - c), d = Aa(a.map(function(p) {
        return p.y || 0;
      }));
      return ve(o) && typeof o == "number" ? d = Math.max(o, d) : o && Array.isArray(o) && o.length && (d = Math.max(Aa(o.map(function(p) {
        return p.y || 0;
      })), d)), ve(d) ? /* @__PURE__ */ I.createElement("rect", {
        x: l < c ? l : l - f,
        y: 0,
        width: f,
        height: Math.floor(d + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(r) {
      var i = this.props, o = i.baseLine, a = i.points, s = i.strokeWidth, l = a[0].y, c = a[a.length - 1].y, f = r * Math.abs(l - c), d = Aa(a.map(function(p) {
        return p.x || 0;
      }));
      return ve(o) && typeof o == "number" ? d = Math.max(o, d) : o && Array.isArray(o) && o.length && (d = Math.max(Aa(o.map(function(p) {
        return p.x || 0;
      })), d)), ve(d) ? /* @__PURE__ */ I.createElement("rect", {
        x: 0,
        y: l < c ? l : l - f,
        width: d + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(f)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(r) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(r) : this.renderHorizontalRect(r);
    }
  }, {
    key: "renderAreaStatically",
    value: function(r, i, o, a) {
      var s = this.props, l = s.layout, c = s.type, f = s.stroke, d = s.connectNulls, p = s.isRange;
      s.ref;
      var m = ZW(s, hCe);
      return /* @__PURE__ */ I.createElement(at, {
        clipPath: o ? "url(#clipPath-".concat(a, ")") : null
      }, /* @__PURE__ */ I.createElement(Ns, As({}, Ee(m, !0), {
        points: r,
        connectNulls: d,
        type: c,
        baseLine: i,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), f !== "none" && /* @__PURE__ */ I.createElement(Ns, As({}, Ee(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: r
      })), f !== "none" && p && /* @__PURE__ */ I.createElement(Ns, As({}, Ee(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(r, i) {
      var o = this, a = this.props, s = a.points, l = a.baseLine, c = a.isAnimationActive, f = a.animationBegin, d = a.animationDuration, p = a.animationEasing, m = a.animationId, y = this.state, g = y.prevPoints, v = y.prevBaseLine;
      return /* @__PURE__ */ I.createElement($i, {
        begin: f,
        duration: d,
        isActive: c,
        easing: p,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(m),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var w = x.t;
        if (g) {
          var S = g.length / s.length, A = s.map(function(C, k) {
            var D = Math.floor(k * S);
            if (g[D]) {
              var $ = g[D], N = _n($.x, C.x), R = _n($.y, C.y);
              return va(va({}, C), {}, {
                x: N(w),
                y: R(w)
              });
            }
            return C;
          }), _;
          if (ve(l) && typeof l == "number") {
            var O = _n(v, l);
            _ = O(w);
          } else if (Ue(l) || Kc(l)) {
            var P = _n(v, 0);
            _ = P(w);
          } else
            _ = l.map(function(C, k) {
              var D = Math.floor(k * S);
              if (v[D]) {
                var $ = v[D], N = _n($.x, C.x), R = _n($.y, C.y);
                return va(va({}, C), {}, {
                  x: N(w),
                  y: R(w)
                });
              }
              return C;
            });
          return o.renderAreaStatically(A, _, r, i);
        }
        return /* @__PURE__ */ I.createElement(at, null, /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, o.renderClipRect(w))), /* @__PURE__ */ I.createElement(at, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, o.renderAreaStatically(s, l, r, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(r, i) {
      var o = this.props, a = o.points, s = o.baseLine, l = o.isAnimationActive, c = this.state, f = c.prevPoints, d = c.prevBaseLine, p = c.totalLength;
      return l && a && a.length && (!f && p > 0 || !zs(f, a) || !zs(d, s)) ? this.renderAreaWithAnimation(r, i) : this.renderAreaStatically(a, s, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, o = i.hide, a = i.dot, s = i.points, l = i.className, c = i.top, f = i.left, d = i.xAxis, p = i.yAxis, m = i.width, y = i.height, g = i.isAnimationActive, v = i.id;
      if (o || !s || !s.length)
        return null;
      var x = this.state.isAnimationFinished, w = s.length === 1, S = Ye("recharts-area", l), A = d && d.allowDataOverflow, _ = p && p.allowDataOverflow, O = A || _, P = Ue(v) ? this.id : v, C = (r = Ee(a, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, k = C.r, D = k === void 0 ? 3 : k, $ = C.strokeWidth, N = $ === void 0 ? 2 : $, R = IL(a) ? a : {}, L = R.clipDot, F = L === void 0 ? !0 : L, W = D * 2 + N;
      return /* @__PURE__ */ I.createElement(at, {
        className: S
      }, A || _ ? /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-".concat(P)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: A ? f : f - m / 2,
        y: _ ? c : c - y / 2,
        width: A ? m : m * 2,
        height: _ ? y : y * 2
      })), !F && /* @__PURE__ */ I.createElement("clipPath", {
        id: "clipPath-dots-".concat(P)
      }, /* @__PURE__ */ I.createElement("rect", {
        x: f - W / 2,
        y: c - W / 2,
        width: m + W,
        height: y + W
      }))) : null, w ? null : this.renderArea(O, P), (a || w) && this.renderDots(O, F, P), (!g || x) && Zi.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        curBaseLine: r.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : r.points !== i.curPoints || r.baseLine !== i.curBaseLine ? {
        curPoints: r.points,
        curBaseLine: r.baseLine
      } : null;
    }
  }]);
}(pi);
XW = qa;
Ui(qa, "displayName", "Area");
Ui(qa, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Ni.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Ui(qa, "getBaseValue", function(e, t, n, r) {
  var i = e.layout, o = e.baseValue, a = t.props.baseValue, s = a ?? o;
  if (ve(s) && typeof s == "number")
    return s;
  var l = i === "horizontal" ? r : n, c = l.scale.domain();
  if (l.type === "number") {
    var f = Math.max(c[0], c[1]), d = Math.min(c[0], c[1]);
    return s === "dataMin" ? d : s === "dataMax" || f < 0 ? f : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
Ui(qa, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.xAxis, i = e.yAxis, o = e.xAxisTicks, a = e.yAxisTicks, s = e.bandSize, l = e.dataKey, c = e.stackedData, f = e.dataStartIndex, d = e.displayedData, p = e.offset, m = t.layout, y = c && c.length, g = XW.getBaseValue(t, n, r, i), v = m === "horizontal", x = !1, w = d.map(function(A, _) {
    var O;
    y ? O = c[f + _] : (O = cn(A, l), Array.isArray(O) ? x = !0 : O = [g, O]);
    var P = O[1] == null || y && cn(A, l) == null;
    return v ? {
      x: wm({
        axis: r,
        ticks: o,
        bandSize: s,
        entry: A,
        index: _
      }),
      y: P ? null : i.scale(O[1]),
      value: O,
      payload: A
    } : {
      x: P ? null : r.scale(O[1]),
      y: wm({
        axis: i,
        ticks: a,
        bandSize: s,
        entry: A,
        index: _
      }),
      value: O,
      payload: A
    };
  }), S;
  return y || x ? S = w.map(function(A) {
    var _ = Array.isArray(A.value) ? A.value[0] : null;
    return v ? {
      x: A.x,
      y: _ != null && A.y != null ? i.scale(_) : null
    } : {
      x: _ != null ? r.scale(_) : null,
      y: A.y
    };
  }) : S = v ? i.scale(g) : r.scale(g), va({
    points: w,
    baseLine: S,
    layout: m,
    isRange: x
  }, p);
});
Ui(qa, "renderDotItem", function(e, t) {
  var n;
  if (/* @__PURE__ */ I.isValidElement(e))
    n = /* @__PURE__ */ I.cloneElement(e, t);
  else if (ze(e))
    n = e(t);
  else {
    var r = Ye("recharts-area-dot", typeof e != "boolean" ? e.className : ""), i = t.key, o = ZW(t, pCe);
    n = /* @__PURE__ */ I.createElement(Dd, As({}, o, {
      key: i,
      className: r
    }));
  }
  return n;
});
function Pc(e) {
  "@babel/helpers - typeof";
  return Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pc(e);
}
function SCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function OCe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, nz(r.key), r);
  }
}
function ACe(e, t, n) {
  return t && OCe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function TCe(e, t, n) {
  return t = Ym(t), PCe(e, ez() ? Reflect.construct(t, n || [], Ym(e).constructor) : t.apply(e, n));
}
function PCe(e, t) {
  if (t && (Pc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return CCe(e);
}
function CCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ez() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ez = function() {
    return !!e;
  })();
}
function Ym(e) {
  return Ym = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ym(e);
}
function ECe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jw(e, t);
}
function jw(e, t) {
  return jw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, jw(e, t);
}
function tz(e, t, n) {
  return t = nz(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nz(e) {
  var t = kCe(e, "string");
  return Pc(t) == "symbol" ? t : t + "";
}
function kCe(e, t) {
  if (Pc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Pc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lw() {
  return Lw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lw.apply(this, arguments);
}
function MCe(e) {
  var t = e.xAxisId, n = $S(), r = DS(), i = RW(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ I.createElement(eu, Lw({}, i, {
      className: Ye("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: r
      },
      ticksGenerator: function(a) {
        return ko(a, !0);
      }
    }))
  );
}
var Go = /* @__PURE__ */ function(e) {
  function t() {
    return SCe(this, t), TCe(this, t, arguments);
  }
  return ECe(t, e), ACe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ I.createElement(MCe, this.props);
    }
  }]);
}(I.Component);
tz(Go, "displayName", "XAxis");
tz(Go, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Cc(e) {
  "@babel/helpers - typeof";
  return Cc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Cc(e);
}
function NCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $Ce(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, oz(r.key), r);
  }
}
function DCe(e, t, n) {
  return t && $Ce(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ICe(e, t, n) {
  return t = qm(t), RCe(e, rz() ? Reflect.construct(t, n || [], qm(e).constructor) : t.apply(e, n));
}
function RCe(e, t) {
  if (t && (Cc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jCe(e);
}
function jCe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rz() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (rz = function() {
    return !!e;
  })();
}
function qm(e) {
  return qm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, qm(e);
}
function LCe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bw(e, t);
}
function Bw(e, t) {
  return Bw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Bw(e, t);
}
function iz(e, t, n) {
  return t = oz(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oz(e) {
  var t = BCe(e, "string");
  return Cc(t) == "symbol" ? t : t + "";
}
function BCe(e, t) {
  if (Cc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Cc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fw() {
  return Fw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fw.apply(this, arguments);
}
var FCe = function(t) {
  var n = t.yAxisId, r = $S(), i = DS(), o = jW(n);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ I.createElement(eu, Fw({}, o, {
      className: Ye("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: i
      },
      ticksGenerator: function(s) {
        return ko(s, !0);
      }
    }))
  );
}, Qi = /* @__PURE__ */ function(e) {
  function t() {
    return NCe(this, t), ICe(this, t, arguments);
  }
  return LCe(t, e), DCe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ I.createElement(FCe, this.props);
    }
  }]);
}(I.Component);
iz(Qi, "displayName", "YAxis");
iz(Qi, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function D$(e) {
  return UCe(e) || VCe(e) || zCe(e) || WCe();
}
function WCe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zCe(e, t) {
  if (e) {
    if (typeof e == "string") return Ww(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ww(e, t);
  }
}
function VCe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function UCe(e) {
  if (Array.isArray(e)) return Ww(e);
}
function Ww(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var zw = function(t, n, r, i, o) {
  var a = Vr(t, RS), s = Vr(t, Sy), l = [].concat(D$(a), D$(s)), c = Vr(t, Ay), f = "".concat(i, "Id"), d = i[0], p = n;
  if (l.length && (p = l.reduce(function(g, v) {
    if (v.props[f] === r && Ji(v.props, "extendDomain") && ve(v.props[d])) {
      var x = v.props[d];
      return [Math.min(g[0], x), Math.max(g[1], x)];
    }
    return g;
  }, p)), c.length) {
    var m = "".concat(d, "1"), y = "".concat(d, "2");
    p = c.reduce(function(g, v) {
      if (v.props[f] === r && Ji(v.props, "extendDomain") && ve(v.props[m]) && ve(v.props[y])) {
        var x = v.props[m], w = v.props[y];
        return [Math.min(g[0], x, w), Math.max(g[1], x, w)];
      }
      return g;
    }, p);
  }
  return o && o.length && (p = o.reduce(function(g, v) {
    return ve(v) ? [Math.min(g[0], v), Math.max(g[1], v)] : g;
  }, p)), p;
}, az = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(l, c, f) {
    this.fn = l, this.context = c, this.once = f || !1;
  }
  function o(l, c, f, d, p) {
    if (typeof f != "function")
      throw new TypeError("The listener must be a function");
    var m = new i(f, d || l, p), y = n ? n + c : c;
    return l._events[y] ? l._events[y].fn ? l._events[y] = [l._events[y], m] : l._events[y].push(m) : (l._events[y] = m, l._eventsCount++), l;
  }
  function a(l, c) {
    --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
  }
  function s() {
    this._events = new r(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var c = [], f, d;
    if (this._eventsCount === 0) return c;
    for (d in f = this._events)
      t.call(f, d) && c.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(f)) : c;
  }, s.prototype.listeners = function(c) {
    var f = n ? n + c : c, d = this._events[f];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var p = 0, m = d.length, y = new Array(m); p < m; p++)
      y[p] = d[p].fn;
    return y;
  }, s.prototype.listenerCount = function(c) {
    var f = n ? n + c : c, d = this._events[f];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(c, f, d, p, m, y) {
    var g = n ? n + c : c;
    if (!this._events[g]) return !1;
    var v = this._events[g], x = arguments.length, w, S;
    if (v.fn) {
      switch (v.once && this.removeListener(c, v.fn, void 0, !0), x) {
        case 1:
          return v.fn.call(v.context), !0;
        case 2:
          return v.fn.call(v.context, f), !0;
        case 3:
          return v.fn.call(v.context, f, d), !0;
        case 4:
          return v.fn.call(v.context, f, d, p), !0;
        case 5:
          return v.fn.call(v.context, f, d, p, m), !0;
        case 6:
          return v.fn.call(v.context, f, d, p, m, y), !0;
      }
      for (S = 1, w = new Array(x - 1); S < x; S++)
        w[S - 1] = arguments[S];
      v.fn.apply(v.context, w);
    } else {
      var A = v.length, _;
      for (S = 0; S < A; S++)
        switch (v[S].once && this.removeListener(c, v[S].fn, void 0, !0), x) {
          case 1:
            v[S].fn.call(v[S].context);
            break;
          case 2:
            v[S].fn.call(v[S].context, f);
            break;
          case 3:
            v[S].fn.call(v[S].context, f, d);
            break;
          case 4:
            v[S].fn.call(v[S].context, f, d, p);
            break;
          default:
            if (!w) for (_ = 1, w = new Array(x - 1); _ < x; _++)
              w[_ - 1] = arguments[_];
            v[S].fn.apply(v[S].context, w);
        }
    }
    return !0;
  }, s.prototype.on = function(c, f, d) {
    return o(this, c, f, d, !1);
  }, s.prototype.once = function(c, f, d) {
    return o(this, c, f, d, !0);
  }, s.prototype.removeListener = function(c, f, d, p) {
    var m = n ? n + c : c;
    if (!this._events[m]) return this;
    if (!f)
      return a(this, m), this;
    var y = this._events[m];
    if (y.fn)
      y.fn === f && (!p || y.once) && (!d || y.context === d) && a(this, m);
    else {
      for (var g = 0, v = [], x = y.length; g < x; g++)
        (y[g].fn !== f || p && !y[g].once || d && y[g].context !== d) && v.push(y[g]);
      v.length ? this._events[m] = v.length === 1 ? v[0] : v : a(this, m);
    }
    return this;
  }, s.prototype.removeAllListeners = function(c) {
    var f;
    return c ? (f = n ? n + c : c, this._events[f] && a(this, f)) : (this._events = new r(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
})(az);
var HCe = az.exports;
const KCe = /* @__PURE__ */ kt(HCe);
var s0 = new KCe(), l0 = "recharts.syncMouseEvents";
function id(e) {
  "@babel/helpers - typeof";
  return id = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, id(e);
}
function GCe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function YCe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, sz(r.key), r);
  }
}
function qCe(e, t, n) {
  return t && YCe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function c0(e, t, n) {
  return t = sz(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sz(e) {
  var t = XCe(e, "string");
  return id(t) == "symbol" ? t : t + "";
}
function XCe(e, t) {
  if (id(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (id(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ZCe = /* @__PURE__ */ function() {
  function e() {
    GCe(this, e), c0(this, "activeIndex", 0), c0(this, "coordinateList", []), c0(this, "layout", "horizontal");
  }
  return qCe(e, [{
    key: "setDetails",
    value: function(n) {
      var r, i = n.coordinateList, o = i === void 0 ? null : i, a = n.container, s = a === void 0 ? null : a, l = n.layout, c = l === void 0 ? null : l, f = n.offset, d = f === void 0 ? null : f, p = n.mouseHandlerCallback, m = p === void 0 ? null : p;
      this.coordinateList = (r = o ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = d ?? this.offset, this.mouseHandlerCallback = m ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(n) {
      if (this.coordinateList.length !== 0)
        switch (n.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(n) {
      this.activeIndex = n;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var n, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), o = i.x, a = i.y, s = i.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((n = window) === null || n === void 0 ? void 0 : n.scrollX) || 0, f = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, d = o + l + c, p = a + this.offset.top + s / 2 + f;
        this.mouseHandlerCallback({
          pageX: d,
          pageY: p
        });
      }
    }
  }]);
}();
function JCe(e, t, n) {
  if (n === "number" && t === !0 && Array.isArray(e)) {
    var r = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
    if (r && i && ve(r) && ve(i))
      return !0;
  }
  return !1;
}
function QCe(e, t, n, r) {
  var i = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : n.left + 0.5,
    y: e === "horizontal" ? n.top + 0.5 : t.y - i,
    width: e === "horizontal" ? r : n.width - 1,
    height: e === "horizontal" ? n.height - 1 : r
  };
}
function lz(e) {
  var t = e.cx, n = e.cy, r = e.radius, i = e.startAngle, o = e.endAngle, a = Bt(t, n, r, i), s = Bt(t, n, r, o);
  return {
    points: [a, s],
    cx: t,
    cy: n,
    radius: r,
    startAngle: i,
    endAngle: o
  };
}
function eEe(e, t, n) {
  var r, i, o, a;
  if (e === "horizontal")
    r = t.x, o = r, i = n.top, a = n.top + n.height;
  else if (e === "vertical")
    i = t.y, a = i, r = n.left, o = n.left + n.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, l = t.cy, c = t.innerRadius, f = t.outerRadius, d = t.angle, p = Bt(s, l, c, d), m = Bt(s, l, f, d);
      r = p.x, i = p.y, o = m.x, a = m.y;
    } else
      return lz(t);
  return [{
    x: r,
    y: i
  }, {
    x: o,
    y: a
  }];
}
function od(e) {
  "@babel/helpers - typeof";
  return od = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, od(e);
}
function I$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? I$(Object(n), !0).forEach(function(r) {
      tEe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : I$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function tEe(e, t, n) {
  return t = nEe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nEe(e) {
  var t = rEe(e, "string");
  return od(t) == "symbol" ? t : t + "";
}
function rEe(e, t) {
  if (od(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (od(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function iEe(e) {
  var t, n, r = e.element, i = e.tooltipEventType, o = e.isActive, a = e.activeCoordinate, s = e.activePayload, l = e.offset, c = e.activeTooltipIndex, f = e.tooltipAxisBandSize, d = e.layout, p = e.chartName, m = (t = r.props.cursor) !== null && t !== void 0 ? t : (n = r.type.defaultProps) === null || n === void 0 ? void 0 : n.cursor;
  if (!r || !m || !o || !a || p !== "ScatterChart" && i !== "axis")
    return null;
  var y, g = Ns;
  if (p === "ScatterChart")
    y = a, g = dSe;
  else if (p === "BarChart")
    y = QCe(d, a, l, f), g = CS;
  else if (d === "radial") {
    var v = lz(a), x = v.cx, w = v.cy, S = v.radius, A = v.startAngle, _ = v.endAngle;
    y = {
      cx: x,
      cy: w,
      startAngle: A,
      endAngle: _,
      innerRadius: S,
      outerRadius: S
    }, g = eW;
  } else
    y = {
      points: eEe(d, a, l)
    }, g = Ns;
  var O = tp(tp(tp(tp({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), y), Ee(m, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: Ye("recharts-tooltip-cursor", m.className)
  });
  return /* @__PURE__ */ rt(m) ? /* @__PURE__ */ ht(m, O) : /* @__PURE__ */ ql(g, O);
}
var oEe = ["item"], aEe = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Ec(e) {
  "@babel/helpers - typeof";
  return Ec = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ec(e);
}
function Fl() {
  return Fl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fl.apply(this, arguments);
}
function R$(e, t) {
  return cEe(e) || lEe(e, t) || uz(e, t) || sEe();
}
function sEe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lEe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, c = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw i;
      }
    }
    return s;
  }
}
function cEe(e) {
  if (Array.isArray(e)) return e;
}
function j$(e, t) {
  if (e == null) return {};
  var n = uEe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function uEe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function fEe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dEe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fz(r.key), r);
  }
}
function hEe(e, t, n) {
  return t && dEe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pEe(e, t, n) {
  return t = Xm(t), mEe(e, cz() ? Reflect.construct(t, n || [], Xm(e).constructor) : t.apply(e, n));
}
function mEe(e, t) {
  if (t && (Ec(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gEe(e);
}
function gEe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cz() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cz = function() {
    return !!e;
  })();
}
function Xm(e) {
  return Xm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Xm(e);
}
function yEe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Vw(e, t);
}
function Vw(e, t) {
  return Vw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Vw(e, t);
}
function kc(e) {
  return xEe(e) || bEe(e) || uz(e) || vEe();
}
function vEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uz(e, t) {
  if (e) {
    if (typeof e == "string") return Uw(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Uw(e, t);
  }
}
function bEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function xEe(e) {
  if (Array.isArray(e)) return Uw(e);
}
function Uw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function L$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function se(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L$(Object(n), !0).forEach(function(r) {
      We(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : L$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function We(e, t, n) {
  return t = fz(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fz(e) {
  var t = wEe(e, "string");
  return Ec(t) == "symbol" ? t : t + "";
}
function wEe(e, t) {
  if (Ec(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ec(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _Ee = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, SEe = {
  width: "100%",
  height: "100%"
}, dz = {
  x: 0,
  y: 0
};
function np(e) {
  return e;
}
var OEe = function(t, n) {
  return n === "horizontal" ? t.x : n === "vertical" ? t.y : n === "centric" ? t.angle : t.radius;
}, AEe = function(t, n, r, i) {
  var o = n.find(function(f) {
    return f && f.index === r;
  });
  if (o) {
    if (t === "horizontal")
      return {
        x: o.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: o.coordinate
      };
    if (t === "centric") {
      var a = o.coordinate, s = i.radius;
      return se(se(se({}, i), Bt(i.cx, i.cy, s, a)), {}, {
        angle: a,
        radius: s
      });
    }
    var l = o.coordinate, c = i.angle;
    return se(se(se({}, i), Bt(i.cx, i.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return dz;
}, Py = function(t, n) {
  var r = n.graphicalItems, i = n.dataStartIndex, o = n.dataEndIndex, a = (r ?? []).reduce(function(s, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(kc(s), kc(c)) : s;
  }, []);
  return a.length > 0 ? a : t && t.length && ve(i) && ve(o) ? t.slice(i, o + 1) : [];
};
function hz(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Hw = function(t, n, r, i) {
  var o = t.graphicalItems, a = t.tooltipAxis, s = Py(n, t);
  return r < 0 || !o || !o.length || r >= s.length ? null : o.reduce(function(l, c) {
    var f, d = (f = c.props.data) !== null && f !== void 0 ? f : n;
    d && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= r && (d = d.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var p;
    if (a.dataKey && !a.allowDuplicatedCategory) {
      var m = d === void 0 ? s : d;
      p = Gp(m, a.dataKey, i);
    } else
      p = d && d[r] || s[r];
    return p ? [].concat(kc(l), [YF(c, p)]) : l;
  }, []);
}, B$ = function(t, n, r, i) {
  var o = i || {
    x: t.chartX,
    y: t.chartY
  }, a = OEe(o, r), s = t.orderedTooltipTicks, l = t.tooltipAxis, c = t.tooltipTicks, f = Wxe(a, s, c, l);
  if (f >= 0 && c) {
    var d = c[f] && c[f].value, p = Hw(t, n, f, d), m = AEe(r, s, f, o);
    return {
      activeTooltipIndex: f,
      activeLabel: d,
      activePayload: p,
      activeCoordinate: m
    };
  }
  return null;
}, TEe = function(t, n) {
  var r = n.axes, i = n.graphicalItems, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, f = t.layout, d = t.children, p = t.stackOffset, m = zF(f, o);
  return r.reduce(function(y, g) {
    var v, x = g.type.defaultProps !== void 0 ? se(se({}, g.type.defaultProps), g.props) : g.props, w = x.type, S = x.dataKey, A = x.allowDataOverflow, _ = x.allowDuplicatedCategory, O = x.scale, P = x.ticks, C = x.includeHidden, k = x[a];
    if (y[k])
      return y;
    var D = Py(t.data, {
      graphicalItems: i.filter(function(ee) {
        var ie, re = a in ee.props ? ee.props[a] : (ie = ee.type.defaultProps) === null || ie === void 0 ? void 0 : ie[a];
        return re === k;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), $ = D.length, N, R, L;
    JCe(x.domain, A, w) && (N = rw(x.domain, null, A), m && (w === "number" || O !== "auto") && (L = nf(D, S, "category")));
    var F = hz(w);
    if (!N || N.length === 0) {
      var W, z = (W = x.domain) !== null && W !== void 0 ? W : F;
      if (S) {
        if (N = nf(D, S, w), w === "category" && m) {
          var G = Mae(N);
          _ && G ? (R = N, N = Im(0, $)) : _ || (N = XM(z, N, g).reduce(function(ee, ie) {
            return ee.indexOf(ie) >= 0 ? ee : [].concat(kc(ee), [ie]);
          }, []));
        } else if (w === "category")
          _ ? N = N.filter(function(ee) {
            return ee !== "" && !Ue(ee);
          }) : N = XM(z, N, g).reduce(function(ee, ie) {
            return ee.indexOf(ie) >= 0 || ie === "" || Ue(ie) ? ee : [].concat(kc(ee), [ie]);
          }, []);
        else if (w === "number") {
          var U = Kxe(D, i.filter(function(ee) {
            var ie, re, le = a in ee.props ? ee.props[a] : (ie = ee.type.defaultProps) === null || ie === void 0 ? void 0 : ie[a], ae = "hide" in ee.props ? ee.props.hide : (re = ee.type.defaultProps) === null || re === void 0 ? void 0 : re.hide;
            return le === k && (C || !ae);
          }), S, o, f);
          U && (N = U);
        }
        m && (w === "number" || O !== "auto") && (L = nf(D, S, "category"));
      } else m ? N = Im(0, $) : s && s[k] && s[k].hasStack && w === "number" ? N = p === "expand" ? [0, 1] : GF(s[k].stackGroups, l, c) : N = WF(D, i.filter(function(ee) {
        var ie = a in ee.props ? ee.props[a] : ee.type.defaultProps[a], re = "hide" in ee.props ? ee.props.hide : ee.type.defaultProps.hide;
        return ie === k && (C || !re);
      }), w, f, !0);
      if (w === "number")
        N = zw(d, N, k, o, P), z && (N = rw(z, N, A));
      else if (w === "category" && z) {
        var V = z, Y = N.every(function(ee) {
          return V.indexOf(ee) >= 0;
        });
        Y && (N = V);
      }
    }
    return se(se({}, y), {}, We({}, k, se(se({}, x), {}, {
      axisType: o,
      domain: N,
      categoricalDomain: L,
      duplicateDomain: R,
      originalDomain: (v = x.domain) !== null && v !== void 0 ? v : F,
      isCategorical: m,
      layout: f
    })));
  }, {});
}, PEe = function(t, n) {
  var r = n.graphicalItems, i = n.Axis, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, f = t.layout, d = t.children, p = Py(t.data, {
    graphicalItems: r,
    dataStartIndex: l,
    dataEndIndex: c
  }), m = p.length, y = zF(f, o), g = -1;
  return r.reduce(function(v, x) {
    var w = x.type.defaultProps !== void 0 ? se(se({}, x.type.defaultProps), x.props) : x.props, S = w[a], A = hz("number");
    if (!v[S]) {
      g++;
      var _;
      return y ? _ = Im(0, m) : s && s[S] && s[S].hasStack ? (_ = GF(s[S].stackGroups, l, c), _ = zw(d, _, S, o)) : (_ = rw(A, WF(p, r.filter(function(O) {
        var P, C, k = a in O.props ? O.props[a] : (P = O.type.defaultProps) === null || P === void 0 ? void 0 : P[a], D = "hide" in O.props ? O.props.hide : (C = O.type.defaultProps) === null || C === void 0 ? void 0 : C.hide;
        return k === S && !D;
      }), "number", f), i.defaultProps.allowDataOverflow), _ = zw(d, _, S, o)), se(se({}, v), {}, We({}, S, se(se({
        axisType: o
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: zr(_Ee, "".concat(o, ".").concat(g % 2), null),
        domain: _,
        originalDomain: A,
        isCategorical: y,
        layout: f
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return v;
  }, {});
}, CEe = function(t, n) {
  var r = n.axisType, i = r === void 0 ? "xAxis" : r, o = n.AxisComp, a = n.graphicalItems, s = n.stackGroups, l = n.dataStartIndex, c = n.dataEndIndex, f = t.children, d = "".concat(i, "Id"), p = Vr(f, o), m = {};
  return p && p.length ? m = TEe(t, {
    axes: p,
    graphicalItems: a,
    axisType: i,
    axisIdKey: d,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  }) : a && a.length && (m = PEe(t, {
    Axis: o,
    graphicalItems: a,
    axisType: i,
    axisIdKey: d,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  })), m;
}, EEe = function(t) {
  var n = _a(t), r = ko(n, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: J_(r, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: n,
    tooltipAxisBandSize: _m(n, r)
  };
}, F$ = function(t) {
  var n = t.children, r = t.defaultShowTooltip, i = jr(n, vc), o = 0, a = 0;
  return t.data && t.data.length !== 0 && (a = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (o = i.props.startIndex), i.props.endIndex >= 0 && (a = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: o,
    dataEndIndex: a,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, kEe = function(t) {
  return !t || !t.length ? !1 : t.some(function(n) {
    var r = Ro(n && n.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, W$ = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, MEe = function(t, n) {
  var r = t.props, i = t.graphicalItems, o = t.xAxisMap, a = o === void 0 ? {} : o, s = t.yAxisMap, l = s === void 0 ? {} : s, c = r.width, f = r.height, d = r.children, p = r.margin || {}, m = jr(d, vc), y = jr(d, jo), g = Object.keys(l).reduce(function(_, O) {
    var P = l[O], C = P.orientation;
    return !P.mirror && !P.hide ? se(se({}, _), {}, We({}, C, _[C] + P.width)) : _;
  }, {
    left: p.left || 0,
    right: p.right || 0
  }), v = Object.keys(a).reduce(function(_, O) {
    var P = a[O], C = P.orientation;
    return !P.mirror && !P.hide ? se(se({}, _), {}, We({}, C, zr(_, "".concat(C)) + P.height)) : _;
  }, {
    top: p.top || 0,
    bottom: p.bottom || 0
  }), x = se(se({}, v), g), w = x.bottom;
  m && (x.bottom += m.props.height || vc.defaultProps.height), y && n && (x = Uxe(x, i, r, n));
  var S = c - x.left - x.right, A = f - x.top - x.bottom;
  return se(se({
    brushBottom: w
  }, x), {}, {
    // never return negative values for height and width
    width: Math.max(S, 0),
    height: Math.max(A, 0)
  });
}, NEe = function(t, n) {
  if (n === "xAxis")
    return t[n].width;
  if (n === "yAxis")
    return t[n].height;
}, Cy = function(t) {
  var n = t.chartName, r = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, a = t.validateTooltipEventTypes, s = a === void 0 ? ["axis"] : a, l = t.axisComponents, c = t.legendContent, f = t.formatAxisMap, d = t.defaultProps, p = function(x, w) {
    var S = w.graphicalItems, A = w.stackGroups, _ = w.offset, O = w.updateId, P = w.dataStartIndex, C = w.dataEndIndex, k = x.barSize, D = x.layout, $ = x.barGap, N = x.barCategoryGap, R = x.maxBarSize, L = W$(D), F = L.numericAxisName, W = L.cateAxisName, z = kEe(S), G = [];
    return S.forEach(function(U, V) {
      var Y = Py(x.data, {
        graphicalItems: [U],
        dataStartIndex: P,
        dataEndIndex: C
      }), ee = U.type.defaultProps !== void 0 ? se(se({}, U.type.defaultProps), U.props) : U.props, ie = ee.dataKey, re = ee.maxBarSize, le = ee["".concat(F, "Id")], ae = ee["".concat(W, "Id")], ue = {}, ne = l.reduce(function(Oe, Ke) {
        var Zt, mt, en = w["".concat(Ke.axisType, "Map")], Yr = ee["".concat(Ke.axisType, "Id")];
        en && en[Yr] || Ke.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Sr(!1, "Specifying a(n) ".concat(Ke.axisType, "Id requires a corresponding ").concat(
          Ke.axisType,
          "Id on the targeted graphical component "
        ).concat((Zt = U == null || (mt = U.type) === null || mt === void 0 ? void 0 : mt.displayName) !== null && Zt !== void 0 ? Zt : "")) : Sr());
        var Cn = en[Yr];
        return se(se({}, Oe), {}, We(We({}, Ke.axisType, Cn), "".concat(Ke.axisType, "Ticks"), ko(Cn)));
      }, ue), J = ne[W], fe = ne["".concat(W, "Ticks")], be = A && A[le] && A[le].hasStack && twe(U, A[le].stackGroups), X = Ro(U.type).indexOf("Bar") >= 0, De = _m(J, fe), pe = [], ke = z && zxe({
        barSize: k,
        stackGroups: A,
        totalSize: NEe(ne, W)
      });
      if (X) {
        var it, st, Xn = Ue(re) ? R : re, Ie = (it = (st = _m(J, fe, !0)) !== null && st !== void 0 ? st : Xn) !== null && it !== void 0 ? it : 0;
        pe = Vxe({
          barGap: $,
          barCategoryGap: N,
          bandSize: Ie !== De ? Ie : De,
          sizeList: ke[ae],
          maxBarSize: Xn
        }), Ie !== De && (pe = pe.map(function(Oe) {
          return se(se({}, Oe), {}, {
            position: se(se({}, Oe.position), {}, {
              offset: Oe.position.offset - Ie / 2
            })
          });
        }));
      }
      var lt = U && U.type && U.type.getComposedData;
      lt && G.push({
        props: se(se({}, lt(se(se({}, ne), {}, {
          displayedData: Y,
          props: x,
          dataKey: ie,
          item: U,
          bandSize: De,
          barPosition: pe,
          offset: _,
          stackedData: be,
          layout: D,
          dataStartIndex: P,
          dataEndIndex: C
        }))), {}, We(We(We({
          key: U.key || "item-".concat(V)
        }, F, ne[F]), W, ne[W]), "animationId", O)),
        childIndex: zae(U, x.children),
        item: U
      });
    }), G;
  }, m = function(x, w) {
    var S = x.props, A = x.dataStartIndex, _ = x.dataEndIndex, O = x.updateId;
    if (!UE({
      props: S
    }))
      return null;
    var P = S.children, C = S.layout, k = S.stackOffset, D = S.data, $ = S.reverseStackOrder, N = W$(C), R = N.numericAxisName, L = N.cateAxisName, F = Vr(P, r), W = Qxe(D, F, "".concat(R, "Id"), "".concat(L, "Id"), k, $), z = l.reduce(function(ee, ie) {
      var re = "".concat(ie.axisType, "Map");
      return se(se({}, ee), {}, We({}, re, CEe(S, se(se({}, ie), {}, {
        graphicalItems: F,
        stackGroups: ie.axisType === R && W,
        dataStartIndex: A,
        dataEndIndex: _
      }))));
    }, {}), G = MEe(se(se({}, z), {}, {
      props: S,
      graphicalItems: F
    }), w == null ? void 0 : w.legendBBox);
    Object.keys(z).forEach(function(ee) {
      z[ee] = f(S, z[ee], G, ee.replace("Map", ""), n);
    });
    var U = z["".concat(L, "Map")], V = EEe(U), Y = p(S, se(se({}, z), {}, {
      dataStartIndex: A,
      dataEndIndex: _,
      updateId: O,
      graphicalItems: F,
      stackGroups: W,
      offset: G
    }));
    return se(se({
      formattedGraphicalItems: Y,
      graphicalItems: F,
      offset: G,
      stackGroups: W
    }, V), z);
  }, y = /* @__PURE__ */ function(v) {
    function x(w) {
      var S, A, _;
      return fEe(this, x), _ = pEe(this, x, [w]), We(_, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), We(_, "accessibilityManager", new ZCe()), We(_, "handleLegendBBoxUpdate", function(O) {
        if (O) {
          var P = _.state, C = P.dataStartIndex, k = P.dataEndIndex, D = P.updateId;
          _.setState(se({
            legendBBox: O
          }, m({
            props: _.props,
            dataStartIndex: C,
            dataEndIndex: k,
            updateId: D
          }, se(se({}, _.state), {}, {
            legendBBox: O
          }))));
        }
      }), We(_, "handleReceiveSyncEvent", function(O, P, C) {
        if (_.props.syncId === O) {
          if (C === _.eventEmitterSymbol && typeof _.props.syncMethod != "function")
            return;
          _.applySyncEvent(P);
        }
      }), We(_, "handleBrushChange", function(O) {
        var P = O.startIndex, C = O.endIndex;
        if (P !== _.state.dataStartIndex || C !== _.state.dataEndIndex) {
          var k = _.state.updateId;
          _.setState(function() {
            return se({
              dataStartIndex: P,
              dataEndIndex: C
            }, m({
              props: _.props,
              dataStartIndex: P,
              dataEndIndex: C,
              updateId: k
            }, _.state));
          }), _.triggerSyncEvent({
            dataStartIndex: P,
            dataEndIndex: C
          });
        }
      }), We(_, "handleMouseEnter", function(O) {
        var P = _.getMouseInfo(O);
        if (P) {
          var C = se(se({}, P), {}, {
            isTooltipActive: !0
          });
          _.setState(C), _.triggerSyncEvent(C);
          var k = _.props.onMouseEnter;
          ze(k) && k(C, O);
        }
      }), We(_, "triggeredAfterMouseMove", function(O) {
        var P = _.getMouseInfo(O), C = P ? se(se({}, P), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        _.setState(C), _.triggerSyncEvent(C);
        var k = _.props.onMouseMove;
        ze(k) && k(C, O);
      }), We(_, "handleItemMouseEnter", function(O) {
        _.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: O,
            activePayload: O.tooltipPayload,
            activeCoordinate: O.tooltipPosition || {
              x: O.cx,
              y: O.cy
            }
          };
        });
      }), We(_, "handleItemMouseLeave", function() {
        _.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), We(_, "handleMouseMove", function(O) {
        O.persist(), _.throttleTriggeredAfterMouseMove(O);
      }), We(_, "handleMouseLeave", function(O) {
        _.throttleTriggeredAfterMouseMove.cancel();
        var P = {
          isTooltipActive: !1
        };
        _.setState(P), _.triggerSyncEvent(P);
        var C = _.props.onMouseLeave;
        ze(C) && C(P, O);
      }), We(_, "handleOuterEvent", function(O) {
        var P = Wae(O), C = zr(_.props, "".concat(P));
        if (P && ze(C)) {
          var k, D;
          /.*touch.*/i.test(P) ? D = _.getMouseInfo(O.changedTouches[0]) : D = _.getMouseInfo(O), C((k = D) !== null && k !== void 0 ? k : {}, O);
        }
      }), We(_, "handleClick", function(O) {
        var P = _.getMouseInfo(O);
        if (P) {
          var C = se(se({}, P), {}, {
            isTooltipActive: !0
          });
          _.setState(C), _.triggerSyncEvent(C);
          var k = _.props.onClick;
          ze(k) && k(C, O);
        }
      }), We(_, "handleMouseDown", function(O) {
        var P = _.props.onMouseDown;
        if (ze(P)) {
          var C = _.getMouseInfo(O);
          P(C, O);
        }
      }), We(_, "handleMouseUp", function(O) {
        var P = _.props.onMouseUp;
        if (ze(P)) {
          var C = _.getMouseInfo(O);
          P(C, O);
        }
      }), We(_, "handleTouchMove", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && _.throttleTriggeredAfterMouseMove(O.changedTouches[0]);
      }), We(_, "handleTouchStart", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && _.handleMouseDown(O.changedTouches[0]);
      }), We(_, "handleTouchEnd", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && _.handleMouseUp(O.changedTouches[0]);
      }), We(_, "triggerSyncEvent", function(O) {
        _.props.syncId !== void 0 && s0.emit(l0, _.props.syncId, O, _.eventEmitterSymbol);
      }), We(_, "applySyncEvent", function(O) {
        var P = _.props, C = P.layout, k = P.syncMethod, D = _.state.updateId, $ = O.dataStartIndex, N = O.dataEndIndex;
        if (O.dataStartIndex !== void 0 || O.dataEndIndex !== void 0)
          _.setState(se({
            dataStartIndex: $,
            dataEndIndex: N
          }, m({
            props: _.props,
            dataStartIndex: $,
            dataEndIndex: N,
            updateId: D
          }, _.state)));
        else if (O.activeTooltipIndex !== void 0) {
          var R = O.chartX, L = O.chartY, F = O.activeTooltipIndex, W = _.state, z = W.offset, G = W.tooltipTicks;
          if (!z)
            return;
          if (typeof k == "function")
            F = k(G, O);
          else if (k === "value") {
            F = -1;
            for (var U = 0; U < G.length; U++)
              if (G[U].value === O.activeLabel) {
                F = U;
                break;
              }
          }
          var V = se(se({}, z), {}, {
            x: z.left,
            y: z.top
          }), Y = Math.min(R, V.x + V.width), ee = Math.min(L, V.y + V.height), ie = G[F] && G[F].value, re = Hw(_.state, _.props.data, F), le = G[F] ? {
            x: C === "horizontal" ? G[F].coordinate : Y,
            y: C === "horizontal" ? ee : G[F].coordinate
          } : dz;
          _.setState(se(se({}, O), {}, {
            activeLabel: ie,
            activeCoordinate: le,
            activePayload: re,
            activeTooltipIndex: F
          }));
        } else
          _.setState(O);
      }), We(_, "renderCursor", function(O) {
        var P, C = _.state, k = C.isTooltipActive, D = C.activeCoordinate, $ = C.activePayload, N = C.offset, R = C.activeTooltipIndex, L = C.tooltipAxisBandSize, F = _.getTooltipEventType(), W = (P = O.props.active) !== null && P !== void 0 ? P : k, z = _.props.layout, G = O.key || "_recharts-cursor";
        return /* @__PURE__ */ I.createElement(iEe, {
          key: G,
          activeCoordinate: D,
          activePayload: $,
          activeTooltipIndex: R,
          chartName: n,
          element: O,
          isActive: W,
          layout: z,
          offset: N,
          tooltipAxisBandSize: L,
          tooltipEventType: F
        });
      }), We(_, "renderPolarAxis", function(O, P, C) {
        var k = zr(O, "type.axisType"), D = zr(_.state, "".concat(k, "Map")), $ = O.type.defaultProps, N = $ !== void 0 ? se(se({}, $), O.props) : O.props, R = D && D[N["".concat(k, "Id")]];
        return /* @__PURE__ */ ht(O, se(se({}, R), {}, {
          className: Ye(k, R.className),
          key: O.key || "".concat(P, "-").concat(C),
          ticks: ko(R, !0)
        }));
      }), We(_, "renderPolarGrid", function(O) {
        var P = O.props, C = P.radialLines, k = P.polarAngles, D = P.polarRadius, $ = _.state, N = $.radiusAxisMap, R = $.angleAxisMap, L = _a(N), F = _a(R), W = F.cx, z = F.cy, G = F.innerRadius, U = F.outerRadius;
        return /* @__PURE__ */ ht(O, {
          polarAngles: Array.isArray(k) ? k : ko(F, !0).map(function(V) {
            return V.coordinate;
          }),
          polarRadius: Array.isArray(D) ? D : ko(L, !0).map(function(V) {
            return V.coordinate;
          }),
          cx: W,
          cy: z,
          innerRadius: G,
          outerRadius: U,
          key: O.key || "polar-grid",
          radialLines: C
        });
      }), We(_, "renderLegend", function() {
        var O = _.state.formattedGraphicalItems, P = _.props, C = P.children, k = P.width, D = P.height, $ = _.props.margin || {}, N = k - ($.left || 0) - ($.right || 0), R = BF({
          children: C,
          formattedGraphicalItems: O,
          legendWidth: N,
          legendContent: c
        });
        if (!R)
          return null;
        var L = R.item, F = j$(R, oEe);
        return /* @__PURE__ */ ht(L, se(se({}, F), {}, {
          chartWidth: k,
          chartHeight: D,
          margin: $,
          onBBoxUpdate: _.handleLegendBBoxUpdate
        }));
      }), We(_, "renderTooltip", function() {
        var O, P = _.props, C = P.children, k = P.accessibilityLayer, D = jr(C, Lr);
        if (!D)
          return null;
        var $ = _.state, N = $.isTooltipActive, R = $.activeCoordinate, L = $.activePayload, F = $.activeLabel, W = $.offset, z = (O = D.props.active) !== null && O !== void 0 ? O : N;
        return /* @__PURE__ */ ht(D, {
          viewBox: se(se({}, W), {}, {
            x: W.left,
            y: W.top
          }),
          active: z,
          label: F,
          payload: z ? L : [],
          coordinate: R,
          accessibilityLayer: k
        });
      }), We(_, "renderBrush", function(O) {
        var P = _.props, C = P.margin, k = P.data, D = _.state, $ = D.offset, N = D.dataStartIndex, R = D.dataEndIndex, L = D.updateId;
        return /* @__PURE__ */ ht(O, {
          key: O.key || "_recharts-brush",
          onChange: Xh(_.handleBrushChange, O.props.onChange),
          data: k,
          x: ve(O.props.x) ? O.props.x : $.left,
          y: ve(O.props.y) ? O.props.y : $.top + $.height + $.brushBottom - (C.bottom || 0),
          width: ve(O.props.width) ? O.props.width : $.width,
          startIndex: N,
          endIndex: R,
          updateId: "brush-".concat(L)
        });
      }), We(_, "renderReferenceElement", function(O, P, C) {
        if (!O)
          return null;
        var k = _, D = k.clipPathId, $ = _.state, N = $.xAxisMap, R = $.yAxisMap, L = $.offset, F = O.type.defaultProps || {}, W = O.props, z = W.xAxisId, G = z === void 0 ? F.xAxisId : z, U = W.yAxisId, V = U === void 0 ? F.yAxisId : U;
        return /* @__PURE__ */ ht(O, {
          key: O.key || "".concat(P, "-").concat(C),
          xAxis: N[G],
          yAxis: R[V],
          viewBox: {
            x: L.left,
            y: L.top,
            width: L.width,
            height: L.height
          },
          clipPathId: D
        });
      }), We(_, "renderActivePoints", function(O) {
        var P = O.item, C = O.activePoint, k = O.basePoint, D = O.childIndex, $ = O.isRange, N = [], R = P.props.key, L = P.item.type.defaultProps !== void 0 ? se(se({}, P.item.type.defaultProps), P.item.props) : P.item.props, F = L.activeDot, W = L.dataKey, z = se(se({
          index: D,
          dataKey: W,
          cx: C.x,
          cy: C.y,
          r: 4,
          fill: TS(P.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: C.payload,
          value: C.value
        }, Ee(F, !1)), Yp(F));
        return N.push(x.renderActiveDot(F, z, "".concat(R, "-activePoint-").concat(D))), k ? N.push(x.renderActiveDot(F, se(se({}, z), {}, {
          cx: k.x,
          cy: k.y
        }), "".concat(R, "-basePoint-").concat(D))) : $ && N.push(null), N;
      }), We(_, "renderGraphicChild", function(O, P, C) {
        var k = _.filterFormatItem(O, P, C);
        if (!k)
          return null;
        var D = _.getTooltipEventType(), $ = _.state, N = $.isTooltipActive, R = $.tooltipAxis, L = $.activeTooltipIndex, F = $.activeLabel, W = _.props.children, z = jr(W, Lr), G = k.props, U = G.points, V = G.isRange, Y = G.baseLine, ee = k.item.type.defaultProps !== void 0 ? se(se({}, k.item.type.defaultProps), k.item.props) : k.item.props, ie = ee.activeDot, re = ee.hide, le = ee.activeBar, ae = ee.activeShape, ue = !!(!re && N && z && (ie || le || ae)), ne = {};
        D !== "axis" && z && z.props.trigger === "click" ? ne = {
          onClick: Xh(_.handleItemMouseEnter, O.props.onClick)
        } : D !== "axis" && (ne = {
          onMouseLeave: Xh(_.handleItemMouseLeave, O.props.onMouseLeave),
          onMouseEnter: Xh(_.handleItemMouseEnter, O.props.onMouseEnter)
        });
        var J = /* @__PURE__ */ ht(O, se(se({}, k.props), ne));
        function fe(Ke) {
          return typeof R.dataKey == "function" ? R.dataKey(Ke.payload) : null;
        }
        if (ue)
          if (L >= 0) {
            var be, X;
            if (R.dataKey && !R.allowDuplicatedCategory) {
              var De = typeof R.dataKey == "function" ? fe : "payload.".concat(R.dataKey.toString());
              be = Gp(U, De, F), X = V && Y && Gp(Y, De, F);
            } else
              be = U == null ? void 0 : U[L], X = V && Y && Y[L];
            if (ae || le) {
              var pe = O.props.activeIndex !== void 0 ? O.props.activeIndex : L;
              return [/* @__PURE__ */ ht(O, se(se(se({}, k.props), ne), {}, {
                activeIndex: pe
              })), null, null];
            }
            if (!Ue(be))
              return [J].concat(kc(_.renderActivePoints({
                item: k,
                activePoint: be,
                basePoint: X,
                childIndex: L,
                isRange: V
              })));
          } else {
            var ke, it = (ke = _.getItemByXY(_.state.activeCoordinate)) !== null && ke !== void 0 ? ke : {
              graphicalItem: J
            }, st = it.graphicalItem, Xn = st.item, Ie = Xn === void 0 ? O : Xn, lt = st.childIndex, Oe = se(se(se({}, k.props), ne), {}, {
              activeIndex: lt
            });
            return [/* @__PURE__ */ ht(Ie, Oe), null, null];
          }
        return V ? [J, null, null] : [J, null];
      }), We(_, "renderCustomized", function(O, P, C) {
        return /* @__PURE__ */ ht(O, se(se({
          key: "recharts-customized-".concat(C)
        }, _.props), _.state));
      }), We(_, "renderMap", {
        CartesianGrid: {
          handler: np,
          once: !0
        },
        ReferenceArea: {
          handler: _.renderReferenceElement
        },
        ReferenceLine: {
          handler: np
        },
        ReferenceDot: {
          handler: _.renderReferenceElement
        },
        XAxis: {
          handler: np
        },
        YAxis: {
          handler: np
        },
        Brush: {
          handler: _.renderBrush,
          once: !0
        },
        Bar: {
          handler: _.renderGraphicChild
        },
        Line: {
          handler: _.renderGraphicChild
        },
        Area: {
          handler: _.renderGraphicChild
        },
        Radar: {
          handler: _.renderGraphicChild
        },
        RadialBar: {
          handler: _.renderGraphicChild
        },
        Scatter: {
          handler: _.renderGraphicChild
        },
        Pie: {
          handler: _.renderGraphicChild
        },
        Funnel: {
          handler: _.renderGraphicChild
        },
        Tooltip: {
          handler: _.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: _.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: _.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: _.renderPolarAxis
        },
        Customized: {
          handler: _.renderCustomized
        }
      }), _.clipPathId = "".concat((S = w.id) !== null && S !== void 0 ? S : Qs("recharts"), "-clip"), _.throttleTriggeredAfterMouseMove = LB(_.triggeredAfterMouseMove, (A = w.throttleDelay) !== null && A !== void 0 ? A : 1e3 / 60), _.state = {}, _;
    }
    return yEe(x, v), hEe(x, [{
      key: "componentDidMount",
      value: function() {
        var S, A;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (S = this.props.margin.left) !== null && S !== void 0 ? S : 0,
            top: (A = this.props.margin.top) !== null && A !== void 0 ? A : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var S = this.props, A = S.children, _ = S.data, O = S.height, P = S.layout, C = jr(A, Lr);
        if (C) {
          var k = C.props.defaultIndex;
          if (!(typeof k != "number" || k < 0 || k > this.state.tooltipTicks.length - 1)) {
            var D = this.state.tooltipTicks[k] && this.state.tooltipTicks[k].value, $ = Hw(this.state, _, k, D), N = this.state.tooltipTicks[k].coordinate, R = (this.state.offset.top + O) / 2, L = P === "horizontal", F = L ? {
              x: N,
              y: R
            } : {
              y: N,
              x: R
            }, W = this.state.formattedGraphicalItems.find(function(G) {
              var U = G.item;
              return U.type.name === "Scatter";
            });
            W && (F = se(se({}, F), W.props.points[k].tooltipPosition), $ = W.props.points[k].tooltipPayload);
            var z = {
              activeTooltipIndex: k,
              isTooltipActive: !0,
              activeLabel: D,
              activePayload: $,
              activeCoordinate: F
            };
            this.setState(z), this.renderCursor(C), this.accessibilityManager.setIndex(k);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(S, A) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== A.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== S.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== S.margin) {
          var _, O;
          this.accessibilityManager.setDetails({
            offset: {
              left: (_ = this.props.margin.left) !== null && _ !== void 0 ? _ : 0,
              top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(S) {
        vx([jr(S.children, Lr)], [jr(this.props.children, Lr)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var S = jr(this.props.children, Lr);
        if (S && typeof S.props.shared == "boolean") {
          var A = S.props.shared ? "axis" : "item";
          return s.indexOf(A) >= 0 ? A : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(S) {
        if (!this.container)
          return null;
        var A = this.container, _ = A.getBoundingClientRect(), O = mye(_), P = {
          chartX: Math.round(S.pageX - O.left),
          chartY: Math.round(S.pageY - O.top)
        }, C = _.width / A.offsetWidth || 1, k = this.inRange(P.chartX, P.chartY, C);
        if (!k)
          return null;
        var D = this.state, $ = D.xAxisMap, N = D.yAxisMap, R = this.getTooltipEventType();
        if (R !== "axis" && $ && N) {
          var L = _a($).scale, F = _a(N).scale, W = L && L.invert ? L.invert(P.chartX) : null, z = F && F.invert ? F.invert(P.chartY) : null;
          return se(se({}, P), {}, {
            xValue: W,
            yValue: z
          });
        }
        var G = B$(this.state, this.props.data, this.props.layout, k);
        return G ? se(se({}, P), G) : null;
      }
    }, {
      key: "inRange",
      value: function(S, A) {
        var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, O = this.props.layout, P = S / _, C = A / _;
        if (O === "horizontal" || O === "vertical") {
          var k = this.state.offset, D = P >= k.left && P <= k.left + k.width && C >= k.top && C <= k.top + k.height;
          return D ? {
            x: P,
            y: C
          } : null;
        }
        var $ = this.state, N = $.angleAxisMap, R = $.radiusAxisMap;
        if (N && R) {
          var L = _a(N);
          return QM({
            x: P,
            y: C
          }, L);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var S = this.props.children, A = this.getTooltipEventType(), _ = jr(S, Lr), O = {};
        _ && A === "axis" && (_.props.trigger === "click" ? O = {
          onClick: this.handleClick
        } : O = {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        });
        var P = Yp(this.props, this.handleOuterEvent);
        return se(se({}, P), O);
      }
    }, {
      key: "addListener",
      value: function() {
        s0.on(l0, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        s0.removeListener(l0, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(S, A, _) {
        for (var O = this.state.formattedGraphicalItems, P = 0, C = O.length; P < C; P++) {
          var k = O[P];
          if (k.item === S || k.props.key === S.key || A === Ro(k.item.type) && _ === k.childIndex)
            return k;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var S = this.clipPathId, A = this.state.offset, _ = A.left, O = A.top, P = A.height, C = A.width;
        return /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("clipPath", {
          id: S
        }, /* @__PURE__ */ I.createElement("rect", {
          x: _,
          y: O,
          height: P,
          width: C
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var S = this.state.xAxisMap;
        return S ? Object.entries(S).reduce(function(A, _) {
          var O = R$(_, 2), P = O[0], C = O[1];
          return se(se({}, A), {}, We({}, P, C.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var S = this.state.yAxisMap;
        return S ? Object.entries(S).reduce(function(A, _) {
          var O = R$(_, 2), P = O[0], C = O[1];
          return se(se({}, A), {}, We({}, P, C.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(S) {
        var A;
        return (A = this.state.xAxisMap) === null || A === void 0 || (A = A[S]) === null || A === void 0 ? void 0 : A.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(S) {
        var A;
        return (A = this.state.yAxisMap) === null || A === void 0 || (A = A[S]) === null || A === void 0 ? void 0 : A.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(S) {
        var A = this.state, _ = A.formattedGraphicalItems, O = A.activeItem;
        if (_ && _.length)
          for (var P = 0, C = _.length; P < C; P++) {
            var k = _[P], D = k.props, $ = k.item, N = $.type.defaultProps !== void 0 ? se(se({}, $.type.defaultProps), $.props) : $.props, R = Ro($.type);
            if (R === "Bar") {
              var L = (D.data || []).find(function(G) {
                return K_e(S, G);
              });
              if (L)
                return {
                  graphicalItem: k,
                  payload: L
                };
            } else if (R === "RadialBar") {
              var F = (D.data || []).find(function(G) {
                return QM(S, G);
              });
              if (F)
                return {
                  graphicalItem: k,
                  payload: F
                };
            } else if (by(k, O) || xy(k, O) || ed(k, O)) {
              var W = DOe({
                graphicalItem: k,
                activeTooltipItem: O,
                itemData: N.data
              }), z = N.activeIndex === void 0 ? W : N.activeIndex;
              return {
                graphicalItem: se(se({}, k), {}, {
                  childIndex: z
                }),
                payload: ed(k, O) ? N.data[W] : k.props.data[W]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var S = this;
        if (!UE(this))
          return null;
        var A = this.props, _ = A.children, O = A.className, P = A.width, C = A.height, k = A.style, D = A.compact, $ = A.title, N = A.desc, R = j$(A, aEe), L = Ee(R, !1);
        if (D)
          return /* @__PURE__ */ I.createElement(g$, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ I.createElement(xx, Fl({}, L, {
            width: P,
            height: C,
            title: $,
            desc: N
          }), this.renderClipPath(), KE(_, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var F, W;
          L.tabIndex = (F = this.props.tabIndex) !== null && F !== void 0 ? F : 0, L.role = (W = this.props.role) !== null && W !== void 0 ? W : "application", L.onKeyDown = function(G) {
            S.accessibilityManager.keyboardEvent(G);
          }, L.onFocus = function() {
            S.accessibilityManager.focus();
          };
        }
        var z = this.parseEventsOfWrapper();
        return /* @__PURE__ */ I.createElement(g$, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ I.createElement("div", Fl({
          className: Ye("recharts-wrapper", O),
          style: se({
            position: "relative",
            cursor: "default",
            width: P,
            height: C
          }, k)
        }, z, {
          ref: function(U) {
            S.container = U;
          }
        }), /* @__PURE__ */ I.createElement(xx, Fl({}, L, {
          width: P,
          height: C,
          title: $,
          desc: N,
          style: SEe
        }), this.renderClipPath(), KE(_, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Gw);
  We(y, "displayName", n), We(y, "defaultProps", se({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, d)), We(y, "getDerivedStateFromProps", function(v, x) {
    var w = v.dataKey, S = v.data, A = v.children, _ = v.width, O = v.height, P = v.layout, C = v.stackOffset, k = v.margin, D = x.dataStartIndex, $ = x.dataEndIndex;
    if (x.updateId === void 0) {
      var N = F$(v);
      return se(se(se({}, N), {}, {
        updateId: 0
      }, m(se(se({
        props: v
      }, N), {}, {
        updateId: 0
      }), x)), {}, {
        prevDataKey: w,
        prevData: S,
        prevWidth: _,
        prevHeight: O,
        prevLayout: P,
        prevStackOffset: C,
        prevMargin: k,
        prevChildren: A
      });
    }
    if (w !== x.prevDataKey || S !== x.prevData || _ !== x.prevWidth || O !== x.prevHeight || P !== x.prevLayout || C !== x.prevStackOffset || !Kl(k, x.prevMargin)) {
      var R = F$(v), L = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: x.chartX,
        chartY: x.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: x.isTooltipActive
      }, F = se(se({}, B$(x, S, P)), {}, {
        updateId: x.updateId + 1
      }), W = se(se(se({}, R), L), F);
      return se(se(se({}, W), m(se({
        props: v
      }, W), x)), {}, {
        prevDataKey: w,
        prevData: S,
        prevWidth: _,
        prevHeight: O,
        prevLayout: P,
        prevStackOffset: C,
        prevMargin: k,
        prevChildren: A
      });
    }
    if (!vx(A, x.prevChildren)) {
      var z, G, U, V, Y = jr(A, vc), ee = Y && (z = (G = Y.props) === null || G === void 0 ? void 0 : G.startIndex) !== null && z !== void 0 ? z : D, ie = Y && (U = (V = Y.props) === null || V === void 0 ? void 0 : V.endIndex) !== null && U !== void 0 ? U : $, re = ee !== D || ie !== $, le = !Ue(S), ae = le && !re ? x.updateId : x.updateId + 1;
      return se(se({
        updateId: ae
      }, m(se(se({
        props: v
      }, x), {}, {
        updateId: ae,
        dataStartIndex: ee,
        dataEndIndex: ie
      }), x)), {}, {
        prevChildren: A,
        dataStartIndex: ee,
        dataEndIndex: ie
      });
    }
    return null;
  }), We(y, "renderActiveDot", function(v, x, w) {
    var S;
    return /* @__PURE__ */ rt(v) ? S = /* @__PURE__ */ ht(v, x) : ze(v) ? S = v(x) : S = /* @__PURE__ */ I.createElement(Dd, x), /* @__PURE__ */ I.createElement(at, {
      className: "recharts-active-dot",
      key: w
    }, S);
  });
  var g = /* @__PURE__ */ Dt(function(x, w) {
    return /* @__PURE__ */ I.createElement(y, Fl({}, x, {
      ref: w
    }));
  });
  return g.displayName = y.displayName, g;
}, $Ee = Cy({
  chartName: "LineChart",
  GraphicalChild: Id,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Go
  }, {
    axisType: "yAxis",
    AxisComp: Qi
  }],
  formatAxisMap: ES
}), DEe = Cy({
  chartName: "BarChart",
  GraphicalChild: nl,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Go
  }, {
    axisType: "yAxis",
    AxisComp: Qi
  }],
  formatAxisMap: ES
}), IEe = Cy({
  chartName: "PieChart",
  GraphicalChild: na,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: vy
  }, {
    axisType: "radiusAxis",
    AxisComp: gy
  }],
  formatAxisMap: fwe,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), REe = Cy({
  chartName: "AreaChart",
  GraphicalChild: qa,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Go
  }, {
    axisType: "yAxis",
    AxisComp: Qi
  }],
  formatAxisMap: ES
});
const pz = I.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n = [],
    // array of objects that represents the data for each legend item
    verticalAlign: r = "bottom",
    // top | bottom
    nameKey: i = "value",
    fontSizeVariant: o
  }, a) => n.length ? /* @__PURE__ */ E(
    "div",
    {
      ref: a,
      className: K(
        "flex items-center justify-center gap-4",
        r === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: n.map((s) => /* @__PURE__ */ he("div", { className: "flex items-center gap-1.5", children: [
        !t && /* @__PURE__ */ E(
          "div",
          {
            className: "size-2 shrink-0 rounded-sm",
            style: {
              backgroundColor: s.color
            }
          }
        ),
        /* @__PURE__ */ E(
          "span",
          {
            className: "capitalize",
            style: { fontSize: o },
            children: s[i]
          }
        )
      ] }, s.value))
    }
  ) : null
);
pz.displayName = "ChartLegendContent";
const mz = I.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    //dot, line, dashed
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const y = () => {
      if (i || !(t != null && t.length))
        return null;
      const [v] = t, x = s ? s(a || "") : v[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: K("font-medium", l), children: x }) : null;
    };
    if (!e || !(t != null && t.length))
      return null;
    const g = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ he(
      "div",
      {
        ref: m,
        className: K(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          g ? null : y(),
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((v, x) => {
            const w = f || v.color || "#000";
            return /* @__PURE__ */ he(
              "div",
              {
                className: K(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: K({
                        "size-2.5": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ he("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: v[d] || v.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(v.value ?? "") : v.value ?? "" })
                  ] })
                ]
              },
              v.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
mz.displayName = "ChartTooltipContent";
const oke = ({
  data: e,
  dataKeys: t = [],
  colors: n = [],
  layout: r = "horizontal",
  // horizontal, vertical
  stacked: i = !1,
  showXAxis: o = !0,
  showYAxis: a = !0,
  showTooltip: s = !0,
  tooltipIndicator: l = "dot",
  // dot, line, dashed
  tooltipLabelKey: c,
  showLegend: f = !1,
  showCartesianGrid: d = !0,
  xTickFormatter: p,
  yTickFormatter: m,
  xAxisDataKey: y,
  yAxisDataKey: g,
  xAxisFontSize: v = "sm",
  // sm, md, lg
  xAxisFontColor: x = "#6B7280",
  yAxisFontColor: w = "#6B7280",
  chartWidth: S = 350,
  chartHeight: A = 200,
  borderRadius: _ = 8,
  xAxisProps: O,
  yAxisProps: P,
  tooltipProps: C,
  activeBar: k
}) => {
  const D = [{ fill: "#7DD3FC" }, { fill: "#2563EB" }], $ = n.length > 0 ? n : D, N = {
    sm: "12px",
    md: "14px",
    lg: "16px"
  }, R = N[v] || N.sm;
  return !e || e.length === 0 ? /* @__PURE__ */ E(eo, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ E(eS, { width: S, height: A, children: /* @__PURE__ */ he(
    DEe,
    {
      data: e,
      margin: { left: 14, right: 14 },
      layout: r,
      children: [
        d && /* @__PURE__ */ E(Ty, { vertical: !1 }),
        r === "horizontal" && o && /* @__PURE__ */ E(
          Go,
          {
            ...O,
            dataKey: y,
            tickLine: !1,
            axisLine: !1,
            tickMargin: 8,
            tickFormatter: p,
            tick: {
              fontSize: R,
              fill: x
            }
          }
        ),
        r === "horizontal" && a && /* @__PURE__ */ E(
          Qi,
          {
            ...P,
            dataKey: g,
            tickLine: !1,
            tickMargin: 10,
            axisLine: !1,
            tickFormatter: m,
            tick: {
              fontSize: R,
              fill: w
            }
          }
        ),
        r === "vertical" && /* @__PURE__ */ he(Ut, { children: [
          /* @__PURE__ */ E(
            Go,
            {
              ...O,
              type: "number",
              dataKey: y,
              hide: !0
            }
          ),
          /* @__PURE__ */ E(
            Qi,
            {
              ...P,
              dataKey: g,
              type: "category",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              tickFormatter: p,
              tick: {
                fontSize: R,
                fill: w
              }
            }
          )
        ] }),
        a && /* @__PURE__ */ E(Qi, { dataKey: g }),
        s && /* @__PURE__ */ E(
          Lr,
          {
            ...C,
            content: /* @__PURE__ */ E(
              mz,
              {
                indicator: l,
                labelKey: c
              }
            )
          }
        ),
        f && /* @__PURE__ */ E(
          jo,
          {
            content: /* @__PURE__ */ E(
              pz,
              {
                fontSizeVariant: R
              }
            )
          }
        ),
        t.map((L, F) => {
          var z;
          let W;
          return i ? F === 0 ? W = [0, 0, 4, 4] : F === t.length - 1 ? W = [4, 4, 0, 0] : W = 0 : W = _, /* @__PURE__ */ E(
            nl,
            {
              dataKey: L,
              fill: (z = $[F]) == null ? void 0 : z.fill,
              radius: W,
              stackId: i ? "a" : void 0,
              activeBar: k
            },
            L
          );
        })
      ]
    }
  ) });
}, gz = I.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    //dot, line, dashed
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const y = () => {
      if (i || !(t != null && t.length))
        return null;
      const [v] = t, x = s ? s(a || "") : v[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: K("font-medium", l), children: x }) : null;
    };
    if (!e || !(t != null && t.length))
      return null;
    const g = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ he(
      "div",
      {
        ref: m,
        className: K(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          g ? null : y(),
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((v, x) => {
            const w = f || v.color || "#000";
            return /* @__PURE__ */ he(
              "div",
              {
                className: K(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: K({
                        "size-2.5 ": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ he("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: v[d] || v.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(v.value ?? "") : v.value ?? "" })
                  ] })
                ]
              },
              v.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
gz.displayName = "ChartTooltipContent";
const ake = ({
  data: e,
  dataKeys: t = [],
  colors: n = [],
  showXAxis: r = !1,
  showYAxis: i = !1,
  showTooltip: o = !0,
  tooltipIndicator: a = "dot",
  // dot, line, dashed
  tooltipLabelKey: s,
  showCartesianGrid: l = !0,
  tickFormatter: c,
  xAxisDataKey: f,
  yAxisDataKey: d,
  xAxisFontSize: p = "sm",
  // sm, md, lg
  xAxisFontColor: m = "#6B7280",
  yAxisFontColor: y = "#6B7280",
  chartWidth: g = 350,
  chartHeight: v = 200,
  withDots: x = !1,
  lineChartWrapperProps: w,
  strokeDasharray: S = "3 3",
  gridColor: A = "#E5E7EB"
}) => {
  const _ = [{ stroke: "#2563EB" }, { stroke: "#38BDF8" }], O = n.length > 0 ? n : _, P = {
    sm: "12px",
    md: "14px",
    lg: "16px"
  }, C = P[p] || P.sm;
  return !e || e.length === 0 ? /* @__PURE__ */ E(eo, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ E(eS, { width: g, height: v, children: /* @__PURE__ */ he($Ee, { ...w, data: e, children: [
    l && /* @__PURE__ */ E(
      Ty,
      {
        strokeDasharray: S,
        horizontal: !1,
        stroke: A
      }
    ),
    /* @__PURE__ */ E(
      Go,
      {
        dataKey: f,
        tickLine: !1,
        axisLine: !1,
        tickMargin: 8,
        tickFormatter: c,
        tick: {
          fontSize: C,
          fill: m
        },
        hide: !r
      }
    ),
    /* @__PURE__ */ E(
      Qi,
      {
        dataKey: d,
        tickLine: !1,
        axisLine: !1,
        tickMargin: 8,
        tick: {
          fontSize: C,
          fill: y
        },
        hide: !i
      }
    ),
    o && /* @__PURE__ */ E(
      Lr,
      {
        content: /* @__PURE__ */ E(
          gz,
          {
            indicator: a,
            labelKey: s
          }
        )
      }
    ),
    t.map((k, D) => /* @__PURE__ */ E(
      Id,
      {
        type: "natural",
        dataKey: k,
        stroke: O[D].stroke,
        fill: O[D].stroke,
        strokeWidth: 2,
        dot: x
      },
      k
    ))
  ] }) });
}, yz = I.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const y = () => {
      if (i || !(t != null && t.length))
        return null;
      const [v] = t, x = s ? s(a || "") : v[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: K("font-medium", l), children: x }) : null;
    };
    if (!e || !(t != null && t.length))
      return null;
    const g = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ he(
      "div",
      {
        ref: m,
        className: K(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          g ? null : y(),
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((v, x) => {
            var S;
            const w = v.color || ((S = v.payload) == null ? void 0 : S.fill) || f || "#000";
            return /* @__PURE__ */ he(
              "div",
              {
                className: K(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: K({
                        "h-2.5 w-2.5 ": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ he("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: v[d] || v.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(v.value ?? "") : v.value ?? "" })
                  ] })
                ]
              },
              v.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
yz.displayName = "ChartTooltipContent";
const vz = I.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n = [],
    // array of objects that represents the data for each legend item
    verticalAlign: r = "bottom",
    // top | bottom
    nameKey: i = "value"
  }, o) => n.length ? /* @__PURE__ */ E(
    "div",
    {
      ref: o,
      className: K(
        "flex items-center justify-center gap-4",
        r === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: n.map((a) => /* @__PURE__ */ he("div", { className: "flex items-center gap-1.5", children: [
        !t && /* @__PURE__ */ E(
          "div",
          {
            className: "h-2 w-2 shrink-0 rounded-sm",
            style: {
              backgroundColor: a.color
            }
          }
        ),
        /* @__PURE__ */ E("span", { className: "capitalize", children: a[i] })
      ] }, a.value))
    }
  ) : null
);
vz.displayName = "ChartLegendContent";
const ske = ({
  data: e,
  dataKey: t,
  type: n = "simple",
  // simple, donut
  showTooltip: r = !0,
  tooltipIndicator: i = "dot",
  // dot, line, dashed
  tooltipLabelKey: o,
  label: a = !1,
  labelName: s = "",
  labelNameColor: l = "#6B7280",
  labelValue: c,
  showLegend: f = !1,
  chartWidth: d = 300,
  pieOuterRadius: p = 90,
  pieInnerRadius: m = 60
}) => {
  const y = n === "donut", g = p, v = y ? m : 0;
  return !e || e.length === 0 ? /* @__PURE__ */ E(eo, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ he(IEe, { width: d, height: d, children: [
    r && /* @__PURE__ */ E(
      Lr,
      {
        content: /* @__PURE__ */ E(
          yz,
          {
            indicator: i,
            labelKey: o
          }
        )
      }
    ),
    f && /* @__PURE__ */ E(jo, { content: /* @__PURE__ */ E(vz, {}) }),
    /* @__PURE__ */ E(
      na,
      {
        data: e,
        cx: "50%",
        cy: "50%",
        innerRadius: v,
        outerRadius: g,
        dataKey: t,
        children: y && a && /* @__PURE__ */ E(
          Sn,
          {
            content: ({ viewBox: x }) => {
              if (x && "cx" in x && "cy" in x)
                return /* @__PURE__ */ he(
                  "text",
                  {
                    x: x.cx,
                    y: x.cy,
                    textAnchor: "middle",
                    dominantBaseline: "middle",
                    className: "space-y-3",
                    children: [
                      /* @__PURE__ */ E(
                        "tspan",
                        {
                          x: x.cx,
                          dy: "-4",
                          className: "fill-foreground text-xl font-bold",
                          children: c
                        }
                      ),
                      /* @__PURE__ */ E(
                        "tspan",
                        {
                          x: x.cx,
                          dy: "24",
                          className: "text-sm",
                          style: { fill: l },
                          children: s
                        }
                      )
                    ]
                  }
                );
            }
          }
        )
      }
    )
  ] });
}, bz = I.forwardRef(
  ({
    className: e,
    hideIcon: t = !1,
    payload: n = [],
    // array of objects that represents the data for each legend item
    verticalAlign: r = "bottom",
    // top | bottom
    nameKey: i = "value",
    fontSizeVariant: o
  }, a) => n.length ? /* @__PURE__ */ E(
    "div",
    {
      ref: a,
      className: K(
        "flex items-center justify-center gap-4",
        r === "top" ? "pb-3" : "pt-3",
        e
      ),
      children: n.map((s) => /* @__PURE__ */ he("div", { className: "flex items-center gap-1.5", children: [
        !t && /* @__PURE__ */ E(
          "div",
          {
            className: "size-2 shrink-0 rounded-sm",
            style: {
              backgroundColor: s.color
            }
          }
        ),
        /* @__PURE__ */ E(
          "span",
          {
            className: "capitalize",
            style: { fontSize: o },
            children: s[i]
          }
        )
      ] }, s.value))
    }
  ) : null
);
bz.displayName = "ChartLegendContent";
const xz = Dt(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r,
    // dot, line, dashed
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: c,
    color: f,
    nameKey: d = "name",
    labelKey: p
  }, m) => {
    const y = Fe(() => {
      if (i || !(t != null && t.length))
        return null;
      const [v] = t, x = s ? s(a || "") : v[p] || a;
      return x ? /* @__PURE__ */ E("div", { className: K("font-medium", l), children: x }) : null;
    }, [
      a,
      s,
      t,
      i,
      l,
      p
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const g = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ he(
      "div",
      {
        ref: m,
        className: K(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border bg-tooltip-background-light px-3 py-2 text-xs shadow-xl",
          n
        ),
        children: [
          g ? null : y,
          /* @__PURE__ */ E("div", { className: "grid gap-1.5", children: t.map((v, x) => {
            const w = f || v.color || "#000";
            return /* @__PURE__ */ he(
              "div",
              {
                className: K(
                  "flex w-full items-stretch gap-2",
                  r === "dot" && "items-center"
                ),
                children: [
                  !o && /* @__PURE__ */ E(
                    "div",
                    {
                      className: K({
                        "size-2.5": r === "dot",
                        "w-1 h-full": r === "line",
                        "w-0 border-[0.5px] border-dashed": r === "dashed"
                      }),
                      style: {
                        backgroundColor: r === "dot" || r === "line" ? w : "",
                        borderColor: r === "dashed" ? w : ""
                      }
                    }
                  ),
                  /* @__PURE__ */ he("div", { className: "flex-1 flex justify-between items-center", children: [
                    /* @__PURE__ */ E("span", { children: v[d] || v.dataKey }),
                    /* @__PURE__ */ E("span", { className: "font-mono font-medium", children: c ? c(v.value ?? "") : v.value ?? "" })
                  ] })
                ]
              },
              v.dataKey || x
            );
          }) })
        ]
      }
    );
  }
);
xz.displayName = "ChartTooltipContent";
const lke = ({
  data: e,
  dataKeys: t,
  colors: n = [],
  variant: r = "solid",
  showXAxis: i = !0,
  showYAxis: o = !0,
  showTooltip: a = !0,
  tooltipIndicator: s = "dot",
  // dot, line, dashed
  tooltipLabelKey: l,
  showLegend: c = !0,
  showCartesianGrid: f = !0,
  tickFormatter: d,
  xAxisDataKey: p,
  yAxisDataKey: m,
  xAxisFontSize: y = "sm",
  // sm, md, lg
  xAxisFontColor: g = "#6B7280",
  chartWidth: v = 350,
  chartHeight: x = 200
}) => {
  const [w, S] = Me(v), [A, _] = Me(x), O = [
    { stroke: "#2563EB", fill: "#BFDBFE" },
    { stroke: "#38BDF8", fill: "#BAE6FD" }
  ], P = n.length > 0 ? n : O;
  Xe(() => {
    S(v), _(x);
  }, [v, x]);
  const C = {
    sm: "12px",
    md: "14px",
    lg: "16px"
  }, k = C[y] || C.sm, D = () => /* @__PURE__ */ E("defs", { children: P.map(($, N) => /* @__PURE__ */ he(
    "linearGradient",
    {
      id: `fill${N}`,
      x1: "0",
      y1: "0",
      x2: "0",
      y2: "1",
      children: [
        /* @__PURE__ */ E(
          "stop",
          {
            offset: "5%",
            stopColor: $.fill,
            stopOpacity: 0.8
          }
        ),
        /* @__PURE__ */ E(
          "stop",
          {
            offset: "95%",
            stopColor: $.fill,
            stopOpacity: 0.1
          }
        )
      ]
    },
    `gradient${N}`
  )) });
  return !e || e.length === 0 ? /* @__PURE__ */ E(eo, { size: "sm", variant: "help", children: "No data available" }) : /* @__PURE__ */ E(eS, { width: w, height: A, children: /* @__PURE__ */ he(REe, { data: e, margin: { left: 14, right: 14 }, children: [
    f && /* @__PURE__ */ E(Ty, { vertical: !1 }),
    i && /* @__PURE__ */ E(
      Go,
      {
        dataKey: p,
        tickLine: !1,
        axisLine: !1,
        tickMargin: 8,
        tickFormatter: d,
        tick: {
          fontSize: k,
          fill: g
        }
      }
    ),
    o && /* @__PURE__ */ E(
      Qi,
      {
        dataKey: m,
        tickLine: !1,
        axisLine: !1,
        tickMargin: 8,
        tick: {
          fontSize: k,
          fill: g
        }
      }
    ),
    a && /* @__PURE__ */ E(
      Lr,
      {
        content: /* @__PURE__ */ E(
          xz,
          {
            indicator: s,
            labelKey: l
          }
        )
      }
    ),
    c && /* @__PURE__ */ E(
      jo,
      {
        content: /* @__PURE__ */ E(
          bz,
          {
            fontSizeVariant: k
          }
        )
      }
    ),
    r === "gradient" && D(),
    t.map(($, N) => /* @__PURE__ */ E(
      qa,
      {
        type: "monotone",
        dataKey: $,
        stroke: P[N % P.length].stroke,
        fill: r === "gradient" ? `url(#fill${N})` : P[N % P.length].fill,
        stackId: "1"
      },
      $
    ))
  ] }) });
}, wz = dt(null), jEe = () => Ve(wz), LEe = () => {
  const { file: e, removeFile: t, isLoading: n, error: r, errorText: i } = jEe(), o = Fe(() => /* @__PURE__ */ E("span", { className: "inline-flex self-start p-0.5", children: /* @__PURE__ */ E(ZH, { className: "size-5 text-icon-primary" }) }), [e]);
  return e ? /* @__PURE__ */ E(
    "div",
    {
      className: K(
        "border border-solid border-transparent flex items-start justify-between rounded mt-2 bg-field-primary-background p-3 gap-3",
        r && "border-alert-border-danger bg-alert-background-danger"
      ),
      children: /* @__PURE__ */ he("div", { className: "flex items-center gap-3 w-full", children: [
        n && o,
        !n && (e.type.startsWith("image/") ? /* @__PURE__ */ E(
          "div",
          {
            className: K(
              "size-10 rounded-sm flex items-center justify-center shrink-0",
              r && "bg-gray-200 "
            ),
            children: r ? /* @__PURE__ */ E(JH, { className: "size-6 text-field-helper" }) : /* @__PURE__ */ E(
              "img",
              {
                src: URL.createObjectURL(e),
                alt: "Preview",
                className: "w-full h-10 object-contain"
              }
            )
          }
        ) : o),
        /* @__PURE__ */ he("div", { className: "text-left flex flex-col gap-1 w-[calc(100%_-_5.5rem)]", children: [
          /* @__PURE__ */ E("span", { className: "text-sm font-medium text-field-label truncate", children: n ? "Loading..." : e.name }),
          !n && /* @__PURE__ */ E(
            "span",
            {
              className: K(
                "text-xs text-field-helper",
                r && "text-support-error"
              ),
              children: r ? i : WH(e.size)
            }
          )
        ] }),
        n ? /* @__PURE__ */ E("span", { className: "inline-flex ml-auto p-0.5", children: /* @__PURE__ */ E(RD, { className: "inline-flex" }) }) : /* @__PURE__ */ E(
          "button",
          {
            onClick: t,
            className: "inline-flex cursor-pointer bg-transparent border-0 p-1 my-0 ml-auto mr-0 ring-0 focus:outline-none self-start",
            children: /* @__PURE__ */ E(rK, { className: "size-4 text-support-error" })
          }
        )
      ] })
    }
  ) : null;
}, BEe = ({
  onFileUpload: e,
  inlineIcon: t = !1,
  label: n = "Drag and drop or browse files",
  helpText: r = "Help Text",
  size: i = "sm",
  disabled: o = !1,
  error: a = !1,
  errorText: s = "Upload failed, please try again."
}) => {
  const [l, c] = Me(!1), [f, d] = Me(null), [p, m] = Me(!1), y = (_) => {
    if (o)
      return;
    c(!0), _.preventDefault(), _.stopPropagation(), m(!1);
    const O = _.dataTransfer.files[0];
    O && (d(O), e && e(O)), c(!1);
  }, g = (_) => {
    o || (_.preventDefault(), m(!0));
  }, v = () => {
    o || m(!1);
  }, x = (_) => {
    if (o)
      return;
    c(!0);
    const O = _.target.files;
    if (!O)
      return;
    const P = O[0];
    P && (d(P), e && e(P)), c(!1);
  }, w = () => {
    d(null);
  }, S = {
    sm: {
      label: "text-sm",
      helpText: "text-xs",
      icon: "size-5",
      padding: t ? "p-3" : "p-5",
      gap: "gap-2.5"
    },
    md: {
      label: "text-sm",
      helpText: "text-xs",
      icon: "size-5",
      padding: t ? "p-4" : "p-6",
      gap: "gap-3"
    },
    lg: {
      label: "text-base",
      helpText: "text-sm",
      icon: "size-6",
      padding: t ? "p-4" : "p-6",
      gap: "gap-3"
    }
  }, A = ut(`fui-file-upload-${ro()}`);
  return /* @__PURE__ */ E(
    wz.Provider,
    {
      value: { file: f, removeFile: w, isLoading: l, error: a, errorText: s },
      children: /* @__PURE__ */ he("div", { children: [
        /* @__PURE__ */ E("label", { htmlFor: A.current, children: /* @__PURE__ */ he(
          "div",
          {
            className: K(
              "min-w-80 cursor-pointer mx-auto border-dashed border rounded-md text-center hover:border-field-dropzone-color hover:bg-field-dropzone-background-hover focus:outline-none focus:ring focus:ring-toggle-on focus:ring-offset-2 transition duration-200 ease-in-out",
              p ? "border-field-dropzone-color bg-field-dropzone-background-hover" : "border-field-border",
              o && "border-field-border bg-field-background-disabled cursor-not-allowed hover:border-field-border",
              S[i].padding
            ),
            onDragOver: g,
            onDragLeave: v,
            onDrop: y,
            children: [
              /* @__PURE__ */ he(
                "div",
                {
                  className: K(
                    "flex flex-col items-center justify-center",
                    t && `flex-row items-start ${S[i].gap}`
                  ),
                  children: [
                    /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(
                      qH,
                      {
                        className: K(
                          "text-field-dropzone-color size-6",
                          S[i].icon,
                          o && "text-field-color-disabled"
                        )
                      }
                    ) }),
                    /* @__PURE__ */ he("div", { className: "flex flex-col", children: [
                      /* @__PURE__ */ E(
                        "span",
                        {
                          className: K(
                            "mt-1 text-center font-medium text-field-label",
                            t && "text-left mt-0",
                            S[i].label,
                            o && "text-field-color-disabled"
                          ),
                          children: n
                        }
                      ),
                      r && /* @__PURE__ */ E(
                        "span",
                        {
                          className: K(
                            "mt-1 text-center font-medium text-field-helper",
                            t && "text-left",
                            S[i].helpText,
                            o && "text-field-color-disabled"
                          ),
                          children: r
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ E(
                "input",
                {
                  id: A.current,
                  type: "file",
                  className: "sr-only",
                  onChange: x,
                  disabled: o
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ E(LEe, {})
      ] })
    }
  );
};
BEe.displayName = "Dropzone";
const _z = dt(
  void 0
), BS = () => {
  const e = Ve(_z);
  if (!e)
    throw new Error("Table components must be used within Table component");
  return e;
}, rl = ({
  children: e,
  className: t,
  checkboxSelection: n = !1,
  ...r
}) => {
  const i = {
    checkboxSelection: n
  }, o = Yt.toArray(e).find(
    (s) => I.isValidElement(s) && s.type === Zm
  ), a = Yt.toArray(e).filter(
    (s) => I.isValidElement(s) && s.type !== Zm
  );
  return /* @__PURE__ */ E(
    _z.Provider,
    {
      value: i,
      children: /* @__PURE__ */ he("div", { className: "flow-root border-0.5 border-solid border-border-subtle rounded-md divide-y-0.5 divide-x-0 divide-solid divide-border-subtle overflow-hidden", children: [
        /* @__PURE__ */ E("div", { className: "overflow-x-auto w-full", children: /* @__PURE__ */ E("div", { className: "relative", children: /* @__PURE__ */ E(
          "table",
          {
            className: K(
              "table-fixed min-w-full border-collapse border-spacing-0",
              t
            ),
            ...r,
            children: a
          }
        ) }) }),
        o
      ] })
    }
  );
}, Sz = ({
  children: e,
  className: t,
  selected: n,
  onChangeSelection: r,
  indeterminate: i,
  disabled: o,
  ...a
}) => {
  const { checkboxSelection: s } = BS(), l = (c) => {
    typeof r == "function" && r(c);
  };
  return /* @__PURE__ */ E(
    "thead",
    {
      className: K(
        "bg-background-secondary border-x-0 border-t-0 border-b-0.5 border-solid border-border-subtle",
        t
      ),
      ...a,
      children: /* @__PURE__ */ he("tr", { children: [
        s && /* @__PURE__ */ E(
          "th",
          {
            scope: "col",
            className: "relative px-5.5 w-11 overflow-hidden",
            children: /* @__PURE__ */ E("div", { className: "absolute inset-0 grid grid-cols-1 place-content-center", children: /* @__PURE__ */ E(
              Jw,
              {
                size: "sm",
                checked: n,
                indeterminate: i,
                disabled: o,
                onChange: l,
                "aria-label": n ? "Deselect all" : "Select all"
              }
            ) })
          }
        ),
        e
      ] })
    }
  );
}, Oz = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "th",
  {
    scope: "col",
    className: K(
      "p-3 text-left text-sm font-medium leading-5 text-text-primary",
      t
    ),
    ...n,
    children: e
  }
), Az = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "tbody",
  {
    className: K(
      "bg-background-primary divide-y-0.5 divide-x-0 divide-solid divide-border-subtle",
      t
    ),
    ...n,
    children: e
  }
), Tz = ({
  children: e,
  selected: t,
  value: n,
  className: r,
  onChangeSelection: i,
  ...o
}) => {
  const { checkboxSelection: a } = BS(), s = (l) => {
    typeof i == "function" && i(l, n);
  };
  return /* @__PURE__ */ he(
    "tr",
    {
      className: K(
        "hover:bg-background-secondary",
        t && "bg-background-secondary",
        r
      ),
      ...o,
      children: [
        a && /* @__PURE__ */ E("td", { className: "relative px-5.5 w-11 overflow-hidden", children: /* @__PURE__ */ E("div", { className: "absolute inset-0 grid grid-cols-1 place-content-center", children: /* @__PURE__ */ E(
          Jw,
          {
            size: "sm",
            checked: t,
            onChange: s,
            "aria-label": "Select row"
          }
        ) }) }),
        e
      ]
    }
  );
}, Pz = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ E(
  "td",
  {
    className: K(
      "px-3 py-3.5 text-sm font-normal leading-5 text-text-secondary",
      t
    ),
    ...n,
    children: e
  }
), Zm = ({
  children: e,
  className: t,
  ...n
}) => {
  const { checkboxSelection: r } = BS();
  return /* @__PURE__ */ E(
    "div",
    {
      className: K("px-3 py-3", r && "px-4", t),
      ...n,
      children: e
    }
  );
};
rl.displayName = "Table";
Sz.displayName = "Table.Head";
Oz.displayName = "Table.HeadCell";
Az.displayName = "Table.Body";
Tz.displayName = "Table.Row";
Pz.displayName = "Table.Cell";
Zm.displayName = "Table.Footer";
rl.Head = Sz;
rl.HeadCell = Oz;
rl.Body = Az;
rl.Row = Tz;
rl.Cell = Pz;
rl.Footer = Zm;
export {
  ike as Accordion,
  eke as Alert,
  lke as AreaChart,
  KEe as Avatar,
  mg as Badge,
  oke as BarChart,
  Ys as Breadcrumb,
  Hn as Button,
  qEe as ButtonGroup,
  Jw as Checkbox,
  ER as Container,
  rke as DatePicker,
  qo as Dialog,
  Zo as Drawer,
  Xs as DropdownMenu,
  BEe as Dropzone,
  VQ as EditorInput,
  zg as HamburgerMenu,
  fY as Input,
  eo as Label,
  ake as LineChart,
  RD as Loader,
  Ua as Menu,
  Bc as Pagination,
  ske as PieChart,
  YEe as ProgressBar,
  YQ as ProgressSteps,
  HEe as RadioButton,
  Xo as SearchBox,
  pd as Select,
  nke as Sidebar,
  tke as Skeleton,
  Z$ as Switch,
  rl as Table,
  H1 as Tabs,
  cY as TextArea,
  GEe as Title,
  QEe as Toaster,
  f1 as Tooltip,
  _d as Topbar,
  JEe as toast
};
